(function ()
{
    'use strict';

    angular
        .module('app.toolbar-inner', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/main/apps/toolbar-inner');


        // Api
        msApiProvider.register('app.updateClientAuth', ['updateClientAuth']);
        msApiProvider.register('app.getCustomKots', ['getCustomKots']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar-inner')
        .controller('PrinterSettingsDialogController', PrinterSettingsDialogController);

    /** @ngInject */
    function PrinterSettingsDialogController($mdDialog, msUtils, msApi, $cookies, __env, $mdToast, $q, $parse)
    {
        var vm = this;

        var webprint = __env.webprint;
        if(__env.isDebug) console.log(webprint);

        // Data               	       
		vm.title = 'Printer Settings';
        vm.printerIP = localStorage.getItem('PrinterIP');
        vm.printerAuth = localStorage.getItem('PrinterAuth');
        vm.printerStatus = localStorage.getItem('PrinterStatus');
        vm.appHost = localStorage.getItem('AppHost');
        vm.showLab = 0;
        vm.localPrinter = $cookies.get("localPrinter");
        

        // Methods
        vm.saveInfo = saveInfo;
        vm.closeDialog = closeDialog;
        vm.initWebPrinter = initWebPrinter;
        vm.testPrinter = testPrinter;
        vm.exists = msUtils.exists;

        //////////
        
        /**
         * Save section
         */
        function saveInfo()
        {					
            if(__env.isDebug) console.log("Input Data");
            if(__env.isDebug) console.log(vm.loginData);
            msApi.request('app.updateClientAuth@save', {param:{printerIP:vm.printerIP,printerAuth:vm.printerAuth}},
                // SUCCESS
                function (response){        
                    //alert("IF");
                    if(__env.isDebug) console.log("Success");
                    if(__env.isDebug) console.log(response.data);   
                    //alert(response.data);
                    if(response.data==true){
                         $mdToast.show(
                            $mdToast.simple().textContent('Printer Auth Updated').position('top right')
                        );
                                                    
                    } else {
                        $mdToast.show(
                            $mdToast.simple().textContent('Printer Auth Not Updated').position('top right')
                        );
                    }
                },
                // ERROR
                function (response){
                    //alert("ELSE");
                    if(__env.isDebug) console.log("Error");
                    if(__env.isDebug) console.log(response.data);
                }
            );	
            //closeDialog();			
        }
        

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        function testPrinter(){
            if(vm.localPrinter!=""){
                var status=__env.webprint.printRaw("Testing", vm.localPrinter);
                if(__env.isDebug) console.log("Printer Result");
                if(__env.isDebug) console.log(status);      
                var def = $q.defer();         
                def.resolve(status);
                if(__env.isDebug) console.log("Result => "+$parse(def.promise));
            } else {
                $mdToast.show(
                    $mdToast.simple().textContent('Local printer not found').position('top right')
                );
            }
        }

        function initWebPrinter(){
            var webprint2 = new WebPrint(false, {
                relayHost: vm.printerIP,
                relayPort: "8080",
                relayOrigin: vm.appHost,
                relayAuth: vm.printerAuth         
            });

            var retValue = webprint2.printInit();
            if(__env.isDebug) console.log("Init Result");
            if(__env.isDebug) console.log(retValue);

            __env.webprint = webprint2;
            var result = retValue.split("|");
        
            localStorage.setItem('PrinterIP',vm.printerIP);
            localStorage.setItem('AppHost',vm.appHost);
            if(result[0]){
                vm.showLab = 1;
                localStorage.setItem('PrinterAuth',result[0]);
            }
            localStorage.setItem('PrinterStatus',result[1]);

            vm.printerAuth = localStorage.getItem('PrinterAuth');
            vm.printerStatus = localStorage.getItem('PrinterStatus');
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar-inner')
        .controller('LocalPrinterDialogController', LocalPrinterDialogController);

    /** @ngInject */
    function LocalPrinterDialogController($mdDialog, msUtils, msApi, $cookies, __env, $timeout)
    {
        var vm = this;

        // Data               
		vm.localPrinter = ""; vm.localPrinterReminder = "0";
		if($cookies.get("localPrinter")!=""){
			//$cookies.put("localPrinter", "myprinter");
			vm.localPrinter = $cookies.get("localPrinter");
			vm.localPrinterReminder = $cookies.get("localPrinterReminder");            
		}

        vm.localNotificationEnable = 1;
        //alert(!$cookies.get("localNotificationEnable"));
        if(!$cookies.get("localNotificationEnable")==false){            
            vm.localNotificationEnable = $cookies.get("localNotificationEnable");
        } else {
            var now = new Date(),
            // this will set the expiration to 12 months
            exp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

            $cookies.put("localNotificationEnable", vm.localNotificationEnable,{expires: exp});
        }
		//alert(vm.localPrinter+" "+vm.localPrinterReminder);
		
		vm.title = 'Local Settings';

        vm.localPrinterIP = "";
        vm.hostList=JSON.parse(localStorage.getItem('PrinterHostList'));
        console.log(vm.hostList);

        vm.hostLab=0;
        vm.localPrinterIP=vm.hostList[0].host;
        if(vm.hostList.length>1){
            vm.hostLab=1;
            
            if($cookies.get("localPrinterIP")!=""){
                vm.localPrinterIP = $cookies.get("localPrinterIP");                
            } else {
                vm.localPrinterIP=vm.hostList[0].host;    
            }            
        }
        

        // Methods
        vm.saveRole = saveRole;
        vm.closeDialog = closeDialog;
        vm.exists = msUtils.exists;
        vm.setPrintIP = setPrintIP;

        //////////
        
        /**
         * Save section
         */
        function saveRole()
        {			
			if(__env.isDebug) console.log(vm.localPrinter);
			if(__env.isDebug) console.log(vm.localPrinterReminder);
			if(vm.localPrinterReminder==null){
				vm.localPrinterReminder=0;	
			}

            if(vm.localNotificationEnable==null){
                vm.localNotificationEnable=0;  
            }

			//alert(vm.localPrinter+" "+vm.localPrinterReminder);

            var now = new Date(),
            // this will set the expiration to 12 months
            exp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());
			//alert(exp);
			$cookies.put("localPrinter", vm.localPrinter,{expires: exp});
			$cookies.put("localPrinterReminder", vm.localPrinterReminder,{expires: exp});
            $cookies.put("localNotificationEnable", vm.localNotificationEnable,{expires: exp});
            closeDialog();			
        }

        function setPrintIP(){
            //alert(vm.localPrinterIP);

            var now = new Date(),
            // this will set the expiration to 12 months
            exp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());
            //alert(exp);


            vm.printHost="";
            vm.printAuth="";
            vm.appHost = localStorage.getItem('AppHost');

            for(var i=0;i<vm.hostList.length;i++){
                if(vm.hostList[i].host==vm.localPrinterIP){
                    vm.printHost=vm.hostList[i].host;
                    vm.printAuth=vm.hostList[i].auth;
                }
            }
            //alert(vm.printHost+" "+vm.printAuth+" "+vm.appHost);

            $cookies.put("localPrinterIP", vm.printHost, {expires: exp});
            $cookies.put("localPrinterAuth", vm.printAuth, {expires: exp});

            //alert(vm.printHost);
            createConnection(vm.printHost);

            /*$timeout(function () {
                getPrinterStatus();
            }, 12000);*/

            /*__env.webprint = "";
            
            var webprint = new WebPrint(false, {
                relayHost: vm.printHost,
                relayPort: "8080",
                relayOrigin: vm.appHost,
                relayAuth: vm.printAuth         
            });

            var retValue = webprint.printInit();
            __env.webprint = webprint;
            //alert(retValue+" "+isNaN(retValue));
            //alert(vm.printAuth);
            localStorage.setItem('PrinterAuth',vm.printAuth);
            if(isNaN(retValue)==true){
                //alert("In");
                var result = retValue.split("|");
                if(result[0]!=""){
                    localStorage.setItem('PrinterAuth',result[0]);
                }
                localStorage.setItem('PrinterStatus',result[1]);
            } else {
                //alert("Out");
                localStorage.setItem('PrinterAuth',"");
                localStorage.setItem('PrinterStatus',0);
            }*/
        
            localStorage.setItem('PrinterIP',vm.printHost);
            localStorage.setItem('AppHost',vm.appHost);
            //localStorage.setItem('PrinterAuth',vm.printAuth);
            
            //if(__env.isDebug) console.log(__env.webprint);
        }
        

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar-inner')
        .controller('NotificationDialogController', NotificationDialogController);

    /** @ngInject */
    function NotificationDialogController(AlertList, $window, $state, $mdDialog, msUtils, msApi, $cookies,  $rootScope)
    {
        var vm = this;

        vm.alertList = AlertList;
        if(__env.isDebug) console.log("AlertList");
        if(__env.isDebug) console.log(vm.alertList); 
        // Data               				
		vm.title = 'Order Alert(s)';
        vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');

        // Methods
        vm.gotoKot = gotoKot;
        vm.closeDialog = closeDialog;
        vm.exists = msUtils.exists;

        //////////
        
        /**
         * Save section
         */
        function gotoKot(alert)
        {						
			if(__env.isDebug) console.log(alert);	
            /*localStorage.setItem('menuID',alert.customerkot_dept_id);
            localStorage.setItem('departmentID',alert.customerkot_dept_id);
            localStorage.setItem('departmentType',alert.department_type); 
            //$state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id});			

            vm.departmentList = JSON.parse($window.localStorage['departmentList']);
            vm.deptTypeList = "";
            for(var d=0;d<vm.departmentList.length;d++){
                if(vm.departmentList[d].department_id == alert.customerkot_dept_id){
                    vm.deptFlow = vm.departmentList[d]['deptFlow'];
                    vm.deptType = vm.deptFlow[0].deptopt_option;
                    //vm.deptTypeList = '';
                    for(var i=1;i<vm.deptFlow.length;i++){
                        vm.deptTypeList = vm.deptTypeList+","+vm.deptFlow[i].deptopt_option;        
                    }
                }
            }
            vm.deptTypeList=vm.deptTypeList.substring(1);
            //alert(vm.deptType+" "+vm.deptTypeList);
            localStorage.setItem('deptTypeList',vm.deptTypeList);

             //$rootScope.$emit('setDepartment2',"");    
            if($state.current.name=="app.dining-custom-bill"){
                $state.go('app.dining-custom-bill-list', {bill_id: alert.customerkot_id});                
            } else if($state.current.name=="app.dining-custom-bill-list"){
                $state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id});                 
            } else {
                $state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id}); 
            }*/  

            closeDialog();	
           	$rootScope.$emit('setDepartment2',alert);    
        }
        

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar-inner')
        .controller('TenderDialogController', TenderDialogController);

    /** @ngInject */
    function TenderDialogController($mdDialog, msUtils, msApi, $cookies)
    {
        var vm = this;

        // Data               
		vm.localPrinter = ""; vm.localPrinterReminder = "0";
		if($cookies.get("localPrinter")!=""){
			//$cookies.put("localPrinter", "myprinter");
			vm.localPrinter = $cookies.get("localPrinter");
			vm.localPrinterReminder = $cookies.get("localPrinterReminder");
		}
		//alert(vm.localPrinter+" "+vm.localPrinterReminder);
		
		vm.title = 'Local Printer';
        

        // Methods
        vm.saveRole = saveRole;
        vm.closeDialog = closeDialog;
        vm.exists = msUtils.exists;

        //////////
        
        /**
         * Save section
         */
        function saveRole()
        {			
			if(__env.isDebug) console.log(vm.localPrinter);
			if(__env.isDebug) console.log(vm.localPrinterReminder);
			if(vm.localPrinterReminder==null){
				vm.localPrinterReminder=0;	
			}

			//alert(vm.localPrinter+" "+vm.localPrinterReminder);
			
			$cookies.put("localPrinter", vm.localPrinter);
			$cookies.put("localPrinterReminder", vm.localPrinterReminder);
            closeDialog();			
        }
        

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.warehouse',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.warehouse', {
				url    : '/warehouse',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/warehouse/warehouse.html',
						controller : 'WarehouseListController as vm'
					}
				},
				resolve: {					
					WarehouseList: function (msApi)
					{					
						return msApi.resolve('app.warehouseList@get');
					}, 
				}
			})
			.state('app.warehouse-list', {
				url    : '/warehouse',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/warehouse/warehouse.html',
						controller : 'WarehouseListController as vm'
					}
				},
				resolve: {					
					WarehouseList: function (msApi)
					{					
						return msApi.resolve('app.warehouseList@get');
					}, 
				}
			})	
			.state('app.warehouse.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/warehouse/new_warehouse/new_warehouse.html',
						controller : 'AddWarehouseController as vm'
					}
				},
				resolve: {
					Warehouse: function (msApi)
					{
						return msApi.resolve('app.warehouseAdd@get');
						//return '';
					}
				},
				bodyClass: 'warehouse'
			})
			.state('app.warehouse.edit', {
				url      : '/edit/:warehouse_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/warehouse/new_warehouse/new_warehouse.html',
						controller : 'EditWarehouseController as vm'
					}
				},
				resolve: {
					Warehouse: function ($stateParams, warehouseService)
					{
						return warehouseService.getWarehouse($stateParams.warehouse_id,'Edit');
					}
				},
				bodyClass: 'warehouse'
			})
			.state('app.warehouse.edit-list', {
				url      : '/edit/:warehouse_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/warehouse/new_warehouse/new_warehouse.html',
						controller : 'EditWarehouseController as vm'
					}
				},
				resolve: {
					Warehouse: function ($stateParams, warehouseService)
					{
						return clientService.getWarehouse($stateParams.warehouse_id,'Edit');
					}
				},
				bodyClass: 'warehouse'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/warehouse');
			
			// Api						
			msApiProvider.register('app.warehouseList', ['warehouseList']);
			msApiProvider.register('app.warehouseSave', ['warehouseSave']);
			msApiProvider.register('app.warehouseUpdate', ['warehouseUpdate']);
			msApiProvider.register('app.warehouseAdd', ['warehouseAdd']);
			msApiProvider.register('app.warehouseEdit', ['warehouseEdit']);
			msApiProvider.register('app.warehouseDel', ['warehouseDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('warehouse', {
				title : 'Warehouses',
				//icon  : 'icon-account-multiple',
				state : 'app.warehouse',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.warehouse')
        .factory('warehouseService', warehouseService);

    /** @ngInject */
    function warehouseService($q, $mdToast, msApi)
    {
        var warehouseEdit = [];

        var service = {
            getWarehouse	: getWarehouse			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getWarehouse(warehouse_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( warehouseEdit.length > 0 )
            {				
                deferred.resolve(warehouseEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.warehouseEdit@save', {param:{warehouse_id:warehouse_id},aToken:aToken,page:'warehouse'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							warehouseEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(warehouseEdit);
																								
							// Resolve the promise
							deferred.resolve(warehouseEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.warehouse')
        .controller('AddWarehouseController', AddWarehouseController);

    /** @ngInject */
    function AddWarehouseController($scope, $mdSidenav, Warehouse, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Warehouse";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Warehouse master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.warehouseDB = Warehouse.data;        		     				
		if(__env.isDebug) console.log(vm.warehouseDB);	
		//vm.branchID = vm.warehouseDB.branchID;
		vm.branchList = vm.warehouseDB.branchList;
		
		//vm.warehouse = {warehouse_code:vm.warehouseDB.warehouseCode};
		vm.warehouse = {warehouse_name:'', warehouse_branch_id:'', warehouse_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.warehouse = {warehouse_status : "Active"};
				

		// Methods
        vm.saveWarehouse = saveWarehouse;
		vm.gotoWarehouse = gotoWarehouse;
						
		/**
         * Go to Staff page
         */
        function gotoWarehouse()
        {
			//alert("1");
            $state.go('app.warehouse-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveWarehouse()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.warehouse);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.warehouseSave@save', {param:{warehouse:vm.warehouse,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'warehouse'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Warehouse Added Successfully').position('top right')
						);
						gotoWarehouse();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.warehouse')
        .controller('EditWarehouseController', EditWarehouseController);

    /** @ngInject */
    function EditWarehouseController($scope, $mdSidenav, Warehouse, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Warehouse";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Warehouse master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data		
		vm.warehouseDB = Warehouse;
		vm.warehouse = vm.warehouseDB.warehouseDets;
		if(__env.isDebug) console.log("Warehouse Det");
		if(__env.isDebug) console.log(vm.warehouseDB);
		
		vm.branchList = vm.warehouseDB.branchList;
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.warehouseDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveWarehouse = saveWarehouse;
		vm.gotoWarehouse = gotoWarehouse;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoWarehouse()
        {
			//alert("1");
            $state.go('app.warehouse-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveWarehouse()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.warehouse);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.warehouseUpdate@save', {param:{warehouse:vm.warehouse,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'warehouse'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Warehouse Updated Successfully').position('top right')
						);
						gotoWarehouse();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter-sales-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.waiter-sales-report', {
				url    : '/waiter-sales-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/waiter-sales-report/waiter-sales-report.html',
						controller : 'WaiterSalesReportController as vm'
					}
				},
				resolve: {					
					WaiterSalesReportList: function (msApi)
					{					
						return msApi.resolve('app.waiterSalesReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.waiter-sales-report-list', {
				url    : '/waiter-sales-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/waiter-sales-report/waiter-sales-report.html',
						controller : 'WaiterSalesReportController as vm'
					}
				},
				resolve: {					
					WaiterSalesReportList: function ($stateParams, waitersalesreportService)
					{
						
						return waitersalesreportService.getWaiterSalesList($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/waiter-sales-report');
			
			// Api						
			msApiProvider.register('app.waiterSalesReportList', ['waiterSalesReportList']);
			msApiProvider.register('app.waiterSalesReportList2', ['waiterSalesReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.opening-stock-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter-sales-report')
        .factory('waitersalesreportService', waitersalesreportService);

    /** @ngInject */
    function waitersalesreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getWaiterSalesList : getWaiterSalesList
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getWaiterSalesList(waiterSalesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.waiterSalesReportList2@save', {param:{waiterSalesDets:waiterSalesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.waiter', {
				url    : '/waiter',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/waiter/waiter.html',
						controller : 'WaiterListController as vm'
					}
				},
				resolve: {					
					WaiterList: function (msApi)
					{					
						return msApi.resolve('app.waiterList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.waiter-list', {
				url    : '/waiter',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/waiter/waiter.html',
						controller : 'WaiterListController as vm'
					}
				},
				resolve: {					
					WaiterList: function (msApi)
					{					
						return msApi.resolve('app.waiterList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.waiter.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/waiter/new_waiter/new_waiter.html',
						controller : 'AddWaiterController as vm'
					}
				},
				resolve: {
					Waiter: function (msApi)
					{
						return msApi.resolve('app.waiterAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'waiter'
			})
			.state('app.waiter.edit', {
				url      : '/edit/:waiter_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/waiter/new_waiter/new_waiter.html',
						controller : 'EditWaiterController as vm'
					}
				},
				resolve: {
					Waiter: function ($stateParams, waiterService)
					{
						return waiterService.getWaiter($stateParams.waiter_id,'Edit');
					}
				},
				bodyClass: 'waiter'
			})
			.state('app.waiter.edit-list', {
				url      : '/edit/:waiter_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/waiter/new_waiter/new_waiter.html',
						controller : 'EditWaiterController as vm'
					}
				},
				resolve: {
					Waiter: function ($stateParams, waiterService)
					{
						return clientService.getWaiter($stateParams.waiter_id,'Edit');
					}
				},
				bodyClass: 'waiter'
			})
			.state('app.waiter.tables', {
				url      : '/tables/:waiter_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/waiter/tables/tables_list.html',
						controller : 'WaiterTablesListController as vm'
					}
				},
				resolve: {
					Tables: function ($stateParams, waiterService)
					{
						return waiterService.getTables($stateParams.waiter_id);
					}
				},
				bodyClass: 'waiter'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/waiter');
			
			// Api						
			msApiProvider.register('app.waiterList', ['waiterList']);
			msApiProvider.register('app.waiterSave', ['waiterSave']);
			msApiProvider.register('app.waiterUpdate', ['waiterUpdate']);
			msApiProvider.register('app.waiterAdd', ['waiterAdd']);
			msApiProvider.register('app.waiterEdit', ['waiterEdit']);
			msApiProvider.register('app.waiterDel', ['waiterDel']);
			
			msApiProvider.register('app.waiterTablesList', ['waiterTablesList']);
			msApiProvider.register('app.waiterTablesSave', ['waiterTablesSave']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('waiter', {
				title : 'Waiters',
				//icon  : 'icon-account-multiple',
				state : 'app.waiter',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter')
        .controller('WaiterTablesListController', WaiterTablesListController);

    /** @ngInject */
    function WaiterTablesListController($state, Tables, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Waiters";
		
        // Data
        vm.tableList = Tables;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.tableList);
		vm.tables = vm.tableList.tableList;
		vm.waiterTables = vm.tableList.tableWaiter;
		vm.branchID = vm.tableList.branchID;
		vm.waiterID = vm.tableList.waiter_id;
        vm.listForm={};
		
		if(vm.tableList.error == "1"){
			gotoLogin();
		} 
		for(var i=0;i<vm.tables.length;i++){
			vm.tables[i].table_branch_id = vm.branchID;
			for(var j=0;j<vm.waiterTables.length;j++){
				if(vm.tables[i].table_id == vm.waiterTables[j].waitertbl_table_id){
					vm.tables[i].selectedchk = 1;									
				}
			}
		}
		
		if(__env.isDebug) console.log(vm.tables);
        		
       	
        // Methods
       
		vm.gotoWaiters = gotoWaiters;	
		vm.saveWaiterTables = saveWaiterTables;
		vm.gotoLogin = gotoLogin;	
		vm.setTables = setTables;
		vm.selectAll = selectAll;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function selectAll(){
			if(vm.mainChk==0){
				vm.mainChk=1;
				for(var i=0;i<vm.tables.length;i++){
					vm.tables[i].selectedchk = 1;
				}
			} else {
				vm.mainChk=0;	
				for(var i=0;i<vm.tables.length;i++){
					vm.tables[i].selectedchk = 0;
				}	
			}
		}
        
		function gotoWaiters()
        {
			//alert("1");
            $state.go('app.waiter-list');
        }
		
		function setTables(waiterID){
			$state.go('app.waiter.tables', {waiter_id: waiterID});
		}
							
		function saveWaiterTables()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.tables);
			if(__env.isDebug) console.log(vm.waiterID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.waiterTablesSave@save', {param:{tables:vm.tables,waiterID:vm.waiterID,branchID:vm.branchID},aToken:aToken,page:'waiter'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoWaiters();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter')
        .factory('waiterService', waiterService);

    /** @ngInject */
    function waiterService($q, $mdToast, msApi)
    {
        var waiterEdit = [], tablesList = [];

        var service = {
            getWaiter	: getWaiter,
			getTables	: getTables
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getWaiter(waiter_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( waiterEdit.length > 0 )
            {				
                deferred.resolve(waiterEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.waiterEdit@save', {param:{waiter_id:waiter_id},aToken:aToken,page:'waiter'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							waiterEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(waiterEdit);
																								
							// Resolve the promise
							deferred.resolve(waiterEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }
		
		function getTables(waiter_id)
        {						
			//alert(waiter_id);
			var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.waiterTablesList@save', {param:{waiter_id:waiter_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'waiter'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						tablesList = response.data;	
						tablesList['waiter_id'] = waiter_id;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(tablesList);
																							
						// Resolve the promise
						deferred.resolve(tablesList);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter')
        .controller('AddWaiterController', AddWaiterController);

    /** @ngInject */
    function AddWaiterController($scope, $mdSidenav, Waiter, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Waiter";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Waiters" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
		}
		
        // Data
		vm.waiterDB = Waiter.data;        		     				
		if(__env.isDebug) console.log(vm.waiterDB);	
		vm.branchID = vm.waiterDB.branchID;
		
		//vm.waiter = {waiter_code:vm.waiterDB.waiterCode};
		vm.waiter = {waiter_name:'', waiter_branch_id:vm.branchID, waiter_pin:'', waiter_mobileno:'', waiter_address:'', waiter_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		vm.typelist = ['Dining','Kiosk'];
		//vm.waiter = {waiter_status : "Active"};
				

		// Methods
        vm.saveWaiter = saveWaiter;
		vm.gotoWaiter = gotoWaiter;
						
		/**
         * Go to Staff page
         */
        function gotoWaiter()
        {
			//alert("1");
            $state.go('app.waiter-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveWaiter()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.waiter);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.waiterSave@save', {param:{waiter:vm.waiter,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'waiter'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Waiter Added Successfully').position('top right')
						);
						gotoWaiter();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter')
        .controller('EditWaiterController', EditWaiterController);

    /** @ngInject */
    function EditWaiterController($scope, $mdSidenav, Waiter, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Waiter";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Waiters" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.waiterDB = Waiter;
		vm.waiter = vm.waiterDB.waiterDets;
		if(__env.isDebug) console.log("Waiter Det");
		if(__env.isDebug) console.log(vm.waiterDB);
				
		vm.statuslist = ['Active','Inactive'];
		vm.typelist = ['Dining','Kiosk'];
		
		if(vm.waiterDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveWaiter = saveWaiter;
		vm.gotoWaiter = gotoWaiter;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoWaiter()
        {
			//alert("1");
            $state.go('app.waiter-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveWaiter()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.waiter);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.waiterUpdate@save', {param:{waiter:vm.waiter,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'waiter'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Waiter Updated Successfully').position('top right')
						);
						gotoWaiter();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.user-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.user-report', {
				url    : '/user-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/user-report/user-report.html',
						controller : 'UserReportController as vm'
					}
				},
				resolve: {					
					UserReportList: function (msApi)
					{					
						return msApi.resolve('app.userReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.user-report-list', {
				url    : '/user-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/user-report/user-report.html',
						controller : 'UserReportController as vm'
					}
				},
				resolve: {					
					UserReportList: function ($stateParams, userreportService)
					{
						
						return userreportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/user-report');
			
			// Api						
			msApiProvider.register('app.userReportList', ['userReportList']);
			msApiProvider.register('app.userReportList2', ['userReportList2']);
			msApiProvider.register('app.user-reportSave', ['user-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('user-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.user-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user-report')
        .factory('userreportService', userreportService);

    /** @ngInject */
    function userreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(userDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.userReportList2@save', {param:{userDets:userDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'user-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.user', {
				url    : '/user',
				views  : {
					'main@app': {
                        templateUrl: 'app/core/layouts/vertical-navigation2.html',
                        controller : 'MainController as vm'
                    },
					'content@app': {
						templateUrl: 'app/main/apps/user/user.html',
						controller : 'UserListController as vm'
					}
				},
				resolve: {					
					UserList: function (msApi)
					{					
						return msApi.resolve('app.userList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.user-list', {
				url    : '/user',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/user/user.html',
						controller : 'UserListController as vm'
					}
				},
				resolve: {					
					UserList: function (msApi)
					{					
						return msApi.resolve('app.userList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.user.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/user/new_user/new_user.html',
						controller : 'AddUserController as vm'
					}
				},
				resolve: {
					User: function (msApi)
					{
						//return msApi.resolve('app.userAdd@get');
						return msApi.resolve('app.userAdd@get',{branchID:localStorage.getItem('BranchID')});;
					}
				},
				bodyClass: 'user'
			})
			.state('app.user.edit', {
				url      : '/edit/:user_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/user/new_user/new_user.html',
						controller : 'EditUserController as vm'
					}
				},
				resolve: {
					User: function ($stateParams, userService)
					{
						return userService.getUser($stateParams.user_id,'Edit');
					}
				},
				bodyClass: 'user'
			})
			.state('app.user.edit-list', {
				url      : '/edit/:user_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/user/new_user/new_user.html',
						controller : 'EditUserController as vm'
					}
				},
				resolve: {
					User: function ($stateParams, userService)
					{
						return clientService.getUser($stateParams.user_id,'Edit');
					}
				},
				bodyClass: 'user'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/user');
			
			// Api						
			msApiProvider.register('app.userList', ['userList']);
			msApiProvider.register('app.userSave', ['userSave']);
			msApiProvider.register('app.userUpdate', ['userUpdate']);
			msApiProvider.register('app.userAdd', ['userAdd']);
			msApiProvider.register('app.userEdit', ['userEdit']);
			msApiProvider.register('app.userDel', ['userDel']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('user', {
				title : 'Users',
				//icon  : 'icon-account-multiple',
				state : 'app.user',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user')
        .factory('userService', userService);

    /** @ngInject */
    function userService($q, $mdToast, msApi)
    {
        var userEdit = [];

        var service = {
            getUser	: getUser			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getUser(user_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( userEdit.length > 0 )
            {				
                deferred.resolve(userEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.userEdit@save', {param:{user_id:user_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'user'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							userEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(userEdit);
																								
							// Resolve the promise
							deferred.resolve(userEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('AddUserController', AddUserController);

    /** @ngInject */
    function AddUserController($scope, $mdSidenav, User, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add User";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Users" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.userDB = User.data;        		     				
		if(__env.isDebug) console.log(vm.userDB);	
		vm.branchID = localStorage.getItem('BranchID');
		
		//vm.user = {user_code:vm.userDB.userCode};
		vm.user = {usr_name:'', usr_branch_id:vm.branchID, usr_type:'', usr_uname:'', usr_password:'', usr_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.type = ['Admin','Staff'];
		vm.type = vm.userDB.roles;
				

		// Methods
        vm.saveUser = saveUser;
		vm.gotoUser = gotoUser;
						
		/**
         * Go to Staff page
         */
        function gotoUser()
        {
			//alert(vm.type);
			$state.go('app.user-list');			
        }
						
		/**
         * Add New Staff
        **/
        function saveUser()
        {
			//alert("In");
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.user);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.userSave@save', {param:{user:vm.user,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'user'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('User Added Successfully').position('top right')
						);
						gotoUser();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('EditUserController', EditUserController);

    /** @ngInject */
    function EditUserController($scope, $mdSidenav, User, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit User";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Users" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.userDB = User;
		vm.user = vm.userDB.userDets;
		if(__env.isDebug) console.log("User Det");
		if(__env.isDebug) console.log(vm.userDB);
				
		vm.statuslist = ['Active','Inactive'];
		//vm.type = ['Admin','Staff'];
		vm.type = vm.userDB.roles;
		
		if(vm.userDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveUser = saveUser;
		vm.gotoUser = gotoUser;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoUser()
        {
			//alert("1");
            $state.go('app.user-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveUser()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.user);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.userUpdate@save', {param:{user:vm.user,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'user'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('User Updated Successfully').position('top right')
						);
						gotoUser();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.units',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.units', {
				url    : '/units',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/units/units.html',
						controller : 'UnitsListController as vm'
					}
				},
				resolve: {					
					UnitsList: function (msApi)
					{					
						return msApi.resolve('app.unitsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.units-list', {
				url    : '/units',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/units/units.html',
						controller : 'UnitsListController as vm'
					}
				},
				resolve: {					
					UnitsList: function (msApi)
					{					
						return msApi.resolve('app.unitsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.units.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/units/new_units/new_units.html',
						controller : 'AddUnitsController as vm'
					}
				},
				resolve: {
					Units: function (msApi)
					{
						return msApi.resolve('app.unitsAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'units'
			})
			.state('app.units.edit', {
				url      : '/edit/:units_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/units/new_units/new_units.html',
						controller : 'EditUnitsController as vm'
					}
				},
				resolve: {
					Units: function ($stateParams, unitsService)
					{
						return unitsService.getUnits($stateParams.units_id,'Edit');
					}
				},
				bodyClass: 'units'
			})
			.state('app.units.edit-list', {
				url      : '/edit/:units_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/units/new_units/new_units.html',
						controller : 'EditUnitsController as vm'
					}
				},
				resolve: {
					Units: function ($stateParams, unitsService)
					{
						return unitsService.getUnits($stateParams.units_id,'Edit');
					}
				},
				bodyClass: 'units'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/units');
			
			// Api						
			msApiProvider.register('app.unitsList', ['unitsList']);
			msApiProvider.register('app.unitsSave', ['unitsSave']);
			msApiProvider.register('app.unitsUpdate', ['unitsUpdate']);
			msApiProvider.register('app.unitsAdd', ['unitsAdd']);
			msApiProvider.register('app.unitsEdit', ['unitsEdit']);
			msApiProvider.register('app.unitsDel', ['unitsDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('units', {
				title : 'Units',
				//icon  : 'icon-account-multiple',
				state : 'app.units',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.units')
        .factory('unitsService', unitsService);

    /** @ngInject */
    function unitsService($q, $mdToast, msApi)
    {
        var unitsEdit = [];

        var service = {
            getUnits	: getUnits			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getUnits(units_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( unitsEdit.length > 0 )
            {				
                deferred.resolve(unitsEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.unitsEdit@save', {param:{units_id:units_id},aToken:aToken,page:'units'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							unitsEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(unitsEdit);
																								
							// Resolve the promise
							deferred.resolve(unitsEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.units')
        .controller('AddUnitsController', AddUnitsController);

    /** @ngInject */
    function AddUnitsController($scope, $mdSidenav, Units, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Units";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables/Units" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.unitsDB = Units.data;        		     				
		if(__env.isDebug) console.log(vm.unitsDB);	
		vm.branchID = vm.unitsDB.branchID;
		
		//vm.units = {units_code:vm.unitsDB.unitsCode};
		vm.units = {unit_name:''};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.units = {units_status : "Active"};
				

		// Methods
        vm.saveUnits = saveUnits;
		vm.gotoUnits = gotoUnits;
						
		/**
         * Go to Staff page
         */
        function gotoUnits()
        {
			//alert("1");
            $state.go('app.units-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveUnits()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.units);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.unitsSave@save', {param:{units:vm.units,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'units'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Unit Added Successfully').position('top right')
						);
						gotoUnits();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.units')
        .controller('EditUnitsController', EditUnitsController);

    /** @ngInject */
    function EditUnitsController($scope, $mdSidenav, Units, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Units";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables/Units" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.unitsDB = Units;
		vm.units = vm.unitsDB.unitsDets;
		if(__env.isDebug) console.log("Units Det");
		if(__env.isDebug) console.log(vm.unitsDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.unitsDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveUnits = saveUnits;
		vm.gotoUnits = gotoUnits;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoUnits()
        {
			//alert("1");
            $state.go('app.units-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveUnits()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.units);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.unitsUpdate@save', {param:{units:vm.units,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'units'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Unit Updated Successfully').position('top right')
						);
						gotoUnits();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.transferin',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.transferin', {
				url    : '/transferin',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/transferin/transferin.html',
						controller : 'TransferinListController as vm'
					}
				},
				resolve: {					
					TransferinList: function (msApi)
					{					
						return msApi.resolve('app.transferinList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.transferin-list', {
				url    : '/transferin',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/transferin/transferin.html',
						controller : 'TransferinListController as vm'
					}
				},
				resolve: {					
					TransferinList: function (msApi)
					{					
						return msApi.resolve('app.transferinList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})			
			.state('app.transferin.edit', {
				url      : '/edit/:transfer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/transferin/new_transferin/new_transferin.html',
						controller : 'EditTransferinController as vm'
					}
				},
				resolve: {
					Transferin: function ($stateParams, transferinService)
					{
						return transferinService.getTransferin($stateParams.transfer_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'transferin'
			})
			.state('app.transferin.edit-list', {
				url      : '/edit/:transfer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/transferin/new_transferin/new_transferin.html',
						controller : 'EditTransferinController as vm'
					}
				},
				resolve: {
					Transferin: function ($stateParams, transferinService)
					{
						return transferinService.getTransferin($stateParams.transfer_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'transferin'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/transferin');
			
			// Api						
			msApiProvider.register('app.transferinList', ['transferinList']);			
			msApiProvider.register('app.transferinEdit', ['transferinEdit']);
			msApiProvider.register('app.transferinreceived', ['transferinreceived']);
			/*msApiProvider.register('app.updateAdmission', ['updateAdmission']);
			*/
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('transferin', {
				title : 'Transferin',
				//icon  : 'icon-account-multiple',
				state : 'app.transferin',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transferin')
        .factory('transferinService', transferinService);

    /** @ngInject */
    function transferinService($q, $mdToast, msApi)
    {
        var transferinEdit = [];

        var service = {
            getTransferin	: getTransferin,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getTransferin(transfer_id,branchID)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( transferEdit.length > 0 )
            {				
                deferred.resolve(transferEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.transferinEdit@save', {param:{transfer_id:transfer_id,branchID:branchID},aToken:aToken,page:'transfer'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							transferinEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(transferinEdit);
																								
							// Resolve the promise
							deferred.resolve(transferinEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transferin')
        .controller('AddTransferinController', AddTransferinController);

    /** @ngInject */
    function AddTransferinController($scope, $mdSidenav, Transferin, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Transfer In";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Transfer In" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.transferDB = Transferin.data;        		     				
		if(__env.isDebug) console.log(vm.transferDB);	
		
		vm.branchID = vm.transferDB.branchID;
		vm.branchList = vm.transferDB.branchList;
		vm.productsList = vm.transferDB.productsList;
		vm.warehouseList = vm.transferDB.warehouseList;
		
		vm.transfer_fullno = vm.transferDB.transferPre+'-'+vm.transferDB.transferNo;
		vm.transfer_date = vm.transferDB.transferDate1;		
		vm.transfer = {transfer_from_branch_id:vm.branchID, transfer_from_warehouse_id:'', transfer_to_branch_id:'', transfer_to_warehouse_id:'', transfer_no:vm.transferDB.transferNo, transfer_date:vm.transferDB.transferDate1, transfer_total_qty:0};
		
		if(__env.isDebug) console.log(vm.transfer);
				
		vm.cust_list = false;		
		
		vm.transferItems = [];		
		vm.newItems = {sno:1, prod_name:'', prod_id:'', prod_unit_id:'', prod_unit_name:'', prod_hqty:'0', prod_qty:'0', prod_list:false, prod_remove:false, prod_foucs:false};
		vm.transferItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.transferItems);									

		// Methods
        vm.addNewTransferin = addNewTransferin;
		vm.gotoTransferin = gotoTransferin;
		vm.setProdID = setProdID;		
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.removeProduct = removeProduct;
		vm.checkQty = checkQty;
								
		/**
         * Go to Staff page
         */		 				
		function showitmlist(param){			
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].sno == param){
					vm.transferItems[i].prod_list = true;
				}
			}	
		}		
						
        function gotoTransferin()
        {
			//alert("1");
            $state.go('app.transfer-list');
        }
		//setProdID();
		
		
		function setProdID(param,sno){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.transferDB.productsList;
			//alert(param);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.transferItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_hqty = '';
			vm.prod_unit_id = '';
			vm.prod_unit_name = '';
			vm.prod_qty = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].ingredients_id == param && arrInp[i].wstock_warehouse_id == vm.transfer.transfer_from_warehouse_id){
					//alert("In2");
					ind++;
					//alert(arrInp[i].wstock_hqty);
					vm.prod_name = arrInp[i].ingredients_name;
					vm.prod_id = arrInp[i].ingredients_id;
					vm.prod_hqty = arrInp[i].wstock_hqty;
					vm.prod_unit_id = arrInp[i].unit_id;
					vm.prod_unit_name = arrInp[i].unit_name;
					vm.prod_qty = 0;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.transferItems.length-1;
			var ind = vm.transferItems.length;
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(i);
				if(vm.transferItems[i].sno == sno){
					//vm.transferItems[i].sno 		= ind;
					vm.transferItems[i].prod_name 	= vm.prod_name;
					vm.transferItems[i].prod_id 	= vm.prod_id;
					vm.transferItems[i].prod_hqty 	= vm.prod_hqty;
					vm.transferItems[i].prod_unit_id 	= vm.prod_unit_id;
					vm.transferItems[i].prod_unit_name = vm.prod_unit_name;
					vm.transferItems[i].prod_qty 	= vm.prod_qty;				
					vm.transferItems[i].prod_list	= vm.prod_list;
					vm.transferItems[i].prod_remove = vm.prod_remove;
				}
			}
			
			if(vm.transferItems[len].prod_id!=""){ 
				vm.newItems = {sno:ind+1, prod_name:'', prod_id:'',prod_unit_id:'', prod_unit_name:'', prod_hqty:'0', prod_qty:'0', prod_list:false, prod_remove:false, prod_foucs:false};
				vm.transferItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.transferItems);
			sumTotal();						
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].prod_id == param){
					vm.transferItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.transferItems);
		}
		
		function checkQty(param){
			for(var i=0;i<vm.transferItems.length;i++){
				if(vm.transferItems[i].prod_id == param){							
					if(parseFloat(vm.transferItems[i].prod_hqty) < parseFloat(vm.transferItems[i].prod_qty)){						
						alert("Unable to issue more than hand qty.");
						vm.transferItems[i].prod_qty = 0;
						vm.transferItems[i].prod_foucs = true;
					}					
				}
			}
			sumTotal();
		}
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;			
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].prod_qty > 0){					
					vm.totalQty = vm.totalQty + parseFloat(vm.transferItems[i].prod_qty);					
				}
			}									
			vm.transfer.transfer_total_qty = vm.totalQty;			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.transferItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewTransferin()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.transfer);	
			if(__env.isDebug) console.log(vm.transferItems);			
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.transfersave@save', {param:{transfer:vm.transfer,transferitm:vm.transferItems,UserID:UserID},aToken:aToken,page:'transfer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Transfer Added Successfully').position('top right')
							);
							gotoTransferin();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transferin')
        .controller('EditTransferinController', EditTransferinController);

    /** @ngInject */
    function EditTransferinController($scope, $mdSidenav, Transferin, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Transfer In";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Transfer In" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
		}
		
        // Data
		vm.transferDB = Transferin;        		     				
		if(__env.isDebug) console.log(vm.transferDB);	
		//if(__env.isDebug) console.log(vm.transferDB.suppDets);
		
		vm.transferItems = [];
		
		vm.branchID = vm.transferDB.branchID;
		vm.branchList = vm.transferDB.branchList;
		vm.productsList = vm.transferDB.productsList;
		vm.warehouseList = vm.transferDB.warehouseList;
		
		vm.transfer = vm.transferDB.transferDets;
		vm.transferTempItems = vm.transferDB.transferItmDets;					
		
		vm.transfer_fullno = vm.transferDB.transferPre+'-'+vm.transfer.transfer_no;		
		if(__env.isDebug) console.log(vm.transfer);
								
		
		var ind = 0;
		for(var i=0;i<vm.transferTempItems.length;i++){
			ind++;		
			
			vm.obj = {sno:ind,prod_itmid:vm.transferTempItems[i].titm_id,prod_name:vm.transferTempItems[i].prod_name, prod_id:vm.transferTempItems[i].prod_id, prod_qty:vm.transferTempItems[i].titm_qty, prod_receqty:vm.transferTempItems[i].titm_received_qty, prod_missqty:vm.transferTempItems[i].titm_missing_qty, prod_unit_name:vm.transferTempItems[i].unit_name};
			vm.transferItems.push(vm.obj);
		}
		if(__env.isDebug) console.log(vm.transferItems);
											

		// Methods
        vm.addNewTransferin = addNewTransferin;
		vm.gotoTransferin = gotoTransferin;		
		vm.checkQty = checkQty;
				
		function gotoTransferin()
        {
			//alert("1");
            $state.go('app.transferin-list');
        }		
		
		function checkQty(param){
			for(var i=0;i<vm.transferItems.length;i++){
				if(vm.transferItems[i].prod_id == param){							
					if(parseFloat(vm.transferItems[i].prod_hqty) < parseFloat(vm.transferItems[i].prod_missqty)){						
						alert("Unable to set missing qty more than sent qty.");
						vm.transferItems[i].prod_qty = 0;
						vm.transferItems[i].prod_foucs = true;
					}					
				}
			}			
		}
		
        function addNewTransferin()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.transfer);	
			if(__env.isDebug) console.log(vm.transferItems);	
			//if(__env.isDebug) console.log(vm.payment);	
			//if(__env.isDebug) console.log(vm.extraItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.transferinreceived@save', {param:{transfer:vm.transfer,transferitm:vm.transferItems,UserID:UserID},aToken:aToken,page:'transfer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Transfer Completed Successfully').position('top right')
							);
							gotoTransferin();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transfer',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.transfer', {
				url    : '/transfer',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/transfer/transfer.html',
						controller : 'TransferListController as vm'
					}
				},
				resolve: {					
					TransferList: function (msApi)
					{					
						return msApi.resolve('app.transferList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.transfer-list', {
				url    : '/transfer',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/transfer/transfer.html',
						controller : 'TransferListController as vm'
					}
				},
				resolve: {					
					TransferList: function (msApi)
					{					
						return msApi.resolve('app.transferList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})			
			.state('app.transfer.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/transfer/new_transfer/new_transfer.html',
						controller : 'AddTransferController as vm'
					}
				},
				resolve: {
					Transfer: function (msApi)
					{
						return msApi.resolve('app.transferAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'transfer'
			})
			.state('app.transfer.edit', {
				url      : '/edit/:transfer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/transfer/new_transfer/new_transfer.html',
						controller : 'EditTransferController as vm'
					}
				},
				resolve: {
					Transfer: function ($stateParams, transferService)
					{
						return transferService.getTransfer($stateParams.transfer_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'transfer'
			})
			.state('app.transfer.edit-list', {
				url      : '/edit/:transfer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/transfer/new_transfer/new_transfer.html',
						controller : 'EditTransferController as vm'
					}
				},
				resolve: {
					Transfer: function ($stateParams, transferService)
					{
						return transferService.getTransfer($stateParams.transfer_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'transfer'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/transfer');
			
			// Api						
			msApiProvider.register('app.transferList', ['transferList']);			
			msApiProvider.register('app.transferAdd', ['transferAdd']);
			msApiProvider.register('app.transferEdit', ['transferEdit']);
			msApiProvider.register('app.transferDel', ['transferDel']);
			msApiProvider.register('app.transfersave', ['transfersave']);
			msApiProvider.register('app.transferUpdate', ['transferUpdate']);
			/*msApiProvider.register('app.updateAdmission', ['updateAdmission']);
			*/
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('transfer', {
				title : 'Transfer',
				//icon  : 'icon-account-multiple',
				state : 'app.transfer',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transfer')
        .factory('transferService', transferService);

    /** @ngInject */
    function transferService($q, $mdToast, msApi)
    {
        var transferEdit = [];

        var service = {
            getTransfer	: getTransfer,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getTransfer(transfer_id,branchID)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( transferEdit.length > 0 )
            {				
                deferred.resolve(transferEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.transferEdit@save', {param:{transfer_id:transfer_id,branchID:branchID},aToken:aToken,page:'transfer'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							transferEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(transferEdit);
																								
							// Resolve the promise
							deferred.resolve(transferEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transfer')
        .controller('AddTransferController', AddTransferController);

    /** @ngInject */
    function AddTransferController($scope, $mdSidenav, Transfer, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Transfer Out";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Transfer Out" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.transferDB = Transfer.data;        		     				
		if(__env.isDebug) console.log(vm.transferDB);	
		
		vm.branchID = vm.transferDB.branchID;
		vm.branchList = vm.transferDB.branchList;
		vm.prodList = vm.transferDB.productsList;
		vm.itmList = vm.transferDB.itemsList;
		vm.productsList = [];
		
		for(var i=0;i<vm.prodList.length;i++){
			vm.obj = {itm_id:vm.prodList[i].ingredients_id, itm_name:vm.prodList[i].ingredients_name, itm_unit_id:vm.prodList[i].unit_id, itm_unit_name:vm.prodList[i].unit_name, itm_hqty:vm.prodList[i].wstock_hqty, itm_branch_id:vm.prodList[i].wstock_branch_id, itm_warehouse:vm.prodList[i].wstock_warehouse_id, itm_type:'Ingredients'};
			vm.productsList.push(vm.obj);	
		}
		
		for(var i=0;i<vm.itmList.length;i++){
			vm.obj = {itm_id:vm.itmList[i].itemlist_id, itm_name:vm.itmList[i].itemlist_name, itm_unit_id:0, itm_unit_name:'', itm_hqty:vm.itmList[i].wstock_hqty, itm_branch_id:vm.itmList[i].wstock_branch_id, itm_warehouse:vm.itmList[i].wstock_warehouse_id, itm_type:'Items'};
			vm.productsList.push(vm.obj);	
		}
		if(__env.isDebug) console.log(vm.productsList);
		
		vm.warehouseList = vm.transferDB.warehouseList;
		
		vm.transfer_fullno = vm.transferDB.transferPre+'-'+vm.transferDB.transferNo;
		vm.transfer_date = vm.transferDB.transferDate1;		
		vm.transfer = {transfer_from_branch_id:vm.branchID, transfer_from_warehouse_id:'', transfer_to_branch_id:'', transfer_to_warehouse_id:'', transfer_no:vm.transferDB.transferNo, transfer_date:vm.transferDB.transferDate1, transfer_total_qty:0};
		
		if(__env.isDebug) console.log(vm.transfer);
				
		vm.cust_list = false;		
		
		vm.transferItems = [];		
		vm.newItems = {sno:1, prod_name:'', prod_id:'', prod_unit_id:'', prod_unit_name:'', prod_hqty:'0', prod_qty:'0', prod_list:false, prod_remove:false, prod_foucs:false};
		vm.transferItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.transferItems);									

		// Methods
        vm.addNewTransfer = addNewTransfer;
		vm.gotoTransfer = gotoTransfer;
		vm.setProdID = setProdID;		
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.removeProduct = removeProduct;
		vm.checkQty = checkQty;
								
		/**
         * Go to Staff page
         */		 				
		function showitmlist(param){			
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].sno == param){
					vm.transferItems[i].prod_list = true;
				}
			}	
		}		
						
        function gotoTransfer()
        {
			//alert("1");
            $state.go('app.transfer-list');
        }
		//setProdID();
		
		
		function setProdID(prod,sno){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.productsList;
			//alert(prod.itm_id);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.transferItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_hqty = '';
			vm.prod_unit_id = '';
			vm.prod_unit_name = '';
			vm.prod_qty = '';
			vm.prod_type = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(arrInp[i].itm_id+" == "+prod.itm_id+" && "+arrInp[i].itm_warehouse+" == "+vm.transfer.transfer_from_warehouse_id+" && "+arrInp[i].itm_type+" == "+prod.itm_type);
				if(arrInp[i].itm_id == prod.itm_id && arrInp[i].itm_warehouse == vm.transfer.transfer_from_warehouse_id && arrInp[i].itm_type == prod.itm_type){
					//alert("In2");
					ind++;
					//alert(arrInp[i].itm_hqty);
					vm.prod_name = arrInp[i].itm_name;
					vm.prod_id = arrInp[i].itm_id;
					vm.prod_hqty = arrInp[i].itm_hqty;
					vm.prod_unit_id = arrInp[i].itm_unit_id;
					vm.prod_unit_name = arrInp[i].itm_unit_name;
					vm.prod_qty = 0;
					vm.prod_type = arrInp[i].itm_type;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.transferItems.length-1;
			var ind = vm.transferItems.length;
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(i);
				if(vm.transferItems[i].sno == sno){
					//vm.transferItems[i].sno 		= ind;
					vm.transferItems[i].prod_name 	= vm.prod_name;
					vm.transferItems[i].prod_id 	= vm.prod_id;
					vm.transferItems[i].prod_hqty 	= vm.prod_hqty;
					vm.transferItems[i].prod_unit_id 	= vm.prod_unit_id;
					vm.transferItems[i].prod_unit_name = vm.prod_unit_name;
					vm.transferItems[i].prod_qty 	= vm.prod_qty;	
					vm.transferItems[i].prod_type 	= vm.prod_type;	
					vm.transferItems[i].prod_list	= vm.prod_list;
					vm.transferItems[i].prod_remove = vm.prod_remove;
				}
			}
			
			if(vm.transferItems[len].prod_id!=""){ 
				vm.newItems = {sno:ind+1, prod_name:'', prod_id:'',prod_unit_id:'', prod_unit_name:'', prod_hqty:'0', prod_qty:'0', prod_list:false, prod_remove:false, prod_foucs:false};
				vm.transferItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.transferItems);
			sumTotal();						
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].prod_id == param){
					vm.transferItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.transferItems);
		}
		
		function checkQty(param){
			for(var i=0;i<vm.transferItems.length;i++){
				if(vm.transferItems[i].prod_id == param){							
					if(parseFloat(vm.transferItems[i].prod_hqty) < parseFloat(vm.transferItems[i].prod_qty)){						
						alert("Unable to issue more than hand qty.");
						vm.transferItems[i].prod_qty = 0;
						vm.transferItems[i].prod_foucs = true;
					}					
				}
			}
			sumTotal();
		}
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;			
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].prod_qty > 0){					
					vm.totalQty = vm.totalQty + parseFloat(vm.transferItems[i].prod_qty);					
				}
			}									
			vm.transfer.transfer_total_qty = vm.totalQty;			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.transferItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewTransfer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.transfer);	
			if(__env.isDebug) console.log(vm.transferItems);			
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.transfersave@save', {param:{transfer:vm.transfer,transferitm:vm.transferItems,UserID:UserID},aToken:aToken,page:'transfer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Transfer Added Successfully').position('top right')
							);
							gotoTransfer();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.transfer')
        .controller('EditTransferController', EditTransferController);

    /** @ngInject */
    function EditTransferController($scope, $mdSidenav, Transfer, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Transfer Out";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Transfer Out" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.transferDB = Transfer;        		     				
		if(__env.isDebug) console.log(vm.transferDB);	
		//if(__env.isDebug) console.log(vm.transferDB.suppDets);
		
		vm.transferItems = [];
		
		vm.branchID = vm.transferDB.branchID;
		vm.branchList = vm.transferDB.branchList;
		vm.prodList = vm.transferDB.productsList;
		vm.itmList = vm.transferDB.itemsList;
		vm.warehouseList = vm.transferDB.warehouseList;
		vm.productsList = [];
		
		for(var i=0;i<vm.prodList.length;i++){
			vm.obj = {itm_id:vm.prodList[i].ingredients_id, itm_name:vm.prodList[i].ingredients_name, itm_unit_id:vm.prodList[i].unit_id, itm_unit_name:vm.prodList[i].unit_name, itm_hqty:vm.prodList[i].wstock_hqty, itm_branch_id:vm.prodList[i].wstock_branch_id, itm_warehouse:vm.prodList[i].wstock_warehouse_id, itm_type:'Ingredients'};
			vm.productsList.push(vm.obj);	
		}
		
		for(var i=0;i<vm.itmList.length;i++){
			vm.obj = {itm_id:vm.itmList[i].itemlist_id, itm_name:vm.itmList[i].itemlist_name, itm_unit_id:0, itm_unit_name:'', itm_hqty:vm.itmList[i].wstock_hqty, itm_branch_id:vm.itmList[i].wstock_branch_id, itm_warehouse:vm.itmList[i].wstock_warehouse_id, itm_type:'Items'};
			vm.productsList.push(vm.obj);	
		}
		if(__env.isDebug) console.log(vm.productsList);
		
		vm.transfer = vm.transferDB.transferDets;
		vm.transferTempItems = vm.transferDB.transferItmDets;					
		
		vm.transfer_fullno = vm.transferDB.transferPre+'-'+vm.transfer.transfer_no;		
		if(__env.isDebug) console.log(vm.transfer);
								
		
		var ind = 0;
		for(var i=0;i<vm.transferTempItems.length;i++){
			ind++;		
			
			vm.obj = {sno:ind ,prod_name:vm.transferTempItems[i].prod_name,  prod_id:vm.transferTempItems[i].prod_id, prod_unit_id:vm.transferTempItems[i].unit_id, prod_hqty:parseFloat(vm.transferTempItems[i].titm_hqty)+parseFloat(vm.transferTempItems[i].titm_qty_old), prod_qty:vm.transferTempItems[i].titm_qty, prod_qty_old:vm.transferTempItems[i].titm_qty_old, prod_unit_name:vm.transferTempItems[i].unit_name, prod_list:false, prod_remove:true, prod_foucs:false, prod_type:vm.transferTempItems[i].titm_type};
			vm.transferItems.push(vm.obj);
		}
		
		vm.newItems = {sno:ind+1, prod_name:'', prod_id:'', prod_unit_id:'',prod_unit_name:'', prod_hqty:'0', prod_qty:'0', prod_list:false, prod_remove:false, prod_foucs:false};
		vm.transferItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.transferItems);								

		// Methods
        vm.addNewTransfer = addNewTransfer;
		vm.gotoTransfer = gotoTransfer;
		vm.setProdID = setProdID;
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.removeProduct = removeProduct;
		vm.checkQty = checkQty;
						
				
		function gotoTransfer()
        {
			//alert("1");
            $state.go('app.transfer-list');
        }				 				

		function showitmlist(param){			
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].sno == param){
					vm.transferItems[i].prod_list = true;
				}
			}	
		}										        
		
		function setProdID(prod,sno){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.productsList;
			//alert(prod.itm_id);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.transferItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_hqty = '';
			vm.prod_unit_id = '';
			vm.prod_unit_name = '';
			vm.prod_qty = '';
			vm.prod_type = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(arrInp[i].itm_id+" == "+prod.itm_id+" && "+arrInp[i].itm_warehouse+" == "+vm.transfer.transfer_from_warehouse_id+" && "+arrInp[i].itm_type+" == "+prod.itm_type);
				if(arrInp[i].itm_id == prod.itm_id && arrInp[i].itm_warehouse == vm.transfer.transfer_from_warehouse_id && arrInp[i].itm_type == prod.itm_type){
					//alert("In2");
					ind++;
					//alert(arrInp[i].itm_hqty);
					vm.prod_name = arrInp[i].itm_name;
					vm.prod_id = arrInp[i].itm_id;
					vm.prod_hqty = arrInp[i].itm_hqty;
					vm.prod_unit_id = arrInp[i].itm_unit_id;
					vm.prod_unit_name = arrInp[i].itm_unit_name;
					vm.prod_qty = 0;
					vm.prod_type = arrInp[i].itm_type;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.transferItems.length-1;
			var ind = vm.transferItems.length;
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(i);
				if(vm.transferItems[i].sno == sno){
					//vm.transferItems[i].sno 		= ind;
					vm.transferItems[i].prod_name 	= vm.prod_name;
					vm.transferItems[i].prod_id 	= vm.prod_id;
					vm.transferItems[i].prod_hqty 	= vm.prod_hqty;
					vm.transferItems[i].prod_unit_id 	= vm.prod_unit_id;
					vm.transferItems[i].prod_unit_name = vm.prod_unit_name;
					vm.transferItems[i].prod_qty 	= vm.prod_qty;	
					vm.transferItems[i].prod_type 	= vm.prod_type;	
					vm.transferItems[i].prod_list	= vm.prod_list;
					vm.transferItems[i].prod_remove = vm.prod_remove;
				}
			}
			
			if(vm.transferItems[len].prod_id!=""){ 
				vm.newItems = {sno:ind+1, prod_name:'', prod_id:'',prod_unit_id:'', prod_unit_name:'', prod_hqty:'0', prod_qty:'0', prod_list:false, prod_remove:false, prod_foucs:false};
				vm.transferItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.transferItems);
			sumTotal();						
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].prod_id == param){
					vm.transferItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.transferItems);
		}
		
		function checkQty(param){
			for(var i=0;i<vm.transferItems.length;i++){
				if(vm.transferItems[i].prod_id == param){		
					//alert((parseFloat(vm.transferItems[i].prod_hqty)+parseFloat(vm.transferItems[i].prod_qty_old))+" < "+parseFloat(vm.transferItems[i].prod_qty));
					if(parseFloat(vm.transferItems[i].prod_hqty) < parseFloat(vm.transferItems[i].prod_qty)){						
						alert("Unable to issue more than hand qty.");
						vm.transferItems[i].prod_qty = vm.transferItems[i].prod_qty_old;
						vm.transferItems[i].prod_foucs = true;
					}					
				}
			}
			sumTotal();
		}
		
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;			
			for(var i=0;i<vm.transferItems.length;i++){
				//alert(vm.transferItems[i].prod_qty);
				if(vm.transferItems[i].prod_qty > 0){					
					vm.totalQty = vm.totalQty + parseFloat(vm.transferItems[i].prod_qty);					
				}
			}
									
			vm.transfer.transfer_total_qty = vm.totalQty;			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.transferItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewTransfer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.transfer);	
			if(__env.isDebug) console.log(vm.transferItems);	
			//if(__env.isDebug) console.log(vm.payment);	
			//if(__env.isDebug) console.log(vm.extraItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.transferUpdate@save', {param:{transfer:vm.transfer,transferitm:vm.transferItems,UserID:UserID},aToken:aToken,page:'transfer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Transfer Updated Successfully').position('top right')
							);
							gotoTransfer();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.category', {
				url    : '/category',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/category/category.html',
						controller : 'CategorysListController as vm'
					}
				},
				resolve: {					
					CategorysList: function (msApi)
					{					
						return msApi.resolve('app.categoryList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.category-list', {
				url    : '/category',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/category/category.html',
						controller : 'CategorysListController as vm'
					}
				},
				resolve: {					
					CategorysList: function (msApi)
					{					
						return msApi.resolve('app.categoryList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.category.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/category/new_category/new_category.html',
						controller : 'AddCategorysController as vm'
					}
				},
				resolve: {
					Categorys: function (msApi)
					{
						return msApi.resolve('app.categoryAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'category'
			})
			.state('app.category.edit', {
				url      : '/edit/:categorylist_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/category/new_category/new_category.html',
						controller : 'EditCategorysController as vm'
					}
				},
				resolve: {
					Categorys: function ($stateParams, categoryService)
					{
						return categoryService.getCategorys($stateParams.categorylist_id,'Edit');
					}
				},
				bodyClass: 'category'
			})
			.state('app.category.edit-list', {
				url      : '/edit/:categorylist_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/category/new_category/new_category.html',
						controller : 'EditCategorysController as vm'
					}
				},
				resolve: {
					Categorys: function ($stateParams, categoryService)
					{
						return categoryService.getCategorys($stateParams.categorylist_id,'Edit');
					}
				},
				bodyClass: 'category'
			})
			.state('app.category.items', {
				url      : '/items/:categorylist_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/category/items/items_list.html',
						controller : 'CategorysItemsListController as vm'
					}
				},
				resolve: {
					Items: function ($stateParams, categoryService)
					{
						return categoryService.getItems($stateParams.categorylist_id);
					}
				},
				bodyClass: 'category'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/category');
			
			// Api						
			msApiProvider.register('app.categoryList', ['categoryList']);
			msApiProvider.register('app.saveCategorys', ['saveCategorys']);
			msApiProvider.register('app.categorySave', ['categorySave']);
			msApiProvider.register('app.categoryUpdate', ['categoryUpdate']);
			msApiProvider.register('app.categoryAdd', ['categoryAdd']);
			msApiProvider.register('app.categoryEdit', ['categoryEdit']);
			msApiProvider.register('app.categoryDel', ['categoryDel']);
			msApiProvider.register('app.removeCategoryImage', ['removeCategoryImage']);
			msApiProvider.register('app.catItemList', ['catItemList']);
			msApiProvider.register('app.catItemSave', ['catItemSave']);

			msApiProvider.register('app.uploadCatImage', ['uploadCatImage']);
			msApiProvider.register('app.catImageEdit', ['catImageEdit']);
			
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('category', {
				title : 'Category',
				//icon  : 'icon-account-multiple',
				state : 'app.category',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category')
        .controller('CategorysItemsListController', CategorysItemsListController);

    /** @ngInject */
    function CategorysItemsListController($state, Items, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Categorys";
		
        // Data
        vm.itemList = Items;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.itemList);
		vm.items = vm.itemList.itemList;
		vm.catItems = vm.itemList.itemCat;
		vm.catID = vm.itemList.category_id;
        vm.listForm={};
		
		if(vm.itemList.error == "1"){
			gotoLogin();
		} 
		for(var i=0;i<vm.items.length;i++){
			for(var j=0;j<vm.catItems.length;j++){
				if(vm.items[i].item_id == vm.catItems[j].catitm_item_id){
					vm.items[i].selectedchk = 1;
					vm.items[i].order = vm.catItems[j].catitm_order;
				}
			}
		}
		
		if(__env.isDebug) console.log(vm.items);
        		
       	
        // Methods
       
		vm.gotoCategorys = gotoCategorys;	
		vm.saveCatItems = saveCatItems;
		vm.gotoLogin = gotoLogin;	
		vm.setItems = setItems;
		vm.selectAll = selectAll;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function selectAll(){
			if(vm.mainChk==0){
				vm.mainChk=1;
				for(var i=0;i<vm.items.length;i++){
					vm.items[i].selectedchk = 1;
				}
			} else {
				vm.mainChk=0;	
				for(var i=0;i<vm.items.length;i++){
					vm.items[i].selectedchk = 0;
				}	
			}
		}
        
		function gotoCategorys()
        {
			//alert("1");
            $state.go('app.category-list');
        }
		
		function setItems(catID){
			$state.go('app.category.items', {category_id: catID});
		}
							
		function saveCatItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.items);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.catItemSave@save', {param:{items:vm.items,catID:vm.catID},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoCategorys();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.template',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.template', {
				url    : '/template',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/template/template.html',
						controller : 'TemplatesListController as vm'
					}
				},
				resolve: {					
					TemplatesList: function (msApi)
					{					
						return msApi.resolve('app.templateList@get');
					}, 
				}
			})
			.state('app.template-list', {
				url    : '/template',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/template/template.html',
						controller : 'TemplatesListController as vm'
					}
				},
				resolve: {					
					TemplatesList: function (msApi)
					{					
						return msApi.resolve('app.templateList@get');
					}, 
				}
			})	
			.state('app.template.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/template/new-template/new-template.html',
						controller : 'NewTemplateController as vm'
					}
				},
				resolve: {
					Templates: function (msApi)
					{
						return msApi.resolve('app.templateAdd@get');
						//return '';
					}
				},
				bodyClass: 'template'
			})
			.state('app.template.edit', {
				url      : '/edit/:template_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/template/new-template/new-template.html',
						controller : 'EditTemplateController as vm'
					}
				},
				resolve: {
					Templates: function ($stateParams, templateService)
					{
						return templateService.getTemplate($stateParams.template_id,'Edit');
					}
				},
				bodyClass: 'template'
			})
			.state('app.template.edit-list', {
				url      : '/edit/:template_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/template/new-template/new-template.html',
						controller : 'EditTemplateController as vm'
					}
				},
				resolve: {
					Templates: function ($stateParams, templateService)
					{
						return templateService.getTemplate($stateParams.template_id,'Edit');
					}
				},
				bodyClass: 'template'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/template');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.templateList', ['templateList']);
			msApiProvider.register('app.templateSave', ['templateSave']);
			msApiProvider.register('app.templateUpdate', ['templateUpdate']);
			msApiProvider.register('app.templateAdd', ['templateAdd']);
			msApiProvider.register('app.templateEdit', ['templateEdit']);
			msApiProvider.register('app.templateDel', ['templateDel']);			
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('template', {
				title : 'Template',
				//icon  : 'icon-account-multiple',
				state : 'app.template',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.template')
        .factory('templateService', templateService);

    /** @ngInject */
    function templateService($q, $mdToast, msApi)
    {
        var templateEdit = [];

        var service = {
            getTemplate	: getTemplate			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getTemplate(template_id)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.templateEdit@save', {param:{template_id:template_id},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						templateEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(templateEdit);
																							
						// Resolve the promise
						deferred.resolve(templateEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }						
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.template')
        .controller('NewTemplateController', NewTemplateController);

    /** @ngInject */
    function NewTemplateController($scope, $mdSidenav, Templates, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Template";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Templates" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.templateDB = Templates.data;
		//vm.template = vm.templateDB.settingDets;
		if(__env.isDebug) console.log("Template Det");
		if(__env.isDebug) console.log(vm.template);
				
		/*if(vm.templateDB.error == "1"){
			gotoLogin();
		} */	
		
		vm.template = {template_name:'', template_design:''};
              
		// Methods
        vm.saveTemplate = saveTemplate;
		vm.gotoTemplate = gotoTemplate;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoTemplate()
        {
			//alert("1");
            $state.go('app.template-list');
        }				
				
		function saveTemplate()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.template);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.templateSave@save', {param:{template:vm.template,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'template'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Template Saved Successfully').position('top right')
						);
						gotoTemplate();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.template')
        .controller('EditTemplateController', EditTemplateController);

    /** @ngInject */
    function EditTemplateController($scope, $mdSidenav, Templates, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Template";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Templates" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.templateDB = Templates;
		//vm.template = vm.templateDB.settingDets;
		if(__env.isDebug) console.log("Template Det");
		if(__env.isDebug) console.log(vm.template);
				
		/*if(vm.templateDB.error == "1"){
			gotoLogin();
		} */	
		
		vm.template = vm.templateDB.templateDets;
              
		// Methods
        vm.saveTemplate = saveTemplate;
		vm.gotoTemplate = gotoTemplate;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoTemplate()
        {
			//alert("1");
            $state.go('app.template-list');
        }				
				
		function saveTemplate()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.template);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.templateUpdate@save', {param:{template:vm.template,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'template'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Template Updated Successfully').position('top right')
						);
						gotoTemplate();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.tax',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.tax', {
				url    : '/tax',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/tax/tax.html',
						controller : 'TaxListController as vm'
					}
				},
				resolve: {					
					TaxList: function (msApi)
					{					
						return msApi.resolve('app.taxList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.tax-list', {
				url    : '/tax',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/tax/tax.html',
						controller : 'TaxListController as vm'
					}
				},
				resolve: {					
					TaxList: function (msApi)
					{					
						return msApi.resolve('app.taxList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.tax.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tax/new_tax/new_tax.html',
						controller : 'AddTaxController as vm'
					}
				},
				resolve: {
					Tax: function (msApi)
					{
						return msApi.resolve('app.taxAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'tax'
			})
			.state('app.tax.edit', {
				url      : '/edit/:tax_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tax/new_tax/new_tax.html',
						controller : 'EditTaxController as vm'
					}
				},
				resolve: {
					Tax: function ($stateParams, taxService)
					{
						return taxService.getTax($stateParams.tax_id,'Edit');
					}
				},
				bodyClass: 'tax'
			})
			.state('app.tax.edit-list', {
				url      : '/edit/:tax_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tax/new_tax/new_tax.html',
						controller : 'EditTaxController as vm'
					}
				},
				resolve: {
					Tax: function ($stateParams, taxService)
					{
						return taxService.getTax($stateParams.tax_id,'Edit');
					}
				},
				bodyClass: 'tax'
			})
			.state('app.tax.mapping', {
				url      : '/mapping/:tax_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tax/mapping/tax_mapping.html',
						controller : 'TaxMappingController as vm'
					}
				},
				resolve: {
					TaxMapping: function ($stateParams, taxService)
					{
						return taxService.getPrinterMapping($stateParams.tax_id);
					}
				},
				bodyClass: 'tax'
			})
			.state('app.tax.option', {
				url      : '/option/:tax_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/tax/options/tax_option.html',
						controller : 'TaxOptionController as vm'
					}
				},
				resolve: {
					TaxOptions: function ($stateParams, taxService)
					{
						return taxService.getPrinterMapping($stateParams.tax_id);
					}
				},
				bodyClass: 'tax'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/tax');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.taxList', ['taxList']);
			msApiProvider.register('app.taxSave', ['taxSave']);
			msApiProvider.register('app.taxUpdate', ['taxUpdate']);
			msApiProvider.register('app.taxAdd', ['taxAdd']);
			msApiProvider.register('app.taxEdit', ['taxEdit']);
			msApiProvider.register('app.taxDel', ['taxDel']);
			
			msApiProvider.register('app.printerMapping', ['printerMapping']);
			msApiProvider.register('app.savePrinterMapping', ['savePrinterMapping']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('tax', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.tax',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tax')
        .factory('taxService', taxService);

    /** @ngInject */
    function taxService($q, $mdToast, msApi)
    {
        var taxEdit = [], taxMap = [];

        var service = {
            getTax	: getTax,
			getPrinterMapping : getPrinterMapping,
			getPrinterOption : getPrinterOption,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getTax(tax_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.taxEdit@save', {param:{tax_id:tax_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'tax'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						taxEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(taxEdit);
						taxEdit['taxID'] = tax_id;
																							
						// Resolve the promise
						deferred.resolve(taxEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getPrinterMapping(tax_id)
        {						
			//alert(tax_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {param:{taxID:tax_id},aToken:aToken,page:'tax'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						taxMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(taxMap);
						taxMap['taxID'] = tax_id;
																							
						// Resolve the promise
						deferred.resolve(taxMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getPrinterOption(tax_id)
        {						
			//alert(tax_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {aToken:aToken,page:'tax'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						taxMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(taxMap);
						taxMap['taxID'] = tax_id;
																							
						// Resolve the promise
						deferred.resolve(taxMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tax')
        .controller('AddTaxController', AddTaxController);

    /** @ngInject */
    function AddTaxController($scope, $mdSidenav, Tax, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Tax";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tax Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
		vm.taxDB = Tax.data;        		     				
		if(__env.isDebug) console.log(vm.taxDB);
		
		vm.branchID = vm.taxDB.branchID;
		
		//vm.tax = {tax_code:vm.taxDB.taxCode};
		vm.tax = {tax_name:'', tax_branch_id:vm.branchID, tax_type:'Exclusive', tax_rate:'', tax_status:'Active'};
		
		vm.depts = vm.taxDB.departmentList;
		vm.categorys = vm.taxDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.taxDB.itemList;
		
		
		vm.taxMapItems = [];
		var obj ={tax_map_id:Math.floor(Math.random()*1000), tax_map_branch_id:vm.branchID, tax_map_tax_id:'', tax_map_department_id:0, tax_map_category_id:0, tax_map_item_id:0};
		vm.taxMapItems.push(obj);
		if(__env.isDebug) console.log(vm.taxMapItems);
		
		
		vm.typelist = ['Inclusive','Exclusive'];
		vm.statuslist = ['Active','Inactive'];
		
		
		
		// Methods
        vm.saveTax = saveTax;
		vm.gotoTax = gotoTax;
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoTax()
        {
			//alert("1");
            $state.go('app.tax-list');
        }
						
		function saveTax()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.tax);
			if(__env.isDebug) console.log(vm.taxMapItems);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.taxSave@save', {param:{tax:vm.tax,taxMapItems:vm.taxMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'tax'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Tax Added Successfully').position('top right')
							);
							gotoTax();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_tax_id:'', print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.taxMapItems.push(obj);
			if(__env.isDebug) console.log(vm.taxMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.taxMapItems.length;i++){	
				if(vm.taxMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.taxMapItems.splice(i, 1);
				}
			}
        }
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tax')
        .controller('EditTaxController', EditTaxController);

    /** @ngInject */
    function EditTaxController($scope, $mdSidenav, Tax, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Printer Jobs";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tax Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.taxDB = Tax;		
		if(__env.isDebug) console.log("Tax Det");
		if(__env.isDebug) console.log(vm.taxDB);
		vm.branchID = vm.taxDB.branchID;
		vm.tax = vm.taxDB.taxDets;
		vm.depts = vm.taxDB.departmentList;
		vm.categorys = vm.taxDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.taxDB.itemList;
		vm.mapList = vm.taxDB.mapList;
		vm.taxID = vm.taxDB.taxID;
		vm.taxMapItems = [];
		
		vm.mapList = vm.taxDB.mapList;
		vm.taxID = vm.taxDB.taxID;
		if(vm.mapList.length > 0){
			vm.taxMapItems = vm.mapList;
		} else {
			var obj ={tax_map_id:Math.floor(Math.random()*1000), tax_map_branch_id:vm.branchID, tax_map_tax_id:vm.taxID, tax_map_department_id:0, tax_map_category_id:0, tax_map_item_id:0};
			vm.taxMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.taxMapItems);
		
		
		vm.typelist = ['Inclusive','Exclusive'];
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.taxDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveTax = saveTax;
		vm.gotoTax = gotoTax;	
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoTax()
        {
			//alert("1");
            $state.go('app.tax-list');
        }
								
		function saveTax()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.tax);
			if(__env.isDebug) console.log(vm.taxMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.taxUpdate@save', {param:{tax:vm.tax,taxMapItems:vm.taxMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'tax'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printers Updated Successfully').position('top right')
							);
							gotoTax();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={tax_map_id:Math.floor(Math.random()*1000), tax_map_branch_id:vm.branchID, tax_map_tax_id:vm.taxID, tax_map_department_id:0, tax_map_category_id:0, tax_map_item_id:0};
			vm.taxMapItems.push(obj);
			if(__env.isDebug) console.log(vm.taxMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.taxMapItems.length;i++){	
				if(vm.taxMapItems[i].tax_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.taxMapItems.splice(i, 1);
				}
			}
        }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.printers', {
				url    : '/printers',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/printers/printers.html',
						controller : 'PrintersListController as vm'
					}
				},
				resolve: {					
					PrintersList: function (msApi)
					{					
						return msApi.resolve('app.printersList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.printers-list', {
				url    : '/printers',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/printers/printers.html',
						controller : 'PrintersListController as vm'
					}
				},
				resolve: {					
					PrintersList: function (msApi)
					{					
						return msApi.resolve('app.printersList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.printers.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printers/new_printers/new_printers.html',
						controller : 'AddPrintersController as vm'
					}
				},
				resolve: {
					Printers: function (msApi)
					{
						return msApi.resolve('app.printersAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'printers'
			})
			.state('app.printers.edit', {
				url      : '/edit/:printers_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printers/new_printers/new_printers.html',
						controller : 'EditPrintersController as vm'
					}
				},
				resolve: {
					Printers: function ($stateParams, printersService)
					{
						return printersService.getPrinters($stateParams.printers_id,'Edit');
					}
				},
				bodyClass: 'printers'
			})
			.state('app.printers.edit-list', {
				url      : '/edit/:printers_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printers/new_printers/new_printers.html',
						controller : 'EditPrintersController as vm'
					}
				},
				resolve: {
					Printers: function ($stateParams, printersService)
					{
						return printersService.getPrinters($stateParams.printers_id,'Edit');
					}
				},
				bodyClass: 'printers'
			})
			.state('app.printers.mapping', {
				url      : '/mapping/:printers_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printers/mapping/printers_mapping.html',
						controller : 'PrintersMappingController as vm'
					}
				},
				resolve: {
					PrintersMapping: function ($stateParams, printersService)
					{
						return printersService.getPrinterMapping($stateParams.printers_id);
					}
				},
				bodyClass: 'printers'
			})
			.state('app.printers.option', {
				url      : '/option/:printers_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printers/options/printers_option.html',
						controller : 'PrintersOptionController as vm'
					}
				},
				resolve: {
					PrintersOptions: function ($stateParams, printersService)
					{
						return printersService.getPrinterMapping($stateParams.printers_id);
					}
				},
				bodyClass: 'printers'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/printers');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.printersList', ['printersList']);
			msApiProvider.register('app.printersSave', ['printersSave']);
			msApiProvider.register('app.printersUpdate', ['printersUpdate']);
			msApiProvider.register('app.printersAdd', ['printersAdd']);
			msApiProvider.register('app.printersEdit', ['printersEdit']);
			msApiProvider.register('app.printersDel', ['printersDel']);
			
			msApiProvider.register('app.printerMapping', ['printerMapping']);
			msApiProvider.register('app.savePrinterMapping', ['savePrinterMapping']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('printers', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.printers',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .controller('PrintersMappingController', PrintersMappingController);

    /** @ngInject */
    function PrintersMappingController($state, PrintersMapping, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Printers";
		
        // Data
        vm.itemList = PrintersMapping;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.itemList);
		//vm.roles = vm.itemList.roleList;
		vm.depts = vm.itemList.departmentList;
		vm.categorys = vm.itemList.categoryList;
		//vm.tickets = {};
		vm.items = vm.itemList.itemList;
		vm.mapList = vm.itemList.mapList;
		vm.printersID = vm.itemList.printersID;
		vm.printerMapItems = [];
		if(vm.mapList.length > 0){
			vm.printerMapItems = vm.mapList;
		} else {
			var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_printers_id:vm.printersID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.printerMapItems);
		
		if(vm.itemList.error == "1"){
			gotoLogin();
		} 
		
        // Methods
       
		vm.gotoPrinters = gotoPrinters;	
		vm.savePrintersItems = savePrintersItems;
		vm.gotoLogin = gotoLogin;			
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }				
        
		function gotoPrinters()
        {
			//alert("1");
            $state.go('app.printers-list');
        }
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_printers_id:vm.printersID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.printerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.printerMapItems.length;i++){	
				if(vm.printerMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.printerMapItems.splice(i, 1);
				}
			}
        }
		
		function savePrintersItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printerMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.savePrinterMapping@save', {param:{printersID:vm.printersID,printerMapItems:vm.printerMapItems},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoPrinters();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.supplier',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.supplier', {
				url    : '/supplier',
				views  : {
					'main@app': {
                        templateUrl: 'app/core/layouts/vertical-navigation2.html',
                        controller : 'MainController as vm'
                    },
					'content@app': {
						templateUrl: 'app/main/apps/supplier/supplier.html',
						controller : 'SupplierListController as vm'
					}
				},
				resolve: {					
					SupplierList: function (msApi)
					{					
						return msApi.resolve('app.supplierList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.supplier-list', {
				url    : '/supplier',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/supplier/supplier.html',
						controller : 'SupplierListController as vm'
					}
				},
				resolve: {					
					SupplierList: function (msApi)
					{					
						return msApi.resolve('app.supplierList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.supplier.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/supplier/new_supplier/new_supplier.html',
						controller : 'AddSupplierController as vm'
					}
				},
				resolve: {
					Supplier: function (msApi)
					{
						return msApi.resolve('app.supplierAdd@get',{branchID:localStorage.getItem('BranchID'),type:'Cust'});
						//return '';
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.supplier.new', {
				url      : '/new',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/supplier/new_supplier/new_supplier.html',
						controller : 'AddSupplierController as vm'
					}
				},
				resolve: {
					Supplier: function (msApi)
					{
						return msApi.resolve('app.supplierAdd@get',{branchID:localStorage.getItem('BranchID'),type:'CustSel'});
						//return '';
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.supplier.edit', {
				url      : '/edit/:supplier_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/supplier/new_supplier/new_supplier.html',
						controller : 'EditSupplierController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.supplier.edit-list', {
				url      : '/edit/:supplier_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/supplier/new_supplier/new_supplier.html',
						controller : 'EditSupplierController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return clientService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/supplier');
			
			// Api						
			msApiProvider.register('app.supplierList', ['supplierList']);
			msApiProvider.register('app.supplierSave', ['supplierSave']);
			msApiProvider.register('app.supplierUpdate', ['supplierUpdate']);
			msApiProvider.register('app.supplierAdd', ['supplierAdd']);
			msApiProvider.register('app.supplierEdit', ['supplierEdit']);
			msApiProvider.register('app.supplierDel', ['supplierDel']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('supplier', {
				title : 'Suppliers',
				//icon  : 'icon-account-multiple',
				state : 'app.supplier',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.supplier')
        .factory('supplierService', supplierService);

    /** @ngInject */
    function supplierService($q, $mdToast, msApi)
    {
        var supplierEdit = [];

        var service = {
            getSupplier	: getSupplier			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getSupplier(supplier_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( supplierEdit.length > 0 )
            {				
                deferred.resolve(supplierEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.supplierEdit@save', {param:{supplier_id:supplier_id},aToken:aToken,page:'supplier'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							supplierEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(supplierEdit);
																								
							// Resolve the promise
							deferred.resolve(supplierEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.supplier')
        .controller('AddSupplierController', AddSupplierController);

    /** @ngInject */
    function AddSupplierController($scope, $mdSidenav, Supplier, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Supplier";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Suppliers" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.supplierDB = Supplier.data;        		     				
		if(__env.isDebug) console.log(vm.supplierDB);	
		vm.branchID = vm.supplierDB.branchID;
		vm.type = vm.supplierDB.type;
		
		//vm.supplier = {supplier_code:vm.supplierDB.supplierCode};
		vm.supplier = {supplier_name:'', supplier_branch_id:vm.branchID, supplier_mobileno:'', supplier_address:'', supplier_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.supplier = {supplier_status : "Active"};
				

		// Methods
        vm.saveSupplier = saveSupplier;
		vm.gotoSupplier = gotoSupplier;
						
		/**
         * Go to Staff page
         */
        function gotoSupplier()
        {
			//alert(vm.type);
			if(vm.type == "Cust"){
				$state.go('app.supplier-list');
			} else if(vm.type == "CustSel"){
	            $state.go('app.supplier-selection-list');
			}
        }
						
		/**
         * Add New Staff
        **/
        function saveSupplier()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.supplier);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.supplierSave@save', {param:{supplier:vm.supplier,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Supplier Added Successfully').position('top right')
						);
						gotoSupplier();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.supplier')
        .controller('EditSupplierController', EditSupplierController);

    /** @ngInject */
    function EditSupplierController($scope, $mdSidenav, Supplier, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Supplier";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Suppliers" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.supplierDB = Supplier;
		vm.supplier = vm.supplierDB.supplierDets;
		if(__env.isDebug) console.log("Supplier Det");
		if(__env.isDebug) console.log(vm.supplierDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.supplierDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveSupplier = saveSupplier;
		vm.gotoSupplier = gotoSupplier;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoSupplier()
        {
			//alert("1");
            $state.go('app.supplier-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveSupplier()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.supplier);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.supplierUpdate@save', {param:{supplier:vm.supplier,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Supplier Updated Successfully').position('top right')
						);
						gotoSupplier();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.stock-update-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.stock-update-report', {
				url    : '/stock-update-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/stock-update-report/stock-update-report.html',
						controller : 'StockUpdateReportController as vm'
					}
				},
				resolve: {					
					ItemReportList: function (msApi)
					{					
						return msApi.resolve('app.stockupdateReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.stock-update-report-list', {
				url    : '/stock-update-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/stock-update-report/stock-update-report.html',
						controller : 'StockUpdateReportController as vm'
					}
				},
				resolve: {					
					ItemReportList: function ($stateParams, stockupdatereportService)
					{
						
						return stockupdatereportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/item-report');
			
			// Api						
			msApiProvider.register('app.stockupdateReportList', ['stockupdateReportList']);
			msApiProvider.register('app.stockupdateReportList2', ['stockupdateReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.stock-update-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.stock-update-report')
        .factory('stockupdatereportService', stockupdatereportService);

    /** @ngInject */
    function stockupdatereportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(stockupdateDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.stockupdateReportList2@save', {param:{stockupdateDets:stockupdateDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.staff',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.staff', {
				url    : '/staff',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/staff/staff.html',
						controller : 'StaffListController as vm'
					}
				},
				resolve: {					
					StaffList: function (msApi)
					{					
						return msApi.resolve('app.staffList@get');
					}, 
				}
			})
			.state('app.staff-list', {
				url    : '/staff',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/staff/staff.html',
						controller : 'StaffListController as vm'
					}
				},
				resolve: {					
					StaffList: function (msApi)
					{					
						return msApi.resolve('app.staffList@get');
					}, 
				}
			})	
			.state('app.staff.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/staff/new_staff/new_staff.html',
						controller : 'AddStaffController as vm'
					}
				},
				resolve: {
					Staff: function (msApi)
					{
						return msApi.resolve('app.staffAdd@get');
						//return '';
					}
				},
				bodyClass: 'staff'
			})
			.state('app.staff.edit', {
				url      : '/edit/:staff_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/staff/new_staff/new_staff.html',
						controller : 'EditStaffController as vm'
					}
				},
				resolve: {
					Staff: function ($stateParams, staffService)
					{
						return staffService.getStaff($stateParams.staff_id,'Edit');
					}
				},
				bodyClass: 'staff'
			})
			.state('app.staff.edit-list', {
				url      : '/edit/:staff_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/staff/new_staff/new_staff.html',
						controller : 'EditStaffController as vm'
					}
				},
				resolve: {
					Staff: function ($stateParams, staffService)
					{
						return staffService.getStaff($stateParams.staff_id,'Edit');
					}
				},
				bodyClass: 'staff'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/staff');
			
			// Api						
			msApiProvider.register('app.staffList', ['staffList']);
			msApiProvider.register('app.staffSave', ['staffSave']);
			msApiProvider.register('app.staffUpdate', ['staffUpdate']);
			msApiProvider.register('app.staffAdd', ['staffAdd']);
			msApiProvider.register('app.staffEdit', ['staffEdit']);
			msApiProvider.register('app.staffDel', ['staffDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('staff', {
				title : 'Staffs',
				//icon  : 'icon-account-multiple',
				state : 'app.staff',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.staff')
        .factory('staffService', staffService);

    /** @ngInject */
    function staffService($q, $mdToast, msApi)
    {
        var staffEdit = [];

        var service = {
            getStaff	: getStaff			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getStaff(staff_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( staffEdit.length > 0 )
            {				
                deferred.resolve(staffEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.staffEdit@save', {param:{staff_id:staff_id},aToken:aToken,page:'staff'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							staffEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(staffEdit);
																								
							// Resolve the promise
							deferred.resolve(staffEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.staff')
        .controller('AddStaffController', AddStaffController);

    /** @ngInject */
    function AddStaffController($scope, $mdSidenav, Staff, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Staff";
		
        // Data
		vm.staffDB = Staff.data;        		     				
		if(__env.isDebug) console.log(vm.staffDB);	
		
		vm.staff = {staff_name:'', staff_designation:'', staff_mobile:'', staff_email:'', staff_address:'', staff_username:'', staff_password:'', staff_doj:vm.staffDB.joinDate1, staff_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.staff = {staff_status : "Active"};				

		// Methods
        vm.saveStaff = saveStaff;
		vm.gotoStaff = gotoStaff;				
		vm.setUsername = setUsername;
						
		
        function gotoStaff()
        {
			//alert("1");
            $state.go('app.staff-list');
        }
		
		function setUsername(){
			vm.staff.staff_username = vm.staff.staff_email;	
		}
		
        function saveStaff()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.staff);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				//alert("IF");	
				msApi.request('app.staffSave@save', {param:{staff:vm.staff,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'staff'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);						
						
						$mdToast.show(
							$mdToast.simple().textContent('Staff Added Successfully').position('top right')
						);
						gotoStaff();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
				
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.staff')
        .controller('EditStaffController', EditStaffController);

    /** @ngInject */
    function EditStaffController($scope, $mdSidenav, Staff, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Staff";
		
        // Data		
		vm.staffDB = Staff;
		vm.staff = vm.staffDB.staffDets;
		if(__env.isDebug) console.log("Staff Det");
		if(__env.isDebug) console.log(vm.staffDB);
		
		if(vm.staff.staff_doj=="0000-00-00"){
			vm.staff.staff_doj = vm.staffDB.joinDate1;
		}	
			
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.staffDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveStaff = saveStaff;
		vm.gotoStaff = gotoStaff;	
		vm.gotoStaffEdit = gotoStaffEdit;	
		//if(__env.isDebug) console.log(vm.studentList);
		vm.gotoLogin = gotoLogin;		
		vm.setUsername = setUsername;
								
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function setUsername(){
			vm.staff.staff_username = vm.staff.staff_email;	
		}
				
        function gotoStaff()
        {
			//alert("1");
            $state.go('app.staff-list');
        }
		
		function gotoStaffEdit(staff_id)
        {
			//alert(staff_id);
            $state.go('app.staff.edit-list', {staff_id: staff_id});
        }
				
		function saveStaff()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.staff);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.staffUpdate@save', {param:{staff:vm.staff,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'staff'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Staff Updated Successfully').position('top right')
						);
						gotoStaff();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.seats',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.seats', {
				url    : '/seats',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/seats/seats.html',
						controller : 'SeatsListController as vm'
					}
				},
				resolve: {					
					SeatsList: function (msApi)
					{					
						return msApi.resolve('app.seatsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.seats-list', {
				url    : '/seats',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/seats/seats.html',
						controller : 'SeatsListController as vm'
					}
				},
				resolve: {					
					SeatsList: function (msApi)
					{					
						return msApi.resolve('app.seatsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.seats.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/seats/new_seats/new_seats.html',
						controller : 'AddSeatsController as vm'
					}
				},
				resolve: {
					Seats: function (msApi)
					{
						return msApi.resolve('app.seatsAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'seats'
			})
			.state('app.seats.edit', {
				url      : '/edit/:seats_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/seats/new_seats/new_seats.html',
						controller : 'EditSeatsController as vm'
					}
				},
				resolve: {
					Seats: function ($stateParams, seatsService)
					{
						return seatsService.getSeats($stateParams.seats_id,'Edit');
					}
				},
				bodyClass: 'seats'
			})
			.state('app.seats.edit-list', {
				url      : '/edit/:seats_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/seats/new_seats/new_seats.html',
						controller : 'EditSeatsController as vm'
					}
				},
				resolve: {
					Seats: function ($stateParams, seatsService)
					{
						return clientService.getSeats($stateParams.seats_id,'Edit');
					}
				},
				bodyClass: 'seats'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/seats');
			
			// Api						
			msApiProvider.register('app.seatsList', ['seatsList']);
			msApiProvider.register('app.seatsSave', ['seatsSave']);
			msApiProvider.register('app.seatsUpdate', ['seatsUpdate']);
			msApiProvider.register('app.seatsAdd', ['seatsAdd']);
			msApiProvider.register('app.seatsEdit', ['seatsEdit']);
			msApiProvider.register('app.seatsDel', ['seatsDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('seats', {
				title : 'Seats',
				//icon  : 'icon-account-multiple',
				state : 'app.seats',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.seats')
        .factory('seatsService', seatsService);

    /** @ngInject */
    function seatsService($q, $mdToast, msApi)
    {
        var seatsEdit = [];

        var service = {
            getSeats	: getSeats			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getSeats(seats_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( seatsEdit.length > 0 )
            {				
                deferred.resolve(seatsEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.seatsEdit@save', {param:{seats_id:seats_id},aToken:aToken,page:'seats'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							seatsEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(seatsEdit);
																								
							// Resolve the promise
							deferred.resolve(seatsEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.seats')
        .controller('AddSeatsController', AddSeatsController);

    /** @ngInject */
    function AddSeatsController($scope, $mdSidenav, Seats, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Seats";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables/Seats" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.seatsDB = Seats.data;        		     				
		if(__env.isDebug) console.log(vm.seatsDB);	
		vm.branchID = vm.seatsDB.branchID;
		
		//vm.seats = {seats_code:vm.seatsDB.seatsCode};
		vm.seats = {table_name:'', table_branch_id:vm.branchID, table_scategory_id:'', table_order:'', table_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.seats = {seats_status : "Active"};
				

		// Methods
        vm.saveSeats = saveSeats;
		vm.gotoSeats = gotoSeats;
						
		/**
         * Go to Staff page
         */
        function gotoSeats()
        {
			//alert("1");
            $state.go('app.seats-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveSeats()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.seats);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.seatsSave@save', {param:{seats:vm.seats,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'seats'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Seats Added Successfully').position('top right')
						);
						gotoSeats();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.seats')
        .controller('EditSeatsController', EditSeatsController);

    /** @ngInject */
    function EditSeatsController($scope, $mdSidenav, Seats, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Seats";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables/Seats" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.seatsDB = Seats;
		vm.seats = vm.seatsDB.seatsDets;
		if(__env.isDebug) console.log("Seats Det");
		if(__env.isDebug) console.log(vm.seatsDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.seatsDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveSeats = saveSeats;
		vm.gotoSeats = gotoSeats;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoSeats()
        {
			//alert("1");
            $state.go('app.seats-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveSeats()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.seats);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.seatsUpdate@save', {param:{seats:vm.seats,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'seats'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Seats Updated Successfully').position('top right')
						);
						gotoSeats();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.scategory',
            [
                // 3rd Party Dependencies
                
                'datatables',
                
            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.scategory', {
				url    : '/scategory',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/scategory/scategory.html',
						controller : 'ScategoryListController as vm'
					}
				},
				resolve: {					
					ScategoryList: function (msApi)
					{					
						return msApi.resolve('app.scategoryList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.scategory-list', {
				url    : '/scategory',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/scategory/scategory.html',
						controller : 'ScategoryListController as vm'
					}
				},
				resolve: {					
					ScategoryList: function (msApi)
					{					
						return msApi.resolve('app.scategoryList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.scategory.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/scategory/new_scategory/new_scategory.html',
						controller : 'AddScategoryController as vm'
					}
				},
				resolve: {
					Scategory: function (msApi)
					{
						return msApi.resolve('app.scategoryAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'scategory'
			})
			.state('app.scategory.edit', {
				url      : '/edit/:scategory_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/scategory/new_scategory/new_scategory.html',
						controller : 'EditScategoryController as vm'
					}
				},
				resolve: {
					Scategory: function ($stateParams, scategoryService)
					{
						return scategoryService.getScategory($stateParams.scategory_id,'Edit');
					}
				},
				bodyClass: 'scategory'
			})
			.state('app.scategory.edit-list', {
				url      : '/edit/:scategory_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/scategory/new_scategory/new_scategory.html',
						controller : 'EditScategoryController as vm'
					}
				},
				resolve: {
					Scategory: function ($stateParams, scategoryService)
					{
						return clientService.getScategory($stateParams.scategory_id,'Edit');
					}
				},
				bodyClass: 'scategory'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/scategory');
			
			// Api						
			msApiProvider.register('app.scategoryList', ['scategoryList']);
			msApiProvider.register('app.scategorySave', ['scategorySave']);
			msApiProvider.register('app.scategoryUpdate', ['scategoryUpdate']);
			msApiProvider.register('app.scategoryAdd', ['scategoryAdd']);
			msApiProvider.register('app.scategoryEdit', ['scategoryEdit']);
			msApiProvider.register('app.scategoryDel', ['scategoryDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('scategory', {
				title : 'Scategory',
				//icon  : 'icon-account-multiple',
				state : 'app.scategory',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scategory')
        .factory('scategoryService', scategoryService);

    /** @ngInject */
    function scategoryService($q, $mdToast, msApi)
    {
        var scategoryEdit = [];

        var service = {
            getScategory	: getScategory			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getScategory(scategory_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( scategoryEdit.length > 0 )
            {				
                deferred.resolve(scategoryEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.scategoryEdit@save', {param:{scategory_id:scategory_id},aToken:aToken,page:'scategory'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							scategoryEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(scategoryEdit);
																								
							// Resolve the promise
							deferred.resolve(scategoryEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scategory')
        .controller('AddScategoryController', AddScategoryController);

    /** @ngInject */
    function AddScategoryController($scope, $mdSidenav, Scategory, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Table Category";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables Categories" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.scategoryDB = Scategory.data;        		     				
		if(__env.isDebug) console.log(vm.scategoryDB);	
		vm.branchID = vm.scategoryDB.branchID;
		
		//vm.scategory = {scategory_code:vm.scategoryDB.scategoryCode};
		vm.scategory = {scategory_name:'', scategory_branch_id:vm.branchID, scategory_order:'', scategory_status:'Active', scategory_dept_id:''};
		vm.deptList = vm.scategoryDB.department;

		vm.statuslist = ['Active','Inactive'];
		//vm.scategory = {scategory_status : "Active"};
				

		// Methods
        vm.saveScategory = saveScategory;
		vm.gotoScategory = gotoScategory;
						
		/**
         * Go to Staff page
         */
        function gotoScategory()
        {
			//alert("1");
            $state.go('app.scategory-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveScategory()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.scategory);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.scategorySave@save', {param:{scategory:vm.scategory,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'scategory'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Scategory Added Successfully').position('top right')
						);
						gotoScategory();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scategory')
        .controller('EditScategoryController', EditScategoryController);

    /** @ngInject */
    function EditScategoryController($scope, $mdSidenav, Scategory, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Table Category";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables Categories" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.scategoryDB = Scategory;
		vm.scategory = vm.scategoryDB.scategoryDets;
		if(__env.isDebug) console.log("Scategory Det");
		if(__env.isDebug) console.log(vm.scategoryDB);

		vm.deptList = vm.scategoryDB.department;
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.scategoryDB.error == "1"){
			gotoLogin();
		} 

		
								
              
		// Methods
        vm.saveScategory = saveScategory;
		vm.gotoScategory = gotoScategory;	
		vm.gotoLogin = gotoLogin;	

		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoScategory()
        {
			//alert("1");
            $state.go('app.scategory-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveScategory()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.scategory);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.scategoryUpdate@save', {param:{scategory:vm.scategory,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'scategory'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Scategory Updated Successfully').position('top right')
						);
						gotoScategory();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																


        
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-tax-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.sales-tax-report', {
				url    : '/sales-tax-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales-tax-report/sales-tax-report.html',
						controller : 'SalesTaxReportController as vm'
					}
				},
				resolve: {					
					SalesTaxReportList: function (msApi)
					{					
						return msApi.resolve('app.salesTaxReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.sales-tax-report-list', {
				url    : '/sales-tax-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales-tax-report/sales-tax-report.html',
						controller : 'SalesTaxReportController as vm'
					}
				},
				resolve: {					
					SalesTaxReportList: function ($stateParams, salestaxreportService)
					{
						
						return salestaxreportService.getSalesTaxList($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/sales-tax-report');
			
			// Api						
			msApiProvider.register('app.salesTaxReportList', ['salesTaxReportList']);
			msApiProvider.register('app.salesTaxReportList2', ['salesTaxReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.opening-stock-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-tax-report')
        .factory('salestaxreportService', salestaxreportService);

    /** @ngInject */
    function salestaxreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getSalesTaxList : getSalesTaxList
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getSalesTaxList(waiterSalesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.salesTaxReportList2@save', {param:{waiterSalesDets:waiterSalesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.sales-report', {
				url    : '/sales-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales-report/sales-report.html',
						controller : 'SalesReportController as vm'
					}
				},
				resolve: {					
					SalesReportList: function (msApi)
					{					
						return msApi.resolve('app.salesReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.sales-report-list', {
				url    : '/sales-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales-report/sales-report.html',
						controller : 'SalesReportController as vm'
					}
				},
				resolve: {					
					SalesReportList: function ($stateParams, salesreportService)
					{
						
						return salesreportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/sales-report');
			
			// Api						
			msApiProvider.register('app.salesReportList', ['salesReportList']);
			msApiProvider.register('app.salesReportList2', ['salesReportList2']);
			msApiProvider.register('app.sales-reportSave', ['sales-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('sales-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.sales-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-report')
        .factory('salesreportService', salesreportService);

    /** @ngInject */
    function salesreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(salesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.salesReportList2@save', {param:{salesDets:salesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'sales-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-intax-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.sales-intax-report', {
				url    : '/sales-intax-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales-intax-report/sales-intax-report.html',
						controller : 'SalesInTaxReportController as vm'
					}
				},
				resolve: {					
					SalesTaxReportList: function (msApi)
					{					
						return msApi.resolve('app.salesInTaxReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.sales-intax-report-list', {
				url    : '/sales-intax-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales-intax-report/sales-intax-report.html',
						controller : 'SalesInTaxReportController as vm'
					}
				},
				resolve: {					
					SalesTaxReportList: function ($stateParams, salesintaxreportService)
					{
						
						return salesintaxreportService.getSalesTaxList($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/sales-intax-report');
			
			// Api						
			msApiProvider.register('app.salesInTaxReportList', ['salesInTaxReportList']);
			msApiProvider.register('app.salesInTaxReportList2', ['salesInTaxReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.opening-stock-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-intax-report')
        .factory('salesintaxreportService', salesintaxreportService);

    /** @ngInject */
    function salesintaxreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getSalesTaxList : getSalesTaxList
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getSalesTaxList(waiterSalesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.salesInTaxReportList2@save', {param:{waiterSalesDets:waiterSalesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.sales', {
				url    : '/sales',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales/sales.html',
						controller : 'SalesController as vm'
					}
				},
				resolve: {					
					SalesList: function (msApi)
					{					
						return msApi.resolve('app.salesReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.sales-list', {
				url    : '/sales',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/sales/sales.html',
						controller : 'SalesController as vm'
					}
				},
				resolve: {					
					SalesList: function ($stateParams, salesService)
					{
						
						return salesService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/sales');
			
			// Api						
			msApiProvider.register('app.salesReportList', ['salesReportList']);
			msApiProvider.register('app.salesReportList3', ['salesReportList3']);
			msApiProvider.register('app.salesSave', ['salesSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('sales', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.sales',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .factory('salesService', salesService);

    /** @ngInject */
    function salesService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(salesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.salesReportList2@save', {param:{salesDets:salesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'sales'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.roles',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.roles', {
				url    : '/roles',
				views  : {
					'main@app': {
                        templateUrl: 'app/core/layouts/vertical-navigation2.html',
                        controller : 'MainController as vm'
                    },
					'content@app': {
						templateUrl: 'app/main/apps/roles/roles.html',
						controller : 'RolesListController as vm'
					}
				},
				resolve: {					
					RolesList: function (msApi)
					{					
						return msApi.resolve('app.rolesList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.roles-list', {
				url    : '/roles',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/roles/roles.html',
						controller : 'RolesListController as vm'
					}
				},
				resolve: {					
					RolesList: function (msApi)
					{					
						return msApi.resolve('app.rolesList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.roles.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/roles/new_roles/new_roles.html',
						controller : 'AddRolesController as vm'
					}
				},
				resolve: {
					Roles: function (msApi)
					{
						//return msApi.resolve('app.rolesAdd@get');
						return msApi.resolve('app.rolesAdd@get',{branchID:localStorage.getItem('BranchID')});;
					}
				},
				bodyClass: 'roles'
			})
			.state('app.roles.edit', {
				url      : '/edit/:roles_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/roles/new_roles/new_roles.html',
						controller : 'EditRolesController as vm'
					}
				},
				resolve: {
					Roles: function ($stateParams, rolesService)
					{
						return rolesService.getRoles($stateParams.roles_id,'Edit');
					}
				},
				bodyClass: 'roles'
			})
			.state('app.roles.edit-list', {
				url      : '/edit/:roles_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/roles/new_roles/new_roles.html',
						controller : 'EditRolesController as vm'
					}
				},
				resolve: {
					Roles: function ($stateParams, rolesService)
					{
						return clientService.getRoles($stateParams.roles_id,'Edit');
					}
				},
				bodyClass: 'roles'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/roles');
			
			// Api						
			msApiProvider.register('app.rolesList', ['rolesList']);
			msApiProvider.register('app.rolesSave', ['rolesSave']);
			msApiProvider.register('app.rolesUpdate', ['rolesUpdate']);
			msApiProvider.register('app.rolesAdd', ['rolesAdd']);
			msApiProvider.register('app.rolesEdit', ['rolesEdit']);
			msApiProvider.register('app.rolesDel', ['rolesDel']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('roles', {
				title : 'Roles',
				//icon  : 'icon-account-multiple',
				state : 'app.roles',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .factory('rolesService', rolesService);

    /** @ngInject */
    function rolesService($q, $mdToast, msApi)
    {
        var rolesEdit = [];

        var service = {
            getRoles	: getRoles			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getRoles(roles_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( rolesEdit.length > 0 )
            {				
                deferred.resolve(rolesEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.rolesEdit@save', {param:{roles_id:roles_id},aToken:aToken,page:'roles'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							rolesEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(rolesEdit);
																								
							// Resolve the promise
							deferred.resolve(rolesEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .controller('AddRolesController', AddRolesController);

    /** @ngInject */
    function AddRolesController($scope, $mdSidenav, Roles, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $window, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Roles";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Users Roles" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.rolesDB = Roles.data;        		     				
		if(__env.isDebug) console.log(vm.rolesDB);	
		vm.branchID = localStorage.getItem('BranchID');
		
		//vm.roles = {roles_code:vm.rolesDB.rolesCode};
		vm.roles = {roles_name:'', roles_branch_id:vm.branchID, roles_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		vm.modulesList = vm.rolesDB.modulesList;
		vm.departments = vm.rolesDB.departments;

		for(var i=0;i<vm.modulesList.length;i++){
			vm.modulesList[i].chk = 0;
		}

		for(var i=0;i<vm.departments.length;i++){
			vm.departments[i].chk = 0;
		}

		vm.mainchk = 0;
		vm.mainchk2 = 0;

		// Methods
        vm.saveRoles = saveRoles;
		vm.gotoRoles = gotoRoles;
		vm.selectAll = selectAll;
		vm.selectModules = selectModules;

		vm.selectAll2 = selectAll2;		
						
		/**
         * Go to Staff page
         */
        function gotoRoles()
        {
			//alert(vm.type);
			$state.go('app.roles-list');			
        }

        function selectAll()
        {
        	if(vm.mainchk==0){
        		vm.mainchk = 1;
        		for(var i=0;i<vm.modulesList.length;i++){
					vm.modulesList[i].chk = 1;
				}
        	} else if(vm.mainchk==1){
        		vm.mainchk = 0;
        		for(var i=0;i<vm.modulesList.length;i++){
					vm.modulesList[i].chk = 0;
				}
        	}					
        }

        function selectModules(module){
        	if(__env.isDebug) console.log(module);
        	//alert(module.chk+" "+module.module_name);
        	if(module.chk == 0){
			    module.chk = 1;
			} else if(module.chk == 1){
			  	module.chk = 0;			    	
			}
			
        	if(vm.mainchk==0){        		
        		for(var i=0;i<vm.modulesList.length;i++){
		        	if(module.module_name==vm.modulesList[i].module_type){
		        		//alert(module.module_name+"=="+vm.modulesList[i].module_type);
			        	if(vm.modulesList[i].chk == 0){
			        		//module.chk = 1;
			        		vm.modulesList[i].chk = 1;
			        	} else if(vm.modulesList[i].chk == 1){
			        		//module.chk = 0;
			        		vm.modulesList[i].chk = 0;
			        	}
			        }
		        }
	        }
        }
		

		function selectAll2()
        {
        	if(vm.mainchk2==0){
        		vm.mainchk2 = 1;
        		for(var i=0;i<vm.departments.length;i++){
					vm.departments[i].chk = 1;
				}
        	} else if(vm.mainchk2==1){
        		vm.mainchk2 = 0;
        		for(var i=0;i<vm.departments.length;i++){
					vm.departments[i].chk = 0;
				}
        	}					
        }

        			
		/**
         * Add New Staff
        **/
        function saveRoles()
        {
			//alert("In");
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.roles);
			if(__env.isDebug) console.log(vm.modulesList);
			if(__env.isDebug) console.log(vm.departments);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.rolesSave@save', {param:{roles:vm.roles,modulesList:vm.modulesList,departments:vm.departments,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'roles'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Roles Added Successfully').position('top right')
						);
						gotoRoles();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .controller('EditRolesController', EditRolesController);

    /** @ngInject */
    function EditRolesController($scope, $mdSidenav, Roles, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $window, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Roles";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Users Roles" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.rolesDB = Roles;
		vm.roles = vm.rolesDB.rolesDets;
		if(__env.isDebug) console.log("Roles Det");
		if(__env.isDebug) console.log(vm.rolesDB);
				
		vm.statuslist = ['Active','Inactive'];
		vm.modulesList = vm.rolesDB.modulesList;
		vm.departments = vm.rolesDB.departments;

		for(var i=0;i<vm.modulesList.length;i++){
			vm.modulesList[i].chk = 0;
		}

		for(var i=0;i<vm.departments.length;i++){
			vm.departments[i].chk = 0;
		}

		vm.modulesStatus = vm.rolesDB.modulesStatus;
		for(var i=0;i<vm.modulesList.length;i++){
			for(var j=0;j<vm.modulesStatus.length;j++){
				if(vm.modulesList[i].module_id==vm.modulesStatus[j].rolemod_module_id){
					vm.modulesList[i].chk = vm.modulesStatus[j].rolemod_status;
				}				
			}
		}

		vm.deptStatus = vm.rolesDB.deptStatus;
		for(var i=0;i<vm.departments.length;i++){
			vm.departments[i].chk = 0;
			for(var j=0;j<vm.deptStatus.length;j++){
				if(vm.departments[i].department_id==vm.deptStatus[j].roledept_module_id){
					vm.departments[i].chk = vm.deptStatus[j].roledept_status;
				}				
			}
		}
		
		
		if(vm.rolesDB.error == "1"){
			gotoLogin();
		} 
		
		vm.mainchk = 0;						
              
		// Methods
        vm.saveRoles = saveRoles;
		vm.gotoRoles = gotoRoles;	
		vm.gotoLogin = gotoLogin;
		vm.selectAll = selectAll;
		vm.selectModules = selectModules;	

		vm.selectAll2 = selectAll2;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        function selectAll()
        {
        	//alert(vm.mainchk);
        	if(vm.mainchk==0){
        		vm.mainchk = 1;
        		for(var i=0;i<vm.modulesList.length;i++){
        			if(vm.modulesList[i].chk==0){
						vm.modulesList[i].chk = 1;
					}
				}
        	} else if(vm.mainchk==1){
        		vm.mainchk = 0;
        		for(var i=0;i<vm.modulesList.length;i++){
        			if(vm.modulesList[i].chk==1){
						vm.modulesList[i].chk = 0;
					}
				}
        	}					
        }

        function selectModules(module){
        	if(__env.isDebug) console.log(module);
        	//alert(module.chk+" "+module.module_name);
        	if(module.chk == 0){
			    module.chk = 1;
			} else if(module.chk == 1){
			  	module.chk = 0;			    	
			}

        	if(vm.mainchk==0){        		
        		for(var i=0;i<vm.modulesList.length;i++){
		        	if(module.module_name==vm.modulesList[i].module_type){
		        		//alert(module.module_name+"=="+vm.modulesList[i].module_type);
			        	if(vm.modulesList[i].chk == 0){
			        		//module.chk = 1;
			        		vm.modulesList[i].chk = 1;
			        	} else if(vm.modulesList[i].chk == 1){
			        		//module.chk = 0;
			        		vm.modulesList[i].chk = 0;
			        	}
			        }
		        }
	        }
        }

        function selectAll2()
        {
        	if(vm.mainchk2==0){
        		vm.mainchk2 = 1;
        		for(var i=0;i<vm.departments.length;i++){
					vm.departments[i].chk = 1;
				}
        	} else if(vm.mainchk2==1){
        		vm.mainchk2 = 0;
        		for(var i=0;i<vm.departments.length;i++){
					vm.departments[i].chk = 0;
				}
        	}					
        }

        
		/**
         * Go to Admission page
         */
        function gotoRoles()
        {
			//alert("1");
            $state.go('app.roles-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveRoles()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.roles);
			if(__env.isDebug) console.log(vm.modulesList);
			if(__env.isDebug) console.log(vm.departments);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.rolesUpdate@save', {param:{roles:vm.roles,modulesList:vm.modulesList,departments:vm.departments,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'roles'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Roles Updated Successfully').position('top right')
						);
						gotoRoles();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.recipes',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.recipes', {
				url    : '/recipes',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/recipes/recipes.html',
						controller : 'RecipesListController as vm'
					}
				},
				resolve: {					
					RecipesList: function (msApi)
					{					
						return msApi.resolve('app.recipesList@get',{branchID:localStorage.getItem('BranchID')});						
					}, 
				}
			})
			.state('app.recipes-list', {
				url    : '/recipes',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/recipes/recipes.html',
						controller : 'RecipesListController as vm'
					}
				},
				resolve: {					
					RecipesList: function (msApi)
					{					
						return msApi.resolve('app.recipesList@get',{branchID:localStorage.getItem('BranchID')});						
					}, 
				}
			})			
			.state('app.recipes.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/recipes/new_recipes/new_recipes.html',
						controller : 'AddRecipesController as vm'
					}
				},
				resolve: {
					Recipes: function (msApi)
					{
						return msApi.resolve('app.recipesAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'recipes'
			})
			.state('app.recipes.edit', {
				url      : '/edit/:recipes_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/recipes/new_recipes/new_recipes.html',
						controller : 'EditRecipesController as vm'
					}
				},
				resolve: {
					Recipes: function ($stateParams, recipesService)
					{
						return recipesService.getRecipes($stateParams.recipes_id,'Edit');
					}
				},
				bodyClass: 'recipes'
			})
			.state('app.recipes.edit-list', {
				url      : '/edit/:recipes_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/recipes/new_recipes/new_recipes.html',
						controller : 'EditRecipesController as vm'
					}
				},
				resolve: {
					Recipes: function ($stateParams, recipesService)
					{
						return recipesService.getRecipes($stateParams.recipes_id,'Edit');
					}
				},
				bodyClass: 'recipes'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/recipes');
			
			// Api						
			msApiProvider.register('app.recipesList', ['recipesList']);
			msApiProvider.register('app.recipessave', ['recipessave']);
			msApiProvider.register('app.recipesAdd', ['recipesAdd']);
			msApiProvider.register('app.recipesEdit', ['recipesEdit']);
			msApiProvider.register('app.recipesDel', ['recipesDel']);
			msApiProvider.register('app.recipesUpdate', ['recipesUpdate']);
			/*msApiProvider.register('app.updateAdmission', ['updateAdmission']);
			*/
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('recipes', {
				title : 'Recipes',
				//icon  : 'icon-account-multiple',
				state : 'app.recipes',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.recipes')
        .factory('recipesService', recipesService);

    /** @ngInject */
    function recipesService($q, $mdToast, msApi)
    {
        var recipesEdit = [];

        var service = {
            getRecipes	: getRecipes,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getRecipes(recipes_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( recipesEdit.length > 0 )
            {				
                deferred.resolve(recipesEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.recipesEdit@save', {param:{recipes_id:recipes_id},aToken:aToken,page:'recipes'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							recipesEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(recipesEdit);
																								
							// Resolve the promise
							deferred.resolve(recipesEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.recipes')
        .controller('AddRecipesController', AddRecipesController);

    /** @ngInject */
    function AddRecipesController($scope, $mdSidenav, Recipes, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window, $log, $timeout)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Recipe";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Recipes" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.recipesDB = Recipes.data;        		     				
		if(__env.isDebug) console.log(vm.recipesDB);	
		
		vm.item = {item_name:"", item_id:"", option_name:"", option_id:""};
		vm.item_list = false;
		vm.opt_list = false;			
		
		vm.recipesItems = [];	
		vm.recipesOpts = [];
		vm.newItems = {sno:1,prod_name:'',prod_id:'',prod_unit_name:'',prod_unit_id:'',prod_qty:'0',prod_list:false,unit_list:false,prod_remove:false};
		vm.recipesItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.recipesItems);
		
				
		// Methods
        vm.setItemID = setItemID;
		vm.setOptID = setOptID;
		vm.showitemlist = showitemlist;
		vm.showoptlist = showoptlist;
		vm.showitmlist = showitmlist;
		vm.setUnitID = setUnitID;
		vm.showunitlist = showunitlist;
		
		vm.addNewRecipes = addNewRecipes;
		vm.gotoRecipes = gotoRecipes;
		vm.setProdID = setProdID;
		vm.removeProduct = removeProduct;
		

		/*** Item autocomplete start ***/		
						
		vm.simulateQuery2 = false;
	    vm.isDisabled2    = false;
	    vm.repos2         = loadAll2();
	    vm.querySearch2   = querySearch2;
	    vm.selectedItemChange2 = selectedItemChange2;
	    vm.searchTextChange2   = searchTextChange2;

        function querySearch2 (query) {
        	//alert("Query");
	      	var results = query ? vm.repos2.filter( createFilterFor2(query) ) : vm.repos2,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange2(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange2(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	showitemlist(item.itemlist_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll2() {
	    	//alert("Loading");
	      	var repos = vm.recipesDB.itemsList
	      	return repos.map( function (repo) {
	        	repo.itemlist_name_low = repo.itemlist_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor2(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.itemlist_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Item autocomplete end ***/		

		/*** Ingredients autocomplete start ***/		
						
		vm.simulateQuery = false;
	    vm.isDisabled    = false;
	    vm.repos         = loadAll();
	    vm.querySearch   = querySearch;
	    vm.selectedItemChange = selectedItemChange;
	    vm.searchTextChange   = searchTextChange;

        function querySearch (query) {
        	//alert("Query");
	      	var results = query ? vm.repos.filter( createFilterFor(query) ) : vm.repos,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange(text) {
	    	//alert("Text Change");
	      	$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setProdID(item.ingredients_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll() {
	    	//alert("Loading");
	      	var repos = vm.recipesDB.ingredientsList
	      	return repos.map( function (repo) {
	        	repo.ingredients_name_low = repo.ingredients_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.ingredients_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Ingredients autocomplete end ***/
	    

	    /*** Unit autocomplete start ***/		
						
		vm.simulateQuery4 = false;
	    vm.isDisabled4    = false;
	    vm.repos4         = loadAll4();
	    vm.querySearch4   = querySearch4;
	    vm.selectedItemChange4 = selectedItemChange4;
	    vm.searchTextChange4   = searchTextChange4;

        function querySearch4 (query) {
        	//alert("Query");
	      	var results = query ? vm.repos4.filter( createFilterFor4(query) ) : vm.repos4,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange4(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange4(itmID,item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setUnitID(itmID,item)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll4() {
	    	//alert("Loading");
	      	var repos = vm.recipesDB.unitsList
	      	return repos.map( function (repo) {
	        	repo.unit_name_low = repo.unit_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor4(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.unit_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Unit autocomplete end ***/


		/**
         * Go to Staff page
         */
		
		function setItemID(){	
			vm.item_list = true;
		}
		
		function showitemlist(param){			
			vm.item_list = false;
			for(var i=0;i<vm.recipesDB.itemsList.length;i++){
				//alert(vm.recipesItems[i].prod_qty);
				if(vm.recipesDB.itemsList[i].itemlist_id == param){
					//alert(vm.recipesDB.itemsList[i].itemlist_id);
					vm.item.item_name = vm.recipesDB.itemsList[i].itemlist_name;
					vm.item.item_id = vm.recipesDB.itemsList[i].itemlist_id;
				}
			}	
			
			for(var i=0;i<vm.recipesDB.itemOptsList.length;i++){				
				if(vm.recipesDB.itemOptsList[i].itmlist_option_itemlist_id == vm.item.item_id){					
					vm.recipesOpts.push(vm.recipesDB.itemOptsList[i]);
				}
			}	
			
			if(__env.isDebug) console.log(vm.recipesOpts);
		}
		
		function setOptID(){	
			vm.opt_list = true;
		}
		
		function showoptlist(param){
			vm.opt_list = false;	
			for(var i=0;i<vm.recipesDB.itemOptsList.length;i++){				
				if(vm.recipesDB.itemOptsList[i].itmlist_option_id == param){
					//alert(vm.recipesDB.itemOptsList[i].itmlist_option_id+" == "+param);
					vm.item.option_name = vm.recipesDB.itemOptsList[i].itmlist_option_name;
					vm.item.option_id = vm.recipesDB.itemOptsList[i].itmlist_option_id;
				}
			}	
		}	
		
		function setUnitID(prod_id,units){	
			for(var i=0;i<vm.recipesItems.length;i++){
				if(vm.recipesItems[i].sno == prod_id){
					vm.recipesItems[i].unit_list = false;
					vm.recipesItems[i].prod_unit_name = units.unit_name;
					vm.recipesItems[i].prod_unit_id = units.unit_id;
				}
			}
		}
		
		function showunitlist(param){
			for(var i=0;i<vm.recipesItems.length;i++){				
				if(vm.recipesItems[i].sno == param){
					//alert(vm.recipesItems[i].sno+" == "+param);
					vm.recipesItems[i].unit_list = true;
				}
			}	
		}	
		
        function gotoRecipes()
        {
			//alert("1");
            $state.go('app.recipes-list');
        }
		//setProdID();
		
		
		function showitmlist(param){			
			for(var i=0;i<vm.recipesItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.recipesItems[i].sno == param){
					vm.recipesItems[i].prod_list = true;
				}
			}	
		}
		
		function setProdID(param){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.recipesDB.ingredientsList;
			//alert(param);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.recipesItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_unit_name = '';
			vm.prod_unit_id = '';
			vm.prod_qty = '';
			vm.prod_list = '';
			vm.unit_list = '';			
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].ingredients_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.prod_name = arrInp[i].ingredients_name;
					vm.prod_id = arrInp[i].ingredients_id;
					vm.prod_unit_name = '';
					vm.prod_unit_id = '';
					vm.prod_qty = 0;
					vm.prod_list = false;
					vm.unit_list = false;
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.recipesItems.length-1;
			var ind = vm.recipesItems.length;
			for(var i=len;i<vm.recipesItems.length;i++){
				vm.recipesItems[i].sno 		= ind;
				vm.recipesItems[i].prod_name 	= vm.prod_name;
				vm.recipesItems[i].prod_id 	= vm.prod_id;
				vm.recipesItems[i].prod_unit_name 	= vm.prod_unit_name;
				vm.recipesItems[i].prod_unit_id 	= vm.prod_unit_id;
				vm.recipesItems[i].prod_qty 	= vm.prod_qty;
				vm.recipesItems[i].prod_list	= vm.prod_list;
				vm.recipesItems[i].unit_list	= vm.unit_list;
				vm.recipesItems[i].prod_remove = vm.prod_remove;
			}
			
			if(vm.recipesItems[0].prod_id!=""){ 
				vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_name:'',prod_unit_id:'',prod_qty:'0',prod_list:false,unit_list:false,prod_remove:false};
				vm.recipesItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.recipesItems);							
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.recipesItems.length;i++){				
				if(vm.recipesItems[i].prod_id == param){
					//alert(vm.recipesItems[i].prod_id+" == "+param);
					vm.recipesItems.splice(i, 1);	
				}
			}			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.recipesItems);
		}
		
						
		function addNewRecipes()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.item);	
			if(__env.isDebug) console.log(vm.recipesItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.recipessave@save', {param:{recipes:vm.item,recipesitm:vm.recipesItems,UserID:UserID},aToken:aToken,page:'recipes'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Recipe Added Successfully').position('top right')
							);
							gotoRecipes();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.recipes')
        .controller('EditRecipesController', EditRecipesController);

    /** @ngInject */
    function EditRecipesController($scope, $mdSidenav, Recipes, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window, $log, $timeout)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Recipe";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Recipes" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.recipesDB = Recipes;        		     				
		if(__env.isDebug) console.log(vm.recipesDB);	
		//if(__env.isDebug) console.log(vm.recipesDB.custDets);
		
		vm.recipesItems = [];
		vm.recipesOpts = [];
		vm.recipes = vm.recipesDB.recipesDets;
		vm.recipesTempItems = vm.recipesDB.recipesItmDetails;
		vm.item = {recipes_id:vm.recipes.recipes_id, item_name:vm.recipes.itemlist_name, item_id:vm.recipes.recipes_itemlist_id, option_name:vm.recipes.itmlist_option_name, option_id:vm.recipes.recipes_optionlist_id};
		vm.item_list = false;
		vm.opt_list = false;
		
		for(var i=0;i<vm.recipesDB.itemOptsList.length;i++){				
			if(vm.recipesDB.itemOptsList[i].itmlist_option_itemlist_id == vm.item.item_id){					
				vm.recipesOpts.push(vm.recipesDB.itemOptsList[i]);
			}
		}
		
		var ind = 0;
		for(var i=0;i<vm.recipesTempItems.length;i++){
			ind++;		
			
			vm.obj = {sno:ind,prod_name:vm.recipesTempItems[i].ingredients_name, prod_id:vm.recipesTempItems[i].recipes_itm_ingredients_id, prod_unit_name:vm.recipesTempItems[i].unit_name, prod_unit_id:vm.recipesTempItems[i].recipes_itm_unit_id, prod_qty:vm.recipesTempItems[i].recipes_itm_qty, prod_list:false,unit_list:false,prod_remove:true, selectedItem:vm.recipesTempItems[i].ingredients_name,searchText:vm.recipesTempItems[i].ingredients_name, selectedItem4:vm.recipesTempItems[i].unit_name,searchText4:vm.recipesTempItems[i].unit_name};
			vm.recipesItems.push(vm.obj);
		}
		
		vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_name:'',prod_unit_id:'',prod_qty:'0',prod_list:false,unit_list:false,prod_remove:false};
		vm.recipesItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.recipesItems);
		
		vm.selectedItem2 = 	vm.item.item_name;
		vm.searchText2 = 	vm.item.item_name;
				

		// Methods
        vm.setItemID = setItemID;
		vm.setOptID = setOptID;
		vm.showitemlist = showitemlist;
		vm.showoptlist = showoptlist;
		vm.showitmlist = showitmlist;
		vm.setUnitID = setUnitID;
		vm.showunitlist = showunitlist;
		
		vm.addNewRecipes = addNewRecipes;
		vm.gotoRecipes = gotoRecipes;
		vm.setProdID = setProdID;
		vm.removeProduct = removeProduct;
		

		/*** Item autocomplete start ***/		
						
		vm.simulateQuery2 = false;
	    vm.isDisabled2    = false;
	    vm.repos2         = loadAll2();
	    vm.querySearch2   = querySearch2;
	    vm.selectedItemChange2 = selectedItemChange2;
	    vm.searchTextChange2   = searchTextChange2;

        function querySearch2 (query) {
        	//alert("Query");
	      	var results = query ? vm.repos2.filter( createFilterFor2(query) ) : vm.repos2,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange2(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange2(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	showitemlist(item.itemlist_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll2() {
	    	//alert("Loading");
	      	var repos = vm.recipesDB.itemsList
	      	return repos.map( function (repo) {
	        	repo.itemlist_name_low = repo.itemlist_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor2(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.itemlist_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Item autocomplete end ***/		

		/*** Ingredients autocomplete start ***/		
						
		vm.simulateQuery = false;
	    vm.isDisabled    = false;
	    vm.repos         = loadAll();
	    vm.querySearch   = querySearch;
	    vm.selectedItemChange = selectedItemChange;
	    vm.searchTextChange   = searchTextChange;

        function querySearch (query) {
        	//alert("Query");
	      	var results = query ? vm.repos.filter( createFilterFor(query) ) : vm.repos,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange(text) {
	    	//alert("Text Change");
	      	$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange(item,ind) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setProdID(item.ingredients_id,ind)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll() {
	    	//alert("Loading");
	      	var repos = vm.recipesDB.ingredientsList
	      	return repos.map( function (repo) {
	        	repo.ingredients_name_low = repo.ingredients_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.ingredients_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Ingredients autocomplete end ***/
	    

	    /*** Unit autocomplete start ***/		
						
		vm.simulateQuery4 = false;
	    vm.isDisabled4    = false;
	    vm.repos4         = loadAll4();
	    vm.querySearch4   = querySearch4;
	    vm.selectedItemChange4 = selectedItemChange4;
	    vm.searchTextChange4   = searchTextChange4;

        function querySearch4 (query) {
        	//alert("Query");
	      	var results = query ? vm.repos4.filter( createFilterFor4(query) ) : vm.repos4,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange4(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange4(itmID,item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setUnitID(itmID,item)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll4() {
	    	//alert("Loading");
	      	var repos = vm.recipesDB.unitsList
	      	return repos.map( function (repo) {
	        	repo.unit_name_low = repo.unit_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor4(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.unit_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Unit autocomplete end ***/

						
			
		function setItemID(){	
			vm.item_list = true;
		}
		
		function showitemlist(param){			
			vm.item_list = false;
			for(var i=0;i<vm.recipesDB.itemsList.length;i++){
				//alert(vm.recipesItems[i].prod_qty);
				if(vm.recipesDB.itemsList[i].itemlist_id == param){
					vm.item.item_name = vm.recipesDB.itemsList[i].itemlist_name;
					vm.item.item_id = vm.recipesDB.itemsList[i].itemlist_id;
				}
			}	
			
			//alert(vm.item.item_id);
			for(var i=0;i<vm.recipesDB.itemOptsList.length;i++){				
				if(vm.recipesDB.itemOptsList[i].itmlist_option_itemlist_id == vm.item.item_id){					
					vm.recipesOpts.push(vm.recipesDB.itemOptsList[i]);
				}
			}	

			if(__env.isDebug) console.log("Opt list");
			if(__env.isDebug) console.log(vm.recipesOpts);
		}
		
		function setOptID(){	
			vm.opt_list = true;
		}
		
		function showoptlist(param){
			vm.opt_list = false;	
			for(var i=0;i<vm.recipesDB.itemOptsList.length;i++){				
				if(vm.recipesDB.itemOptsList[i].itmlist_option_id == param){
					//alert(vm.recipesDB.itemOptsList[i].itmlist_option_id+" == "+param);
					vm.item.option_name = vm.recipesDB.itemOptsList[i].itmlist_option_name;
					vm.item.option_id = vm.recipesDB.itemOptsList[i].itmlist_option_id;
				}
			}	
		}	
		
		function setUnitID(prod_id,units){	
			for(var i=0;i<vm.recipesItems.length;i++){
				if(vm.recipesItems[i].sno == prod_id){
					vm.recipesItems[i].unit_list = false;
					vm.recipesItems[i].prod_unit_name = units.unit_name;
					vm.recipesItems[i].prod_unit_id = units.unit_id;
				}
			}
		}
		
		function showunitlist(param){
			for(var i=0;i<vm.recipesItems.length;i++){				
				if(vm.recipesItems[i].sno == param){
					//alert(vm.recipesItems[i].sno+" == "+param);
					vm.recipesItems[i].unit_list = true;
				}
			}	
		}	
		
        function gotoRecipes()
        {
			//alert("1");
            $state.go('app.recipes-list');
        }
		//setProdID();
		
		
		function showitmlist(param){			
			for(var i=0;i<vm.recipesItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.recipesItems[i].sno == param){
					vm.recipesItems[i].prod_list = true;
				}
			}	
		}
		
		function setProdID(param,index){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.recipesDB.ingredientsList;
			//alert(param);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.recipesItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_unit_name = '';
			vm.prod_unit_id = '';
			vm.prod_qty = '';
			vm.prod_list = '';
			vm.unit_list = '';			
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].ingredients_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.prod_name = arrInp[i].ingredients_name;
					vm.prod_id = arrInp[i].ingredients_id;
					vm.prod_unit_name = '';
					vm.prod_unit_id = '';
					vm.prod_qty = 0;
					vm.prod_list = false;
					vm.unit_list = false;
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.recipesItems.length-1;
			var ind = vm.recipesItems.length;
			/*for(var i=len;i<vm.recipesItems.length;i++){
				vm.recipesItems[i].sno 		= ind;
				vm.recipesItems[i].prod_name 	= vm.prod_name;
				vm.recipesItems[i].prod_id 	= vm.prod_id;
				vm.recipesItems[i].prod_unit_name 	= vm.prod_unit_name;
				vm.recipesItems[i].prod_unit_id 	= vm.prod_unit_id;
				vm.recipesItems[i].prod_qty 	= vm.prod_qty;
				vm.recipesItems[i].prod_list	= vm.prod_list;
				vm.recipesItems[i].unit_list	= vm.unit_list;
				vm.recipesItems[i].prod_remove = vm.prod_remove;
			}*/

			alert(vm.recipesItems[index].selectedItem4);
			vm.recipesItems[index].sno 		= ind;
				vm.recipesItems[index].prod_name 	= vm.prod_name;
				vm.recipesItems[index].prod_id 	= vm.prod_id;
				vm.recipesItems[index].prod_unit_name 	= vm.prod_unit_name;
				vm.recipesItems[index].prod_unit_id 	= vm.prod_unit_id;
				vm.recipesItems[index].prod_qty 	= vm.prod_qty;
				vm.recipesItems[index].prod_list	= vm.prod_list;
				vm.recipesItems[index].unit_list	= vm.unit_list;
				vm.recipesItems[index].prod_remove = vm.prod_remove;
			
			if(vm.recipesItems[0].prod_id!=""){ 
				vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_name:'',prod_unit_id:'',prod_qty:'0',prod_list:false,unit_list:false,prod_remove:false};
				vm.recipesItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.recipesItems);							
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.recipesItems.length;i++){				
				if(vm.recipesItems[i].prod_id == param){
					//alert(vm.recipesItems[i].prod_id+" == "+param);
					vm.recipesItems.splice(i, 1);	
				}
			}			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.recipesItems);
		}
		
		function addNewRecipes()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.item);	
			if(__env.isDebug) console.log(vm.recipesItems);				
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.recipesUpdate@save', {param:{recipes:vm.item,recipesitm:vm.recipesItems,UserID:UserID},aToken:aToken,page:'recipes'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Recipes Updated Successfully').position('top right')
							);
							gotoRecipes();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchasei',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.purchasei', {
				url    : '/purchasei',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/purchasei/purchasei.html',
						controller : 'PurchaseiListController as vm'
					}
				},
				resolve: {					
					PurchaseiList: function (msApi)
					{					
						return msApi.resolve('app.purchaseiList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.purchasei-list', {
				url    : '/purchasei',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/purchasei/purchasei.html',
						controller : 'PurchaseiListController as vm'
					}
				},
				resolve: {					
					PurchaseiList: function (msApi)
					{					
						return msApi.resolve('app.purchaseiList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})			
			.state('app.purchasei.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/purchasei/new_purchasei/new_purchasei.html',
						controller : 'AddPurchaseiController as vm'
					}
				},
				resolve: {
					Purchasei: function (msApi)
					{
						return msApi.resolve('app.purchaseiAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'purchasei'
			})
			.state('app.purchasei.edit', {
				url      : '/edit/:purchasei_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/purchasei/new_purchasei/new_purchasei.html',
						controller : 'EditPurchaseiController as vm'
					}
				},
				resolve: {
					Purchasei: function ($stateParams, purchaseiService)
					{
						return purchaseiService.getPurchasei($stateParams.purchasei_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'purchasei'
			})
			.state('app.purchasei.edit-list', {
				url      : '/edit/:purchasei_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/purchasei/new_purchasei/new_purchasei.html',
						controller : 'EditPurchaseiController as vm'
					}
				},
				resolve: {
					Purchasei: function ($stateParams, purchaseiService)
					{
						return purchaseiService.getPurchasei($stateParams.purchasei_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'purchasei'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/purchasei');
			
			// Api						
			msApiProvider.register('app.purchaseiList', ['purchaseiList']);			
			msApiProvider.register('app.purchaseiAdd', ['purchaseiAdd']);
			msApiProvider.register('app.purchaseiEdit', ['purchaseiEdit']);
			msApiProvider.register('app.purchaseiDel', ['purchaseiDel']);
			msApiProvider.register('app.purchaseisave', ['purchaseisave']);
			msApiProvider.register('app.purchaseiUpdate', ['purchaseiUpdate']);
			/*msApiProvider.register('app.updateAdmission', ['updateAdmission']);
			*/
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('purchasei', {
				title : 'Purchasei',
				//icon  : 'icon-account-multiple',
				state : 'app.purchasei',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchasei')
        .factory('purchaseiService', purchaseiService);

    /** @ngInject */
    function purchaseiService($q, $mdToast, msApi)
    {
        var purchaseiEdit = [];

        var service = {
            getPurchasei	: getPurchasei,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPurchasei(purchasei_id,branchID)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( purchaseiEdit.length > 0 )
            {				
                deferred.resolve(purchaseiEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.purchaseiEdit@save', {param:{purchasei_id:purchasei_id,branchID:branchID},aToken:aToken,page:'purchasei'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							purchaseiEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(purchaseiEdit);
																								
							// Resolve the promise
							deferred.resolve(purchaseiEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchasei')
        .controller('AddPurchaseiController', AddPurchaseiController);

    /** @ngInject */
    function AddPurchaseiController($scope, $mdSidenav, Purchasei, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Item Purcahse";
		
        // Data
		vm.purchaseiDB = Purchasei.data;        		     				
		if(__env.isDebug) console.log(vm.purchaseiDB);	
		
		vm.totalXtrAmt = 0;
		vm.branchID = vm.purchaseiDB.branchID;
		vm.productsList = vm.purchaseiDB.productsList;
		vm.warehouseList = vm.purchaseiDB.warehouseList;
		
		vm.purchasei_fullno = vm.purchaseiDB.purchaseiPre+'-'+vm.purchaseiDB.purchaseiNo;
		vm.purchasei_date = vm.purchaseiDB.purchaseiDate1;		
		vm.purchasei = {purchasei_branch_id:vm.branchID, purchasei_warehouse_id:vm.warehouseList[0].warehouse_id, purchasei_supplier_id:'', purchasei_no:vm.purchaseiDB.purchaseiNo, purchasei_date:vm.purchaseiDB.purchaseiDate1, purchasei_type:'', purchasei_total_qty:0, purchasei_total_tax:0, purchasei_total_discount:0, purchasei_total_extra:0, purchasei_total_gross:0, purchasei_total_net:0};
		vm.supplier = {supplier_name:"", supplier_mobile:"", supplier_address:""};
		if(__env.isDebug) console.log(vm.purchasei);
				
		vm.cust_list = false;		
		vm.statuslist = ['Active','Inactive'];
		vm.modelist = ['Cash','Card','Cheque'];		
		
		vm.purchaseiItems = [];		
		vm.newItems = {sno:1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
		vm.purchaseiItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.purchaseiItems);
		
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		/*vm.extraItems = [];		
		vm.extra = {extra_id:'1',extra_name:'',extra_amount:''};
		vm.extraItems.push(vm.extra);		
		if(__env.isDebug) console.log(vm.extraItems);
		
		vm.payment = {spay_supplier_id:'',spay_amount:'',spay_date:vm.purchaseiDB.purchaseiDate1,spay_mode:'',spay_remarks:''};
		if(__env.isDebug) console.log(vm.payment);*/		

		// Methods
        vm.addNewPurchasei = addNewPurchasei;
		vm.gotoPurchasei = gotoPurchasei;
		vm.setProdID = setProdID;
		vm.setCustID = setCustID;
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.showcustlist = showcustlist;
		vm.removeProduct = removeProduct;
		//vm.removeextra = removeextra;
		//vm.addExtra = addExtra;
		//vm.checkPayment = checkPayment;
						
		/**
         * Go to Staff page
         */
		 
		function checkPayment(){
			if(vm.payment.spay_amount > vm.purchasei.purchasei_total_net){
				vm.payment.spay_amount = 0;
				alert("Unable to pay more than bill nett amount");
				return false;
			}	
		}
		
		function setCustID(){	
			vm.cust_list = true;
		}

		function showitmlist(param){			
			for(var i=0;i<vm.purchaseiItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.purchaseiItems[i].sno == param){
					vm.purchaseiItems[i].prod_list = true;
				}
			}	
		}		
				
		function showcustlist(param){	
			vm.cust_list = false;
			//alert(param);
			for(var i=0;i<vm.purchaseiDB.supplierList.length;i++){
				if(vm.purchaseiDB.supplierList[i].supplier_id == param){
					//alert(vm.purchaseiDB.supplierList[i].supplier_id+" == "+param);
					//vm.payment.spay_supplier_id = vm.purchaseiDB.supplierList[i].supplier_id;
					vm.purchasei.purchasei_supplier_id = vm.purchaseiDB.supplierList[i].supplier_id;
					vm.supplier.supplier_name = vm.purchaseiDB.supplierList[i].supplier_name; 
					vm.supplier.supplier_mobile = vm.purchaseiDB.supplierList[i].supplier_mobileno; 
					vm.supplier.supplier_address = vm.purchaseiDB.supplierList[i].supplier_address;				
				}
			}
		}
		
        function gotoPurchasei()
        {
			//alert("1");
            $state.go('app.purchasei-list');
        }
		//setProdID();
		
		
		function setProdID(param){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.purchaseiDB.productsList;
			//alert(param);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.purchaseiItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_unit = '';
			vm.prod_price = '';
			vm.prod_qty = '';
			//vm.prod_tax = '';
			//vm.prod_disc = '';
			vm.prod_total = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].itemlist_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.prod_name = arrInp[i].itemlist_name;
					vm.prod_id = arrInp[i].itemlist_id;
					vm.prod_unit_id = arrInp[i].unit_id;
					vm.prod_unit_name = arrInp[i].unit_name;
					vm.prod_qty = 0;
					vm.prod_price = '';
					//vm.prod_tax = arrInp[i].product_gst;
					//vm.prod_disc = 0;
					vm.prod_total = 0;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.purchaseiItems.length-1;
			var ind = vm.purchaseiItems.length;
			for(var i=len;i<vm.purchaseiItems.length;i++){
				vm.purchaseiItems[i].sno 		= ind;
				vm.purchaseiItems[i].prod_name 	= vm.prod_name;
				vm.purchaseiItems[i].prod_id 	= vm.prod_id;
				vm.purchaseiItems[i].prod_unit_id 	= vm.prod_unit_id;
				vm.purchaseiItems[i].prod_unit_name = vm.prod_unit_name;
				vm.purchaseiItems[i].prod_qty 	= vm.prod_qty;
				vm.purchaseiItems[i].prod_price 	= vm.prod_price;
				//vm.purchaseiItems[i].prod_tax 	= vm.prod_tax;
				//vm.purchaseiItems[i].prod_disc 	= vm.prod_disc;
				vm.purchaseiItems[i].prod_total = vm.prod_total;
				vm.purchaseiItems[i].prod_list	= vm.prod_list;
				vm.purchaseiItems[i].prod_remove = vm.prod_remove;
			}
			
			if(vm.purchaseiItems[0].prod_id!=""){ 
				vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
				vm.purchaseiItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.purchaseiItems);
			sumTotal();						
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.purchaseiItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.purchaseiItems[i].prod_id == param){
					vm.purchaseiItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseiItems);
		}
		
		/*function removeextra(param){
			//alert(param);
			for(var i=0;i<vm.extraItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.extraItems[i].extra_id == param){
					vm.extraItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.extraItems);
		}
		function addExtra(){
			var ind = vm.extraItems.length;
			vm.extra = {extra_id:ind+1,extra_name:'',extra_amount:''};
			vm.extraItems.push(vm.extra);		
			if(__env.isDebug) console.log(vm.extraItems);
			sumTotal();
		}*/
		
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;
			vm.totalgross = 0;
			vm.totalnett = 0;
			vm.totalTax = 0;
			vm.totalDisc = 0;
			vm.totalXtrAmt = 0;
			
			for(var i=0;i<vm.purchaseiItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.purchaseiItems[i].prod_qty > 0){
					var tot	= vm.purchaseiItems[i].prod_price * vm.purchaseiItems[i].prod_qty;
					//var tax = (tot * vm.purchaseiItems[i].prod_tax)/100;
					//var dis = (tot * vm.purchaseiItems[i].prod_disc)/100;
					
					//var total = tot+tax-dis;
					var total = tot;
					vm.purchaseiItems[i].prod_total = total;
					
					//vm.totalTax = vm.totalTax + tax;
					//vm.totalDisc = vm.totalDisc + dis;
					
					vm.totalQty = vm.totalQty + parseInt(vm.purchaseiItems[i].prod_qty);
					vm.totalgross = vm.totalgross + tot;
					vm.totalnett = vm.totalnett + total;
				}
			}
			
			
			/*for(var i=0;i<vm.extraItems.length;i++){
				if(vm.extraItems[i].extra_amount > 0){
					vm.totalXtrAmt = vm.totalXtrAmt + parseFloat(vm.extraItems[i].extra_amount); 
				}
			}*/
			
			//vm.totalnett = vm.totalgross + vm.totalTax - vm.totalDisc;
			vm.purchasei.purchasei_total_gross = vm.totalgross;
			vm.purchasei.purchasei_total_qty = vm.totalQty;
			//vm.purchasei.purchasei_total_tax = vm.totalTax;
			//vm.purchasei.purchasei_total_discount = vm.totalDisc;
			vm.purchasei.purchasei_total_net = vm.totalnett+vm.totalXtrAmt;						
			//vm.purchasei.purchasei_total_extra = vm.totalXtrAmt;
			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseiItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewPurchasei()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.purchasei);	
			if(__env.isDebug) console.log(vm.purchaseiItems);
			//if(__env.isDebug) console.log(vm.payment);	
			//if(__env.isDebug) console.log(vm.extraItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.purchaseisave@save', {param:{purchasei:vm.purchasei,purchaseiitm:vm.purchaseiItems,UserID:UserID},aToken:aToken,page:'purchasei'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Purchase Added Successfully').position('top right')
							);
							gotoPurchasei();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchasei')
        .controller('EditPurchaseiController', EditPurchaseiController);

    /** @ngInject */
    function EditPurchaseiController($scope, $mdSidenav, Purchasei, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Item Purcahse";
		
        // Data
		vm.purchaseiDB = Purchasei;        		     				
		if(__env.isDebug) console.log(vm.purchaseiDB);	
		//if(__env.isDebug) console.log(vm.purchaseiDB.suppDets);
		
		vm.purchaseiItems = [];
		
		vm.suppDets = vm.purchaseiDB.suppDets;				
		vm.purchasei = vm.purchaseiDB.purchaseiDets;
		vm.purchaseiTempItems = vm.purchaseiDB.purchaseiItmDets;	
		vm.productsList = vm.purchaseiDB.productsList;	
		vm.warehouseList = vm.purchaseiDB.warehouseList;
		
		vm.supplier = {supplier_name:vm.suppDets.supplier_name, supplier_mobile:vm.suppDets.supplier_mobileno, supplier_address:vm.suppDets.supplier_address};
		
		vm.purchasei_fullno = vm.purchaseiDB.purchaseiPre+'-'+vm.purchasei.purchasei_no;
		
		if(__env.isDebug) console.log(vm.purchasei);
				
		vm.cust_list = false;		
		vm.statuslist = ['Active','Inactive'];
		vm.modelist = ['Cash','Card','Cheque'];
		vm.typelist = ['Ingredients','Sales Items'];
		
		var ind = 0;
		for(var i=0;i<vm.purchaseiTempItems.length;i++){
			ind++;		
			
			vm.obj = {sno:ind,prod_name:vm.purchaseiTempItems[i].itemlist_name, prod_id:vm.purchaseiTempItems[i].piitm_product_id, prod_unit_id:vm.purchaseiTempItems[i].piitm_unit_id, prod_price:vm.purchaseiTempItems[i].piitm_price, prod_qty:vm.purchaseiTempItems[i].piitm_qty, prod_qty_old:vm.purchaseiTempItems[i].piitm_qty_old, prod_unit_name:vm.purchaseiTempItems[i].piitm_unit_name, prod_total:vm.purchaseiTempItems[i].piitm_total, prod_list:false,prod_remove:true};
			vm.purchaseiItems.push(vm.obj);
		}
		
		vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
		vm.purchaseiItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.purchaseiItems);
		
		
		/*vm.extraItems = [];			
		var ind = 0;
		for(var i=0;i<vm.purchaseiTempXtr.length;i++){
			ind++;		
			
			vm.obj = {extra_id:ind,extra_name:vm.purchaseiTempXtr[i].pxtr_name,extra_amount:vm.purchaseiTempXtr[i].pxtr_amount};
			vm.extraItems.push(vm.obj);
		}
		if(__env.isDebug) console.log(vm.extraItems);		
		if(vm.extraItems.length == 0){			
			vm.extra = {extra_id:ind+1,extra_name:'',extra_amount:''};
			vm.extraItems.push(vm.extra);		
		}
		if(__env.isDebug) console.log(vm.extraItems);*/
				

		// Methods
        vm.addNewPurchasei = addNewPurchasei;
		vm.gotoPurchasei = gotoPurchasei;
		vm.setProdID = setProdID;
		vm.setCustID = setCustID;
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.showcustlist = showcustlist;
		vm.removeProduct = removeProduct;
		//vm.removeextra = removeextra;
		//vm.addExtra = addExtra;
		//vm.checkPayment = checkPayment;
						
		/**
         * Go to Staff page
         */
		 
		function checkPayment(){
			//alert("In");
			//alert(vm.payment.spay_amount);
			if(vm.payment.spay_amount > vm.purchasei.purchasei_total_net){
				vm.payment.spay_amount = 0;
				alert("Unable to pay more than bill nett amount");
				return false;
			}
		}
		
		 
		
		function setCustID(){	
			vm.cust_list = true;
		}

		function showitmlist(param){			
			for(var i=0;i<vm.purchaseiItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.purchaseiItems[i].sno == param){
					vm.purchaseiItems[i].prod_list = true;
				}
			}	
		}		
				
		function showcustlist(param){	
			vm.cust_list = false;
			for(var i=0;i<vm.purchaseiDB.supplierList.length;i++){
				if(vm.purchaseiDB.supplierList[i].supplier_id == param){
					vm.purchasei.purchasei_supplier_id = vm.purchaseiDB.supplierList[i].supplier_id;
					vm.supplier.supplier_name = vm.purchaseiDB.supplierList[i].supplier_name; 
					vm.supplier.supplier_mobile = vm.purchaseiDB.supplierList[i].supplier_mobileno; 
					vm.supplier.supplier_address = vm.purchaseiDB.supplierList[i].supplier_address;				
				}
			}
		}
		
        function gotoPurchasei()
        {
			//alert("1");
            $state.go('app.purchasei-list');
        }
		//setProdID();
		
		
		function setProdID(param){
			//var ind = 0;
			vm.obj = [];			
			var arrInp = vm.purchaseiDB.productsList;
			//alert(vm.purchaseiItems[0].prod_id);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.purchaseiItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_unit = '';
			vm.prod_price = '';
			vm.prod_qty = '';
			//vm.prod_tax = '';
			//vm.prod_disc = '';
			vm.prod_total = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].itemlist_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.prod_name = arrInp[i].itemlist_name;
					vm.prod_id = arrInp[i].itemlist_id;
					vm.prod_unit_id = arrInp[i].unit_id;
					vm.prod_unit_name = arrInp[i].unit_name;
					vm.prod_qty = 0;
					vm.prod_price = '';
					//vm.prod_tax = arrInp[i].product_gst;
					//vm.prod_disc = 0;
					vm.prod_total = 0;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.purchaseiItems.length-1;
			var ind = vm.purchaseiItems.length;
			for(var i=len;i<vm.purchaseiItems.length;i++){
				vm.purchaseiItems[i].sno 		= ind;
				vm.purchaseiItems[i].prod_name 	= vm.prod_name;
				vm.purchaseiItems[i].prod_id 	= vm.prod_id;
				vm.purchaseiItems[i].prod_unit_id 	= vm.prod_unit_id;
				vm.purchaseiItems[i].prod_unit_name = vm.prod_unit_name;
				vm.purchaseiItems[i].prod_qty 	= vm.prod_qty;
				vm.purchaseiItems[i].prod_price 	= vm.prod_price;
				//vm.purchaseiItems[i].prod_tax 	= vm.prod_tax;
				//vm.purchaseiItems[i].prod_disc 	= vm.prod_disc;
				vm.purchaseiItems[i].prod_total = vm.prod_total;
				vm.purchaseiItems[i].prod_list	= vm.prod_list;
				vm.purchaseiItems[i].prod_remove = vm.prod_remove;
			}
			
			if(vm.purchaseiItems[0].prod_id!=""){ 
				vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
				vm.purchaseiItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.purchaseiItems);
			sumTotal();
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.purchaseiItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.purchaseiItems[i].prod_id == param){
					vm.purchaseiItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseiItems);
		}
		
		/*function removeextra(param){
			//alert(param);
			for(var i=0;i<vm.extraItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.extraItems[i].extra_id == param){
					vm.extraItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.extraItems);
		}
		
		function addExtra(){
			var ind = vm.extraItems.length;
			vm.extra = {extra_id:ind+1,extra_name:'',extra_amount:''};
			vm.extraItems.push(vm.extra);		
			if(__env.isDebug) console.log(vm.extraItems);
			sumTotal();
		}*/
		
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;
			vm.totalgross = 0;
			vm.totalnett = 0;
			vm.totalTax = 0;
			vm.totalDisc = 0;
			vm.totalXtrAmt = 0;
			
			for(var i=0;i<vm.purchaseiItems.length;i++){
				//alert(vm.purchaseiItems[i].prod_qty);
				if(vm.purchaseiItems[i].prod_qty > 0){
					var tot	= vm.purchaseiItems[i].prod_price * vm.purchaseiItems[i].prod_qty;
					//var tax = (tot * vm.purchaseiItems[i].prod_tax)/100;
					//var dis = (tot * vm.purchaseiItems[i].prod_disc)/100;
					
					//var total = tot+tax-dis;
					var total = tot;
					vm.purchaseiItems[i].prod_total = total;
					
					//vm.totalTax = vm.totalTax + tax;
					//vm.totalDisc = vm.totalDisc + dis;
					
					vm.totalQty = vm.totalQty + parseInt(vm.purchaseiItems[i].prod_qty);
					vm.totalgross = vm.totalgross + tot;
					vm.totalnett = vm.totalnett + total;
				}
			}
			
			
			/*for(var i=0;i<vm.extraItems.length;i++){
				if(vm.extraItems[i].extra_amount > 0){
					vm.totalXtrAmt = vm.totalXtrAmt + parseFloat(vm.extraItems[i].extra_amount); 
				}
			}*/
			
			//vm.totalnett = vm.totalgross + vm.totalTax - vm.totalDisc;
			vm.purchasei.purchasei_total_gross = vm.totalgross;
			vm.purchasei.purchasei_total_qty = vm.totalQty;
			//vm.purchasei.purchasei_total_tax = vm.totalTax;
			//vm.purchasei.purchasei_total_discount = vm.totalDisc;
			vm.purchasei.purchasei_total_net = vm.totalnett+vm.totalXtrAmt;						
			//vm.purchasei.purchasei_total_extra = vm.totalXtrAmt;
			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseiItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewPurchasei()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.purchasei);	
			if(__env.isDebug) console.log(vm.purchaseiItems);	
			//if(__env.isDebug) console.log(vm.payment);	
			//if(__env.isDebug) console.log(vm.extraItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.purchaseiUpdate@save', {param:{purchasei:vm.purchasei,purchaseiitm:vm.purchaseiItems,UserID:UserID},aToken:aToken,page:'purchasei'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Purchase Updated Successfully').position('top right')
							);
							gotoPurchasei();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.purchase-report', {
				url    : '/purchase-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/purchase-report/purchase-report.html',
						controller : 'PurchaseReportController as vm'
					}
				},
				resolve: {					
					PurchaseReportList: function (msApi)
					{					
						return msApi.resolve('app.purchaseReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.purchase-report-list', {
				url    : '/purchase-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/purchase-report/purchase-report.html',
						controller : 'PurchaseReportController as vm'
					}
				},
				resolve: {					
					PurchaseReportList: function ($stateParams, purchasereportService)
					{
						
						return purchasereportService.getPurchaseList($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/purchase-report');
			
			// Api						
			msApiProvider.register('app.purchaseReportList', ['purchaseReportList']);
			msApiProvider.register('app.purchaseReportList2', ['purchaseReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.opening-stock-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase-report')
        .factory('purchasereportService', purchasereportService);

    /** @ngInject */
    function purchasereportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getPurchaseList : getPurchaseList
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getPurchaseList(purchaseDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.purchaseReportList2@save', {param:{purchaseDets:purchaseDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.purchase', {
				url    : '/purchase',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/purchase/purchase.html',
						controller : 'PurchaseListController as vm'
					}
				},
				resolve: {					
					PurchaseList: function (msApi)
					{					
						return msApi.resolve('app.purchaseList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.purchase-list', {
				url    : '/purchase',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/purchase/purchase.html',
						controller : 'PurchaseListController as vm'
					}
				},
				resolve: {					
					PurchaseList: function (msApi)
					{					
						return msApi.resolve('app.purchaseList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})			
			.state('app.purchase.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/purchase/new_purchase/new_purchase.html',
						controller : 'AddPurchaseController as vm'
					}
				},
				resolve: {
					Purchase: function (msApi)
					{
						return msApi.resolve('app.purchaseAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'purchase'
			})
			.state('app.purchase.edit', {
				url      : '/edit/:purchase_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/purchase/new_purchase/new_purchase.html',
						controller : 'EditPurchaseController as vm'
					}
				},
				resolve: {
					Purchase: function ($stateParams, purchaseService)
					{
						return purchaseService.getPurchase($stateParams.purchase_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'purchase'
			})
			.state('app.purchase.edit-list', {
				url      : '/edit/:purchase_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/purchase/new_purchase/new_purchase.html',
						controller : 'EditPurchaseController as vm'
					}
				},
				resolve: {
					Purchase: function ($stateParams, purchaseService)
					{
						return purchaseService.getPurchase($stateParams.purchase_id,localStorage.getItem('BranchID'));
					}
				},
				bodyClass: 'purchase'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/purchase');
			
			// Api						
			msApiProvider.register('app.purchaseList', ['purchaseList']);			
			msApiProvider.register('app.purchaseAdd', ['purchaseAdd']);
			msApiProvider.register('app.purchaseEdit', ['purchaseEdit']);
			msApiProvider.register('app.purchaseDel', ['purchaseDel']);
			msApiProvider.register('app.purchasesave', ['purchasesave']);
			msApiProvider.register('app.purchaseUpdate', ['purchaseUpdate']);
			/*msApiProvider.register('app.updateAdmission', ['updateAdmission']);
			*/
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('purchase', {
				title : 'Purchase',
				//icon  : 'icon-account-multiple',
				state : 'app.purchase',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase')
        .factory('purchaseService', purchaseService);

    /** @ngInject */
    function purchaseService($q, $mdToast, msApi)
    {
        var purchaseEdit = [];

        var service = {
            getPurchase	: getPurchase,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPurchase(purchase_id,branchID)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( purchaseEdit.length > 0 )
            {				
                deferred.resolve(purchaseEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.purchaseEdit@save', {param:{purchase_id:purchase_id,branchID:branchID},aToken:aToken,page:'purchase'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							purchaseEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(purchaseEdit);
																								
							// Resolve the promise
							deferred.resolve(purchaseEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase')
        .controller('AddPurchaseController', AddPurchaseController);

    /** @ngInject */
    function AddPurchaseController($scope, $mdSidenav, Purchase, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window, $log, $timeout)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Ingredients Purcahse";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Purchase" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		vm.purchaseDB = Purchase.data;        		     				
		if(__env.isDebug) console.log(vm.purchaseDB);	
		
		vm.totalXtrAmt = 0;
		vm.branchID = vm.purchaseDB.branchID;
		vm.productsList = vm.purchaseDB.productsList;
		vm.warehouseList = vm.purchaseDB.warehouseList;
		
		vm.purchase_fullno = vm.purchaseDB.purchasePre+'-'+vm.purchaseDB.purchaseNo;
		vm.purchase_date = vm.purchaseDB.purchaseDate1;		
		vm.purchase = {purchase_branch_id:vm.branchID, purchase_warehouse_id:vm.warehouseList[0].warehouse_id, purchase_supplier_id:'', purchase_no:vm.purchaseDB.purchaseNo, purchase_date:vm.purchaseDB.purchaseDate1, purchase_type:'', purchase_total_qty:0, purchase_total_tax:0, purchase_total_discount:0, purchase_total_extra:0, purchase_total_gross:0, purchase_total_net:0};
		vm.supplier = {supplier_name:"", supplier_mobile:"", supplier_address:""};
		if(__env.isDebug) console.log(vm.purchase);
				
		vm.cust_list = false;		
		vm.statuslist = ['Active','Inactive'];
		vm.modelist = ['Cash','Card','Cheque'];
		vm.typelist = ['Ingredients','Sales Items'];
		
		vm.purchaseItems = [];		
		vm.newItems = {sno:1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
		vm.purchaseItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.purchaseItems);
		
		
		
		/*vm.extraItems = [];		
		vm.extra = {extra_id:'1',extra_name:'',extra_amount:''};
		vm.extraItems.push(vm.extra);		
		if(__env.isDebug) console.log(vm.extraItems);
		
		vm.payment = {spay_supplier_id:'',spay_amount:'',spay_date:vm.purchaseDB.purchaseDate1,spay_mode:'',spay_remarks:''};
		if(__env.isDebug) console.log(vm.payment);*/		

		// Methods
        vm.addNewPurchase = addNewPurchase;
		vm.gotoPurchase = gotoPurchase;
		vm.setProdID = setProdID;
		vm.setCustID = setCustID;
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.showcustlist = showcustlist;
		vm.removeProduct = removeProduct;
		//vm.removeextra = removeextra;
		//vm.addExtra = addExtra;
		//vm.checkPayment = checkPayment;
						
		/**
         * Go to Staff page
         */
        
		/*** Supplier autocomplete start ***/		
						
		vm.simulateQuery = false;
	    vm.isDisabled    = false;
	    vm.repos         = loadAll();
	    vm.querySearch   = querySearch;
	    vm.selectedItemChange = selectedItemChange;
	    vm.searchTextChange   = searchTextChange;

        function querySearch (query) {
        	//alert("Query");
	      	var results = query ? vm.repos.filter( createFilterFor(query) ) : vm.repos,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	showcustlist(item.supplier_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll() {
	    	//alert("Loading");
	      	var repos = vm.purchaseDB.supplierList
	      	return repos.map( function (repo) {
	        	repo.supplier_name_low = repo.supplier_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.supplier_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Supplier autocomplete end ***/ 

	    /*** Item autocomplete start ***/		
						
		vm.simulateQuery2 = false;
	    vm.isDisabled2    = false;
	    vm.repos2         = loadAll2();
	    vm.querySearch2   = querySearch2;
	    vm.selectedItemChange2 = selectedItemChange2;
	    vm.searchTextChange2   = searchTextChange2;

        function querySearch2 (query) {
        	//alert("Query");
	      	var results = query ? vm.repos2.filter( createFilterFor2(query) ) : vm.repos2,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange2(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange2(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setProdID(item.ingredients_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll2() {
	    	//alert("Loading");
	      	var repos = vm.productsList
	      	return repos.map( function (repo) {
	        	repo.ingredients_name_low = repo.ingredients_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor2(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.ingredients_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Item autocomplete end ***/

		 
		function checkPayment(){
			if(vm.payment.spay_amount > vm.purchase.purchase_total_net){
				vm.payment.spay_amount = 0;
				alert("Unable to pay more than bill nett amount");
				return false;
			}	
		}
		
		function setCustID(){	
			vm.cust_list = true;
		}

		function showitmlist(param){			
			for(var i=0;i<vm.purchaseItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.purchaseItems[i].sno == param){
					vm.purchaseItems[i].prod_list = true;
				}
			}	
		}		
				
		function showcustlist(param){	
			vm.cust_list = false;
			//alert(param);
			for(var i=0;i<vm.purchaseDB.supplierList.length;i++){
				if(vm.purchaseDB.supplierList[i].supplier_id == param){
					//alert(vm.purchaseDB.supplierList[i].supplier_id+" == "+param);
					//vm.payment.spay_supplier_id = vm.purchaseDB.supplierList[i].supplier_id;
					vm.purchase.purchase_supplier_id = vm.purchaseDB.supplierList[i].supplier_id;
					vm.supplier.supplier_name = vm.purchaseDB.supplierList[i].supplier_name; 
					vm.supplier.supplier_mobile = vm.purchaseDB.supplierList[i].supplier_mobileno; 
					vm.supplier.supplier_address = vm.purchaseDB.supplierList[i].supplier_address;				
				}
			}
		}
		
        function gotoPurchase()
        {
			//alert("1");
            $state.go('app.purchase-list');
        }
		//setProdID();
		
		
		function setProdID(param){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.purchaseDB.productsList;
			//alert(param);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.purchaseItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_unit = '';
			vm.prod_price = '';
			vm.prod_qty = '';
			//vm.prod_tax = '';
			//vm.prod_disc = '';
			vm.prod_total = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].ingredients_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.prod_name = arrInp[i].ingredients_name;
					vm.prod_id = arrInp[i].ingredients_id;
					vm.prod_unit_id = arrInp[i].unit_id;
					vm.prod_unit_name = arrInp[i].unit_name;
					vm.prod_qty = 0;
					vm.prod_price = '';
					//vm.prod_tax = arrInp[i].product_gst;
					//vm.prod_disc = 0;
					vm.prod_total = 0;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.purchaseItems.length-1;
			var ind = vm.purchaseItems.length;
			for(var i=len;i<vm.purchaseItems.length;i++){
				vm.purchaseItems[i].sno 		= ind;
				vm.purchaseItems[i].prod_name 	= vm.prod_name;
				vm.purchaseItems[i].prod_id 	= vm.prod_id;
				vm.purchaseItems[i].prod_unit_id 	= vm.prod_unit_id;
				vm.purchaseItems[i].prod_unit_name = vm.prod_unit_name;
				vm.purchaseItems[i].prod_qty 	= vm.prod_qty;
				vm.purchaseItems[i].prod_price 	= vm.prod_price;
				//vm.purchaseItems[i].prod_tax 	= vm.prod_tax;
				//vm.purchaseItems[i].prod_disc 	= vm.prod_disc;
				vm.purchaseItems[i].prod_total = vm.prod_total;
				vm.purchaseItems[i].prod_list	= vm.prod_list;
				vm.purchaseItems[i].prod_remove = vm.prod_remove;
			}
			
			if(vm.purchaseItems[0].prod_id!=""){ 
				vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
				vm.purchaseItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.purchaseItems);
			sumTotal();						
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.purchaseItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.purchaseItems[i].prod_id == param){
					vm.purchaseItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseItems);
		}
		
		/*function removeextra(param){
			//alert(param);
			for(var i=0;i<vm.extraItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.extraItems[i].extra_id == param){
					vm.extraItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.extraItems);
		}
		function addExtra(){
			var ind = vm.extraItems.length;
			vm.extra = {extra_id:ind+1,extra_name:'',extra_amount:''};
			vm.extraItems.push(vm.extra);		
			if(__env.isDebug) console.log(vm.extraItems);
			sumTotal();
		}*/
		
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;
			vm.totalgross = 0;
			vm.totalnett = 0;
			vm.totalTax = 0;
			vm.totalDisc = 0;
			vm.totalXtrAmt = 0;
			
			for(var i=0;i<vm.purchaseItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.purchaseItems[i].prod_qty > 0){
					var tot	= vm.purchaseItems[i].prod_price * vm.purchaseItems[i].prod_qty;
					//var tax = (tot * vm.purchaseItems[i].prod_tax)/100;
					//var dis = (tot * vm.purchaseItems[i].prod_disc)/100;
					
					//var total = tot+tax-dis;
					var total = tot;
					vm.purchaseItems[i].prod_total = total;
					
					//vm.totalTax = vm.totalTax + tax;
					//vm.totalDisc = vm.totalDisc + dis;
					
					vm.totalQty = vm.totalQty + parseInt(vm.purchaseItems[i].prod_qty);
					vm.totalgross = vm.totalgross + tot;
					vm.totalnett = vm.totalnett + total;
				}
			}
			
			
			/*for(var i=0;i<vm.extraItems.length;i++){
				if(vm.extraItems[i].extra_amount > 0){
					vm.totalXtrAmt = vm.totalXtrAmt + parseFloat(vm.extraItems[i].extra_amount); 
				}
			}*/
			
			//vm.totalnett = vm.totalgross + vm.totalTax - vm.totalDisc;
			vm.purchase.purchase_total_gross = vm.totalgross;
			vm.purchase.purchase_total_qty = vm.totalQty;
			//vm.purchase.purchase_total_tax = vm.totalTax;
			//vm.purchase.purchase_total_discount = vm.totalDisc;
			vm.purchase.purchase_total_net = vm.totalnett+vm.totalXtrAmt;						
			//vm.purchase.purchase_total_extra = vm.totalXtrAmt;
			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewPurchase()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.purchase);	
			if(__env.isDebug) console.log(vm.purchaseItems);
			//if(__env.isDebug) console.log(vm.payment);	
			//if(__env.isDebug) console.log(vm.extraItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.purchasesave@save', {param:{purchase:vm.purchase,purchaseitm:vm.purchaseItems,UserID:UserID},aToken:aToken,page:'purchase'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Purchase Added Successfully').position('top right')
							);
							gotoPurchase();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase')
        .controller('EditPurchaseController', EditPurchaseController);

    /** @ngInject */
    function EditPurchaseController($scope, $mdSidenav, Purchase, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window, $log, $timeout)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Ingredients Purcahse";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Purchase" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}
		
		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.purchaseDB = Purchase;        		     				
		if(__env.isDebug) console.log(vm.purchaseDB);	
		//if(__env.isDebug) console.log(vm.purchaseDB.suppDets);
		
		vm.purchaseItems = [];
		
		vm.suppDets = vm.purchaseDB.suppDets;				
		vm.purchase = vm.purchaseDB.purchaseDets;
		vm.purchaseTempItems = vm.purchaseDB.purchaseItmDets;	
		vm.productsList = vm.purchaseDB.productsList;	
		vm.warehouseList = vm.purchaseDB.warehouseList;
		
		vm.supplier = {supplier_name:vm.suppDets.supplier_name, supplier_mobile:vm.suppDets.supplier_mobileno, supplier_address:vm.suppDets.supplier_address};
		
		vm.purchase_fullno = vm.purchaseDB.purchasePre+'-'+vm.purchase.purchase_no;
		
		if(__env.isDebug) console.log(vm.purchase);
				
		vm.cust_list = false;		
		vm.statuslist = ['Active','Inactive'];
		vm.modelist = ['Cash','Card','Cheque'];
		vm.typelist = ['Ingredients','Sales Items'];
		
		vm.selectedItem = 	vm.supplier.supplier_name;
		vm.searchText = 	vm.supplier.supplier_name;

		var ind = 0;
		for(var i=0;i<vm.purchaseTempItems.length;i++){
			ind++;		
			
			vm.obj = {sno:ind,prod_name:vm.purchaseTempItems[i].ingredients_name, prod_id:vm.purchaseTempItems[i].pitm_product_id, prod_unit_id:vm.purchaseTempItems[i].pitm_unit_id, prod_price:vm.purchaseTempItems[i].pitm_price, prod_qty:vm.purchaseTempItems[i].pitm_qty, prod_qty_old:vm.purchaseTempItems[i].pitm_qty_old, prod_unit_name:vm.purchaseTempItems[i].pitm_unit_name,  prod_total:vm.purchaseTempItems[i].pitm_total, prod_list:false,prod_remove:true, selectedItem2:vm.purchaseTempItems[i].ingredients_name,searchText2:vm.purchaseTempItems[i].ingredients_name};
			vm.purchaseItems.push(vm.obj);
		}
		
		vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
		vm.purchaseItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.purchaseItems);
		
		
		/*vm.extraItems = [];			
		var ind = 0;
		for(var i=0;i<vm.purchaseTempXtr.length;i++){
			ind++;		
			
			vm.obj = {extra_id:ind,extra_name:vm.purchaseTempXtr[i].pxtr_name,extra_amount:vm.purchaseTempXtr[i].pxtr_amount};
			vm.extraItems.push(vm.obj);
		}
		if(__env.isDebug) console.log(vm.extraItems);		
		if(vm.extraItems.length == 0){			
			vm.extra = {extra_id:ind+1,extra_name:'',extra_amount:''};
			vm.extraItems.push(vm.extra);		
		}
		if(__env.isDebug) console.log(vm.extraItems);*/
				

		// Methods
        vm.addNewPurchase = addNewPurchase;
		vm.gotoPurchase = gotoPurchase;
		vm.setProdID = setProdID;
		vm.setCustID = setCustID;
		vm.sumTotal = sumTotal;
		vm.showitmlist = showitmlist;
		vm.showcustlist = showcustlist;
		vm.removeProduct = removeProduct;
		//vm.removeextra = removeextra;
		//vm.addExtra = addExtra;
		//vm.checkPayment = checkPayment;
						
		/**
         * Go to Staff page
         */


         /*** Supplier autocomplete start ***/		
						
		vm.simulateQuery = false;
	    vm.isDisabled    = false;
	    vm.repos         = loadAll();
	    vm.querySearch   = querySearch;
	    vm.selectedItemChange = selectedItemChange;
	    vm.searchTextChange   = searchTextChange;

        function querySearch (query) {
        	//alert("Query");
	      	var results = query ? vm.repos.filter( createFilterFor(query) ) : vm.repos,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	showcustlist(item.supplier_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll() {
	    	//alert("Loading");
	      	var repos = vm.purchaseDB.supplierList
	      	return repos.map( function (repo) {
	        	repo.supplier_name_low = repo.supplier_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.supplier_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Supplier autocomplete end ***/ 

	    /*** Item autocomplete start ***/		
						
		vm.simulateQuery2 = false;
	    vm.isDisabled2    = false;
	    vm.repos2         = loadAll2();
	    vm.querySearch2   = querySearch2;
	    vm.selectedItemChange2 = selectedItemChange2;
	    vm.searchTextChange2   = searchTextChange2;

        function querySearch2 (query) {
        	//alert("Query");
	      	var results = query ? vm.repos2.filter( createFilterFor2(query) ) : vm.repos2,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange2(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange2(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setProdID(item.ingredients_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll2() {
	    	//alert("Loading");
	      	var repos = vm.productsList
	      	return repos.map( function (repo) {
	        	repo.ingredients_name_low = repo.ingredients_name.toLowerCase();	        	
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor2(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.ingredients_name_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

	    /*** Item autocomplete end ***/
		 
		function checkPayment(){
			//alert("In");
			//alert(vm.payment.spay_amount);
			if(vm.payment.spay_amount > vm.purchase.purchase_total_net){
				vm.payment.spay_amount = 0;
				alert("Unable to pay more than bill nett amount");
				return false;
			}
		}
		
		 
		
		function setCustID(){	
			vm.cust_list = true;
		}

		function showitmlist(param){			
			for(var i=0;i<vm.purchaseItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.purchaseItems[i].sno == param){
					vm.purchaseItems[i].prod_list = true;
				}
			}	
		}		
				
		function showcustlist(param){	
			vm.cust_list = false;
			for(var i=0;i<vm.purchaseDB.supplierList.length;i++){
				if(vm.purchaseDB.supplierList[i].supplier_id == param){
					vm.purchase.purchase_supplier_id = vm.purchaseDB.supplierList[i].supplier_id;
					vm.supplier.supplier_name = vm.purchaseDB.supplierList[i].supplier_name; 
					vm.supplier.supplier_mobile = vm.purchaseDB.supplierList[i].supplier_mobileno; 
					vm.supplier.supplier_address = vm.purchaseDB.supplierList[i].supplier_address;				
				}
			}
		}
		
        function gotoPurchase()
        {
			//alert("1");
            $state.go('app.purchase-list');
        }
		//setProdID();
		
		
		function setProdID(param){
			//var ind = 0;
			vm.obj = [];			
			var arrInp = vm.purchaseDB.productsList;
			//alert(vm.purchaseItems[0].prod_id);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.purchaseItems);
			
			vm.prod_name = '';
			vm.prod_id = '';
			vm.prod_unit = '';
			vm.prod_price = '';
			vm.prod_qty = '';
			//vm.prod_tax = '';
			//vm.prod_disc = '';
			vm.prod_total = '';
			vm.prod_list = '';
			vm.prod_remove = '';
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].ingredients_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.prod_name = arrInp[i].ingredients_name;
					vm.prod_id = arrInp[i].ingredients_id;
					vm.prod_unit_id = arrInp[i].unit_id;
					vm.prod_unit_name = arrInp[i].unit_name;
					vm.prod_qty = 0;
					vm.prod_price = '';
					//vm.prod_tax = arrInp[i].product_gst;
					//vm.prod_disc = 0;
					vm.prod_total = 0;
					vm.prod_list = false;	
					vm.prod_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.prod_name+" "+vm.prod_id+" "+vm.prod_unit);
			
			var len = vm.purchaseItems.length-1;
			var ind = vm.purchaseItems.length;
			for(var i=len;i<vm.purchaseItems.length;i++){
				vm.purchaseItems[i].sno 		= ind;
				vm.purchaseItems[i].prod_name 	= vm.prod_name;
				vm.purchaseItems[i].prod_id 	= vm.prod_id;
				vm.purchaseItems[i].prod_unit_id 	= vm.prod_unit_id;
				vm.purchaseItems[i].prod_unit_name = vm.prod_unit_name;
				vm.purchaseItems[i].prod_qty 	= vm.prod_qty;
				vm.purchaseItems[i].prod_price 	= vm.prod_price;
				//vm.purchaseItems[i].prod_tax 	= vm.prod_tax;
				//vm.purchaseItems[i].prod_disc 	= vm.prod_disc;
				vm.purchaseItems[i].prod_total = vm.prod_total;
				vm.purchaseItems[i].prod_list	= vm.prod_list;
				vm.purchaseItems[i].prod_remove = vm.prod_remove;
			}
			
			if(vm.purchaseItems[0].prod_id!=""){ 
				vm.newItems = {sno:ind+1,prod_name:'',prod_id:'',prod_unit_id:'',prod_unit_name:'',prod_price:'',prod_qty:'0',prod_total:'0',prod_list:false,prod_remove:false};
				vm.purchaseItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.purchaseItems);
			sumTotal();
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.purchaseItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.purchaseItems[i].prod_id == param){
					vm.purchaseItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseItems);
		}
		
		/*function removeextra(param){
			//alert(param);
			for(var i=0;i<vm.extraItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.extraItems[i].extra_id == param){
					vm.extraItems.splice(i, 1);	
				}
			}
			sumTotal();
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.extraItems);
		}
		
		function addExtra(){
			var ind = vm.extraItems.length;
			vm.extra = {extra_id:ind+1,extra_name:'',extra_amount:''};
			vm.extraItems.push(vm.extra);		
			if(__env.isDebug) console.log(vm.extraItems);
			sumTotal();
		}*/
		
		function sumTotal(){
			//alert("Hi");			
			vm.totalQty = 0;
			vm.totalgross = 0;
			vm.totalnett = 0;
			vm.totalTax = 0;
			vm.totalDisc = 0;
			vm.totalXtrAmt = 0;
			
			for(var i=0;i<vm.purchaseItems.length;i++){
				//alert(vm.purchaseItems[i].prod_qty);
				if(vm.purchaseItems[i].prod_qty > 0){
					var tot	= vm.purchaseItems[i].prod_price * vm.purchaseItems[i].prod_qty;
					//var tax = (tot * vm.purchaseItems[i].prod_tax)/100;
					//var dis = (tot * vm.purchaseItems[i].prod_disc)/100;
					
					//var total = tot+tax-dis;
					var total = tot;
					vm.purchaseItems[i].prod_total = total;
					
					//vm.totalTax = vm.totalTax + tax;
					//vm.totalDisc = vm.totalDisc + dis;
					
					vm.totalQty = vm.totalQty + parseInt(vm.purchaseItems[i].prod_qty);
					vm.totalgross = vm.totalgross + tot;
					vm.totalnett = vm.totalnett + total;
				}
			}
			
			
			/*for(var i=0;i<vm.extraItems.length;i++){
				if(vm.extraItems[i].extra_amount > 0){
					vm.totalXtrAmt = vm.totalXtrAmt + parseFloat(vm.extraItems[i].extra_amount); 
				}
			}*/
			
			//vm.totalnett = vm.totalgross + vm.totalTax - vm.totalDisc;
			vm.purchase.purchase_total_gross = vm.totalgross;
			vm.purchase.purchase_total_qty = vm.totalQty;
			//vm.purchase.purchase_total_tax = vm.totalTax;
			//vm.purchase.purchase_total_discount = vm.totalDisc;
			vm.purchase.purchase_total_net = vm.totalnett+vm.totalXtrAmt;						
			//vm.purchase.purchase_total_extra = vm.totalXtrAmt;
			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.purchaseItems);
		}
						
		/**
         * Add New Staff
        **/
        function addNewPurchase()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.purchase);	
			if(__env.isDebug) console.log(vm.purchaseItems);	
			//if(__env.isDebug) console.log(vm.payment);	
			//if(__env.isDebug) console.log(vm.extraItems);
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.purchaseUpdate@save', {param:{purchase:vm.purchase,purchaseitm:vm.purchaseItems,UserID:UserID},aToken:aToken,page:'purchase'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Purchase Updated Successfully').position('top right')
							);
							gotoPurchase();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .factory('printersService', printersService);

    /** @ngInject */
    function printersService($q, $mdToast, msApi)
    {
        var printersEdit = [], printersMap = [];

        var service = {
            getPrinters	: getPrinters,
			getPrinterMapping : getPrinterMapping,
			getPrinterOption : getPrinterOption,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPrinters(printers_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printersEdit@save', {param:{printers_id:printers_id},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						printersEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(printersEdit);
																							
						// Resolve the promise
						deferred.resolve(printersEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getPrinterMapping(printers_id)
        {						
			//alert(printers_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {param:{printersID:printers_id},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						printersMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(printersMap);
						printersMap['printersID'] = printers_id;
																							
						// Resolve the promise
						deferred.resolve(printersMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getPrinterOption(printers_id)
        {						
			//alert(printers_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {aToken:aToken,page:'printers'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						printersMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(printersMap);
						printersMap['printersID'] = printers_id;
																							
						// Resolve the promise
						deferred.resolve(printersMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .controller('AddPrintersController', AddPrintersController);

    /** @ngInject */
    function AddPrintersController($scope, $mdSidenav, Printers, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Branch";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Printers" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.printersDB = Printers.data;        		     				
		if(__env.isDebug) console.log(vm.printersDB);	
		
		vm.branchID = vm.printersDB.branchID;
		
		//vm.printers = {printers_code:vm.printersDB.printersCode};
		vm.printers = {printers_name:'',  printers_branch_id:vm.branchID,  printers_device:'', printers_status:'Active'};
		
		vm.devicelist = __env.printersList;
		if(__env.isDebug) console.log(vm.devicelist);
		//vm.typelist = ['KOTs','Tickets'];
		vm.statuslist = ['Active','Inactive'];
		//vm.printers = {printers_status : "Active"};
		
		
		
		// Methods
        vm.savePrinters = savePrinters;
		vm.gotoPrinters = gotoPrinters;
		vm.gotoLogin = gotoLogin;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoPrinters()
        {
			//alert("1");
            $state.go('app.printers-list');
        }
						
		function savePrinters()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printers);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printersSave@save', {param:{printers:vm.printers,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printers Added Successfully').position('top right')
							);
							gotoPrinters();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }						
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .controller('EditPrintersController', EditPrintersController);

    /** @ngInject */
    function EditPrintersController($scope, $mdSidenav, Printers, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Branch";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Printers" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.printersDB = Printers;		
		if(__env.isDebug) console.log("Printers Det");
		if(__env.isDebug) console.log(vm.printersDB);
		vm.printers = vm.printersDB.printersDets;
		
		vm.devicelist = __env.printersList;
		if(__env.isDebug) console.log(vm.devicelist);
		//vm.typelist = ['KOTs','Tickets'];
		vm.statuslist = ['Active','Inactive'];
				
		
		if(vm.printersDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.savePrinters = savePrinters;
		vm.gotoPrinters = gotoPrinters;	
		vm.gotoLogin = gotoLogin;	
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoPrinters()
        {
			//alert("1");
            $state.go('app.printers-list');
        }
								
		function savePrinters()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printers);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printersUpdate@save', {param:{printers:vm.printers,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printers Updated Successfully').position('top right')
							);
							gotoPrinters();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .controller('PrintersMappingController', PrintersMappingController);

    /** @ngInject */
    function PrintersMappingController($state, PrintersMapping, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Printers";
		
        // Data
        vm.itemList = PrintersMapping;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.itemList);
		//vm.roles = vm.itemList.roleList;
		vm.depts = vm.itemList.departmentList;
		vm.categorys = vm.itemList.categoryList;
		//vm.tickets = {};
		vm.items = vm.itemList.itemList;
		vm.mapList = vm.itemList.mapList;
		vm.printersID = vm.itemList.printersID;
		vm.printerMapItems = [];
		if(vm.mapList.length > 0){
			vm.printerMapItems = vm.mapList;
		} else {
			var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_printers_id:vm.printersID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.printerMapItems);
		
		if(vm.itemList.error == "1"){
			gotoLogin();
		} 
		
        // Methods
       
		vm.gotoPrinters = gotoPrinters;	
		vm.savePrintersItems = savePrintersItems;
		vm.gotoLogin = gotoLogin;			
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }				
        
		function gotoPrinters()
        {
			//alert("1");
            $state.go('app.printers-list');
        }
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_printers_id:vm.printersID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.printerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.printerMapItems.length;i++){	
				if(vm.printerMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.printerMapItems.splice(i, 1);
				}
			}
        }
		
		function savePrintersItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printerMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.savePrinterMapping@save', {param:{printersID:vm.printersID,printerMapItems:vm.printerMapItems},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoPrinters();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.printerjobs',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.printerjobs', {
				url    : '/printerjobs',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/printerjobs.html',
						controller : 'PrinterjobsListController as vm'
					}
				},
				resolve: {					
					PrinterjobsList: function (msApi)
					{					
						return msApi.resolve('app.printerjobsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.printerjobs-list', {
				url    : '/printerjobs',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/printerjobs.html',
						controller : 'PrinterjobsListController as vm'
					}
				},
				resolve: {					
					PrinterjobsList: function (msApi)
					{					
						return msApi.resolve('app.printerjobsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.printerjobs.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/new_printerjobs/new_printerjobs.html',
						controller : 'AddPrinterjobsController as vm'
					}
				},
				resolve: {
					Printerjobs: function (msApi)
					{
						return msApi.resolve('app.printerjobsAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'printerjobs'
			})
			.state('app.printerjobs.edit', {
				url      : '/edit/:printerjobs_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/new_printerjobs/new_printerjobs.html',
						controller : 'EditPrinterjobsController as vm'
					}
				},
				resolve: {
					Printerjobs: function ($stateParams, printerjobsService)
					{
						return printerjobsService.getPrinterjobs($stateParams.printerjobs_id,'Edit');
					}
				},
				bodyClass: 'printerjobs'
			})
			.state('app.printerjobs.edit-list', {
				url      : '/edit/:printerjobs_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/new_printerjobs/new_printerjobs.html',
						controller : 'EditPrinterjobsController as vm'
					}
				},
				resolve: {
					Printerjobs: function ($stateParams, printerjobsService)
					{
						return printerjobsService.getPrinterjobs($stateParams.printerjobs_id,'Edit');
					}
				},
				bodyClass: 'printerjobs'
			})
			.state('app.printerjobs.mapping', {
				url      : '/mapping/:printerjobs_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/mapping/printerjobs_mapping.html',
						controller : 'PrinterjobsMappingController as vm'
					}
				},
				resolve: {
					PrinterjobsMapping: function ($stateParams, printerjobsService)
					{
						return printerjobsService.getPrinterMapping($stateParams.printerjobs_id);
					}
				},
				bodyClass: 'printerjobs'
			})
			.state('app.printerjobs.option', {
				url      : '/option/:printerjobs_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/printerjobs/options/printerjobs_option.html',
						controller : 'PrinterjobsOptionController as vm'
					}
				},
				resolve: {
					PrinterjobsOptions: function ($stateParams, printerjobsService)
					{
						return printerjobsService.getPrinterMapping($stateParams.printerjobs_id);
					}
				},
				bodyClass: 'printerjobs'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/printerjobs');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.printerjobsList', ['printerjobsList']);
			msApiProvider.register('app.printerjobsSave', ['printerjobsSave']);
			msApiProvider.register('app.printerjobsUpdate', ['printerjobsUpdate']);
			msApiProvider.register('app.printerjobsAdd', ['printerjobsAdd']);
			msApiProvider.register('app.printerjobsEdit', ['printerjobsEdit']);
			msApiProvider.register('app.printerjobsDel', ['printerjobsDel']);
			
			msApiProvider.register('app.printerMapping', ['printerMapping']);
			msApiProvider.register('app.savePrinterMapping', ['savePrinterMapping']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('printerjobs', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.printerjobs',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printerjobs')
        .factory('printerjobsService', printerjobsService);

    /** @ngInject */
    function printerjobsService($q, $mdToast, msApi)
    {
        var printerjobsEdit = [], printerjobsMap = [];

        var service = {
            getPrinterjobs	: getPrinterjobs,
			getPrinterMapping : getPrinterMapping,
			getPrinterOption : getPrinterOption,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPrinterjobs(printerjobs_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerjobsEdit@save', {param:{printerjobs_id:printerjobs_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'printerjobs'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						printerjobsEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(printerjobsEdit);
						printerjobsEdit['printerjobsID'] = printerjobs_id;
																							
						// Resolve the promise
						deferred.resolve(printerjobsEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getPrinterMapping(printerjobs_id)
        {						
			//alert(printerjobs_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {param:{printerjobsID:printerjobs_id},aToken:aToken,page:'printerjobs'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						printerjobsMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(printerjobsMap);
						printerjobsMap['printerjobsID'] = printerjobs_id;
																							
						// Resolve the promise
						deferred.resolve(printerjobsMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getPrinterOption(printerjobs_id)
        {						
			//alert(printerjobs_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {aToken:aToken,page:'printerjobs'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						printerjobsMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(printerjobsMap);
						printerjobsMap['printerjobsID'] = printerjobs_id;
																							
						// Resolve the promise
						deferred.resolve(printerjobsMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printerjobs')
        .controller('AddPrinterjobsController', AddPrinterjobsController);

    /** @ngInject */
    function AddPrinterjobsController($scope, $mdSidenav, Printerjobs, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Printer Jobs";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Printer Jobs" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
		vm.printersDB = Printerjobs.data;        		     				
		if(__env.isDebug) console.log(vm.printersDB);
		
		vm.branchID = vm.printersDB.branchID;
		
		//vm.printers = {printers_code:vm.printersDB.printersCode};
		vm.printerjobs = {printerjobs_name:'', printerjobs_branch_id:vm.branchID, printerjobs_type:'', printerjobs_printers_id:'', printerjobs_template:'', printerjobs_local_printer:'0', printerjobs_kdslink:''};
		
		vm.depts = vm.printersDB.departmentList;
		vm.categorys = vm.printersDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.printersDB.itemList;
		vm.mapList = vm.printersDB.mapList;
		vm.printersID = vm.printersDB.printersID;
		vm.printerMapItems = [];
		vm.templateList = vm.printersDB.templateList;
		vm.showLink = 0;
		
		/*if(vm.mapList.length > 0){
			vm.printerMapItems = vm.mapList;
		} else {
			var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_printers_id:'', print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
		}*/
		
		var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_printers_id:'', print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
		vm.printerMapItems.push(obj);
		if(__env.isDebug) console.log(vm.printerMapItems);
		
		
		vm.typelist = ['KOTs','Bills'];
		vm.statuslist = ['Active','Inactive'];
		
		//vm.printers = {printers_status : "Active"};
		
		
		// Methods
        vm.savePrinterjobs = savePrinterjobs;
		vm.gotoPrinterjobs = gotoPrinterjobs;
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
				
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoPrinterjobs()
        {
			//alert("1");
            $state.go('app.printerjobs-list');
        }

       
						
		function savePrinterjobs()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printerjobs);
			if(__env.isDebug) console.log(vm.printerMapItems);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerjobsSave@save', {param:{printers:vm.printerjobs,printerMapItems:vm.printerMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printerjobs Added Successfully').position('top right')
							);
							gotoPrinterjobs();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_printers_id:'', print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.printerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.printerMapItems.length;i++){	
				if(vm.printerMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.printerMapItems.splice(i, 1);
				}
			}
        }
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printerjobs')
        .controller('EditPrinterjobsController', EditPrinterjobsController);

    /** @ngInject */
    function EditPrinterjobsController($scope, $mdSidenav, Printerjobs, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Printer Jobs";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Printer Jobs" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.printersDB = Printerjobs;		
		if(__env.isDebug) console.log("Printerjobs Det");
		if(__env.isDebug) console.log(vm.printersDB);
		vm.branchID = vm.printersDB.branchID;
		vm.printers = vm.printersDB.printersDets;
		vm.printerjobs = vm.printersDB.printerjobsDets;
		vm.depts = vm.printersDB.departmentList;
		vm.categorys = vm.printersDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.printersDB.itemList;
		vm.mapList = vm.printersDB.mapList;
		vm.printersID = vm.printersDB.printersID;
		vm.printerMapItems = [];
		vm.templateList = vm.printersDB.templateList;
		
		vm.mapList = vm.printersDB.mapList;
		vm.printerjobsID = vm.printersDB.printerjobsID;
		if(vm.mapList.length > 0){
			vm.printerMapItems = vm.mapList;
		} else {
			var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_printers_id:vm.printerjobsID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.printerMapItems);
		
		
		vm.typelist = ['KOTs','Bills'];
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.printersDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.savePrinterjobs = savePrinterjobs;
		vm.gotoPrinterjobs = gotoPrinterjobs;	
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		vm.setLink = setLink;

		setLink();
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoPrinterjobs()
        {
			//alert("1");
            $state.go('app.printerjobs-list');
        }

        function setLink(){
        	if(__env.isDebug) console.log(__env.kdsUrl);
        	if (vm.printerjobs.printerjobs_type=='KOTs') {
        		vm.showLink = 1;
        		vm.printerjobs.printerjobs_kdslink = __env.kdsUrl+''+vm.branchID+'/'+vm.printerjobs.printerjobs_id;		
        	} else {
        		vm.showLink = 0;
        		vm.printerjobs.printerjobs_kdslink = "";
        	}    
        	if(__env.isDebug) console.log("Print Jobs");
			if(__env.isDebug) console.log(vm.printerjobs);    	
        }
								
		function savePrinterjobs()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printers);
			if(__env.isDebug) console.log(vm.printerMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerjobsUpdate@save', {param:{printers:vm.printerjobs,printerMapItems:vm.printerMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'printers'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printers Updated Successfully').position('top right')
							);
							gotoPrinterjobs();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_printers_id:vm.printerjobsID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.printerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.printerMapItems.length;i++){	
				if(vm.printerMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.printerMapItems.splice(i, 1);
				}
			}
        }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .controller('PrintersMappingController', PrintersMappingController);

    /** @ngInject */
    function PrintersMappingController($state, PrintersMapping, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Printers";
		
        // Data
        vm.itemList = PrintersMapping;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.itemList);
		//vm.roles = vm.itemList.roleList;
		vm.depts = vm.itemList.departmentList;
		vm.categorys = vm.itemList.categoryList;
		//vm.tickets = {};
		vm.items = vm.itemList.itemList;
		vm.mapList = vm.itemList.mapList;
		vm.printersID = vm.itemList.printersID;
		vm.printerMapItems = [];
		if(vm.mapList.length > 0){
			vm.printerMapItems = vm.mapList;
		} else {
			var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_printers_id:vm.printersID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.printerMapItems);
		
		if(vm.itemList.error == "1"){
			gotoLogin();
		} 
		
        // Methods
       
		vm.gotoPrinters = gotoPrinters;	
		vm.savePrintersItems = savePrintersItems;
		vm.gotoLogin = gotoLogin;			
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }				
        
		function gotoPrinters()
        {
			//alert("1");
            $state.go('app.printers-list');
        }
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_printers_id:vm.printersID, print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.printerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.printerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.printerMapItems.length;i++){	
				if(vm.printerMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.printerMapItems.splice(i, 1);
				}
			}
        }
		
		function savePrintersItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.printerMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.savePrinterMapping@save', {param:{printersID:vm.printersID,printerMapItems:vm.printerMapItems},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoPrinters();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pricing',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getPricing('Admission Page'));		
		//if(localStorage.getPricing('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.pricing', {
				url    : '/pricing',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/pricing/pricing.html',
						controller : 'PricingListController as vm'
					}
				},
				resolve: {					
					PricingList: function (msApi)
					{					
						return msApi.resolve('app.pricingList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.pricing-list', {
				url    : '/pricing',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/pricing/pricing.html',
						controller : 'PricingListController as vm'
					}
				},
				resolve: {					
					PricingList: function (msApi)
					{					
						return msApi.resolve('app.pricingList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/pricing');
			
			// Api						
			msApiProvider.register('app.pricingList', ['pricingList']);
			msApiProvider.register('app.pricingSave', ['pricingSave']);
			msApiProvider.register('app.pricingEdit', ['pricingEdit']);
			
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('pricing', {
				title : 'Pricings',
				//icon  : 'icon-account-multiple',
				state : 'app.pricing',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pricing')
        .factory('pricingService', pricingService);

    /** @ngInject */
    function pricingService($q, $mdToast, msApi)
    {
        var pricingEdit = [];

        var service = {
            getPricing	: getPricing			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPricing(pricing_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( pricingEdit.length > 0 )
            {				
                deferred.resolve(pricingEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.pricingEdit@save', {param:{pricing_id:pricing_id},aToken:aToken,page:'pricing'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							pricingEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(pricingEdit);
																								
							// Resolve the promise
							deferred.resolve(pricingEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.price-tag',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.price-tag', {
				url    : '/price-tag',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/price-tag/price-tag.html',
						controller : 'PriceTagsListController as vm'
					}
				},
				resolve: {					
					PriceTagsList: function (msApi)
					{					
						return msApi.resolve('app.price-tagList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.price-tag-list', {
				url    : '/price-tag',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/price-tag/price-tag.html',
						controller : 'PriceTagsListController as vm'
					}
				},
				resolve: {					
					PriceTagsList: function (msApi)
					{					
						return msApi.resolve('app.price-tagList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.price-tag.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/price-tag/new_price-tag/new_price-tag.html',
						controller : 'AddPriceTagsController as vm'
					}
				},
				resolve: {
					PriceTags: function (msApi)
					{
						return msApi.resolve('app.price-tagAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'price-tag'
			})
			.state('app.price-tag.edit', {
				url      : '/edit/:price_tag_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/price-tag/new_price-tag/new_price-tag.html',
						controller : 'EditPriceTagsController as vm'
					}
				},
				resolve: {
					PriceTags: function ($stateParams, price_tagService)
					{
						return price_tagService.getPriceTags($stateParams.price_tag_id,'Edit');
					}
				},
				bodyClass: 'price-tag'
			})
			.state('app.price-tag.edit-list', {
				url      : '/edit/:price_tag_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/price-tag/new_price-tag/new_price-tag.html',
						controller : 'EditPriceTagsController as vm'
					}
				},
				resolve: {
					PriceTags: function ($stateParams, price_tagService)
					{
						return clientService.getPriceTags($stateParams.price_tag_id,'Edit');
					}
				},
				bodyClass: 'price-tag'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/price-tag');
			
			// Api						
			msApiProvider.register('app.price-tagList', ['price_tagList']);
			msApiProvider.register('app.price-tagSave', ['price_tagSave']);
			msApiProvider.register('app.price-tagUpdate', ['price_tagUpdate']);
			msApiProvider.register('app.price-tagAdd', ['price_tagAdd']);
			msApiProvider.register('app.price-tagEdit', ['price_tagEdit']);
			msApiProvider.register('app.price-tagDel', ['price_tagDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('price_tag', {
				title : 'Price Tags',
				//icon  : 'icon-account-multiple',
				state : 'app.price-tag',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.price-tag')
        .factory('price_tagService', price_tagService);

    /** @ngInject */
    function price_tagService($q, $mdToast, msApi)
    {
        var price_tagEdit = [];

        var service = {
            getPriceTags	: getPriceTags			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPriceTags(price_tag_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( price_tagEdit.length > 0 )
            {				
                deferred.resolve(price_tagEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.price-tagEdit@save', {param:{price_tag_id:price_tag_id},aToken:aToken,page:'price_tag'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							price_tagEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(price_tagEdit);
																								
							// Resolve the promise
							deferred.resolve(price_tagEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.price-tag')
        .controller('AddPriceTagsController', AddPriceTagsController);

    /** @ngInject */
    function AddPriceTagsController($scope, $mdSidenav, PriceTags, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add PriceTags";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Price Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.price_tagDB = PriceTags.data;        		     				
		if(__env.isDebug) console.log(vm.price_tagDB);
		vm.branchID = vm.price_tagDB.branchID;
		
		//vm.price_tag = {price_tag_code:vm.price_tagDB.price_tagCode};
		vm.price_tag = {price_tag_name:'', price_branch_id:vm.branchID, price_tag_mobileno:'', price_tag_address:'', price_tag_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.price_tag = {price_tag_status : "Active"};
				

		// Methods
        vm.savePriceTags = savePriceTags;
		vm.gotoPriceTags = gotoPriceTags;
						
		/**
         * Go to Staff page
         */
        function gotoPriceTags()
        {
			//alert("1");
            $state.go('app.price-tag-list');
        }
						
		/**
         * Add New Staff
        **/
        function savePriceTags()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.price_tag);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.price-tagSave@save', {param:{price_tag:vm.price_tag,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'price_tag'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('PriceTags Added Successfully').position('top right')
						);
						gotoPriceTags();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.price-tag')
        .controller('EditPriceTagsController', EditPriceTagsController);

    /** @ngInject */
    function EditPriceTagsController($scope, $mdSidenav, PriceTags, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit PriceTags";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Price Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.price_tagDB = PriceTags;
		vm.price_tag = vm.price_tagDB.price_tagDets;
		if(__env.isDebug) console.log("PriceTags Det");
		if(__env.isDebug) console.log(vm.price_tagDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.price_tagDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.savePriceTags = savePriceTags;
		vm.gotoPriceTags = gotoPriceTags;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoPriceTags()
        {
			//alert("1");
            $state.go('app.price-tag-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function savePriceTags()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.price_tag);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.price-tagUpdate@save', {param:{price_tag:vm.price_tag,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'price_tag'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('PriceTags Updated Successfully').position('top right')
						);
						gotoPriceTags();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.ordertagoption',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.ordertagoption', {
				url    : '/ordertagoption/:order_tag_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/ordertagoption/ordertagoption.html',
						controller : 'OrdertagoptionsListController as vm'
					}
				},
				resolve: {
					OrderTagOptions: function ($stateParams, ordertagoptionService)
					{
						return ordertagoptionService.getOrdertagoptionslist($stateParams.order_tag_id);
					}
				},				
			})
			.state('app.ordertagoption-list', {
				url    : '/ordertagoption/:order_tag_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/ordertagoption/ordertagoption.html',
						controller : 'OrdertagoptionsListController as vm'
					}
				},
				resolve: {
					OrderTagOptions: function ($stateParams, ordertagoptionService)
					{
						return ordertagoptionService.getOrdertagoptionslist($stateParams.order_tag_id);
					}
				}
			})	
			.state('app.ordertagoption.add', {
				url      : '/add/:ordertagoption_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ordertagoption/new_ordertagoption/new_ordertagoption.html',
						controller : 'AddOrdertagoptionsController as vm'
					}
				},
				resolve: {
					OrderOption: function ($stateParams)
					{
						return $stateParams.ordertagoption_id;
					}
				},
				bodyClass: 'ordertagoption'
			})
			.state('app.ordertagoption.edit', {
				url      : '/edit/:ordertagoption_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ordertagoption/new_ordertagoption/new_ordertagoption.html',
						controller : 'EditOrdertagoptionsController as vm'
					}
				},
				resolve: {
					Ordertagoptions: function ($stateParams, ordertagoptionService)
					{
						return ordertagoptionService.getOrdertagoptions($stateParams.ordertagoption_id,'Edit');
					}
				},
				bodyClass: 'ordertagoption'
			})
			.state('app.ordertagoption.edit-list', {
				url      : '/edit/:ordertagoption_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ordertagoption/new_ordertagoption/new_ordertagoption.html',
						controller : 'EditOrdertagoptionsController as vm'
					}
				},
				resolve: {
					Ordertagoptions: function ($stateParams, ordertagoptionService)
					{
						return ordertagoptionService.getOrdertagoptions($stateParams.ordertagoption_id,'Edit');
					}
				},
				bodyClass: 'ordertagoption'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/ordertagoption');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.ordertagoptionList', ['ordertagoptionList']);
			msApiProvider.register('app.ordertagoptionSave', ['ordertagoptionSave']);
			msApiProvider.register('app.ordertagoptionUpdate', ['ordertagoptionUpdate']);
			msApiProvider.register('app.ordertagoptionAdd', ['ordertagoptionAdd']);
			msApiProvider.register('app.ordertagoptionEdit', ['ordertagoptionEdit']);
			msApiProvider.register('app.ordertagoptionDel', ['ordertagoptionDel']);			
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('ordertagoption', {
				title : 'Ordertagoption',
				//icon  : 'icon-account-multiple',
				state : 'app.ordertagoption',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ordertagoption')
        .factory('ordertagoptionService', ordertagoptionService);

    /** @ngInject */
    function ordertagoptionService($q, $mdToast, msApi)
    {
        var ordertagoptionEdit = [];

        var service = {
            getOrdertagoptions	: getOrdertagoptions,
			getOrdertagoptionslist : getOrdertagoptionslist,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getOrdertagoptionslist(order_tag_id)
        {						
			//alert(order_tag_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ordertagoptionList@save', {param:{order_tag_id:order_tag_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'ordertagoption'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						ordertagoptionEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(ordertagoptionEdit);																	
						// Resolve the promise
						deferred.resolve(ordertagoptionEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getOrdertagoptions(ordertagoption_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ordertagoptionEdit@save', {param:{ordertagoption_id:ordertagoption_id},aToken:aToken,page:'ordertagoption'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						ordertagoptionEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(ordertagoptionEdit);
																							
						// Resolve the promise
						deferred.resolve(ordertagoptionEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ordertagoption')
        .controller('AddOrdertagoptionsController', AddOrdertagoptionsController);

    /** @ngInject */
    function AddOrdertagoptionsController($scope, $mdSidenav, OrderTagOptions, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Ordertagoption";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Order Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.orderOption = OrderTagOptions;        		     				
		if(__env.isDebug) console.log("List");
		if(__env.isDebug) console.log(vm.orderOption);
		vm.branchID = localStorage.getItem('BranchID');
				
		vm.ordertagoption = {ordertagoption_order_tag_id:vm.orderOption.order_tag_id, ordertagoption_branch_id:vm.branchID, ordertagoption_name:'', ordertagoption_rate:''};		
		if(__env.isDebug) console.log(vm.ordertagoption);
		
		vm.statuslist = ['Active','Inactive'];
		//vm.ordertagoption = {ordertagoption_status : "Active"};
		
		
		// Methods
        vm.saveOrdertagoptions = saveOrdertagoptions;
		vm.gotoOrdertagoptions = gotoOrdertagoptions;
		vm.gotoLogin = gotoLogin;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoOrdertagoptions()
        {
			//alert(vm.orderOption.order_tag_id);
            $state.go('app.ordertagoption-list',{order_tag_id: vm.orderOption.order_tag_id});
        }
						
		function saveOrdertagoptions()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.ordertagoption);			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ordertagoptionSave@save', {param:{ordertagoption:vm.ordertagoption,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'ordertagoption'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Order Tag Option Added Successfully').position('top right')
						);
						gotoOrdertagoptions();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }						
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ordertagoption')
        .controller('EditOrdertagoptionsController', EditOrdertagoptionsController);

    /** @ngInject */
    function EditOrdertagoptionsController($scope, $mdSidenav, Ordertagoptions, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Ordertagoption";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Order Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.ordertagoptionDB = Ordertagoptions;
		vm.ordertagoption = vm.ordertagoptionDB.ordertagoptionDets;
		if(__env.isDebug) console.log("Ordertagoptions Det");
		if(__env.isDebug) console.log(vm.ordertagoptionDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.ordertagoptionDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveOrdertagoptions = saveOrdertagoptions;
		vm.gotoOrdertagoptions = gotoOrdertagoptions;	
		vm.gotoLogin = gotoLogin;	
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoOrdertagoptions()
        {
			//alert("1");
            $state.go('app.ordertagoption',{order_tag_id: vm.ordertagoptionDB.ordertagoptionDets.ordertagoption_order_tag_id});
        }
								
		function saveOrdertagoptions()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.ordertagoption);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ordertagoptionUpdate@save', {param:{ordertagoption:vm.ordertagoption,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'ordertagoption'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Order Tag Option Updated Successfully').position('top right')
						);
						gotoOrdertagoptions();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.order-tag',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.order-tag', {
				url    : '/order-tag',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/order-tag.html',
						controller : 'OrderTagListController as vm'
					}
				},
				resolve: {					
					OrderTagList: function (msApi)
					{					
						return msApi.resolve('app.orderTagList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.order-tag-list', {
				url    : '/order-tag',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/order-tag.html',
						controller : 'OrderTagListController as vm'
					}
				},
				resolve: {					
					OrderTagList: function (msApi)
					{					
						return msApi.resolve('app.orderTagList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.order-tag.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/new_order-tag/new_order-tag.html',
						controller : 'AddOrderTagController as vm'
					}
				},
				resolve: {
					OrderTag: function (msApi)
					{
						return msApi.resolve('app.orderTagAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'order-tag'
			})
			.state('app.order-tag.edit', {
				url      : '/edit/:order_tag_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/new_order-tag/new_order-tag.html',
						controller : 'EditOrderTagController as vm'
					}
				},
				resolve: {
					OrderTag: function ($stateParams, orderTagService)
					{
						return orderTagService.getOrderTag($stateParams.order_tag_id,'Edit');
					}
				},
				bodyClass: 'order-tag'
			})
			.state('app.order-tag.edit-list', {
				url      : '/edit/:order_tag_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/new_order-tag/new_order-tag.html',
						controller : 'EditOrderTagController as vm'
					}
				},
				resolve: {
					OrderTag: function ($stateParams, orderTagService)
					{
						return orderTagService.getOrderTag($stateParams.order_tag_id,'Edit');
					}
				},
				bodyClass: 'order-tag'
			})
			.state('app.order-tag.mapping', {
				url      : '/mapping/:order_tag_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/mapping/order_tag_mapping.html',
						controller : 'OrderTagMappingController as vm'
					}
				},
				resolve: {
					OrderTagMapping: function ($stateParams, orderTagService)
					{
						return orderTagService.getOrderMapping($stateParams.order_tag_id);
					}
				},
				bodyClass: 'order-tag'
			})
			.state('app.order-tag.option', {
				url      : '/option/:order_tag_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/order-tag/options/order_tag_option.html',
						controller : 'OrderTagOptionController as vm'
					}
				},
				resolve: {
					OrderTagOptions: function ($stateParams, orderTagService)
					{
						return orderTagService.getOrderMapping($stateParams.order_tag_id);
					}
				},
				bodyClass: 'order-tag'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/order-tag');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.orderTagList', ['orderTagList']);
			msApiProvider.register('app.orderTagSave', ['orderTagSave']);
			msApiProvider.register('app.orderTagUpdate', ['orderTagUpdate']);
			msApiProvider.register('app.orderTagAdd', ['orderTagAdd']);
			msApiProvider.register('app.orderTagEdit', ['orderTagEdit']);
			msApiProvider.register('app.orderTagDel', ['orderTagDel']);
			
			msApiProvider.register('app.orderMapping', ['orderMapping']);
			msApiProvider.register('app.saveOrderMapping', ['saveOrderMapping']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('order-tag', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.order-tag',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.order-tag')
        .factory('orderTagService', orderTagService);

    /** @ngInject */
    function orderTagService($q, $mdToast, msApi)
    {
        var orderTagEdit = [], orderTagMap = [];

        var service = {
            getOrderTag	: getOrderTag,
			getOrderMapping : getOrderMapping,
			getOrderOption : getOrderOption,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getOrderTag(order_tag_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.orderTagEdit@save', {param:{order_tag_id:order_tag_id},aToken:aToken,page:'order-tag'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						orderTagEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(orderTagEdit);
																							
						// Resolve the promise
						deferred.resolve(orderTagEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getOrderMapping(order_tag_id)
        {						
			//alert(order_tag_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.orderMapping@save', {branchID:localStorage.getItem('BranchID'),aToken:aToken,page:'order-tag'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						orderTagMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(orderTagMap);
						orderTagMap['orderTagID'] = order_tag_id;
																							
						// Resolve the promise
						deferred.resolve(orderTagMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getOrderOption(order_tag_id)
        {						
			//alert(order_tag_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.orderMapping@save', {aToken:aToken,page:'order-tag'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						orderTagMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(orderTagMap);
						orderTagMap['orderTagID'] = order_tag_id;
																							
						// Resolve the promise
						deferred.resolve(orderTagMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.order-tag')
        .controller('AddOrderTagController', AddOrderTagController);

    /** @ngInject */
    function AddOrderTagController($scope, $mdSidenav, OrderTag, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Branch";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Order Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.orderTagDB = OrderTag.data;        		     				
		if(__env.isDebug) console.log(vm.orderTagDB);	
		vm.branchID = vm.orderTagDB.branchID;
		
		//vm.orderTag = {order-tag_code:vm.order-tagDB.order-tagCode};
		vm.orderTag = {order_tag_name:'', order_tag_branch_id:vm.branchID, order_tag_addprice:'', order_tag_taxfree:'',  order_tag_freetaging:'', order_tag_savetags:'', order_tag_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.order-tag = {order-tag_status : "Active"};
		
		
		// Methods
        vm.saveOrderTag = saveOrderTag;
		vm.gotoOrderTag = gotoOrderTag;
		vm.gotoLogin = gotoLogin;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoOrderTag()
        {
			//alert("1");
            $state.go('app.order-tag-list');
        }
						
		function saveOrderTag()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.orderTag);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.orderTagSave@save', {param:{orderTag:vm.orderTag,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'order-tag'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('OrderTag Added Successfully').position('top right')
							);
							gotoOrderTag();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }						
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.order-tag')
        .controller('EditOrderTagController', EditOrderTagController);

    /** @ngInject */
    function EditOrderTagController($scope, $mdSidenav, OrderTag, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Branch";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Order Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.orderTagDB = OrderTag;		
		if(__env.isDebug) console.log("OrderTag Det");
		if(__env.isDebug) console.log(vm.orderTagDB);
		vm.orderTag = vm.orderTagDB.orderTagDets;
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.orderTagDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveOrderTag = saveOrderTag;
		vm.gotoOrderTag = gotoOrderTag;	
		vm.gotoLogin = gotoLogin;	
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoOrderTag()
        {
			//alert("1");
            $state.go('app.order-tag-list');
        }
								
		function saveOrderTag()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.orderTag);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.orderTagUpdate@save', {param:{orderTag:vm.orderTag,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'order-tag'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('OrderTag Updated Successfully').position('top right')
							);
							gotoOrderTag();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.order-tag')
        .controller('OrderTagMappingController', OrderTagMappingController);

    /** @ngInject */
    function OrderTagMappingController($state, OrderTagMapping, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "OrderTags";
		
        // Data
        vm.itemList = OrderTagMapping;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.itemList);
		
		vm.branchID = vm.itemList.branchID;
		vm.roles = vm.itemList.roleList;
		vm.depts = vm.itemList.departmentList;
		vm.categorys = vm.itemList.categoryList;
		vm.tickets = {};
		vm.items = vm.itemList.itemList;
		vm.orderTagID = vm.itemList.orderTagID;
		vm.orderTagItems = [];
        var obj ={order_tag_items_id:Math.floor(Math.random()*1000), order_tag_branch_id:vm.branchID, order_tag_items_order_tag_id:vm.orderTagID, order_tag_role_id:0, order_tag_dept_id:0, order_tag_ticket_id:0, order_tag_category_id:0, order_tag_item_id:0};
		vm.orderTagItems.push(obj);
		if(__env.isDebug) console.log(vm.orderTagItems);
		
		if(vm.itemList.error == "1"){
			gotoLogin();
		} 
		
        // Methods
       
		vm.gotoOrderTags = gotoOrderTags;	
		vm.saveOrderTageItems = saveOrderTageItems;
		vm.gotoLogin = gotoLogin;			
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }				
        
		function gotoOrderTags()
        {
			//alert("1");
            $state.go('app.order-tag-list');
        }
		
		function addRow()
        {
			 var obj ={order_tag_items_id:Math.floor(Math.random()*1000), order_tag_items_order_tag_id:vm.orderTagID, order_tag_role_id:0, order_tag_dept_id:0, order_tag_ticket_id:0, order_tag_category_id:0, order_tag_item_id:0};
			vm.orderTagItems.push(obj);
			if(__env.isDebug) console.log(vm.orderTagItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.orderTagItems.length;i++){	
				if(vm.orderTagItems[i].order_tag_items_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.kotItems.splice(i, 1);
				}
			}
        }
		
		function saveOrderTageItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.orderTagItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			/*var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.catItemSave@save', {param:{orderTagItems:vm.orderTagItems},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoOrderTags();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}*/
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.opening-stock-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.opening-stock-report', {
				url    : '/opening-stock-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/opening-stock-report/opening-stock-report.html',
						controller : 'OpeningStockReportController as vm'
					}
				},
				resolve: {					
					ItemReportList: function (msApi)
					{					
						return msApi.resolve('app.openingstockReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.opening-stock-report-list', {
				url    : '/opening-stock-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/opening-stock-report/opening-stock-report.html',
						controller : 'OpeningStockReportController as vm'
					}
				},
				resolve: {					
					ItemReportList: function ($stateParams, openingstockreportService)
					{
						
						return openingstockreportService.getItemOpeningList($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/opening-stock-report');
			
			// Api						
			msApiProvider.register('app.openingstockReportList', ['openingstockReportList']);
			msApiProvider.register('app.openingstockReportList2', ['openingstockReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.opening-stock-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.opening-stock-report')
        .factory('openingstockreportService', openingstockreportService);

    /** @ngInject */
    function openingstockreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getItemOpeningList : getItemOpeningList
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getItemOpeningList(openingstockDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.openingstockReportList2@save', {param:{openingstockDets:openingstockDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.offer',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.offer', {
				url    : '/offer',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/offer/offer.html',
						controller : 'OfferListController as vm'
					}
				},
				resolve: {					
					OfferList: function (msApi)
					{					
						return msApi.resolve('app.offerList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.offer-list', {
				url    : '/offer',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/offer/offer.html',
						controller : 'OfferListController as vm'
					}
				},
				resolve: {					
					OfferList: function (msApi)
					{					
						return msApi.resolve('app.offerList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.offer.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/offer/new_offer/new_offer.html',
						controller : 'AddOfferController as vm'
					}
				},
				resolve: {
					Offer: function (msApi)
					{
						return msApi.resolve('app.offerAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'offer'
			})
			.state('app.offer.edit', {
				url      : '/edit/:offer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/offer/new_offer/new_offer.html',
						controller : 'EditOfferController as vm'
					}
				},
				resolve: {
					Offer: function ($stateParams, offerService)
					{
						return offerService.getOffer($stateParams.offer_id,'Edit');
					}
				},
				bodyClass: 'offer'
			})
			.state('app.offer.edit-list', {
				url      : '/edit/:offer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/offer/new_offer/new_offer.html',
						controller : 'EditOfferController as vm'
					}
				},
				resolve: {
					Offer: function ($stateParams, offerService)
					{
						return offerService.getOffer($stateParams.offer_id,'Edit');
					}
				},
				bodyClass: 'offer'
			})
			.state('app.offer.mapping', {
				url      : '/mapping/:offer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/offer/mapping/offer_mapping.html',
						controller : 'OfferMappingController as vm'
					}
				},
				resolve: {
					OfferMapping: function ($stateParams, offerService)
					{
						return offerService.getPrinterMapping($stateParams.offer_id);
					}
				},
				bodyClass: 'offer'
			})
			.state('app.offer.option', {
				url      : '/option/:offer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/offer/options/offer_option.html',
						controller : 'OfferOptionController as vm'
					}
				},
				resolve: {
					OfferOptions: function ($stateParams, offerService)
					{
						return offerService.getPrinterMapping($stateParams.offer_id);
					}
				},
				bodyClass: 'offer'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/offer');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.offerList', ['offerList']);
			msApiProvider.register('app.offerSave', ['offerSave']);
			msApiProvider.register('app.offerUpdate', ['offerUpdate']);
			msApiProvider.register('app.offerAdd', ['offerAdd']);
			msApiProvider.register('app.offerEdit', ['offerEdit']);
			msApiProvider.register('app.offerDel', ['offerDel']);
			
			msApiProvider.register('app.printerMapping', ['printerMapping']);
			msApiProvider.register('app.savePrinterMapping', ['savePrinterMapping']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('offer', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.offer',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.offer')
        .factory('offerService', offerService);

    /** @ngInject */
    function offerService($q, $mdToast, msApi)
    {
        var offerEdit = [], offerMap = [];

        var service = {
            getOffer	: getOffer,
			getPrinterMapping : getPrinterMapping,
			getPrinterOption : getPrinterOption,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getOffer(offer_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.offerEdit@save', {param:{offer_id:offer_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'offer'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						offerEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(offerEdit);
						offerEdit['offerID'] = offer_id;
																							
						// Resolve the promise
						deferred.resolve(offerEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getPrinterMapping(offer_id)
        {						
			//alert(offer_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {param:{offerID:offer_id},aToken:aToken,page:'offer'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						offerMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(offerMap);
						offerMap['offerID'] = offer_id;
																							
						// Resolve the promise
						deferred.resolve(offerMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getPrinterOption(offer_id)
        {						
			//alert(offer_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {aToken:aToken,page:'offer'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						offerMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(offerMap);
						offerMap['offerID'] = offer_id;
																							
						// Resolve the promise
						deferred.resolve(offerMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.offer')
        .controller('AddOfferController', AddOfferController);

    /** @ngInject */
    function AddOfferController($scope, $mdSidenav, Offer, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Offer";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Offer Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.offerDB = Offer.data;        		     				
		if(__env.isDebug) console.log(vm.offerDB);
		
		vm.branchID = vm.offerDB.branchID;
		
		//vm.offer = {offer_code:vm.offerDB.offerCode};
		vm.offer = {offer_name:'', offer_branch_id:vm.branchID, offer_type:'Per', offer_rate:'', offer_from:'', offer_to:'', offer_status:'Active'};
		
		vm.depts = vm.offerDB.departmentList;
		vm.categorys = vm.offerDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.offerDB.itemList;
		
		
		vm.offerMapItems = [];
		var obj ={offer_map_id:Math.floor(Math.random()*1000), offer_map_branch_id:vm.branchID, offer_map_offer_id:'', offer_map_department_id:0, offer_map_category_id:0, offer_map_item_id:0};
		vm.offerMapItems.push(obj);
		if(__env.isDebug) console.log(vm.offerMapItems);
		
		
		vm.typelist = ['Percentage','Amount'];
		vm.statuslist = ['Active','Inactive'];
		
		
		
		// Methods
        vm.saveOffer = saveOffer;
		vm.gotoOffer = gotoOffer;
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoOffer()
        {
			//alert("1");
            $state.go('app.offer-list');
        }
						
		function saveOffer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.offer);
			if(__env.isDebug) console.log(vm.offerMapItems);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.offerSave@save', {param:{offer:vm.offer,offerMapItems:vm.offerMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'offer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Offer Added Successfully').position('top right')
							);
							gotoOffer();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_offer_id:'', print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.offerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.offerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.offerMapItems.length;i++){	
				if(vm.offerMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.offerMapItems.splice(i, 1);
				}
			}
        }
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.offer')
        .controller('EditOfferController', EditOfferController);

    /** @ngInject */
    function EditOfferController($scope, $mdSidenav, Offer, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Offer";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Offer Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.offerDB = Offer;		
		if(__env.isDebug) console.log("Offer Det");
		if(__env.isDebug) console.log(vm.offerDB);
		vm.branchID = vm.offerDB.branchID;
		vm.offer = vm.offerDB.offerDets;
		vm.depts = vm.offerDB.departmentList;
		vm.categorys = vm.offerDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.offerDB.itemList;
		vm.mapList = vm.offerDB.mapList;
		vm.offerID = vm.offerDB.offerID;
		vm.offerMapItems = [];
		
		vm.mapList = vm.offerDB.mapList;
		vm.offerID = vm.offerDB.offerID;
		if(vm.mapList.length > 0){
			vm.offerMapItems = vm.mapList;
		} else {
			var obj ={offer_map_id:Math.floor(Math.random()*1000), offer_map_branch_id:vm.branchID, offer_map_offer_id:vm.offerID, offer_map_department_id:0, offer_map_category_id:0, offer_map_item_id:0};
			vm.offerMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.offerMapItems);
		
		
		vm.typelist = ['Percentage','Amount'];
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.offerDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveOffer = saveOffer;
		vm.gotoOffer = gotoOffer;	
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoOffer()
        {
			//alert("1");
            $state.go('app.offer-list');
        }
								
		function saveOffer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.offer);
			if(__env.isDebug) console.log(vm.offerMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.offerUpdate@save', {param:{offer:vm.offer,offerMapItems:vm.offerMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'offer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printers Updated Successfully').position('top right')
							);
							gotoOffer();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={offer_map_id:Math.floor(Math.random()*1000), offer_map_branch_id:vm.branchID, offer_map_offer_id:vm.offerID, offer_map_department_id:0, offer_map_category_id:0, offer_map_item_id:0};
			vm.offerMapItems.push(obj);
			if(__env.isDebug) console.log(vm.offerMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.offerMapItems.length;i++){	
				if(vm.offerMapItems[i].offer_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.offerMapItems.splice(i, 1);
				}
			}
        }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.kot-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.kot-report', {
				url    : '/kot-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/kot-report/kot-report.html',
						controller : 'KotReportController as vm'
					}
				},
				resolve: {					
					KotReportList: function (msApi)
					{					
						return msApi.resolve('app.kotReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.kot-report-list', {
				url    : '/kot-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/kot-report/kot-report.html',
						controller : 'KotReportController as vm'
					}
				},
				resolve: {					
					KotReportList: function ($stateParams, kotreportService)
					{
						
						return kotreportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/kot-report');
			
			// Api						
			msApiProvider.register('app.kotReportList', ['kotReportList']);
			msApiProvider.register('app.kotReportList2', ['kotReportList2']);
			msApiProvider.register('app.kot-reportSave', ['kot-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('kot-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.kot-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.kot-report')
        .factory('kotreportService', kotreportService);

    /** @ngInject */
    function kotreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(salesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.salesReportList2@save', {param:{salesDets:salesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'kot-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item-stock-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.item-stock-report', {
				url    : '/item-stock-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item-stock-report/item-stock-report.html',
						controller : 'ItemStockReportController as vm'
					}
				},
				resolve: {					
					ItemStockReportList: function (msApi)
					{					
						return msApi.resolve('app.itemstockReportList@get',{branchID:localStorage.getItem('BranchID'),periodID:localStorage.getItem('periodID')});
					}, 
				}
			})
			.state('app.item-stock-report-list', {
				url    : '/item-stock-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item-stock-report/item-stock-report.html',
						controller : 'ItemStockReportController as vm'
					}
				},
				resolve: {					
					ItemStockReportList: function ($stateParams, itemstockreportService)
					{
						
						return msApi.resolve('app.itemstockReportList@get',{branchID:localStorage.getItem('BranchID'),periodID:localStorage.getItem('periodID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/item-stock-report');
			
			// Api						
			msApiProvider.register('app.itemstockReportList', ['itemstockReportList']);
			msApiProvider.register('app.itemstockReportList2', ['itemstockReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.item-stock-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item-stock-report')
        .factory('itemstockreportService', itemstockreportService);

    /** @ngInject */
    function itemstockreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(itemstockDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.itemstockReportList2@save', {param:{itemstockDets:itemstockDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'item-stock-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.item-report', {
				url    : '/item-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item-report/item-report.html',
						controller : 'ItemReportController as vm'
					}
				},
				resolve: {					
					ItemReportList: function (msApi)
					{					
						return msApi.resolve('app.itemReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.item-report-list', {
				url    : '/item-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item-report/item-report.html',
						controller : 'ItemReportController as vm'
					}
				},
				resolve: {					
					ItemReportList: function ($stateParams, itemreportService)
					{
						
						return itemreportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/item-report');
			
			// Api						
			msApiProvider.register('app.itemReportList', ['itemReportList']);
			msApiProvider.register('app.itemReportList2', ['itemReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.item-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item-report')
        .factory('itemreportService', itemreportService);

    /** @ngInject */
    function itemreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(itemDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.itemReportList2@save', {param:{itemDets:itemDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'item-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.item', {
				url    : '/item',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item/item.html',
						controller : 'ItemListController as vm'
					}
				},
				resolve: {					
					ItemList: function (msApi)
					{					
						return msApi.resolve('app.itemList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.item-list', {
				url    : '/item',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item/item.html',
						controller : 'ItemListController as vm'
					}
				},
				resolve: {					
					ItemList: function (msApi)
					{					
						return msApi.resolve('app.itemList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.item.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/item/new_item/new_item.html',
						controller : 'AddItemController as vm'
					}
				},
				resolve: {
					Item: function (msApi)
					{
						return msApi.resolve('app.itemAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'item'
			})
			.state('app.item.edit', {
				url      : '/edit/:itmlist_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/item/new_item/new_item.html',
						controller : 'EditItemController as vm'
					}
				},
				resolve: {
					Item: function ($stateParams, itemService)
					{
						return itemService.getItem($stateParams.itmlist_id,'Edit');
					}
				},
				bodyClass: 'item'
			})
			.state('app.item.edit-list', {
				url      : '/edit/:itmlist_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/item/new_item/new_item.html',
						controller : 'EditItemController as vm'
					}
				},
				resolve: {
					Item: function ($stateParams, itemService)
					{
						return itemService.getItem($stateParams.itmlist_id,'Edit');
					}
				},
				bodyClass: 'item'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/item');
			
			// Api						
			msApiProvider.register('app.itemList', ['itemList']);
			msApiProvider.register('app.itemSave', ['itemSave']);
			msApiProvider.register('app.itemUpdate', ['itemUpdate']);
			msApiProvider.register('app.itemAdd', ['itemAdd']);
			msApiProvider.register('app.itemEdit', ['itemEdit']);
			msApiProvider.register('app.itemDel', ['itemDel']);
			
			msApiProvider.register('app.saveItems', ['saveItems']);
			
			msApiProvider.register('app.uploadItemImages', ['uploadItemImages']);
			msApiProvider.register('app.removeItemImage', ['removeItemImage']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('item', {
				title : 'Items',
				//icon  : 'icon-account-multiple',
				state : 'app.item',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item')
        .factory('itemService', itemService);

    /** @ngInject */
    function itemService($q, $mdToast, msApi)
    {
        var itemEdit = [];

        var service = {
            getItem	: getItem			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getItem(itmlist_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( itemEdit.length > 0 )
            {				
                deferred.resolve(itemEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.itemEdit@save', {param:{itmlist_id:itmlist_id, branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'item'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							itemEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(itemEdit);
																								
							// Resolve the promise
							deferred.resolve(itemEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item')
        .controller('AddItemController', AddItemController);

    /** @ngInject */
    function AddItemController($scope, $mdSidenav, Item, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Item";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
		vm.itemDB = Item.data;        		     				
		if(__env.isDebug) console.log(vm.itemDB);	
		vm.branchID = vm.itemDB.branchID;
		vm.unitsList = vm.itemDB.unitsList;
		//vm.item = {itemlist_code:vm.itemDB.itemCode};
		vm.item = {itemlist_name:'', itemlist_isoption:1, itemlist_image:'', itemlist_type:'', itemlist_code:'', itemlist_barcode:'', itemlist_unit_id:'', itemlist_is_inventory:'', itemlist_reorder_min_level:'', itemlist_reorder_max_level:'', itemlist_currqty:0};
		
		vm.statuslist = ['Veg','Non-Veg','Egg Only'];
		//vm.item = {itemlist_status : "Active"};
		
		vm.optionsList = [];		
		vm.option = {itmlist_option_id:'1', itmlist_option_itemlist_id:'', itmlist_option_name:'Normal', itmlist_option_order:'1'};
		vm.optionsList.push(vm.option);		
		if(__env.isDebug) console.log(vm.optionsList);
		
		
		vm.files=[];
		
		if(vm.item.itemlist_image!=''){											
			vm.files = {img_id : vm.item.itemlist_id, image : vm.item.itemlist_image, url : __env.imagePath+'/items/'+vm.item.itemlist_image};
		}
		if(__env.isDebug) console.log(vm.files);

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   	: __env.apiUrl+'uploadItemImages',
             chunkSize                	: 15 * 1024 * 1024,
             maxChunkRetries          	: 1,
             simultaneousUploads      	: 1,
             testChunks               	: false,
			 permanentErrors			: [404, 500, 501],
             progressCallbacksInterval	: 1000
        };
		
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
		

		// Methods
        vm.saveItem = saveItem;
		vm.gotoItem = gotoItem;
		vm.removeOption = removeOption;
		vm.addOption = addOption;
		
		
		vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
		vm.progress = progress;
		vm.fileError = fileError;
		vm.fileError2 = fileError2;
		
						
		/**
         * Go to Staff page
         */
        function gotoItem()
        {
			//alert("1");
            $state.go('app.item-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveItem()
        {
			if(__env.isDebug) console.log("Save Data");			
			if(__env.isDebug) console.log(vm.item);
			if(__env.isDebug) console.log(vm.optionsList);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				 msApi.request('app.itemSave@save', {param:{item:vm.item,options:vm.optionsList,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'item'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Item Added Successfully').position('top right')
						);
						gotoItem();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function removeOption(param){
			//alert(param);
			for(var i=0;i<vm.optionsList.length;i++){
				//alert(vm.salesItems[i].prod_qty);
				if(vm.optionsList[i].ccontact_id == param){
					vm.optionsList.splice(i, 1);	
				}
			}			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.optionsList);
		}
		
		function addOption(){
			var ind = vm.optionsList.length;	
			if(ind>0){
				vm.item.itemlist_isoption = 1;
			} 
			vm.option = {itmlist_option_id:ind+1,itmlist_option_itemlist_id:'',itmlist_option_name:'',itmlist_option_order:''};
			vm.optionsList.push(vm.option);		
			if(__env.isDebug) console.log(vm.optionsList);			
		}
		
		
		/** Upload Part Start **/
		
		function progress(file, flow){
			if(__env.isDebug) console.log("progess");
			if(__env.isDebug) console.log(file);			
			if(__env.isDebug) console.log(flow);
		}
		
		function fileError(file, message, flow){
			if(__env.isDebug) console.log("fileError");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log(message);
			if(__env.isDebug) console.log(flow);
		}
		
		function fileError2(file, message, flow){
			if(__env.isDebug) console.log("fileError2");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log(message);
			if(__env.isDebug) console.log(flow);
		}

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
			//vm.files = [];	
			/*if(__env.isDebug) console.log("fileAdded");
			if(__env.isDebug) console.log("Message");
			if(__env.isDebug) console.log(message);*/
            // Prepare the temp file data for file list
            var uploadingFile = {
                id       : file.uniqueIdentifier,                
               	name     : '1234567890', 
			   	type     : '',				
				url      : ''
            };
			//if(__env.isDebug) console.log(uploadingFile);

            // Append it to the file list
            //vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload(file, message)
        {
			/*if(__env.isDebug) console.log("upload");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log("Message");
			if(__env.isDebug) console.log(message);*/
			
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
			/*alert("2");
			if(__env.isDebug) console.log("upload end");
			if(__env.isDebug) console.log(vm.ngFlow);*/
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
			//alert("3");
			if(__env.isDebug) console.log("fileSuccess");
			if(__env.isDebug) console.log("file");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log("Message");
			if(__env.isDebug) console.log(message);
			
			
			if(message!=null){
				$mdToast.show(
					$mdToast.simple().textContent('Gallery image Added').position('top right')
				);
			}
			
			//vm.files=[];			 
			vm.files = {img_id : vm.item.itemlist_id, image : message, url : __env.imagePath+'/items/'+message};
			if(__env.isDebug) console.log(vm.files);
			//editGalleryImage(message);
			vm.item.itemlist_image = message;
			if(__env.isDebug) console.log(vm.item);
        }
		
		function removeImage(image)
        {
			if(__env.isDebug) console.log("Remove Image Data");
			if(__env.isDebug) console.log(vm.files);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
			  msApi.request('app.removeItemImage@save', {param:{image:vm.files,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'item'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);												 
						vm.files = {img_id : vm.files.img_id, image : '', url : ''};						
						if(__env.isDebug) console.log(vm.files);
						
						$mdToast.show(
							$mdToast.simple().textContent('Image Removed').position('top right')
						);											
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
						
		
		/** Upload Part End **/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item')
        .controller('EditItemController', EditItemController);

    /** @ngInject */
    function EditItemController($scope, $mdSidenav, Item, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Item";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.itemDB = Item;
		vm.item = vm.itemDB.itemDets;
		vm.unitsList = vm.itemDB.unitsList;

		if(__env.isDebug) console.log("Item Det");
		if(__env.isDebug) console.log(vm.itemDB);
		
		vm.optionsList = vm.itemDB.optionDets;		
		if(vm.optionsList.length==0){
			vm.option = {itmlist_option_id:1,itmlist_option_itemlist_id:vm.item.itemlist_id,itmlist_option_name:'Normal',itmlist_option_order:'1'};
			vm.optionsList.push(vm.option);		
		}
		if(__env.isDebug) console.log(vm.optionsList);
		
		vm.statuslist = ['Veg','Non-Veg','Egg Only'];
		
		if(vm.itemDB.error == "1"){
			gotoLogin();
		} 
		
		vm.files=[];
		if(vm.item.itemlist_image!=""){											
			vm.files = {img_id : vm.item.itemlist_id, image : vm.item.itemlist_image, url : __env.imagePath+'/items/'+vm.item.itemlist_image};
		}
		if(__env.isDebug) console.log(vm.files);

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   	: __env.apiUrl+'uploadItemImages',
             chunkSize                	: 15 * 1024 * 1024,
             maxChunkRetries          	: 1,
             simultaneousUploads      	: 1,
             testChunks               	: false,
			 permanentErrors			: [404, 500, 501],
             progressCallbacksInterval	: 1000
        };
		
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
								
              
		// Methods
        vm.saveItem = saveItem;
		vm.gotoItem = gotoItem;	
		vm.gotoStaffEdit = gotoStaffEdit;	
		//if(__env.isDebug) console.log(vm.studentList);
		vm.gotoLogin = gotoLogin;
		vm.removeOption = removeOption;
		vm.addOption = addOption;
		
		vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
		vm.progress = progress;
		vm.fileError = fileError;
		vm.fileError2 = fileError2;
		vm.removeImage = removeImage;
		
				
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoItem()
        {
			//alert("1");
            $state.go('app.item-list');
        }
		
		function gotoStaffEdit(staff_id)
        {
			//alert(staff_id);
            $state.go('app.item.edit-list', {staff_id: staff_id});
        }
				
		/**
         * Add New Admission
        **/
        function saveItem()
        {
			if(__env.isDebug) console.log("Save Data");						
			if(__env.isDebug) console.log(vm.item);
			if(__env.isDebug) console.log(vm.optionsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.itemUpdate@save', {param:{item:vm.item,options:vm.optionsList,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'item'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Item Updated Successfully').position('top right')
						);
						gotoItem();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
		function removeOption(param){
			//alert(param);
			for(var i=0;i<vm.optionsList.length;i++){
				//alert(vm.optionsList[i].ccontact_id+" == "+param);
				if(vm.optionsList[i].ccontact_id == param){
					vm.optionsList.splice(i, 1);	
				}
			}			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.optionsList);
		}
		
		function addOption(){
			var ind = vm.optionsList.length;						
			vm.option = {itmlist_option_id:ind+1,itmlist_option_itemlist_id:'',itmlist_option_name:'',itmlist_option_order:''};
			vm.optionsList.push(vm.option);		
			if(__env.isDebug) console.log(vm.optionsList);			
		}
		
		/** Upload Part Start **/
		
		function progress(file, flow){
			if(__env.isDebug) console.log("progess");
			if(__env.isDebug) console.log(file);			
			if(__env.isDebug) console.log(flow);
		}
		
		function fileError(file, message, flow){
			if(__env.isDebug) console.log("fileError");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log(message);
			if(__env.isDebug) console.log(flow);
		}
		
		function fileError2(file, message, flow){
			if(__env.isDebug) console.log("fileError2");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log(message);
			if(__env.isDebug) console.log(flow);
		}

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
			//vm.files = [];	
			/*if(__env.isDebug) console.log("fileAdded");
			if(__env.isDebug) console.log("Message");
			if(__env.isDebug) console.log(message);*/
            // Prepare the temp file data for file list
            var uploadingFile = {
                id       : file.uniqueIdentifier,                
               	name     : '1234567890', 
			   	type     : '',				
				url      : ''
            };
			//if(__env.isDebug) console.log(uploadingFile);

            // Append it to the file list
            //vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload(file, message)
        {
			/*if(__env.isDebug) console.log("upload");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log("Message");
			if(__env.isDebug) console.log(message);*/
			
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
			/*alert("2");
			if(__env.isDebug) console.log("upload end");
			if(__env.isDebug) console.log(vm.ngFlow);*/
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
			//alert("3");
			if(__env.isDebug) console.log("fileSuccess");
			if(__env.isDebug) console.log("file");
			if(__env.isDebug) console.log(file);
			if(__env.isDebug) console.log("Message");
			if(__env.isDebug) console.log(message);
			
			
			if(message!=null){
				$mdToast.show(
					$mdToast.simple().textContent('Item image Added').position('top right')
				);
			}
			
			//vm.files=[];			 
			vm.files = {img_id : vm.item.itemlist_id, image : message, url : __env.imagePath+'/items/'+message};
			if(__env.isDebug) console.log(vm.files);
			//editGalleryImage(message);
			vm.item.itemlist_image = message;
			if(__env.isDebug) console.log(vm.item);
        }
		
		function removeImage(image)
        {
			if(__env.isDebug) console.log("Remove Image Data");
			if(__env.isDebug) console.log(vm.files);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
			  msApi.request('app.removeItemImage@save', {param:{image:vm.files,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'item'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);												 
						vm.files = {img_id : vm.files.img_id, image : '', url : ''};						
						if(__env.isDebug) console.log(vm.files);
						
						$mdToast.show(
							$mdToast.simple().textContent('Image Removed').position('top right')
						);											
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
						
		
		/** Upload Part End **/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase')
        .factory('purchaseService', purchaseService);

    /** @ngInject */
    function purchaseService($q, $mdToast, msApi)
    {
        var purchaseEdit = [];

        var service = {
            getPurchase	: getPurchase,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getPurchase(purchase_id,branchID)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( purchaseEdit.length > 0 )
            {				
                deferred.resolve(purchaseEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.purchaseEdit@save', {param:{purchase_id:purchase_id,branchID:branchID},aToken:aToken,page:'purchase'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							purchaseEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(purchaseEdit);
																								
							// Resolve the promise
							deferred.resolve(purchaseEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.ingredients', {
				url    : '/ingredients',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients/ingredients.html',
						controller : 'IngredientsListController as vm'
					}
				},
				resolve: {					
					IngredientsList: function (msApi)
					{					
						return msApi.resolve('app.ingredientsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.ingredients-list', {
				url    : '/ingredients',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients/ingredients.html',
						controller : 'IngredientsListController as vm'
					}
				},
				resolve: {					
					IngredientsList: function (msApi)
					{					
						return msApi.resolve('app.ingredientsList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.ingredients.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients/new_ingredients/new_ingredients.html',
						controller : 'AddIngredientsController as vm'
					}
				},
				resolve: {
					Ingredients: function (msApi)
					{
						return msApi.resolve('app.ingredientsAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'ingredients'
			})
			.state('app.ingredients.edit', {
				url      : '/edit/:ingredients_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients/new_ingredients/new_ingredients.html',
						controller : 'EditIngredientsController as vm'
					}
				},
				resolve: {
					Ingredients: function ($stateParams, ingredientsService)
					{
						return ingredientsService.getIngredients($stateParams.ingredients_id,'Edit');
					}
				},
				bodyClass: 'ingredients'
			})
			.state('app.ingredients.edit-list', {
				url      : '/edit/:ingredients_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients/new_ingredients/new_ingredients.html',
						controller : 'EditIngredientsController as vm'
					}
				},
				resolve: {
					Ingredients: function ($stateParams, ingredientsService)
					{
						return ingredientsService.getIngredients($stateParams.ingredients_id,'Edit');
					}
				},
				bodyClass: 'ingredients'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/ingredients');
			
			// Api						
			msApiProvider.register('app.ingredientsList', ['ingredientsList']);
			msApiProvider.register('app.ingredientsSave', ['ingredientsSave']);
			msApiProvider.register('app.ingredientsUpdate', ['ingredientsUpdate']);
			msApiProvider.register('app.ingredientsAdd', ['ingredientsAdd']);
			msApiProvider.register('app.ingredientsEdit', ['ingredientsEdit']);
			msApiProvider.register('app.ingredientsDel', ['ingredientsDel']);						
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('ingredients', {
				title : 'Ingredientss',
				//icon  : 'icon-account-multiple',
				state : 'app.ingredients',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients')
        .factory('ingredientsService', ingredientsService);

    /** @ngInject */
    function ingredientsService($q, $mdToast, msApi)
    {
        var ingredientsEdit = [];

        var service = {
            getIngredients	: getIngredients			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getIngredients(ingredients_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
					
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ingredientsEdit@save', {param:{ingredients_id:ingredients_id, branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'ingredients'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						ingredientsEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(ingredientsEdit);
																							
						// Resolve the promise
						deferred.resolve(ingredientsEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients')
        .controller('AddIngredientsController', AddIngredientsController);

    /** @ngInject */
    function AddIngredientsController($scope, $mdSidenav, Ingredients, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Ingredients";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Ingredients" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.ingredientsDB = Ingredients.data;        		     				
		if(__env.isDebug) console.log(vm.ingredientsDB);	
		vm.branchID = vm.ingredientsDB.branchID;
		vm.units = vm.ingredientsDB.unitsList;
		//vm.ingredients = {ingredients_code:vm.ingredientsDB.ingredientsCode};
		vm.ingredients = {ingredients_name:'', ingredients_transferunit_id:'', ingredients_baseunit_id:'', ingredients_mulitples:'', ingredients_min_qty:'', ingredients_max_qty:'', ingredients_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.ingredients = {ingredients_status : "Active"};				
				

		// Methods
        vm.saveIngredients = saveIngredients;
		vm.gotoIngredients = gotoIngredients;				
							
		/**
         * Go to Staff page
         */
        function gotoIngredients()
        {
			//alert("1");
            $state.go('app.ingredients-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveIngredients()
        {
			if(__env.isDebug) console.log("Save Data");			
			if(__env.isDebug) console.log(vm.ingredients);
			if(__env.isDebug) console.log(vm.optionsList);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ingredientsSave@save', {param:{ingredients:vm.ingredients,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'ingredients'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Ingredients Added Successfully').position('top right')
						);
						gotoIngredients();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }					
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients')
        .controller('EditIngredientsController', EditIngredientsController);

    /** @ngInject */
    function EditIngredientsController($scope, $mdSidenav, Ingredients, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Ingredients";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Ingredients" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.ingredientsDB = Ingredients;
		vm.ingredients = vm.ingredientsDB.ingredientsDets;
		if(__env.isDebug) console.log("Ingredients Det");
		if(__env.isDebug) console.log(vm.ingredientsDB);
		vm.units = vm.ingredientsDB.unitsList;		
		
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.ingredientsDB.error == "1"){
			gotoLogin();
		} 										
              
		// Methods
        vm.saveIngredients = saveIngredients;
		vm.gotoIngredients = gotoIngredients;			
		//if(__env.isDebug) console.log(vm.studentList);
		vm.gotoLogin = gotoLogin;
				
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoIngredients()
        {
			//alert("1");
            $state.go('app.ingredients-list');
        }
						
		/**
         * Add New Admission
        **/
        function saveIngredients()
        {
			if(__env.isDebug) console.log("Save Data");						
			if(__env.isDebug) console.log(vm.ingredients);
			if(__env.isDebug) console.log(vm.optionsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ingredientsUpdate@save', {param:{ingredients:vm.ingredients,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'ingredients'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Ingredients Updated Successfully').position('top right')
						);
						gotoIngredients();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																								
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.extra',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.extra', {
				url    : '/extra',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/extra/extra.html',
						controller : 'ExtraListController as vm'
					}
				},
				resolve: {					
					ExtraList: function (msApi)
					{					
						return msApi.resolve('app.extraList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.extra-list', {
				url    : '/extra',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/extra/extra.html',
						controller : 'ExtraListController as vm'
					}
				},
				resolve: {					
					ExtraList: function (msApi)
					{					
						return msApi.resolve('app.extraList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.extra.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/extra/new_extra/new_extra.html',
						controller : 'AddExtraController as vm'
					}
				},
				resolve: {
					Extra: function (msApi)
					{
						return msApi.resolve('app.extraAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'extra'
			})
			.state('app.extra.edit', {
				url      : '/edit/:extra_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/extra/new_extra/new_extra.html',
						controller : 'EditExtraController as vm'
					}
				},
				resolve: {
					Extra: function ($stateParams, extraService)
					{
						return extraService.getExtra($stateParams.extra_id,'Edit');
					}
				},
				bodyClass: 'extra'
			})
			.state('app.extra.edit-list', {
				url      : '/edit/:extra_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/extra/new_extra/new_extra.html',
						controller : 'EditExtraController as vm'
					}
				},
				resolve: {
					Extra: function ($stateParams, extraService)
					{
						return extraService.getExtra($stateParams.extra_id,'Edit');
					}
				},
				bodyClass: 'extra'
			})
			.state('app.extra.mapping', {
				url      : '/mapping/:extra_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/extra/mapping/extra_mapping.html',
						controller : 'ExtraMappingController as vm'
					}
				},
				resolve: {
					ExtraMapping: function ($stateParams, extraService)
					{
						return extraService.getPrinterMapping($stateParams.extra_id);
					}
				},
				bodyClass: 'extra'
			})
			.state('app.extra.option', {
				url      : '/option/:extra_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/extra/options/extra_option.html',
						controller : 'ExtraOptionController as vm'
					}
				},
				resolve: {
					ExtraOptions: function ($stateParams, extraService)
					{
						return extraService.getPrinterMapping($stateParams.extra_id);
					}
				},
				bodyClass: 'extra'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/extra');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.extraList', ['extraList']);
			msApiProvider.register('app.extraSave', ['extraSave']);
			msApiProvider.register('app.extraUpdate', ['extraUpdate']);
			msApiProvider.register('app.extraAdd', ['extraAdd']);
			msApiProvider.register('app.extraEdit', ['extraEdit']);
			msApiProvider.register('app.extraDel', ['extraDel']);
			
			msApiProvider.register('app.printerMapping', ['printerMapping']);
			msApiProvider.register('app.savePrinterMapping', ['savePrinterMapping']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('extra', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.extra',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.extra')
        .factory('extraService', extraService);

    /** @ngInject */
    function extraService($q, $mdToast, msApi)
    {
        var extraEdit = [], extraMap = [];

        var service = {
            getExtra	: getExtra,
			getPrinterMapping : getPrinterMapping,
			getPrinterOption : getPrinterOption,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getExtra(extra_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.extraEdit@save', {param:{extra_id:extra_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'extra'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						extraEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(extraEdit);
						extraEdit['extraID'] = extra_id;
																							
						// Resolve the promise
						deferred.resolve(extraEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getPrinterMapping(extra_id)
        {						
			//alert(extra_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {param:{extraID:extra_id},aToken:aToken,page:'extra'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						extraMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(extraMap);
						extraMap['extraID'] = extra_id;
																							
						// Resolve the promise
						deferred.resolve(extraMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getPrinterOption(extra_id)
        {						
			//alert(extra_id);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printerMapping@save', {aToken:aToken,page:'extra'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						extraMap = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(extraMap);
						extraMap['extraID'] = extra_id;
																							
						// Resolve the promise
						deferred.resolve(extraMap);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.extra')
        .controller('AddExtraController', AddExtraController);

    /** @ngInject */
    function AddExtraController($scope, $mdSidenav, Extra, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Extra Charge";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Extra Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.extraDB = Extra.data;        		     				
		if(__env.isDebug) console.log(vm.extraDB);
		
		vm.branchID = vm.extraDB.branchID;
		
		//vm.extra = {extra_code:vm.extraDB.extraCode};
		vm.extra = {extra_name:'', extra_branch_id:vm.branchID, extra_type:'Per', extra_rate:'', extra_inclTax:'', extra_inclDiscount:'', extra_inclRemove:'', extra_status:'Active', extra_dept:'', extra_billable:''};
		
		vm.depts = vm.extraDB.departmentList;
		vm.categorys = vm.extraDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.extraDB.itemList;
		
		
		vm.extraMapItems = [];
		var obj ={extra_map_id:Math.floor(Math.random()*1000), extra_map_branch_id:vm.branchID, extra_map_extra_id:'', extra_map_department_id:0, extra_map_category_id:0, extra_map_item_id:0};
		vm.extraMapItems.push(obj);
		if(__env.isDebug) console.log(vm.extraMapItems);
		
		
		vm.typelist = ['Percentage','Amount'];
		vm.statuslist = ['Active','Inactive'];
		
		
		
		// Methods
        vm.saveExtra = saveExtra;
		vm.gotoExtra = gotoExtra;
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoExtra()
        {
			//alert("1");
            $state.go('app.extra-list');
        }
						
		function saveExtra()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.extra);
			if(__env.isDebug) console.log(vm.extraMapItems);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.extraSave@save', {param:{extra:vm.extra,extraMapItems:vm.extraMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'extra'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Extra Added Successfully').position('top right')
							);
							gotoExtra();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={print_map_id:Math.floor(Math.random()*1000), print_map_branch_id:vm.branchID, print_map_extra_id:'', print_map_department_id:0, print_map_category_id:0, print_map_item_id:0};
			vm.extraMapItems.push(obj);
			if(__env.isDebug) console.log(vm.extraMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.extraMapItems.length;i++){	
				if(vm.extraMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.extraMapItems.splice(i, 1);
				}
			}
        }
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.extra')
        .controller('EditExtraController', EditExtraController);

    /** @ngInject */
    function EditExtraController($scope, $mdSidenav, Extra, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Extra Charge";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Extra Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.extraDB = Extra;		
		if(__env.isDebug) console.log("Extra Det");
		if(__env.isDebug) console.log(vm.extraDB);
		vm.branchID = vm.extraDB.branchID;
		vm.extra = vm.extraDB.extraDets;
		vm.depts = vm.extraDB.departmentList;
		vm.categorys = vm.extraDB.categoryList;
		//vm.tickets = {};
		vm.items = vm.extraDB.itemList;
		vm.mapList = vm.extraDB.mapList;
		vm.extraID = vm.extraDB.extraID;
		vm.extraMapItems = [];
		
		vm.mapList = vm.extraDB.mapList;
		vm.extraID = vm.extraDB.extraID;
		if(vm.mapList.length > 0){
			vm.extraMapItems = vm.mapList;
		} else {
			var obj ={extra_map_id:Math.floor(Math.random()*1000), extra_map_branch_id:vm.branchID, extra_map_extra_id:vm.extraID, extra_map_department_id:0, extra_map_category_id:0, extra_map_item_id:0};
			vm.extraMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.extraMapItems);
		
		
		vm.typelist = ['Percentage','Amount'];
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.extraDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveExtra = saveExtra;
		vm.gotoExtra = gotoExtra;	
		vm.gotoLogin = gotoLogin;
		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoExtra()
        {
			//alert("1");
            $state.go('app.extra-list');
        }
								
		function saveExtra()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.extra);
			if(__env.isDebug) console.log(vm.extraMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.extraUpdate@save', {param:{extra:vm.extra,extraMapItems:vm.extraMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'extra'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Printers Updated Successfully').position('top right')
							);
							gotoExtra();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function addRow()
        {
			 var obj ={extra_map_id:Math.floor(Math.random()*1000), extra_map_branch_id:vm.branchID, extra_map_extra_id:vm.extraID, extra_map_department_id:0, extra_map_category_id:0, extra_map_item_id:0};
			vm.extraMapItems.push(obj);
			if(__env.isDebug) console.log(vm.extraMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.extraMapItems.length;i++){	
				if(vm.extraMapItems[i].extra_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.extraMapItems.splice(i, 1);
				}
			}
        }
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.dining',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.dining', {
				url    : '/dining',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {										
					Billing: function ($stateParams, diningService)
					{
						
						return diningService.getBillGenDets();						
					}
				}
			})
			.state('app.dining-list', {
				url    : '/dining',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-list2', {
				url    : '/dining',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-parcel', {
				url    : '/parcel',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-parcel2', {
				url    : '/parcel',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-parcel-list', {
				url    : '/parcel/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-online', {
				url    : '/online',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-online-list', {
				url    : '/online',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-retail', {
				url    : '/retail',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-retail-list', {
				url    : '/retail',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets();
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-table', {
				url    : '/tables',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {										
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillDets(localStorage.getItem('tableID'));
					}
				}
			})
			.state('app.dining-customer', {
				url    : '/customers',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {										
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillCustDets(localStorage.getItem('customerID'));
					}
				}
			})	
			.state('app.dining-dining-bill', {
				url    : '/dining/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-parcel-bill', {
				url    : '/parcel/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-homedelivery-bill', {
				url    : '/homedelivery/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-online-bill', {
				url    : '/online/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-retail-bill', {
				url    : '/retail/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getBillGenDets2($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-custom-bill', {
				url    : '/custom-dining/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getCustomKot($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.dining-custom-bill-list', {
				url    : '/custom-dining/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getCustomKot($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			/*.state('app.online-custom-bill', {
				url    : '/custom-online/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getCustomKot($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})
			.state('app.online-custom-bill-list', {
				url    : '/custom-online/:bill_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/dining/dining.html',
						controller : 'DiningController as vm'
					}
				},
				resolve: {					
					Billing: function ($stateParams, diningService)
					{
						return diningService.getCustomKot($stateParams.bill_id);
					} 
				},
				bodyClass: 'dining'
			})*/;
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/dining');
			
			// Api	
			msApiProvider.register('app.createBill', ['createBill']);
			msApiProvider.register('app.createBill2', ['createBill2']);
			msApiProvider.register('app.createBill3', ['createBill3']);
			msApiProvider.register('app.createBill4', ['createBill4']);

			msApiProvider.register('app.createCustomBill', ['createCustomBill']);			

			msApiProvider.register('app.saveKOT', ['saveKOT']);
			msApiProvider.register('app.saveBill', ['saveBill']);

			msApiProvider.register('app.reprintKOT', ['reprintKOT']);	
			msApiProvider.register('app.printAllKOT', ['printAllKOT']);						
			
			msApiProvider.register('app.diningList', ['diningList']);
			msApiProvider.register('app.diningSave', ['diningSave']);
			msApiProvider.register('app.diningUpdate', ['diningUpdate']);
			msApiProvider.register('app.diningAdd', ['diningAdd']);
			msApiProvider.register('app.diningEdit', ['diningEdit']);
			msApiProvider.register('app.diningDel', ['diningDel']);
			
			msApiProvider.register('app.pendParcelBills', ['pendParcelBills']);
			msApiProvider.register('app.customerSave2', ['customerSave2']);
			msApiProvider.register('app.updateOrder', ['updateOrder']);
			msApiProvider.register('app.getItmDets', ['getItmDets']);
			msApiProvider.register('app.pendRetailBills', ['pendRetailBills']);

			msApiProvider.register('app.homeCustDets2', ['homeCustDets2']);
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('dining', {
				title : 'POS',
				//icon  : 'icon-account-multiple',
				state : 'app.dining',
				weight: 11
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dining')
        .factory('diningService', diningService);

    /** @ngInject */
    function diningService($q, $mdToast, msApi)
    {
        var billSetting = [], billCustSetting = [];

        var service = {
            getBillDets	: getBillDets,
			getBillCustDets : getBillCustDets,
			getBillGenDets : getBillGenDets,
			getBillGenDets2 : getBillGenDets2,
			getCustomKot : getCustomKot
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getBillDets(table_id)
        {						
			//alert(table_id);
			// Create a new deferred object
            var deferred = $q.defer();							
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.createBill@save', {param:{table_id:table_id,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID'),periodID:localStorage.getItem('periodID'),synDate:localStorage.getItem('syncTime')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						billSetting = response.data;						
						if(__env.isDebug) console.log('Service Log Before 2');
						if(__env.isDebug) console.log(billSetting);
																							
						// Resolve the promise
						deferred.resolve(billSetting);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		function getBillCustDets(customer_id)
        {						
			//alert(customer_id);
			// Create a new deferred object
            var deferred = $q.defer();							
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.createBill2@save', {param:{customer_id:customer_id,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID'),periodID:localStorage.getItem('periodID'),synDate:localStorage.getItem('syncTime')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						billCustSetting = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(billCustSetting);
																							
						// Resolve the promise
						deferred.resolve(billCustSetting);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getBillGenDets()
        {						
			//alert(customer_id);
			// Create a new deferred object
            var deferred = $q.defer();							
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.createBill3@save', {param:{branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID'),periodID:localStorage.getItem('periodID'),synDate:localStorage.getItem('syncTime')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						billCustSetting = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(billCustSetting);
																							
						// Resolve the promise
						deferred.resolve(billCustSetting);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		function getBillGenDets2(bill_id)
        {						
			//alert(customer_id);
			// Create a new deferred object
            var deferred = $q.defer();							
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.createBill4@save', {param:{bill_id:bill_id,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID'),periodID:localStorage.getItem('periodID'),synDate:localStorage.getItem('syncTime')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						billCustSetting = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(billCustSetting);
																							
						// Resolve the promise
						deferred.resolve(billCustSetting);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }

        function getCustomKot(bill_id)
        {						
			//alert(customer_id);
			// Create a new deferred object
            var deferred = $q.defer();							
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.createCustomBill@save', {param:{bill_id:bill_id,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID'),periodID:localStorage.getItem('periodID'),synDate:localStorage.getItem('syncTime')},aToken:aToken,page:'supplier'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						billCustSetting = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(billCustSetting);
																							
						// Resolve the promise
						deferred.resolve(billCustSetting);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.department',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.department', {
				url    : '/department',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/department/department.html',
						controller : 'DepartmentListController as vm'
					}
				},
				resolve: {					
					DepartmentList: function (msApi)
					{					
						return msApi.resolve('app.departmentList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.department-list', {
				url    : '/department',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/department/department.html',
						controller : 'DepartmentListController as vm'
					}
				},
				resolve: {					
					DepartmentList: function (msApi)
					{					
						return msApi.resolve('app.departmentList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.department.flow', {
				url      : '/flow/:department_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/department/flow_department/flow_department.html',
						controller : 'FlowDepartmentController as vm'
					}
				},
				resolve: {
					DepartmentOptions: function ($stateParams, departmentService)
					{
						return departmentService.getDepartmentFlow($stateParams.department_id);
					}
				},
				bodyClass: 'department'
			})
			.state('app.department.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/department/new_department/new_department.html',
						controller : 'AddDepartmentController as vm'
					}
				},
				resolve: {
					Department: function (msApi)
					{
						return msApi.resolve('app.departmentAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'department'
			})
			.state('app.department.edit', {
				url      : '/edit/:department_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/department/new_department/new_department.html',
						controller : 'EditDepartmentController as vm'
					}
				},
				resolve: {
					Department: function ($stateParams, departmentService)
					{
						return departmentService.getDepartment($stateParams.department_id,'Edit');
					}
				},
				bodyClass: 'department'
			})
			.state('app.department.edit-list', {
				url      : '/edit/:department_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/department/new_department/new_department.html',
						controller : 'EditDepartmentController as vm'
					}
				},
				resolve: {
					Department: function ($stateParams, departmentService)
					{
						return clientService.getDepartment($stateParams.department_id,'Edit');
					}
				},
				bodyClass: 'department'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/department');
			
			// Api						
			msApiProvider.register('app.departmentList', ['departmentList']);
			msApiProvider.register('app.departmentSave', ['departmentSave']);
			msApiProvider.register('app.departmentUpdate', ['departmentUpdate']);
			msApiProvider.register('app.departmentAdd', ['departmentAdd']);
			msApiProvider.register('app.departmentEdit', ['departmentEdit']);
			msApiProvider.register('app.departmentDel', ['departmentDel']);
			
			msApiProvider.register('app.departmentFlow', ['departmentFlow']);
			msApiProvider.register('app.departmentFlowUpdate', ['departmentFlowUpdate']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('departmentList', {
				title : 'Department',
				//icon  : 'icon-account-multiple',
				state : 'app.department',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.department')
        .factory('departmentService', departmentService);

    /** @ngInject */
    function departmentService($q, $mdToast, msApi)
    {
        var departmentEdit = [];

        var service = {
            getDepartment	: getDepartment,
			getDepartmentFlow	: getDepartmentFlow
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getDepartment(department_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( departmentEdit.length > 0 )
            {				
                deferred.resolve(departmentEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.departmentEdit@save', {param:{department_id:department_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'department'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							departmentEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(departmentEdit);
																								
							// Resolve the promise
							deferred.resolve(departmentEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }
		
		
		function getDepartmentFlow(department_id)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.departmentFlow@save', {param:{department_id:department_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'department'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						departmentEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(departmentEdit);
																							
						// Resolve the promise
						deferred.resolve(departmentEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.department')
        .controller('AddDepartmentController', AddDepartmentController);

    /** @ngInject */
    function AddDepartmentController($scope, $mdSidenav, Department, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Department";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			

			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].name=="Departments" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}			
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
		vm.departmentDB = Department.data;        		     				
		if(__env.isDebug) console.log(vm.departmentDB);	
		vm.branchID = vm.departmentDB.branchID;
		
		//vm.department = {department_code:vm.departmentDB.departmentCode};
		vm.department = {department_name:'', department_branch_id:vm.branchID, department_price_tag_id:'0', department_kot_jobs_id:'', department_bill_jobs_id:'', department_status:'Active',department_type:'',department_mode_btns:'',department_holdpage:'',department_showprintkot:'',department_ifshowkot:'',department_kotlable:'KOT',department_ifshowsettle:'',department_settlelable:'Settle'};
		
		vm.priceTags = vm.departmentDB.priceTags;		
		vm.printerJobs = vm.departmentDB.printerJobs;

		vm.categorys = vm.departmentDB.categoryList;		
		vm.items = vm.departmentDB.itemList;
		vm.extraList = vm.departmentDB.extraList;
		
		vm.statuslist = ['Active','Inactive'];
		vm.typelist = ['Dining','Home Delivery','Parcel','Online','Retail'];
		//vm.department = {department_status : "Active"};
		vm.showHold = 0;

		vm.deptMapItems = [];
		var obj ={dept_map_id:Math.floor(Math.random()*1000), dept_map_branch_id:vm.branchID, dept_map_dept_id:'', dept_map_category_id:0, dept_map_item_id:0};
		vm.deptMapItems.push(obj);
		if(__env.isDebug) console.log(vm.deptMapItems);
				

		// Methods
        vm.saveDepartment = saveDepartment;
		vm.gotoDepartment = gotoDepartment;
		vm.setType = setType;
		vm.setKOTBtn = setKOTBtn;
		vm.setSettleBtn = setSettleBtn;

		vm.addRow = addRow;
		vm.deleteRow = deleteRow;
						
		/**
         * Go to Staff page
         */
        function setKOTBtn()
        {
			if(vm.department.department_ifshowkot==1){
				vm.department.department_ifshowkot = 0;
			} else if(vm.department.department_ifshowkot==0){
				vm.department.department_ifshowkot = 1;
			}
			if(__env.isDebug) console.log(vm.department);
        }

        function setSettleBtn()
        {
			if(vm.department.department_ifshowsettle==1){
				vm.department.department_ifshowsettle = 0;
			} else if(vm.department.department_ifshowsettle==0){
				vm.department.department_ifshowsettle = 1;
			}
			if(__env.isDebug) console.log(vm.department);
        }

        function gotoDepartment()
        {
			//alert("1");
            $state.go('app.department-list');
        }

        function setType(){
        	if(vm.department.department_type=="Parcel" || vm.department.department_type=="Online"){
        		vm.showHold = 1;
        	}
        }
						
		/**
         * Add New Staff
        **/
        function saveDepartment()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.department);
			if(__env.isDebug) console.log(vm.contactsList);
			if(__env.isDebug) console.log(vm.deptMapItems);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.departmentSave@save', {param:{department:vm.department,deptMapItems:vm.deptMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'department'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Department Added Successfully').position('top right')
						);
						gotoDepartment();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }

        function addRow()
        {
			var obj ={dept_map_id:Math.floor(Math.random()*1000), dept_map_branch_id:vm.branchID, dept_map_dept_id:'', dept_map_category_id:0, dept_map_item_id:0};
			vm.deptMapItems.push(obj);
			if(__env.isDebug) console.log(vm.deptMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.deptMapItems.length;i++){	
				if(vm.deptMapItems[i].print_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.deptMapItems.splice(i, 1);
				}
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.department')
        .controller('EditDepartmentController', EditDepartmentController);

    /** @ngInject */
    function EditDepartmentController($scope, $mdSidenav, Department, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Department";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			

			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].name=="Departments" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}			
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.departmentDB = Department;
		vm.department = vm.departmentDB.departmentDets;
		if(vm.department.department_kotlable==""){
			//vm.department.department_kotlable = "KOT";
		}
		if(__env.isDebug) console.log("Department Det");
		if(__env.isDebug) console.log(vm.departmentDB);

		vm.deptID = vm.department.department_id;
		vm.branchID = vm.departmentDB.branchID;
		
		vm.priceTags = vm.departmentDB.priceTags;
		vm.printerJobs = vm.departmentDB.printerJobs;

		vm.categorys = vm.departmentDB.categoryList;		
		vm.items = vm.departmentDB.itemList;
		vm.extraList = vm.departmentDB.extraList;

		
		var kotJobID = (vm.department.department_kot_jobs_id).split(',');
		vm.department.department_kot_jobs_id = kotJobID;
		
		var billJobID = (vm.department.department_bill_jobs_id).split(',');
		vm.department.department_bill_jobs_id = billJobID;

		var extraID = (vm.department.department_extras).split(',');
		vm.department.department_extras = extraID;
				
		vm.statuslist = ['Active','Inactive'];
		vm.typelist = ['Dining','Home Delivery','Parcel','Online','Retail'];
		
		if(vm.departmentDB.error == "1"){
			gotoLogin();
		} 

		vm.showHold = 0;
		if(vm.department.department_type=="Parcel" || vm.department.department_type=="Online"){
        	vm.showHold = 1;
        }

        vm.deptMapItems = [];
		
		vm.mapList = vm.departmentDB.mapList;		
		if(vm.mapList.length > 0){
			vm.deptMapItems = vm.mapList;
		} else {
			var obj ={dept_map_id:Math.floor(Math.random()*1000), dept_map_branch_id:vm.branchID, dept_map_dept_id:vm.deptID, dept_map_category_id:0, dept_map_item_id:0};
			vm.deptMapItems.push(obj);
		}
		if(__env.isDebug) console.log(vm.deptMapItems);
								
              
		// Methods
        vm.saveDepartment = saveDepartment;
		vm.gotoDepartment = gotoDepartment;	
		vm.gotoLogin = gotoLogin;
		vm.setType = setType;	

		vm.setKOTBtn = setKOTBtn;
		vm.setSettleBtn = setSettleBtn;

		vm.addRow = addRow;
		vm.deleteRow = deleteRow;							
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        function setType(){
        	if(vm.department.department_type=="Parcel" || vm.department.department_type=="Online"){
        		vm.showHold = 1;
        	}
        }
		
		/**
         * Go to Admission page
         */
        function gotoDepartment()
        {
			//alert("1");
            $state.go('app.department-list');
        }
				
				
		/**
         * Add New Admission
        **/

        function setKOTBtn()
        {
			if(vm.department.department_ifshowkot==1){
				vm.department.department_ifshowkot = 0;
			} else if(vm.department.department_ifshowkot==0){
				vm.department.department_ifshowkot = 1;
			}
			if(__env.isDebug) console.log(vm.department);
        }

        function setSettleBtn()
        {
			if(vm.department.department_ifshowsettle==1){
				vm.department.department_ifshowsettle = 0;
			} else if(vm.department.department_ifshowsettle==0){
				vm.department.department_ifshowsettle = 1;
			}
			if(__env.isDebug) console.log(vm.department);
        }
        
        function saveDepartment()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.department);
			if(__env.isDebug) console.log(vm.contactsList);
			if(__env.isDebug) console.log(vm.deptMapItems);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.departmentUpdate@save', {param:{department:vm.department,deptMapItems:vm.deptMapItems,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'department'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Department Updated Successfully').position('top right')
						);
						gotoDepartment();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }

        function addRow()
        {
			var obj ={dept_map_id:Math.floor(Math.random()*1000), dept_map_branch_id:vm.branchID, dept_map_dept_id:vm.taxID, dept_map_category_id:0, dept_map_item_id:0};
			vm.deptMapItems.push(obj);
			if(__env.isDebug) console.log(vm.deptMapItems);
		}
		
		function deleteRow(itm)
        {
			//alert(itm);
			for(var i=0;i<vm.deptMapItems.length;i++){	
				if(vm.deptMapItems[i].dept_map_id == itm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.deptMapItems.splice(i, 1);
				}
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.department')
        .controller('FlowDepartmentController', FlowDepartmentController);

    /** @ngInject */
    function FlowDepartmentController($scope, $mdSidenav, DepartmentOptions, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Flow of Department";
		

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			

			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].name=="Departments" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}			
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.departmentOpts = DepartmentOptions;
		vm.deptOpts = vm.departmentOpts.deptOptions;
		vm.deptFlow = vm.departmentOpts.deptFlow;
		if(__env.isDebug) console.log("Department Det");
		if(__env.isDebug) console.log(vm.departmentOpts);
				
		
		if(vm.departmentOpts.error == "1"){
			gotoLogin();
		}
				
		for(var i=0;i<vm.deptOpts.length;i++){
			var chk=0; var order=''; var flow_id="";
			for(var j=0;j<vm.deptFlow.length;j++){
				if(vm.deptOpts[i].deptopt_id == vm.deptFlow[j].deptflow_deptopt_id){
					chk=1;	
					order=vm.deptFlow[j].deptflow_order;
					flow_id=vm.deptFlow[j].deptflow_id;
					
				}	
			}
			vm.deptOpts[i].deptID = vm.departmentOpts.department_id;
			vm.deptOpts[i].branchID = vm.departmentOpts.branchID;
			vm.deptOpts[i].selectedChk = chk;
			vm.deptOpts[i].orderIndex = order;
			vm.deptOpts[i].flow_id = flow_id;
		}
		if(__env.isDebug) console.log(vm.deptOpts);
										
              
		// Methods
        vm.saveDepartmentFlow = saveDepartmentFlow;
		vm.gotoDepartment = gotoDepartment;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoDepartment()
        {
			//alert("1");
            $state.go('app.department-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveDepartmentFlow()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.deptOpts);			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.departmentFlowUpdate@save', {param:{deptOpts:vm.deptOpts,department_id:vm.departmentOpts.department_id,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'department'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Department Updated Successfully').position('top right')
						);
						gotoDepartment();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.daybook-report', {
				url    : '/daybook-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/daybook-report/daybook-report.html',
						controller : 'DaybookReportController as vm'
					}
				},
				resolve: {					
					DaybookReportList: function (msApi)
					{					
						return msApi.resolve('app.daybookReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.daybook-report-list', {
				url    : '/daybook-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/daybook-report/daybook-report.html',
						controller : 'DaybookReportController as vm'
					}
				},
				resolve: {					
					DaybookReportList: function ($stateParams, daybookreportService)
					{
						
						return daybookreportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/daybook-report');
			
			// Api						
			msApiProvider.register('app.daybookReportList', ['daybookReportList']);
			msApiProvider.register('app.daybookReportList2', ['daybookReportList2']);
			msApiProvider.register('app.daybook-reportSave', ['daybook-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveDaybook('daybook-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.daybook-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook-report')
        .factory('daybookreportService', daybookreportService);

    /** @ngInject */
    function daybookreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(daybookDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getDaybook('UserATK');	
			msApi.request('app.daybookReportList2@save', {param:{daybookDets:daybookDets,branchID:localStorage.getDaybook('BranchID'),UserID:localStorage.getDaybook('UserID')},aToken:aToken,page:'daybook-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.daybook', {
				url    : '/daybook',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/daybook/daybook.html',
						controller : 'DaybookListController as vm'
					}
				},
				resolve: {					
					DaybookList: function (msApi)
					{					
						return msApi.resolve('app.daybookList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.daybook-list', {
				url    : '/daybook',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/daybook/daybook.html',
						controller : 'DaybookListController as vm'
					}
				},
				resolve: {					
					DaybookList: function (msApi)
					{					
						return msApi.resolve('app.daybookList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.daybook.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/daybook/new_daybook/new_daybook.html',
						controller : 'AddDaybookController as vm'
					}
				},
				resolve: {
					Daybook: function (msApi)
					{
						return msApi.resolve('app.daybookAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'daybook'
			})
			.state('app.daybook.edit', {
				url      : '/edit/:daybook_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/daybook/new_daybook/new_daybook.html',
						controller : 'EditDaybookController as vm'
					}
				},
				resolve: {
					Daybook: function ($stateParams, daybookService)
					{
						return daybookService.getHead($stateParams.daybook_id,'Edit');
					}
				},
				bodyClass: 'daybook'
			})
			.state('app.daybook.edit-list', {
				url      : '/edit/:daybook_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/daybook/new_daybook/new_daybook.html',
						controller : 'EditDaybookController as vm'
					}
				},
				resolve: {
					Daybook: function ($stateParams, daybookService)
					{
						return daybookService.getHead($stateParams.daybook_id,'Edit');
					}
				},
				bodyClass: 'daybook'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/daybook');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.daybookList', ['daybookList']);
			msApiProvider.register('app.daybookSave', ['daybookSave']);
			msApiProvider.register('app.daybookUpdate', ['daybookUpdate']);
			msApiProvider.register('app.daybookAdd', ['daybookAdd']);
			msApiProvider.register('app.daybookEdit', ['daybookEdit']);
			msApiProvider.register('app.daybookDel', ['daybookDel']);
										
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('daybook', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.daybook',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook')
        .factory('daybookService', daybookService);

    /** @ngInject */
    function daybookService($q, $mdToast, msApi)
    {
        var daybookEdit = [];

        var service = {
            getHead	: getHead,			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getHead(daybook_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.daybookEdit@save', {param:{daybook_id:daybook_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'tax'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						daybookEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(daybookEdit);
						daybookEdit['daybookID'] = daybook_id;
																							
						// Resolve the promise
						deferred.resolve(daybookEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook')
        .controller('AddDaybookController', AddDaybookController);

    /** @ngInject */
    function AddDaybookController($scope, $mdSidenav, Daybook, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Daybook";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Daybook" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.daybookDB = Daybook.data;        		     				
		if(__env.isDebug) console.log(vm.daybookDB);
		
		vm.branchID = vm.daybookDB.branchID;
		vm.head = vm.daybookDB.headList;
		vm.periodID = localStorage.getItem('periodID');
		
		
		vm.daybook = {daybook_branch_id:vm.branchID, daybook_period_id:vm.periodID, daybook_head_id:'', daybook_amount:'', daybook_remarks:'', daybook_type:'Expenses'};
		
		vm.statuslist = ['Income','Expenses'];
		
		// Methods
        vm.saveDaybook = saveDaybook;
		vm.gotoDaybook = gotoDaybook;
		vm.gotoLogin = gotoLogin;
						
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoDaybook()
        {
			//alert("1");
            $state.go('app.daybook-list');
        }
						
		function saveDaybook()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.daybook);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.daybookSave@save', {param:{daybook:vm.daybook,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'daybook'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Daybook Added Successfully').position('top right')
							);
							gotoDaybook();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }				
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook')
        .controller('EditDaybookController', EditDaybookController);

    /** @ngInject */
    function EditDaybookController($scope, $mdSidenav, Daybook, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Daybook";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Daybook" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.daybookDB = Daybook;		
		if(__env.isDebug) console.log("Daybook Det");
		if(__env.isDebug) console.log(vm.daybookDB);
		vm.branchID = vm.daybookDB.branchID;
		vm.head = vm.daybookDB.headList;
		vm.daybook = vm.daybookDB.daybookDetails;
		
		vm.statuslist = ['Income','Expenses'];
		
		if(vm.daybookDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveDaybook = saveDaybook;
		vm.gotoDaybook = gotoDaybook;	
		vm.gotoLogin = gotoLogin;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoDaybook()
        {
			//alert("1");
            $state.go('app.daybook-list');
        }
								
		function saveDaybook()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.daybook);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.daybookUpdate@save', {param:{daybook:vm.daybook,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'daybook'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Daybook Updated Successfully').position('top right')
							);
							gotoDaybook();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard', 
			[
                // 3rd Party Dependencies                                
                'flow',
				'datatables',
                'gridshore.c3js.chart',
                'nvd3',
                'angular-chartist',
                'chart.js'			
            ]
		)
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
		.state('app.dashboard', {
            url      : '/dashboard',
            views    : {                
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            resolve: {
				Listings: function (msApi)
				{	
					/*if(localStorage.getItem('UserRole')!="Super Admin"){
						return msApi.resolve('app.dbListings@get',{branchID:localStorage.getItem('BranchID')});
					} else {
						return msApi.resolve('app.dbSAListings@get',{branchID:localStorage.getItem('BranchID')});
					}*/
                    return msApi.resolve('app.dbSAListings@get',{branchID:localStorage.getItem('BranchID')});
				},            
			},
            bodyClass: 'dashboard'
        })
		.state('app.dashboard-list', {
            url      : '/dashboard/:type',
            views    : {                
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            resolve: {
				Listings: function ($stateParams, dashboardService)
				{
					
					return dashboardService.getlistBillDets($stateParams.type);						
				},            
			},
            bodyClass: 'dashboard'
        });
        
		// Api
		//msApiProvider.register('app.contacts', ['contacts']);
        msApiProvider.register('app.dbListings', ['dbListings']);
		msApiProvider.register('app.dbSAListings', ['dbSAListings']);
		msApiProvider.register('app.listBillDets', ['listBillDets']);
		

        // Navigation
        /*msNavigationServiceProvider.saveItem('dashboard', {
            title : 'Home',
            state : 'app.dashboard',
            weight: 1
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .factory('dashboardService', dashboardService);

    /** @ngInject */
    function dashboardService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(type)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.listBillDets@save', {param:{type:type,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customer',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.customer', {
				url    : '/customer',
				views  : {
					'main@app': {
                        templateUrl: 'app/core/layouts/vertical-navigation2.html',
                        controller : 'MainController as vm'
                    },
					'content@app': {
						templateUrl: 'app/main/apps/customer/customer.html',
						controller : 'CustomerListController as vm'
					}
				},
				resolve: {					
					CustomerList: function (msApi)
					{					
						return msApi.resolve('app.customerList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.customer-list', {
				url    : '/customer',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/customer/customer.html',
						controller : 'CustomerListController as vm'
					}
				},
				resolve: {					
					CustomerList: function (msApi)
					{					
						return msApi.resolve('app.customerList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.customer.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/customer/new_customer/new_customer.html',
						controller : 'AddCustomerController as vm'
					}
				},
				resolve: {
					Customer: function (msApi)
					{
						return msApi.resolve('app.customerAdd@get',{branchID:localStorage.getItem('BranchID'),type:'Cust'});
						//return '';
					}
				},
				bodyClass: 'customer'
			})
			.state('app.customer.new', {
				url      : '/new',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/customer/new_customer/new_customer.html',
						controller : 'AddCustomerController as vm'
					}
				},
				resolve: {
					Customer: function (msApi)
					{
						return msApi.resolve('app.customerAdd@get',{branchID:localStorage.getItem('BranchID'),type:'CustSel'});
						//return '';
					}
				},
				bodyClass: 'customer'
			})
			.state('app.customer.edit', {
				url      : '/edit/:customer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/customer/new_customer/new_customer.html',
						controller : 'EditCustomerController as vm'
					}
				},
				resolve: {
					Customer: function ($stateParams, customerService)
					{
						return customerService.getCustomer($stateParams.customer_id,'Edit');
					}
				},
				bodyClass: 'customer'
			})
			.state('app.customer.edit-list', {
				url      : '/edit/:customer_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/customer/new_customer/new_customer.html',
						controller : 'EditCustomerController as vm'
					}
				},
				resolve: {
					Customer: function ($stateParams, customerService)
					{
						return clientService.getCustomer($stateParams.customer_id,'Edit');
					}
				},
				bodyClass: 'customer'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/customer');
			
			// Api						
			msApiProvider.register('app.customerList', ['customerList']);
			msApiProvider.register('app.customerSave', ['customerSave']);
			msApiProvider.register('app.customerUpdate', ['customerUpdate']);
			msApiProvider.register('app.customerAdd', ['customerAdd']);
			msApiProvider.register('app.customerEdit', ['customerEdit']);
			msApiProvider.register('app.customerDel', ['customerDel']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('customer', {
				title : 'Customers',
				//icon  : 'icon-account-multiple',
				state : 'app.customer',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customer')
        .factory('customerService', customerService);

    /** @ngInject */
    function customerService($q, $mdToast, msApi)
    {
        var customerEdit = [];

        var service = {
            getCustomer	: getCustomer			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getCustomer(customer_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( customerEdit.length > 0 )
            {				
                deferred.resolve(customerEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.customerEdit@save', {param:{customer_id:customer_id},aToken:aToken,page:'customer'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							customerEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(customerEdit);
																								
							// Resolve the promise
							deferred.resolve(customerEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customer')
        .controller('AddCustomerController', AddCustomerController);

    /** @ngInject */
    function AddCustomerController($scope, $mdSidenav, Customer, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Customer";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Customers" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.customerDB = Customer.data;        		     				
		if(__env.isDebug) console.log(vm.customerDB);	
		vm.branchID = vm.customerDB.branchID;
		vm.type = vm.customerDB.type;
		
		//vm.customer = {customer_code:vm.customerDB.customerCode};
		vm.customer = {customer_name:'', customer_branch_id:vm.branchID, customer_mobileno:'', customer_address:'', customer_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.customer = {customer_status : "Active"};
				

		// Methods
        vm.saveCustomer = saveCustomer;
		vm.gotoCustomer = gotoCustomer;
						
		/**
         * Go to Staff page
         */
        function gotoCustomer(CustID)
        {
			//alert(vm.type+" "+CustID);
			if(vm.type == "Cust"){
				$state.go('app.customer-list');
			} else if(vm.type == "CustSel"){
	            //$state.go('app.customer-selection-list');

	            localStorage.setItem('customerID',CustID);
				$state.go('app.dining-customer');
			}
        }
						
		/**
         * Add New Staff
        **/
        function saveCustomer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.customer);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.customerSave@save', {param:{customer:vm.customer,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'customer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						var CustID = response.data;
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Customer Added Successfully').position('top right')
						);
						gotoCustomer(CustID);
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customer')
        .controller('EditCustomerController', EditCustomerController);

    /** @ngInject */
    function EditCustomerController($scope, $mdSidenav, Customer, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Customer";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Customers" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.customerDB = Customer;
		vm.customer = vm.customerDB.customerDets;
		if(__env.isDebug) console.log("Customer Det");
		if(__env.isDebug) console.log(vm.customerDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.customerDB.error == "1"){
			gotoLogin();
		} 
								
              
		// Methods
        vm.saveCustomer = saveCustomer;
		vm.gotoCustomer = gotoCustomer;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoCustomer()
        {
			//alert("1");
            $state.go('app.customer-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveCustomer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.customer);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.customerUpdate@save', {param:{customer:vm.customer,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'customer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Customer Updated Successfully').position('top right')
						);
						gotoCustomer();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.clear-sales',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.clear-sales', {
				url    : '/clear-sales',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/clear-sales/clear-sales.html',
						controller : 'ClearSalesController as vm'
					}
				},
				resolve: {					
					ClearSalesList: function (msApi)
					{					
						return msApi.resolve('app.clearSalesList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.clear-sales-list', {
				url    : '/clear-sales',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/clear-sales/clear-sales.html',
						controller : 'ClearSalesController as vm'
					}
				},
				resolve: {					
					ClearSalesList: function ($stateParams, clearsalesService)
					{
						
						return clearsalesService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/clear-sales');
			
			// Api						
			msApiProvider.register('app.clearSalesList', ['clearSalesList']);
			msApiProvider.register('app.clearSalesList2', ['clearSalesList2']);
			msApiProvider.register('app.delBillDets', ['delBillDets']);				
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('clear-sales', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.clear-sales',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.clear-sales')
        .factory('clearsalesService', clearsalesService);

    /** @ngInject */
    function clearsalesService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(salesDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.salesReportList2@save', {param:{salesDets:salesDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'clear-sales'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.category-report', {
				url    : '/category-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/category-report/category-report.html',
						controller : 'CategoryReportController as vm'
					}
				},
				resolve: {					
					CategoryReportList: function (msApi)
					{					
						return msApi.resolve('app.categoryReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.category-report-list', {
				url    : '/category-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/category-report/category-report.html',
						controller : 'CategoryReportController as vm'
					}
				},
				resolve: {					
					CategoryReportList: function ($stateParams, categoryreportService)
					{
						
						return categoryreportService.getlistBillDets($stateParams.type);						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/category-report');
			
			// Api						
			msApiProvider.register('app.categoryReportList', ['categoryReportList']);
			msApiProvider.register('app.categoryReportList2', ['categoryReportList2']);
			msApiProvider.register('app.category-reportSave', ['category-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('category-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.category-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category-report')
        .factory('categoryreportService', categoryreportService);

    /** @ngInject */
    function categoryreportService($q, $mdToast, msApi)
    {
        var listBillDets = [];
        var service = {
			getlistBillDets : getlistBillDets
        };

        return service;

        //////////		
		
		/**
         * Get Student Details
         */
        function getlistBillDets(categoryDets)
        {						
			// Create a new deferred object
			//alert(type);
            var deferred = $q.defer();
           	var aToken=localStorage.getItem('UserATK');	
			msApi.request('app.categoryReportList2@save', {param:{categoryDets:categoryDets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'category-report'},
				// SUCCESS
				function (response)
				{
					// Store the products
					listBillDets = response;
					
					//classes['selectedClassSetting']=selList;
					
					if(__env.isDebug) console.log('Pending Pickups');
					if(__env.isDebug) console.log(listBillDets);

					// Resolve the promise
					deferred.resolve(listBillDets);
				},

				// ERROR
				function (response)
				{
					// Reject the promise
					deferred.reject(response);
				}
			);
            return deferred.promise;
        }						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category')
        .factory('categoryService', categoryService);

    /** @ngInject */
    function categoryService($q, $mdToast, msApi)
    {
        var categoryEdit = [], itemsList = [];

        var service = {
            getCategorys	: getCategorys,
			getItems		: getItems
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getCategorys(categorylist_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( categoryEdit.length > 0 )
            {				
                deferred.resolve(categoryEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.categoryEdit@save', {param:{categorylist_id:categorylist_id},aToken:aToken,page:'category'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							categoryEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(categoryEdit);
																								
							// Resolve the promise
							deferred.resolve(categoryEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }
		
		
		function getItems(categorylist_id)
        {						
			//alert(categorylist_id);
			var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.catItemList@save', {param:{categorylist_id:categorylist_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'category'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						itemsList = response.data;	
						itemsList['categorylist_id'] = categorylist_id;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(itemsList);
																							
						// Resolve the promise
						deferred.resolve(itemsList);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category')
        .controller('AddCategorysController', AddCategorysController);

    /** @ngInject */
    function AddCategorysController($scope, $mdSidenav, Categorys, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Categorys";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Category Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.categoryDB = Categorys.data;        		     				
		if(__env.isDebug) console.log(vm.categoryDB);	
		vm.branchID = vm.categoryDB.branchID;
		
		//vm.category = {categorylist_code:vm.categoryDB.categoryCode};
		vm.category = {categorylist_id:'', categorylist_name:'', categorylist_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.category = {categorylist_status : "Active"};
		
				
		// Methods
        vm.saveCategorys = saveCategorys;
		vm.gotoCategorys = gotoCategorys;
		//vm.removeImage = removeImage;
				
						
		/**
         * Go to Staff page
         */
        function gotoCategorys()
        {
			//alert("1");
            $state.go('app.category-list');
        }
						
		/**
         * Add New Staff
        **/
        function saveCategorys()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.category);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.categorySave@save', {param:{category:vm.category,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Categorys Added Successfully').position('top right')
						);
						gotoCategorys();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }										
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.category')
        .controller('EditCategorysController', EditCategorysController);

    /** @ngInject */
    function EditCategorysController($scope, $mdSidenav, Categorys, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Categorys";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Category Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.categoryDB = Categorys;
		vm.category = vm.categoryDB.categoryDets;
		if(__env.isDebug) console.log("Categorys Det");
		if(__env.isDebug) console.log(vm.categoryDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.categoryDB.error == "1"){
			gotoLogin();
		} 

		if(vm.category.categorylist_image!=""){
			vm.files = {
				url	: __env.imagePath+'categories/'+vm.category.categorylist_image
			};
		}
		console.log(vm.files);

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   	: __env.apiUrl+'uploadCatImage',
             chunkSize                	: 15 * 1024 * 1024,
             maxChunkRetries          	: 1,
             simultaneousUploads      	: 1,
             testChunks               	: false,
			 permanentErrors			: [404, 500, 501],
             progressCallbacksInterval	: 1000
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
		
		// Methods
        vm.saveCategorys = saveCategorys;
		vm.gotoCategorys = gotoCategorys;	
		vm.gotoLogin = gotoLogin;	

		vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
		vm.progress = progress;
		vm.fileError = fileError;
		vm.fileError2 = fileError2;	
		vm.editCatImage = editCatImage;						
				
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		/**
         * Go to Admission page
         */
        function gotoCategorys()
        {
			//alert("1");
            $state.go('app.category-list');
        }
				
				
		/**
         * Add New Admission
        **/
        function saveCategorys()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.category);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.categoryUpdate@save', {param:{category:vm.category,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Categorys Updated Successfully').position('top right')
						);
						gotoCategorys();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		/** Upload Part Start **/
		
		function progress(file, flow){
			console.log("progess");
			console.log(file);			
			console.log(flow);
		}
		
		function fileError(file, message, flow){
			console.log("fileError");
			console.log(file);
			console.log(message);
			console.log(flow);
		}
		
		function fileError2(file, message, flow){
			console.log("fileError2");
			console.log(file);
			console.log(message);
			console.log(flow);
		}

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
			vm.files = [];	
			console.log("fileAdded");
			//console.log("Message");
			//console.log(message);
            // Prepare the temp file data for file list
            var uploadingFile = {
                id       : file.uniqueIdentifier,                
               	name     : '1234567890', 
			   	type     : '',				
				url      : ''
            };
			//console.log(uploadingFile);

            // Append it to the file list
            vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload(file, message)
        {
			console.log("upload");
			console.log(file);
			console.log("Message");
			console.log(message);
			
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
			/*alert("2");
			console.log("upload end");
			console.log(vm.ngFlow);*/
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
			//alert("3");
			console.log("fileSuccess");
			console.log("file");
			console.log(file);
			console.log("Message");
			console.log(message);
			
			
			if(message!=null){
				$mdToast.show(
					$mdToast.simple().textContent('Category image Added').position('top right')
				);
			}
			
			vm.files=[];
			vm.files = {
                //id       : file.uniqueIdentifier,                
               	//name     : file.file.name, 
			   	//type     : file.file.type,                              
				url      : __env.imagePath+'categories/'+message
            };            			
			console.log(vm.files);
			editCatImage(message);
        }
		
		function editCatImage(img_name)
        {
			//console.log("Save Data");
			//console.log(img_name);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.catImageEdit@save', {value:img_name,param:vm.category.categorylist_id,aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						console.log("Success");
						console.log(response.data);
						if(response.data!=null){
							$mdToast.show(
								$mdToast.simple().textContent('Category image uploaded').position('top right')
							);
						} else {
							$mdToast.show(
								$mdToast.simple().textContent('Category image not uploaded').position('top right')
							);
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		/** Upload Part End **/
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.category')
        .controller('CategorysItemsListController', CategorysItemsListController);

    /** @ngInject */
    function CategorysItemsListController($state, Items, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Categorys";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Category Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.itemList = Items;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.itemList);
		vm.items = vm.itemList.itemList;
		vm.catItems = vm.itemList.itemCat;
		vm.branchID = vm.itemList.branchID;
		vm.catID = vm.itemList.categorylist_id;
        vm.listForm={};

        vm.search = "";
		
		if(vm.itemList.error == "1"){
			gotoLogin();
		} 
		for(var i=0;i<vm.items.length;i++){
			vm.items[i].item_branch_id = vm.branchID;
			for(var j=0;j<vm.catItems.length;j++){
				if(vm.items[i].item_id == vm.catItems[j].catitm_item_id){
					vm.items[i].selectedchk = 1;
					vm.items[i].order = vm.catItems[j].catitm_order;					
				}
			}
		}
		
		if(__env.isDebug) console.log(vm.items);
        		
       	
        // Methods
       
		vm.gotoCategorys = gotoCategorys;	
		vm.saveCatItems = saveCatItems;
		vm.gotoLogin = gotoLogin;	
		vm.setItems = setItems;
		vm.selectAll = selectAll;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function selectAll(){
			if(vm.mainChk==0){
				vm.mainChk=1;
				for(var i=0;i<vm.items.length;i++){
					vm.items[i].selectedchk = 1;
				}
			} else {
				vm.mainChk=0;	
				for(var i=0;i<vm.items.length;i++){
					vm.items[i].selectedchk = 0;
				}	
			}
		}
        
		function gotoCategorys()
        {
			//alert("1");
            $state.go('app.category-list');
        }
		
		function setItems(catID){
			$state.go('app.category.items', {category_id: catID});
		}
							
		function saveCatItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.items);
			if(__env.isDebug) console.log(vm.catID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.catItemSave@save', {param:{items:vm.items,catID:vm.catID,branchID:vm.branchID},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						gotoCategorys();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.branch',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.branch', {
				url    : '/branch',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/branch/branch.html',
						controller : 'BranchsListController as vm'
					}
				},
				resolve: {					
					BranchsList: function (msApi)
					{					
						return msApi.resolve('app.branchList@get');
					}, 
				}
			})
			.state('app.branch-list', {
				url    : '/branch',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/branch/branch.html',
						controller : 'BranchsListController as vm'
					}
				},
				resolve: {					
					BranchsList: function (msApi)
					{					
						return msApi.resolve('app.branchList@get');
					}, 
				}
			})	
			.state('app.branch.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/branch/new_branch/new_branch.html',
						controller : 'AddBranchsController as vm'
					}
				},
				resolve: {
					Branchs: function (msApi)
					{
						return msApi.resolve('app.branchAdd@get');
						//return '';
					}
				},
				bodyClass: 'branch'
			})
			.state('app.branch.edit', {
				url      : '/edit/:branch_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/branch/new_branch/new_branch.html',
						controller : 'EditBranchsController as vm'
					}
				},
				resolve: {
					Branchs: function ($stateParams, branchService)
					{
						return branchService.getBranchs($stateParams.branch_id,'Edit');
					}
				},
				bodyClass: 'branch'
			})
			.state('app.branch.edit-list', {
				url      : '/edit/:branch_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/branch/new_branch/new_branch.html',
						controller : 'EditBranchsController as vm'
					}
				},
				resolve: {
					Branchs: function ($stateParams, branchService)
					{
						return branchService.getBranchs($stateParams.branch_id,'Edit');
					}
				},
				bodyClass: 'branch'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/branch');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.branchList', ['branchList']);
			msApiProvider.register('app.branchSave', ['branchSave']);
			msApiProvider.register('app.branchUpdate', ['branchUpdate']);
			msApiProvider.register('app.branchAdd', ['branchAdd']);
			msApiProvider.register('app.branchEdit', ['branchEdit']);
			msApiProvider.register('app.branchDel', ['branchDel']);			
			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('branch', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.branch',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.branch')
        .factory('branchService', branchService);

    /** @ngInject */
    function branchService($q, $mdToast, msApi)
    {
        var branchEdit = [];

        var service = {
            getBranchs	: getBranchs,
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getBranchs(branch_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.branchEdit@save', {param:{branch_id:branch_id},aToken:aToken,page:'branch'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						branchEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(branchEdit);
																							
						// Resolve the promise
						deferred.resolve(branchEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.branch')
        .controller('AddBranchsController', AddBranchsController);

    /** @ngInject */
    function AddBranchsController($scope, $mdSidenav, Branchs, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Branch";
		
        // Data
		vm.branchDB = Branchs.data;        		     				
		if(__env.isDebug) console.log(vm.branchDB);	
		
		//vm.branch = {branch_code:vm.branchDB.branchCode};
		vm.branch = {branch_name:'', branch_description:'', branch_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		//vm.branch = {branch_status : "Active"};
		
		
		// Methods
        vm.saveBranchs = saveBranchs;
		vm.gotoBranchs = gotoBranchs;
		vm.gotoLogin = gotoLogin;
		
				
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoBranchs()
        {
			//alert("1");
            $state.go('app.branch-list');
        }
						
		function saveBranchs()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branch);
			if(__env.isDebug) console.log(vm.contactsList);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.branchSave@save', {param:{branch:vm.branch,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'branch'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						$mdToast.show(
							$mdToast.simple().textContent('Branchs Added Successfully').position('top right')
						);
						gotoBranchs();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }						
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.branch')
        .controller('EditBranchsController', EditBranchsController);

    /** @ngInject */
    function EditBranchsController($scope, $mdSidenav, Branchs, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Branch";
		
        // Data		
		vm.branchDB = Branchs;
		vm.branch = vm.branchDB.branchDets;
		if(__env.isDebug) console.log("Branchs Det");
		if(__env.isDebug) console.log(vm.branchDB);
				
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.branchDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveBranchs = saveBranchs;
		vm.gotoBranchs = gotoBranchs;	
		vm.gotoLogin = gotoLogin;	
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoBranchs()
        {
			//alert("1");
            $state.go('app.branch-list');
        }
								
		function saveBranchs()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branch);
			if(__env.isDebug) console.log(vm.contactsList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.branchUpdate@save', {param:{branch:vm.branch,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'branch'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Branchs Updated Successfully').position('top right')
						);
						gotoBranchs();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.billing',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.billing', {
				url    : '/billing/:dining_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/billing/billing.html',
						controller : 'BillingListController as vm'
					}
				},
				resolve: {										
					BillingList: function ($stateParams, billingService)
					{
						return billingService.getBillingDets($stateParams.dining_id);
					}
				},
				bodyClass: 'billing'
			})
			.state('app.billing-list', {
				url    : '/billing/:dining_id',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/billing/billing.html',
						controller : 'BillingListController as vm'
					}
				},
				resolve: {										
					BillingList: function ($stateParams, billingService)
					{
						return billingService.getBillingDets($stateParams.dining_id);
					}
				},
				bodyClass: 'billing'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/billing');
			
			// Api						
			msApiProvider.register('app.getBillingDets', ['getBillingDets']);
			msApiProvider.register('app.endBill', ['endBill']);
			msApiProvider.register('app.printBills', ['printBills']);
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('billing', {
				title : 'Billings',
				//icon  : 'icon-account-multiple',
				state : 'app.billing',
				weight: 9
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.billing')
        .factory('billingService', billingService);

    /** @ngInject */
    function billingService($q, $mdToast, msApi)
    {
        var billingDets = [];

        var service = {
            getBillingDets	: getBillingDets			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getBillingDets(dining_id)
        {						
			//alert(dining_id);			
			var aToken=localStorage.getItem('UserATK');
			var deferred = $q.defer();
			if(aToken!=""){
				msApi.request('app.getBillingDets@save', {param:{dining_id:dining_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						billingDets = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(billingDets);
																							
						// Resolve the promise
						deferred.resolve(billingDets);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
			return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.available',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getAvailable('Admission Page'));		
		//if(localStorage.getAvailable('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.available', {
				url    : '/available',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/available/available.html',
						controller : 'AvailableListController as vm'
					}
				},
				resolve: {					
					AvailableList: function (msApi)
					{					
						return msApi.resolve('app.availableList@get',{branchID:localStorage.getItem('BranchID'),periodID:localStorage.getItem('periodID')});
					}, 
				}
			})
			.state('app.available-list', {
				url    : '/available',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/available/available.html',
						controller : 'AvailableListController as vm'
					}
				},
				resolve: {					
					AvailableList: function (msApi)
					{					
						return msApi.resolve('app.availableList@get',{branchID:localStorage.getItem('BranchID'),periodID:localStorage.getItem('periodID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/available');
			
			// Api						
			msApiProvider.register('app.availableList', ['availableList']);
			msApiProvider.register('app.availableSave', ['availableSave']);
			msApiProvider.register('app.unavailableSave', ['unavailableSave']);
			
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('available', {
				title : 'Availables',
				//icon  : 'icon-account-multiple',
				state : 'app.available',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.available')
        .factory('availableService', availableService);

    /** @ngInject */
    function availableService($q, $mdToast, msApi)
    {
        var availableEdit = [];

        var service = {
            getAvailable	: getAvailable			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getAvailable(available_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			//alert(student_id);
            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            /*if ( availableEdit.length > 0 )
            {				
                deferred.resolve(availableEdit);
            }
            // otherwise make an API call and load
            // the products
            else
            {*/				
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.availableEdit@save', {param:{available_id:available_id},aToken:aToken,page:'available'},
						// SUCCESS
						function (response)
						{
							//alert("3");
							// Store the products
							availableEdit = response.data;						
							if(__env.isDebug) console.log('Service Log Before');
							if(__env.isDebug) console.log(availableEdit);
																								
							// Resolve the promise
							deferred.resolve(availableEdit);
						},
	
						// ERROR
						function (response)
						{
							// Reject the promise
							deferred.reject(response);
						}
					);
				} else {
					//alert("else");
					return {"error":"1"};
				}
            //}
            return deferred.promise;
        }								
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.account-head',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.account-head', {
				url    : '/account-head',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/account-head/account-head.html',
						controller : 'AccountheadListController as vm'
					}
				},
				resolve: {					
					AccountheadList: function (msApi)
					{					
						return msApi.resolve('app.accountheadList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.account-head-list', {
				url    : '/account-head',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/account-head/account-head.html',
						controller : 'AccountheadListController as vm'
					}
				},
				resolve: {					
					AccountheadList: function (msApi)
					{					
						return msApi.resolve('app.accountheadList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			.state('app.account-head.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/account-head/new_account-head/new_account-head.html',
						controller : 'AddAccountheadController as vm'
					}
				},
				resolve: {
					Accounthead: function (msApi)
					{
						return msApi.resolve('app.taxAdd@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}
				},
				bodyClass: 'tax'
			})
			.state('app.account-head.edit', {
				url      : '/edit/:tax_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/account-head/new_account-head/new_account-head.html',
						controller : 'EditAccountheadController as vm'
					}
				},
				resolve: {
					Accounthead: function ($stateParams, headService)
					{
						return headService.getHead($stateParams.tax_id,'Edit');
					}
				},
				bodyClass: 'tax'
			})
			.state('app.account-head.edit-list', {
				url      : '/edit/:tax_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/account-head/new_account-head/new_account-head.html',
						controller : 'EditAccountheadController as vm'
					}
				},
				resolve: {
					Accounthead: function ($stateParams, headService)
					{
						return headService.getHead($stateParams.tax_id,'Edit');
					}
				},
				bodyClass: 'tax'
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/tax');
			
			// Api						
			msApiProvider.register('app.actionDB', ['actionCalling']);
			msApiProvider.register('app.accountheadList', ['accountheadList']);
			msApiProvider.register('app.headSave', ['headSave']);
			msApiProvider.register('app.headUpdate', ['headUpdate']);
			msApiProvider.register('app.headAdd', ['headAdd']);
			msApiProvider.register('app.headEdit', ['headEdit']);
			msApiProvider.register('app.headDel', ['headDel']);
										
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('tax', {
				title : 'Branch',
				//icon  : 'icon-account-multiple',
				state : 'app.tax',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.account-head')
        .factory('headService', headService);

    /** @ngInject */
    function headService($q, $mdToast, msApi)
    {
        var headEdit = [];

        var service = {
            getHead	: getHead,			
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getHead(head_id,type)
        {						
			//alert(type);
			// Create a new deferred object
            var deferred = $q.defer();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.headEdit@save', {param:{head_id:head_id,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'tax'},
					// SUCCESS
					function (response)
					{
						//alert("3");
						// Store the products
						headEdit = response.data;						
						if(__env.isDebug) console.log('Service Log Before');
						if(__env.isDebug) console.log(headEdit);
						headEdit['headID'] = head_id;
																							
						// Resolve the promise
						deferred.resolve(headEdit);
					},

					// ERROR
					function (response)
					{
						// Reject the promise
						deferred.reject(response);
					}
				);
			} else {
				//alert("else");
				return {"error":"1"};
			}
            return deferred.promise;
        }
		
		
		
						
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.account-head')
        .controller('AddAccountheadController', AddAccountheadController);

    /** @ngInject */
    function AddAccountheadController($scope, $mdSidenav, Accounthead, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Add Account Head";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Account Head" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
		vm.headDB = Accounthead.data;        		     				
		if(__env.isDebug) console.log(vm.headDB);
		
		vm.branchID = vm.headDB.branchID;
		
		
		vm.head = {achead_name:'', achead_branch_id:vm.branchID, achead_status:'Active'};
		
		vm.statuslist = ['Active','Inactive'];
		
		// Methods
        vm.saveAccounthead = saveAccounthead;
		vm.gotoAccounthead = gotoAccounthead;
		vm.gotoLogin = gotoLogin;
						
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoAccounthead()
        {
			//alert("1");
            $state.go('app.account-head-list');
        }
						
		function saveAccounthead()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.head);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.headSave@save', {param:{head:vm.head,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'account-head'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						//if(__env.isDebug) console.log(response.admission);
						//if(__env.isDebug) console.log(response.sibling);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Account Head Added Successfully').position('top right')
							);
							gotoAccounthead();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }				
			
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.account-head')
        .controller('EditAccountheadController', EditAccountheadController);

    /** @ngInject */
    function EditAccountheadController($scope, $mdSidenav, Accounthead, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Edit Account Head";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Account Head" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data		
		vm.headDB = Accounthead;		
		if(__env.isDebug) console.log("Accounthead Det");
		if(__env.isDebug) console.log(vm.headDB);
		vm.branchID = vm.headDB.branchID;
		vm.head = vm.headDB.accountheadDets;
		
		vm.statuslist = ['Active','Inactive'];
		
		if(vm.headDB.error == "1"){
			gotoLogin();
		} 
				       
		// Methods
        vm.saveAccounthead = saveAccounthead;
		vm.gotoAccounthead = gotoAccounthead;	
		vm.gotoLogin = gotoLogin;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function gotoAccounthead()
        {
			//alert("1");
            $state.go('app.account-head-list');
        }
								
		function saveAccounthead()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.head);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.headUpdate@save', {param:{head:vm.head,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'account-head'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Account Head Updated Successfully').position('top right')
							);
							gotoAccounthead();					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
       // msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        //msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        //msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        //msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);

        msApiProvider.register('app.getCustomKots', ['getCustomKots']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        /*msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );*/

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.work-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.work-report', {
				url    : '/work-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/work-report/work-report.html',
						controller : 'WorkReportController as vm'
					}
				},
				resolve: {					
					WorkReportList: function (msApi)
					{					
						return msApi.resolve('app.workReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.work-report-list', {
				url    : '/work-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/work-report/work-report.html',
						controller : 'WorkReportController as vm'
					}
				},
				resolve: {					
					WorkReportList: function (msApi)
					{					
						return msApi.resolve('app.workReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/work-report');
			
			// Api						
			msApiProvider.register('app.workReportList', ['workReportList']);
			msApiProvider.register('app.work-reportSave', ['work-reportSave']);	
			msApiProvider.register('app.printWPBillDirect', ['printWPBillDirect']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
			msApiProvider.register('app.workReportDets', ['workReportDets']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('work-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.work-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.work-report')
        .controller('WorkReportController', WorkReportController);

    /** @ngInject */
    function WorkReportController(WorkReportList, $state, msApi, $window, __env, $mdToast, $rootScope,$cookies)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Work Period Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Work Period Reports" && vm.pageID[i].status==0){ 					
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data 
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		      
		vm.workreportList = WorkReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.workreportList);   
		vm.branchID = vm.workreportList.branchID;
		//vm.tax = vm.workreportList.workReportTax;

		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.salesDets = {from:vm.workreportList.from,to:vm.workreportList.to,type:'Today'};
		vm.periodIDs = "";

		
		vm.deptTotal = 0;

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.workReportDets = workReportDets;
		
		vm.wprPDFExport = wprPDFExport;
		vm.wprCSVExport = wprCSVExport;
		
		vm.salesItmsPDFExport = salesItmsPDFExport;
		vm.changeDate = changeDate;

		vm.extraTotal = 0;

		
		/*for(var i=0;i<vm.workreportList.workReportBillItems.length;i++){
			vm.workreportList.workReportBillItems[i].bitm_tax = parseFloat((vm.workreportList.workReportBillItems[i].bitm_total * vm.tax)/100);
			
			vm.workreportList.workReportBillItems[i].bitm_taxtotal = parseFloat(vm.workreportList.workReportBillItems[i].bitm_tax) + parseFloat(vm.workreportList.workReportBillItems[i].bitm_total);
		}
		if(__env.isDebug) console.log(vm.workreportList.workReportBillItems);*/
		
        //////////

        changeDate();
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function wprPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'wprPDFExport/'+vm.branchID);
			 vm.inpt2=vm.periodIDs.split("|");
			 //$window.location.href = __env.apiUrl+'wprPDFExport/'+vm.branchID+'/'+vm.inpt2[0]+'/'+vm.inpt2[1];			 			 
			 $window.open(__env.apiUrl+'wprPDFExport/'+vm.branchID+'/'+vm.inpt2[0]+'/'+vm.inpt2[1], '_blank');
        }
		
		function wprCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'wprPDFExport/'+vm.branchID);
			 //alert(vm.salesDets.mode);
			 vm.inpt2=vm.periodIDs.split("|");
			 //$window.location.href = __env.apiUrl+'wprCSVExport/'+vm.branchID+'/'+vm.inpt2[0]+'/'+vm.inpt2[1];
			 $window.open(__env.apiUrl+'wprCSVExport/'+vm.branchID+'/'+vm.inpt2[0]+'/'+vm.inpt2[1], '_blank');
        }
		
		function salesItmsPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'wprPDFExport/'+vm.branchID);
			 vm.inpt2=vm.periodIDs.split("|");
			 //$window.location.href = __env.apiUrl+'salesItmsPDFExport/'+vm.branchID;			 			 
			 $window.open(__env.apiUrl+'salesItmsPDFExport/'+vm.branchID+'/'+vm.inpt2[0]+'/'+vm.inpt2[1], '_blank');
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.work-report-list');
        }
		
		
		function workReportDets(workperiodID){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			//alert(workperiodID);
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			if(__env.isDebug) console.log(vm.inputDets);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){		
				msApi.request('app.workReportDets@save', {param:{branchID:vm.branchID,inputDets:vm.salesDets},aToken:aToken,page:'work-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						vm.workreportList = response.data;
						
						vm.workreportList.workReportSales.sm_discountTotal = parseFloat(vm.workreportList.workReportSales.sm_discount) + parseFloat(vm.workreportList.workReportSales.sm_round);
						vm.periodIDs = vm.workreportList.workPeriodIDs;
						//alert(vm.periodIDs);
						vm.branchID = vm.workreportList.branchID;
						vm.tax = vm.workreportList.workReportTax;

						vm.deptTotal = 0;
						for(var i=0;i<vm.workreportList.workReportDeptSales.length;i++){
							vm.deptTotal = vm.deptTotal + parseFloat(vm.workreportList.workReportDeptSales[i].sm_nett);
						}

						vm.extraTotal = 0;						
						for(var i=0;i<vm.workreportList.workReportExtraBills.length;i++){
							vm.extraTotal = vm.extraTotal + parseFloat(vm.workreportList.workReportExtraBills[i].smTotal);
						}
						
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPBillDirect@save', {param:{branchID:vm.branchID,periodID:vm.periodIDs},aToken:aToken,page:'work-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						var prndata=response.prndata;
						if (prndata){
							if(__env.isDebug) console.log(prndata);
							var inp = prndata.split('~');						
							if(__env.isDebug) console.log(inp);									
							var status="";
							if(inp[0]!=""){								

								var printers=inp[1];
								var printerIP=$cookies.get("localPrinterIP");	

								//findPrinter(inp[1],printerIP);
								console.log(printers);

								//var config = { encoding: 'ISO-8859-1' };
								var config = "";
								var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
								//status=printData(config, data);
								status=printData(data,printers,config,printerIP);
								if(__env.isDebug) console.log("Print Status => ".status);
							}
						}							
						gotoReport();
																
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'work-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		function changeDate(){
			//alert(vm.salesDets.type);	
			if(vm.salesDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.salesDets.from = day;
				vm.salesDets.to = day;
				
			} else if(vm.salesDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.salesDets.from = day;
				vm.salesDets.to = day;
			} else if(vm.salesDets.type == 'This Week'){
				var date = moment();
				
				vm.salesDets.from = date.clone().startOf('isoWeek');
				vm.salesDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.salesDets.type == 'This Month'){
				var date = new Date();
								
				vm.salesDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.salesDets.from+" "+vm.salesDets.to);	
			workReportDets();
		}	
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.work-period',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.work-period', {
				url    : '/work-period',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/work-period/work-period.html',
						controller : 'WorkPeriodController as vm'
					},
					'toolbar@app'   : {
                        templateUrl: 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarControllerIn as vm'
                    }
				},
				resolve: {					
					PeriodList: function (msApi)
					{					
						return msApi.resolve('app.periodDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.work-period-list', {
				url    : '/work-period',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/work-period/work-period.html',
						controller : 'WorkPeriodController as vm'
					},
					'toolbar@app'   : {
                        templateUrl: 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarControllerIn as vm'
                    }
				},
				resolve: {					
					PeriodList: function (msApi)
					{					
						return msApi.resolve('app.periodDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/work-period');
			
			// Api						
			msApiProvider.register('app.periodDets', ['periodDets']);
			msApiProvider.register('app.saveStart', ['saveStart']);
			msApiProvider.register('app.saveEnd', ['saveEnd']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('work-period', {
				title : 'Dines',
				//icon  : 'icon-account-multiple',
				state : 'app.work-period',
				weight: 8
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.work-period')
        .controller('WorkPeriodController', WorkPeriodController);

    /** @ngInject */
    function WorkPeriodController(PeriodList, $state, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope,$cookies)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Work Period";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Work Periods" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		
		vm.periodList = PeriodList.data;
		if(__env.isDebug) console.log("List");
		if(__env.isDebug) console.log(vm.periodList);
		vm.branchID = vm.periodList.branchID;
        // Data				
		//vm.workPeriod = JSON.parse($window.localStorage['workperiodList']);
		//if(__env.isDebug) console.log('List');
		//if(__env.isDebug) console.log(vm.workPeriod);

		
		vm.periodID = '';
		if($window.localStorage['periodID']!=""){
			vm.periodID = JSON.parse($window.localStorage['periodID']);
		}
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.periodID);
		
		vm.startperiod = {workperiod_start_amount:'',workperiod_start_description:''};		
		vm.endperiod = {workperiod_end_amount:'',workperiod_end_description:''};
		
		//vm.periodID = '';
		vm.periodStatus = 0;
		
		if(vm.periodList.periodDets!=""){
			//vm.periodID = vm.periodList.periodDets.workperiod_id;
			vm.periodStatus = vm.periodList.periodDets.workperiod_status;	
		}		
		
		vm.listCell = 1;
		vm.startCell = 0;
		vm.endCell = 0;

		vm.endSave = 0;
		
						
		// Methods        
		vm.gotowork = gotowork;	
		vm.gotoLogin = gotoLogin;		
		vm.gotoDining = gotoDining;
		
		vm.startPeriod = startPeriod;
		vm.endPeriod = endPeriod;
		vm.saveStart = saveStart;
		vm.saveEnd = saveEnd;
		vm.cancelPeriod = cancelPeriod;
				
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
        
		function gotowork()
        {
			//alert("1");
			$window.localStorage['customKots'] = JSON.stringify("");
            $state.go('app.home-list');
        }								
		
		function gotoDining(work_id)
        {
			localStorage.setItem('workID',work_id);
			$state.go('app.dining');
        }
		
		function listPeriod(){
			vm.listCell = 1;
			vm.startCell = 0;
			vm.endCell = 0;	
		}
		
		function startPeriod(){
			vm.listCell = 0;
			vm.startCell = 1;
			vm.endCell = 0;	
		}
						
		function endPeriod(){
			vm.listCell = 0;
			vm.startCell = 0;
			vm.endCell = 1;	
		}
		
		function cancelPeriod(){
			vm.startperiod = {workperiod_start_amount:'',workperiod_start_description:''};		
			vm.endperiod = {workperiod_end_amount:'',workperiod_end_description:''};
			listPeriod();
		}
		
		function saveStart(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.startperiod);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.saveStart@save', {param:{startperiod:vm.startperiod,branchID:vm.branchID,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'work-period'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);	
						
						vm.periodID = response.data;
						//alert(vm.periodID);
						$window.localStorage['periodID'] = parseInt(JSON.stringify(vm.periodID));
						vm.periodStatus = 1;
						$mdToast.show(
							$mdToast.simple().textContent('Work Period Started').position('top right')
						);
						gotowork();
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function saveEnd(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.saveEnd);
			vm.endSave = 1;	
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.saveEnd@save', {param:{endperiod:vm.endperiod,periodID:vm.periodID,branchID:vm.branchID,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'work-period'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						if(__env.isDebug) console.log(response.prndata);
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);	
						vm.periodID = '';
						//alert(vm.periodID);
						$window.localStorage['periodID'] = vm.periodID;
						vm.periodStatus = 0;
						vm.endSave = 0;
						

						$mdToast.show(
							$mdToast.simple().textContent('Work Period Ended').position('top right')
						);
						

						vm.productList = JSON.parse($window.localStorage['productList']);
						for(var i=0;i<vm.productList.length;i++){			
							vm.optList=vm.productList[i].itmOptionsList;
							for(var op=0;op<vm.optList.length;op++){			
								vm.optList[op].unavailabeleStatus = 0;												
							}
							vm.productList[i].unavailableStatus = 0;																									
						}
						if(__env.isDebug) console.log("After unavailableItms");
						if(__env.isDebug) console.log(vm.productList);
						$window.localStorage['productList'] = JSON.stringify(vm.productList);

						gotowork();

						var prndata=response.prndata;
						if (prndata){
							if(__env.isDebug) console.log(prndata);
							var inp = prndata.split('~');						
							if(__env.isDebug) console.log(inp);									
							var status="";
							if(inp[0]!=""){								

								var printers=inp[1];
								var printerIP=$cookies.get("localPrinterIP");	

								//findPrinter(inp[1],printerIP);
								console.log(printers);
								

								//var config = { encoding: 'ISO-8859-1' };
								var config = "";
								var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
								//status=printData(config, data);
								status=printData(data,printers,config,printerIP);
								if(__env.isDebug) console.log("Print Status => ".status);
							}
						}
										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.wastage',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.wastage', {
				url    : '/wastage',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/wastage/wastage.html',
						controller : 'WastageListController as vm'
					}
				},
				resolve: {					
					WastageList: function (msApi)
					{					
						return msApi.resolve('app.wastageList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.wastage-list', {
				url    : '/wastage',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/wastage/wastage.html',
						controller : 'WastageListController as vm'
					}
				},
				resolve: {					
					WastageList: function (msApi)
					{					
						return msApi.resolve('app.wastageList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/wastage');
			
			// Api						
			msApiProvider.register('app.wastageList', ['wastageList']);						
			msApiProvider.register('app.wastagesave', ['wastagesave']);
			msApiProvider.register('app.wastageUpdate', ['wastageUpdate']);
			msApiProvider.register('app.getExpDate', ['getExpDate']);
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('wastage', {
				title : 'Wastage',
				//icon  : 'icon-account-multiple',
				state : 'app.wastage',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.wastage')
        .controller('WastageListController', WastageListController);

    /** @ngInject */
    function WastageListController($scope, $mdSidenav, WastageList, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window, $filter)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Wastage Entry";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Wastage" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
        if(__env.isDebug) console.log("Wastage Details");	
		vm.wastageDB = WastageList.data;        		     				
		if(__env.isDebug) console.log(vm.wastageDB);	
				
		vm.branchID = vm.wastageDB.branchID;
		vm.periodID = localStorage.getItem('periodID');
		vm.batchList = vm.wastageDB.batchList;	
		vm.search = "";	
		
		vm.mainChk = 0;
		for(var i=0;i<vm.batchList.length;i++){
			vm.batchList[i].selectedchk = 0;
			vm.batchList[i].wastageQty = vm.batchList[i].inventory_currqty;
		}
		if(__env.isDebug) console.log(vm.batchList);							
		
						
		// Methods
        vm.saveWastage = saveWastage;
		vm.gotoWastage = gotoWastage;
		vm.selectAll = selectAll;
		
        function gotoWastage()
        {
			//alert("1");
            //$state.go('app.wastage-list');

            if($state.current.name=="app.wastage"){
                $state.go('app.wastage-list');                
            } else if($state.current.name=="app.wastage-list"){
                $state.go('app.wastage');                 
            } else {
                $state.go('app.wastage'); 
            }
        }	

        function selectAll(){
			if(vm.mainChk==0){
				vm.mainChk=1;
				for(var i=0;i<vm.batchList.length;i++){
					vm.batchList[i].selectedchk = 1;
				}
			} else {
				vm.mainChk=0;	
				for(var i=0;i<vm.batchList.length;i++){
					vm.batchList[i].selectedchk = 0;
				}	
			}
		}

        	
        function saveWastage()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.batchList);	
			
			for (var i = 0; i < vm.batchList.length; i++) {
				vm.batchList[i].branchID = vm.branchID;
				vm.batchList[i].periodID = vm.periodID;
				/*if(vm.batchList[i].selectedchk == 1){
					vm.batchList[i].wastageQty = vm.batchList[i].inventory_currqty;
				}*/
			}
			
			if(__env.isDebug) console.log(vm.batchList);
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.wastagesave@save', {param:{batchList:vm.batchList,UserID:UserID,branchID:vm.branchID},aToken:aToken,page:'wastage'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);						
						if(response.data==1){
							$mdToast.show(
								$mdToast.simple().textContent('Wastage Saved Successfully').position('top right')
							);
							gotoWastage();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.warehousemenu',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.warehousemenu', {
				url    : '/warehousemenu',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/warehousemenu/warehousemenu.html',
						controller : 'WarehousemenuListController as vm'
					}
				},
				resolve: {					
					WarehousemenuList: function (msApi)
					{					
						return '';
					}, 
				}
			})
			.state('app.warehousemenu-list', {
				url    : '/warehousemenu',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/warehousemenu/warehousemenu.html',
						controller : 'WarehousemenuListController as vm'
					}
				},
				resolve: {					
					WarehousemenuList: function (msApi)
					{					
						return '';
					}, 
				}
			})	
			.state('app.warehousemenu.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/warehousemenu/new_warehousemenu/new_warehousemenu.html',
						controller : 'AddWarehousemenuController as vm'
					}
				},
				resolve: {
					Supplier: function (msApi)
					{
						return msApi.resolve('app.supplierAdd@get');
						//return '';
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.warehousemenu.edit', {
				url      : '/edit/:warehousemenu_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/warehousemenu/new_warehousemenu/new_warehousemenu.html',
						controller : 'EditWarehousemenuController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.warehousemenu.edit-list', {
				url      : '/edit/:warehousemenu_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/warehousemenu/new_warehousemenu/new_warehousemenu.html',
						controller : 'EditWarehousemenuController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/warehousemenu');
			
			// Api						
			msApiProvider.register('app.supplierList', ['supplierList']);
			msApiProvider.register('app.supplierSave', ['supplierSave']);
			msApiProvider.register('app.supplierUpdate', ['supplierUpdate']);
			msApiProvider.register('app.supplierAdd', ['supplierAdd']);
			msApiProvider.register('app.supplierEdit', ['supplierEdit']);
			msApiProvider.register('app.supplierDel', ['supplierDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('warehousemenu', {
				title : 'Warehousemenus',
				//icon  : 'icon-account-multiple',
				state : 'app.warehousemenu',
				weight: 20
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.warehousemenu')
        .controller('WarehousemenuListController', WarehousemenuListController);

    /** @ngInject */
    function WarehousemenuListController($state, WarehousemenuList, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Warehousemenu";
		
        // Data
        //vm.warehousemenu = WarehousemenuList.data;
		//if(__env.isDebug) console.log('List');
		//if(__env.isDebug) console.log(vm.warehousemenu);
        //vm.listForm={};
		
		/*if(vm.warehousemenu.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddWarehousemenu = gotoAddWarehousemenu;
		vm.warehousemenuPDFExport = staffPDFExport;
		vm.warehousemenuCSVExport = staffCSVExport;
		
		vm.gotowarehousemenu = gotowarehousemenu;	
		vm.editWarehousemenu = editWarehousemenu;
		vm.deleteWarehousemenu = deleteWarehousemenu;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddWarehousemenu()
        {
			 //alert("Hi");
			 $state.go('app.warehousemenu.add');
        } 
		
		function editWarehousemenu(warehousemenu_id)
        {
			 //alert(warehousemenu_id);
			 $state.go('app.warehousemenu.edit', {warehousemenu_id: warehousemenu_id});
        }
		
		function gotowarehousemenu()
        {
			//alert("1");
            $state.go('app.warehousemenu-list');
        }
		
		function gotoPayments(warehousemenu_id){
			$state.go('app.warehousemenu-payment', {warehousemenu_id: warehousemenu_id});
		}
						
		function deleteWarehousemenu(warehousemenu_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.warehousemenu);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this warehousemenu?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_supplier',param:{supplier_id:supplier_id},aToken:aToken,page:'supplier'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Supplier Deleted').position('top right')
							);
							gotowarehousemenu();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function staffPDFExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffPDFExport';			 			 
        } 
		
		function staffCSVExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffCSVExport';			 			 
        }
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.warehouse')
        .controller('WarehouseListController', WarehouseListController);

    /** @ngInject */
    function WarehouseListController($state, WarehouseList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Warehouse";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Warehouse master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
        vm.warehouse = WarehouseList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.warehouse);
        vm.listForm={};
		
		if(vm.warehouse.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddWarehouse = gotoAddWarehouse;		
		vm.gotowarehouse = gotowarehouse;	
		vm.editWarehouse = editWarehouse;
		vm.deleteWarehouse = deleteWarehouse;
		vm.gotoLogin = gotoLogin;
		
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddWarehouse()
        {
			 //alert("Hi");
			 $state.go('app.warehouse.add');
        } 
		
		function editWarehouse(warehouse_id)
        {
			 //alert(warehouse_id);
			 $state.go('app.warehouse.edit', {warehouse_id: warehouse_id});
        }
		
		function gotowarehouse()
        {
			//alert("1");
            $state.go('app.warehouse-list');
        }
		
					
		function deleteWarehouse(warehouse_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.warehouse);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this warehouse?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_warehouse',param:{warehouse_id:warehouse_id},aToken:aToken,page:'warehouse'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Warehouse Deleted').position('top right')
							);
							gotowarehouse();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter-sales-report')
        .controller('WaiterSalesReportController', WaiterSalesReportController);

    /** @ngInject */
    function WaiterSalesReportController(WaiterSalesReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Waiter Sales Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Waiter Sales Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data    
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		   
		vm.openingstockreportList = WaiterSalesReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.openingstockreportList);   
		vm.branchID = vm.openingstockreportList.branchID;
		vm.itemList = vm.openingstockreportList.itemList;
		vm.categoryList = vm.openingstockreportList.categoryList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.waiterSalesDets = {from:vm.openingstockreportList.from,to:vm.openingstockreportList.to,type:'Today'};
		
		vm.itemInventoryReport = "";
		vm.totalStock = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemPDFExport = itemPDFExport;
		vm.itemCSVExport = itemCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.openingstockreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function itemPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.waiterSalesDets.mode+"|"+vm.waiterSalesDets.from+"|"+vm.waiterSalesDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemPDFExport/'+vm.param;			 			 
        }
		
		function itemCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.waiterSalesDets.mode+"|"+vm.waiterSalesDets.from+"|"+vm.waiterSalesDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.opening-stock-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.waiterSalesDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.waiterSalesReportList2@save', {param:{waiterSalesDets:vm.waiterSalesDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.waiterSalesReport = vm.output.waiterSalesReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.waiterSalesDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type};														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.waiterSalesDets.type);	
			if(vm.waiterSalesDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.waiterSalesDets.from = day;
				vm.waiterSalesDets.to = day;
				
			} else if(vm.waiterSalesDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.waiterSalesDets.from = day;
				vm.waiterSalesDets.to = day;
			} else if(vm.waiterSalesDets.type == 'This Week'){
				var date = moment();
				
				vm.waiterSalesDets.from = date.clone().startOf('isoWeek');
				vm.waiterSalesDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.waiterSalesDets.type == 'This Month'){
				var date = new Date();
								
				vm.waiterSalesDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.waiterSalesDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.waiterSalesDets.from+" "+vm.waiterSalesDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.waiter')
        .controller('WaiterListController', WaiterListController);

    /** @ngInject */
    function WaiterListController($state, WaiterList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Waiter";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Waiters" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
		}

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Work Periods" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}
		
        // Data
        vm.waiter = WaiterList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.waiter);
        vm.listForm={};
		
		if(vm.waiter.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddWaiter = gotoAddWaiter;		
		vm.gotowaiter = gotowaiter;	
		vm.editWaiter = editWaiter;
		vm.deleteWaiter = deleteWaiter;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.setTables = setTables;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddWaiter()
        {
			 //alert("Hi");
			 $state.go('app.waiter.add');
        } 
		
		function editWaiter(waiter_id)
        {
			 //alert(waiter_id);
			 $state.go('app.waiter.edit', {waiter_id: waiter_id});
        }
		
		function gotowaiter()
        {
			//alert("1");
            $state.go('app.waiter-list');
        }
		
		function setTables(waiter_id)
        {			
            $state.go('app.waiter.tables', {waiter_id: waiter_id});
        }
		
		function gotoPayments(waiter_id){
			$state.go('app.waiter-payment', {waiter_id: waiter_id});
		}
						
		function deleteWaiter(waiter_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.waiter);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this waiter?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_waiter',param:{waiter_id:waiter_id},aToken:aToken,page:'waiter'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Waiter Deleted').position('top right')
							);
							gotowaiter();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.variance-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.variance-report', {
				url    : '/variance-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/variance-report/variance-report.html',
						controller : 'VarianceReportController as vm'
					}
				},
				resolve: {					
					VarianceReportList: function (msApi)
					{					
						return msApi.resolve('app.varianceReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.variance-report-list', {
				url    : '/variance-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/variance-report/variance-report.html',
						controller : 'VarianceReportController as vm'
					}
				},
				resolve: {					
					VarianceReportList: function (msApi)
					{
						
						return msApi.resolve('app.varianceReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/variance-report');
			
			// Api						
			msApiProvider.register('app.varianceReportList', ['varianceReportList']);
			msApiProvider.register('app.varianceReportList2', ['varianceReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.variance-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.variance-report')
        .controller('VarianceReportController', VarianceReportController);

    /** @ngInject */
    function VarianceReportController(VarianceReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Variance Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Stock Update Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data     
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		  
		vm.variancereportList = VarianceReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.variancereportList);   
		vm.branchID = vm.variancereportList.branchID;
		vm.itemList = vm.variancereportList.itemList;
		vm.categoryList = vm.variancereportList.categoryList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.varianceDets = {from:vm.variancereportList.from,to:vm.variancereportList.to,type:'Today',catID:vm.variancereportList.catID,itmID:vm.variancereportList.itmID};
		
		vm.varianceReport = "";
		vm.totalStock = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemPDFExport = itemPDFExport;
		vm.itemCSVExport = itemCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.variancereportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function itemPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.varianceDets.mode+"|"+vm.varianceDets.from+"|"+vm.varianceDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemPDFExport/'+vm.param;			 			 
        }
		
		function itemCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.varianceDets.mode+"|"+vm.varianceDets.from+"|"+vm.varianceDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.variance-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'variance-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'variance-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.varianceDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.varianceReportList2@save', {param:{varianceDets:vm.varianceDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'variance-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.varianceReport = vm.output.varianceReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.varianceDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,itmID:vm.output.itmID,catID:vm.output.catID};
					
					vm.totalStock = 0;
					for(var i=0;i<vm.varianceReport.length;i++){
						vm.totalStock = vm.totalStock + parseFloat(vm.varianceReport[i].variance_qty);
					}
										
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.varianceDets.type);	
			if(vm.varianceDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.varianceDets.from = day;
				vm.varianceDets.to = day;
				
			} else if(vm.varianceDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.varianceDets.from = day;
				vm.varianceDets.to = day;
			} else if(vm.varianceDets.type == 'This Week'){
				var date = moment();
				
				vm.varianceDets.from = date.clone().startOf('isoWeek');
				vm.varianceDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.varianceDets.type == 'This Month'){
				var date = new Date();
								
				vm.varianceDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.varianceDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.varianceDets.from+" "+vm.varianceDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.variance',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.variance', {
				url    : '/variance',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/variance/variance.html',
						controller : 'VarianceListController as vm'
					}
				},
				resolve: {					
					VarianceList: function (msApi)
					{					
						return msApi.resolve('app.varianceList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.variance-list', {
				url    : '/variance',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/variance/variance.html',
						controller : 'VarianceListController as vm'
					}
				},
				resolve: {					
					VarianceList: function (msApi)
					{					
						return msApi.resolve('app.varianceList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/variance');
			
			// Api						
			msApiProvider.register('app.varianceList', ['varianceList']);						
			msApiProvider.register('app.varianceSave', ['varianceSave']);
			msApiProvider.register('app.varianceUpdate', ['varianceUpdate']);
			msApiProvider.register('app.getExpDate', ['getExpDate']);
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('variance', {
				title : 'Variance',
				//icon  : 'icon-account-multiple',
				state : 'app.variance',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.variance')
        .controller('VarianceListController', VarianceListController);

    /** @ngInject */
    function VarianceListController($scope, $mdSidenav, VarianceList, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window, $filter)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Physical Stock Update";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Variance" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
        if(__env.isDebug) console.log("Variance Details");	
		vm.varianceDB = VarianceList.data;        		     				
		if(__env.isDebug) console.log(vm.varianceDB);	
				
		vm.branchID = vm.varianceDB.branchID;
		vm.periodID = localStorage.getItem('periodID');
		vm.itemStockList = vm.varianceDB.itemStockList;		
		vm.search = "";
		
		vm.mainChk = 0;
		for(var i=0;i<vm.itemStockList.length;i++){
			vm.itemStockList[i].physicalQty = vm.itemStockList[i].item_currqty;
			vm.itemStockList[i].varianceQty = parseFloat(vm.itemStockList[i].item_currqty) - parseFloat(vm.itemStockList[i].physicalQty);
			vm.itemStockList[i].remarks = "";
		}
		if(__env.isDebug) console.log(vm.itemStockList);							
		
						
		// Methods
        vm.saveVariance = saveVariance;
		vm.gotoVariance = gotoVariance;
		vm.selectAll = selectAll;
		vm.setVariance = setVariance;
		
        function gotoVariance()
        {
			//alert("1");
            //$state.go('app.variance-list');

            if($state.current.name=="app.variance"){
                $state.go('app.variance-list');                
            } else if($state.current.name=="app.variance-list"){
                $state.go('app.variance');                 
            } else {
                $state.go('app.variance'); 
            }
        }	

        function setVariance(){
        	for(var i=0;i<vm.itemStockList.length;i++){
				vm.itemStockList[i].varianceQty = parseFloat(vm.itemStockList[i].item_currqty) - parseFloat(vm.itemStockList[i].physicalQty);				
				if(isNaN(vm.itemStockList[i].varianceQty)){
					vm.itemStockList[i].varianceQty = 0;
				}
			}
        }

        function selectAll(){
			if(vm.mainChk==0){
				vm.mainChk=1;
				for(var i=0;i<vm.itemStockList.length;i++){
					vm.itemStockList[i].selectedchk = 1;
				}
			} else {
				vm.mainChk=0;	
				for(var i=0;i<vm.itemStockList.length;i++){
					vm.itemStockList[i].selectedchk = 0;
				}	
			}
		}

        	
        function saveVariance()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.itemStockList);	
			
			for (var i = 0; i < vm.itemStockList.length; i++) {
				vm.itemStockList[i].branchID = vm.branchID;
				vm.itemStockList[i].periodID = vm.periodID;				
			}
			
			if(__env.isDebug) console.log(vm.itemStockList);
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.varianceSave@save', {param:{itemStockList:vm.itemStockList,UserID:UserID,branchID:vm.branchID},aToken:aToken,page:'variance'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);						
						if(response.data==1){
							$mdToast.show(
								$mdToast.simple().textContent('Variance Saved Successfully').position('top right')
							);
							gotoVariance();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user-report')
        .controller('UserReportController', UserReportController);

    /** @ngInject */
    function UserReportController(UserReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "User Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="User Report" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data     
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		  
		vm.userreportList = UserReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.userreportList);   
		vm.branchID = vm.userreportList.branchID;
		vm.userList = vm.userreportList.userList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];
		vm.payMode = ["Cash","Card","UPI","Paytm","Zomato","Uber","Swiggy"];
		vm.userDets = {from:vm.userreportList.from,to:vm.userreportList.to,type:'Today',userID:vm.userreportList.userID};
		if(__env.isDebug) console.log(vm.userDets);   
		
		vm.userReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.userPDFExport = userPDFExport;
		vm.userCSVExport = userCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();
		
		if(__env.isDebug) console.log(vm.userreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function userPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'userPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.userDets.mode+"|"+vm.userDets.from+"|"+vm.userDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'userPDFExport/'+vm.param;			 			 
        }
		
		function userCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'userPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.userDets.mode+"|"+vm.userDets.from+"|"+vm.userDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'userCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.user-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'user-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'user-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.userDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.userReportList2@save', {param:{userDets:vm.userDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'user-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.userList = vm.output.userList;
					vm.userReportList = vm.output.dbListingBills;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.userDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,userID:vm.output.userID};
					
					vm.totalAmt = 0;
					vm.totalTax = 0;
					vm.totalNet = 0;
					for(var i=0;i<vm.userReportList.length;i++){
						vm.totalAmt = vm.totalAmt + parseFloat(vm.userReportList[i].bil_totalamt);
						vm.totalTax = vm.totalTax + parseFloat(vm.userReportList[i].bil_tottaxamt);
						vm.totalNet = vm.totalNet + parseFloat(vm.userReportList[i].bil_totalnetamt);	
					}
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.userDets.type);	
			if(vm.userDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.userDets.from = day;
				vm.userDets.to = day;
				
			} else if(vm.userDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.userDets.from = day;
				vm.userDets.to = day;
			} else if(vm.userDets.type == 'This Week'){
				var date = moment();
				
				vm.userDets.from = date.clone().startOf('isoWeek');
				vm.userDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.userDets.type == 'This Month'){
				var date = new Date();
								
				vm.userDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.userDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.userDets.from+" "+vm.userDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('UserListController', UserListController);

    /** @ngInject */
    function UserListController($state, UserList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "User";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Users" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.user = UserList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.user);
        vm.listForm={};
		
		if(vm.user.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddUser = gotoAddUser;		
		vm.gotouser = gotouser;	
		vm.editUser = editUser;
		vm.deleteUser = deleteUser;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddUser()
        {
			 //alert("Hi");
			 $state.go('app.user.add');
        } 
		
		function editUser(user_id)
        {
			 //alert(user_id);
			 $state.go('app.user.edit', {user_id: user_id});
        }
		
		function gotouser()
        {
			//alert("1");
            $state.go('app.user-list');
        }
		
		function gotoPayments(user_id){
			$state.go('app.user-payment', {user_id: user_id});
		}
						
		function deleteUser(user_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.user);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this user?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_user',param:{usr_id:user_id},aToken:aToken,page:'user'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('User Deleted').position('top right')
							);
							gotouser();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }										
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.units')
        .controller('UnitsListController', UnitsListController);

    /** @ngInject */
    function UnitsListController($state, UnitsList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Units";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables/Units" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.units = UnitsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.units);
        vm.listForm={};
		
		if(vm.units.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddUnits = gotoAddUnits;		
		vm.gotounits = gotounits;	
		vm.editUnits = editUnits;
		vm.deleteUnits = deleteUnits;
		vm.gotoLogin = gotoLogin;		
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddUnits()
        {
			 //alert("Hi");			

			$state.go('app.units.add');
        } 
		
		function editUnits(units_id)
        {
			 //alert(units_id);
			 $state.go('app.units.edit', {units_id: units_id});
        }
		
		function gotounits()
        {
			//alert("1");
            $state.go('app.units-list');
        }
							
		function deleteUnits(units_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.units);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this unit?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_units',param:{unit_id:units_id},aToken:aToken,page:'units'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Unit Deleted').position('top right')
							);
							gotounits();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.transferin')
        .controller('TransferinListController', TransferinListController);

    /** @ngInject */
    function TransferinListController($state, TransferinList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Transfer In";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Transfer In" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data        		
		vm.transfer = TransferinList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.transfer);
        vm.listForm={};
		
		/*if(vm.transfer.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gototransfer = gototransfer;	
		vm.editTransferin = editTransferin;
		vm.deleteTransferin = deleteTransferin;
		vm.gotoLogin = gotoLogin;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        
		function editTransferin(transfer_id)
        {
			 //alert(transfer_id);
			 $state.go('app.transferin.edit', {transfer_id: transfer_id});
        }
		
		function gototransfer()
        {
			//alert("1");
            $state.go('app.transferin-list');
        }
						
		function deleteTransferin(transfer_id)
        {
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.transfer);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this transfer?");
				if (r == true) {
					msApi.request('app.transferinDel@save', {param:{transfer_id:transfer_id},aToken:aToken,page:'transfer'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);	
							if(response.data!=""){
								$mdToast.show(
									$mdToast.simple().textContent('Transfer Deleted').position('top right')
								);
								gototransfer();					
							}
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.transfer')
        .controller('TransferListController', TransferListController);

    /** @ngInject */
    function TransferListController($state, TransferList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Transfer Out";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Transfer Out" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data        		
		vm.transfer = TransferList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.transfer);
        vm.listForm={};
		
		/*if(vm.transfer.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddTransfer = gotoAddTransfer;
		vm.gototransfer = gototransfer;	
		vm.editTransfer = editTransfer;
		vm.deleteTransfer = deleteTransfer;
		vm.gotoLogin = gotoLogin;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddTransfer()
        {
			 //alert("Hi");
			 $state.go('app.transfer.add');
        } 
		
		function editTransfer(transfer_id)
        {
			 //alert(transfer_id);
			 $state.go('app.transfer.edit', {transfer_id: transfer_id});
        }
		
		function gototransfer()
        {
			//alert("1");
            $state.go('app.transfer-list');
        }
						
		function deleteTransfer(transfer_id)
        {
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.transfer);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this transfer?");
				if (r == true) {
					msApi.request('app.transferDel@save', {param:{transfer_id:transfer_id},aToken:aToken,page:'transfer'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);	
							if(response.data!=""){
								$mdToast.show(
									$mdToast.simple().textContent('Transfer Deleted').position('top right')
								);
								gototransfer();					
							}
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar-inner')
        .controller('ToolbarControllerIn', ToolbarControllerIn);

    /** @ngInject */
    function ToolbarControllerIn(msApi, $rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, __env, $window, $mdDialog, $document, $cookies, $interval)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        //alert("In");

        vm.printHost = $cookies.get("localPrinterIP");
        createConnection(vm.printHost);    


        vm.printStatus=__env.printStatus;
        $timeout(function () {
            getPrinterStatus();
        }, 12000);

        /*if(checkConnection()==false){
            vm.printStatus = 0;
            __env.printStatus = 0;
            localStorage.setItem('PrinterStatus',0);                
        } else {
            vm.printStatus = 1;
            __env.printStatus = 1;
            localStorage.setItem('PrinterStatus',1);
        }*/
		
		vm.departmentList = JSON.parse($window.localStorage['departmentList']);
        vm.roleDeptList = JSON.parse($window.localStorage['roleDeptList']);

        console.log(vm.departmentList);
        
        for(var d=0;d<vm.departmentList.length;d++){
            for(var r=0;r<vm.roleDeptList.length;r++){
                //alert(vm.departmentList[d].department_id+" == "+vm.roleDeptList[r].dept_id+" && "+vm.roleDeptList[r].status+" == "+1);
                if(vm.departmentList[d].department_id == vm.roleDeptList[r].dept_id && vm.roleDeptList[r].status == 1){
                    //alert("IF");
                    vm.departmentList[d].show = 1;
                } else if(vm.departmentList[d].department_id == vm.roleDeptList[r].dept_id && vm.roleDeptList[r].status == 0){
                    //alert("ELSE");
                    vm.departmentList[d].show = 0;
                }
            }
        }    
		if(__env.isDebug) console.log("Tootbar");
		if(__env.isDebug) console.log(vm.departmentList);
        vm.printerStatus = localStorage.getItem('PrinterStatus');

        
        vm.billsBlock=0;

        if($window.localStorage['page']!=""){
            vm.page = JSON.parse($window.localStorage['page']);             
            if(vm.page["billsBlock"]==1){ vm.billsBlock=1; }           
        }

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            ar: {
                'title'      : 'Arabic',
                'translation': 'TOOLBAR.ARABIC',
                'code'       : 'ar',
                'flag'       : 'ar'
            }
        };
		vm.deptID="";
		//alert(localStorage.getItem('departmentID'));
		vm.deptID = localStorage.getItem('menuID');
		//alert(vm.deptID);
		vm.role = localStorage.getItem('UserRole');
		vm.kotExist = localStorage.getItem('ifKOTExist');	

        $rootScope.totalAlert = 0;
        vm.branchID = localStorage.getItem('BranchID');
        vm.alertList = JSON.parse($window.localStorage['customKots']);
        if(__env.isDebug) console.log("Alert List");
        if(__env.isDebug) console.log(vm.alertList);
        if(vm.alertList.length>0){
            $rootScope.totalAlert = vm.alertList.length;
        }
        //vm.totalAlert = $rootScope.totalAlert;
		
		vm.main = 0;
		//alert(vm.KOTItmCount);
		if(!vm.deptID){
			vm.main = 1;	
		}
		vm.show = 0;
		//alert(JSON.parse($window.localStorage['periodID']));
		//alert($window.localStorage['periodID']);
		if($window.localStorage['periodID']!=0){
			//alert("In")
			vm.show = 1;
		} /*else {
			vm.show = 1;
		}*/
		//alert(vm.show);
		//alert(vm.show);
		//alert(vm.deptID);
		//vm.AppSchoolName		= localStorage.getItem('AppSchoolName');
		//vm.AppSchoolName		= "Distributer App";
		//vm.CustomerName	= localStorage.getItem('UserName');
		//vm.SelectStudentRollNo	= localStorage.getItem('SelectStudentRollNo');
		vm.CustomerBranch = localStorage.getItem('UserBranchName');
		//vm.SelectStudentImage 	= localStorage.getItem('SelectStudentImage');
		
		vm.SelectStudentImg	= 'assets/images/avatars/profile.jpg';
		
		/*if(vm.SelectStudentImage!=""){			
			vm.SelectStudentImg	= __env.apiUrl+'view/userfiles/students/'+vm.SelectStudentImage;
		} else {
			vm.SelectStudentImg	= 'assets/images/avatars/profile.jpg';
		}*/

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;		
		vm.changeMenu = changeMenu;
		vm.setDepartment = setDepartment;
		vm.gotoHome = gotoHome;
		//vm.logout = logout;
		vm.gotoBills = gotoBills;
		
        vm.getPrinterStatus = getPrinterStatus;
		vm.openLocalPrinterDialog = openLocalPrinterDialog;
        vm.openPrinterSettings = openPrinterSettings;
        vm.toggleSidenavfour = toggleSidenavfour;

        vm.getNewAlert = getNewAlert;
        vm.orderdets = orderdets;
        //vm.setDepartment2 = setDepartment2;
				
        function toggleSidenavfour(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        //////////

        init();
		

        //vm.counter = 0;

        var syncTime = localStorage.getItem('BranchID')+"|"+JSON.parse($window.localStorage['lastAlertTime'])+"|"+localStorage.getItem('AppHost');   

        if(!$cookies.get("localNotificationEnable")==false && $cookies.get("localNotificationEnable")==1){            
            var w;
            if(isNaN(__env.orderWorker)==true) {
                w = __env.orderWorker;
            } 
            
            if(typeof(Worker) !== "undefined") {
                if(typeof(w) == "undefined") {
                    w = new Worker("check_custom_order.js");
                    if(__env.isDebug) console.log("Worker Registered");
                    __env.orderWorker = w;
                     w.postMessage(syncTime);
                } else {
                    if(__env.isDebug) console.log("Worker Exist");
                    //w.postMessage(syncTime);
                }                           
            } else {                             
                if(__env.isDebug) console.log("Sorry, your browser does not support Web Workers...");
            }

            
            //__env.orderWorker = w;
            
                            
            if(__env.isDebug) console.log("In Toolbar Worker");
            if(__env.isDebug) console.log(__env.orderWorker);
                        
            w.addEventListener('message', function(e) {               
                //vm.counter = e.data;
                if(__env.isDebug) console.log("List => "+e.data);

                if(e.data!=""){
                    var audio = new Audio('assets/sound/sound.mp3');
                    audio.play();

                    getNewAlert(e.data);                                
                }
            }, false);                  
            //__env.orderWorker=w;
        }

                            

        function getNewAlert(result){
            vm.branchID = localStorage.getItem('BranchID');
            var inp=(result).split("|");
            if(__env.isDebug) console.log("Input Data");
            if(__env.isDebug) console.log(inp);

            //alert("In");

            var aToken=localStorage.getItem('UserATK');
            if(aToken!=""){
                msApi.request('app.getCustomKotDets@save', {param:{cKotID:inp[1],branchID:vm.branchID},aToken:aToken,page:'alert'},
                    // SUCCESS
                    function (response){        
                        //alert("IF");
                        if(__env.isDebug) console.log("Success");
                        if(__env.isDebug) console.log(response.data);   
                        //alert(response.data.status);
                        var list = response.data.alertList;
                        if(list.length>0){
                            vm.alertList = JSON.parse($window.localStorage['customKots']);
                            if(__env.isDebug) console.log("Alert Old List");
                            if(__env.isDebug) console.log(vm.alertList);

                            for(var i=0;i<list.length;i++){
                                var ifIDE = 0;
                                for(var a=0;a<vm.alertList.length;a++){
                                    if(list[i].customerkot_id == vm.alertList[a].customerkot_id){
                                        ifIDE = ifIDE + 1;
                                    }
                                }
                                
                                //alert(ifIDE);
                                if(ifIDE==0){
                                    vm.alertList.push(list[i]);
                                }
                                
                            }

                            $window.localStorage['lastAlertTime'] = JSON.stringify(response.data.lastAlertTime);
                            if(__env.isDebug) console.log("Alert New List");
                            if(__env.isDebug) console.log(vm.alertList);
                            if(vm.alertList.length>0){
                                $rootScope.totalAlert = vm.alertList.length;
                            }                            
                            
                            $window.localStorage['customKots'] = JSON.stringify(vm.alertList);
                            $rootScope.$emit('changeAlerts','');
                            orderdets(list);
                        }
                    },
                    // ERROR
                    function (response){
                        //alert("ELSE");
                        if(__env.isDebug) console.log("Error");
                        if(__env.isDebug) console.log(response.data);
                    }
                );
            } else {
                $mdToast.show(
                    $mdToast.simple().textContent('Access Token Expired').position('top right')
                );
                //$state.go('app.login');   
            }
        }

        
        function orderdets(list,ev){
            $mdDialog.show({
                controller         : 'NotificationDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/login/dialogs/notification/notification-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    AlertList    : list,
                }                
            });
        }


       // console.log("OrderWorker=>"+__env.orderWorker);
        /*if (__env.orderWorker){
            var worker = __env.orderWorker;
            worker.addEventListener('message', function(e) {
               
                //vm.counter = e.data;
                console.log("List => "+e.data);
            }, false);
        }*/
        
		//worker.postMessage('Ibrahim');
        

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }
		

        function getPrinterStatus(){            
            if(checkConnection()==false){
                vm.printStatus = 0;
                __env.printStatus = 0;
                localStorage.setItem('PrinterStatus',0);   

                vm.printHost = $cookies.get("localPrinterIP");
                createConnection(vm.printHost);   
                $timeout(function () {
                    getPrinterStatus();
                }, 12000);           
            } else {
                vm.printStatus = 1;
                __env.printStatus = 1;
                localStorage.setItem('PrinterStatus',1);
            }
            //alert(vm.printStatus);
        }
		
		function logout()
        {
			//alert("1");
            $state.go('app.login');
        }
		
		function gotoBills(){
			//alert("in");
			vm.deptID = 'bills';	
			localStorage.setItem('menuID','bills');
            localStorage.setItem('departmentID',"");
			$state.go('app.bills');
		}

        $rootScope.$on('setDepartment2', function (events, data) {  
            localStorage.setItem('departmentID',data.customerkot_dept_id);
            localStorage.setItem('departmentType',data.department_type);            
            localStorage.setItem('menuID',data.customerkot_dept_id);  

            vm.departmentList = JSON.parse($window.localStorage['departmentList']);
            vm.deptTypeList = "";
            for(var d=0;d<vm.departmentList.length;d++){
                if(vm.departmentList[d].department_id == data.customerkot_dept_id){
                    vm.deptFlow = vm.departmentList[d]['deptFlow'];
                    vm.deptType = vm.deptFlow[0].deptopt_option;
                    //vm.deptTypeList = '';
                    for(var i=1;i<vm.deptFlow.length;i++){
                        vm.deptTypeList = vm.deptTypeList+","+vm.deptFlow[i].deptopt_option;        
                    }
                }

                for(var r=0;r<vm.roleDeptList.length;r++){
                    //alert(vm.departmentList[d].department_id+" == "+vm.roleDeptList[r].dept_id+" && "+vm.roleDeptList[r].status+" == "+1);
                    if(vm.departmentList[d].department_id == vm.roleDeptList[r].dept_id && vm.roleDeptList[r].status == 1){
                        //alert("IF");
                        vm.departmentList[d].show = 1;
                    } else if(vm.departmentList[d].department_id == vm.roleDeptList[r].dept_id && vm.roleDeptList[r].status == 0){
                        //alert("ELSE");
                        vm.departmentList[d].show = 0;
                    }
                }
            }
            vm.deptTypeList=vm.deptTypeList.substring(1);
            //alert(vm.deptType+" "+vm.deptTypeList);
            localStorage.setItem('deptTypeList',vm.deptTypeList);

            vm.deptID = localStorage.getItem('menuID');
            //alert(vm.deptID);

            if($state.current.name=="app.dining-custom-bill"){
                $state.go('app.dining-custom-bill-list', {bill_id: data.customerkot_id});                
            } else if($state.current.name=="app.dining-custom-bill-list"){
                $state.go('app.dining-custom-bill', {bill_id: data.customerkot_id});                 
            } else {
                $state.go('app.dining-custom-bill', {bill_id: data.customerkot_id}); 
            }
        });
				  

        function setDepartment(dept){
			//alert(localStorage.getItem('departmentID'));
            //alert(dept.department_id+" "+dept.department_type);

			if(localStorage.getItem('periodID') != ''){
				//localStorage.setItem('customerID','');
				//localStorage.setItem('tableID','');
				localStorage.setItem('departmentID',dept.department_id);
				localStorage.setItem('departmentType',dept.department_type);
                localStorage.setItem('menuID',dept.department_id);
				//$state.go('app.dining');	
				
				vm.deptID = localStorage.getItem('menuID');
				//alert(vm.deptID);
				vm.main = 0;	
				//if(__env.isDebug) console.log(dept);
				vm.deptFlow = dept['deptFlow'];
				if(__env.isDebug) console.log(vm.deptFlow);
				
				vm.deptType = vm.deptFlow[0].deptopt_option;
                //alert(vm.deptType);
				vm.deptTypeList = '';
				for(var i=1;i<vm.deptFlow.length;i++){
					vm.deptTypeList = vm.deptTypeList+","+vm.deptFlow[i].deptopt_option;		
				}
				vm.deptTypeList=vm.deptTypeList.substring(1);
				//alert(vm.deptType+" "+vm.deptTypeList);
				localStorage.setItem('deptTypeList',vm.deptTypeList);
                //alert(dept.department_type);
				if(dept.department_type=="Dining"){
					//$state.go('app.table');
                    //alert(vm.deptType);	
					if(vm.deptType=="table"){
						//$state.go('app.table');
                        //alert($state.current.name);
                        if($state.current.name=="app.table"){
                            $state.go('app.table-list', {}, {reload: true});                
                        } else if($state.current.name=="app.table-list"){
                            $state.go('app.table', {}, {reload: true});                 
                        } else {
                            $state.go('app.table', {}, {reload: true}); 
                        }
                        //$state.reload();
					} else {
						if(localStorage.getItem('deptTypeList')==""){
							localStorage.setItem('deptTypeList',vm.deptType);	
						}
						$state.go('app.dining', {}, {reload: true});	
					}
				} else if(dept.department_type=="Home Delivery"){
					//$state.go('app.customer-selection');
					if(vm.deptType=="customer-selection"){
						$state.go('app.customer-selection', {}, {reload: true});
					} else {
						$state.go('app.dining-customer', {}, {reload: true});	
					}
				} else if(dept.department_type=="Parcel"){
					//$state.go('app.dining-parcel');
					if(vm.deptType=="dining-parcel"){
						$state.go('app.dining-parcel', {}, {reload: true});
                        /*if(vm.deptType=="dining-parcel"){
                            $state.go('app.dining-parcel2');
                        } else {
                            $state.go('app.dining-parcel');    
                        }*/
                       // $state.reload();
					} else {
						if(localStorage.getItem('deptTypeList')==""){
							localStorage.setItem('deptTypeList',vm.deptType);	
						}
						$state.go('app.dining-parcel', {}, {reload: true});	
					}
                    //$state.reload();
				} else if(dept.department_type=="Retail"){
                    //$state.go('app.dining-parcel');
                    if(vm.deptType=="dining-retail"){
                        $state.go('app.dining-retail', {}, {reload: true});
                        /*if(vm.deptType=="dining-parcel"){
                            $state.go('app.dining-parcel2');
                        } else {
                            $state.go('app.dining-parcel');    
                        }*/
                       // $state.reload();
                    } else {
                        if(localStorage.getItem('deptTypeList')==""){
                            localStorage.setItem('deptTypeList',vm.deptType);   
                        }
                        $state.go('app.dining-retail', {}, {reload: true}); 
                    }
                } else {
					//$state.go('app.dining-online');
					/*if(vm.deptType=="dining-online"){
						$state.go('app.dining-online-list');
					} else {
						$state.go('app.dining-online');	
					}*/
                    //$state.reload();	

                    if($state.current.name=="app.dining-online"){
                        $state.go('app.dining-online-list', {}, {reload: true});                
                    } else if($state.current.name=="app.dining-online-list"){
                        $state.go('app.dining-online', {}, {reload: true});                 
                    } else {
                        $state.go('app.dining-online', {}, {reload: true}); 
                    }
				}

                vm.deptItems = dept.deptItems;
                vm.categoryList = JSON.parse($window.localStorage['categoryList']);
                vm.productList = JSON.parse($window.localStorage['productList']);

                for(var i=0;i<vm.categoryList.length;i++){
                    vm.categoryList[i].deptShow = 0;
                    if(vm.deptItems.length > 0){
                        for(var d=0;d<vm.deptItems.length;d++){
                            if(vm.deptItems[d].dept_map_category_id==0){
                                vm.categoryList[i].deptShow = 1;
                            } else {
                                if(vm.deptItems[d].dept_map_category_id == vm.categoryList[i].category_id){
                                    vm.categoryList[i].deptShow = 1;
                                }   
                            }
                        }
                    }
                }

                for(var i=0;i<vm.productList.length;i++){                               
                    vm.productList[i].deptShow = 0;
                    if(vm.deptItems.length > 0){
                        for(var d=0;d<vm.deptItems.length;d++){
                            if(vm.deptItems[d].dept_map_category_id==0 && vm.deptItems[d].dept_map_item_id==0){
                                vm.productList[i].deptShow = 1;
                            } else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id==0){
                                vm.productList[i].deptShow = 1;                             
                            } else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id!=0){
                                if(vm.deptItems[d].dept_map_item_id == vm.productList[i].item_id){
                                    vm.productList[i].deptShow = 1;                             
                                }
                            }   
                        }
                    }
                }

                $window.localStorage['categoryList'] = JSON.stringify(vm.categoryList);
                $window.localStorage['productList'] = JSON.stringify(vm.productList);

			} else {
				$state.go('app.home');
			}
		}
		
		function gotoHome(){			
			vm.main = 1;
			//alert(vm.main)
			localStorage.setItem('menuID','');
			$state.go('app.home');	
		}


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {            
            
            /*vm.lastAlertTime = JSON.parse($window.localStorage['lastAlertTime']);
            if(__env.isDebug) console.log("Input Data");
            if(__env.isDebug) console.log(vm.lastAlertTime);
            var aToken=localStorage.getItem('UserATK');
            if(aToken!=""){
                msApi.request('app.getCustomKots@save', {param:{lastAlertTime:vm.lastAlertTime,branchID:vm.branchID},aToken:aToken,page:'alert'},
                    // SUCCESS
                    function (response){        
                        //alert("IF");
                        if(__env.isDebug) console.log("Success");
                        if(__env.isDebug) console.log(response.data);   
                        //alert(response.data.status);
                        if(response.data.lastAlertTime!=""){
                            //vm.selectedParentDet = response.data;
                            var list = response.data.alertList;
                            for(var i=0;i<list.length;i++){
                                vm.alertList.push(list[i]);
                            }
                            if(__env.isDebug) console.log("Alert New List");
                            if(__env.isDebug) console.log(vm.alertList);
                            if(vm.alertList.length>0){
                                $rootScope.totalAlert = vm.alertList.length;
                            }
                            vm.totalAlert = $rootScope.totalAlert;

                            $window.localStorage['lastAlertTime'] = JSON.stringify(response.data.lastAlertTime);
                            $window.localStorage['customKots'] = JSON.stringify(vm.alertList);
                        }
                    },
                    // ERROR
                    function (response){
                        //alert("ELSE");
                        if(__env.isDebug) console.log("Error");
                        if(__env.isDebug) console.log(response.data);
                    }
                );
            } else {
                $mdToast.show(
                    $mdToast.simple().textContent('Access Token Expired').position('top right')
                );
                //$state.go('app.login');   
            }*/
               
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        /*function logout()
        {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            console.log("Language");
            console.log(lang);
            vm.selectedLanguage = lang;
            
            //vm.selectedLanguage = lang;
            //alert(vm.selectedLanguage);

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
           /* if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }*/
            
            // Change the language
            //alert(lang.code);
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
		
		function changeMenu(){
			//alert("Hi");
			vm.SelectStudentName	= localStorage.getItem('SelectStudentName');
			
			if(__env.isDebug) console.log("Name "+localStorage.getItem('SelectStudentName'));
			
			vm.SelectStudentRollNo	= localStorage.getItem('SelectStudentRollNo');
			vm.SelectStudentClass 	= localStorage.getItem('SelectStudentClass');
			vm.SelectStudentImage 	= localStorage.getItem('SelectStudentImage');
			
			if(vm.SelectStudentImage!=""){			
				vm.SelectStudentImg	= __env.apiUrl+'view/userfiles/students/'+vm.SelectStudentImage;
			} else {
				vm.SelectStudentImg	= 'assets/images/avatars/profile.jpg';
			}
		}
		
		
		function openLocalPrinterDialog(ev)
        {			
            $mdDialog.show({
                controller         : 'LocalPrinterDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/toolbar-inner/dialogs/local-printer/local-printer-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,               
            });
        }

        function openPrinterSettings(ev)
        {           
            $mdDialog.show({
                controller         : 'PrinterSettingsDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/toolbar-inner/dialogs/printer-settings/printer-settings-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true, 
                /*locals             : {
                    PrinterDets : "",                   
                } */             
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tickets',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.tickets', {
				url    : '/tickets',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/tickets/tickets.html',
						controller : 'TicketsListController as vm'
					}
				},
				resolve: {					
					TicketDets: function (msApi)
					{					
						return msApi.resolve('app.ticketDate@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.tickets-list', {
				url    : '/tickets',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/tickets/tickets.html',
						controller : 'TicketsListController as vm'
					}
				},
				resolve: {					
					TicketDets: function (msApi)
					{					
						return msApi.resolve('app.ticketDate@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/tickets');
			
			// Api						
			msApiProvider.register('app.ticketsList', ['ticketsList']);
			msApiProvider.register('app.ticketDate', ['ticketDate']);
			msApiProvider.register('app.cancelTicket', ['cancelTicket']);	
			msApiProvider.register('app.reprintTicket', ['reprintTicket']);	
														
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tickets')
        .controller('TicketsListController', TicketsListController);

    /** @ngInject */
    function TicketsListController($state, TicketDets, msApi, $window, __env, $mdToast, $rootScope, $cookies)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Tickets";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tickets" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}	
		
		vm.ticketDets = TicketDets.data;
		if(__env.isDebug) console.log(vm.ticketDets);
		
        // Data     		
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');


		vm.tickets = {fromDate:vm.ticketDets.fromDate,toDate:vm.ticketDets.toDate,status:'',mode:'',billno:''};
		if(__env.isDebug) console.log(vm.tickets);
        
        vm.ticketDets = [];
		vm.paymentDet = '';
		vm.reasonTag = 0;
		vm.payMode = ["Cash","Card","UPI","Paytm","Zomato","Uber","Swiggy"];
		vm.statuslist = ['Ordered','Completed','Cancelled'];

		vm.taxTotal = 0;
		vm.extraTotal = 0;
		vm.paymentTotal = 0;
		vm.showSummary = 0;
		
		
       	// Methods
        vm.listTickets = listTickets;
		vm.gotoLogin = gotoLogin;	
		vm.showItms = showItms;
		vm.cancelTicket = cancelTicket;
		vm.saveTickets = saveTickets;
		vm.printTicket = printTicket;
		vm.gotoTicket = gotoTicket;
		vm.billSummary = billSummary;
				
		listTickets();
		
        //////////	
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoTicket(bill){
			if(__env.isDebug) console.log("Bill Dets");
			if(__env.isDebug) console.log(bill);

			var deptType = bill.bil_type;			
			var billID =  bill.bil_id;
			//alert(deptType+" "+billID);
			localStorage.setItem('departmentType',deptType);
			localStorage.setItem('departmentID',bill.bil_dept_id);
			if(deptType=="Dining"){
				$state.go('app.dining-dining-bill', {bill_id: billID});
			} else if(deptType=="Home Delivery"){
				$state.go('app.dining-homedelivery-bill', {bill_id: billID});
			} else if(deptType=="Parcel"){
				$state.go('app.dining-parcel-bill', {bill_id: billID});
			} else if(deptType=="Retail"){
				$state.go('app.dining-retail-bill', {bill_id: billID});
			} else {
				$state.go('app.dining-online-bill', {bill_id: billID});
			}	


			vm.deptItems = "";
			vm.departmentList = JSON.parse($window.localStorage['departmentList']);
			for(var d=0;d<vm.departmentList.length;d++){
				if(vm.departmentList[d].department_id == bill.bil_dept_id){
					vm.deptItems = vm.departmentList[d].deptItems;
				}
			}
			
            vm.categoryList = JSON.parse($window.localStorage['categoryList']);
            vm.productList = JSON.parse($window.localStorage['productList']);

            for(var i=0;i<vm.categoryList.length;i++){
                vm.categoryList[i].deptShow = 0;
                if(vm.deptItems.length > 0){
                    for(var d=0;d<vm.deptItems.length;d++){
                        if(vm.deptItems[d].dept_map_category_id==0){
                            vm.categoryList[i].deptShow = 1;
                        } else {
                            if(vm.deptItems[d].dept_map_category_id == vm.categoryList[i].category_id){
                                vm.categoryList[i].deptShow = 1;
                            }   
                        }
                    }
                }
            }

            for(var i=0;i<vm.productList.length;i++){                               
                vm.productList[i].deptShow = 0;
                if(vm.deptItems.length > 0){
                    for(var d=0;d<vm.deptItems.length;d++){
                        if(vm.deptItems[d].dept_map_category_id==0 && vm.deptItems[d].dept_map_item_id==0){
                            vm.productList[i].deptShow = 1;
                        } else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id==0){
                            vm.productList[i].deptShow = 1;                             
                        } else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id!=0){
                            if(vm.deptItems[d].dept_map_item_id == vm.productList[i].item_id){
                                vm.productList[i].deptShow = 1;                             
                            }
                        }   
                    }
                }
            }

            $window.localStorage['categoryList'] = JSON.stringify(vm.categoryList);
            $window.localStorage['productList'] = JSON.stringify(vm.productList);	
		}
		
		function cancelTicket()
        {
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you want to Cancel this Ticket?");
				if (r == true) {
					vm.reasonTag = 1;		            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function printTicket()
        {
			var billID = vm.paymentDet.bil_id;
			//alert(billID);
			//$window.open(__env.apiUrl+'printTicket/'+billID);
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(billID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.reprintTicket@save', {param:{billID:billID},aToken:aToken,page:'work-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Dining Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);
						//printWebUSB("@@EaSiddique Kabab Centre - Head\n");
						vm.billDet = response.data;
						//alert(response.data);
						if(vm.billDet.billID){
							var webprint = __env.webprint;
							
							var billID=vm.billDet.billID;							
							var prndata=vm.billDet.prndata;
							
							//alert(prndata);
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);
									//webprint.printRaw(inp[0], inp[1]);
									
									/*if(inp[1]==0){
										webprint.printRaw(inp[0], inp[2]);
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){
											webprint.printRaw(inp[0], vm.printer);
										} else {
											webprint.printRaw(inp[0], inp[2]);	
										}
									}*/

									var printers="";
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										printers=inp[2];
										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){
											printers=vm.printer;				
										} else {											
											printers=inp[2];
										}
									}
									//alert(printers);
									console.log(printers);

									var config = qz.configs.create(printers, { encoding: 'ISO-8859-1' }); 
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									status=qz.print(config, data);
								}
							}																					 
						}									
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function saveTickets()
        {
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.paymentDet);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.cancelTicket@save', {param:{tickets:vm.paymentDet,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);	
						listTickets();
						vm.paymentDet = '';
						vm.reasonTag = 0;
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }

        function billSummary(){
			if (vm.showSummary==1) {
				vm.showSummary = 0;
			} else {
				vm.showSummary = 1;
			}
		}
        					
		function listTickets(tickets_id)
        {
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.tickets);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ticketsList@save', {param:{tickets:vm.tickets,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);	
						vm.tickets = response.data.tickets;
						vm.ticketDets = response.data.ticketDets;

						for(var i=0;i<vm.ticketDets.length;i++){
							vm.ticketDets[i].billTotal = parseFloat(vm.ticketDets[i].bil_totalnetamt) + parseFloat(vm.ticketDets[i].bil_totalround);
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function showItms(itmID){
			for(var i=0;i<vm.ticketDets.length;i++){
				if(vm.ticketDets[i].bil_id == itmID){
					//vm.ticketItms = vm.ticketDets[i].ticketItms;
					vm.paymentDet = vm.ticketDets[i];
				}	
			}
			//vm.discount = ((parseFloat(vm.paymentDet.bil_totalamt) + parseFloat(vm.paymentDet.bil_tottaxamt)) * parseFloat(vm.paymentDet.bil_discount))/100;
			//vm.discount = parseFloat(vm.paymentDet.bil_discountamt) + parseFloat(vm.paymentDet.bil_round);
			vm.discount = parseFloat(vm.paymentDet.bil_discountamt);
			//alert(vm.discount);


			vm.taxTotal = 0;
			vm.extraTotal = 0;
			vm.paymentTotal = 0;

			vm.taxList=vm.paymentDet.billTaxList;
			for(var t=0;t<vm.taxList.length;t++){
				if(vm.taxList[t].tax_amt>0){
					vm.taxTotal = vm.taxTotal + parseFloat(vm.taxList[t].tax_amt);	
				} else {
					vm.taxTotal = vm.taxTotal + parseFloat(vm.taxList[t].tax_amt2);	
				}											
			}

			vm.extraList=vm.paymentDet.billExtraList;
			for(var t=0;t<vm.extraList.length;t++){
				vm.extraTotal = vm.extraTotal + parseFloat(vm.extraList[t].extra_amt);																	
			}

			vm.paymentList=vm.paymentDet.billPaymentList;
			for(var t=0;t<vm.paymentList.length;t++){
				vm.paymentTotal = vm.paymentTotal + parseFloat(vm.paymentList[t].bill_amount);																	
			}			
		}	
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.template')
        .controller('TemplatesListController', TemplatesListController);

    /** @ngInject */
    function TemplatesListController($state, TemplatesList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Templates";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Templates" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.template = TemplatesList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.template);
        vm.listForm={};
		
		if(vm.template.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddTemplates = gotoAddTemplates;		
		vm.gotoTemplates = gotoTemplates;	
		vm.editTemplates = editTemplates;
		vm.deleteTemplates = deleteTemplates;
		vm.gotoLogin = gotoLogin;			
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddTemplates()
        {
			 //alert("Hi");
			 $state.go('app.template.add');
        } 
		
		function editTemplates(template_id)
        {
			 //alert(customer_id);
			 $state.go('app.template.edit', {template_id: template_id});
        }
		
		function gotoTemplates()
        {
			//alert("1");
            $state.go('app.template-list');
        }				
							
		function deleteTemplates(template_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.template);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this template?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_print_template',param:{template_id:template_id},aToken:aToken,page:'template'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Template Deleted').position('top right')
							);
							gotoTemplates();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tax')
        .controller('TaxListController', TaxListController);

    /** @ngInject */
    function TaxListController($state, TaxList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Tax";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tax Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
        vm.ordeTag = TaxList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordeTag);
        vm.listForm={};
		
		if(vm.ordeTag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddTax = gotoAddTax;		
		vm.gotoTax = gotoTax;	
		vm.editTax = editTax;
		vm.deleteTax = deleteTax;
		vm.gotoLogin = gotoLogin;	
		vm.mapTax = mapTax;
		vm.optionTax = optionTax;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddTax()
        {
			 //alert("Hi");
			 $state.go('app.tax.add');
        } 
		
		function editTax(tax_id)
        {
			 //alert(customer_id);
			 $state.go('app.tax.edit', {tax_id: tax_id});
        }
		
		function mapTax(tax_id)
        {
			 //alert(customer_id);
			 $state.go('app.tax.mapping', {tax_id: tax_id});
        }
		
		function optionTax(tax_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption', {tax_id: tax_id});
        }
		
		function gotoTax()
        {
			//alert("1");
            $state.go('app.tax-list');
        }
				
							
		function deleteTax(tax_id)
        {
			//alert(tax_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this tax?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_tax',param:{tax_id:tax_id},aToken:aToken,page:'tax'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_tax_mapping',param:{tax_map_tax_id:tax_id},aToken:aToken,page:'tax'},
								// SUCCESS
								function (response){		
									//alert("IF");
									//if(__env.isDebug) console.log("Success");
									//if(__env.isDebug) console.log(response.data);
									//alert(response.data);											
								},
								// ERROR
								function (response){
									//alert("ELSE");
									if(__env.isDebug) console.log("Error");
									console.error(response.data);
								}
							);
							
							
							$mdToast.show(
								$mdToast.simple().textContent('Tax Deleted').position('top right')
							);
							gotoTax();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.table',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.table', {
				url    : '/table',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/tables/table.html',
						controller : 'TableController as vm'
					}
				},
				resolve: {										
					TableDets: function (msApi)
					{
						
						return msApi.resolve('app.tableDets@get',{branchID:localStorage.getItem('BranchID')});					
					}
				}
			})
			.state('app.table-list', {
				url    : '/table',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/tables/table.html',
						controller : 'TableController as vm'
					}
				},
				resolve: {										
					TableDets: function (msApi)
					{
						
						return msApi.resolve('app.tableDets@get',{branchID:localStorage.getItem('BranchID')});					
					}
				}
			});

			// Translation
	    	$translatePartialLoaderProvider.addPart('app/main/apps/tables');
			
			// Api						
			msApiProvider.register('app.tableDets', ['tableDets']);
			msApiProvider.register('app.createBill', ['createBill']);
			msApiProvider.register('app.changeTableID', ['changeTableID']);
			msApiProvider.register('app.getTblStatus', ['getTblStatus']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('table', {
				title : 'Dines',
				//icon  : 'icon-account-multiple',
				state : 'app.table',
				weight: 8
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.table')
        .controller('TableController', TableController);

    /** @ngInject */
    function TableController($state, TableDets, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope, $mdDialog)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Dine-In";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="POS" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}
		
        // Data	
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		vm.tableDets = TableDets.data;
		vm.table = JSON.parse($window.localStorage['tableList']);
		vm.category = JSON.parse($window.localStorage['tableCategoryList']);
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.table);	
		if(__env.isDebug) console.log(vm.tableDets);
		vm.deptID = localStorage.getItem('departmentID');
		//alert(vm.deptID);	

		vm.catCount=0;
		for(var i=0;i<vm.category.length;i++){
			if(vm.category[i].scategory_dept_id==vm.deptID && vm.catCount==0){
				vm.catID = vm.category[i].scategory_id;
				vm.catCount=1;
			}
		}
		//vm.catID = vm.category[0].scategory_id;
		//alert(vm.catID);
		
		
		for(var i=0;i<vm.table.length;i++){
			vm.table[i].status = 0;		
			for(var j=0;j<vm.tableDets.tableDets.length;j++){
				//alert(vm.table[i].table_id+" == "+vm.tableDets.tableDets[j].bil_table_id);				
				if(vm.table[i].table_id == vm.tableDets.tableDets[j].bil_table_id && vm.tableDets.tableDets[j].bil_print==0){
					vm.table[i].status = 1;
					vm.table[i].startON = vm.tableDets.tableDets[j].bil_date;
					vm.table[i].amount = parseFloat(vm.tableDets.tableDets[j].bil_totalnetamt) + parseFloat(vm.tableDets.tableDets[j].bil_totalround);
					vm.table[i].time = vm.tableDets.tableDets[j].orderTime;
				} else if(vm.table[i].table_id == vm.tableDets.tableDets[j].bil_table_id && vm.tableDets.tableDets[j].bil_print==1){
					vm.table[i].status = 2;
					vm.table[i].startON = vm.tableDets.tableDets[j].bil_date;
					vm.table[i].amount = parseFloat(vm.tableDets.tableDets[j].bil_totalnetamt) + parseFloat(vm.tableDets.tableDets[j].bil_totalround);
					vm.table[i].time = vm.tableDets.tableDets[j].orderTime;
				}
			}
		}
		if(__env.isDebug) console.log(vm.table);
						
		// Methods        
		vm.gototable = gototable;	
		vm.gotoLogin = gotoLogin;
		vm.gotoDining = gotoDining;
		vm.setCategory = setCategory;
		vm.refreshTable = refreshTable;
		
		
		
        //////////
		
		function setCategory(catID){
			vm.catID = catID;
			//alert(vm.catID);
		}
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
        
		function gototable()
        {
			//alert("1");
            $state.go('app.table-list');
        }		
		
		function gotoDining(table_id)
        {			

			if(localStorage.getItem('tableChange')==1){
				//localStorage.setItem('tableChange','0');
				var tableID = localStorage.getItem('tableID'); 
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					
					msApi.request('app.getTblStatus@save', {param:{tableID:tableID,tableNewID:table_id,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);
							//localStorage.setItem('tableID',table_id);
							//$state.go('app.dining-table');
							if(response.data!=0){
								var confirm = $mdDialog.confirm()
					                .title('Table Merge Confirmation.')
					                .htmlContent('Customer already exist on your selected table, Do you want to merge with that table.')
					                .ariaLabel('Table Merge')
					                .targetEvent()
					                .ok('Merge Tables')
					                .cancel('No');

					            $mdDialog.show(confirm).then(function ()
					            {
									//alert("IF");					               
									changeTable(table_id);
					            }, function ()
					            {
					            	//alert("Else");	
					            	localStorage.setItem('tableChange','0');
					            });	
							} else {
								var confirm = $mdDialog.confirm()
					                .title('Table Merge Confirmation.')
					                .htmlContent('Do you want to merge with that table.')
					                .ariaLabel('Table Merge')
					                .targetEvent()
					                .ok('Merge Tables')
					                .cancel('No');

					            $mdDialog.show(confirm).then(function ()
					            {
									//alert("Else");					               
									changeTable(table_id);
					            }, function ()
					            {
					            	//alert("Else");	
					            	localStorage.setItem('tableChange','0');
					            });	
							}
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);										
				} else {
					$mdToast.show(
						$mdToast.simple().textContent('Access Token Expired').position('top right')
					);
					//$state.go('app.login');	
				}
			} else {
				localStorage.setItem('tableID',table_id);
				$state.go('app.dining-table');	
			}					
        }

        function changeTable(table_id)
        {			
			if(localStorage.getItem('tableChange')==1){
				localStorage.setItem('tableChange','0');
				var tableID = localStorage.getItem('tableID'); 
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.changeTableID@save', {param:{tableID:tableID,tableNewID:table_id,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);
							localStorage.setItem('tableID',table_id);
							$state.go('app.dining-table');
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);          
				} else {
					$mdToast.show(
						$mdToast.simple().textContent('Access Token Expired').position('top right')
					);
					//$state.go('app.login');	
				}
			} else {
				localStorage.setItem('tableID',table_id);
				$state.go('app.dining-table');	
			}					
        }

        function refreshTable(){
        	//alert($state.current.name);
        	/*if($state.current.name=="app.table"){
				$state.go('app.table-list');				
			} else if($state.current.name=="app.table-list"){
				$state.go('app.table');					
			}*/

			if(__env.isDebug) console.log("Refresh");
			$state.reload();
        }
						
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.support',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.support', {
				url    : '/support',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/support/support.html',
						controller : 'SupportController as vm'
					},
					'toolbar@app'   : {
                        templateUrl: 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarControllerIn as vm'
                    }
				},
				resolve: {					
					PeriodList: function (msApi)
					{					
						return msApi.resolve('app.periodDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.support-list', {
				url    : '/support',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/support/support.html',
						controller : 'SupportController as vm'
					},
					'toolbar@app'   : {
                        templateUrl: 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarControllerIn as vm'
                    }
				},
				resolve: {					
					PeriodList: function (msApi)
					{					
						return msApi.resolve('app.periodDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/support');
			
			// Api						
			msApiProvider.register('app.periodDets', ['periodDets']);
			msApiProvider.register('app.saveStart', ['saveStart']);
			msApiProvider.register('app.saveEnd', ['saveEnd']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('support', {
				title : 'Dines',
				//icon  : 'icon-account-multiple',
				state : 'app.support',
				weight: 8
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.support')
        .controller('SupportController', SupportController);

    /** @ngInject */
    function SupportController(PeriodList, $state, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope, $mdDialog, $document, $cookies)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Main Menu";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Support" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}	
		
		vm.periodList = PeriodList.data;
		if(__env.isDebug) console.log("List");
		if(__env.isDebug) console.log(vm.periodList);
		vm.role = localStorage.getItem('UserRole');
				
		
        // Data		
		vm.periodID = '';
		//vm.showPOS = 0;
		if($window.localStorage['periodID']!=""){
			vm.periodID = JSON.parse($window.localStorage['periodID']);
			//vm.showPOS = 1;
		}
		//alert(vm.showPOS);
		
		if(__env.isDebug) console.log('List 3');
		if(__env.isDebug) console.log(vm.periodID);
		vm.startperiod = {workperiod_start_amount:'',workperiod_start_description:''};		
		vm.endperiod = {workperiod_end_amount:'',workperiod_end_description:''};				
						
		// Methods        
		vm.gotoLogin = gotoLogin;						
		vm.logout = logout;			
		
		//////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }				
		
		function logout()
        {
			//alert("1");
            $state.go('app.login');
        }								        														
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.supplier')
        .controller('SupplierListController', SupplierListController);

    /** @ngInject */
    function SupplierListController($state, SupplierList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Supplier";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Suppliers" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.supplier = SupplierList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.supplier);
        vm.listForm={};
		
		if(vm.supplier.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddSupplier = gotoAddSupplier;		
		vm.gotosupplier = gotosupplier;	
		vm.editSupplier = editSupplier;
		vm.deleteSupplier = deleteSupplier;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddSupplier()
        {
			 //alert("Hi");
			 $state.go('app.supplier.add');
        } 
		
		function editSupplier(supplier_id)
        {
			 //alert(supplier_id);
			 $state.go('app.supplier.edit', {supplier_id: supplier_id});
        }
		
		function gotosupplier()
        {
			//alert("1");
            $state.go('app.supplier-list');
        }
		
		function gotoPayments(supplier_id){
			$state.go('app.supplier-payment', {supplier_id: supplier_id});
		}
						
		function deleteSupplier(supplier_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.supplier);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this supplier?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_supplier',param:{supplier_id:supplier_id},aToken:aToken,page:'supplier'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Supplier Deleted').position('top right')
							);
							gotosupplier();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }										
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.stock-update-report')
        .controller('StockUpdateReportController', StockUpdateReportController);

    /** @ngInject */
    function StockUpdateReportController(ItemReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Opening Stock Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Stock Update Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
			
		}
		
        // Data      
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		 
		vm.stockupdatereportList = ItemReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.stockupdatereportList);   
		vm.branchID = vm.stockupdatereportList.branchID;
		vm.itemList = vm.stockupdatereportList.itemList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.stockupdateDets = {from:vm.stockupdatereportList.from,to:vm.stockupdatereportList.to,type:'Today',itmID:vm.stockupdatereportList.itmID};
		
		vm.itemInventoryReport = "";
		vm.totalStock = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemPDFExport = itemPDFExport;
		vm.itemCSVExport = itemCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.stockupdatereportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function itemPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.stockupdateDets.mode+"|"+vm.stockupdateDets.from+"|"+vm.stockupdateDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemPDFExport/'+vm.param;			 			 
        }
		
		function itemCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.stockupdateDets.mode+"|"+vm.stockupdateDets.from+"|"+vm.stockupdateDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.stock-update-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'stock-update-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'stock-update-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.stockupdateDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.stockupdateReportList2@save', {param:{stockupdateDets:vm.stockupdateDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'stock-update-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.itemInventoryReport = vm.output.itemInventoryReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.stockupdateDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,itmID:vm.output.itmID};
					
					for(var i=0;i<vm.itemInventoryReport.length;i++){
						vm.totalStock = vm.totalStock + parseFloat(vm.itemInventoryReport[i].inventory_qty);
					}
										
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.stockupdateDets.type);	
			if(vm.stockupdateDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.stockupdateDets.from = day;
				vm.stockupdateDets.to = day;
				
			} else if(vm.stockupdateDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.stockupdateDets.from = day;
				vm.stockupdateDets.to = day;
			} else if(vm.stockupdateDets.type == 'This Week'){
				var date = moment();
				
				vm.stockupdateDets.from = date.clone().startOf('isoWeek');
				vm.stockupdateDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.stockupdateDets.type == 'This Month'){
				var date = new Date();
								
				vm.stockupdateDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.stockupdateDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.stockupdateDets.from+" "+vm.stockupdateDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.stock-report',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.stock-report', {
				url    : '/stock-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/stock-report/stock-report.html',
						controller : 'StockReportController as vm'
					}
				},
				resolve: {					
					StockReport: function (msApi)
					{					
						return msApi.resolve('app.stockreportList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.stock-report-list', {
				url    : '/stock-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/stock-report/stock-report.html',
						controller : 'StockReportController as vm'
					}
				},
				resolve: {					
					StockReport: function (msApi)
					{					
						return msApi.resolve('app.stockreportList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/stock-report');
			
			// Api						
			msApiProvider.register('app.stockreportList', ['stockreportList']);			
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('stock-report', {
				title : 'Purchase',
				//icon  : 'icon-account-multiple',
				state : 'app.stock-report',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.stock-report')
        .controller('StockReportController', StockReportController);

    /** @ngInject */
    function StockReportController($state, StockReport, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Stock Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Stock Report" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data        		
		vm.stockreport = StockReport.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.stockreport);
        vm.listForm={};
		
		/*if(vm.stockreport.error == "1"){
			gotoLogin();
		} */
		vm.stockList = vm.stockreport.stockreportList;
		for(var i=0;i<vm.stockList.length;i++){			
			if(vm.stockList[i].ingredients_min_qty <= vm.stockList[i].wstock_hqty && vm.stockList[i].ingredients_max_qty >= vm.stockList[i].wstock_hqty){
				//alert("IF 1");
				vm.stockList[i].wstock_type = 1;
			} else if(vm.stockList[i].wstock_hqty > vm.stockList[i].ingredients_max_qty){
				//alert("IF 3");	
				vm.stockList[i].wstock_type = 2;
			} else if(vm.stockList[i].ingredients_min_qty > vm.stockList[i].wstock_hqty){
				//alert("IF 2");	
				vm.stockList[i].wstock_type = 3;
			}				
		}
		if(__env.isDebug) console.log(vm.stockList);
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods        
		vm.gotoLogin = gotoLogin;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }        							
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.staff')
        .controller('StaffListController', StaffListController);

    /** @ngInject */
    function StaffListController($state, StaffList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Staff";
		
        // Data
        vm.staff = StaffList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.staff);
        vm.listForm={};
		
		if(vm.staff.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddStaff = gotoAddStaff;
		vm.staffPDFExport = staffPDFExport;
		vm.staffCSVExport = staffCSVExport;
		
		vm.gotostaff = gotostaff;	
		vm.editStaff = editStaff;
		vm.deleteStaff = deleteStaff;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddStaff()
        {
			 //alert("Hi");
			 $state.go('app.staff.add');
        } 
		
		function editStaff(staff_id)
        {
			 //alert(staff_id);
			 $state.go('app.staff.edit', {staff_id: staff_id});
        }
		
		function gotostaff()
        {
			//alert("1");
            $state.go('app.staff-list');
        }
		
		function gotoPayments(staff_id){
			$state.go('app.staff-payment', {staff_id: staff_id});
		}
						
		function deleteStaff(staff_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.staff);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this staff?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_staff',param:{staff_id:staff_id},aToken:aToken,page:'staff'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Staff Deleted').position('top right')
							);
							gotostaff();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function staffPDFExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffPDFExport';			 			 
        } 
		
		function staffCSVExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffCSVExport';			 			 
        }
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.short-expiry-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.short-expiry-report', {
				url    : '/short-expiry-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/short-expiry-report/short-expiry-report.html',
						controller : 'ShortExpiryReportController as vm'
					}
				},
				resolve: {					
					ShortExpiryReportList: function (msApi)
					{					
						return msApi.resolve('app.shortexpiryReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.short-expiry-report-list', {
				url    : '/short-expiry-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/short-expiry-report/short-expiry-report.html',
						controller : 'ShortExpiryReportController as vm'
					}
				},
				resolve: {					
					ShortExpiryReportList: function ($stateParams, shortexpiryreportService)
					{
						
						return msApi.resolve('app.shortexpiryReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/short-expiry-report');
			
			// Api						
			msApiProvider.register('app.shortexpiryReportList', ['shortexpiryReportList']);
			msApiProvider.register('app.shortexpiryReportList2', ['shortexpiryReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.short-expiry-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.short-expiry-report')
        .controller('ShortExpiryReportController', ShortExpiryReportController);

    /** @ngInject */
    function ShortExpiryReportController(ShortExpiryReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Short Expiry Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Stock Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data       

		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');

		
		vm.shortexpiryreportList = ShortExpiryReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.shortexpiryreportList);   
		vm.branchID = vm.shortexpiryreportList.branchID;
		vm.shortExpiryReport = vm.shortexpiryreportList.shortExpiryReport;

		vm.categoryList = vm.shortexpiryreportList.categoryList;
		vm.itemList = vm.shortexpiryreportList.itemList;

		vm.shortStockDets = {catID:vm.shortexpiryreportList.catID,itmID:vm.shortexpiryreportList.itmID};

		vm.totalStock = 0; vm.totalStock2 = 0;
		for(var i=0;i<vm.shortExpiryReport.length;i++){
			vm.totalStock = vm.totalStock + parseFloat(vm.shortExpiryReport[i].inventory_qty);
			vm.totalStock2 = vm.totalStock2 + parseFloat(vm.shortExpiryReport[i].inventory_currqty);
		}
					
		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.shortexpiryPDFExport = shortexpiryPDFExport;
		vm.shortexpiryCSVExport = shortexpiryCSVExport;
        //////////
		
		
		function shortexpiryPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'shortexpiryPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.shortexpiryDets.mode+"|"+vm.shortexpiryDets.from+"|"+vm.shortexpiryDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'shortexpiryPDFExport/'+vm.param;			 			 
        }
		
		function shortexpiryCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'shortexpiryPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.shortexpiryDets.mode+"|"+vm.shortexpiryDets.from+"|"+vm.shortexpiryDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'shortexpiryCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.short-expiry-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'short-expiry-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'short-expiry-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}    

		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.shortStockDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.shortexpiryReportList2@save', {param:{shortStockDets:vm.shortStockDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.shortExpiryReport = vm.output.shortExpiryReport;
					
					vm.categoryList = vm.output.categoryList;
					vm.itemList = vm.output.itemList;

					vm.shortStockDets = {catID:vm.output.catID,itmID:vm.output.itmID};
					
					for(var i=0;i<vm.shortExpiryReport.length;i++){
						vm.totalStock = vm.totalStock + parseFloat(vm.shortExpiryReport[i].inventory_qty);
						vm.totalStock2 = vm.totalStock2 + parseFloat(vm.shortExpiryReport[i].inventory_currqty);
					}
																								
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}    								
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.settings', {
				url    : '/settings',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/settings/settings.html',
						controller : 'SettingsController as vm'
					}
				},
				resolve: {					
					SettingsDet: function (msApi)
					{					
						return msApi.resolve('app.settingsDet@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.settings-list', {
				url    : '/settings',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/settings/settings.html',
						controller : 'SettingsController as vm'
					}
				},
				resolve: {					
					SettingsDet: function (msApi)
					{					
						return msApi.resolve('app.settingsDet@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        //$translatePartialLoaderProvider.addPart('app/main/apps/settings');
			
			// Api						
			msApiProvider.register('app.settingsDet', ['settingsDet']);
			msApiProvider.register('app.settingsUpdate', ['settingsUpdate']);					
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('settings', {
				title : 'Settingss',
				//icon  : 'icon-account-multiple',
				state : 'app.settings',
				weight: 2
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', SettingsController);

    /** @ngInject */
    function SettingsController($scope, $mdSidenav, SettingsDet, msUtils, $mdDialog, $document, msApi, $state, $mdToast, __env, $rootScope, $window)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Settings";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Settings" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data		
		vm.settingsDB = SettingsDet.data;
		if(__env.isDebug) console.log("Settings Det");
		if(__env.isDebug) console.log(vm.settingsDB);
		vm.settings = vm.settingsDB.settingDets;
		vm.printersList = vm.settingsDB.printersList;
		vm.expiryDays = [1,2,3,4,5,6,7,8,9,10];

		vm.billSeq = ['Yearly','Monthly','Daily'];

		if(__env.isDebug) console.log(vm.settings);
				
		if(vm.settingsDB.error == "1"){
			gotoLogin();
		} 								
              
		// Methods
        vm.saveSettings = saveSettings;
		vm.gotoSettings = gotoSettings;	
		vm.gotoLogin = gotoLogin;								
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
				
        function gotoSettings()
        {
			//alert("1");
            $state.go('app.settings-list');
        }
				
				
		function saveSettings()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.settings);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.settingsUpdate@save', {param:{settings:vm.settings,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'settings'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Settings Updated Successfully').position('top right')
						);
						gotoSettings();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }																
		
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.seats')
        .controller('SeatsListController', SeatsListController);

    /** @ngInject */
    function SeatsListController($state, SeatsList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Seats";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables/Seats" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.seats = SeatsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.seats);
        vm.listForm={};
		
		if(vm.seats.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddSeats = gotoAddSeats;		
		vm.gotoseats = gotoseats;	
		vm.editSeats = editSeats;
		vm.deleteSeats = deleteSeats;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddSeats()
        {
			 //alert("Hi");
			 $state.go('app.seats.add');
        } 
		
		function editSeats(seats_id)
        {
			 //alert(seats_id);
			 $state.go('app.seats.edit', {seats_id: seats_id});
        }
		
		function gotoseats()
        {
			//alert("1");
            $state.go('app.seats-list');
        }
		
		function gotoPayments(seats_id){
			$state.go('app.seats-payment', {seats_id: seats_id});
		}
						
		function deleteSeats(seats_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.seats);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this table?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_table',param:{table_id:seats_id},aToken:aToken,page:'seats'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Table Deleted').position('top right')
							);
							gotoseats();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scategory')
        .controller('ScategoryListController', ScategoryListController);

    /** @ngInject */
    function ScategoryListController($state, ScategoryList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Scategory";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Tables Categories" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.scategory = ScategoryList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.scategory);
        vm.listForm={};
		
		if(vm.scategory.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddScategory = gotoAddScategory;		
		vm.gotoscategory = gotoscategory;	
		vm.editScategory = editScategory;
		vm.deleteScategory = deleteScategory;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddScategory()
        {
			 //alert("Hi");
			 $state.go('app.scategory.add');
        } 
		
		function editScategory(scategory_id)
        {
			 //alert(scategory_id);
			 $state.go('app.scategory.edit', {scategory_id: scategory_id});
        }
		
		function gotoscategory()
        {
			//alert("1");
            $state.go('app.scategory-list');
        }
		
		function gotoPayments(scategory_id){
			$state.go('app.scategory-payment', {scategory_id: scategory_id});
		}
						
		function deleteScategory(scategory_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.scategory);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this table category?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_scategory',param:{scategory_id:scategory_id},aToken:aToken,page:'scategory'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Table Deleted').position('top right')
							);
							gotoscategory();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-tax-report')
        .controller('SalesTaxReportController', SalesTaxReportController);

    /** @ngInject */
    function SalesTaxReportController(SalesTaxReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Sales Exclusiove Tax Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Sales Tax Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data       
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		vm.salestaxreportList = SalesTaxReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.salestaxreportList);   
		vm.branchID = vm.salestaxreportList.branchID;
		vm.itemList = vm.salestaxreportList.itemList;
		vm.categoryList = vm.salestaxreportList.categoryList;
		
		vm.dateList = ['Current Month','Last Month','Custom'];		
		vm.salesTaxDets = {from:vm.salestaxreportList.from,to:vm.salestaxreportList.to,type:'Current Month'};
		
		vm.salesTaxReport = "";
		vm.totalStock = 0;
		vm.periodIDs = "";
		vm.totalBills=0; vm.totalAmount=0; vm.totalTaxs=0; vm.totalNett=0;

		for(var i=0;i<vm.salesTaxReport.length;i++){
			vm.totalBills = vm.totalBills + vm.salesTaxReport[i].billCount;
			vm.totalAmount = vm.totalAmount + vm.salesTaxReport[i].billAmount;
			vm.totalTaxs = vm.totalTaxs + vm.salesTaxReport[i].taxAmount;
			vm.totalNett = vm.totalNett + vm.salesTaxReport[i].totalAmount;
		}

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.salesTaxPDFExport = salesTaxPDFExport;
		vm.salesTaxCSVExport = salesTaxCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.salestaxreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function salesTaxPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.salesTaxDets.from+"|"+vm.salesTaxDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'salesTaxPDFExport/'+vm.param;			 			 
        }
		
		function salesTaxCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.salesTaxDets.from+"|"+vm.salesTaxDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'salesTaxCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.opening-stock-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.salesTaxDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.salesTaxReportList2@save', {param:{salesTaxDets:vm.salesTaxDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.salesTaxReport = vm.output.salesTaxReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.salesTaxDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type};														

					vm.totalBills=0; vm.totalAmount=0; vm.totalTaxs=0; vm.totalNett=0;

					for(var i=0;i<vm.salesTaxReport.length;i++){
						vm.totalBills = vm.totalBills + vm.salesTaxReport[i].billCount;
						vm.totalAmount = vm.totalAmount + vm.salesTaxReport[i].billAmount;
						vm.totalTaxs = vm.totalTaxs + vm.salesTaxReport[i].taxAmount;
						vm.totalNett = vm.totalNett + vm.salesTaxReport[i].totalAmount;
					}

				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.salesTaxDets.type);	
			if(vm.salesTaxDets.type == 'Current Month'){
				var date = new Date();
								
				vm.salesTaxDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesTaxDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			} else if(vm.salesTaxDets.type == 'Last Month'){
				var date = new Date();
								
				vm.salesTaxDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth())).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesTaxDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth())).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			} else if(vm.salesTaxDets.type == 'Custom'){
				var date = new Date();
								
				vm.salesTaxDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesTaxDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.salesTaxDets.from+" "+vm.salesTaxDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-report')
        .controller('SalesReportController', SalesReportController);

    /** @ngInject */
    function SalesReportController(SalesReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Sales Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Sales Report" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }
			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }
			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data      
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		 
		vm.salesreportList = SalesReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.salesreportList);   
		vm.branchID = vm.salesreportList.branchID;
		vm.tax = vm.salesreportList.workReportTax;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];
		vm.payMode = ["Cash","Card","UPI","Paytm","Zomato","Uber","Swiggy"];
		vm.salesDets = {from:vm.salesreportList.from,to:vm.salesreportList.to,type:'Today',mode:vm.salesreportList.mode};
		
		vm.salesReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.salesPDFExport = salesPDFExport;
		vm.salesCSVExport = salesCSVExport;
		vm.changeDate = changeDate;
		
		/*alert(vm.salesDets.type);
		var date = new Date();
		vm.salesDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		vm.salesDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		alert(vm.salesDets.from+" "+vm.salesDets.to);*/
		changeDate();
		
		/*for(var i=0;i<vm.salesreportList.workReportBillItems.length;i++){
			vm.salesreportList.workReportBillItems[i].bitm_tax = parseFloat((vm.salesreportList.workReportBillItems[i].bitm_total * vm.tax)/100);
			
			vm.salesreportList.workReportBillItems[i].bitm_taxtotal = parseFloat(vm.salesreportList.workReportBillItems[i].bitm_tax) + parseFloat(vm.salesreportList.workReportBillItems[i].bitm_total);
		}*/
		if(__env.isDebug) console.log(vm.salesreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function salesPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'salesPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.salesDets.mode+"|"+vm.salesDets.from+"|"+vm.salesDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'salesPDFExport/'+vm.param;			 			 
        }
		
		function salesCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'salesPDFExport/'+vm.branchID);
			 //alert(vm.salesDets.from);
			 //alert(vm.salesDets.to);
			 vm.param = vm.branchID+"|"+vm.salesDets.mode+"|"+vm.salesDets.from+"|"+vm.salesDets.to;
			 //alert(vm.param);
			 console.log(vm.param);
			 $window.location.href = __env.apiUrl+'salesCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.sales-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'sales-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'sales-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.salesDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.salesReportList2@save', {param:{salesDets:vm.salesDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'sales-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.tax = vm.output.workReportTax;
					vm.salesReportList = vm.output.dbListingBills;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.salesDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,mode:vm.output.mode};
					
					vm.totalAmt = 0;
					vm.totalTax = 0;
					vm.totalNet = 0;
					for(var i=0;i<vm.salesReportList.length;i++){
						vm.totalAmt = vm.totalAmt + parseFloat(vm.salesReportList[i].bil_totalamt);
						vm.totalTax = vm.totalTax + parseFloat(vm.salesReportList[i].bil_tottaxamt);
						vm.totalNet = vm.totalNet + parseFloat(vm.salesReportList[i].bil_totalnetamt);	
					}
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.salesDets.type);	
			if(vm.salesDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.salesDets.from = day;
				vm.salesDets.to = day;
				
			} else if(vm.salesDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.salesDets.from = day;
				vm.salesDets.to = day;
			} else if(vm.salesDets.type == 'This Week'){
				var date = moment();
				
				vm.salesDets.from = date.clone().startOf('isoWeek');
				vm.salesDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.salesDets.type == 'This Month'){
				var date = new Date();
								
				vm.salesDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.salesDets.from+" "+vm.salesDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sales-intax-report')
        .controller('SalesInTaxReportController', SalesInTaxReportController);

    /** @ngInject */
    function SalesInTaxReportController(SalesTaxReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Sales Inclusive Tax Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Sales Tax Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data     
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		  
		vm.salestaxreportList = SalesTaxReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.salestaxreportList);   
		vm.branchID = vm.salestaxreportList.branchID;
		vm.itemList = vm.salestaxreportList.itemList;
		vm.categoryList = vm.salestaxreportList.categoryList;
		
		vm.dateList = ['Current Month','Last Month','Custom'];		
		vm.salesTaxDets = {from:vm.salestaxreportList.from,to:vm.salestaxreportList.to,type:'Current Month'};
		
		vm.salesInTaxReport = "";
		vm.totalStock = 0;
		vm.periodIDs = "";
		vm.totalBills=0; vm.totalAmount=0; vm.totalTaxs=0; vm.totalNett=0;

		for(var i=0;i<vm.salesInTaxReport.length;i++){
			vm.totalBills = vm.totalBills + vm.salesInTaxReport[i].billCount;
			vm.totalAmount = vm.totalAmount + vm.salesInTaxReport[i].billAmount;
			vm.totalTaxs = vm.totalTaxs + vm.salesInTaxReport[i].taxAmount;
			vm.totalNett = vm.totalNett + vm.salesInTaxReport[i].totalAmount;
		}

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.salesTaxPDFExport = salesTaxPDFExport;
		vm.salesTaxCSVExport = salesTaxCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.salestaxreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function salesTaxPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.salesTaxDets.from+"|"+vm.salesTaxDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'salesTaxPDFExport/'+vm.param;			 			 
        }
		
		function salesTaxCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.salesTaxDets.from+"|"+vm.salesTaxDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'salesTaxCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.opening-stock-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.salesTaxDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.salesInTaxReportList2@save', {param:{salesTaxDets:vm.salesTaxDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.salesInTaxReport = vm.output.salesInTaxReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.salesTaxDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type};														

					vm.totalBills=0; vm.totalAmount=0; vm.totalTaxs=0; vm.totalNett=0;

					for(var i=0;i<vm.salesInTaxReport.length;i++){
						vm.totalBills = vm.totalBills + vm.salesInTaxReport[i].billCount;
						vm.totalAmount = vm.totalAmount + vm.salesInTaxReport[i].billAmount;
						vm.totalTaxs = vm.totalTaxs + vm.salesInTaxReport[i].taxAmount;
						vm.totalNett = vm.totalNett + vm.salesInTaxReport[i].totalAmount;
					}

				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.salesTaxDets.type);	
			if(vm.salesTaxDets.type == 'Current Month'){
				var date = new Date();
								
				vm.salesTaxDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesTaxDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			} else if(vm.salesTaxDets.type == 'Last Month'){
				var date = new Date();
								
				vm.salesTaxDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth())).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesTaxDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth())).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			} else if(vm.salesTaxDets.type == 'Custom'){
				var date = new Date();
								
				vm.salesTaxDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesTaxDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.salesTaxDets.from+" "+vm.salesTaxDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesController', SalesController);

    /** @ngInject */
    function SalesController(SalesList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Sales Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Sales Report" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data       
		vm.salesreportList = SalesList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.salesreportList);  
		vm.branchID = vm.salesreportList.branchID; 
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.salesDets = {from:vm.salesreportList.from,to:vm.salesreportList.to,type:'Today'};
		
		vm.salesReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		
		vm.salesExport = salesExport;
		vm.taxExport = taxExport;
		vm.realisationExport = realisationExport;
		vm.changeDate = changeDate;
		vm.listReport = listReport;
		
		changeDate();		
		if(__env.isDebug) console.log(vm.salesreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
					
		function salesExport()
        {			
			 vm.param = vm.branchID+"|"+vm.salesDets.from+"|"+vm.salesDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'salesExport/'+vm.param;			 			 
        }

        function taxExport()
        {			
			 vm.param = vm.branchID+"|"+vm.salesDets.from+"|"+vm.salesDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'taxExport/'+vm.param;			 			 
        }

        function realisationExport()
        {			
			 vm.param = vm.branchID+"|"+vm.salesDets.from+"|"+vm.salesDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'realisationExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }									
				
		function changeDate(){
			//alert(vm.salesDets.type);	
			if(vm.salesDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.salesDets.from = day;
				vm.salesDets.to = day;
				
			} else if(vm.salesDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.salesDets.from = day;
				vm.salesDets.to = day;
			} else if(vm.salesDets.type == 'This Week'){
				var date = moment();
				
				vm.salesDets.from = date.clone().startOf('isoWeek');
				vm.salesDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.salesDets.type == 'This Month'){
				var date = new Date();
								
				vm.salesDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.salesDets.from+" "+vm.salesDets.to);	
			listReport();			
		}

		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.salesDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.salesReportList3@save', {param:{salesDets:vm.salesDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'sales-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;					
					vm.salesDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type};									
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .controller('RolesListController', RolesListController);

    /** @ngInject */
    function RolesListController($state, RolesList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Roles";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Users Roles" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.roles = RolesList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.roles);
        vm.listForm={};
		
		if(vm.roles.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddRoles = gotoAddRoles;		
		vm.gotoroles = gotoroles;	
		vm.editRoles = editRoles;
		vm.deleteRoles = deleteRoles;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddRoles()
        {
			 //alert("Hi");
			 $state.go('app.roles.add');
        } 
		
		function editRoles(roles_id)
        {
			 //alert(roles_id);
			 $state.go('app.roles.edit', {roles_id: roles_id});
        }
		
		function gotoroles()
        {
			//alert("1");
            $state.go('app.roles-list');
        }
		
		function gotoPayments(roles_id){
			$state.go('app.roles-payment', {roles_id: roles_id});
		}
						
		function deleteRoles(roles_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.roles);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this roles?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_roles',param:{roles_id:roles_id},aToken:aToken,page:'roles'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Roles Deleted').position('top right')
							);
							gotoroles();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }										
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.reset-password', {
            url      : '/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.reset-password': {
                    templateUrl: 'app/main/apps/reset-password/reset-password.html',
                    controller : 'ResetController as vm'
                }
            },
			resolve: {
				SystemDets: function (msApi)
				{
					return msApi.resolve('app.systemDets@get');
				}    
			},
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/reset-password');
		
		msApiProvider.register('app.parentReset', ['parentReset']);
		msApiProvider.register('app.systemDets', ['systemDets']);

        // Navigation
        /*msNavigationServiceProvider.saveItem('apps.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reset-password')
        .controller('ResetController', ResetController);

    /** @ngInject */
    function ResetController(SystemDets, $mdToast, $document, msApi, $state, __env)
    {
        // Data
		var vm = this;
		vm.resetData = [];
		
		vm.systemDets = SystemDets.data;
		//if(__env.isDebug) console.log(vm.systemDets);
		
		vm.schoolName = vm.systemDets.genset_school_name;
		vm.schoolLogo = vm.systemDets.genset_logo;
		vm.schoolImage = vm.systemDets.genset_image;
		
		if(vm.schoolImage!=""){
			vm.files = {
				url	: __env.apiUrl+'view/userfiles/logo/'+vm.schoolImage
			};
		} else {
			vm.files = {
				url	: 'assets/images/avatars/profile.jpg'
			};
		}
		if(__env.isDebug) console.log(vm.files);

        // Methods
		
		vm.resetPassword = resetPassword;
		//vm.gotoResetPassword = gotoResetPassword;

        //////////
		
		/** Check Login **/
		
		function resetPassword(){
			if(__env.isDebug) console.log("Input Data");
			if(__env.isDebug) console.log(vm.resetData);
			var UserID = localStorage.getItem('UserID');
			msApi.request('app.parentReset@save', {param:{userID:UserID,otp:vm.resetData.otp_no,password:vm.resetData.password}},
				// SUCCESS
				function (response){		
					//alert("IF");
					if(__env.isDebug) console.log("Success");
					if(__env.isDebug) console.log(response.data);	
					//alert(response.data);
					if(response.data!=0){
						//vm.selectedParentDet = response.data;
						var inp = (response.data).split(':');
						localStorage.clear();
						//localStorage.setItem('UserMobNo',inp[2]);
						//localStorage.setItem('UserPassword',inp[3]);
						//localStorage.setItem('UserID',inp[0]);
						//localStorage.setItem('UserName',inp[1]);
						$mdToast.show(
							$mdToast.simple().textContent('Password Resetted Successfully').position('top right')
						);
						gotoLogin();						
					} else if(response.data==0){
						$mdToast.show(
							$mdToast.simple().textContent('Invalide Mobile No').position('top right')
						);
					}
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					if(__env.isDebug) console.log(response.data);
				}
			);
		}
		
		/** Login Redirection **/
		
		function gotoLogin()
        {
			//var param = localStorage.setItem('UserID');
			//alert(param);
			$state.go('app.login');
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reportmenu',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.reportmenu', {
				url    : '/reportmenu',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/reportmenu/reportmenu.html',
						controller : 'ReportmenuListController as vm'
					}
				},
				resolve: {					
					ReportmenuList: function (msApi)
					{					
						return '';
					}, 
				}
			})
			.state('app.reportmenu-list', {
				url    : '/reportmenu',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/reportmenu/reportmenu.html',
						controller : 'ReportmenuListController as vm'
					}
				},
				resolve: {					
					ReportmenuList: function (msApi)
					{					
						return '';
					}, 
				}
			})	
			.state('app.reportmenu.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/reportmenu/new_reportmenu/new_reportmenu.html',
						controller : 'AddReportmenuController as vm'
					}
				},
				resolve: {
					Supplier: function (msApi)
					{
						return msApi.resolve('app.supplierAdd@get');
						//return '';
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.reportmenu.edit', {
				url      : '/edit/:reportmenu_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/reportmenu/new_reportmenu/new_reportmenu.html',
						controller : 'EditReportmenuController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.reportmenu.edit-list', {
				url      : '/edit/:reportmenu_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/reportmenu/new_reportmenu/new_reportmenu.html',
						controller : 'EditReportmenuController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/reportmenu');
			
			// Api						
			msApiProvider.register('app.supplierList', ['supplierList']);
			msApiProvider.register('app.supplierSave', ['supplierSave']);
			msApiProvider.register('app.supplierUpdate', ['supplierUpdate']);
			msApiProvider.register('app.supplierAdd', ['supplierAdd']);
			msApiProvider.register('app.supplierEdit', ['supplierEdit']);
			msApiProvider.register('app.supplierDel', ['supplierDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('reportmenu', {
				title : 'Reportmenus',
				//icon  : 'icon-account-multiple',
				state : 'app.reportmenu',
				weight: 20
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reportmenu')
        .controller('ReportmenuListController', ReportmenuListController);

    /** @ngInject */
    function ReportmenuListController($state, ReportmenuList, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Reportmenu";
		
        // Data
        //vm.reportmenu = ReportmenuList.data;
		//if(__env.isDebug) console.log('List');
		//if(__env.isDebug) console.log(vm.reportmenu);
        //vm.listForm={};
		
		/*if(vm.reportmenu.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddReportmenu = gotoAddReportmenu;
		vm.reportmenuPDFExport = staffPDFExport;
		vm.reportmenuCSVExport = staffCSVExport;
		
		vm.gotoreportmenu = gotoreportmenu;	
		vm.editReportmenu = editReportmenu;
		vm.deleteReportmenu = deleteReportmenu;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddReportmenu()
        {
			 //alert("Hi");
			 $state.go('app.reportmenu.add');
        } 
		
		function editReportmenu(reportmenu_id)
        {
			 //alert(reportmenu_id);
			 $state.go('app.reportmenu.edit', {reportmenu_id: reportmenu_id});
        }
		
		function gotoreportmenu()
        {
			//alert("1");
            $state.go('app.reportmenu-list');
        }
		
		function gotoPayments(reportmenu_id){
			$state.go('app.reportmenu-payment', {reportmenu_id: reportmenu_id});
		}
						
		function deleteReportmenu(reportmenu_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.reportmenu);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this reportmenu?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_supplier',param:{supplier_id:supplier_id},aToken:aToken,page:'supplier'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Supplier Deleted').position('top right')
							);
							gotoreportmenu();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function staffPDFExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffPDFExport';			 			 
        } 
		
		function staffCSVExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffCSVExport';			 			 
        }
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.report', {
				url    : '/report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/report/report.html',
						controller : 'ReportController as vm'
					}
				},
				resolve: {					
					ReportList: function (msApi)
					{					
						return "";
					}, 
				}
			})
			.state('app.report-list', {
				url    : '/report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/report/report.html',
						controller : 'ReportController as vm'
					}
				},
				resolve: {					
					ReportList: function ()
					{
						
						return "";						
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/report');
			
			// Api													
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report')
        .controller('ReportController', ReportController);

    /** @ngInject */
    function ReportController(ReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Reports list";
		

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }
			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }
			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data       		
		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.gotoReport = gotoReport;
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.report-list');
        }				
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.recipes')
        .controller('RecipesListController', RecipesListController);

    /** @ngInject */
    function RecipesListController($state, RecipesList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Recipes";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Recipes" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data        		
		vm.recipes = RecipesList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.recipes);
        vm.listForm={};
		
		/*if(vm.recipes.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddRecipes = gotoAddRecipes;
			
		vm.gotorecipes = gotorecipes;	
		vm.editRecipes = editRecipes;
		vm.deleteRecipes = deleteRecipes;
		vm.gotoLogin = gotoLogin;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddRecipes()
        {
			 //alert("Hi");
			 $state.go('app.recipes.add');
        } 
		
		function editRecipes(recipes_id)
        {
			 //alert(recipes_id);
			 $state.go('app.recipes.edit', {recipes_id: recipes_id});
        }
		
		function gotorecipes()
        {
			//alert("1");
            $state.go('app.recipes-list');
        }
						
		function deleteRecipes(recipes_id)
        {
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.recipes);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this recipes?");
				if (r == true) {
					msApi.request('app.recipesDel@save', {param:{recipes_id:recipes_id},aToken:aToken,page:'recipes'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);	
							if(response.data!=""){
								$mdToast.show(
									$mdToast.simple().textContent('Recipes Deleted').position('top right')
								);
								gotorecipes();					
							}
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }												
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.purchasei')
        .controller('PurchaseiListController', PurchaseiListController);

    /** @ngInject */
    function PurchaseiListController($state, PurchaseiList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Item Purcahse";
		
        // Data   
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		     		
		vm.purchasei = PurchaseiList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.purchasei);
        vm.listForm={};
		
		/*if(vm.purchasei.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddPurchasei = gotoAddPurchasei;
		vm.gotopurchasei = gotopurchasei;	
		vm.editPurchasei = editPurchasei;
		vm.deletePurchasei = deletePurchasei;
		vm.gotoLogin = gotoLogin;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddPurchasei()
        {
			 //alert("Hi");
			 $state.go('app.purchasei.add');
        } 
		
		function editPurchasei(purchasei_id)
        {
			 //alert(purchasei_id);
			 $state.go('app.purchasei.edit', {purchasei_id: purchasei_id});
        }
		
		function gotopurchasei()
        {
			//alert("1");
            $state.go('app.purchasei-list');
        }
						
		function deletePurchasei(purchasei_id)
        {
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.purchasei);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this purchase?");
				if (r == true) {
					msApi.request('app.purchaseiDel@save', {param:{purchasei_id:purchasei_id},aToken:aToken,page:'purchasei'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);	
							if(response.data!=""){
								$mdToast.show(
									$mdToast.simple().textContent('Purchasei Deleted').position('top right')
								);
								gotopurchasei();					
							}
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase-report')
        .controller('PurchaseReportController', PurchaseReportController);

    /** @ngInject */
    function PurchaseReportController(PurchaseReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Purchase Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Purchase Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data  
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		     
		vm.openingstockreportList = PurchaseReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.openingstockreportList);   
		vm.branchID = vm.openingstockreportList.branchID;
		vm.itemList = vm.openingstockreportList.itemList;
		vm.categoryList = vm.openingstockreportList.categoryList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.purchaseDets = {from:vm.openingstockreportList.from,to:vm.openingstockreportList.to,type:'Today'};
		
		vm.itemInventoryReport = "";
		vm.totalPurchase = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemPDFExport = itemPDFExport;
		vm.itemCSVExport = itemCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.openingstockreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function itemPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.purchaseDets.mode+"|"+vm.purchaseDets.from+"|"+vm.purchaseDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemPDFExport/'+vm.param;			 			 
        }
		
		function itemCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.purchaseDets.mode+"|"+vm.purchaseDets.from+"|"+vm.purchaseDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.opening-stock-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.purchaseDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.purchaseReportList2@save', {param:{purchaseDets:vm.purchaseDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.purchaseReport = vm.output.purchaseReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.purchaseDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type};														
					
					vm.totalPurchase = 0;
					for(var i=0;i<vm.purchaseReport.length;i++){
						vm.totalPurchase = vm.totalPurchase + parseFloat(vm.purchaseReport[i].purchase_total_net);
					}
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.purchaseDets.type);	
			if(vm.purchaseDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.purchaseDets.from = day;
				vm.purchaseDets.to = day;
				
			} else if(vm.purchaseDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.purchaseDets.from = day;
				vm.purchaseDets.to = day;
			} else if(vm.purchaseDets.type == 'This Week'){
				var date = moment();
				
				vm.purchaseDets.from = date.clone().startOf('isoWeek');
				vm.purchaseDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.purchaseDets.type == 'This Month'){
				var date = new Date();
								
				vm.purchaseDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.purchaseDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.purchaseDets.from+" "+vm.purchaseDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.purchase')
        .controller('PurchaseListController', PurchaseListController);

    /** @ngInject */
    function PurchaseListController($state, PurchaseList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Ingredients Purcahse";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Purchase" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data      
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		  		
		vm.purchase = PurchaseList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.purchase);
        vm.listForm={};
		
		/*if(vm.purchase.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddPurchase = gotoAddPurchase;
		vm.gotopurchase = gotopurchase;	
		vm.editPurchase = editPurchase;
		vm.deletePurchase = deletePurchase;
		vm.gotoLogin = gotoLogin;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddPurchase()
        {
			 //alert("Hi");
			 $state.go('app.purchase.add');
        } 
		
		function editPurchase(purchase_id)
        {
			 //alert(purchase_id);
			 $state.go('app.purchase.edit', {purchase_id: purchase_id});
        }
		
		function gotopurchase()
        {
			//alert("1");
            $state.go('app.purchase-list');
        }
						
		function deletePurchase(purchase_id)
        {
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.purchase);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this purchase?");
				if (r == true) {
					msApi.request('app.purchaseDel@save', {param:{purchase_id:purchase_id},aToken:aToken,page:'purchase'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response.data);
							//alert(response.data);	
							if(response.data!=""){
								$mdToast.show(
									$mdToast.simple().textContent('Purchase Deleted').position('top right')
								);
								gotopurchase();					
							}
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }							
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.printers')
        .controller('PrintersListController', PrintersListController);

    /** @ngInject */
    function PrintersListController($state, PrintersList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Printers";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Printers" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.ordeTag = PrintersList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordeTag);
        vm.listForm={};
		
		if(vm.ordeTag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddPrinters = gotoAddPrinters;		
		vm.gotoPrinters = gotoPrinters;	
		vm.editPrinters = editPrinters;
		vm.deletePrinters = deletePrinters;
		vm.gotoLogin = gotoLogin;	
		vm.mapPrinters = mapPrinters;
		vm.optionPrinters = optionPrinters;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddPrinters()
        {
			 //alert("Hi");
			 $state.go('app.printers.add');
        } 
		
		function editPrinters(printers_id)
        {
			 //alert(customer_id);
			 $state.go('app.printers.edit', {printers_id: printers_id});
        }
		
		function mapPrinters(printers_id)
        {
			 //alert(customer_id);
			 $state.go('app.printers.mapping', {printers_id: printers_id});
        }
		
		function optionPrinters(printers_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption', {printers_id: printers_id});
        }
		
		function gotoPrinters()
        {
			//alert("1");
            $state.go('app.printers-list');
        }
				
							
		function deletePrinters(printers_id)
        {
			//alert(printers_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this printer?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_printers',param:{printers_id:printers_id},aToken:aToken,page:'printers'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Printer Deleted').position('top right')
							);
							gotoPrinters();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.printerjobs')
        .controller('PrinterjobsListController', PrinterjobsListController);

    /** @ngInject */
    function PrinterjobsListController($state, PrinterjobsList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Printerjobs";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Printer Jobs" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.ordeTag = PrinterjobsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordeTag);
        vm.listForm={};
		
		if(vm.ordeTag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddPrinterjobs = gotoAddPrinterjobs;		
		vm.gotoPrinterjobs = gotoPrinterjobs;	
		vm.editPrinterjobs = editPrinterjobs;
		vm.deletePrinterjobs = deletePrinterjobs;
		vm.gotoLogin = gotoLogin;	
		vm.mapPrinterjobs = mapPrinterjobs;
		vm.optionPrinterjobs = optionPrinterjobs;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddPrinterjobs()
        {
			 //alert("Hi");
			 $state.go('app.printerjobs.add');
        } 
		
		function editPrinterjobs(printerjobs_id)
        {
			 //alert(customer_id);
			 $state.go('app.printerjobs.edit', {printerjobs_id: printerjobs_id});
        }
		
		function mapPrinterjobs(printerjobs_id)
        {
			 //alert(customer_id);
			 $state.go('app.printerjobs.mapping', {printerjobs_id: printerjobs_id});
        }
		
		function optionPrinterjobs(printerjobs_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption', {printerjobs_id: printerjobs_id});
        }
		
		function gotoPrinterjobs()
        {
			//alert("1");
            $state.go('app.printerjobs-list');
        }
				
							
		function deletePrinterjobs(printerjobs_id)
        {
			//alert(printerjobs_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this printer job?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_printerjobs',param:{printerjobs_id:printerjobs_id},aToken:aToken,page:'printerjobs'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Printer Deleted').position('top right')
							);
							gotoPrinterjobs();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.printer-testing',
            [
				'datatables',
			
            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.printer-testing', {
				url    : '/printer-testing',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/printer-testing/printer-testing.html',
						controller : 'PrinterTestingController as vm'
					}
				},
				resolve: {					
					StockReport: function (msApi)
					{					
						//return msApi.resolve('app.stockreportList@get',{branchID:localStorage.getItem('BranchID')});
						return '';
					}, 
				}
			})
			.state('app.printer-testing-list', {
				url    : '/printer-testing',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/printer-testing/printer-testing.html',
						controller : 'PrinterTestingController as vm'
					}
				},
				resolve: {					
					StockReport: function (msApi)
					{					
						//return msApi.resolve('app.stockreportList@get',{branchID:localStorage.getItem('BranchID')});
						return '';
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/printer-testing');
			
			// Api						
			msApiProvider.register('app.stockreportList', ['stockreportList']);			
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('printer-testing', {
				title : 'Purchase',
				//icon  : 'icon-account-multiple',
				state : 'app.printer-testing',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.printer-testing')
        .controller('PrinterTestingController', PrinterTestingController);

    /** @ngInject */
    function PrinterTestingController($state, StockReport, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Printer Testing";

		
        // Data        		
		vm.stockreport = StockReport.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.stockreport);
        vm.listForm={};
		
		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods        
		vm.gotoLogin = gotoLogin;
		vm.testPrint = testPrint;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }        	
		function testPrint(){
			
			console.log("Testing");
			//const qz = require("qz-tray");
			
			
/*			qz.websocket.connect({host: "192.168.50.233"}).then(() => {
				return qz.printers.find('PRP-250C', { encoding: 'ISO-8859-1' });
			}).then((printers) => {
				/*console.log(printers);
				//var config = qz.configs.create('PDF');
				var config = qz.configs.create(printers);
				return qz.print(config, [{
					type: 'pixel',
					format: 'html',
					flavor: 'plain',
					data: '<h1>اختبار الطباعة!</h1><h1>Tesing Arabic</h1>'
				}]);
				
			}).then(() => {
				//console.log(printers);
				//var config = qz.configs.create(printers, { encoding: 'ISO-8859-1' });				
				var qr = 'https://qz.io';
				// The dot size of the QR code
				var dots = '\x09';

				// Some proprietary size calculation
				var qrLength = qr.length + 3;
				var size1 =  String.fromCharCode(qrLength % 256);
				var size0 = String.fromCharCode(Math.floor(qrLength / 256));
						
				var data = [ 
				'\x1B' + '\x40' + 'John Doe' +'\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A', // Some text and a few line feeds to make sure the initiation and first line are coming through

				// <!-- BEGIN QR DATA -->
				'\x1D' + '\x28' + '\x6B' + '\x04' + '\x00' + '\x31' + '\x41' + '\x32' + '\x00',    // <Function 165> select the model (model 2 is widely supported)
				'\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x43' + dots,               // <Function 167> set the size of the module
				'\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x45' + '\x30',             // <Function 169> select level of error correction (48,49,50,51) printer-dependent
				'\x1D' + '\x28' + '\x6B' + size1 + size0 + '\x31' + '\x50' + '\x30' + qr,          // <Function 080> send your data (testing 123) to the image storage area in the printer
				'\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x51' +'\x30',              // <Function 081> print the symbol data in the symbol storage area
				'\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x52' +'\x30',              // <Function 082> Transmit the size information of the symbol data in the symbol storage area
				// <!-- END QR DATA -->

				'New York, NY' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A' + '\x0A'               // more line feeds and text to see if we messed up the QR Code syntax      
				];*/
/*				var config2 = qz.configs.create(printers, { encoding: 'ISO-8859-1' });	
				var data2 = '<center><h2 style="font-family:sans-serif;margin:0px 0px 0px;">App 4 Demo</h2></center>'+
				'<center><h6 style="font-family:sans-serif;margin:15px 0px 0px;"><i>#2B, Jeeva Street, TVS Tollgate, Near Jamal Mohamed College Bus Stop, Testing Paragraph, Trichy-20</i></h6></center>'+
				'<center><h6 style="font-family:sans-serif;margin:12px 0px 0px;"><i>123-4567890</i></h6></center>'+
				'<hr>'+
				'<div><h5 style="font-family:sans-serif;margin:15px 0px 0px;float:left;"><i><span style="font-weight:400;">Bill No :</span> 710</i></h5><h5 style="font-family:sans-serif;margin:15px 0px 0px;float:right;"><i><span style="font-weight:400;">Date :</span> 09/12/2021</i></h5></div>'+
				'<div style="clear:both;"></div>'+
				'<div><h5 style="font-family:sans-serif;margin:12px 0px 0px;float:left;"><i><span style="font-weight:400;">User :</span> Admin</i></h5><h5 style="font-family:sans-serif;margin:12px 0px 0px;float:right;"><i><span style="font-weight:400;">Time :</span> 07:19 pm</i></h5></div>'+
				'<div style="clear:both;"></div>'+
				'<div><h5 style="font-family:sans-serif;margin:12px 0px 0px;float:left;"><i><span style="font-weight:400;">Waiter :</span> </i></h5><h5 style="font-family:sans-serif;margin:12px 0px 0px;float:right;"><i><span style="font-weight:400;">Table No :</span> </i></h5></div>'+
				'<div style="clear:both;"></div>'+
				'<div><h5 style="font-family:sans-serif;margin:12px 0px 0px;float:left;"><i><span style="font-weight:400;">Dept. Name :</span> Take Away</i></h5><h5 style="font-family:sans-serif;margin:12px 0px 0px;float:right;"><i><span style="font-weight:400;">Order ID :</span> </i></h5></div>'+
				'<div style="clear:both;"></div>'+
				'<center><h6 style="font-family:sans-serif;margin-bottom:23px;">Duplicate Bill</h6></center>'+
				'<table style="font-family:sans-serif;width:100%;border-top:2px solid #000;border-spacing:0;">'+
				'<tbody><tr><th style="text-align:left;padding:10px 0px;border-bottom:1px solid #999;font-size:15px;">Item Name</th><th style="text-align:center;padding:10px 0px;border-bottom:1px solid #999;font-size:15px;">Qty</th><th style="text-align:center;padding:10px 0px;border-bottom:1px solid #999;font-size:15px;">Rate</th><th style="text-align:right;padding:10px 0px;border-bottom:1px solid #999;font-size:15px;">Amount</th></tr>'+
				'<tr><td style="text-align:left;text-transform:uppercase;font-size:13px;padding:10px 0px;">Cone shawarma</td><td style="text-align:center;font-size:13px;padding:10px 0px;">2</td><td style="text-align:center;font-size:13px;padding:10px 0px;">130.00</td><td style="text-align:right;font-size:15px;padding:10px 0px;"><b>260.00</b></td></tr>'+
				'<tr><td style="text-align:left;text-transform:uppercase;font-size:13px;padding:10px 0px;">Mayonnnaise.Special</td><td style="text-align:center;font-size:13px;padding:10px 0px;">2</td><td style="text-align:center;font-size:13px;padding:10px 0px;">20.00</td><td style="text-align:right;font-size:15px;padding:10px 0px;"><b>40.00</b></td></tr>'+
				'<tr><td style="text-align:left;text-transform:uppercase;font-size:13px;padding:10px 0px;">Mexican Shawarma</td><td style="text-align:center;font-size:13px;padding:10px 0px;">2</td><td style="text-align:center;font-size:13px;padding:10px 0px;">80.00</td><td style="text-align:right;font-size:15px;padding:10px 0px;"><b>160.00</b></td></tr>'+
				'</tbody></table>'+
				'<hr style="border-style:dotted;">'+
				'<table style="font-family:sans-serif;width:100%;border-spacing:0;"><tbody><tr><td style="text-align:center;width:20%;"><h5 style="margin:0px;font-weight:300;"><i>Qty :</i></h5><h5 style="margin:8px 0px 0px;">6</h5></td><td style="text-align:center;width:20%;"><h5 style="margin:0px;font-weight:300;"><i>Items :</i></h5><h5 style="margin:8px 0px 0px;">3</h5></td><td style="text-align:center;width:30%;"><h5 style="margin:0px;font-weight:300;"><i>Sub Total :</i></h5><h5 style="margin:8px 0px 0px;">460.00</h5></td><td style="text-align:center;width:30%;"><h5 style="margin:0px;font-weight:300;"><i>Tax (Excl.) :</i></h5><h5 style="margin:8px 0px 0px;">21.00</h5></td></tr></tbody></table>'+
				'<hr style="border-style:dotted;">'+
				'<table style="font-family:sans-serif;width:100%;border-spacing:0;"><tbody><tr><td style="text-align:right;width:75%;font-size:15px;padding:5px 0px;">Discount :</td><td style="text-align:right;width:25%;padding:5px 0px;">0.00</td></tr><tr><td style="text-align:right;width:75%;font-size:15px;padding:5px 0px;">Nett :</td><td style="text-align:right;width:25%;padding:5px 0px;">501.00</td></tr><tr><td style="text-align:right;width:75%;font-size:15px;padding:5px 0px;">Round of :</td><td style="text-align:right;width:25%;padding:5px 0px;">0.00</td></tr><tr><td style="text-align:right;width:75%;font-size:15px;padding:5px 0px;"><b>Total :</b></td><td style="text-align:right;width:25%;padding:5px 0px;"><h3 style="margin:0px;font-size:25px;">501.00</h3></td></tr></tbody></table>'+
				'<h5 style="font-family:sans-serif;text-align:center;margin-bottom:15px;"><b>Tax Summary  (Tax     Per %     Amount)</b></h5>'+
				'<hr>'+
				'<table style="font-family:sans-serif;width:100%;border-spacing:0;">'+
				'<tbody><tr><td style="text-align:right;width:55%;font-size:13px;padding:5px 0px;">CGST (Excl.)</td><td style="text-align:right;width:20%;font-size:13px;padding:5px 0px;">2.5%</td><td style="text-align:right;width:25%;padding:5px 0px;font-size:13px;"><b>10.50</b></td></tr>'+
				'<tr><td style="text-align:right;width:55%;font-size:13px;padding:5px 0px;">SGST (Excl.)</td><td style="text-align:right;width:20%;font-size:13px;padding:5px 0px;">2.5%</td><td style="text-align:right;width:25%;padding:5px 0px;font-size:13px;"><b>10.50</b></td></tr>'+
				'</tbody></table>'+
				'<table style="font-family:sans-serif;width:100%;border-spacing:0;"><tbody><tr><td style="text-align:right;width:75%;font-size:15px;padding:5px 0px;"><b>Tax Amount :</b></td><td style="text-align:right;width:25%;padding:5px 0px;"><b> 21.00</b></td></tr></tbody></table>';
				return qz.print(config2, [{
					type: 'pixel',
					format: 'html',
					flavor: 'plain',
					data: data2
				}]).catch(function(e) { console.error(e); });;
			}).then(() => {
				//return qz.websocket.disconnect();
			}).then(() => {
				// process.exit(0);
			}).catch((err) => {
				console.error(err);
				// process.exit(1);
			});*/
		}		

		function testPrint_Old2(){

			//let ThermalPrinterEncoder = require('thermal-printer-encoder');

			/*let encoder = new ThermalPrinterEncoder({
				language: 'esc/pos'
			});

			let result = encoder
				.initialize()
				.text('The quick brown fox jumps over the lazy dog')
				.newline()
				.qrcode('https://nielsleenheer.com')
				.encode();

				var webprint = __env.webprint;
				if(__env.isDebug) console.log(webprint);
				webprint.printRaw(result, "PRP-250C");*/

		}
		
        function testPrint_old(){
        	//alert("In")
        	//const ThermalPrinter = require("node-thermal-printer").printer;
			//const PrinterTypes = require("node-thermal-printer").types;
			 
			/*let printer = new ThermalPrinter({
			  type: PrinterTypes.EPSON,
			  interface: 'printer:Send To OneNote 2010'
			});
			 
			printer.alignCenter();
			printer.println("Hello world");
			//await printer.printImage('./assets/olaii-logo-black.png')
			printer.cut();
			 
			try {
			  let execute = printer.execute()
			  console.error("Print done!");
			} catch (error) {
			  console.log("Print failed:", error);
			}*/

			/*
			let isConnected = await printer.isPrinterConnected();       // Check if printer is connected, return bool of status
			let execute = await printer.execute();                      // Executes all the commands. Returns success or throws error
			let raw = await printer.raw(Buffer.from("Hello world"));    // Print instantly. Returns success or throws error
			printer.print("Hello World");                               // Append text
			printer.println("Hello World");                             // Append text with new line
			printer.openCashDrawer();                                   // Kick the cash drawer
			printer.cut();                                              // Cuts the paper (if printer only supports one mode use this)
			printer.partialCut();                                       // Cuts the paper leaving a small bridge in middle (if printer supports multiple cut modes)
			printer.beep();                                             // Sound internal beeper/buzzer (if available)
			printer.upsideDown(true);                                   // Content is printed upside down (rotated 180 degrees)
			printer.setCharacterSet("SLOVENIA");                        // Set character set - default set on init
			printer.setPrinterDriver(Object)                            // Set printer drive - default set on init
			 
			printer.bold(true);                                         // Set text bold
			printer.invert(true);                                       // Background/text color inversion
			printer.underline(true);                                    // Underline text (1 dot thickness)
			printer.underlineThick(true);                               // Underline text with thick line (2 dot thickness)
			printer.drawLine();                                         // Draws a line
			printer.newLine();                                          // Insers break line
			 
			printer.alignCenter();                                      // Align text to center
			printer.alignLeft();                                        // Align text to left
			printer.alignRight();                                       // Align text to right
			 
			printer.setTypeFontA();                                     // Set font type to A (default)
			printer.setTypeFontB();                                     // Set font type to B
			 
			printer.setTextNormal();                                    // Set text to normal
			printer.setTextDoubleHeight();                              // Set text to double height
			printer.setTextDoubleWidth();                               // Set text to double width
			printer.setTextQuadArea();                                  // Set text to quad area
			printer.setTextSize(7,7);                                   // Set text height (0-7) and width (0-7)
			 
			printer.leftRight("Left", "Right");                         // Prints text left and right
			printer.table(["One", "Two", "Three"]);                     // Prints table equaly
			printer.tableCustom([                                       // Prints table with custom settings (text, align, width, cols, bold)
			  { text:"Left", align:"LEFT", width:0.5 },
			  { text:"Center", align:"CENTER", width:0.25, bold:true },
			  { text:"Right", align:"RIGHT", cols:8 }
			]);
			 
			//printer.code128("Code128");                                 // Print code128 bar code
			//printer.printQR("QR CODE");                                 // Print QR code
			//await printer.printImage('./assets/olaii-logo-black.png');  // Print PNG image
			 
			print.clear();                                              // Clears printText value
			print.getText();                                            // Returns printer buffer string value
			print.getBuffer();                                          // Returns printer buffer
			print.setBuffer(newBuffer);                                 // Set the printer buffer to a copy of newBuffer
			print.getWidth();           

			*/
        }			
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pricing')
        .controller('PricingListController', PricingListController);

    /** @ngInject */
    function PricingListController($state, PricingList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Item Pricing";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Pricings" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.pricing = PricingList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.pricing);	
		vm.branchID = vm.pricing.branchID;
		
		vm.items = vm.pricing.priceItmList;
		vm.priceList = vm.pricing.priceingList;
		vm.tags = vm.pricing.priceTagList;
		var tag = {price_tag_id:'0',price_tag_name:''};
		vm.btnBlock = 0;
		vm.search = "";

		vm.tags.push(tag);
		if(__env.isDebug) console.log(vm.tags);	
		
        vm.listForm={};
		
		if(vm.pricing.error == "1"){
			gotoLogin();
		} 
        
		//vm.itmPriningList = [];
		for(var i=0;i<vm.items.length;i++){	
			vm.itmTags = [];
			for(var j=0;j<vm.tags.length;j++){
				var priID = "";
				var price = "";
				
				for(var k=0;k<vm.priceList.length;k++){										
					if(vm.items[i].item_id == vm.priceList[k].item_price_item_id && vm.items[i].itm_option_id == vm.priceList[k].item_price_option_id && vm.tags[j].price_tag_id == vm.priceList[k].item_price_tag_id){
						priID = vm.priceList[k].item_price_id;
						price = vm.priceList[k].item_price_price;
					}
				}
					
				var obj = {item_price_id:priID, item_branch_id:vm.branchID, item_price_item_id:vm.items[i].item_id, item_price_option_id:vm.items[i].itm_option_id, item_price_tag_id:vm.tags[j].price_tag_id, item_price_price:price};
				vm.itmTags.push(obj);
				
			}	
			vm.items[i].itmTags = vm.itmTags
		}
		if(__env.isDebug) console.log(vm.items);
       	
        // Methods        		
		vm.gotopricing = gotopricing;	
		vm.savePricing = savePricing;
		vm.gotoLogin = gotoLogin;
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
        
		function gotopricing()
        {
			//alert("1");
            //$state.go('app.pricing-list');

            if($state.current.name=="app.pricing"){
				$state.go('app.pricing-list');				
			} else if($state.current.name=="app.pricing-list"){
				$state.go('app.pricing');					
			}
        }
				
						
		function savePricing(pricing_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.items);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				$mdToast.show(
					$mdToast.simple().textContent('Please wait until save complete').position('top right')
				);
				vm.btnBlock = 1;

				msApi.request('app.pricingSave@save', {param:{items:vm.items},aToken:aToken,page:'pricing'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						vm.btnBlock = 0;
						$mdToast.show(
							$mdToast.simple().textContent('Item Pricing Saved').position('top right')
						);						
						gotopricing();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.price-tag')
        .controller('PriceTagsListController', PriceTagsListController);

    /** @ngInject */
    function PriceTagsListController($state, PriceTagsList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "PriceTags";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Price Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.price_tag = PriceTagsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.price_tag);
        vm.listForm={};
		
		if(vm.price_tag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddPriceTags = gotoAddPriceTags;		
		vm.gotoPriceTags = gotoPriceTags;	
		vm.editPriceTags = editPriceTags;
		vm.deletePriceTags = deletePriceTags;
		vm.gotoLogin = gotoLogin;		
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddPriceTags()
        {
			 //alert("Hi");
			 $state.go('app.price-tag.add');
        } 
		
		function editPriceTags(price_tag_id)
        {
			 //alert(customer_id);
			 $state.go('app.price-tag.edit', {price_tag_id: price_tag_id});
        }
		
		function gotoPriceTags()
        {
			//alert("1");
            $state.go('app.price-tag-list');
        }
							
		function deletePriceTags(price_tag_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.price_tag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this price tag?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_price_tag',param:{price_tag_id:price_tag_id},aToken:aToken,page:'price_tag'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Price Tags Deleted').position('top right')
							);
							gotoPriceTags();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ordertagoption')
        .controller('OrdertagoptionsListController', OrdertagoptionsListController);

    /** @ngInject */
    function OrdertagoptionsListController($state, OrderTagOptions, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Order Tag Options";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Order Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.ordertagoption = OrderTagOptions;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordertagoption);
        vm.listForm={};
		vm.orderTagID = vm.ordertagoption.order_tag_id;
		
		if(vm.ordertagoption.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddOrdertagoptions = gotoAddOrdertagoptions;		
		vm.gotoOrdertagoptions = gotoOrdertagoptions;	
		vm.editOrdertagoptions = editOrdertagoptions;
		vm.deleteOrdertagoptions = deleteOrdertagoptions;
		vm.gotoLogin = gotoLogin;	
		vm.gotoOrderTag = gotoOrderTag;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddOrdertagoptions(id)
        {
			 //alert("Hi");
			 $state.go('app.ordertagoption.add', {ordertagoption_id: id});
        } 
		
		function editOrdertagoptions(ordertagoption_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption.edit', {ordertagoption_id: ordertagoption_id});
        }
		
		function gotoOrdertagoptions()
        {
			//alert("1");
            $state.go('app.ordertagoption-list',{order_tag_id:vm.orderTagID});
        }
		
		function gotoOrderTag()
        {
			//alert("1");
            $state.go('app.order-tag-list');
        }
				
							
		function deleteOrdertagoptions(ordertagoption_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.ordertagoption);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this Option?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_order_tag_options',param:{ordertagoption_id:ordertagoption_id},aToken:aToken,page:'ordertagoption'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Order Tag Option Deleted').position('top right')
							);
							gotoOrdertagoptions();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.order-tag')
        .controller('OrderTagListController', OrderTagListController);

    /** @ngInject */
    function OrderTagListController($state, OrderTagList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "OrderTag";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Order Tags" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.ordeTag = OrderTagList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordeTag);
        vm.listForm={};
		
		if(vm.ordeTag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddOrderTag = gotoAddOrderTag;		
		vm.gotoOrderTag = gotoOrderTag;	
		vm.editOrderTag = editOrderTag;
		vm.deleteOrderTag = deleteOrderTag;
		vm.gotoLogin = gotoLogin;	
		vm.mapOrderTag = mapOrderTag;
		vm.optionOrderTag = optionOrderTag;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddOrderTag()
        {
			 //alert("Hi");
			 $state.go('app.order-tag.add');
        } 
		
		function editOrderTag(order_tag_id)
        {
			 //alert(customer_id);
			 $state.go('app.order-tag.edit', {order_tag_id: order_tag_id});
        }
		
		function mapOrderTag(order_tag_id)
        {
			 //alert(customer_id);
			 $state.go('app.order-tag.mapping', {order_tag_id: order_tag_id});
        }
		
		function optionOrderTag(order_tag_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption', {order_tag_id: order_tag_id});
        }
		
		function gotoOrderTag()
        {
			//alert("1");
            $state.go('app.order-tag-list');
        }
				
							
		function deleteOrderTag(order_tag_id)
        {
			//alert(order_tag_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this order tag?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_order_tags',param:{order_tag_id:order_tag_id},aToken:aToken,page:'order-tag'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Order Tag Deleted').position('top right')
							);
							gotoOrderTag();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.opening-stock-report')
        .controller('OpeningStockReportController', OpeningStockReportController);

    /** @ngInject */
    function OpeningStockReportController(ItemReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Opening Stock Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Opening Stock Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data   
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		    
		vm.openingstockreportList = ItemReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.openingstockreportList);   
		vm.branchID = vm.openingstockreportList.branchID;
		vm.itemList = vm.openingstockreportList.itemList;
		vm.categoryList = vm.openingstockreportList.categoryList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.openingstockDets = {from:vm.openingstockreportList.from,to:vm.openingstockreportList.to,type:'Today',catID:vm.openingstockreportList.catID,itmID:vm.openingstockreportList.itmID};
		
		vm.itemInventoryReport = "";
		vm.totalStock = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemPDFExport = itemPDFExport;
		vm.itemCSVExport = itemCSVExport;
		vm.changeDate = changeDate;
		
		changeDate();	
		if(__env.isDebug) console.log(vm.openingstockreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function itemPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.openingstockDets.mode+"|"+vm.openingstockDets.from+"|"+vm.openingstockDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemPDFExport/'+vm.param;			 			 
        }
		
		function itemCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.openingstockDets.mode+"|"+vm.openingstockDets.from+"|"+vm.openingstockDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.opening-stock-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'opening-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.openingstockDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.openingstockReportList2@save', {param:{openingstockDets:vm.openingstockDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.itemInventoryReport = vm.output.itemInventoryReport;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.openingstockDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,itmID:vm.output.itmID,catID:vm.output.catID};
					
					vm.totalStock = 0;
					for(var i=0;i<vm.itemInventoryReport.length;i++){
						vm.totalStock = vm.totalStock + parseFloat(vm.itemInventoryReport[i].inventory_qty);
					}
										
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.openingstockDets.type);	
			if(vm.openingstockDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.openingstockDets.from = day;
				vm.openingstockDets.to = day;
				
			} else if(vm.openingstockDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.openingstockDets.from = day;
				vm.openingstockDets.to = day;
			} else if(vm.openingstockDets.type == 'This Week'){
				var date = moment();
				
				vm.openingstockDets.from = date.clone().startOf('isoWeek');
				vm.openingstockDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.openingstockDets.type == 'This Month'){
				var date = new Date();
								
				vm.openingstockDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.openingstockDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.openingstockDets.from+" "+vm.openingstockDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.offer')
        .controller('OfferListController', OfferListController);

    /** @ngInject */
    function OfferListController($state, OfferList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Offer";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Offer Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
        vm.ordeTag = OfferList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordeTag);
        vm.listForm={};
		
		if(vm.ordeTag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddOffer = gotoAddOffer;		
		vm.gotoOffer = gotoOffer;	
		vm.editOffer = editOffer;
		vm.deleteOffer = deleteOffer;
		vm.gotoLogin = gotoLogin;	
		vm.mapOffer = mapOffer;
		vm.optionOffer = optionOffer;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddOffer()
        {
			 //alert("Hi");
			 $state.go('app.offer.add');
        } 
		
		function editOffer(offer_id)
        {
			 //alert(customer_id);
			 $state.go('app.offer.edit', {offer_id: offer_id});
        }
		
		function mapOffer(offer_id)
        {
			 //alert(customer_id);
			 $state.go('app.offer.mapping', {offer_id: offer_id});
        }
		
		function optionOffer(offer_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption', {offer_id: offer_id});
        }
		
		function gotoOffer()
        {
			//alert("1");
            $state.go('app.offer-list');
        }
				
							
		function deleteOffer(offer_id)
        {
			//alert(offer_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this offer?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_offer',param:{offer_id:offer_id},aToken:aToken,page:'offer'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_offer_mapping',param:{offer_map_offer_id:offer_id},aToken:aToken,page:'offer'},
								// SUCCESS
								function (response){		
									//alert("IF");
									//if(__env.isDebug) console.log("Success");
									//if(__env.isDebug) console.log(response.data);
									//alert(response.data);											
								},
								// ERROR
								function (response){
									//alert("ELSE");
									if(__env.isDebug) console.log("Error");
									console.error(response.data);
								}
							);
							
							
							$mdToast.show(
								$mdToast.simple().textContent('Offer Deleted').position('top right')
							);
							gotoOffer();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.managemenu',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.managemenu', {
				url    : '/managemenu',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/managemenu/managemenu.html',
						controller : 'ManagemenuListController as vm'
					}
				},
				resolve: {					
					ManagemenuList: function (msApi)
					{					
						return '';
					}, 
				}
			})
			.state('app.managemenu-list', {
				url    : '/managemenu',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/managemenu/managemenu.html',
						controller : 'ManagemenuListController as vm'
					}
				},
				resolve: {					
					ManagemenuList: function (msApi)
					{					
						return '';
					}, 
				}
			})	
			.state('app.managemenu.add', {
				url      : '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/managemenu/new_managemenu/new_managemenu.html',
						controller : 'AddManagemenuController as vm'
					}
				},
				resolve: {
					Supplier: function (msApi)
					{
						return msApi.resolve('app.supplierAdd@get');
						//return '';
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.managemenu.edit', {
				url      : '/edit/:managemenu_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/managemenu/new_managemenu/new_managemenu.html',
						controller : 'EditManagemenuController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			})
			.state('app.managemenu.edit-list', {
				url      : '/edit/:managemenu_id',
				views: {
					'content@app': {
						templateUrl: 'app/main/apps/managemenu/new_managemenu/new_managemenu.html',
						controller : 'EditManagemenuController as vm'
					}
				},
				resolve: {
					Supplier: function ($stateParams, supplierService)
					{
						return supplierService.getSupplier($stateParams.supplier_id,'Edit');
					}
				},
				bodyClass: 'supplier'
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/managemenu');
			
			// Api						
			msApiProvider.register('app.supplierList', ['supplierList']);
			msApiProvider.register('app.supplierSave', ['supplierSave']);
			msApiProvider.register('app.supplierUpdate', ['supplierUpdate']);
			msApiProvider.register('app.supplierAdd', ['supplierAdd']);
			msApiProvider.register('app.supplierEdit', ['supplierEdit']);
			msApiProvider.register('app.supplierDel', ['supplierDel']);
						
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('managemenu', {
				title : 'Managemenus',
				//icon  : 'icon-account-multiple',
				state : 'app.managemenu',
				weight: 20
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.managemenu')
        .controller('ManagemenuListController', ManagemenuListController);

    /** @ngInject */
    function ManagemenuListController($state, ManagemenuList, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Managemenu";
		
        // Data
        //vm.managemenu = ManagemenuList.data;
		//if(__env.isDebug) console.log('List');
		//if(__env.isDebug) console.log(vm.managemenu);
        //vm.listForm={};
		
		/*if(vm.managemenu.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddManagemenu = gotoAddManagemenu;
		vm.managemenuPDFExport = staffPDFExport;
		vm.managemenuCSVExport = staffCSVExport;
		
		vm.gotomanagemenu = gotomanagemenu;	
		vm.editManagemenu = editManagemenu;
		vm.deleteManagemenu = deleteManagemenu;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddManagemenu()
        {
			 //alert("Hi");
			 $state.go('app.managemenu.add');
        } 
		
		function editManagemenu(managemenu_id)
        {
			 //alert(managemenu_id);
			 $state.go('app.managemenu.edit', {managemenu_id: managemenu_id});
        }
		
		function gotomanagemenu()
        {
			//alert("1");
            $state.go('app.managemenu-list');
        }
		
		function gotoPayments(managemenu_id){
			$state.go('app.managemenu-payment', {managemenu_id: managemenu_id});
		}
						
		function deleteManagemenu(managemenu_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.managemenu);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this managemenu?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_supplier',param:{supplier_id:supplier_id},aToken:aToken,page:'supplier'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Supplier Deleted').position('top right')
							);
							gotomanagemenu();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function staffPDFExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffPDFExport';			 			 
        } 
		
		function staffCSVExport()
        {
			 //alert("Hi");			 
			 $window.location.href = __env.apiUrl+'staffCSVExport';			 			 
        }
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);
		

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
		
		//if(__env.isDebug) console.log('App Const');
		//if(__env.isDebug) console.log(msApiProvider );
		//if(__env.isDebug) console.log(msApiProvider.appConstantValues);
		
		
		// State
		$stateProvider.state('app.login', {
			url      : '/login',
			views    : {
				'main@'                          : {
					templateUrl: 'app/core/layouts/content-only.html',
					controller : 'MainController as vm'
				},
				'content@app.login': {
					templateUrl: 'app/main/apps/login/signin.html',
					controller : 'SigninController as vm'
				}
			},
            resolve: {
				SystemDets: function (msApi)
				{
					return msApi.resolve('app.systemDets@get');
					//return '';
				}    
			},
			bodyClass: 'login'
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/apps/login');
		
		// Api
        msApiProvider.register('app.systemDets', ['systemDets']);
		msApiProvider.register('app.check_login', ['check_login']);
		msApiProvider.register('app.getCustomKotDets', ['getCustomKotDets']);

		// Navigation
		/*msNavigationServiceProvider.saveItem('apps.login', {
			title : 'Login',
			state : 'app.login',
			weight: 1
		});*/
		if(localStorage.getItem('UserID')!=""){ 
			msNavigationServiceProvider.saveItem('login', {
				title : 'Logout',
				//icon  : 'icon-logout',
				state : 'app.login',
				weight: 8
			});
		}
	
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.login')
        .controller('SigninController', SigninController);

    /** @ngInject */
    function SigninController(SystemDets, $mdToast, $document, msApi, $state, $location, __env, $window, $mdDialog, $rootScope, $interval, $cookies)
    {
        // Data
		var vm = this;
        vm.systemDets = SystemDets.data;
		if(__env.isDebug) console.log(vm.systemDets);
		localStorage.clear();
		vm.loginData = [];
		vm.selectedParentDet = null;

		if(__env.reqPrinterID){
			$interval.cancel(__env.reqPrinterID);			
		}
		localStorage.clear();
		
		
        // Methods		
		vm.checkLogin = checkLogin;
		vm.gotoHome = gotoHome;
		vm.stopWorker = stopWorker;
		//vm.getNewAlert = getNewAlert;
		//vm.orderdets = orderdets;

		if(__env.isDebug) console.log("In Worker");
		if(__env.isDebug) console.log(__env.orderWorker);	
		//alert(isNaN(__env.orderWorker));
		if(isNaN(__env.orderWorker)==true) {
			stopWorker();
        }

        //alert(!$cookies.get("localNotificationEnable"));
        if(!$cookies.get("localNotificationEnable")==true){            
        	//alert("in");
        	var now = new Date(),
            // this will set the expiration to 12 months
            exp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());
            $cookies.put("localNotificationEnable", 1,{expires: exp});
        }
		
        //////////
		
		/*if(__env.isDebug) console.log('App Const');
		if(__env.isDebug) console.log(appName);
		if(__env.isDebug) console.log(appConstantValues);*/
		
		/** Load Login **/
		//alert(localStorage.getItem('UserID'));
		if(__env.isDebug) console.log("In User ID");
		if(__env.isDebug) console.log(localStorage.getItem('UserID'));
		if(localStorage.getItem('UserID')!=null){
			//alert("IF");
			$location.path('/parent-dashboard');
		}
		
				
        vm.clientName = vm.systemDets.client_name;
        vm.clientStatus = vm.systemDets.client_status;
        vm.clientLogo = __env.imagePath+"logo.png";
        //vm.printHost = vm.systemDets.client_printer_host;
        vm.clientVersion = vm.systemDets.client_version;

        vm.printDets = [];

        var obj1={host:vm.systemDets.client_printer_host,auth:vm.systemDets.client_printer_auth};
        vm.printDets.push(obj1);

        if(vm.systemDets.client_printer_host2!=""){
        	var obj2={host:vm.systemDets.client_printer_host2,auth:vm.systemDets.client_printer_auth2};
        	vm.printDets.push(obj2);
    	}
    	if(vm.systemDets.client_printer_host3!=""){
        	var obj3={host:vm.systemDets.client_printer_host3,auth:vm.systemDets.client_printer_auth3};
        	vm.printDets.push(obj3);
        }

        var now = new Date(),
        // this will set the expiration to 12 months
        exp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());
		//alert(exp);		
        
        
        console.log(vm.printDets);
        localStorage.setItem('PrinterHostList',JSON.stringify(vm.printDets));

        vm.appHost = vm.systemDets.client_hosting;
		vm.printHost = vm.systemDets.client_printer_host;
		vm.printAuth = vm.systemDets.client_printer_auth;
		
		if(!$cookies.get("localPrinterIP")==false && !$cookies.get("localPrinterAuth")==false){
            if($cookies.get("localPrinterIP")!="" && $cookies.get("localPrinterAuth")!=""){
            	vm.printHost = $cookies.get("localPrinterIP");                
            	vm.printAuth = $cookies.get("localPrinterAuth");                
        	}
        }


        if(vm.clientStatus==1){
        	vm.clientStatusLabel = "Your account Expired, Please contact Admin";
        } else if(vm.clientStatus==2){
        	vm.clientStatusLabel = "Your account Disabled, Please contact Admin";
        }
		
		//console.log(vm.clientLogo);

		console.log(vm.printDets);				
		//endConnection();				

		//alert(vm.printHost);
		createConnection(vm.printHost);		

		$cookies.put("localPrinterIP", vm.printHost, {expires: exp});
        $cookies.put("localPrinterAuth", vm.printAuth, {expires: exp});


					
	
		localStorage.setItem('PrinterIP',vm.printHost);
		localStorage.setItem('AppHost',vm.appHost);


		localStorage.setItem('Currency_Sign',vm.systemDets.client_currency_sign);
		localStorage.setItem('Currency_Decimals',vm.systemDets.client_currency_decimals);
		
		//localStorage.setItem('PrinterAuth',vm.printAuth);
		

		/** Check Login **/

		function stopWorker() { 
			//alert("In");
			var worker = __env.orderWorker;
            worker.terminate();
            worker = undefined;
            __env.orderWorker = "";
        }        
		
		function checkLogin(){
			if(__env.isDebug) console.log("Input Data");
			if(__env.isDebug) console.log(vm.loginData);
			msApi.request('app.check_login@save', {param:{mobileno:vm.loginData.mobileno,password:vm.loginData.password}},
				// SUCCESS
				function (response){		
					//alert("IF");
					if(__env.isDebug) console.log("Success");
					if(__env.isDebug) console.log(response.data);	
					//alert(response.data.status);
					if(response.data.status!=0){
						//vm.selectedParentDet = response.data;
						var inp = (response.data.status).split(':');						
						localStorage.setItem('UserID',inp[0]);
						localStorage.setItem('UserName',inp[1]);
						localStorage.setItem('UserRole',inp[2]);
						localStorage.setItem('UserATK',inp[4]);
						localStorage.setItem('BranchID',response.data.branchID);
						
						localStorage.setItem('LogEntry',"1");
						
						
						//localStorage.setItem('UserBranchName',inp[5]);
						//localStorage.setItem('UserDiscount',inp[3]);
						//localStorage.setItem('UserType',inp[4]);	
												
						vm.pageID = response.data.rolePageList;
						//console.log("ROLEPAGES");
						if(__env.isDebug) console.log(vm.pageID);

						$window.localStorage['page'] = JSON.stringify(response.data.setPage);
						$window.localStorage['pageID'] = JSON.stringify(vm.pageID);		
						
						$window.localStorage['roleDeptList'] = JSON.stringify(response.data.roleDeptList);
						localStorage.setItem('ifKOTExist','0');	
						//$window.localStorage['rolePageList'] = JSON.stringify(response.data.rolePageList);
						$window.localStorage['tableList'] = JSON.stringify(response.data.tableList);
						$window.localStorage['categoryList'] = JSON.stringify(response.data.categoryList);
						$window.localStorage['productList'] = JSON.stringify(response.data.productList);
						$window.localStorage['departmentList'] = JSON.stringify(response.data.departmentList);
						$window.localStorage['customerList'] = JSON.stringify(response.data.customerList);
						$window.localStorage['waiterList'] = JSON.stringify(response.data.waiterList);
						$window.localStorage['periodID'] = JSON.stringify(parseInt(response.data.periodID));
						$window.localStorage['taxDets'] = JSON.stringify(response.data.taxDets);
						$window.localStorage['orderTags'] = JSON.stringify(response.data.orderTags);
						$window.localStorage['tableCategoryList'] = JSON.stringify(response.data.tableCategoryList);
						$window.localStorage['taxMasterList'] = JSON.stringify(response.data.taxMasterList);
						$window.localStorage['extraMasterList'] = JSON.stringify(response.data.extraMasterList);
						$window.localStorage['companyDets'] = JSON.stringify(response.data.companyDets);
						$window.localStorage['syncTime'] = JSON.stringify(response.data.syncTime);
						$window.localStorage['lastAlertTime'] = JSON.stringify(response.data.syncTime);
						$window.localStorage['customKots'] = JSON.stringify(response.data.customKots);
						var syncTime = response.data.branchID+"|"+JSON.stringify(response.data.syncTime)+"|"+localStorage.getItem('AppHost');	
						
						//alert(syncTime);

						if(!$cookies.get("localNotificationEnable")==false && $cookies.get("localNotificationEnable")==1){
							var w;
							if(isNaN(__env.orderWorker)==true) {
								w = __env.orderWorker;
							} 
							if(typeof(Worker) !== "undefined") {
								if(typeof(w) == "undefined") {
							    	w = new Worker("check_custom_order.js");
							    	console.log("Worker Registered");
							    	w.postMessage(syncTime);
							    	__env.orderWorker = w;
							   	} else {
							   		console.log("Worker Exist");
							   	}						    
							} else {							 
								if(__env.isDebug) console.log("Sorry, your browser does not support Web Workers...");
							}
							//w.postMessage(syncTime);
						}
						
						
						
						if(__env.isDebug) console.log("In Log Worker");
						if(__env.isDebug) console.log(__env.orderWorker);
						

						var retValue = checkConnection();
						//alert(retValue);
						if(retValue==true){
				            __env.printStatus = 1;
				            localStorage.setItem('PrinterStatus',1);
				        }
						
						gotoHome();

					} else if(response.data.status==0){
						$mdToast.show(
							$mdToast.simple().textContent('Invalid Username/Password').position('top right')
						);
					}
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					if(__env.isDebug) console.log(response.data);
				}
			);
		}

		
		/** Dashboard Redirection **/
		
		function gotoDashboard()
        {
			//var param = localStorage.setItem('UserID');
			//alert(param);
			$state.go('app.dashboard');
        } 
		
		function gotoHome()
        {
			//var param = localStorage.setItem('UserID');
			//alert(param);
			$state.go('app.home');
        } 
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.kot-report')
        .controller('KotReportController', KotReportController);

    /** @ngInject */
    function KotReportController(KotReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Verification Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Verification Report" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data    
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		   
		vm.kotreportList = KotReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.kotreportList);   
		vm.branchID = vm.kotreportList.branchID;
		vm.tax = vm.kotreportList.workReportTax;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];
		vm.payMode = ["Cash","Card","UPI","Paytm","Zomato","Uber","Swiggy"];
		
		vm.salesDets = {from:vm.kotreportList.from,to:vm.kotreportList.to,type:vm.kotreportList.type,mode:vm.kotreportList.mode,billno:vm.kotreportList.billno};
		
		vm.kotReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.wprPDFExport = wprPDFExport;
		vm.salesItmsPDFExport = salesItmsPDFExport;
		vm.changeDate = changeDate;
		
		/*for(var i=0;i<vm.kotreportList.workReportBillItems.length;i++){
			vm.kotreportList.workReportBillItems[i].bitm_tax = parseFloat((vm.kotreportList.workReportBillItems[i].bitm_total * vm.tax)/100);
			
			vm.kotreportList.workReportBillItems[i].bitm_taxtotal = parseFloat(vm.kotreportList.workReportBillItems[i].bitm_tax) + parseFloat(vm.kotreportList.workReportBillItems[i].bitm_total);
		}*/
		if(__env.isDebug) console.log(vm.kotreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function wprPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'wprPDFExport/'+vm.branchID);
			 $window.location.href = __env.apiUrl+'wprPDFExport/'+vm.branchID;			 			 
        }
		
		function salesItmsPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'wprPDFExport/'+vm.branchID);
			 $window.location.href = __env.apiUrl+'salesItmsPDFExport/'+vm.branchID;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.kot-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'kot-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'kot-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		listReport();
		
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.salesDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.kotReportList2@save', {param:{salesDets:vm.salesDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'kot-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.tax = vm.output.workReportTax;
					vm.kotReportList = vm.output.dbListingBills;
					
					vm.salesDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,mode:vm.output.mode};
					
					vm.totalAmt = 0;
					vm.totalTax = 0;
					vm.totalNet = 0;
					for(var i=0;i<vm.kotReportList.length;i++){
						vm.totalAmt = vm.totalAmt + parseFloat(vm.kotReportList[i].bil_totalamt);
						vm.totalTax = vm.totalTax + parseFloat(vm.kotReportList[i].bil_tottaxamt);
						vm.totalNet = vm.totalNet + parseFloat(vm.kotReportList[i].bil_totalnetamt);	
					}
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.salesDets.type);	
			if(vm.salesDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.salesDets.from = day;
				vm.salesDets.to = day;
				
			} else if(vm.salesDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.salesDets.from = day;
				vm.salesDets.to = day;
			} else if(vm.salesDets.type == 'This Week'){
				var date = moment();
				
				vm.salesDets.from = date.clone().startOf('isoWeek');
				vm.salesDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.salesDets.type == 'This Month'){
				var date = new Date();
								
				vm.salesDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.salesDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.salesDets.from+" "+vm.salesDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.item-stock-report')
        .controller('ItemStockReportController', ItemStockReportController);

    /** @ngInject */
    function ItemStockReportController(ItemStockReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Current Stock Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Stock Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data      
		
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		vm.itemstockreportList = ItemStockReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.itemstockreportList);   
		vm.branchID = vm.itemstockreportList.branchID;
		vm.itemStockReport = vm.itemstockreportList.itemStockReport;		
		vm.itemList = vm.itemstockreportList.itemList;
		vm.categoryList = vm.itemstockreportList.categoryList;

		vm.itmStockList = {catID:vm.itemstockreportList.catID,itmID:vm.itemstockreportList.itmID};

		vm.totalOpStock = 0; vm.totalSalesStock = 0; vm.totalWasteStock = 0; 
		vm.totalVarStock = 0; vm.totalCurrStock = 0; vm.totalCurrValue = 0;
		for(var i=0;i<vm.itemStockReport.length;i++){
			vm.totalOpStock = vm.totalOpStock + parseFloat(vm.itemStockReport[i].openingStock);
			vm.totalSalesStock = vm.totalSalesStock + parseFloat(vm.itemStockReport[i].salesStock);
			vm.totalWasteStock = vm.totalWasteStock + parseFloat(vm.itemStockReport[i].wastageStock);
			vm.totalVarStock = vm.totalVarStock + parseFloat(vm.itemStockReport[i].varianceStock);
			vm.totalCurrStock = vm.totalCurrStock + parseFloat(vm.itemStockReport[i].item_currqty);
			vm.totalCurrValue = vm.totalCurrValue + parseFloat(vm.itemStockReport[i].currStockValue);
		}
					
		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemstockPDFExport = itemstockPDFExport;
		vm.itemstockCSVExport = itemstockCSVExport;
        //////////
		
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.itmStockList);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.itemstockReportList2@save', {param:{itmStockList:vm.itmStockList,periodID:localStorage.getItem('periodID'),branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemStockReport = vm.output.itemStockReport;
					
					vm.categoryList = vm.output.categoryList;
					vm.itemList = vm.output.itemList;

					vm.itmStockList = {catID:vm.output.catID,itmID:vm.output.itmID};
					
					vm.totalOpStock = 0; vm.totalSalesStock = 0; vm.totalWasteStock = 0; 
					vm.totalVarStock = 0; vm.totalCurrStock = 0; vm.totalCurrValue = 0;
		
					for(var i=0;i<vm.itemStockReport.length;i++){
						vm.totalOpStock = vm.totalOpStock + parseFloat(vm.itemStockReport[i].openingStock);
						vm.totalSalesStock = vm.totalSalesStock + parseFloat(vm.itemStockReport[i].salesStock);
						vm.totalWasteStock = vm.totalWasteStock + parseFloat(vm.itemStockReport[i].wastageStock);
						vm.totalVarStock = vm.totalVarStock + parseFloat(vm.itemStockReport[i].varianceStock);
						vm.totalCurrStock = vm.totalCurrStock + parseFloat(vm.itemStockReport[i].item_currqty);
						vm.totalCurrValue = vm.totalCurrValue + parseFloat(vm.itemStockReport[i].currStockValue);
					}
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		function itemstockPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemstockPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.itemstockDets.mode+"|"+vm.itemstockDets.from+"|"+vm.itemstockDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemstockPDFExport/'+vm.param;			 			 
        }
		
		function itemstockCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemstockPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.itemstockDets.mode+"|"+vm.itemstockDets.from+"|"+vm.itemstockDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemstockCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.item-stock-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'item-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'item-stock-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}        								
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.item-report')
        .controller('ItemReportController', ItemReportController);

    /** @ngInject */
    function ItemReportController(ItemReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Item wise Sales Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data      
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		 
		vm.itemreportList = ItemReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.itemreportList);   
		vm.branchID = vm.itemreportList.branchID;
		vm.itemList = vm.itemreportList.itemList;
		vm.categoryList = vm.itemreportList.categoryList;
		//vm.itemList = vm.itemreportList.itemList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.itemDets = {from:vm.itemreportList.from,to:vm.itemreportList.to,type:'Today',catID:vm.itemreportList.catID,itmID:vm.itemreportList.itmID};
		
		vm.itemReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemPDFExport = itemPDFExport;
		vm.itemCSVExport = itemCSVExport;
		vm.changeDate = changeDate;
		
		/*alert(vm.itemDets.type);
		var date = new Date();
		vm.itemDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		vm.itemDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		alert(vm.itemDets.from+" "+vm.itemDets.to);*/
		changeDate();
		
		/*for(var i=0;i<vm.itemreportList.workReportBillItems.length;i++){
			vm.itemreportList.workReportBillItems[i].bitm_tax = parseFloat((vm.itemreportList.workReportBillItems[i].bitm_total * vm.tax)/100);
			
			vm.itemreportList.workReportBillItems[i].bitm_taxtotal = parseFloat(vm.itemreportList.workReportBillItems[i].bitm_tax) + parseFloat(vm.itemreportList.workReportBillItems[i].bitm_total);
		}*/
		if(__env.isDebug) console.log(vm.itemreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function itemPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.itemDets.mode+"|"+vm.itemDets.from+"|"+vm.itemDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemPDFExport/'+vm.param;			 			 
        }
		
		function itemCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.itemDets.mode+"|"+vm.itemDets.from+"|"+vm.itemDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.item-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'item-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'item-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.itemDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.itemReportList2@save', {param:{itemDets:vm.itemDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'item-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemList = vm.output.itemList;
					vm.itemReportList = vm.output.workReportBillItems;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.itemDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,itmID:vm.output.itmID,catID:vm.output.catID};
					
					vm.totalAmt = 0;
					for(var i=0;i<vm.itemReportList.length;i++){
						vm.totalAmt = vm.totalAmt + parseFloat(vm.itemReportList[i].bitm_total);						
					}
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.itemDets.type);	
			if(vm.itemDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.itemDets.from = day;
				vm.itemDets.to = day;
				
			} else if(vm.itemDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.itemDets.from = day;
				vm.itemDets.to = day;
			} else if(vm.itemDets.type == 'This Week'){
				var date = moment();
				
				vm.itemDets.from = date.clone().startOf('isoWeek');
				vm.itemDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.itemDets.type == 'This Month'){
				var date = new Date();
								
				vm.itemDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.itemDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.itemDets.from+" "+vm.itemDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.item-reorder-report',
            [
                // 3rd Party Dependencies
                'flow',
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.item-reorder-report', {
				url    : '/item-reorder-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item-reorder-report/item-reorder-report.html',
						controller : 'ItemReorderReportController as vm'
					}
				},
				resolve: {					
					ItemReorderReportList: function (msApi)
					{					
						return msApi.resolve('app.itemreorderReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.item-reorder-report-list', {
				url    : '/item-reorder-report',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/item-reorder-report/item-reorder-report.html',
						controller : 'ItemReorderReportController as vm'
					}
				},
				resolve: {					
					ItemReorderReportList: function ($stateParams, itemreorderreportService)
					{
						
						return msApi.resolve('app.itemreorderReportList@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/item-reorder-report');
			
			// Api						
			msApiProvider.register('app.itemreorderReportList', ['itemreorderReportList']);
			msApiProvider.register('app.itemreorderReportList2', ['itemreorderReportList2']);
			msApiProvider.register('app.item-reportSave', ['item-reportSave']);	
			msApiProvider.register('app.printWPReport5', ['printWPReport5']);
			msApiProvider.register('app.printItmsReport5', ['printItmsReport5']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('item-report', {
				title : 'Tickets',
				//icon  : 'icon-account-multiple',
				state : 'app.item-reorder-report',
				weight: 2
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.item-reorder-report')
        .controller('ItemReorderReportController', ItemReorderReportController);

    /** @ngInject */
    function ItemReorderReportController(ItemReorderReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Item Reorder Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Reorder Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data    
		
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');

		
		vm.itemreorderreportList = ItemReorderReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.itemreorderreportList);   
		vm.branchID = vm.itemreorderreportList.branchID;
		vm.itemReorderReport = vm.itemreorderreportList.itemReorderReport;
		vm.categoryList = vm.itemreorderreportList.categoryList;
		vm.itemList = vm.itemreorderreportList.itemList;

		vm.reorderstockDets = {catID:vm.itemReorderReport.catID,itmID:vm.itemReorderReport.itmID};
			
		vm.totalStock = 0;
		for(var i=0;i<vm.itemReorderReport.length;i++){
			vm.totalStock = vm.totalStock + parseFloat(vm.itemReorderReport[i].item_currqty);
		}			
		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.itemreorderPDFExport = itemreorderPDFExport;
		vm.itemreorderCSVExport = itemreorderCSVExport;
        //////////
		
		
		function itemreorderPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemreorderPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.itemreorderDets.mode+"|"+vm.itemreorderDets.from+"|"+vm.itemreorderDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemreorderPDFExport/'+vm.param;			 			 
        }
		
		function itemreorderCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'itemreorderPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.itemreorderDets.mode+"|"+vm.itemreorderDets.from+"|"+vm.itemreorderDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'itemreorderCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.item-reorder-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'item-reorder-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'item-reorder-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}     


		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.reorderstockDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.itemreorderReportList2@save', {param:{reorderstockDets:vm.reorderstockDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'opening-stock-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.itemReorderReport = vm.output.itemReorderReport;
					
					vm.categoryList = vm.output.categoryList;
					vm.itemList = vm.output.itemList;

					vm.reorderstockDets = {catID:vm.output.catID,itmID:vm.output.itmID};
					
					for(var i=0;i<vm.itemReorderReport.length;i++){
						vm.totalStock = vm.totalStock + parseFloat(vm.itemReorderReport[i].item_currqty);
					}
										
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}   								
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.item')
        .controller('ItemListController', ItemListController);

    /** @ngInject */
    function ItemListController($state, ItemList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Item Pools";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0
		vm.clearsalesBlock=0;
		
		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.item = ItemList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.item);
        vm.listForm={};
		vm.chkAll = 0;
		vm.blockBtn = 0;
		vm.branchID = vm.item.branchID;
		vm.warehouseList = vm.item.warehouseList;
		
		if(vm.item.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddItem = gotoAddItem;		
		
		vm.gotoitem = gotoitem;	
		vm.editItem = editItem;
		vm.deleteItem = deleteItem;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		
		vm.selectAll = selectAll;
		vm.saveItems = saveItems;
        
        //////////
		
		
		function selectAll(){
			//alert(vm.chkAll);
			if(vm.chkAll==0){
				vm.chkAll = 1;	
				for(var i=0;i<vm.item.itemList.length;i++){
					vm.item.itemList[i].itemlist_selected = 1;
				}
			} else if(vm.chkAll==1){
				vm.chkAll = 0;	
				for(var i=0;i<vm.item.itemList.length;i++){
					vm.item.itemList[i].itemlist_selected = 0;
				}
			}	
		}
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddItem()
        {
			 //alert("Hi");
			 $state.go('app.item.add');
        } 
		
		function editItem(itmlist_id)
        {
			 //alert(itmlist_id);
			 $state.go('app.item.edit', {itmlist_id: itmlist_id});
        }
		
		function gotoitem()
        {
			//alert("1");
            $state.go('app.item-list');
        }
		
		function gotoPayments(itmlist_id){
			$state.go('app.item-payment', {itmlist_id: itmlist_id});
		}
						
		function deleteItem(itemlist)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(itemlist);
			//if(__env.isDebug) console.log(vm.admission);
			//alert(itemlist.itemlist_id);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				if(itemlist.itemlist_branchs>0){
					var msg="This item already selected for "+itemlist.itemlist_branchs+" branchs. Do you delete this item?";	
				} else {
					var msg="Do you delete this item?";	
				}	
				var r = confirm(msg);
				if (r == true) {
					msApi.request('app.itemDel@save', {mode:'delete',table:'tbl_itemlist',param:{itemlist_id:itemlist.itemlist_id},aToken:aToken,page:'item'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Item Deleted').position('top right')
							);
							gotoitem();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function saveItems()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.item.itemList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			vm.blockBtn = 1;

			if(aToken!=""){
				$mdToast.show(
					$mdToast.simple().textContent('Please wait until update').position('top right')
				);	
				msApi.request('app.saveItems@save', {param:{itemList:vm.item.itemList,branchID:vm.branchID},aToken:aToken,page:'item'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						vm.blockBtn = 0;
						$mdToast.show(
							$mdToast.simple().textContent('Item(s) Updated').position('top right')
						);
						gotoitem();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.inventory',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.inventory', {
				url    : '/inventory',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/inventory/inventory.html',
						controller : 'InventoryListController as vm'
					}
				},
				resolve: {					
					InventoryList: function (msApi)
					{					
						return msApi.resolve('app.inventoryList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.inventory-list', {
				url    : '/inventory',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/inventory/inventory.html',
						controller : 'InventoryListController as vm'
					}
				},
				resolve: {					
					InventoryList: function (msApi)
					{					
						return msApi.resolve('app.inventoryList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/inventory');
			
			// Api						
			msApiProvider.register('app.inventoryList', ['inventoryList']);						
			msApiProvider.register('app.inventorysave', ['inventorysave']);
			msApiProvider.register('app.inventoryUpdate', ['inventoryUpdate']);
			msApiProvider.register('app.getExpDate', ['getExpDate']);
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('inventory', {
				title : 'Inventory',
				//icon  : 'icon-account-multiple',
				state : 'app.inventory',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.inventory')
        .controller('InventoryListController', InventoryListController);

    /** @ngInject */
    function InventoryListController($scope, $mdSidenav, InventoryList, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window, $filter, $log, $timeout)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Opening Stock Entry";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Inventory" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0; vm.ivarianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
        if(__env.isDebug) console.log("Inventory Details");	
		vm.inventoryDB = InventoryList.data;        		     				
		if(__env.isDebug) console.log(vm.inventoryDB);	
				
		vm.branchID = vm.inventoryDB.branchID;
		vm.periodID = localStorage.getItem('periodID');
		vm.inventoryList = vm.inventoryDB.inventoryList;
		vm.productsList = vm.inventoryDB.batchItmsList;
		vm.productInsert = 1;

		if(__env.isDebug) console.log(vm.productsList);
						
		vm.inventory = {date:vm.inventoryDB.date};
		vm.inventoryItems = [];		
		vm.newItems = {sno:1,branchID:vm.branchID,periodID:vm.periodID,inventory_id:'',itms_name:'',itms_id:'',option_id:'',itms_unit_id:'',itms_unit_name:'',itms_price:'',itms_qty:'0',itms_currqty:'0',itms_prod_date:'',itms_expiry_days:'',itms_expiry_date:'',itms_cost_price:'',itms_selling_price:'',itms_list:false,itms_remove:false};
		vm.inventoryItems.push(vm.newItems);		
		if(__env.isDebug) console.log(vm.inventoryItems);
		
						
		// Methods
        vm.saveInventory = saveInventory;
		vm.gotoInventory = gotoInventory;
		vm.setProdID = setProdID;				
		vm.showitmlist = showitmlist;		
		vm.removeProduct = removeProduct;
		vm.getExpDate = getExpDate;
		vm.editInventory = editInventory;


		vm.simulateQuery = false;
	    vm.isDisabled    = false;
	    vm.repos         = loadAll();
	    vm.querySearch   = querySearch;
	    vm.selectedItemChange = selectedItemChange;
	    vm.searchTextChange   = searchTextChange;

        function querySearch (query) {
        	//alert("Query");
	      	var results = query ? vm.repos.filter( createFilterFor(query) ) : vm.repos,
	          deferred;
	          //alert(results);
	      	if (vm.simulateQuery) {
	        	//alert("IF");
	        	deferred = $q.defer();
	        	$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        	return deferred.promise;
	      	} else {
	      		//alert("Else");
	        	return results;
	      	}
	    }
	    
	    function searchTextChange(text) {
	    	//alert("Text Change");
	      	//$log.info('Text changed to ' + text);
	    }
	    
	    function selectedItemChange(item) {
	    	//alert("Item Change");
	    	//alert(item.item_name);
	    	setProdID(item.item_id)
	      	//$log.info('Item changed to ' + JSON.stringify(item));
	    }
	    
	    function loadAll() {
	    	//alert("Loading");
	      	var repos = vm.productsList
	      	return repos.map( function (repo) {
	        	repo.item_name_low = repo.item_name.toLowerCase();
	        	repo.item_code_low = repo.item_code.toLowerCase();
	        	repo.item_barcode_low = repo.item_barcode.toLowerCase();
	        	return repo;
	      	});
	    }
	    
	    function createFilterFor(query) {
	    	//alert("Filter");
	      	var lowercaseQuery = angular.lowercase(query);
	      	return function filterFn(item) {
	        	return (item.item_name_low.indexOf(lowercaseQuery) === 0 || item.item_code_low.indexOf(lowercaseQuery) === 0 || item.item_barcode_low.indexOf(lowercaseQuery) === 0);
	      	};
	    }

		function getExpDate(itms){
			//alert(itms.itms_prod_date+" && "+itms.itms_expiry_days);
			if(itms.itms_prod_date!="" && itms.itms_expiry_days!="" && itms.itms_expiry_days>=0){
				var UserID=localStorage.getItem('UserID');
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.getExpDate@save', {param:{itms:itms},aToken:aToken,page:'inventory'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							if(__env.isDebug) console.log(response);
							//alert(response);	
							itms.itms_expiry_date = response.expiry_date; 					
							
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				} else {
					$mdToast.show(
						$mdToast.simple().textContent('Access Token Expired').position('top right')
					);
					//$state.go('app.login');	
				}
			}
		}

		function showitmlist(param){
			//alert(param);
			if(vm.productInsert==1){			
				for(var i=0;i<vm.inventoryItems.length;i++){
					//alert(vm.inventoryItems[i].itms_qty);
					if(vm.inventoryItems[i].sno == param){
						vm.inventoryItems[i].itms_list = true;
					}
				}	
			}
		}		
								
        function gotoInventory()
        {
			//alert("1");
            //$state.go('app.inventory-list');

            if($state.current.name=="app.inventory"){
                $state.go('app.inventory-list');                
            } else if($state.current.name=="app.inventory-list"){
                $state.go('app.inventory');                 
            } else {
                $state.go('app.inventory'); 
            }
        }	

        function editInventory(inventory){
        	if(__env.isDebug) console.log("Inventory");
			if(__env.isDebug) console.log(inventory);
			vm.productInsert = 0;
			vm.inventoryItems = [];
			vm.newItems = {sno:1,branchID:vm.branchID,periodID:vm.periodID,inventory_id:inventory.inventory_id,itms_name:inventory.item_name,itms_id:inventory.inventory_item_id,option_id:inventory.inventory_option_id,itms_unit_id:inventory.unit_id,itms_unit_name:inventory.unit_name,itms_price:'',itms_qty:inventory.inventory_qty,itms_currqty:inventory.inventory_qty,itms_prod_date:inventory.inventory_prod_date,itms_expiry_days:inventory.inventory_expiry_days,itms_expiry_date:inventory.inventory_expiry_date,itms_list:false,itms_remove:false};
			vm.inventoryItems.push(vm.newItems);
			if(__env.isDebug) console.log(vm.inventoryItems);
        }	
			
		function setProdID(param,index){
			var ind = 0;
			vm.obj = [];			
			var arrInp = vm.inventoryDB.batchItmsList;
			//alert(param+" "+index);
			
			if(__env.isDebug) console.log("In");
			if(__env.isDebug) console.log(vm.inventoryItems);
					

			vm.itms_name = '';
			vm.itms_id = '';
			vm.option_id = '';
			vm.itms_unit_id = '';
			vm.itms_unit_name = '';	
			vm.itms_list = '';
			vm.itms_cost = 0;
			vm.itms_sale = 0;				
			vm.itms_remove = false;
			
			for(var i=0;i<arrInp.length;i++){
				//alert(i);
				if(arrInp[i].item_id == param){
					//alert("In2");
					ind++;
					//alert(arrInp[i].product_name);
					vm.itms_name = arrInp[i].item_name;
					vm.itms_id = arrInp[i].item_id;
					vm.option_id = arrInp[i].itm_option_id;
					vm.itms_unit_id = arrInp[i].unit_id;
					vm.itms_unit_name = arrInp[i].unit_name;
					//vm.itms_sale = arrInp[i].item_price;										
					vm.itms_list = false;
					vm.itms_remove = true;
				}
			}
			//if(__env.isDebug) console.log(vm.itms_name+" "+vm.itms_id+" "+vm.itms_unit);
			
			var len = vm.inventoryItems.length-1;
			var ind = vm.inventoryItems.length;
			for(var i=len;i<vm.inventoryItems.length;i++){
				vm.inventoryItems[i].sno 		= ind;
				vm.inventoryItems[i].itms_name 	= vm.itms_name;
				vm.inventoryItems[i].itms_id 	= vm.itms_id;
				vm.inventoryItems[i].option_id 	= vm.option_id;				
				vm.inventoryItems[i].itms_unit_id 	= vm.itms_unit_id;
				vm.inventoryItems[i].itms_unit_name = vm.itms_unit_name;
				vm.inventoryItems[i].itms_cost_price = vm.itms_cost;
				vm.inventoryItems[i].itms_selling_price = vm.itms_sale;				
				vm.inventoryItems[i].itms_list	= vm.itms_list;
				vm.inventoryItems[i].itms_prod_date = vm.inventoryDB.prodDate;
				vm.inventoryItems[i].itms_remove = vm.itms_remove;
				vm.inventoryItems[i].itms_qty = '';				
			}
			//alert(len);
			$('#itms_qty'+len).focus();

			/*vm.inventoryItems[i].sno 		= ind;
			vm.inventoryItems[i].itms_name 	= vm.itms_name;
			vm.inventoryItems[i].itms_id 	= vm.itms_id;
			vm.inventoryItems[i].option_id 	= vm.option_id;				
			vm.inventoryItems[i].itms_unit_id 	= vm.itms_unit_id;
			vm.inventoryItems[i].itms_unit_name = vm.itms_unit_name;				
			vm.inventoryItems[i].itms_list	= vm.itms_list;
			vm.inventoryItems[i].itms_prod_date = vm.inventoryDB.prodDate;
			vm.inventoryItems[i].itms_remove = vm.itms_remove;*/

			
			if(vm.inventoryItems[0].itms_id!=""){ 
				vm.newItems = {sno:ind+1,branchID:vm.branchID,periodID:vm.periodID,inventory_id:'',itms_name:'',itms_id:'',option_id:'',itms_unit_id:'',itms_unit_name:'',itms_price:'',itms_qty:'0',itms_currqty:'0',itms_prod_date:vm.inventoryDB.prodDate,itms_expiry_days:'',itms_expiry_date:'',itms_cost_price:'',itms_selling_price:'',itms_list:false,itms_remove:false};
				vm.inventoryItems.push(vm.newItems);
			}
			
			if(__env.isDebug) console.log("In Listing");
			if(__env.isDebug) console.log(vm.inventoryItems);							
		}		
		
		function removeProduct(param){
			//alert(param);
			for(var i=0;i<vm.inventoryItems.length;i++){
				//alert(vm.inventoryItems[i].itms_qty);
				if(vm.inventoryItems[i].itms_id == param){
					vm.inventoryItems.splice(i, 1);	
				}
			}
			
			if(__env.isDebug) console.log("In Sum");
			if(__env.isDebug) console.log(vm.inventoryItems);
		}
			
        function saveInventory()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.inventory);	
			if(__env.isDebug) console.log(vm.inventoryItems);
			
			
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.inventorysave@save', {param:{inventory:vm.inventory,inventoryitm:vm.inventoryItems,UserID:UserID},aToken:aToken,page:'inventory'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);						
						if(response.data!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Inventory Saved Successfully').position('top right')
							);
							gotoInventory();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients-stock-update',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
		
		

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.ingredients-stock-update', {
				url    : '/ingredients-stock-update',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients-stock-update/ingredients-stock-update.html',
						controller : 'IngredientsstockupdateListController as vm'
					}
				},
				resolve: {					
					StockUpdateList: function (msApi)
					{					
						return msApi.resolve('app.ingredientsUpdateList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			})
			.state('app.ingredients-stock-update-list', {
				url    : '/ingredients-stock-update',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/ingredients-stock-update/ingredients-stock-update.html',
						controller : 'IngredientsstockupdateListController as vm'
					}
				},
				resolve: {					
					StockUpdateList: function (msApi)
					{					
						return msApi.resolve('app.ingredientsUpdateList@get',{branchID:localStorage.getItem('BranchID')});
						//return '';
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/ingredients-stock-update');
			
			// Api						
			msApiProvider.register('app.ingredientsUpdateList', ['ingredientsUpdateList']);						
			msApiProvider.register('app.ingredientsUpdateSave', ['ingredientsUpdateSave']);
			msApiProvider.register('app.varianceUpdate', ['varianceUpdate']);
			msApiProvider.register('app.getExpDate', ['getExpDate']);
			
			
	
			// Navigation
			msNavigationServiceProvider.saveItem('ingredients-stock-update', {
				title : 'Variance',
				//icon  : 'icon-account-multiple',
				state : 'app.ingredients-stock-update',
				weight: 6
			});		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients-stock-update')
        .controller('IngredientsstockupdateListController', IngredientsstockupdateListController);

    /** @ngInject */
    function IngredientsstockupdateListController($scope, $mdSidenav, StockUpdateList, msUtils, $mdDialog, $document, msApi, $state, $mdToast, $rootScope, $window, $filter)
    {				
        
     	var vm = this;
		$rootScope.pageTitle = "Ingredients Physical Stock Update";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Ingredients Physical Stock Update" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.warmasterageBlock=0; vm.purBlock=0; vm.transinBlock=0; vm.transoutBlock=0; vm.stkrptBlock=0;
		vm.inventoryBlock=0; vm.wasteBlock=0; vm.varianceBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["warmasterageBlock"]==1){ vm.warmasterageBlock=1; }
			if(vm.page["purBlock"]==1){ vm.purBlock=1; }
			if(vm.page["transinBlock"]==1){ vm.transinBlock=1; }
			if(vm.page["transoutBlock"]==1){ vm.transoutBlock=1; }
			if(vm.page["stkrptBlock"]==1){ vm.stkrptBlock=1; }
			if(vm.page["inventoryBlock"]==1){ vm.inventoryBlock=1; }			
			if(vm.page["wasteBlock"]==1){ vm.wasteBlock=1; }
			if(vm.page["varianceBlock"]==1){ vm.varianceBlock=1; }
			if(vm.page["ivarianceBlock"]==1){ vm.ivarianceBlock=1; }
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
        if(__env.isDebug) console.log("StockUpdate Details");	
		vm.varianceDB = StockUpdateList.data;        		     				
		if(__env.isDebug) console.log(vm.varianceDB);	
				
		vm.branchID = vm.varianceDB.branchID;
		vm.periodID = localStorage.getItem('periodID');
		vm.itemStockList = vm.varianceDB.itemStockList;		
		vm.search = "";
		
		vm.mainChk = 0;
		for(var i=0;i<vm.itemStockList.length;i++){
			vm.itemStockList[i].physicalQty = vm.itemStockList[i].wstock_hqty;
			vm.itemStockList[i].varianceQty = parseFloat(vm.itemStockList[i].wstock_hqty) - parseFloat(vm.itemStockList[i].physicalQty);
			vm.itemStockList[i].remarks = "";
		}
		if(__env.isDebug) console.log(vm.itemStockList);							
		
						
		// Methods
        vm.saveStockUpdate = saveStockUpdate;
		vm.gotoStockUpdate = gotoStockUpdate;
		vm.selectAll = selectAll;
		vm.setStockUpdate = setStockUpdate;
		
        function gotoStockUpdate()
        {
			//alert("1");
            //$state.go('app.variance-list');

            if($state.current.name=="app.ingredients-stock-update"){
                $state.go('app.ingredients-stock-update-list');                
            } else if($state.current.name=="app.ingredients-stock-update-list"){
                $state.go('app.ingredients-stock-update');                 
            } else {
                $state.go('app.ingredients-stock-update'); 
            }
        }	

        function setStockUpdate(){
        	for(var i=0;i<vm.itemStockList.length;i++){
				vm.itemStockList[i].varianceQty = parseFloat(vm.itemStockList[i].wstock_hqty) - parseFloat(vm.itemStockList[i].physicalQty);				
				if(isNaN(vm.itemStockList[i].varianceQty)){
					vm.itemStockList[i].varianceQty = 0;
				}
			}
			if(__env.isDebug) console.log(vm.itemStockList);
        }

        function selectAll(){
			if(vm.mainChk==0){
				vm.mainChk=1;
				for(var i=0;i<vm.itemStockList.length;i++){
					vm.itemStockList[i].selectedchk = 1;
				}
			} else {
				vm.mainChk=0;	
				for(var i=0;i<vm.itemStockList.length;i++){
					vm.itemStockList[i].selectedchk = 0;
				}	
			}
		}

        	
        function saveStockUpdate()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.itemStockList);	
			
			for (var i = 0; i < vm.itemStockList.length; i++) {
				vm.itemStockList[i].branchID = vm.branchID;
				vm.itemStockList[i].periodID = vm.periodID;				
			}
			
			if(__env.isDebug) console.log(vm.itemStockList);
			var UserID=localStorage.getItem('UserID');
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.ingredientsUpdateSave@save', {param:{itemStockList:vm.itemStockList,UserID:UserID,branchID:vm.branchID},aToken:aToken,page:'variance'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response);
						//alert(response.data);						
						if(response.data==1){
							$mdToast.show(
								$mdToast.simple().textContent('Ingredients Stock Update Successfully').position('top right')
							);
							gotoStockUpdate();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		                        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ingredients')
        .controller('IngredientsListController', IngredientsListController);

    /** @ngInject */
    function IngredientsListController($state, IngredientsList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Ingredients";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Ingredients" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.ingredients = IngredientsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ingredients);
        vm.listForm={};
		
		if(vm.ingredients.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddIngredients = gotoAddIngredients;		
		vm.gotoingredients = gotoingredients;	
		vm.editIngredients = editIngredients;
		vm.deleteIngredients = deleteIngredients;
		vm.gotoLogin = gotoLogin;
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddIngredients()
        {
			 //alert("Hi");
			 $state.go('app.ingredients.add');
        } 
		
		function editIngredients(ingredients_id)
        {
			 //alert(ingredients_id);
			 $state.go('app.ingredients.edit', {ingredients_id: ingredients_id});
        }
		
		function gotoingredients()
        {
			//alert("1");
            $state.go('app.ingredients-list');
        }
								
		function deleteIngredients(ingredients_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.ingredients);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this ingredients?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_ingredients',param:{ingredients_id:ingredients_id},aToken:aToken,page:'ingredients'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Ingredients Deleted').position('top right')
							);
							gotoingredients();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
							
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.home', {
				url    : '/home',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/home/home.html',
						controller : 'HomeController as vm'
					},
					'toolbar@app'   : {
                        templateUrl: 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarControllerIn as vm'
                    }
				},
				resolve: {					
					PeriodList: function (msApi)
					{					
						return msApi.resolve('app.periodDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.home-list', {
				url    : '/home',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/home/home.html',
						controller : 'HomeController as vm'
					},
					'toolbar@app'   : {
                        templateUrl: 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarControllerIn as vm'
                    }
				},
				resolve: {					
					PeriodList: function (msApi)
					{					
						return msApi.resolve('app.periodDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/home');
			
			// Api						
			msApiProvider.register('app.periodDets', ['periodDets']);
			msApiProvider.register('app.saveStart', ['saveStart']);
			msApiProvider.register('app.saveEnd', ['saveEnd']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('home', {
				title : 'Dines',
				//icon  : 'icon-account-multiple',
				state : 'app.home',
				weight: 8
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController(PeriodList, $state, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope, $mdDialog, $document, $cookies)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Main Menu";

		vm.wprptBlock=0; vm.posBlock=0; vm.ticketBlock=0; vm.dashBlock=0; 
		vm.wareBlock=0; vm.manageBlock=0; vm.rptBlock=0; vm.supBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["workBlock"]==1){ vm.workBlock=1; }
			if(vm.page["posBlock"]==1){ vm.posBlock=1; }
			if(vm.page["ticketBlock"]==1){ vm.ticketBlock=1; }
			if(vm.page["dashBlock"]==1){ vm.dashBlock=1; }
			if(vm.page["wareBlock"]==1){ vm.wareBlock=1; }
			if(vm.page["manageBlock"]==1){ vm.manageBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["rptBlock"]==1){ vm.rptBlock=1; }
			if(vm.page["supBlock"]==1){ vm.supBlock=1; }
		}
		
		vm.periodList = PeriodList.data;
		if(__env.isDebug) console.log("List");
		if(__env.isDebug) console.log(vm.periodList);
		vm.role = localStorage.getItem('UserRole');
				

		$rootScope.totalAlert = 0;       
        vm.alertList = JSON.parse($window.localStorage['customKots']);
        if(__env.isDebug) console.log("Alert List");
        if(__env.isDebug) console.log(vm.alertList);
        if(vm.alertList.length>0){
            $rootScope.totalAlert = vm.alertList.length;
        }
        vm.totalAlert = $rootScope.totalAlert;
		
        // Data		
		vm.periodID = '';
		//vm.showPOS = 0;
		if($window.localStorage['periodID']!=""){
			vm.periodID = JSON.parse($window.localStorage['periodID']);
			//vm.showPOS = 1;
		}
		//alert(vm.showPOS);

			
		if(__env.isDebug) console.log('List 3');
		if(__env.isDebug) console.log(vm.periodID);
		vm.startperiod = {workperiod_start_amount:'',workperiod_start_description:''};		
		vm.endperiod = {workperiod_end_amount:'',workperiod_end_description:''};
		
		//vm.periodID = '';
		vm.periodStatus = 0;
		
		if(vm.periodList.periodDets!=""){
			//vm.periodID = vm.periodList.periodDets.workperiod_id;
			vm.periodStatus = vm.periodList.periodDets.workperiod_status;	
		}		
		
		if(vm.periodID==""){
			vm.showPOS = 0;
		}
		
		vm.listCell = 1;
		vm.startCell = 0;
		vm.endCell = 0;
		
						
		// Methods        
		vm.gotoLogin = gotoLogin;						
		vm.gotoWorkPeriod = gotoWorkPeriod;
		vm.gotoPOS = gotoPOS;
		vm.gotoTickets = gotoTickets;
		vm.gotoDashboard = gotoDashboard;
		vm.reports = reports;
		vm.support = support;
		vm.warehouse = warehouse;
		vm.department = department;
		vm.logout = logout;	
		vm.openLocalPrinterDialog = openLocalPrinterDialog;
		vm.orderdets = orderdets;
		
		function orderdets(ev){
			$mdDialog.show({
                controller         : 'NotificationDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/login/dialogs/notification/notification-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,               
            });
		}
		
		//alert(localStorage.getItem('LogEntry'));
		vm.localPrinterReminder = $cookies.get("localPrinterReminder");
		if(localStorage.getItem('LogEntry')==1){
			if(vm.localPrinterReminder==0 || !vm.localPrinterReminder){
				openLocalPrinterDialog();
			}
			localStorage.setItem('LogEntry',"0");
		}
		
		
		//////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }				
		
		function gotoWorkPeriod()
        {
			//alert("1");
           $state.go('app.work-period');		   
        }
		
		function gotoPOS(){
			//alert("1");
			localStorage.setItem('departmentID','');
			localStorage.setItem('departmentType','');
			var deptID = localStorage.getItem('departmentID');
			var deptType = localStorage.getItem('departmentType');
			//alert(deptID);
			if(deptID==null || deptID==''){
				vm.departmentList = JSON.parse($window.localStorage['departmentList']);
				
				//alert(vm.departmentList[0].department_id);
				deptID = vm.departmentList[0].department_id;
				deptType = vm.departmentList[0].department_type;
				
				localStorage.setItem('departmentID',deptID);
				localStorage.setItem('departmentType',deptType);

				vm.deptItems = vm.departmentList[0].deptItems;
                vm.categoryList = JSON.parse($window.localStorage['categoryList']);
                vm.productList = JSON.parse($window.localStorage['productList']);

                for(var i=0;i<vm.categoryList.length;i++){
                    vm.categoryList[i].deptShow = 0;
                    if(vm.deptItems.length > 0){
                        for(var d=0;d<vm.deptItems.length;d++){
                            if(vm.deptItems[d].dept_map_category_id==0){
                                vm.categoryList[i].deptShow = 1;
                            } else {
                                if(vm.deptItems[d].dept_map_category_id == vm.categoryList[i].category_id){
                                    vm.categoryList[i].deptShow = 1;
                                }   
                            }
                        }
                    }
                }

                for(var i=0;i<vm.productList.length;i++){                               
                    vm.productList[i].deptShow = 0;
                    if(vm.deptItems.length > 0){
                        for(var d=0;d<vm.deptItems.length;d++){
                        	//alert(vm.deptItems[d].dept_map_item_id);

                        	if(vm.deptItems[d].dept_map_category_id==0 && vm.deptItems[d].dept_map_item_id==0){
                        		vm.productList[i].deptShow = 1;
                        	} else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id==0){
                        		vm.productList[i].deptShow = 1;	                            
                        	} else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id!=0){
                        		if(vm.deptItems[d].dept_map_item_id == vm.productList[i].item_id){
                        			vm.productList[i].deptShow = 1;	                            
                        		}
                        	}	                           
                        }
                    }
                }

                $window.localStorage['categoryList'] = JSON.stringify(vm.categoryList);
                $window.localStorage['productList'] = JSON.stringify(vm.productList);
				
				//$state.go('app.table');	
			}
			//alert(deptType);
			if(deptType=="Dining"){
				$state.go('app.table');
			} else if(deptType=="Home Delivery"){
				$state.go('app.customer-selection');
			} else {
				$state.go('app.dining');
			}
		}
		
		function gotoTickets(){
			$state.go('app.tickets');
		}
		
		function gotoDashboard(){
			$state.go('app.dashboard');
		}
		
		function reports(){
			$state.go('app.report');
		}
		
		function support(){
			$state.go('app.support');
		}
		
		function warehouse(){
			$state.go('app.warehouse');
		}
		
		function department(){
			$state.go('app.department');
		}
		
		function logout()
        {
			//alert("1");
            $state.go('app.login');
        }								        														
		
		function openLocalPrinterDialog(ev)
        {			
            $mdDialog.show({
                controller         : 'LocalPrinterDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/toolbar-inner/dialogs/local-printer/local-printer-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,               
            });
        }
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/main/apps/forgot-password/forgot.html',
                    controller : 'ForgotController as vm'
                }
            },
			resolve: {
				SystemDets: function (msApi)
				{
					return msApi.resolve('app.systemDets@get');
				}    
			},
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/forgot-password');
		
		// Api
		msApiProvider.register('app.systemDets', ['systemDets']);
		msApiProvider.register('app.parentForgot', ['parentForgot']);

        // Navigation
        /*msNavigationServiceProvider.saveItem('apps.forgot-password', {
            title : 'Forgot Password',
            state : 'app.forgot-password',
            weight: 3
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password')
        .controller('ForgotController', ForgotController);

    /** @ngInject */
    function ForgotController(SystemDets, $mdToast, $document, msApi, $state, __env)
    {
        // Data
		var vm = this;
		vm.forgotData = [];
		vm.systemDets = SystemDets.data;
		//if(__env.isDebug) console.log(vm.systemDets);
		
		vm.schoolName = vm.systemDets.genset_school_name;
		vm.schoolLogo = vm.systemDets.genset_logo;
		vm.schoolImage = vm.systemDets.genset_image;
		
		if(vm.schoolImage!=""){
			vm.files = {
				url	: __env.apiUrl+'view/userfiles/logo/'+vm.schoolImage
			};
		} else {
			vm.files = {
				url	: 'assets/images/avatars/profile.jpg'
			};
		}
		if(__env.isDebug) console.log(vm.files);

        // Methods
		
		vm.checkAccount = checkAccount;
		vm.gotoResetPassword = gotoResetPassword;

        //////////
		
		
		/** Check Login **/
		
		function checkAccount(){
			if(__env.isDebug) console.log("Input Data");
			if(__env.isDebug) console.log(vm.forgotData);
			msApi.request('app.parentForgot@save', {param:{mobileno:vm.forgotData.mobileno}},
				// SUCCESS
				function (response){		
					//alert("IF");
					if(__env.isDebug) console.log("Success");
					if(__env.isDebug) console.log(response.data);	
					//alert(response.data);
					if(response.data!=0){
						//vm.selectedParentDet = response.data;
						var inp = (response.data).split(':');
						localStorage.clear();
						localStorage.setItem('UserMobNo',inp[2]);
						//localStorage.setItem('UserPassword',vm.loginData.password);
						localStorage.setItem('UserID',inp[0]);
						localStorage.setItem('UserName',inp[1]);
							
						gotoResetPassword();				
					} else if(response.data==0){
						$mdToast.show(
							$mdToast.simple().textContent('Invalide Mobile No').position('top right')
						);
					}
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					if(__env.isDebug) console.log(response.data);
				}
			);
		}
		
		/** Reset Password Redirection **/
		
		function gotoResetPassword()
        {
			//var param = localStorage.setItem('UserID');
			//alert(param);
			$state.go('app.reset-password');
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.extra')
        .controller('ExtraListController', ExtraListController);

    /** @ngInject */
    function ExtraListController($state, ExtraList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Extra Charges";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Extra Master" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
        vm.ordeTag = ExtraList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.ordeTag);
        vm.listForm={};
		
		if(vm.ordeTag.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddExtra = gotoAddExtra;		
		vm.gotoExtra = gotoExtra;	
		vm.editExtra = editExtra;
		vm.deleteExtra = deleteExtra;
		vm.gotoLogin = gotoLogin;	
		vm.mapExtra = mapExtra;
		vm.optionExtra = optionExtra;
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddExtra()
        {
			 //alert("Hi");
			 $state.go('app.extra.add');
        } 
		
		function editExtra(extra_id)
        {
			 //alert(customer_id);
			 $state.go('app.extra.edit', {extra_id: extra_id});
        }
		
		function mapExtra(extra_id)
        {
			 //alert(customer_id);
			 $state.go('app.extra.mapping', {extra_id: extra_id});
        }
		
		function optionExtra(extra_id)
        {
			 //alert(customer_id);
			 $state.go('app.ordertagoption', {extra_id: extra_id});
        }
		
		function gotoExtra()
        {
			//alert("1");
            $state.go('app.extra-list');
        }
				
							
		function deleteExtra(extra_id)
        {
			//alert(extra_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this extra?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_extra',param:{extra_id:extra_id},aToken:aToken,page:'extra'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_extra_mapping',param:{extra_map_extra_id:extra_id},aToken:aToken,page:'extra'},
								// SUCCESS
								function (response){		
									//alert("IF");
									//if(__env.isDebug) console.log("Success");
									//if(__env.isDebug) console.log(response.data);
									//alert(response.data);											
								},
								// ERROR
								function (response){
									//alert("ELSE");
									if(__env.isDebug) console.log("Error");
									console.error(response.data);
								}
							);
							
							
							$mdToast.show(
								$mdToast.simple().textContent('Extra Deleted').position('top right')
							);
							gotoExtra();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dining')
        .controller('DiningController', DiningController);

    /** @ngInject */
    function DiningController($state, Billing, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope, $filter, $document, $cookies, $mdDialog)
    {
        
     	var vm = this;

     	vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="POS" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.voidBlock=0; vm.giftBlock=0; vm.discBlock=0; vm.allKotBlock=0;
		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);

			if(vm.page["voidBlock"]==1){ vm.voidBlock=1; }
			if(vm.page["giftBlock"]==1){ vm.giftBlock=1; }
			if(vm.page["discBlock"]==1){ vm.discBlock=1; }
			if(vm.page["allKotBlock"]==1){ vm.allKotBlock=1; }
		}		

		//alert(vm.allKotBlock);
		
		vm.input = "";		
		/*$document.bind('keyup', function (e) {
			//alert(String.fromCharCode(e.keyCode));
			//alert(e.which);
			vm.input  = vm.input + String.fromCharCode(e.keyCode);							
		});*/
		
		
		$rootScope.KOTItmCount = 0;
		
		//alert(vm.input);
				
					
				
        // Data
		//alert(tableID);
       	vm.billDet = Billing;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.billDet);
        vm.listForm={};
		if(vm.billDet.unavailableItms!=""){
			$window.localStorage['syncTime'] = JSON.stringify(vm.billDet.syncTime);
			vm.unavailableItms = vm.billDet.unavailableItms;
			vm.productList = JSON.parse($window.localStorage['productList']);
			for(var i=0;i<vm.productList.length;i++){			
				var opcnt22=0;
				for(var j=0;j<vm.unavailableItms.length;j++){			
					if(vm.productList[i].item_id == vm.unavailableItms[j].available_item_id){
						vm.optList=vm.productList[i].itmOptionsList;
						var opcnt2=vm.optList.length;					
						for(var op=0;op<vm.optList.length;op++){			
							//alert(vm.optList[op].itm_option_id+" == "+vm.unavailableItms[j].available_opt_id);
							if(vm.optList[op].itm_option_id == vm.unavailableItms[j].available_opt_id){
								var avalStock = vm.unavailableItms[j].available_stock;
								if(vm.unavailableItms[j].available_status == 1 && vm.unavailableItms[j].available_stock == 0){
									opcnt22++;
									avalStock = 0;								
								}
								vm.optList[op].unavailabeleStatus = vm.unavailableItms[j].available_status;
								vm.optList[op].availableStock = avalStock;
							}
						}
						//alert(opcnt2+" == "+opcnt22);
						if(opcnt2 == opcnt22){
							vm.productList[i].unavailableStatus = 1;
						} else {
							vm.productList[i].unavailableStatus = 0;
						}									
					}		
				}
			}
			if(__env.isDebug) console.log("After unavailableItms");
			if(__env.isDebug) console.log(vm.productList);
			$window.localStorage['productList'] = JSON.stringify(vm.productList);
		}


		vm.ifCustomOrder = "";
		//localStorage.setItem('deptTypeList',"");
		vm.ifCustomType = "";
		if(vm.billDet.customKotDets!=""){
			vm.billDet.tableName = vm.billDet.customKotDets.table_name;
			localStorage.setItem('deptTypeList',"dining-customer");


			//vm.ifCustomOrder = vm.billDet.customKotDets.customerkot_id;
			vm.ifCustomType = vm.billDet.customKotDets.customerkot_type;
		}

		vm.ifCustomNotes = "";
		if(vm.billDet.customKotNotes != ""){
			vm.ifCustomNotes = vm.billDet.customKotNotes;
		}
		if(__env.isDebug) console.log("Notes List");
		if(__env.isDebug) console.log(vm.ifCustomNotes);

		vm.UserName = localStorage.getItem('UserName');
		vm.tblrowactive = {"background": "rgba(67, 160, 71, 0.3)"};

		vm.companyDets = JSON.parse($window.localStorage['companyDets']);		
		if(__env.isDebug) console.log(vm.companyDets);
		vm.roundofrate = (vm.companyDets[0]['branch_roundofrate'])/100;

		vm.showMode = vm.companyDets[0]['branch_showpaymentmodebeforeprint'];
		vm.nacReason = vm.companyDets[0]['branch_anable_nacreason'];
		vm.voidReason = vm.companyDets[0]['branch_anable_voidreason'];
		vm.giftReason = vm.companyDets[0]['branch_anable_giftreason'];
		vm.voidHide = vm.companyDets[0]['branch_showvoidafterprint'];
		vm.giftHide = vm.companyDets[0]['branch_showvoidafterprint'];


		
		vm.periodID = parseInt(JSON.parse($window.localStorage['periodID']));
		//alert(vm.periodID);
		vm.kotItems = [];
		vm.totalAmount = 0;
		vm.totalAmountFinal = 0;
		vm.totalGrossAmount = 0;
		vm.totalQty = 0;
		vm.ifNewRows = 0;
		vm.itemMenu = 0;
		vm.selectedItm = "";
		
		vm.itmstyle = {"bottom": "260px"};
		vm.keystyle = {"display": ""};
		vm.key = 0;
		vm.existBtn = 0;
		
		
		vm.selOrderTags="";
		vm.selOrderTagStatus="";
		//vm.searchItm = {};
		vm.voidShow = 1;
		vm.giftShow = 1;
		vm.plusDisp = 1;
		vm.minusDisp = 1;
		vm.cancelDisp = 1;
		vm.moveDisp = 1;
		vm.voidDisp = 1;
		vm.giftDisp = 1;
		
		//vm.billNotes = "";
		
		vm.saveFlag = 1;
		vm.cashBtn = 1;
		
		vm.sideItms = 1;
		vm.sideRetails = 0;
		vm.sideNote = 0;
		vm.sideOpts = 0;
		vm.sideCust = 0;
		vm.sideMessage = 0;
		vm.giftMessage = 0;
		vm.voidMessage = 0;
		vm.nacMessage = 0;
		vm.sideWaiter = 0;
		vm.sideOrderNo = 0;
		vm.sidePendparcel = 0;
		vm.sidePendRetail = 0;
		vm.sideDiscount = 0;

		vm.listCustomer = 1;
		vm.kotMenu = 0;
		vm.kotID = "";

		vm.customerBox = 1;
		vm.colladped = 0;

		vm.extraMsg = "";

		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');

		//alert(localStorage.getItem('deptTypeList'));
		if(localStorage.getItem('deptTypeList')=="dining"){
			vm.sideItms = 1;	
		} else if(localStorage.getItem('deptTypeList')=="dining-waiter"){
			vm.sideItms = 0;	
			vm.sideWaiter = 1;	
		} else if(localStorage.getItem('deptTypeList')=="dining-customer"){
			vm.sideItms = 0;	
			vm.sideCust = 1;	
		} else if(localStorage.getItem('deptTypeList')=="customers"){
			vm.sideItms = 1;	
		} else if(localStorage.getItem('deptTypeList')=="dining-parcel"){
			vm.sideItms = 1;	
		} else if(localStorage.getItem('deptTypeList')=="pending-parcel"){
			vm.sideItms = 0;	
			vm.sidePendparcel = 1;	
			selectPendParcel();
		} else if(localStorage.getItem('deptTypeList')=="dining-online"){
			vm.sideItms = 1;	
		} else if(localStorage.getItem('deptTypeList')=="dining-retail"){
			vm.sideItms = 0;	
			vm.sideRetails = 1;
		} else if(localStorage.getItem('deptTypeList')=="pending-retail"){
			vm.sideItms = 0;	
			vm.sideRetails = 0;
			vm.sidePendRetail = 1;	
			vm.sideDiscount = 0;
			selectPendRetail();
		} else if(localStorage.getItem('deptTypeList')==""){
			vm.sideItms = 1;	
		} 

		//alert(localStorage.getItem('departmentType'));

		if(localStorage.getItem('departmentType')=="Retail"){
			vm.sideItms = 0;	
			vm.sideRetails = 1;		
		}


		//alert(vm.sideItms+" "+vm.sideRetails);
		
		vm.seletedPriceTag = 0;		
		vm.department = localStorage.getItem('departmentID');
		//alert(vm.department);
		vm.itmOptions = '';
		vm.deptType = "";
		if(localStorage.getItem('departmentType')!=""){
			vm.deptType = localStorage.getItem('departmentType');
		}

		vm.extraSummary = [];
		vm.taxSummary = [];	
		vm.extraSelected=[];
		//alert(!vm.billDet.extraList)
		if(!vm.billDet.extraList==false){
			vm.extraSelected=vm.billDet.extraList;
		}
		
		vm.taxMasterList = JSON.parse($window.localStorage['taxMasterList']);
		vm.extraMasterList2 = JSON.parse($window.localStorage['extraMasterList']);
		vm.extraMasterList = JSON.parse($window.localStorage['extraMasterList']);
		vm.taxRate = JSON.parse($window.localStorage['taxDets']);
		vm.departmentList = JSON.parse($window.localStorage['departmentList']);
		vm.orderTagList = JSON.parse($window.localStorage['orderTags']);
		for(var i=0;i<vm.orderTagList.length;i++){
			var tags = vm.orderTagList[i].orderTagOptions;
			for(var j=0;j<tags.length;j++){	
				tags[j].status = 0;						
			}
		}
		//if(__env.isDebug) console.log(vm.orderTagList);

		for (var i=0;i<vm.extraMasterList.length;i++) {
			var remove=vm.extraMasterList[i].removeStatus;
			vm.extraMasterList[i].extra_delete = 0;
			for (var j=0;j<vm.extraSelected.length;j++) {
				if((vm.extraSelected[j].bextra_extra_id==vm.extraMasterList[i].extra_id) && vm.extraSelected[j].bextra_delete==1){
					remove = 1;
					vm.extraMasterList[i].extra_delete = 1;
					vm.extraMasterList[i].removeStatus = 1;
				}
			}
			var obj={extra_id:vm.extraMasterList[i].extra_id,extra_name:vm.extraMasterList[i].extra_name,extra_inclRemove:vm.extraMasterList[i].extra_inclRemove,extra_inclTax:vm.extraMasterList[i].extra_inclTax,extra_inclDiscount:vm.extraMasterList[i].extra_inclDiscount,extra_total:0,removeStatus:remove,extra_delete:remove,itmList:[]};
			vm.extraSummary.push(obj);
		}

		if(__env.isDebug) console.log(vm.extraSummary);

		for (var i=0;i<vm.taxMasterList.length;i++) {
			var obj={tax_id:vm.taxMasterList[i].tax_id,tax_name:vm.taxMasterList[i].tax_name,tax_type:vm.taxMasterList[i].tax_type,tax_total:0,tax_total2:0};
			vm.taxSummary.push(obj);
		}
		
		vm.payMode = "";
		vm.pageHold = 0;
		vm.deptItems = "";
		vm.ifKotBtnShow = 0; vm.kotBtnLabel = "";
		vm.ifSettleBtnShow = 0; vm.settleBtnLabel = "";		
		vm.printcKotBtnShow = 0;
		for(var i=0;i<vm.departmentList.length;i++){
			if(vm.departmentList[i].department_id == vm.department){
				vm.seletedPriceTag = vm.departmentList[i].department_price_tag_id;
				vm.departmentName = vm.departmentList[i].department_name;
				vm.payMode = (vm.departmentList[i].deptPayMode).split(",");
				vm.pageHold = vm.departmentList[i].department_holdpage;
				//vm.deptItems = vm.departmentList[i].deptItems;
				vm.ifKotBtnShow = vm.departmentList[i].department_ifshowkot;
				vm.kotBtnLabel = vm.departmentList[i].department_kotlable;
				vm.ifSettleBtnShow = vm.departmentList[i].department_ifshowsettle;		
				vm.settleBtnLabel = vm.departmentList[i].department_settlelable;
				vm.printcKotBtnShow = vm.departmentList[i].department_showprintkot;
			}
		}
		//alert(vm.ifKotBtnShow+" "+vm.kotBtnLabel+" "+vm.ifSettleBtnShow+" "+vm.settleBtnLabel);
		$rootScope.pageTitle = vm.departmentName;
		//if(__env.isDebug) console.log("Selected Tag");
		//if(__env.isDebug) console.log(vm.seletedPriceTag);

		if(__env.isDebug) console.log("Payment Mode");
		if(__env.isDebug) console.log(vm.payMode);

		vm.isPrinted = 0;
		if(vm.billDet.billDets.bil_print==1){
			vm.isPrinted = 1;
		}


		vm.customKotNote="";
		if(vm.billDet.customKotDets.customerkot_notes!=""){		
			vm.customKotNote = vm.billDet.customKotDets.customerkot_notes;
		}

		vm.customMessage="";
		if(vm.billDet.customKotDets.customerkot_message!=""){		
			vm.customMessage = vm.billDet.customKotDets.customerkot_message;
		}
		//alert(vm.customMessage);
		
		if(vm.billDet.billDets=="" && vm.billDet.customKotDets==""){
			var tableID = ""; var custID = "";
			if(vm.billDet.tableID){
				tableID = vm.billDet.tableID;
			}
			
			if(vm.billDet.customerID){
				custID = vm.billDet.customerID;
			}
			
			vm.billAddons = {bil_table_id:tableID, bil_cusid:custID, bil_print:"", bil_remarks:"", bil_timing:"", bil_stfid:'', bil_kotrefno:'', bil_orderID:'', billNotes:'', bil_type:vm.deptType, bil_tottaxamt:0, bil_totextraamt:0, bil_totaltaxamt:0, bil_totalqty:0, bil_totalamt:0, bil_totalround:0, bil_totaldiscount:0, bil_totaldiscountrate:'', bil_totalnetamt:0};	
		} else if(vm.billDet.customKotDets!="" && vm.billDet.billDets==""){
		//}  else if(vm.billDet.customKotDets!=""){
			//var roundRate = vm.billDet.billDets.bil_totalround;
			//alert(roundRate);
			//alert(vm.totalAmountFinal);	
			//vm.discount = parseFloat(vm.billDet.billDets.bil_discountamt) + parseFloat(vm.billDet.billDets.bil_round);
			//vm.totalAmountFinal = parseFloat(vm.billDet.billDets.bil_totalnetamt) + parseFloat(vm.billDet.billDets.bil_totalround) - vm.discount;
			
			//vm.nettAmtt = parseFloat(vm.billDet.billDets.bil_totalamt) + parseFloat(vm.billDet.billDets.bil_totalround) + parseFloat(vm.billDet.billDets.bil_totaltaxamt) - parseFloat(vm.billDet.billDets.bil_discountamt) - parseFloat(vm.billDet.billDets.bil_round);
			//alert("In");	
			vm.billAddons = {bil_table_id:vm.billDet.customKotDets.customerkot_table_id, bil_kotrefno:'', bil_orderID:'', bil_cusid:vm.billDet.customKotDets.customerkot_customer_id, bil_print:"", bil_remarks:"", bil_timing:"", bil_stfid:"", billNotes:vm.customMessage, bil_type:vm.deptType, bil_tottaxamt:0, bil_totextraamt:0, bil_totaltaxamt:0, bil_totalqty:0, bil_totalamt:0, bil_totalnetamt:0, bil_totaldiscount:0, bil_totaldiscountrate:'', bil_totalround:0};
		//} else if(vm.billDet.billDets!="" && vm.billDet.customKotDets==""){
		} else if(vm.billDet.billDets!=""){
			var roundRate = vm.billDet.billDets.bil_totalround;
			//alert(roundRate);
			//alert(vm.totalAmountFinal);	
			//alert(vm.billDet.billDets.bil_discountamt);
			vm.discount = parseFloat(vm.billDet.billDets.bil_discountamt) + parseFloat(vm.billDet.billDets.bil_round);
			vm.totalAmountFinal = parseFloat(vm.billDet.billDets.bil_totalnetamt) + parseFloat(vm.billDet.billDets.bil_totalround) - vm.discount;
			//alert("Else");
			//alert(vm.discount);
			var discrate=vm.billDet.billDets.bil_discount;
			if(discrate==0){
				discrate="";
			}

			vm.nettAmtt = parseFloat(vm.billDet.billDets.bil_totalamt) + parseFloat(vm.billDet.billDets.bil_totalround) + parseFloat(vm.billDet.billDets.bil_totaltaxamt) - parseFloat(vm.billDet.billDets.bil_discountamt) - parseFloat(vm.billDet.billDets.bil_round);
			vm.billAddons = {bil_table_id:vm.billDet.billDets.bil_table_id, bil_kotrefno:'', bil_orderID:vm.billDet.billDets.bil_order_id, bil_cusid:vm.billDet.billDets.bil_cusid, bil_print:vm.billDet.billDets.bil_print, bil_remarks:vm.billDet.billDets.bil_remarks, bil_timing:vm.billDet.billDets.bil_timing, bil_stfid:vm.billDet.billDets.bil_stfid, billNotes:vm.billDet.billDets.bil_notes, bil_type:vm.billDet.billDets.bil_type, bil_tottaxamt:vm.billDet.billDets.bil_tottaxamt, bil_totextraamt:vm.billDet.billDets.bil_totextraamt, bil_totaltaxamt:vm.billDet.billDets.bil_totaltaxamt, bil_totalqty:vm.billDet.billDets.bil_totalqty, bil_totalamt:vm.billDet.billDets.bil_totalamt, bil_totalnetamt:vm.nettAmtt, bil_totaldiscount:vm.discount, bil_totaldiscountrate:discrate, bil_totalround:roundRate};
		
		}
		if(__env.isDebug) console.log(vm.billAddons);				
		
		if(vm.billDet.kotItmsDets!="" && vm.billDet.kotItmsDets.length>0){
			var itmDets = vm.billDet.kotItmsDets;	
			if(__env.isDebug) console.log(itmDets);
			for(var i=0;i<itmDets.length;i++){
				var itmName = itmDets[i].item_name+'.'+itmDets[i].itm_option_name;
				if(itmDets[i].itm_option_name=="Normal"){
					itmName = itmDets[i].item_name;
				}

				var orderTagOpt = itmDets[i].kotitem_orderTagsList;
				if(__env.isDebug) console.log("KOT Item Options");
				if(__env.isDebug) console.log(orderTagOpt);
				
				for(var o=0;o<orderTagOpt.length;o++){	
					//alert(orderTagOpt[o].kotitemtag_ordertag_price);
					var rate = 0;
					if(orderTagOpt[o].kotitemtag_ordertag_rate > 0){
						rate = parseFloat(orderTagOpt[o].kotitemtag_ordertag_rate) / parseFloat(itmDets[i].kotitem_qty);	
					}										
					orderTagOpt[o].kotitemtag_ordertag_price = rate							
				}
				if(__env.isDebug) console.log(orderTagOpt);

				var obj	= {kotitem_id:itmDets[i].kotitem_id,kotitem_type:'',kotitem_ref_id:'',kotitem_bill_id:itmDets[i].kotitem_bill_id,kotitem_kot_id:itmDets[i].kotitem_kot_id,kotitem_cat_id:itmDets[i].kotitem_cat_id,kotitem_itm_id:itmDets[i].kotitem_itm_id,kotitem_option_id:itmDets[i].kotitem_option_id,kotitem_itm_name:itmName,kotitem_qty:itmDets[i].kotitem_qty,kotitem_rate:itmDets[i].kotitem_rate,kotitem_totat:itmDets[i].kotitem_totat,kotitem_message:itmDets[i].kotitem_message,kotitem_status:itmDets[i].kotitem_status,kotitem_old_status:itmDets[i].kotitem_status,kotitem_sub_qty:0,kotitem_orderTagsList:itmDets[i].kotitem_orderTagsList,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};
				vm.kotItems.push(obj);	
			}
			if(__env.isDebug) console.log(vm.kotItems);
			//vm.totalAmount = vm.billDet.billDets.bil_totalamt;
			//vm.totalQty = vm.billDet.billDets.bil_totalqty;
		}

		if(vm.billDet.customKotItmsDets!="" && vm.billDet.customKotItmsDets.length>0){
			var itmDets = vm.billDet.customKotItmsDets;	
			var diffID = 0;
			
			for(var i=0;i<itmDets.length;i++){
				var itmName = itmDets[i].item_name+'.'+itmDets[i].itm_option_name;
				if(itmDets[i].itm_option_name=="Normal"){
					itmName = itmDets[i].item_name;
				}

				var orderTags=[];
				var randomID=Math.round(Math.random()*1000);
				var custTags=itmDets[i].kotitem_orderTagsList;
				if(__env.isDebug) console.log(custTags);
				for(var t=0;t<custTags.length;t++){
					var otag = {kotitemtag_tag_id:Math.round(Math.random()*1000), kotitemtag_bill_id:'', kotitemtag_kot_id:'', kotitemtag_kotitem_id:randomID, kotitemtag_ordertag_id:0, kotitemtag_ordertag_name:custTags[t].customerkotitemtag_ordertag_name, kotitemtag_ordertag_rate:custTags[t].customerkotitemtag_ordertag_rate};
					orderTags.push(otag);
				} 
				if(__env.isDebug) console.log(orderTags);

				if(itmDets[i].customerkotitem_qty > 0 && diffID != itmDets[i].customerkot_no){
					diffID = itmDets[i].customerkot_no;	
					//vm.ifCustomOrder = vm.ifCustomOrder+','+itmDets[i].customerkot_id;
					var obj	= {kotitem_id:randomID,kotitem_kot_id:'',kotitem_type:'Custom',kotitem_ordno:'Custom Ord No : '+itmDets[i].customerkot_no,kotitem_orderTagsList:[],kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};				
					vm.kotItems.push(obj);				
				}
				var obj	= {kotitem_id:randomID,kotitem_ref_id:'',kotitem_bill_id:'',kotitem_type:'Custom',kotitem_kot_id:'',kotitem_cat_id:itmDets[i].customerkotitem_cat_id,kotitem_itm_id:itmDets[i].customerkotitem_itm_id,kotitem_option_id:itmDets[i].customerkotitem_option_id,kotitem_itm_name:itmName,kotitem_qty:itmDets[i].customerkotitem_qty,kotitem_rate:itmDets[i].customerkotitem_rate,kotitem_totat:itmDets[i].customerkotitem_totat,kotitem_message:'',kotitem_status:'New',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:orderTags,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};								
				vm.kotItems.push(obj);				
				vm.existBtn++;	
			}
			/*
			if(vm.ifCustomOrder!=""){			
				vm.ifCustomOrder = vm.ifCustomOrder.substring(1);
			}
			*/

			//alert(vm.ifCustomOrder);
			

			vm.ifNewRows = 1;
			if(__env.isDebug) console.log("Custom Kot Items");
			if(__env.isDebug) console.log(vm.kotItems);
			//vm.totalAmount = vm.billDet.billDets.bil_totalamt;
			//vm.totalQty = vm.billDet.billDets.bil_totalqty;
			
			vm.count = 0; 
			for(var i=0;i<vm.kotItems.length;i++){				
				if((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "New-Gift") || (vm.kotItems[i].kotitem_status == "New-Void")){
					vm.count = parseInt(vm.count) + 1;									
				}
			}
			
			$rootScope.KOTItmCount = vm.count;
		}

		if(vm.billDet.customKotDets!="" && vm.ifCustomOrder==""){
			for(var i=0;i<vm.billDet.customKotNotes.length;i++){
				vm.ifCustomOrder = vm.ifCustomOrder+','+vm.billDet.customKotNotes[i].customerkot_id;				
			}
		}
		if(vm.ifCustomOrder!=""){			
			vm.ifCustomOrder = vm.ifCustomOrder.substring(1);
		}
		//alert(vm.ifCustomOrder);
		
		vm.categoryList = JSON.parse($window.localStorage['categoryList']);
		vm.productList = JSON.parse($window.localStorage['productList']);
		//if(__env.isDebug) console.log('List');
		//if(__env.isDebug) console.log(vm.categoryList);
		//if(__env.isDebug) console.log(vm.productList);
		/*if(vm.ordertwo.error == "1"){
			gotoLogin();
		} */
                
        if(__env.isDebug) console.log(vm.deptItems);
		vm.selCatID=vm.categoryList[0].category_id;
		//alert(vm.selCatID);
		/*for(var i=0;i<vm.categoryList.length;i++){
			vm.categoryList[i].deptShow = 0;
			if(vm.deptItems.length > 0){
				for(var d=0;d<vm.deptItems.length;d++){
					if(vm.deptItems[d].dept_map_category_id==0){
						vm.categoryList[i].deptShow = 1;
					} else {
						if(vm.deptItems[d].dept_map_category_id == vm.categoryList[i].category_id){
							vm.categoryList[i].deptShow = 1;
						}	
					}
				}
			}
		}*/

		var colr=0;
		for(var i=0;i<vm.categoryList.length;i++){
			if(vm.categoryList[i].deptShow==1){
				vm.categoryList[i].category_color = (colr%4);	
				vm.categoryList[i].image = __env.imagePath+'/categories/'+vm.categoryList[i].category_image;				
				colr++;
			}
		}
		if(__env.isDebug) console.log(vm.categoryList);
		
		for(var i=0;i<vm.productList.length;i++){			
			vm.productList[i].image = "";
			if(vm.productList[i].item_image!=""){
				vm.productList[i].image = __env.imagePath+'/items/'+vm.productList[i].item_image;	
			}
			
			var opt = vm.productList[i].itmOptionsList;
			var batch = vm.productList[i].batchList;
			var price = 0;
			var optID = 0;
			var optcnt = 0;
			var stock = 0;
			for(var j=0;j<opt.length;j++){			
				if(opt[j].item_price_tag_id == vm.seletedPriceTag && price == 0){
					if(opt[j].unavailabeleStatus == 0){
						price = opt[j].item_price_price;
						optID = opt[j].itm_option_id;
						stock = opt[j].availableStock;
					} else if(opt[j].unavailabeleStatus == 1 && opt[j].availableStock > 0){
						price = opt[j].item_price_price;
						optID = opt[j].itm_option_id;
						stock = opt[j].availableStock;
					}
				}
				
				if(opt[j].item_price_tag_id == vm.seletedPriceTag){
					optcnt = optcnt + 1;
				}
			}
			if(price==0){
				for(var j=0;j<opt.length;j++){			
					if(opt[j].item_price_tag_id == 0){
						if(opt[j].unavailabeleStatus == 0){
							price = opt[j].item_price_price;
							optID = opt[j].itm_option_id;
							stock = opt[j].availableStock;
						} else if(opt[j].unavailabeleStatus == 1 && opt[j].availableStock > 0){
							price = opt[j].item_price_price;
							optID = opt[j].itm_option_id;
							stock = opt[j].availableStock;
						}
					}					
				}	
			}

			if(batch.length>0 && batch[0].inventory_selling_price > 0){
				price = batch[0].inventory_selling_price;				
			}

			if(batch.length>0){
				stock = 0;
				for(var j=0;j<batch.length;j++){
					stock = stock + parseFloat(batch[j].inventory_currqty); 
				}
			}
			
			vm.productList[i].item_price = price;
			vm.productList[i].item_optcnt = optcnt;
			vm.productList[i].item_opt_id = optID;
			vm.productList[i].item_stock = stock;

			/*vm.productList[i].deptShow = 0;
			if(vm.deptItems.length > 0){
				for(var d=0;d<vm.deptItems.length;d++){
					if(vm.deptItems[d].dept_map_item_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id == vm.productList[i].item_id){
						vm.productList[i].deptShow = 1;
					} else if(vm.deptItems[d].dept_map_item_id==0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id){
						vm.productList[i].deptShow = 1;
					}
				}
			}*/
		}
		if(__env.isDebug) console.log("After Rate Fixed");
		if(__env.isDebug) console.log(vm.productList);
								
		//vm.customerList = JSON.parse($window.localStorage['customerList']);

		vm.customerList = vm.billDet.customerList;
		vm.waiterList = JSON.parse($window.localStorage['waiterList']);	

		if(__env.isDebug) console.log(vm.customerList);
		
		vm.customerName = ''; vm.customerMobile = ""; vm.customerAddress="";
		vm.customerRecent = "";
		if(vm.billDet.billDets.customerName!=""){
			vm.customerName = vm.billDet.billDets.customerName;	
		} 
		if(vm.billDet.customKotDets.customer_name!=""){
			vm.customerName = vm.billDet.customKotDets.customer_name;
			vm.customerMobile = vm.billDet.customKotDets.customer_mobileno;
			vm.customerAddress = vm.billDet.customKotDets.customer_address;
			vm.customerRecent = vm.billDet.customKotDets.recentBills;

			vm.customerBox = 0;
		}

		if(vm.billAddons.bil_cusid!=""){
			for(var i=0;i<vm.customerList.length;i++){
				if(vm.customerList[i].customer_id == vm.billAddons.bil_cusid){
					setCustomerDets(vm.customerList[i]);
				}
			}	
		}

		vm.activeTbl = 0;
		//alert(vm.billDet.customKotDets.activeTable);
		if(vm.billDet.customKotDets.activeTable!=""){
			vm.activeTbl = vm.billDet.customKotDets.activeTable;
		}
		
		vm.waiterName = '';
		if(vm.billDet.billDets.waiterName!=""){
			vm.waiterName = vm.billDet.billDets.waiterName;	
		}
		
		vm.catInp = 1;
		//alert(vm.catInp);
				
		//vm.prodRows[0]='One';
		//vm.prodRows[1]='Two';
		//vm.prodRows[2]='Three';
		

		vm.retailDets={retailKOTID:'',retailCatID:'',retailItmID:'',retailOptID:'',retailBatchID:'',retailItm:'',retailItmUnit:'',retailQty:'',retailCurrQty:''}
		vm.discountDets={billAmount:'',billTax:'',discountRate:'',discountAmount:'',discountFocus:''};
		
       	  
        // Methods        
		
		vm.gotoLogin = gotoLogin;
		
		vm.gotoListing = gotoListing;
		vm.gotoBilling = gotoBilling;
		vm.setCategory = setCategory;
		vm.addItmtoKot = addItmtoKot;
		vm.increase = increase;
		vm.decrease = decrease;	
		vm.setAsGift = setAsGift;
		vm.setAsGift2 = setAsGift2;
		vm.cancelGift = cancelGift;
		vm.setAsVoid = setAsVoid;
		vm.setAsVoid2 = setAsVoid2;
		vm.cancelVoid = cancelVoid;		
		vm.showSubMenu = showSubMenu;
		vm.saveKOT = saveKOT;
		vm.saveBill = saveBill;
		vm.closeBillasCash = closeBillasCash;
		vm.closeBillasCard = closeBillasCard;
		vm.closeBillasOnline = closeBillasOnline;
		vm.closeBillasOnline2 = closeBillasOnline2;
		vm.clearInput = clearInput;
		vm.removeItem = removeItem;
		vm.addInput = addInput;
		vm.gotoTicketNote = gotoTicketNote;
		vm.closeTicketNote = closeTicketNote;
		vm.changeItmOption = changeItmOption;
		vm.setCustomerDets = setCustomerDets;
		vm.setWaiterDets = setWaiterDets;
		vm.selectCustomer = selectCustomer;
		vm.selectWaiter = selectWaiter;
		vm.selectOrderID = selectOrderID;
		vm.selectPendParcel = selectPendParcel;
		vm.checkInput = checkInput;
		
		vm.gototable = gototable;
		vm.printBill = printBill;
		vm.setOrderTags = setOrderTags;
		vm.setOrderTags2 = setOrderTags2;
		vm.gotoClearAll = gotoClearAll;
		vm.gotoExit = gotoExit;
		vm.setPendingBill = setPendingBill;
		vm.removeTags = removeTags;
		
		vm.showKeyboard = showKeyboard;
		vm.hideKeyboard = hideKeyboard;

		vm.addCustomer = addCustomer;
		vm.saveCustomer = saveCustomer;
		vm.resetCustomer = resetCustomer;

		vm.reprintKOT = reprintKOT;
		vm.printAllKOT = printAllKOT;
		vm.showReprint = showReprint;
		vm.changeCustomerBox = changeCustomerBox;
		vm.changeTimeBox = changeTimeBox;
		vm.customertbleHideshow = customertbleHideshow;
		
		// Retails Methods
		vm.selRetailItm = selRetailItm;
		vm.selRetailItmBatch = selRetailItmBatch;
		vm.getItmDets = getItmDets;
		vm.getDiscAmount = getDiscAmount;
		vm.gotoAdd = gotoAdd;
		vm.gotoDiscAdd = gotoDiscAdd;
		vm.getDiscAmt = getDiscAmt;
		vm.clearRetailItm = clearRetailItm;
		vm.clearDiscountItm = clearDiscountItm;

		vm.addItmtoKotRetails = addItmtoKotRetails;
		vm.addDiscounttoKot = addDiscounttoKot;
		vm.selectPendRetail = selectPendRetail;
		vm.showDiscount = showDiscount;
		vm.closeRetailBills = closeRetailBills;
		vm.gotoSettle = gotoSettle;
		vm.selectTender = selectTender;
		vm.closeDialog = closeDialog;

		vm.removeExtra = removeExtra;
		vm.searchCustomer = searchCustomer;
		
		vm.retailAddDis = 0;
		vm.discountAddDis = 0;
		$("#retailAddBtn").prop('disabled','false');
		function selRetailItmBatch(itm,batch){
			//alert("Inr");
			if(__env.isDebug) console.log("Selected Batch");
			if(__env.isDebug) console.log(batch);			

			vm.retailDets={retailKOTID:'',retailCatID:itm.catitm_category_id,retailItmID:itm.item_id,retailOptID:itm.item_opt_id,retailBatchID:batch.inventory_id,retailItm:itm.item_name,retailItmUnit:itm.unit_name,retailQty:'',retailCurrQty:parseFloat(batch.inventory_currqty)};
			if(vm.retailDets.retailItm!=""){
				getItmDets();
				//$("#retailQty").focus();
			}
		}	

		function clearDiscountItm(){
			vm.discountDets={billAmount:vm.billAddons.bil_totalamt,billTax:vm.billAddons.bil_tottaxamt,discountRate:'',discountAmount:'',discountFocus:''};			
			$("#discountRate").focus();
		}

		function clearRetailItm(){
			vm.retailDets={retailKOTID:'',retailCatID:'',retailItmID:'',retailOptID:'',retailBatchID:'',retailItm:'',retailItmUnit:'',retailQty:'',retailCurrQty:''}
			$("#retailItm").focus();
		}

		function selRetailItm(itm){
			//alert("Inr 2");
		
			var batchList = itm.batchList;
			if(batchList.length > 1){	
				//alert(itm.showBatch);				
				if(itm.showBatch == 0){
					itm.showBatch = 1;
					vm.retailtblarrow = {"transform": "rotate(180deg)"};
				} else {
					itm.showBatch = 0;
					vm.retailtblarrow = {"transform": "rotate(0deg)"};
				}
			} /*else {
				var batchID = batchList[0].inventory_id;
				vm.retailDets={retailCatID:itm.catitm_category_id,retailItmID:itm.item_id,retailOptID:itm.item_opt_id,retailBatchID:batchID,retailItm:itm.item_name,retailItmUnit:itm.unit_name,retailQty:0};
				vm.retailQtyFocus = 1;
				if(__env.isDebug) console.log("Retail Item Select 1");
				if(__env.isDebug) console.log(vm.retailDets);
			}*/
			
			vm.retailDets={retailKOTID:'',retailCatID:itm.catitm_category_id,retailItmID:itm.item_id,retailOptID:itm.item_opt_id,retailBatchID:"",retailItm:itm.item_name,retailItmUnit:itm.unit_name,retailQty:'',retailCurrQty:parseFloat(itm.item_currqty)};
			if(vm.retailDets.retailItm!=""){
				getItmDets();								
			}

			if(__env.isDebug) console.log(itm);						
		}

		function getDiscAmt(event){
			if(__env.isDebug) console.log("Discount Item");
			if(__env.isDebug) console.log(vm.discountDets);

			//alert(event.keyCode);			
			if(event.keyCode!=9 && (vm.billAddons.bil_totaldiscount!=vm.discountDets.discountAmount)){
				vm.discountDets.discountRate = "";				
			}			

			if(vm.discountDets.discountAmount>0){
				vm.discountAddDis = 1;
			}
		}

		function gotoDiscAdd(){
			if(__env.isDebug) console.log("Discount Item");
			if(__env.isDebug) console.log(vm.discountDets);
			
			$("#discountAddBtn").focus();
			vm.discountAddDis = 1;	
			vm.discountDets.discountFocus = "1";				

			/*if(parseFloat(vm.discountDets.discountAmount) > 0){
				//alert("In");
				$("#discountAddBtn").focus();
				vm.discountAddDis = 1;					
			} else {
				//alert("Else");
				$("#discountAmount").focus();
				vm.discountAddDis = 0;
			}*/
		}

		function gotoAdd(){
			//alert("In");
			if(__env.isDebug) console.log("Retail Item");
			if(__env.isDebug) console.log(vm.retailDets);

			//alert(vm.retailDets.retailCurrQty+" >= "+vm.retailDets.retailQty);
			if(parseFloat(vm.retailDets.retailCurrQty) >= parseFloat(vm.retailDets.retailQty)){
				//alert("In");
				$("#retailAddBtn").focus();
				vm.retailAddDis = 1;					
			} else {
				//alert("Else");
				$("#retailQty").focus();
				vm.retailAddDis = 0;

				if(parseFloat(vm.retailDets.retailQty) > parseFloat(vm.retailDets.retailCurrQty) && parseFloat(vm.retailDets.retailCurrQty) > 0){
					var confirm = $mdDialog.confirm()
			        .title('Avaliable Qty is Less')
			        .htmlContent('Unable to add this to kot, avaliable qty of '+vm.retailDets.retailItm+' is less than ordered qty.')
			        .ariaLabel('Unable to add')
			        .ok('Ok')
			        //.cancel('Cancel')
			        .targetEvent(event);
				    $mdDialog.show(confirm).then(function ()
				    {
				               
				    });
				} else if(parseFloat(vm.retailDets.retailCurrQty)==0){
					var confirm = $mdDialog.confirm()
			        .title('Avaliable Qty is 0!')
		                .htmlContent('Unable to add this to kot, avaliable qty of '+vm.retailDets.retailItm+' is 0.')
			        .ariaLabel('Unable to add')
			        .ok('Ok')
			        //.cancel('Cancel')
			        .targetEvent(event);
				    $mdDialog.show(confirm).then(function ()
				    {
				               
				    });
				}
				return false;
			}
			//alert(vm.retailAddDis);
		}

		function getDiscAmount(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.discountDets);


			//var bilAmount = parseFloat(vm.discountDets.billAmount) + parseFloat(vm.discountDets.billExtra) + parseFloat(vm.discountDets.billTax);			
			var bilAmount = parseFloat(vm.billAddons.bil_totalamt) + parseFloat(vm.billAddons.bil_totextraamt) + parseFloat(vm.billAddons.bil_tottaxamt);			
			//alert(bilAmount+" - "+vm.discountDets.discountRate);
			var amt = ((bilAmount * parseFloat(vm.discountDets.discountRate))/100);
			//alert(amt);
			vm.discountDets.discountAmount = amt;
			vm.discountDets.discountFocus = "1";

			if(amt>0){
				vm.discountAddDis = 1;		
			}
			

			$("#discountAmount").focus();			
		}

		function getItmDets(){
			//alert("In");
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.retailDets);
			if(__env.isDebug) console.log(vm.retailDets.retailItm);
			if(vm.retailDets.retailItm!=""){
				var aToken=localStorage.getItem('UserATK');
				if(aToken!=""){
					msApi.request('app.getItmDets@save', {param:{string:vm.retailDets.retailItm,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
						// SUCCESS
						function (response){		
							//alert("IF");
							if(__env.isDebug) console.log("Success Kot");
							if(__env.isDebug) console.log(response);
							//alert(response.data);
							var itmDets = response.itmDets;
							if(__env.isDebug) console.log(itmDets);
							var optID = 0;
							for(var i=0;i<vm.productList.length;i++){					
								if(vm.productList[i].catitm_category_id == itmDets.catitm_category_id && vm.productList[i].item_id == itmDets.item_id){								
									vm.productList[i].item_currqty = itmDets.item_currqty;
									vm.productList[i].batchList = itmDets.batchList;
									//vm.productList[i].showBatch = itmDets.showBatch;
									vm.productList[i].isExpired = itmDets.isExpired;
									vm.productList[i].isShortExpired = itmDets.isShortExpired;
									
									var opt = vm.productList[i].itmOptionsList;
									var batch = vm.productList[i].batchList;
									var price = 0;									
									var optcnt = 0;
									var stock = 0;
									for(var j=0;j<opt.length;j++){			
										if(opt[j].item_price_tag_id == vm.seletedPriceTag && price == 0){
											if(opt[j].unavailabeleStatus == 0){
												price = opt[j].item_price_price;
												optID = opt[j].itm_option_id;
												stock = opt[j].availableStock;
											} else if(opt[j].unavailabeleStatus == 1 && opt[j].availableStock > 0){
												price = opt[j].item_price_price;
												optID = opt[j].itm_option_id;
												stock = opt[j].availableStock;
											}
										}
										
										if(opt[j].item_price_tag_id == vm.seletedPriceTag){
											optcnt = optcnt + 1;
										}
									}

									if(price==0){
										for(var j=0;j<opt.length;j++){			
											if(opt[j].item_price_tag_id == 0){
												if(opt[j].unavailabeleStatus == 0){
													price = opt[j].item_price_price;
													optID = opt[j].itm_option_id;
													stock = opt[j].availableStock;
												} else if(opt[j].unavailabeleStatus == 1 && opt[j].availableStock > 0){
													price = opt[j].item_price_price;
													optID = opt[j].itm_option_id;
													stock = opt[j].availableStock;
												}
											}					
										}	
									}

									if(batch.length>0 && batch[0].inventory_selling_price > 0){
										price = batch[0].inventory_selling_price;
									}

									vm.productList[i].item_price = price;	
									vm.productList[i].item_optcnt = optcnt;
									vm.productList[i].item_opt_id = optID;
									vm.productList[i].item_stock = stock;
									var qty='';
									if(vm.retailDets.retailQty > 0){
										qty=vm.retailDets.retailQty;
									} else if(itmDets.codeQty > 0){
										qty=itmDets.codeQty;
									}
									//vm.retailDets={retailKOTID:vm.retailDets.retailKOTID,retailCatID:vm.productList[i].catitm_category_id,retailItmID:vm.productList[i].item_id,retailOptID:vm.productList[i].item_opt_id,retailBatchID:"",retailItm:vm.productList[i].item_name,retailItmUnit:vm.productList[i].unit_name,retailQty:qty,retailCurrQty:parseFloat(itmDets.item_currqty)};

								}
							}

							//alert(itmDets.batchList.length);
							//alert(vm.retailDets.retailBatchID);
							if(itmDets.batchList.length > 0){
								var batchList = "";
								if(vm.retailDets.retailBatchID!=""){
									for(var i=0;i<itmDets.batchList.length;i++){
										if(itmDets.batchList[i].inventory_id == vm.retailDets.retailBatchID){
											batchList = itmDets.batchList[i];	
										}
									}
								} else {
									batchList = itmDets.batchList[0];
								}
								if(__env.isDebug) console.log("Selected Batch");
								if(__env.isDebug) console.log(batchList);

								//var batchList = itmDets.batchList;
								//alert(optID);
								var batchID = vm.retailDets.retailBatchID;
								if(batchList.isExpired==1 || batchList.isExpired==2){	
									var batchID = batchList.inventory_id;
									vm.retailDets={retailKOTID:vm.retailDets.retailKOTID,retailCatID:itmDets.catitm_category_id,retailItmID:itmDets.item_id,retailOptID:optID,retailBatchID:batchID,retailItm:itmDets.item_name,retailItmUnit:itmDets.unit_name,retailQty:qty,retailCurrQty:parseFloat(itmDets.item_currqty)};
									$("#retailQty").focus();

									//vm.retailQtyFocus = 1;								
								} else if(batchList.isExpired==0){
									var confirm = $mdDialog.confirm()
								    	.title(itmDets.item_name+' is Expired')
								       	.htmlContent('Item is expired, Do you want to sale this item.')
								    	.ariaLabel('Unable to add')
								      	.ok('Yes')
								        .cancel('No')
								        .targetEvent(event);
									    $mdDialog.show(confirm).then(function ()
									    {
											//alert("IF");	
											var batchID = batchList.inventory_id;
											vm.retailDets={retailKOTID:vm.retailDets.retailKOTID,retailCatID:itmDets.catitm_category_id,retailItmID:itmDets.item_id,retailOptID:optID,retailBatchID:batchID,retailItm:itmDets.item_name,retailItmUnit:itmDets.unit_name,retailQty:qty,retailCurrQty:parseFloat(itmDets.item_currqty)};
											
											$("#retailQty").focus();
											//vm.retailQtyFocus = 1;
									    }, function ()
									    {
									       	//alert("Else");
									       	vm.retailDets={retailKOTID:'',retailCatID:'',retailItmID:'',retailOptID:'',retailBatchID:'',retailItm:'',retailItmUnit:'',retailQty:'',retailCurrQty:''};	
									    });
								}				
							} else if(itmDets.batchList.length==0){
								var confirm = $mdDialog.confirm()
				                .title('Item out of stock')
				                .htmlContent('Unable to select this item, Item batch(s) not found.')
				                .ariaLabel('Unable to select')
				                .ok('Ok')
				                //.cancel('Cancel')
				                .targetEvent(event);
					            $mdDialog.show(confirm).then(function ()
					            {
					             	vm.retailDets={retailKOTID:'',retailCatID:'',retailItmID:'',retailOptID:'',retailBatchID:'',retailItm:'',retailItmUnit:'',retailQty:'',retailCurrQty:''};	  
					            });
							}

							if(__env.isDebug) console.log("Items List");
							if(__env.isDebug) console.log(vm.productList);
							if(__env.isDebug) console.log(vm.retailDets);
							$window.localStorage['productList'] = JSON.stringify(vm.productList);
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				} else {
					$mdToast.show(
						$mdToast.simple().textContent('Access Token Expired').position('top right')
					);
					//$state.go('app.login');	
				}
			}
        }
		
		vm.customerBillID = 0;
		function customertbleHideshow(billID){
			if(billID!=""){
				vm.customerBillID = billID;
			} else {
				vm.customerBillID = 0;
			}
			//alert(vm.customerBillID);
		}
						
		//vm.checkInput();
		recalSummary();

	    ///////
    	function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
        	document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
    	}
    
		////////////////////
		
		/*$document.bind('keyup', function (e) {
			if(__env.isDebug) console.log(e);							  
			//alert(e.keyCode+" "+e.key);
			vm.input = e.key;
			alert(vm.input);
			//checkInput();
		});*/
		
		$document.bind('keyup', function (e) {
			//if(__env.isDebug) console.log(e);							  
			//alert(e.keyCode+" "+e.key);
			
			if((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode == 190)){
				//var input = $window.document.getElementById('input');
				//vm.input = e.key;

				//alert(e.key);
				if(localStorage.getItem('departmentType')=="Retail"){
					//alert("Itm "+$("#retailItm").val());
					
					if($("#retailItm").val()=="" && vm.sideRetails == 1){
						//alert("In 1");
						$("#retailItm").val(e.key);
						$("#retailItm").focus();
						vm.retailDets.retailItm = e.key;		
					}

					if(($("#discountRate").val()=="" || $("#discountRate").val()==0) && vm.discountDets.discountFocus=="" && vm.sideDiscount==1){
						//alert("In 1");
						$("#discountRate").val(e.key);
						$("#discountRate").focus();
						//vm.discountDets.discountRate = vm.discountDets.discountRate + e.key;		
					} else if($("#discountRate").val()!="" && vm.discountDets.discountFocus=="" && vm.sideDiscount==1){
						$("#discountRate").focus();
					}

					//vm.retailDets.retailItm = e.key;				
				} else {
					input.focus();	
					if(vm.input==""){
						if(e.keyCode == 190){
							vm.input = '0'+e.key;
						} else {
							vm.input = e.key;
						}
					}
					
					checkInput();
				}
					
				/*var input = $window.document.getElementById('input');				
				var inp = e.key;						
				vm.input = vm.input.concat(inp);
				//alert("Output => "+vm.input);	
				//if(__env.isDebug) console.log(vm.input);			
	
				if(vm.input!=""){
					input.focus();
					checkInput();
				}*/
			}

			/*if(e.keyCode == 13){
				//alert("in");
				$("#retailItm").focus();
			}*/			
			if(e.keyCode == 13 && vm.input!=""){	
				
				var sitm;					
				//var sitm=$filter('filter')(vm.productList, vm.searchItm)[0];				
				var searchList=$filter('filter')(vm.productList, vm.searchItm,true,"item_code");	
				for(var i=0;i<searchList.length;i++){
					if(searchList[i].item_code == vm.input){					
						sitm =searchList[i];									
					}
				}
				if (!sitm){					
					sitm=$filter('filter')(vm.productList, vm.searchItm)[0];
				}
				clearInput();
				vm.addItmtoKot(sitm);
				var e = angular.element.Event("keyup");
				e.which = 13;
				angular.element("#input").trigger(e);			
			}
		});
		
				
		function showKeyboard(){
			vm.itmstyle = {"bottom": "260px"};
			vm.keystyle = {"display": ""};
			vm.key = 0;
		}
		
		function hideKeyboard(){
			vm.itmstyle = {"bottom": "0px"};
			vm.keystyle = {"display": "none"};
			vm.key = 1;
		}
		
		function gotoLogin(){
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function checkInput(){			

			//alert("In check "+vm.input);
			//alert((isNaN(parseInt(vm.input)) || isNaN(parseFloat(vm.input))));
			//if((isNaN(parseInt(vm.input)) || isNaN(parseFloat(vm.input))) && vm.input != "" ){				
			if(vm.input != "" ){	
				//alert("in");
				vm.searchItm = vm.input;	
				vm.catInp = 0;				
			} else {
				vm.catInp = 1;				
			}
		}
		
		
		function setCategory(catID){
			//alert(catID);
			vm.selCatID = catID;			
			//vm.selCatID = null;			
			vm.catInp = 1;
			vm.input = '';
			angular.element("#itmHolder")[0].scrollTop=0;
		}
		
		function addInput(input){
			vm.input = vm.input+input;
		}

		function removeTags(tagID){
			//alert(tagID);
			for(var i=0;i<vm.selOrderTags.length;i++){	
				if(vm.selOrderTags[i].kotitemtag_tag_id == tagID){
					vm.selOrderTags.splice(i, 1);
				}
			}
			calSummary();
		}
		
		function showSubMenu(itmRef){ 
			//alert(itmRef);
						
			
			vm.voidShow = 1;
			vm.giftShow = 1;			
			vm.plusDisp = 1;
			vm.minusDisp = 1;
			vm.cancelDisp = 1;
			vm.giftDisp = 1;
			
			vm.moveDisp = 1;
			vm.voidDisp = 1;
			
			vm.sideItms = 1;
			vm.sideNote = 0;
			vm.sideOpts = 0;
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sideDiscount = 0;
			vm.itmOptions = "";
			vm.selOrderTagStatus = ""; 
			
			if(localStorage.getItem('departmentType')=="Retail"){ 
				vm.plusDisp = 0;
				vm.minusDisp = 0;
				if((vm.selectedItm == "") || (vm.selectedItm != itmRef.kotitem_id)){
					//alert(itmRef.kotitem_status);
					vm.itemMenu = 1;
					vm.sideItms = 0;
					vm.sideOpts = 0;				
					vm.selectedItm = itmRef.kotitem_id;
				} else if(vm.selectedItm == itmRef.kotitem_id){
					vm.itemMenu = 0;
					vm.sideItms = 0;
					vm.sideOpts = 0;
					vm.selectedItm = '';
				}

				var currQty=0;
				for(var i=0;i<vm.productList.length;i++){
					if(vm.productList[i].item_id == itmRef.kotitem_itm_id && vm.productList[i].item_opt_id == itmRef.kotitem_option_id && vm.productList[i].catitm_category_id == itmRef.kotitem_cat_id){
						currQty = vm.productList[i].item_currqty;						
					}
				}

				vm.retailDets={retailKOTID:itmRef.kotitem_id,retailCatID:itmRef.kotitem_cat_id,retailItmID:itmRef.kotitem_itm_id,retailOptID:itmRef.kotitem_option_id,retailBatchID:itmRef.kotitem_batch_id,retailItm:itmRef.kotitem_itm_name,retailItmUnit:itmRef.kotitem_unit_name,retailQty:itmRef.kotitem_qty,retailCurrQty:currQty};
				if(__env.isDebug) console.log("RetailDets List");
				if(__env.isDebug) console.log(vm.retailDets); 
				$("#retailItm").focus();
				//getItmDets();
			} else {
				//alert("Else");
				if((vm.selectedItm == "") || (vm.selectedItm != itmRef.kotitem_id)){
					//alert(itmRef.kotitem_status);
					//alert("Else 1");

					vm.itemMenu = 1;
					vm.sideItms = 0;
					if(itmRef.kotitem_status == 'New' || itmRef.kotitem_status == 'New-Gift'){
						vm.sideOpts = 1;				
					} else {
						vm.sideOpts = 0;
					}
					vm.selectedItm = itmRef.kotitem_id;
				} else if(vm.selectedItm == itmRef.kotitem_id){
					//alert("Else 2");

					vm.itemMenu = 0;
					vm.sideItms = 1;
					vm.sideOpts = 0;
					vm.selectedItm = '';
				}
			}
					
			
			//alert(vm.selectedItm);
			for(var i=0;i<vm.productList.length;i++){					
				if(vm.productList[i].catitm_category_id == itmRef.kotitem_cat_id && vm.productList[i].item_id == itmRef.kotitem_itm_id){
				//if(vm.productList[i].catitm_category_id == itmRef.kotitem_cat_id && vm.productList[i].item_id == itmRef.kotitem_itm_id && vm.productList[i].item_optcnt > 1){
					//alert("IN");
					//vm.sideItms = 0;
					//vm.sideNote = 0;
					//vm.sideOpts = 1;
					//vm.sideCust = 0;
					//vm.sideWaiter = 0;
					
					vm.itmOptions = vm.productList[i].itmOptionsList;
				}					
			}
			//alert(vm.seletedPriceTag);
			if(__env.isDebug) console.log("Item Options");
			if(__env.isDebug) console.log(vm.itmOptions);
			
			if(vm.sideOpts==1){
				for(var i=0;i<vm.kotItems.length;i++){	
					if(vm.kotItems[i].kotitem_id == vm.selectedItm){
						vm.selOrderTags = vm.kotItems[i].kotitem_orderTagsList;
						vm.selOrderTagStatus = vm.kotItems[i].kotitem_status;
					}
				}				
			}

			if(__env.isDebug) console.log("Order Options");
			if(__env.isDebug) console.log(vm.selOrderTags);

			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;					
					
					
					if(vm.kotItems[i].kotitem_status == 'New-Gift'){
						vm.giftShow = 0;
						//vm.cancelDisp = 0;
						vm.moveDisp = 0;
						if(vm.kotItems[i].kotitem_qty == 1){
							vm.minusDisp = 0;	
						}						
					}
					
					if(vm.kotItems[i].kotitem_status == 'New-Void'){	
						vm.voidShow = 0;
						//vm.voidDisp = 0;
						vm.plusDisp = 0;
						vm.minusDisp = 0;
						vm.cancelDisp = 0;												
						if(vm.kotItems[i].kotitem_qty > 1){
							vm.plusDisp = 1;
							vm.minusDisp = 1;
						}
					}
					
					//alert(vm.kotItems[i].kotitem_status+" "+vm.kotItems[i].kotitem_qty);
					if(vm.kotItems[i].kotitem_status == 'Submitted-Gift'){	
						vm.giftShow = 0;
						vm.plusDisp = 0;						
						vm.minusDisp = 0;
						vm.cancelDisp = 0;
						vm.voidDisp = 0;
						vm.giftDisp = 0;
						if(vm.kotItems[i].kotitem_qty > 1){
							vm.plusDisp = 1;
							vm.minusDisp = 1;
						}
						//alert(vm.plusDisp);
					}
					
					if(vm.kotItems[i].kotitem_status == 'Submitted-Void'){	
						vm.voidShow = 0;
						vm.voidDisp = 0;
						vm.plusDisp = 0;
						vm.minusDisp = 0;
						vm.cancelDisp = 0;	
						vm.giftDisp = 0;
						if(vm.kotItems[i].kotitem_qty > 1){
							vm.plusDisp = 1;
							vm.minusDisp = 1;
						}
					}
					
					/*if(vm.kotItems[i].kotitem_status == 'Submitted-Void'){
						vm.voidShow = 0;
						vm.cancelDisp = 0;
						vm.giftShow = -1;
						if(vm.kotItems[i].kotitem_qty <= 1){
							vm.plusDisp = 0;
							vm.minusDisp = 0;	
						}
					}*/
					
					if(vm.kotItems[i].kotitem_status == 'Submitted'){
						vm.plusDisp = 0;
						vm.minusDisp = 0;
						if(vm.kotItems[i].kotitem_qty > 1){
							vm.plusDisp = 1;
							vm.minusDisp = 1;
						}
						
						vm.cancelDisp = 0;												
					}
					
					if(vm.kotItems[i].kotitem_status == 'New'){						
						vm.voidDisp = 0;
						vm.moveDisp = 0;
						if(vm.kotItems[i].kotitem_qty == 1){
							vm.minusDisp = 0;	
						}
					}
				}
			}
			//calSummary();
			
		}
		
		function increase(){												
			var stock = 0; var unavail = 0; var selQty = 0;
			for(var i=0;i<vm.productList.length;i++){
				for(var k=0;k<vm.kotItems.length;k++){	
					if(vm.productList[i].item_id == vm.kotItems[k].kotitem_itm_id && vm.productList[i].item_opt_id == vm.kotItems[k].kotitem_option_id && vm.productList[i].catitm_category_id == vm.kotItems[k].kotitem_cat_id && vm.kotItems[k].kotitem_status=="New"){
						var opt = vm.productList[i].itmOptionsList;						
						for(var j=0;j<opt.length;j++){
							unavail = opt[j].unavailabeleStatus;
							stock = opt[j].availableStock;			
						}
						selQty = selQty + parseFloat(vm.kotItems[k].kotitem_qty);
					}
				}
			}

			//alert(selQty);
			//alert(unavail+" "+stock);
			
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){
					//alert(vm.kotItems[i].kotitem_sub_qty+" < "+vm.kotItems[i].kotitem_qty);
					if((unavail==0 && stock==0) || (unavail==1 && stock>vm.kotItems[i].kotitem_qty && stock>selQty)){							
						if(vm.kotItems[i].kotitem_status == 'New'){
							var qty = parseInt(vm.kotItems[i].kotitem_qty)+1;					
							vm.kotItems[i].kotitem_qty = qty;
						//} else if((vm.kotItems[i].kotitem_status == 'Submitted-Void' || vm.kotItems[i].kotitem_status == 'Submitted-Gift' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'Submitted' || vm.kotItems[i].kotitem_status == 'New-Gift') && vm.kotItems[i].kotitem_sub_qty < vm.kotItems[i].kotitem_qty){
								
						} else if((vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'Submitted' || vm.kotItems[i].kotitem_status == 'New-Gift') && vm.kotItems[i].kotitem_sub_qty < vm.kotItems[i].kotitem_qty){	
							//alert("ELSE");
							var qty = parseInt(vm.kotItems[i].kotitem_sub_qty)+1;	
							if(vm.kotItems[i].kotitem_qty == qty){
								qty = 0;	
							}
							//alert(qty);
							vm.kotItems[i].kotitem_sub_qty = qty ;
						}
						
						if(vm.kotItems[i].kotitem_qty > 1){
							vm.minusDisp = 1;	
						}								
					} else {
						var confirm = $mdDialog.confirm()
						    .title('Order qty is greater than avaliable stock')
						    .htmlContent('Unable to add this to kot, Order qty is greater than avaliable stock.')
						    .ariaLabel('Unable to add')
						    .ok('Ok')
						    //.cancel('Cancel')
						    .targetEvent(event);
							$mdDialog.show(confirm).then(function ()
							{
							               
							});
					}

					var orderTagOpt = vm.kotItems[i].kotitem_orderTagsList;
					if(__env.isDebug) console.log("KOT Item Options");
					if(__env.isDebug) console.log(orderTagOpt);
					for(var o=0;o<orderTagOpt.length;o++){	
						//alert(orderTagOpt[o].kotitemtag_ordertag_price);
						if(orderTagOpt[o].tag_rate!=""){
							var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt[o].kotitemtag_ordertag_price);	
						} else {
							var rate = 0;
						}
						//alert(rate);
						orderTagOpt[o].kotitemtag_ordertag_rate = rate							
					}
				}
			}		
			calSummary();									
		}
		
		function decrease(){									
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm && vm.kotItems[i].kotitem_qty > 1){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;					
					//vm.kotItems[i].kotitem_qty = qty ;
					
					if(vm.kotItems[i].kotitem_status == 'New'){
						var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;					
						vm.kotItems[i].kotitem_qty = qty ;
					//} else if((vm.kotItems[i].kotitem_status == 'Submitted-Void' || vm.kotItems[i].kotitem_status == 'Submitted-Gift' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'Submitted' || vm.kotItems[i].kotitem_status == 'New-Gift') && vm.kotItems[i].kotitem_sub_qty < vm.kotItems[i].kotitem_qty){
					} else if((vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'Submitted' || vm.kotItems[i].kotitem_status == 'New-Gift') && vm.kotItems[i].kotitem_sub_qty < vm.kotItems[i].kotitem_qty){	
						//alert("ELSE");
						if(parseInt(vm.kotItems[i].kotitem_sub_qty)>0){
							var qty = parseInt(vm.kotItems[i].kotitem_sub_qty)-1;	
						} else {
							var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;	
						}
						vm.kotItems[i].kotitem_sub_qty = qty ;
					}

					var orderTagOpt = vm.kotItems[i].kotitem_orderTagsList;
					if(__env.isDebug) console.log("KOT Item Options");
					if(__env.isDebug) console.log(orderTagOpt);
					for(var o=0;o<orderTagOpt.length;o++){	
						//alert(orderTagOpt[o].kotitemtag_ordertag_price);
						if(orderTagOpt[o].tag_rate!=""){
							var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt[o].kotitemtag_ordertag_price);	
						} else {
							var rate = 0;
						}
						//alert(rate);
						orderTagOpt[o].kotitemtag_ordertag_rate = rate							
					}
				}
			}
			
			
			calSummary();
		}
		
		function setAsGift(){
			if(vm.giftReason==1){
				vm.sideItms = 0;
				vm.sideNote = 0;
				vm.sideOpts = 0;	
				vm.sideCust = 0;
				vm.sideMessage = 1;
				vm.giftMessage = 1;
				vm.voidMessage = 0;
				vm.nacMessage = 0;
				vm.sideWaiter = 0;
				vm.sideOrderNo = 0;
				vm.sidePendparcel = 0;
				vm.sideRetails = 0;
				vm.sidePendRetail = 0;
				vm.sideDiscount = 0;

				vm.extraMsg = "";
			} else {
				setAsGift2();				
			}
		}

		function setAsGift2(){
			vm.itemMenu = 0;	
		
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){										
					if(vm.kotItems[i].kotitem_sub_qty == 0){
						//vm.kotItems[i].kotitem_status = vm.kotItems[i].kotitem_status+'-Gift';
						var total = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(vm.kotItems[i].kotitem_rate);

						//alert(vm.kotItems[i].kotitem_qty);
						var orderTagOpt = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt);
						for(var o=0;o<orderTagOpt.length;o++){	
							//alert(orderTagOpt[o].kotitemtag_ordertag_price);
							if(orderTagOpt[o].tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}
							//alert(rate);
							orderTagOpt[o].kotitemtag_ordertag_rate = rate							
						}
						
 						var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:vm.selectedItm,kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.kotItems[i].kotitem_cat_id,kotitem_itm_id:vm.kotItems[i].kotitem_itm_id,kotitem_option_id:vm.kotItems[i].kotitem_option_id,kotitem_itm_name:vm.kotItems[i].kotitem_itm_name,kotitem_qty:vm.kotItems[i].kotitem_qty,kotitem_rate:vm.kotItems[i].kotitem_rate,kotitem_totat:total,kotitem_message:vm.extraMsg,kotitem_status:'New-Gift',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:orderTagOpt,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};
						vm.kotItems.push(obj);
						vm.ifNewRows = 1;
						
						//vm.ifNewRows = 1;
						vm.kotItems[i].kotitem_qty = 0;
						vm.kotItems[i].kotitem_totat = 0;
						vm.kotItems[i].kotitem_sub_qty = 0;
					} else if(vm.kotItems[i].kotitem_sub_qty > 0){						
						var total = parseFloat(vm.kotItems[i].kotitem_sub_qty) * parseFloat(vm.kotItems[i].kotitem_rate);

						var orderTagOpt = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt);
						var orderList=[];
						for(var o=0;o<orderTagOpt.length;o++){	
							//alert(orderTagOpt[o].kotitemtag_ordertag_price);
							if(orderTagOpt[o].kotitemtag_ordertag_price > 0){
								var rate = parseFloat(vm.kotItems[i].kotitem_sub_qty) * parseFloat(orderTagOpt[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}

							var obj2 = {kotitemtag_tag_id:Math.round(Math.random()*1000), kotitemtag_bill_id:orderTagOpt[o].kotitemtag_bill_id, kotitemtag_kot_id:'', kotitemtag_kotitem_id:orderTagOpt[o].kotitemtag_kotitem_id, kotitemtag_ordertag_id:0, kotitemtag_ordertag_name:orderTagOpt[o].kotitemtag_ordertag_name, kotitemtag_ordertag_price:orderTagOpt[o].kotitemtag_ordertag_price, kotitemtag_ordertag_rate:rate};
							orderList.push(obj2);
							//alert(rate);
							//orderTagOpt[o].kotitemtag_ordertag_rate = rate							
						}
						if(__env.isDebug) console.log(orderList);
						
 						var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:vm.selectedItm,kotitem_bill_id:vm.kotItems[i].kotitem_bill_id,kotitem_kot_id:'',kotitem_cat_id:vm.kotItems[i].kotitem_cat_id,kotitem_itm_id:vm.kotItems[i].kotitem_itm_id,kotitem_option_id:vm.kotItems[i].kotitem_option_id,kotitem_itm_name:vm.kotItems[i].kotitem_itm_name,kotitem_qty:vm.kotItems[i].kotitem_sub_qty,kotitem_rate:vm.kotItems[i].kotitem_rate,kotitem_totat:total,kotitem_message:vm.extraMsg,kotitem_status:'New-Gift',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:orderList,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};
						vm.kotItems.push(obj);
						vm.ifNewRows = 1;
						
						//vm.ifNewRows = 1;
						vm.kotItems[i].kotitem_qty = parseInt(vm.kotItems[i].kotitem_qty) - parseInt(vm.kotItems[i].kotitem_sub_qty);
						vm.kotItems[i].kotitem_totat = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(vm.kotItems[i].kotitem_rate);
						vm.kotItems[i].kotitem_sub_qty = 0;

						var orderTagOpt2 = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt2);
						for(var o=0;o<orderTagOpt2.length;o++){	
							//alert(orderTagOpt2[o].kotitemtag_ordertag_price);
							if(orderTagOpt2[o].tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt2[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}
							//alert(rate);
							orderTagOpt2[o].kotitemtag_ordertag_rate = rate							
						}
						if(__env.isDebug) console.log(orderTagOpt2);
						vm.kotItems[i].kotitem_orderTagsList = orderTagOpt2;						
					}
				}
			}
			if(__env.isDebug) console.log("Kot List Gift");
			if(__env.isDebug) console.log(vm.kotItems);
			
			vm.sideItms = 1;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;
	
			vm.extraMsg = "";

			vm.existBtn=0;
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_status == 'New' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'New-Gift'){
					vm.existBtn++;
				}
			}
			
			calSummary();		
		}
		
		function resetcancelGift(refID, qty){
			//alert(refID+" "+qty);
			for(var i=0;i<vm.kotItems.length;i++){			
				//alert(vm.selectedItm);
				if(vm.kotItems[i].kotitem_id == refID){					
					vm.kotItems[i].kotitem_qty = parseFloat(vm.kotItems[i].kotitem_qty)+parseFloat(qty);
					vm.kotItems[i].kotitem_sub_qty = 0;
					vm.kotItems[i].kotitem_message = "";
					var total = vm.kotItems[i].kotitem_qty * parseFloat(vm.kotItems[i].kotitem_rate);
					vm.kotItems[i].kotitem_totat = total;

					var orderTagOpt2 = vm.kotItems[i].kotitem_orderTagsList;
					if(__env.isDebug) console.log("KOT Item Options");
					if(__env.isDebug) console.log(orderTagOpt2);
					for(var o=0;o<orderTagOpt2.length;o++){	
						//alert(orderTagOpt2[o].kotitemtag_ordertag_price);
						if(orderTagOpt2[o].tag_rate!=""){
							var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt2[o].kotitemtag_ordertag_price);	
						} else {
							var rate = 0;
						}
						//alert(rate);
						orderTagOpt2[o].kotitemtag_ordertag_rate = rate							
					}
					if(__env.isDebug) console.log(orderTagOpt2);
					vm.kotItems[i].kotitem_orderTagsList = orderTagOpt2;
				}
			}
			
		}
		
		function cancelGift(){
			vm.itemMenu = 0;	
			vm.billDet.status = "";
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){					
					if(vm.kotItems[i].kotitem_sub_qty == 0){
						//vm.kotItems[i].kotitem_status = vm.kotItems[i].kotitem_status.replace('-Gift','');
						//alert(vm.kotItems[i].kotitem_ref_id+" "+vm.kotItems[i].kotitem_qty);
						resetcancelGift(vm.kotItems[i].kotitem_ref_id,vm.kotItems[i].kotitem_qty);
						vm.kotItems.splice(i, 1);
						vm.ifNewRows = 0;
					} else if(vm.kotItems[i].kotitem_sub_qty > 0){
						var qty = parseInt(vm.kotItems[i].kotitem_qty) - parseInt(vm.kotItems[i].kotitem_sub_qty);
												
						resetcancelGift(vm.kotItems[i].kotitem_ref_id,vm.kotItems[i].kotitem_sub_qty);
						
						//var total = qty * parseFloat(vm.kotItems[i].kotitem_rate);
						//var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_ref_id:'',kotitem_bill_id:vm.kotItems[i].kotitem_bill_id,kotitem_kot_id:vm.kotItems[i].kotitem_kot_id,kotitem_itm_id:vm.kotItems[i].kotitem_itm_id,kotitem_option_id:vm.kotItems[i].kotitem_option_id,kotitem_itm_name:vm.kotItems[i].kotitem_itm_name,kotitem_qty:qty,kotitem_rate:vm.kotItems[i].kotitem_rate,kotitem_totat:total,kotitem_status:'New-Gift',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:[]};
						//vm.kotItems.push(obj);
						
						
						vm.ifNewRows = 1;												
						vm.kotItems[i].kotitem_qty = parseInt(qty);
						vm.kotItems[i].kotitem_totat = parseInt(qty) * parseFloat(vm.kotItems[i].kotitem_rate);
						vm.kotItems[i].kotitem_sub_qty = 0;
						//vm.kotItems[i].kotitem_status = 'Submitted';

						var orderTagOpt2 = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt2);
						for(var o=0;o<orderTagOpt2.length;o++){	
							//alert(orderTagOpt2[o].kotitemtag_ordertag_price);
							if(orderTagOpt2[o].tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt2[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}
							//alert(rate);
							orderTagOpt2[o].kotitemtag_ordertag_rate = rate							
						}
						if(__env.isDebug) console.log(orderTagOpt2);
						vm.kotItems[i].kotitem_orderTagsList = orderTagOpt2;
					}					
					
				}
			}
			if(__env.isDebug) console.log("Kot List Gift");
			if(__env.isDebug) console.log(vm.kotItems);
			
			vm.existBtn=0;
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_status == 'New' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'New-Gift'){
					vm.existBtn++;
				}
			}
			
			calSummary();		
		}
		
		function setAsVoid(){
			//alert("In");
			if(vm.voidReason==1){
				vm.sideItms = 0;
				vm.sideNote = 0;
				vm.sideOpts = 0;	
				vm.sideCust = 0;
				vm.sideMessage = 1;
				vm.giftMessage = 0;
				vm.voidMessage = 1;
				vm.nacMessage = 0;
				vm.sideWaiter = 0;
				vm.sideOrderNo = 0;
				vm.sidePendparcel = 0;
				vm.sideRetails = 0;
				vm.sidePendRetail = 0;
				vm.sideDiscount = 0;

				vm.extraMsg = "";
			} else {
				setAsVoid2();				
			}
		}	

		function setAsVoid2(){ 
			vm.itemMenu = 0;	
			vm.billDet.status = "New Orders";
			
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;					
					if(vm.kotItems[i].kotitem_sub_qty == 0){
						//vm.kotItems[i].kotitem_status = 'New-Void';
						
						var total = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(vm.kotItems[i].kotitem_rate);

						//alert(vm.kotItems[i].kotitem_qty);
						var orderTagOpt = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt);
						for(var o=0;o<orderTagOpt.length;o++){	
							//alert(orderTagOpt[o].kotitemtag_ordertag_price);
							if(orderTagOpt[o].tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}
							//alert(rate);
							orderTagOpt[o].kotitemtag_ordertag_rate = rate							
						}
						
 						var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:vm.selectedItm,kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.kotItems[i].kotitem_cat_id,kotitem_itm_id:vm.kotItems[i].kotitem_itm_id,kotitem_option_id:vm.kotItems[i].kotitem_option_id,kotitem_itm_name:vm.kotItems[i].kotitem_itm_name,kotitem_qty:vm.kotItems[i].kotitem_qty,kotitem_rate:vm.kotItems[i].kotitem_rate,kotitem_totat:total,kotitem_message:vm.extraMsg,kotitem_status:'New-Void',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:orderTagOpt,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};
						vm.kotItems.push(obj);
						vm.ifNewRows = 1;
						
						
						//vm.ifNewRows = 1;
						vm.kotItems[i].kotitem_qty = 0;
						vm.kotItems[i].kotitem_totat = 0;
						vm.kotItems[i].kotitem_sub_qty = 0;
						
					} else if(vm.kotItems[i].kotitem_sub_qty > 0){						
						var total = parseFloat(vm.kotItems[i].kotitem_sub_qty) * parseFloat(vm.kotItems[i].kotitem_rate);

						//alert(vm.kotItems[i].kotitem_qty+" "+vm.kotItems[i].kotitem_sub_qty);

						var orderTagOpt = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt);
						var orderList=[];
						for(var o=0;o<orderTagOpt.length;o++){	
							//alert(orderTagOpt[o].kotitemtag_ordertag_price);
							if(orderTagOpt[o].kotitemtag_ordertag_price > 0){
								var rate = parseFloat(vm.kotItems[i].kotitem_sub_qty) * parseFloat(orderTagOpt[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}

							var obj2 = {kotitemtag_tag_id:Math.round(Math.random()*1000), kotitemtag_bill_id:orderTagOpt[o].kotitemtag_bill_id, kotitemtag_kot_id:orderTagOpt[o].kotitemtag_kot_id, kotitemtag_kotitem_id:orderTagOpt[o].kotitemtag_kotitem_id, kotitemtag_ordertag_id:0, kotitemtag_ordertag_name:orderTagOpt[o].kotitemtag_ordertag_name, kotitemtag_ordertag_price:orderTagOpt[o].kotitemtag_ordertag_price, kotitemtag_ordertag_rate:rate};
							orderList.push(obj2);
							//alert(rate);
							//orderTagOpt[o].kotitemtag_ordertag_rate = rate							
						}
						if(__env.isDebug) console.log(orderList);

						
						
 						var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:vm.selectedItm,kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.kotItems[i].kotitem_cat_id,kotitem_itm_id:vm.kotItems[i].kotitem_itm_id,kotitem_option_id:vm.kotItems[i].kotitem_option_id,kotitem_itm_name:vm.kotItems[i].kotitem_itm_name,kotitem_qty:vm.kotItems[i].kotitem_sub_qty,kotitem_rate:vm.kotItems[i].kotitem_rate,kotitem_totat:total,kotitem_message:vm.extraMsg,kotitem_status:'New-Void',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:orderList,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};
						vm.kotItems.push(obj);
						vm.ifNewRows = 1;
						
						
						//vm.ifNewRows = 1;
						vm.kotItems[i].kotitem_qty = parseInt(vm.kotItems[i].kotitem_qty) - parseInt(vm.kotItems[i].kotitem_sub_qty);
						vm.kotItems[i].kotitem_totat = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(vm.kotItems[i].kotitem_rate);
						vm.kotItems[i].kotitem_sub_qty = 0;

						var orderTagOpt2 = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt2);
						for(var o=0;o<orderTagOpt2.length;o++){	
							//alert(orderTagOpt2[o].kotitemtag_ordertag_price);
							if(orderTagOpt2[o].tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt2[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}
							//alert(rate);
							orderTagOpt2[o].kotitemtag_ordertag_rate = rate							
						}
						if(__env.isDebug) console.log(orderTagOpt2);
						vm.kotItems[i].kotitem_orderTagsList = orderTagOpt2;						
					}
				}
			}
			if(__env.isDebug) console.log("Kot List Void");
			if(__env.isDebug) console.log(vm.kotItems);
			
			vm.sideItms = 1;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;

			vm.extraMsg = "";
			
			vm.existBtn=0;
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_status == 'New' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'New-Gift'){
					vm.existBtn++;
				}
			}
			
			calSummary();		
		}
		
		function resetcancelVoid(refID, qty){
			for(var i=0;i<vm.kotItems.length;i++){			
				//alert(vm.selectedItm);
				if(vm.kotItems[i].kotitem_id == refID){					
					vm.kotItems[i].kotitem_qty = parseFloat(vm.kotItems[i].kotitem_qty)+parseFloat(qty);
					vm.kotItems[i].kotitem_message = "";
					vm.kotItems[i].kotitem_sub_qty = 0;
					var total = vm.kotItems[i].kotitem_qty * parseFloat(vm.kotItems[i].kotitem_rate);
					vm.kotItems[i].kotitem_totat = total;

					//alert(vm.kotItems[i].kotitem_qty);

					var orderTagOpt2 = vm.kotItems[i].kotitem_orderTagsList;
					if(__env.isDebug) console.log("KOT Item Options");
					if(__env.isDebug) console.log(orderTagOpt2);
					for(var o=0;o<orderTagOpt2.length;o++){	
						//alert(orderTagOpt2[o].kotitemtag_ordertag_price);
						if(orderTagOpt2[o].tag_rate!=""){
							var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt2[o].kotitemtag_ordertag_price);	
						} else {
							var rate = 0;
						}
						//alert(rate);
						orderTagOpt2[o].kotitemtag_ordertag_rate = rate							
					}
					if(__env.isDebug) console.log(orderTagOpt2);
					vm.kotItems[i].kotitem_orderTagsList = orderTagOpt2;
				}
			}
			
		}
		
		function cancelVoid(){
			vm.itemMenu = 0;
			vm.sideOpts = 0;
			vm.sideItms = 1;
			vm.billDet.status = "";
			for(var i=0;i<vm.kotItems.length;i++){			
				//alert(vm.selectedItm);
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){
					if(vm.kotItems[i].kotitem_sub_qty == 0){
						//vm.kotItems[i].kotitem_status = 'New';
						resetcancelVoid(vm.kotItems[i].kotitem_ref_id,vm.kotItems[i].kotitem_qty);
						vm.kotItems.splice(i, 1);
						vm.ifNewRows = 0;
						
					} else if(vm.kotItems[i].kotitem_sub_qty > 0){
						var qty = parseInt(vm.kotItems[i].kotitem_qty) - parseInt(vm.kotItems[i].kotitem_sub_qty);
						
						resetcancelVoid(vm.kotItems[i].kotitem_ref_id,vm.kotItems[i].kotitem_sub_qty);
						
						//var total = qty * parseFloat(vm.kotItems[i].kotitem_rate);
						//var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_ref_id:'',kotitem_bill_id:vm.kotItems[i].kotitem_bill_id,kotitem_kot_id:vm.kotItems[i].kotitem_kot_id,kotitem_itm_id:vm.kotItems[i].kotitem_itm_id,kotitem_option_id:vm.kotItems[i].kotitem_option_id,kotitem_itm_name:vm.kotItems[i].kotitem_itm_name,kotitem_qty:qty,kotitem_rate:vm.kotItems[i].kotitem_rate,kotitem_totat:total,kotitem_status:'New-Void',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:[]};
						//vm.kotItems.push(obj);
						
						vm.ifNewRows = 1;
						//vm.ifNewRows = 1;
						vm.kotItems[i].kotitem_qty = qty;
						vm.kotItems[i].kotitem_totat = qty * parseFloat(vm.kotItems[i].kotitem_rate);
						vm.kotItems[i].kotitem_sub_qty = 0;
						//vm.kotItems[i].kotitem_status = 'Submitted';

						var orderTagOpt2 = vm.kotItems[i].kotitem_orderTagsList;
						if(__env.isDebug) console.log("KOT Item Options");
						if(__env.isDebug) console.log(orderTagOpt2);
						for(var o=0;o<orderTagOpt2.length;o++){	
							//alert(orderTagOpt2[o].kotitemtag_ordertag_price);
							if(orderTagOpt2[o].tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(orderTagOpt2[o].kotitemtag_ordertag_price);	
							} else {
								var rate = 0;
							}
							//alert(rate);
							orderTagOpt2[o].kotitemtag_ordertag_rate = rate							
						}
						if(__env.isDebug) console.log(orderTagOpt2);
						vm.kotItems[i].kotitem_orderTagsList = orderTagOpt2;
					}										
				}
			}
			if(__env.isDebug) console.log("Kot List Void");
			if(__env.isDebug) console.log(vm.kotItems);
			
			vm.existBtn=0;
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_status == 'New' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'New-Gift'){
					vm.existBtn++;
				}
			}
			
			calSummary();		
		}
		
		function removeItem(){
			vm.itemMenu = 0;	
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.kotItems.splice(i, 1);
				}
			}
			if(__env.isDebug) console.log("Kot List Remove");
			if(__env.isDebug) console.log(vm.kotItems);
			
			vm.existBtn=0;
			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_status == 'New' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'New-Gift'){
					vm.existBtn++;
				}
			}
			if(localStorage.getItem('departmentType')=="Retail"){
				vm.sideItms = 0;
				vm.sideOpts = 0;
				vm.selectedItm = '';	
			} else {
				vm.sideItms = 1;
				vm.sideOpts = 0;
				vm.selectedItm = '';	
			} 						
			calSummary();
		}
		
		function clearInput(){
			vm.input = "";	
			vm.searchItm = vm.input;
			
		}
		
		vm.orderTagOpt={'tag_name':'','tag_rate':''};
		function setOrderTags(opt){
			vm.orderTagOpt={'tag_name':opt.ordertagoption_name,'tag_rate':opt.ordertagoption_rate,'tag_opt':opt};	
		}	

		vm.orderTagErr = 0;
		function setOrderTags2(opt){
			if(vm.orderTagOpt.tag_name!=""){
				vm.orderTagErr = 0;
				for(var i=0;i<vm.kotItems.length;i++){	
					if(vm.kotItems[i].kotitem_id == vm.selectedItm){
						vm.tagIN = 0;
						/*var tags = vm.kotItems[i].kotitem_orderTagsList;
						for(var j=0;j<tags.length;j++){	
							//alert(tags[j].kotitemtag_kotitem_id+" == "+vm.kotItems[i].kotitem_id+" && "+tags[j].kotitemtag_ordertag_id+" == "+opt.ordertagoption_id);
							if(tags[j].kotitemtag_kotitem_id == vm.kotItems[i].kotitem_id && tags[j].kotitemtag_ordertag_id == opt.ordertagoption_id){
								tags.splice(j, 1);
								vm.tagIN = 1;
								opt.status = 0;
							}
						}*/
						
						if(vm.tagIN == 0){
							//alert(vm.orderTagOpt.tag_rate);
							if(vm.orderTagOpt.tag_rate!=""){
								var rate = parseFloat(vm.kotItems[i].kotitem_qty) * parseFloat(vm.orderTagOpt.tag_rate);	
								var price = vm.orderTagOpt.tag_rate;
							} else {
								var rate = 0;
								var price = 0;
							}
							
							var obj = {kotitemtag_tag_id:Math.round(Math.random()*1000), kotitemtag_bill_id:vm.kotItems[i].kotitem_bill_id, kotitemtag_kot_id:vm.kotItems[i].kotitem_kot_id, kotitemtag_kotitem_id:vm.kotItems[i].kotitem_id, kotitemtag_ordertag_id:0, kotitemtag_ordertag_name:vm.orderTagOpt.tag_name, kotitemtag_ordertag_price:price, kotitemtag_ordertag_rate:rate};
							vm.kotItems[i].kotitem_orderTagsList.push(obj);
							//opt.status = 1;

							vm.orderTagOpt={'tag_name':'','tag_rate':''};
						}					
					}
				}
				if(__env.isDebug) console.log("Kot List Order Tag");
				if(__env.isDebug) console.log(vm.kotItems);
				if(__env.isDebug) console.log(vm.orderTagList);
				calSummary();
			} else {
				vm.orderTagErr = 1;
				$("#tag_name").focus();
				$mdToast.show(
					$mdToast.simple().textContent('Please enter kitchen notes').position('top right')
				);
			}
		}
		
		function gotoClearAll(){
			//vm.kotItems = [];  	
			//$state.go('app.table');
			
			vm.itemMenu = 0;	

			for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_status == "New"){
					//alert(i+" "+vm.kotItems[i].kotitem_status);
					//var qty = parseInt(vm.kotItems[i].kotitem_qty)-1;										
					vm.kotItems.splice(i);
				}
			}
			
			if(__env.isDebug) console.log("Kot List Remove");
			if(__env.isDebug) console.log(vm.kotItems);
			calSummary();			
		}
		
		function gotoExit(){
			//vm.kotItems = [];  	
			/*if(vm.kotItems.length > 0){
				var r = confirm("Do you want to exit?");
				if (r == true) {
					//$state.go('app.table');
					gotoListing();
				}
			} else {
				gotoListing();	
			}*/
			//alert($rootScope.KOTItmCount);
			$rootScope.KOTItmCount = 0;
			gotoListing();	

		}
		
		function addItmtoKot(itm){
			/*for(var i=0;i<vm.kotItems.length;i++){	
				if(vm.kotItems[i].kotitem_id == vm.selectedItm){
					//alert(vm.kotItems[i].kotitem_sub_qty+" < "+vm.kotItems[i].kotitem_qty);
					if(vm.kotItems[i].kotitem_status == 'New'){
						var qty = parseInt(vm.kotItems[i].kotitem_qty)+1;					
						vm.kotItems[i].kotitem_qty = qty;
					//} else if((vm.kotItems[i].kotitem_status == 'Submitted-Void' || vm.kotItems[i].kotitem_status == 'Submitted-Gift' || vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'Submitted' || vm.kotItems[i].kotitem_status == 'New-Gift') && vm.kotItems[i].kotitem_sub_qty < vm.kotItems[i].kotitem_qty){
						
					} else if((vm.kotItems[i].kotitem_status == 'New-Void' || vm.kotItems[i].kotitem_status == 'Submitted' || vm.kotItems[i].kotitem_status == 'New-Gift') && vm.kotItems[i].kotitem_sub_qty < vm.kotItems[i].kotitem_qty){	
						//alert("ELSE");
						var qty = parseInt(vm.kotItems[i].kotitem_sub_qty)+1;	
						if(vm.kotItems[i].kotitem_qty == qty){
							qty = 0;	
						}
						//alert(qty);
						vm.kotItems[i].kotitem_sub_qty = qty ;
					}
					
					if(vm.kotItems[i].kotitem_qty > 1){
						vm.minusDisp = 1;	
					}								
				} 
			}
			
			calSummary();*/
			
			var selQty = 0;
			for(var k=0;k<vm.kotItems.length;k++){	
				if(itm.item_id == vm.kotItems[k].kotitem_itm_id && itm.item_opt_id == vm.kotItems[k].kotitem_option_id && itm.catitm_category_id == vm.kotItems[k].kotitem_cat_id){
					selQty = selQty + parseFloat(vm.kotItems[k].kotitem_qty);
				}
			}

			//alert(selQty);

			//alert(itmID);
			vm.billDet.status = "New Orders";
			vm.ifNewRows = 1;
			vm.itemMenu = 0;
			var qty=1;
			//if(vm.input>1){ 
			if(vm.input>0){ 
				qty=vm.input;
				vm.input = '';
			}

			var typ = checkNumber(qty);
			//alert(typ);
			if(typ==1){
				qty = parseInt(qty);	
			} else if(typ==0){
				qty = parseFloat(qty).toFixed(3);	
			}			
			
			vm.selectedItm = "";
			for(var i=0;i<vm.productList.length;i++){
				if(vm.productList[i].item_id == itm.item_id && vm.productList[i].item_opt_id == itm.item_opt_id && vm.productList[i].catitm_category_id == itm.catitm_category_id){
					if(vm.productList[i].item_price>0){
						if(vm.productList[i].item_stock==0){	
							vm.existBtn++;
							var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:'',kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.productList[i].catitm_category_id,kotitem_itm_id:vm.productList[i].item_id,kotitem_option_id:vm.productList[i].item_opt_id,kotitem_itm_name:vm.productList[i].item_name,kotitem_qty:qty,kotitem_rate:vm.productList[i].item_price,kotitem_totat:(qty*vm.productList[i].item_price),kotitem_message:"",kotitem_status:'New',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_batch_id:'',kotitem_orderTagsList:[],kotitem_extra_amount:0};
							vm.kotItems.push(obj);
						} if(vm.productList[i].item_stock>0){
							if(vm.productList[i].item_stock>=qty && vm.productList[i].item_stock>selQty){
								vm.existBtn++;
								var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:'',kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.productList[i].catitm_category_id,kotitem_itm_id:vm.productList[i].item_id,kotitem_option_id:vm.productList[i].item_opt_id,kotitem_itm_name:vm.productList[i].item_name,kotitem_qty:qty,kotitem_rate:vm.productList[i].item_price,kotitem_totat:(qty*vm.productList[i].item_price),kotitem_message:"",kotitem_status:'New',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_batch_id:'',kotitem_orderTagsList:[],kotitem_extra_amount:0};
								vm.kotItems.push(obj);
							} else {
								var confirm = $mdDialog.confirm()
				                .title('Order qty is greater than avaliable stock')
				                .htmlContent('Unable to add this to kot, Order qty is greater than avaliable stock.')
				                .ariaLabel('Unable to add')
				                .ok('Ok')
				                //.cancel('Cancel')
				                .targetEvent(event);
					            $mdDialog.show(confirm).then(function ()
					            {
					               
					            });
							}
						}

						//vm.existBtn++;
						//var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:'',kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.productList[i].catitm_category_id,kotitem_itm_id:vm.productList[i].item_id,kotitem_option_id:vm.productList[i].item_opt_id,kotitem_itm_name:vm.productList[i].item_name,kotitem_qty:qty,kotitem_rate:vm.productList[i].item_price,kotitem_totat:(qty*vm.productList[i].item_price),kotitem_status:'New',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:[]};
						//vm.kotItems.push(obj);
					} else if(vm.productList[i].item_price>0){
						var confirm = $mdDialog.confirm()
		                .title('Item price is 0!')
		                .htmlContent('Unable to add this to kot, Item price is 0.')
		                .ariaLabel('Unable to add')
		                .ok('Ok')
		                //.cancel('Cancel')
		                .targetEvent(event);
			            $mdDialog.show(confirm).then(function ()
			            {
			               
			            });
					} 
				}
			}
			calSummary();
						
			if(__env.isDebug) console.log("Kot List Add");
			if(__env.isDebug) console.log(vm.kotItems);
						
		}

		function checkNumber(n){
			var typ = n%1;			
			if(typ==0){
				return 1;
			} else {
				return 0;
			}		   
		}
		
		function addDiscounttoKot(){
			if(__env.isDebug) console.log(vm.discountDets);
			//alert(vm.discountDets.discountAmount);
			var disc = 0;			
			if(vm.discountDets.discountAmount!=""){
				disc = parseFloat(vm.discountDets.discountAmount);
			}
			//alert(disc);
			vm.billAddons.bil_totaldiscountrate = vm.discountDets.discountRate;
			vm.billAddons.bil_totaldiscount = disc;
 			//vm.discountDets={billAmount:vm.billAddons.bil_totalamt,billTax:vm.billAddons.bil_tottaxamt,discountRate:'',discountAmount:''};	
 			vm.discountDets.discountFocus = "";
 			//closeRetailBills()

 			//alert(vm.existBtn);
 			vm.discountAddDis = 1;

 			if(vm.existBtn > 0){
 				//alert("In");
 				closeTicketNote();
 				calSummary();		
 			} else {
 				//alert("Out");
 				
 				recalSummary();
 			}
 			
		}

		function addItmtoKotRetails(){
			//alert(itmID);
			var itm = vm.retailDets;
			if(__env.isDebug) console.log("Selected Items");
			if(__env.isDebug) console.log(itm);
			vm.billDet.status = "New Orders";
			vm.ifNewRows = 1;
			vm.itemMenu = 0;
			var qty=itm.retailQty;
			var typ = checkNumber(qty);
			//alert(typ);
			if(typ==1){
				qty = parseInt(qty);	
			} else if(typ==0){
				qty = parseFloat(qty).toFixed(3);	
			}
			
			/*if(vm.input>1){
				qty=vm.input;
				vm.input = '';
			}*/
			vm.selectedItm = "";
			//alert(itm.retailKOTID);
			if(itm.retailKOTID==""){
				for(var i=0;i<vm.productList.length;i++){
					if(vm.productList[i].item_id == itm.retailItmID && vm.productList[i].item_opt_id == itm.retailOptID && vm.productList[i].catitm_category_id == itm.retailCatID){
						var price = vm.productList[i].item_price;
						var batch = vm.productList[i].batchList;
						if(itm.retailBatchID!=""){
							if(batch.length==1){
								if(batch[0].inventory_id==itm.retailBatchID && batch[0].inventory_selling_price > 0){
									price = batch[0].inventory_selling_price;
								}
							} else if(batch.length>1){
								for(var b=0;b<batch.length;b++){
									if(batch[b].inventory_id==itm.retailBatchID && batch[b].inventory_selling_price > 0){
										price = batch[b].inventory_selling_price;
									}
								}								
							}
						}
						
						if(price>0 && vm.productList[i].item_currqty>=0){
							vm.existBtn++;
							
							var obj	= {kotitem_id:Math.round(Math.random()*1000),kotitem_type:'',kotitem_ref_id:'',kotitem_bill_id:'',kotitem_kot_id:'',kotitem_cat_id:vm.productList[i].catitm_category_id,kotitem_itm_id:vm.productList[i].item_id,kotitem_option_id:vm.productList[i].item_opt_id,kotitem_itm_name:vm.productList[i].item_name,kotitem_qty:qty,kotitem_rate:price,kotitem_totat:(qty*price),kotitem_message:'',kotitem_status:'New',kotitem_old_status:'',kotitem_sub_qty:0,kotitem_orderTagsList:[],kotitem_batch_id:itm.retailBatchID,kotitem_unit_name:vm.productList[i].unit_name,kotitem_extra_amount:0};
							vm.kotItems.push(obj);
							vm.productList[i].showBatch = 0;
							
						} else if(price==0){
							var confirm = $mdDialog.confirm()
			                .title('Item price is 0!')
			                .htmlContent('Unable to add this to kot, Item price is 0.')
			                .ariaLabel('Unable to add')
			                .ok('Ok')
			                //.cancel('Cancel')
			                .targetEvent(event);
				            $mdDialog.show(confirm).then(function ()
				            {
				               
				            });
						} else if(vm.productList[i].item_currqty==0){
							var confirm = $mdDialog.confirm()
			                .title('Item qty is 0!')
			                .htmlContent('Unable to add this to kot, Item qty is 0.')
			                .ariaLabel('Unable to add')
			                .ok('Ok')
			                //.cancel('Cancel')
			                .targetEvent(event);
				            $mdDialog.show(confirm).then(function ()
				            {
				               
				            });
						} 
					}
				}
			} else {
				for(var i=0;i<vm.kotItems.length;i++){
					if(vm.kotItems[i].kotitem_id == itm.retailKOTID){
						vm.kotItems[i].kotitem_qty = itm.retailQty;
						vm.kotItems[i].kotitem_totat = vm.kotItems[i].kotitem_rate*itm.retailQty;
					}
				}				
			}
			vm.retailDets={retailKOTID:'',retailCatID:'',retailItmID:'',retailOptID:'',retailBatchID:'',retailItm:'',retailItmUnit:'',retailQty:'',retailCurrQty:''};
			if($("#retailItm").val()==""){
				//alert("In 2");
				$("#retailItm").focus();
			}
			
			calSummary();
						
			if(__env.isDebug) console.log("Kot List Add");
			if(__env.isDebug) console.log(vm.kotItems);
						
		}
		
		function changeItmOption(opt){
			//alert(opt.item_price_price);
			if(opt.item_price_price>0){
				for(var i=0;i<vm.kotItems.length;i++){	
					if(vm.kotItems[i].kotitem_id == vm.selectedItm){
						var name = (vm.kotItems[i].kotitem_itm_name).split('.');
						vm.kotItems[i].kotitem_itm_name = name[0]+'.'+opt.itm_option_name;
						vm.kotItems[i].kotitem_option_id = opt.itm_option_id;
						vm.kotItems[i].kotitem_rate = opt.item_price_price;
						vm.kotItems[i].kotitem_totat = vm.kotItems[i].kotitem_qty*opt.item_price_price;
					}
				}	
			} else if(opt.item_price_price==0){
				var confirm = $mdDialog.confirm()
                .title('Item price is 0!')
                .htmlContent('Unable to add this to kot, Item price is 0.')
                .ariaLabel('Unable to add')
                .ok('Ok')
                //.cancel('Cancel')
                .targetEvent(event);
	            $mdDialog.show(confirm).then(function ()
	            {
	               
	            });
			}	
			
			//vm.itemMenu = 0; 
			//closeTicketNote();
			calSummary();
			if(__env.isDebug) console.log("Kot List Option Change");
			if(__env.isDebug) console.log(vm.kotItems);
		}


		function removeExtra(extra) {
			//alert(extra.extra_id);
			for (var i=0;i<vm.extraMasterList.length;i++) {
				if(vm.extraMasterList[i].extra_id==extra.extra_id){
					vm.extraMasterList[i].removeStatus = 1;
					vm.extraSummary[i].removeStatus = 1;
				}				
			}
			calSummary();
		}

		
			
		function calSummary(){ 
			//alert("Calling");
			if(__env.isDebug) console.log("Kot List Summary");
			if(__env.isDebug) console.log(vm.kotItems);	
			var total = 0; var qty = 0;
			var tagTotal = 0;
			for(var i=0;i<vm.kotItems.length;i++){				
				if(((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "Submitted")) && vm.kotItems[i].kotitem_qty > 0){
					//alert(vm.kotItems[i].kotitem_qty);
					
					var tagDets = vm.kotItems[i].kotitem_orderTagsList;
					for(var j=0;j<tagDets.length;j++){
						if(tagDets[j].kotitemtag_ordertag_rate!=""){
							tagTotal = tagTotal + parseFloat(tagDets[j].kotitemtag_ordertag_rate);
						} else {
							tagTotal = tagTotal + 0;
						}
					}
					
					var tot = parseFloat(vm.kotItems[i].kotitem_qty*vm.kotItems[i].kotitem_rate);
					vm.kotItems[i].kotitem_totat = tot;
					vm.kotItems[i].kotitem_tag_totat = tagTotal;
					total = total + tot;
					qty = qty + parseInt(vm.kotItems[i].kotitem_qty);
				}
			}
			//alert("Cal"+total);
			vm.totalGrossAmount = total;
			vm.totalGrossAmount = vm.totalGrossAmount + tagTotal;	

			//alert(vm.totalGrossAmount);

			for (var i=0;i<vm.kotItems.length;i++) {
				vm.kotItems[i].kotitem_extra_amount = 0;						
			}

			vm.extra = 0;					
			vm.totalExtra=0;
			for(var t=0;t<vm.extraMasterList.length;t++){
				vm.itmExtra=0;
				vm.extraSummary[t].extra_total = 0;
				//alert(vm.extraMasterList[t].removeStatus);
				if(vm.extraMasterList[t].removeStatus==0 && vm.extraMasterList[t].extra_delete==0){
					if((vm.extraMasterList[t].extra_billable==0)){
						//alert("In");
						vm.extraItemArr=[];
						for(var i=0;i<vm.kotItems.length;i++){				
							//alert("Index "+i);																		
							if(((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "Submitted")) && vm.kotItems[i].kotitem_qty > 0){											
								if((vm.extraMasterList[t].extra_map_department_id==vm.department)){																
									if(((vm.extraMasterList[t].extra_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.extraMasterList[t].extra_map_category_id==0))){
										if(((vm.extraMasterList[t].extra_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.extraMasterList[t].extra_map_item_id==0))){
											var extra = 0;	
											//alert("In 1 "+ vm.extraMasterList[t].extra_type);
											if(vm.extraMasterList[t].extra_type == "Percentage"){
												var charge = parseFloat((vm.kotItems[i].kotitem_rate * vm.extraMasterList[t].extra_rate)/100);	
												extra = parseFloat(charge * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(charge);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											} else {
												extra = parseFloat(vm.extraMasterList[t].extra_rate * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(vm.extraMasterList[t].extra_rate);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											}	
											//alert("In 1 "+ extra);

											
											vm.itmExtra = vm.itmExtra + extra;																		
											vm.totalExtra = vm.totalExtra + extra;								
											vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 

											var obj={itmName:vm.kotItems[i].kotitem_itm_name,itmRate:extra};
											vm.extraItemArr.push(obj); 
										}		
									}
								} else if((vm.extraMasterList[t].extra_map_department_id==0)){						
									if(((vm.extraMasterList[t].extra_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.extraMasterList[t].extra_map_category_id==0))){
										if(((vm.extraMasterList[t].extra_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.extraMasterList[t].extra_map_item_id==0))){
											var extra = 0;	
											//alert("In 2 "+ vm.extraMasterList[t].extra_type);
											if(vm.extraMasterList[t].extra_type == "Percentage"){
												var charge = parseFloat((vm.kotItems[i].kotitem_rate * vm.extraMasterList[t].extra_rate)/100);	
												extra = parseFloat(charge * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(charge);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											} else {
												extra = parseFloat(vm.extraMasterList[t].extra_rate * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(vm.extraMasterList[t].extra_rate);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											}	
											//alert("In 2 "+ extra);
											
											
											vm.itmExtra = vm.itmExtra + extra;																		
											vm.totalExtra = vm.totalExtra + extra;								
											vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 		

											var obj={itmName:vm.kotItems[i].kotitem_itm_name,itmRate:extra};
											vm.extraItemArr.push(obj);
										}		
									}
								}
							}
						}					
						vm.extraSummary[t]['itmList'] = vm.extraItemArr; 	
						//alert("In"+vm.itmExtra);
					} else {
						//alert("Out");
						//alert(vm.totalGrossAmount);
						if(vm.totalGrossAmount>0){
							if((vm.extraMasterList[t].extra_map_department_id==vm.department)){																
								var extra = 0;	
								//alert("Out 1 "+ vm.extraMasterList[t].extra_type);
								if(vm.extraMasterList[t].extra_type == "Percentage"){
									extra = parseFloat((vm.totalGrossAmount * vm.extraMasterList[t].extra_rate)/100);
								} else {
									extra = parseFloat(vm.extraMasterList[t].extra_rate);
								}	
								//alert("Out 1 "+ extra);
								vm.itmExtra = vm.itmExtra + extra;																		
								vm.totalExtra = vm.totalExtra + extra;
								vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 
							

							} else if((vm.extraMasterList[t].extra_map_department_id==0)){						
								var extra = 0;	
								//alert("Out 2 "+ vm.extraMasterList[t].extra_type);
								if(vm.extraMasterList[t].extra_type == "Percentage"){
									extra = parseFloat((vm.totalGrossAmount * vm.extraMasterList[t].extra_rate)/100);
								} else {
									extra = parseFloat(vm.extraMasterList[t].extra_rate);
								}	
								//alert("Out 2 "+ extra);
								vm.itmExtra = vm.itmExtra + extra;																		
								vm.totalExtra = vm.totalExtra + extra;
								vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 
															
							}
						}
						vm.extraItemArr=[];
						//alert("Out"+vm.itmExtra);	
						var obj={itmName:"Bill Extra",itmRate:vm.itmExtra};						
						vm.extraItemArr.push(obj);							
					}
					vm.extra = vm.extra + vm.itmExtra;
					vm.extraSummary[t]['itmList'] = vm.extraItemArr; 	
				}				
			}
			//alert(vm.totalExtra);
			//alert(vm.extra);

			if(__env.isDebug) console.log(vm.kotItems);	
			if(__env.isDebug) console.log(vm.extraSummary);	

			vm.tax = 0;
			//alert(vm.taxRate);
			/*if(vm.taxRate>0){
				vm.tax = Math.round((vm.totalGrossAmount * vm.taxRate)/100);
			}*/

			for (var i=0;i<vm.taxSummary.length;i++) {
				vm.taxSummary[i].tax_total = 0;
				vm.taxSummary[i].tax_total2 = 0;				
			}
			
			vm.totalTax=0;
			for(var i=0;i<vm.kotItems.length;i++){				
				if(((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "Submitted")) && vm.kotItems[i].kotitem_qty > 0){
					vm.itmTax=0;					
					for(var t=0;t<vm.taxMasterList.length;t++){																
						if((vm.taxMasterList[t].tax_type=="Exclusive")){
							if((vm.taxMasterList[t].tax_map_department_id==vm.department)){																
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert(rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										//alert(tax);
										vm.itmTax = vm.itmTax + parseFloat(tax);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total = vm.taxSummary[t].tax_total + parseFloat(tax); 
									}		
								}
							} else if((vm.taxMasterList[t].tax_map_department_id==0)){						
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										//alert(vm.kotItems[i].kotitem_rate+" * "+vm.taxMasterList[t].tax_rate);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert(rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										//alert(tax);
										vm.itmTax = vm.itmTax + parseFloat(tax);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total = vm.taxSummary[t].tax_total + parseFloat(tax); 
									}		
								}
							}
						} else {
							if((vm.taxMasterList[t].tax_map_department_id==vm.department)){																
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert(rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total2 = vm.taxSummary[t].tax_total2 + parseFloat(tax);								
									}		
								}
							} else if((vm.taxMasterList[t].tax_map_department_id==0)){						
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										//alert(vm.kotItems[i].kotitem_rate+" * "+vm.taxMasterList[t].tax_rate);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert(rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total2 = vm.taxSummary[t].tax_total2 + parseFloat(tax);
									}		
								}
							}
						}					
					}
					//alert(vm.itmTax);				
					vm.tax = vm.tax + vm.itmTax;
				}
			}
			//vm.taxMasterList
			//alert(vm.totalTax);

			//alert(vm.extra);
			
			if(__env.isDebug) console.log(vm.taxSummary);	
					
			//vm.totalAmount = vm.totalGrossAmount + vm.extra + vm.tax - vm.billAddons.bil_totaldiscount;
			vm.totalAmount = vm.totalGrossAmount + vm.extra + vm.tax;
			var discRate=vm.billAddons.bil_totaldiscountrate;
			var discAmt = 0;
			//alert(discRate);			
			if(discRate!="" || discRate!=0){
				discAmt = (vm.totalAmount * (discRate/100)).toFixed(2);	
			} else {
				discAmt = vm.billAddons.bil_totaldiscount;	
			}			
			//alert(discAmt);
			vm.billAddons.bil_totaldiscount = discAmt;
			vm.totalAmount = vm.totalAmount - discAmt;

			vm.totalQty = qty;
			
			//alert(vm.totalAmount);
			vm.totalAmount2 = vm.totalAmount - Math.round(vm.totalAmount);
			//alert(vm.totalAmount2+">="+vm.roundofrate);
			if(__env.isDebug)  console.log("Round of Rate ===" + vm.roundofrate);
			if(__env.isDebug) console.log("vm.totalAmount=" + vm.totalAmount);
			if(__env.isDebug) console.log("Round vm.totalAmount2=" + Math.round(vm.totalAmount));
			if(__env.isDebug) console.log("vm.totalAmount2=" + vm.totalAmount2);
			if (parseFloat(vm.roundofrate)==0.00){
				vm.bil_totalround=0;
			}else  {
				
				if(vm.totalAmount2>=vm.roundofrate){
					vm.bil_totalround = 1 - parseFloat(vm.totalAmount2);
				} else {
					vm.bil_totalround = -(parseFloat(vm.totalAmount2));
				}
			}
			if(__env.isDebug) console.log("vm.roundofrate=");
			if(__env.isDebug) console.log(parseFloat(vm.roundofrate));
			if(__env.isDebug) console.log(vm.bil_totalround);
			

			vm.totalAmountFinal = parseFloat(vm.totalAmount) + parseFloat(vm.bil_totalround);
			
			vm.billAddons.bil_totalround = vm.bil_totalround;
			vm.billAddons.bil_totalqty = vm.totalQty;
			vm.billAddons.bil_totalamt = vm.totalGrossAmount;
			//vm.billAddons.bil_totaltagamt = tagTotal;
			vm.billAddons.bil_totalnetamt = vm.totalAmount;
			vm.billAddons.bil_tottaxamt = vm.tax;
			vm.billAddons.bil_totextraamt = vm.extra;	
			vm.billAddons.bil_totaltaxamt = vm.totalTax;	
			if(__env.isDebug) console.log("In Summary");
			if(__env.isDebug) console.log(vm.billAddons);
			
			//alert(vm.kotItems.length);
			
			vm.count = 0; 
			for(var i=0;i<vm.kotItems.length;i++){				
				if((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "New-Gift") || (vm.kotItems[i].kotitem_status == "New-Void")){
					vm.count = parseInt(vm.count) + 1;									
				}
			}
			
			$rootScope.KOTItmCount = vm.count;
		}

		function recalSummary(){
			if(__env.isDebug) console.log("Kot List Summary");
			if(__env.isDebug) console.log(vm.kotItems);	
			var total = 0; var qty = 0;
			var tagTotal = 0;
			for(var i=0;i<vm.kotItems.length;i++){				
				if(((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "Submitted")) && vm.kotItems[i].kotitem_qty > 0){
					//alert(vm.kotItems[i].kotitem_qty);
					
					var tagDets = vm.kotItems[i].kotitem_orderTagsList;
					for(var j=0;j<tagDets.length;j++){
						//tagTotal = tagTotal + parseFloat(tagDets[j].kotitemtag_ordertag_rate);
						if(tagDets[j].kotitemtag_ordertag_rate!=""){
							tagTotal = tagTotal + parseFloat(tagDets[j].kotitemtag_ordertag_rate);
						} else {
							tagTotal = tagTotal + 0;
						}
					}
					
					var tot = parseFloat(vm.kotItems[i].kotitem_qty*vm.kotItems[i].kotitem_rate);
					vm.kotItems[i].kotitem_totat = tot;
					vm.kotItems[i].kotitem_tag_totat = tagTotal;
					total = total + tot;
					qty = qty + parseInt(vm.kotItems[i].kotitem_qty);
				}
			}
			//alert("RCal"+total);
			vm.totalGrossAmount = total;
			vm.totalGrossAmount = vm.totalGrossAmount + tagTotal;	


			vm.extra = 0;					
			vm.totalExtra=0;
			for(var t=0;t<vm.extraMasterList.length;t++){
				vm.itmExtra=0;
				vm.extraSummary[t].extra_total = 0;
				//alert(vm.extraMasterList[t].extra_delete);
				if(vm.extraMasterList[t].removeStatus==0 && vm.extraMasterList[t].extra_delete==0){
					if((vm.extraMasterList[t].extra_billable==0)){
						//alert("In");
						
						vm.extraItemArr=[];

						for(var i=0;i<vm.kotItems.length;i++){				
							//alert("Index "+i);																		
							if(((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "Submitted")) && vm.kotItems[i].kotitem_qty > 0){											
								if((vm.extraMasterList[t].extra_map_department_id==vm.department)){																
									if(((vm.extraMasterList[t].extra_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.extraMasterList[t].extra_map_category_id==0))){
										if(((vm.extraMasterList[t].extra_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.extraMasterList[t].extra_map_item_id==0))){
											var extra = 0;	
											//alert("In 1 "+ vm.extraMasterList[t].extra_type);
											if(vm.extraMasterList[t].extra_type == "Percentage"){
												var charge = parseFloat((vm.kotItems[i].kotitem_rate * vm.extraMasterList[t].extra_rate)/100);	
												extra = parseFloat(charge * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(charge);
													//vm.kotItems[i].kotitem_extra_amount = parseFloat(charge);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											} else {
												extra = parseFloat(vm.extraMasterList[t].extra_rate * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(vm.extraMasterList[t].extra_rate);
													//vm.kotItems[i].kotitem_extra_amount = parseFloat(vm.extraMasterList[t].extra_rate);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											}	
											//alert("In 1 "+ extra);

											
											vm.itmExtra = vm.itmExtra + extra;																		
											vm.totalExtra = vm.totalExtra + extra;								
											vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 

											var obj={itmName:vm.kotItems[i].kotitem_itm_name,itmRate:extra};
											vm.extraItemArr.push(obj);
											
										}		
									}
								} else if((vm.extraMasterList[t].extra_map_department_id==0)){						
									if(((vm.extraMasterList[t].extra_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.extraMasterList[t].extra_map_category_id==0))){
										if(((vm.extraMasterList[t].extra_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.extraMasterList[t].extra_map_item_id==0))){
											var extra = 0;	
											//alert("In 2 "+ vm.extraMasterList[t].extra_type);
											if(vm.extraMasterList[t].extra_type == "Percentage"){
												var charge = parseFloat((vm.kotItems[i].kotitem_rate * vm.extraMasterList[t].extra_rate)/100);	
												extra = parseFloat(charge * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(charge);
													//vm.kotItems[i].kotitem_extra_amount = parseFloat(charge);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											} else {
												extra = parseFloat(vm.extraMasterList[t].extra_rate * vm.kotItems[i].kotitem_qty);
												if(vm.extraMasterList[t].extra_inclTax == 1){
													vm.kotItems[i].kotitem_extra_amount = vm.kotItems[i].kotitem_extra_amount + parseFloat(vm.extraMasterList[t].extra_rate);
													//vm.kotItems[i].kotitem_extra_amount = parseFloat(vm.extraMasterList[t].extra_rate);
												} /*else {
													vm.kotItems[i].kotitem_extra_amount = 0;
												}*/
											}	
											//alert("In 2 "+ extra);
											
											
											vm.itmExtra = vm.itmExtra + extra;																		
											vm.totalExtra = vm.totalExtra + extra;								
											vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 		

											var obj={itmName:vm.kotItems[i].kotitem_itm_name,itmRate:extra};
											vm.extraItemArr.push(obj);											
										}		
									}
								}
							}
						}		
						vm.extraSummary[t]['itmList'] = vm.extraItemArr; 			
					} else {
						//alert("Out");
						if(vm.totalGrossAmount>0){
							if((vm.extraMasterList[t].extra_map_department_id==vm.department)){																
								var extra = 0;	
								//alert("Out 1 "+ vm.extraMasterList[t].extra_type);
								if(vm.extraMasterList[t].extra_type == "Percentage"){
									extra = parseFloat((vm.totalGrossAmount * vm.extraMasterList[t].extra_rate)/100);
								} else {
									extra = parseFloat(vm.extraMasterList[t].extra_rate);
								}	
								//alert("Out 1 "+ extra);
								vm.itmExtra = vm.itmExtra + extra;																		
								vm.totalExtra = vm.totalExtra + extra;
								vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 
								
							} else if((vm.extraMasterList[t].extra_map_department_id==0)){						
								var extra = 0;	
								//alert("Out 2 "+ vm.extraMasterList[t].extra_type);
								if(vm.extraMasterList[t].extra_type == "Percentage"){
									extra = parseFloat((vm.totalGrossAmount * vm.extraMasterList[t].extra_rate)/100);
								} else {
									extra = parseFloat(vm.extraMasterList[t].extra_rate);
								}	
								//alert("Out 2 "+ extra);
								vm.itmExtra = vm.itmExtra + extra;																		
								vm.totalExtra = vm.totalExtra + extra;
								vm.extraSummary[t].extra_total = vm.extraSummary[t].extra_total + parseFloat(extra); 

							}
							//alert(vm.itmExtra);									
						}
						vm.extraItemArr=[];
						var obj={itmName:"Bill Extra",itmRate:vm.itmExtra};						
						vm.extraItemArr.push(obj);
					}
					vm.extra = vm.extra + vm.itmExtra;
					vm.extraSummary[t]['itmList'] = vm.extraItemArr;
				}
			}
			//alert(vm.totalExtra);
			//alert(vm.extra);

			if(__env.isDebug) console.log(vm.kotItems);	
			if(__env.isDebug) console.log(vm.extraSummary);			

			vm.tax = 0;
			//alert(vm.taxRate);
			
			/*if(vm.taxRate>0){
				vm.tax = Math.round((vm.totalGrossAmount * vm.taxRate)/100);
			}*/			
			
			for (var i=0;i<vm.taxSummary.length;i++) {
				vm.taxSummary[i].tax_total = 0;
				vm.taxSummary[i].tax_total2 = 0;				
			}
			
			vm.totalTax=0;
			for(var i=0;i<vm.kotItems.length;i++){				
				if(((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "Submitted")) && vm.kotItems[i].kotitem_qty > 0){
					vm.itmTax=0;					
					for(var t=0;t<vm.taxMasterList.length;t++){																
						if((vm.taxMasterList[t].tax_type=="Exclusive")){
							if((vm.taxMasterList[t].tax_map_department_id==vm.department)){																
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert("Ex Rate IF "+rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										//alert("Ex Tax IF "+tax);
										vm.itmTax = vm.itmTax + parseFloat(tax);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total = vm.taxSummary[t].tax_total + parseFloat(tax); 
									}		
								}
							} else if((vm.taxMasterList[t].tax_map_department_id==0)){						
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										//alert(vm.kotItems[i].kotitem_rate+" * "+vm.taxMasterList[t].tax_rate);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert("Ex Rate ELSE "+rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										//alert("Ex Tax ELSE "+tax);
										vm.itmTax = vm.itmTax + parseFloat(tax);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total = vm.taxSummary[t].tax_total + parseFloat(tax); 
									}		
								}
							}
						} else {
							if((vm.taxMasterList[t].tax_map_department_id==vm.department)){																
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert("IN Rate IF "+rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total2 = vm.taxSummary[t].tax_total2 + parseFloat(tax);								
									}		
								}
							} else if((vm.taxMasterList[t].tax_map_department_id==0)){						
								if(((vm.taxMasterList[t].tax_map_category_id==vm.kotItems[i].kotitem_cat_id) || (vm.taxMasterList[t].tax_map_category_id==0))){
									if(((vm.taxMasterList[t].tax_map_item_id==vm.kotItems[i].kotitem_itm_id) || (vm.taxMasterList[t].tax_map_item_id==0))){
										//alert(vm.kotItems[i].kotitem_itm_id+" "+vm.kotItems[i].kotitem_rate+" "+vm.kotItems[i].kotitem_extra_amount);
										//alert(vm.kotItems[i].kotitem_rate+" * "+vm.taxMasterList[t].tax_rate);
										var rate = parseFloat(vm.kotItems[i].kotitem_rate) + parseFloat(vm.kotItems[i].kotitem_extra_amount);
										//alert("IN Rate ELSE "+rate);
										var tax = ((rate * vm.kotItems[i].kotitem_qty * vm.taxMasterList[t].tax_rate)/100);
										vm.totalTax = vm.totalTax + parseFloat(tax);								
										vm.taxSummary[t].tax_total2 = vm.taxSummary[t].tax_total2 + parseFloat(tax);
									}		
								}
							}
						}					
					}
					//alert(vm.itmTax);				
					vm.tax = vm.tax + vm.itmTax;
				}
			}
			//vm.taxMasterList
			//alert(vm.totalTax);
			
			if(__env.isDebug) console.log(vm.taxSummary);	
						
			vm.currNettAmount = vm.billAddons.bil_totalnetamt;
			
			//alert(vm.totalGrossAmount+" + "+vm.extra+" + "+vm.tax+" - "+vm.billAddons.bil_totaldiscount);
			//vm.totalAmount = vm.totalGrossAmount + vm.extra + vm.tax - vm.billAddons.bil_totaldiscount;
			vm.totalAmount = vm.totalGrossAmount + vm.extra + vm.tax;
			var discRate=vm.billAddons.bil_totaldiscountrate;
			//alert( vm.billAddons.bil_totaldiscount);
			var discAmt = 0;
			//alert(discRate);			
			if(discRate!="" || discRate!=0){
				discAmt = (vm.totalAmount * (discRate/100)).toFixed(2);	
			} else {
				discAmt = vm.billAddons.bil_totaldiscount;	
			}			
			//alert(discAmt);
			vm.billAddons.bil_totaldiscount = discAmt;
			vm.totalAmount = vm.totalAmount - discAmt;
			vm.totalQty = qty;
			
			//alert(vm.totalAmount);
			vm.totalAmount2 = vm.totalAmount - Math.round(vm.totalAmount);
			//alert(vm.totalAmount2+">="+vm.roundofrate);
			if (parseFloat(vm.roundofrate)==0.00){
				vm.bil_totalround=0;
			}else  {
				
				if(vm.totalAmount2>=vm.roundofrate){
					vm.bil_totalround = 1 - parseFloat(vm.totalAmount2);
				} else {
					vm.bil_totalround = -(parseFloat(vm.totalAmount2));
				}
			}
			if(__env.isDebug) console.log("vm.roundofrate=");
			if(__env.isDebug) console.log(parseFloat(vm.roundofrate));
			if(__env.isDebug) console.log(vm.bil_totalround);

			var tdisc=0;
			/*if(!isNaN(vm.billAddons.bil_totaldiscount)){
				tdisc=vm.billAddons.bil_totaldiscount;
			}*/
			
			vm.totalAmountFinal = parseFloat(vm.totalAmount) + parseFloat(vm.bil_totalround)- tdisc;
			
			//alert(vm.currNettAmount+" "+vm.totalAmount);
			vm.billAddons.bil_totalround = vm.bil_totalround;
			vm.billAddons.bil_totalqty = vm.totalQty;
			vm.billAddons.bil_totalamt = vm.totalGrossAmount;
			//vm.billAddons.bil_totaltagamt = tagTotal;
			//vm.billAddons.bil_totaldiscount = tdisc;
			vm.billAddons.bil_totalnetamt = vm.totalAmount - tdisc;
			vm.billAddons.bil_tottaxamt = vm.tax;	
			vm.billAddons.bil_totaltaxamt = vm.totalTax;
			vm.billAddons.bil_totextraamt = vm.extra;	
			if(__env.isDebug) console.log("In Summary");
			if(__env.isDebug) console.log(vm.billAddons);
			

			//alert(vm.kotItems.length);

			if(vm.currNettAmount!=vm.totalAmount){
				updateOrder();
			}
			
			vm.count = 0; 
			for(var i=0;i<vm.kotItems.length;i++){				
				if((vm.kotItems[i].kotitem_status == "New") || (vm.kotItems[i].kotitem_status == "New-Gift") || (vm.kotItems[i].kotitem_status == "New-Void")){
					vm.count = parseInt(vm.count) + 1;									
				}
			}
			
			$rootScope.KOTItmCount = vm.count;
		}

		function updateOrder(){
			//alert("In");
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.billDet.billDets);
			if(__env.isDebug) console.log(vm.billAddons);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.updateOrder@save', {param:{billDets:vm.billDet.billDets,billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success Kot");
						if(__env.isDebug) console.log(response);
						//alert(response.data);
						if(__env.isDebug) console.log(response.data);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Order Auto Updated').position('top right')
							);
																					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function saveKOT(type){
			//alert(type);
			
			for(var i=0;i<vm.kotItems.length;i++){
				if(!vm.kotItems[i].kotitem_orderTagsList.length==""){
					var filtered = $filter('orderBy')(vm.kotItems[i].kotitem_orderTagsList, 'kotitemtag_ordertag_id');
					vm.kotItems[i].kotitem_orderTagsList = filtered;
				}

				if(!vm.kotItems[i].kotitem_itm_id){
					//alert(vm.kotItems[i].kotitem_ordno);
					vm.kotItems.splice(i, 1);
				}
			}
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.billDet.billDets);
			if(__env.isDebug) console.log(vm.kotItems);
			if(__env.isDebug) console.log(vm.periodID);
			//if(__env.isDebug) console.log(vm.totalQty);
			if(__env.isDebug) console.log(vm.billAddons);
			if(__env.isDebug) console.log(vm.billDet.tableID);

			if(__env.isDebug) console.log(vm.extraSummary);
			if(__env.isDebug) console.log(vm.taxSummary);

			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;
				msApi.request('app.saveKOT@save', {param:{billDets:vm.billDet.billDets,kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder,extraSummary:vm.extraSummary,taxSummary:vm.taxSummary},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success Kot");
						if(__env.isDebug) console.log(response);
						//alert(response.data);
						if(__env.isDebug) console.log(response.data);
						if(response.data){
							if(__env.isDebug) console.log("response.prndata");							
							var prndata=response.prndata;
							$rootScope.KOTItmCount = 0;
							vm.printSt = 0;
							vm.errorMsg = "";
							if(vm.ifCustomOrder!=0){
								vm.alertList = JSON.parse($window.localStorage['customKots']);
								vm.ifCustomID = (vm.ifCustomOrder).split(",");

								if(__env.isDebug) console.log(vm.ifCustomID);

	                            for(var i=0;i<vm.alertList.length;i++){
	                            	for(var j=0;j<vm.ifCustomID.length;j++){
	                            	//if(vm.alertList[i].customerkot_id == vm.ifCustomOrder){
		                            	//alert(vm.alertList[i].customerkot_id +" == "+ vm.ifCustomID[j]);
		                            	if(vm.alertList[i].customerkot_id == vm.ifCustomID[j]){
		                            		//alert("in");
		                                	vm.alertList.splice(i, 1);	                            	
		                                }
		                            }
	                            }
	                            if(__env.isDebug) console.log("Alert New List");
	                            if(__env.isDebug) console.log(vm.alertList);
	                            if(vm.alertList.length>0){
	                                $rootScope.totalAlert = vm.alertList.length;
	                            } else {
	                            	$rootScope.totalAlert = 0;
	                            }                          
	                            
	                            $window.localStorage['customKots'] = JSON.stringify(vm.alertList);
	                            $rootScope.$emit('changeAlerts','');
							}

							/*
							var itmDets = response.data.billItmsCurrQtyDets;
							if(__env.isDebug) console.log(itmDets);
							for(var i=0;i<vm.productList.length;i++){
								for(var q=0;q<itmDets.length;q++){					
									if(vm.productList[i].catitm_category_id == itmDets[q].catitm_category_id && vm.productList[i].item_id == itmDets[q].item_id){								
										vm.productList[i].item_currqty = itmDets[q].item_currqty;
										vm.productList[i].batchList = itmDets[q].batchList;
										vm.productList[i].lastBatch = itmDets[q].lastBatch;
										vm.productList[i].showBatch = itmDets[q].showBatch;
									}
								}
							}
							if(__env.isDebug) console.log("Items List");
							if(__env.isDebug) console.log(vm.productList);
							$window.localStorage['productList'] = JSON.stringify(vm.productList);
							*/

							if (prndata){
								if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);
									
									
									var status="";
									
									var printers="";
									//alert(inp[1]+" "+inp[2]);
									var printerIP=$cookies.get("localPrinterIP");	
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										//findPrinter(inp[2],printerIP);
										printers=inp[2];

										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){												
											//findPrinter(vm.printer,printerIP);					
											printers=vm.printer;				
										} else {
											//findPrinter(inp[2],printerIP);
											printers=inp[2];
										}
									}									
									//alert(printers);
									console.log(printers);

									
									//var config = { encoding: 'ISO-8859-1' };
									var config = "";
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									//var data = [{type: 'raw',format: 'image',flavor: 'plain',data: 'assets/logo.png'}];
									//status=printData(config, data);
									status=printData(data,printers,config,printerIP);
									

									//alert(status);
									if(__env.isDebug) console.log("Printing Status");
									if(__env.isDebug) console.log(status);
									/*if(status!=""){
										var result = status.split("|");
										vm.printSt = result[0];
										vm.errorMsg = result[1];
									}*/
								}
							}							
							var kotID=response.data;
							if(vm.printSt==1){
								$mdToast.show(
									$mdToast.simple().textContent('Order Saved, Kot Printed Successfully.').position('top right')
								);
							} else {
								$mdToast.show(
									$mdToast.simple().textContent('Order Saved, Kot Not Printed.').position('top right')
								);
							}

							
														
							//$window.open(__env.apiUrl+'startPrintKOT/'+kotID);
							//$window.open(__env.apiUrl+'printSKCKOT/'+localStorage.getItem('BranchID')+'/'+kotID);
							gotoListing();	
							vm.saveFlag = 1;
							vm.existBtn = 0;
							//printKOT(response.data);
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }

        function showReprint(kotID){
        	//alert(kotID);
        	vm.kotID = kotID;
        	vm.kotMenu = 1; 
        	vm.itemMenu = 2;
        }

        function reprintKOT(kotID){
			//alert(type);
			
			if(__env.isDebug) console.log(kotID);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.reprintKOT@save', {param:{kotID:kotID},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success Kot");
						if(__env.isDebug) console.log(response);
						//alert(response.data);
						if(__env.isDebug) console.log(response.data);
						if(response.data){
							vm.kotID = "";
        					vm.kotMenu = 0;	
        					vm.itemMenu = 0;

							if(__env.isDebug) console.log("response.prndata");							
							var prndata=response.prndata;
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);
																											

									var printers="";
									//alert(inp[1]+" "+inp[2]);
									var printers="";
									//alert(inp[1]+" "+inp[2]);
									var printerIP=$cookies.get("localPrinterIP");	
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										//findPrinter(inp[2],printerIP);
										printers=inp[2];

										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){												
											//findPrinter(vm.printer,printerIP);					
											printers=vm.printer;				
										} else {
											//findPrinter(inp[2],printerIP);
											printers=inp[2];
										}
									}									
									//alert(printers);
									console.log(printers);

									
									//var config = { encoding: 'ISO-8859-1' };
									var config = "";
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									//status=printData(config, data);
									status=printData(data,printers,config,printerIP);
									//alert(printers);
									

									//alert(status);
									if(__env.isDebug) console.log("Printing Status");
									if(__env.isDebug) console.log(status);
								}
							}	

							$mdToast.show(
								$mdToast.simple().textContent('Kot Reprinted').position('top right')
							);
																					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }

        function printAllKOT(){
			//alert(vm.billDet.billDets.bil_id);
			var billID=vm.billDet.billDets.bil_id;
			if(__env.isDebug) console.log(billID);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printAllKOT@save', {param:{billID:billID},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success Kot");
						if(__env.isDebug) console.log(response);
						//alert(response.data);
						if(__env.isDebug) console.log(response.data);
						if(response.data){
							vm.billID = "";
        					vm.kotMenu = 0;	
        					vm.itemMenu = 0;

							if(__env.isDebug) console.log("response.prndata");							
							var prndata=response.prndata;
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);
																		
									var status="";
									var printers="";
									//alert(inp[1]+" "+inp[2]);
									var printerIP=$cookies.get("localPrinterIP");	
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										//findPrinter(inp[2],printerIP);
										printers=inp[2];

										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){												
											//findPrinter(vm.printer,printerIP);					
											printers=vm.printer;				
										} else {
											//findPrinter(inp[2],printerIP);
											printers=inp[2];
										}
									}									
									//alert(printers);
									console.log(printers);

									
									//var config = { encoding: 'ISO-8859-1' };
									var config = "";
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									//status=printData(config, data);
									status=printData(data,printers,config,printerIP);
									

									//alert(status);
									if(__env.isDebug) console.log("Printing Status");
									if(__env.isDebug) console.log(status);
								}
							}	

							$mdToast.show(
								$mdToast.simple().textContent('All Kot Printed').position('top right')
							);
																					
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		/*function printKOT(){
			const escpos = require('../');
			const device  = new escpos.USB(0x0416, 0x5011);
			// const device  = new escpos.Network('localhost');
			// const device  = new escpos.Serial('/dev/usb/lp0');
			const printer = new escpos.Printer(device);
			
			device.open(function(err){
			
			  printer
			  .font('a')
			  .align('ct')
			  .style('bu')
			  .size(1, 1)
			  .text('The quick brown fox jumps over the lazy dog')			  
			  .barcode('1234567', 'EAN8')
			  .qrimage('https://github.com/song940/node-escpos', function(err){
				this.cut();
				this.close();
			  });
			
			});	
		}*/
		
				
		function saveBill(){
			for(var i=0;i<vm.kotItems.length;i++){
				if(vm.kotItems[i].kotitem_orderTagsList.length){
					var filtered = $filter('orderBy')(vm.kotItems[i].kotitem_orderTagsList, 'kotitemtag_ordertag_id');
					vm.kotItems[i].kotitem_orderTagsList = filtered;
				}

				if(!vm.kotItems[i].kotitem_itm_id){
					//alert(vm.kotItems[i].kotitem_ordno);
					vm.kotItems.splice(i, 1);
				}
			}
			
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			var billDets = vm.billDet.billDets;			
			if(__env.isDebug) console.log(billDets);
			if(__env.isDebug) console.log(vm.kotItems);
			if(__env.isDebug) console.log(vm.periodID);
			//if(__env.isDebug) console.log(vm.totalQty);
			if(__env.isDebug) console.log(vm.billAddons);
			if(__env.isDebug) console.log(vm.billDet.tableID);

			if(__env.isDebug) console.log(vm.extraSummary);
			if(__env.isDebug) console.log(vm.taxSummary);

			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;
				if(billDets==null){
					//alert("IF");
					var param = {billDets:'',kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:'Ordered',printMode:'0',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder,extraSummary:vm.extraSummary,taxSummary:vm.taxSummary};
				} else {
					//alert("ELSE");
					var param = {billDets:billDets,kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:'Ordered',printMode:'0',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder,extraSummary:vm.extraSummary,taxSummary:vm.taxSummary};
				}
				if(__env.isDebug) console.log(param);
				msApi.request('app.saveBill@save', {param:param,aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success @ Save Bill");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						if(response.data){
							$rootScope.KOTItmCount = 0;	
							$mdToast.show(
								$mdToast.simple().textContent('Order Saved').position('top right')
							);

							if(vm.ifCustomOrder!=0){
								vm.alertList = JSON.parse($window.localStorage['customKots']);
								vm.ifCustomID = (vm.ifCustomOrder).split(",");

								if(__env.isDebug) console.log(vm.ifCustomID);

	                            for(var i=0;i<vm.alertList.length;i++){
	                            	for(var j=0;j<vm.ifCustomID.length;j++){
	                            	//if(vm.alertList[i].customerkot_id == vm.ifCustomOrder){
		                            	//alert(vm.alertList[i].customerkot_id +" == "+ vm.ifCustomID[j]);
		                            	if(vm.alertList[i].customerkot_id == vm.ifCustomID[j]){
		                            		//alert("in");
		                                	vm.alertList.splice(i, 1);	                            	
		                                }
		                            }
	                            }
	                            if(__env.isDebug) console.log("Alert New List");
	                            if(__env.isDebug) console.log(vm.alertList);
	                            if(vm.alertList.length>0){
	                                $rootScope.totalAlert = vm.alertList.length;
	                            } else {
	                            	$rootScope.totalAlert = 0;
	                            }                          
	                            
	                            $window.localStorage['customKots'] = JSON.stringify(vm.alertList);
							}

							var itmDets = response.data.billItmsCurrQtyDets;
							if(__env.isDebug) console.log(itmDets);
							for(var i=0;i<vm.productList.length;i++){
								for(var q=0;q<itmDets.length;q++){					
									if(vm.productList[i].catitm_category_id == itmDets[q].catitm_category_id && vm.productList[i].item_id == itmDets[q].item_id){								
										vm.productList[i].item_currqty = itmDets[q].item_currqty;
										vm.productList[i].batchList = itmDets[q].batchList;
										vm.productList[i].lastBatch = itmDets[q].lastBatch;
										vm.productList[i].showBatch = itmDets[q].showBatch;
									}
								}
							}
							if(__env.isDebug) console.log("Items List");
							if(__env.isDebug) console.log(vm.productList);
							$window.localStorage['productList'] = JSON.stringify(vm.productList);
							
							gotoBilling(response.data.bill_id);	
							vm.saveFlag = 1;
							vm.existBtn = 0;
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function printBill(){
			for(var i=0;i<vm.kotItems.length;i++){
				if(vm.kotItems[i].kotitem_orderTagsList.length){
					var filtered = $filter('orderBy')(vm.kotItems[i].kotitem_orderTagsList, 'kotitemtag_ordertag_id');
					vm.kotItems[i].kotitem_orderTagsList = filtered;
				}

				if(!vm.kotItems[i].kotitem_itm_id){
					//alert(vm.kotItems[i].kotitem_ordno);
					vm.kotItems.splice(i, 1);
				}
			}
			
			//alert(vm.ifCustomOrder);

			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log("اورما لبناني");
			var billDets = vm.billDet.billDets;			
			if(__env.isDebug) console.log(billDets);
			if(__env.isDebug) console.log(vm.kotItems);
			if(__env.isDebug) console.log(vm.periodID);
			//if(__env.isDebug) console.log(vm.totalQty);
			if(__env.isDebug) console.log(vm.billAddons);
			//if(__env.isDebug) console.log(vm.billDet.tableID);

			if(__env.isDebug) console.log(vm.extraSummary);
			if(__env.isDebug) console.log(vm.taxSummary);

			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;
				if(billDets==null){
					//alert("IF");
					var param = {billDets:'',kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:'Ordered',printMode:'1',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder,extraSummary:vm.extraSummary,taxSummary:vm.taxSummary};
				} else {
					//alert("ELSE");
					var param = {billDets:billDets,kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:'Ordered',printMode:'1',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder,extraSummary:vm.extraSummary,taxSummary:vm.taxSummary};
				}
				if(__env.isDebug) console.log(param);
				msApi.request('app.saveBill@save', {param:param,aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Dining Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);
						//printWebUSB("@@EaSiddique Kabab Centre - Head\n");
						vm.billDet = response.data;
						//alert(response.data);
						if(vm.billDet.billID){
							//alert("In");
							/*var prndata=vm.billDet.prndata;							
							if (prndata){
								//if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
							}*/
							var billID=vm.billDet.billID;
							$rootScope.KOTItmCount = 0;
							$mdToast.show(
								$mdToast.simple().textContent('Order Saved').position('top right')
							);

							if(vm.ifCustomOrder!=0){
								//alert(vm.ifCustomOrder);
								vm.alertList = JSON.parse($window.localStorage['customKots']);
	                            vm.ifCustomID = (vm.ifCustomOrder).split(",");
	                            //alert("IN");
								if(__env.isDebug) console.log(vm.ifCustomID);

	                            for(var i=0;i<vm.alertList.length;i++){
	                            	for(var j=0;j<vm.ifCustomID.length;j++){
	                            	//if(vm.alertList[i].customerkot_id == vm.ifCustomOrder){
		                            	//alert(vm.alertList[i].customerkot_id +" == "+ vm.ifCustomID[j]);
		                            	if(vm.alertList[i].customerkot_id == vm.ifCustomID[j]){
		                            		//alert("in");
		                                	vm.alertList.splice(i, 1);	                            	
		                                }
		                            }
	                            }
	                            if(__env.isDebug) console.log("Alert New List");
	                            if(__env.isDebug) console.log(vm.alertList);
	                            if(vm.alertList.length>0){
	                                $rootScope.totalAlert = vm.alertList.length;
	                            } else {
	                            	$rootScope.totalAlert = 0;
	                            }                          
	                            
	                            $window.localStorage['customKots'] = JSON.stringify(vm.alertList);
	                            $rootScope.$emit('changeAlerts','');
							}

							var itmDets = response.data.billItmsCurrQtyDets;
							if(__env.isDebug) console.log(itmDets);
							for(var i=0;i<vm.productList.length;i++){
								for(var q=0;q<itmDets.length;q++){					
									if(vm.productList[i].catitm_category_id == itmDets[q].catitm_category_id && vm.productList[i].item_id == itmDets[q].item_id){								
										vm.productList[i].item_currqty = itmDets[q].item_currqty;
										vm.productList[i].batchList = itmDets[q].batchList;
										vm.productList[i].lastBatch = itmDets[q].lastBatch;
										vm.productList[i].showBatch = itmDets[q].showBatch;
										vm.productList[i].isExpired = itmDets[q].isExpired;
									}
								}
							}
							if(__env.isDebug) console.log("Items List");
							if(__env.isDebug) console.log(vm.productList);
							$window.localStorage['productList'] = JSON.stringify(vm.productList);

							if(__env.isDebug) console.log("Start Print ");
							//$window.open(__env.apiUrl+'printBillsTest/'+billID, "popup","width=400,height=300,left=300,top=200");
							//$window.open(__env.apiUrl+'startPrintBill/'+billID);
							//gotoBilling(response.data);					
							
							//gotoBillDets(billID);
							
							var prndata=vm.billDet.prndata;
							
							//alert(prndata);
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);									

									var printers="";
									//alert(inp[1]+" "+inp[2]);
									var printerIP=$cookies.get("localPrinterIP");	
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										//findPrinter(inp[2],printerIP);
										printers=inp[2];

										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){												
											//findPrinter(vm.printer,printerIP);					
											printers=vm.printer;				
										} else {
											//findPrinter(inp[2],printerIP);
											printers=inp[2];
										}
									}									
									//alert(printers);
									console.log(printers);

									
									//var config = { encoding: 'ISO-8859-1' };
									var config = "";
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									//status=printData(config, data);
									status=printData(data,printers,config,printerIP);
								}
							}
							
							vm.customerName = "";
							if(vm.billDet.billDets!=""){
								var discrate=vm.billDet.billDets.bil_discount;
								if(discrate==0){
									discrate="";
								}

								vm.discount = parseFloat(vm.billDet.billDets.bil_discountamt) + parseFloat(vm.billDet.billDets.bil_round);
								vm.billAddons = {bil_table_id:vm.billDet.billDets.bil_table_id,bil_cusid:vm.billDet.billDets.bil_cusid,bil_stfid:vm.billDet.billDets.bil_stfid,billNotes:vm.billDet.billDets.bil_notes,bil_type:vm.billDet.billDets.bil_type,bil_tottaxamt:vm.billDet.billDets.bil_tottaxamt,bil_totextraamt:vm.billDet.billDets.bil_totextraamt,bil_totaltaxamt:vm.billDet.billDets.bil_totaltaxamt,bil_totalqty:vm.billDet.billDets.bil_totalqty,bil_totalamt:vm.billDet.billDets.bil_totalamt,bil_totalnetamt:vm.discount, bil_totaldiscount:vm.discount, bil_totaldiscountrate:discrate,bil_totalround:vm.billDet.billDets.bil_totalround};  
							} else {
								vm.billAddons = {bil_table_id:tableID, bil_cusid:custID, bil_print:"", bil_remarks:"", bil_timing:"", bil_stfid:'',billNotes:'', bil_type:vm.deptType, bil_tottaxamt:0, bil_totextraamt:0, bil_totaltaxamt:0, bil_totalqty:0, bil_totalamt:0, bil_totalround:0, bil_totaldiscount:0, bil_totaldiscountrate:'', bil_totalnetamt:0};	
							}
							
							vm.kotItems = [];										
							if(vm.billDet.kotItmsDets.length>0){
								var itmDets = vm.billDet.kotItmsDets;	
								for(var i=0;i<itmDets.length;i++){
									var itmName = itmDets[i].item_name+'.'+itmDets[i].itm_option_name;
									if(itmDets[i].itm_option_name=="Normal"){
										itmName = itmDets[i].item_name;
									}
									var obj	= {kotitem_id:itmDets[i].kotitem_id,kotitem_type:'',kotitem_ref_id:'',kotitem_bill_id:itmDets[i].kotitem_bill_id,kotitem_kot_id:itmDets[i].kotitem_kot_id,kotitem_cat_id:itmDets[i].kotitem_cat_id,kotitem_itm_id:itmDets[i].kotitem_itm_id,kotitem_option_id:itmDets[i].kotitem_option_id,kotitem_itm_name:itmName,kotitem_qty:itmDets[i].kotitem_qty,kotitem_rate:itmDets[i].kotitem_rate,kotitem_totat:itmDets[i].kotitem_totat,kotitem_message:itmDets[i].kotitem_message,kotitem_status:itmDets[i].kotitem_status,kotitem_old_status:itmDets[i].kotitem_status,kotitem_sub_qty:0,kotitem_orderTagsList:itmDets[i].kotitem_orderTagsList,kotitem_batch_id:'',kotitem_unit_name:'',kotitem_extra_amount:0};
									vm.kotItems.push(obj);	
								}								
							}
							if(__env.isDebug) console.log("Items");
							if(__env.isDebug) console.log(vm.billAddons);	
							if(__env.isDebug) console.log(vm.kotItems);
							
							vm.saveFlag = 1;
							vm.existBtn = 0;
							
							var deptType = localStorage.getItem('departmentType');
							//alert(billID);
							if(deptType=="Dining"){
								$state.go('app.table');
							} else if(deptType=="Home Delivery"){
								$state.go('app.customer-selection');
							} else if(deptType=="Parcel"){
								if(vm.pageHold==1){
									$state.go('app.dining-parcel-bill', {bill_id: vm.billDet.billID});
								} else {
									if($state.current.name=="app.dining-parcel"){
				                        $state.go('app.dining-parcel2');                
				                    } else if($state.current.name=="app.dining-parcel2"){
				                        $state.go('app.dining-parcel');                 
				                    } else {
				                        $state.go('app.dining-parcel'); 
				                    }
								}
							} else if(deptType=="Online"){
								if(vm.pageHold==1){
									$state.go('app.dining-online-bill', {bill_id: vm.billDet.billID});
								} else {
									if($state.current.name=="app.dining-online"){
				                        $state.go('app.dining-online-list');                
				                    } else if($state.current.name=="app.dining-online-list"){
				                        $state.go('app.dining-online');                 
				                    } else {
				                        $state.go('app.dining-online'); 
				                    }
								}
							} 
							
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						console.error(response);
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function gotoBillDets(billID){
			var deptType = localStorage.getItem('departmentType');
			//alert(billID);
			if(deptType=="Dining"){
				$state.go('app.table');
			} else if(deptType=="Home Delivery"){
				$state.go('app.dining-homedelivery-bill', {bill_id: billID});
			} else if(deptType=="Parcel"){
				$state.go('app.dining-parcel-bill', {bill_id: billID});
			} else {
				$state.go('app.dining-online-bill', {bill_id: billID});
			}	
		}
		
		
		function closeBillasCash(){ 
			for(var i=0;i<vm.kotItems.length;i++){
				if(vm.kotItems[i].kotitem_orderTagsList.length){
					var filtered = $filter('orderBy')(vm.kotItems[i].kotitem_orderTagsList, 'kotitemtag_ordertag_id');
					vm.kotItems[i].kotitem_orderTagsList = filtered;
				}

				if(!vm.kotItems[i].kotitem_itm_id){
					//alert(vm.kotItems[i].kotitem_ordno);
					vm.kotItems.splice(i, 1);
				}
			}
			
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.billDet);
			if(__env.isDebug) console.log(vm.billDet.billDets);
			if(__env.isDebug) console.log(vm.kotItems);
			if(__env.isDebug) console.log(vm.periodID);
			//if(__env.isDebug) console.log(vm.totalQty);
			if(__env.isDebug) console.log(vm.billAddons);
			if(__env.isDebug) console.log(vm.billDet.tableID);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;
				msApi.request('app.saveBill@save', {param:{billDets:vm.billDet.billDets,kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:'Cash',printMode:'0',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						vm.billDet = response.data;
						if(vm.billDet.bill_id){
							var billID=vm.billDet.bill_id;
							$rootScope.KOTItmCount = 0;
							$mdToast.show(
								$mdToast.simple().textContent('Order Completed').position('top right')
							);
							
							var tableID = ""; var custID = "";
							if(vm.billDet.tableID){
								tableID = vm.billDet.tableID;
							}
							//alert(tableID);
							if(vm.billDet.customerID){
								custID = vm.billDet.customerID;
							}
							
							vm.billAddons = {bil_table_id:tableID, bil_cusid:custID, bil_print:"", bil_remarks:"", bil_timing:"", bil_stfid:'',billNotes:'' , bil_type:vm.deptType, bil_tottaxamt:0, bil_totextraamt:0, bil_totaltaxamt:0, bil_totalqty:0, bil_totalamt:0, bil_totalnetamt:0, bil_totaldiscount:0, bil_totaldiscountrate:'', bil_totalround:0};	
							
							//vm.billDet.billDets = "";
							vm.kotItems = [];
							
							//gotoListing();	
							//$window.open(__env.apiUrl+'startPrintBill/'+billID);
							vm.saveFlag = 1;
							vm.existBtn = 0;

							var deptType = localStorage.getItem('departmentType');
							//alert(billID);
							if(deptType=="Dining"){
								$state.go('app.table');
							}
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function closeBillasCard(){
			for(var i=0;i<vm.kotItems.length;i++){
				if(vm.kotItems[i].kotitem_orderTagsList.length){
					var filtered = $filter('orderBy')(vm.kotItems[i].kotitem_orderTagsList, 'kotitemtag_ordertag_id');
					vm.kotItems[i].kotitem_orderTagsList = filtered;
				}

				if(!vm.kotItems[i].kotitem_itm_id){
					//alert(vm.kotItems[i].kotitem_ordno);
					vm.kotItems.splice(i, 1);
				}
			}
			
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.billDet.billDets);
			if(__env.isDebug) console.log(vm.kotItems);
			if(__env.isDebug) console.log(vm.periodID);
			//if(__env.isDebug) console.log(vm.totalQty);
			if(__env.isDebug) console.log(vm.billAddons);
			//if(__env.isDebug) console.log(vm.billDet.tableID);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;	
				msApi.request('app.saveBill@save', {param:{billDets:vm.billDet.billDets,kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:'Card',printMode:'0',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						vm.billDet = response.data;
						if(vm.billDet.bill_id){
							var billID=vm.billDet.bill_id;
							$rootScope.KOTItmCount = 0;
							$mdToast.show(
								$mdToast.simple().textContent('Order Completed').position('top right')
							);
							//vm.billDet.billDets = "";
							
							var tableID = ""; var custID = "";
							if(vm.billDet.tableID){
								tableID = vm.billDet.tableID;
							}
							
							if(vm.billDet.customerID){
								custID = vm.billDet.customerID;
							}
							
							vm.billAddons = {bil_table_id:tableID, bil_cusid:custID, bil_print:"", bil_remarks:"", bil_timing:"", bil_stfid:'',billNotes:'', bil_type:vm.deptType, bil_tottaxamt:0, bil_totextraamt:0, bil_totaltaxamt:0, bil_totalqty:0, bil_totalamt:0, bil_totalnetamt:0, bil_totaldiscount:0, bil_totaldiscountrate:'', bil_totalround:0};	
							
							vm.kotItems = [];
							//gotoListing();	
							//$window.open(__env.apiUrl+'startPrintBill/'+billID);
							
							
							vm.saveFlag = 1;
							vm.existBtn = 0;
							
							var deptType = localStorage.getItem('departmentType');
							//alert(billID);
							if(deptType=="Dining"){
								$state.go('app.table');
							}
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function closeBillasOnline(type){
			if(type=="NAC"){
				if(vm.nacReason==1){
					vm.sideItms = 0;
					vm.sideNote = 0;
					vm.sideOpts = 0;	
					vm.sideCust = 0;
					vm.sideMessage = 1;
					vm.giftMessage = 0;
					vm.voidMessage = 0;
					vm.nacMessage = 1;
					vm.sideWaiter = 0;
					vm.sideOrderNo = 0;
					vm.sidePendparcel = 0;
					vm.sideRetails = 0;
					vm.sidePendRetail = 0;
					vm.sideDiscount = 0;

					vm.extraMsg = "";
				} else {
					closeBillasOnline2(type);	
				}
			} else {

				closeBillasOnline2(type);	
			}
		}
			
		function closeBillasOnline2(type){
			//alert(type);
			for(var i=0;i<vm.kotItems.length;i++){
				if(vm.kotItems[i].kotitem_orderTagsList.length){
					var filtered = $filter('orderBy')(vm.kotItems[i].kotitem_orderTagsList, 'kotitemtag_ordertag_id');
					vm.kotItems[i].kotitem_orderTagsList = filtered;
				}

				if(!vm.kotItems[i].kotitem_itm_id){
					//alert(vm.kotItems[i].kotitem_ordno);
					vm.kotItems.splice(i, 1);
				}
			}

			if(vm.extraMsg!=""){
				vm.billAddons.bil_remarks = vm.extraMsg;
			}
			
			vm.itemMenu = 0;
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.billDet.billDets);
			if(__env.isDebug) console.log(vm.kotItems);
			if(__env.isDebug) console.log(vm.periodID);
			//if(__env.isDebug) console.log(vm.totalQty);
			if(__env.isDebug) console.log(vm.billAddons);
			//if(__env.isDebug) console.log(vm.billDet.tableID);
			
			if(__env.isDebug) console.log(vm.extraSummary);
			if(__env.isDebug) console.log(vm.taxSummary);

			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;	
				msApi.request('app.saveBill@save', {param:{billDets:vm.billDet.billDets,kotItems:vm.kotItems,periodID:vm.periodID,ifNewRows:vm.ifNewRows,type:type,printMode:'0',billAddons:vm.billAddons,branchID:localStorage.getItem('BranchID'),department:vm.department,deptType:vm.deptType,UserID:localStorage.getItem('UserID'),ifCustomOrder:vm.ifCustomOrder,extraSummary:vm.extraSummary,taxSummary:vm.taxSummary},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						vm.billDet = response.data;
						if(vm.billDet.bill_id){
							var billID=vm.billDet.bill_id;
							$rootScope.KOTItmCount = 0;
							$mdToast.show(
								$mdToast.simple().textContent('Order Completed').position('top right')
							);
							//vm.billDet.billDets = "";

							if(vm.ifCustomOrder!=0){
								vm.alertList = JSON.parse($window.localStorage['customKots']);
								vm.ifCustomID = (vm.ifCustomOrder).split(",");

								if(__env.isDebug) console.log(vm.ifCustomID);

	                            for(var i=0;i<vm.alertList.length;i++){
	                            	for(var j=0;j<vm.ifCustomID.length;j++){
	                            	//if(vm.alertList[i].customerkot_id == vm.ifCustomOrder){
		                            	//alert(vm.alertList[i].customerkot_id +" == "+ vm.ifCustomID[j]);
		                            	if(vm.alertList[i].customerkot_id == vm.ifCustomID[j]){
		                            		//alert("in");
		                                	vm.alertList.splice(i, 1);	                            	
		                                }
		                            }
	                            }
	                            if(__env.isDebug) console.log("Alert New List");
	                            if(__env.isDebug) console.log(vm.alertList);
	                            if(vm.alertList.length>0){
	                                $rootScope.totalAlert = vm.alertList.length;
	                            } else {
	                            	$rootScope.totalAlert = 0;
	                            }                          
	                            
	                            $window.localStorage['customKots'] = JSON.stringify(vm.alertList);
	                            $rootScope.$emit('changeAlerts','');
							}

							var itmDets = response.data.billItmsCurrQtyDets;
							if(__env.isDebug) console.log(itmDets);
							for(var i=0;i<vm.productList.length;i++){
								for(var q=0;q<itmDets.length;q++){					
									if(vm.productList[i].catitm_category_id == itmDets[q].catitm_category_id && vm.productList[i].item_id == itmDets[q].item_id){								
										vm.productList[i].item_currqty = itmDets[q].item_currqty;
										vm.productList[i].batchList = itmDets[q].batchList;
										vm.productList[i].lastBatch = itmDets[q].lastBatch;
										vm.productList[i].showBatch = itmDets[q].showBatch;
									}
								}
							}
							if(__env.isDebug) console.log("Items List");
							if(__env.isDebug) console.log(vm.productList);
							$window.localStorage['productList'] = JSON.stringify(vm.productList);
							
							var tableID = ""; var custID = "";
							if(vm.billDet.tableID){
								tableID = vm.billDet.tableID;
							}
							
							if(vm.billDet.customerID){
								custID = vm.billDet.customerID;
							}
							 
							vm.customerName = ""; 
							vm.billAddons = {bil_table_id:tableID, bil_cusid:custID, bil_print:"", bil_remarks:"", bil_timing:"", bil_stfid:'',billNotes:'', bil_type:vm.deptType, bil_tottaxamt:0, bil_totextraamt:0, bil_totaltaxamt:0, bil_totalqty:0, bil_totalamt:0, bil_totalnetamt:0, bil_totaldiscount:0, bil_totaldiscountrate:'', bil_totalround:0};	
							
							vm.kotItems = [];
							//gotoListing();	
							vm.saveFlag = 1;
							vm.existBtn = 0;
							vm.sideOpts = 0;
							
							vm.sideItms = 1;
							vm.sideCust = 0;
			
							vm.sideMessage = 0;
							vm.giftMessage = 0;
							vm.voidMessage = 0;
							vm.nacMessage = 0;
							vm.extraMsg = "";

							var deptType = localStorage.getItem('departmentType');
							//alert(deptType);
							if(deptType=="Dining"){
								$state.go('app.table');
							} else if(deptType=="Online"){
								$state.go('app.online');
							} else if(deptType=="Retail"){
								$state.go('app.dining-retail');
							}
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function gototable(){
			localStorage.setItem('tableChange','1');
			$state.go('app.table'); 
		}
		
		function gotoListing()
        {
			//alert("1");
            //$state.go('app.table-list');
			var deptType = localStorage.getItem('departmentType');
			//alert(deptType);
			if(deptType=="Dining"){
				$state.go('app.table');
			} else if(deptType=="Home Delivery"){
				$state.go('app.customer-selection');
			} else if(deptType=="Parcel"){
				//$state.go('app.dining-parcel2');
				if($state.current.name=="app.dining-parcel2"){
                	$state.go('app.dining-parcel');                
	            } else if($state.current.name=="app.dining-parcel"){
	                $state.go('app.dining-parcel2');                 
	            } else {
	                $state.go('app.dining-parcel2'); 
	            }
			} else if(deptType=="Retail"){
				//$state.go('app.dining-retail-list');

				if($state.current.name=="dining-retail-list"){
                	$state.go('app.dining-retail');                
	            } else if($state.current.name=="app.dining-retail"){
	                $state.go('app.dining-retail-list');                 
	            } else {
	                $state.go('app.dining-retail-list'); 
	            }

			} else {
				//$state.go('app.dining-online-list');

				if($state.current.name=="app.dining-online-list"){
                	$state.go('app.dining-online');                
	            } else if($state.current.name=="app.dining-online"){
	                $state.go('app.dining-online-list');                 
	            } else {
	                $state.go('app.dining-online-list'); 
	            }
			}
        }
		
		function gotoBilling(dining_id){
			//alert(dining_id);
			$state.go('app.billing', {dining_id: dining_id});
		}

		function gotoSettle(bill_id){
			//alert(bill_id);
			$state.go('app.billing', {dining_id: bill_id});
		}
		
		
		function searchCustomer(){        	
        	if(__env.isDebug) console.log("Search Data");
			if(__env.isDebug) console.log(vm.searchCust);
        	var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
	        	msApi.request('app.homeCustDets2@save', {param:{search:vm.searchCust,type:"Recent",branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'customer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						var input = response.data;
						vm.customerList = input.customerList;	
																				
						for(var i=0;i<vm.customerList.length;i++){
							if(vm.customerList[i].customer_id == vm.custID){
								setCustomerDets(vm.customerList[i]);
							}
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
				
		function setCustomerDets(cust){
			vm.billAddons.bil_cusid = cust.customer_id;
			//alert(vm.billAddons.bil_cusid);
			vm.customerBox = 0;
			vm.customerName = cust.customer_name;
			vm.customerMobile = cust.customer_mobileno;
			vm.customerAddress = cust.customer_address;
			vm.customerRecent = cust.recentBills;
			//closeTicketNote();
		}
		
		function setWaiterDets(waiter){			
			vm.billAddons.bil_stfid = waiter.waiter_id;	
			//alert(vm.billAddons.bil_stfid);
			vm.waiterName = waiter.waiter_name;
			closeTicketNote();
		}
		
		function setPendingBill(bill){			
			$state.go('app.dining-parcel-list', {bill_id: bill.bil_id});
			closeTicketNote();
		}
		
		function gotoTicketNote(){
			vm.sideItms = 0;
			vm.sideNote = 1;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;
		}
		
		function closeTicketNote(){
			vm.sideItms = 1;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;

			if(localStorage.getItem('departmentType')=="Retail"){
				vm.sideItms = 0;
				vm.sideRetails = 1;
			}

			vm.selectedItm = '';
			vm.itemMenu = 0;				
		}

		function closeRetailBills(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 1;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;

			vm.selectedItm = '';
			vm.itemMenu = 0;				
		}

		
		function changeCustomerBox(){
			//alert('hi demo');
			if (vm.customerBox==1) {
				vm.customerBox = 0;
			} else if (vm.customerBox==0) {
				vm.customerBox = 1;
			}
		}
		function changeTimeBox(){
			//alert('hi demo');
			if (vm.customerBox==1 || vm.customerBox==0) {
				vm.customerBox = 2;
			} else if (vm.customerBox==2) {
				vm.customerBox = 0;
			}
		}
		
		function selectCustomer(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 1;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			if(vm.billAddons.bil_cusid!=""){
				vm.customerBox = 0;
			} else {
				vm.customerBox = 1;
			} 
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;
		}
		
		function selectWaiter(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 1;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;
		}

		function selectOrderID(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 1;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 0;
		}
		
		vm.pendParcelBills = [];
		function selectPendParcel(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 1;
						
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;	
				msApi.request('app.pendParcelBills@save', {param:{branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						vm.pendParcelBills = response.data.pendParcelBills;						
						for(var i=0;i<vm.pendParcelBills.length;i++){
							vm.pendParcelBills[i].pendTotal = parseFloat(vm.pendParcelBills[i].bil_totalnetamt) + parseFloat(vm.pendParcelBills[i].bil_totalround);
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}

		vm.pendRetailBills = [];
		

		function showDiscount(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 0;
			vm.sideDiscount = 1;

			$("#discountRate").focus();
			vm.discExtra = 0;
			for (var i=0;i<vm.extraSummary.length;i++) {
				//vm.extraMasterList[i].extraTotal = 0;
				if(vm.extraSummary[i].extra_inclDiscount==1 && vm.extraSummary[i].extra_total>0){
					vm.discExtra = vm.discExtra + parseFloat(vm.extraSummary[i].extra_total);
				}				
			}			
			vm.discountDets={billAmount:vm.billAddons.bil_totalamt,billExtra:vm.discExtra,billTax:vm.billAddons.bil_tottaxamt,discountRate:vm.billAddons.bil_totaldiscountrate,discountAmount:vm.billAddons.bil_totaldiscount,discountFocus:''};			
		}

		function selectPendRetail(){
			vm.sideItms = 0;
			vm.sideNote = 0;
			vm.sideOpts = 0;	
			vm.sideCust = 0;
			vm.sideMessage = 0;
			vm.giftMessage = 0;
			vm.voidMessage = 0;
			vm.nacMessage = 0;
			vm.sideWaiter = 0;
			vm.sideOrderNo = 0;
			vm.sidePendparcel = 0;
			vm.sideRetails = 0;
			vm.sidePendRetail = 1;
			vm.sideDiscount = 0;
						
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				vm.saveFlag = 0;	
				msApi.request('app.pendRetailBills@save', {param:{branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						vm.pendRetailBills = response.data.pendRetailBills;						
						for(var i=0;i<vm.pendRetailBills.length;i++){
							vm.pendRetailBills[i].pendTotal = parseFloat(vm.pendRetailBills[i].bil_totalnetamt) + parseFloat(vm.pendRetailBills[i].bil_totalround);
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		
		function addCustomer()
        {
			 //alert("Hi");
			//$state.go('app.customer.new');
			vm.listCustomer = 0;
			vm.customer = {customer_name:'', customer_branch_id:localStorage.getItem('BranchID'), customer_mobileno:'', customer_address:'', customer_status:'Active'};
        }

        function resetCustomer(){
        	vm.listCustomer = 1;
        } 
		        	
        function saveCustomer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.customer);		
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.customerSave2@save', {param:{customer:vm.customer,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'customer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						vm.input2 = response.data;
						if(vm.input2.custID!=""){
							vm.customerList = vm.input2.customerList;
							vm.custID = vm.input2.custID;
							//$window.localStorage['customerList'] = JSON.stringify(response.data.customerList);
							$window.localStorage['customerList'] = JSON.stringify(vm.customerList);							
							vm.customerList = JSON.parse($window.localStorage['customerList']);
							for(var i=0;i<vm.customerList.length;i++){
								if(vm.customerList[i].customer_id == vm.custID){
									setCustomerDets(vm.customerList[i]);
								}
							}						

							vm.listCustomer = 1;								

							$mdToast.show(
								$mdToast.simple().textContent('Customer Added Successfully').position('top right')
							);	
							
						}
											
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }	
		
		function selectTender(ev){
			$mdDialog.show({
                controller         : 'DiningController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/dining/dialog/tender-dialog/tender-dialog.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
				locals             : {
                    Billing	: Billing
                }	
            });
		}
		function closeDialog()
        {
            $mdDialog.hide();
        }
		
		
		
		
		
		
		
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.department')
        .controller('DepartmentListController', DepartmentListController);

    /** @ngInject */
    function DepartmentListController($state, DepartmentList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Department";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			//alert("In");
			vm.pageID = JSON.parse($window.localStorage['pageID']);			

			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Departments" && vm.pageID[i].status==0){
					$state.go('app.home'); 
				}			
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.department = DepartmentList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.department);
        vm.listForm={};
		
		if(vm.department.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddDepartment = gotoAddDepartment;		
		vm.gotodepartment = gotodepartment;	
		vm.editDepartment = editDepartment;
		vm.flowDepartment = flowDepartment;
		vm.deleteDepartment = deleteDepartment;
		vm.gotoLogin = gotoLogin;
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddDepartment()
        {
			 //alert("Hi");
			 $state.go('app.department.add');
        } 
		
		function editDepartment(department_id)
        {
			 //alert(department_id);
			 $state.go('app.department.edit', {department_id: department_id});
        }
		
		function flowDepartment(department_id)
        {
			 //alert(department_id);
			 $state.go('app.department.flow', {department_id: department_id});
        }
		
		function gotodepartment()
        {
			//alert("1");
            $state.go('app.department-list');
        }
				
						
		function deleteDepartment(department_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.department);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this department?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_department',param:{department_id:department_id},aToken:aToken,page:'department'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Department Deleted').position('top right')
							);
							gotodepartment();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook-report')
        .controller('DaybookReportController', DaybookReportController);

    /** @ngInject */
    function DaybookReportController(DaybookReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Daybook Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Daybook Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data   
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		    
		vm.daybookreportList = DaybookReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.daybookreportList);   
		vm.branchID = vm.daybookreportList.branchID;
		vm.accountheadList = vm.daybookreportList.accountheadList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.daybookDets = {from:vm.daybookreportList.from,to:vm.daybookreportList.to,type:'Today',accID:vm.daybookreportList.accID};
		
		vm.daybookReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printDaybooksReport = printDaybooksReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.daybookPDFExport = daybookPDFExport;
		vm.daybookCSVExport = daybookCSVExport;
		vm.changeDate = changeDate;
		
		/*alert(vm.daybookDets.type);
		var date = new Date();
		vm.daybookDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		vm.daybookDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		alert(vm.daybookDets.from+" "+vm.daybookDets.to);*/
		changeDate();
		
		/*for(var i=0;i<vm.daybookreportList.workReportBillDaybooks.length;i++){
			vm.daybookreportList.workReportBillDaybooks[i].bitm_tax = parseFloat((vm.daybookreportList.workReportBillDaybooks[i].bitm_total * vm.tax)/100);
			
			vm.daybookreportList.workReportBillDaybooks[i].bitm_taxtotal = parseFloat(vm.daybookreportList.workReportBillDaybooks[i].bitm_tax) + parseFloat(vm.daybookreportList.workReportBillDaybooks[i].bitm_total);
		}*/
		if(__env.isDebug) console.log(vm.daybookreportList.workReportBillDaybooks);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function daybookPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'daybookPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.daybookDets.mode+"|"+vm.daybookDets.from+"|"+vm.daybookDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'daybookPDFExport/'+vm.param;			 			 
        }
		
		function daybookCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'daybookPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.daybookDets.mode+"|"+vm.daybookDets.from+"|"+vm.daybookDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'daybookCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.daybook-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'daybook-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printDaybooksReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'daybook-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.daybookDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.daybookReportList2@save', {param:{daybookDets:vm.daybookDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'daybook-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.accountheadList = vm.output.accountheadList;
					vm.daybookReportList = vm.output.daybookReportList;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.daybookDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,accID:vm.output.accID};
					
					vm.totalInAmt = 0;
					vm.totalExpAmt = 0;
					for(var i=0;i<vm.daybookReportList.length;i++){
						vm.totalInAmt = vm.totalInAmt + parseFloat(vm.daybookReportList[i].inAmt);						
						vm.totalExpAmt = vm.totalExpAmt + parseFloat(vm.daybookReportList[i].expAmt);						
					}
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.daybookDets.type);	
			if(vm.daybookDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.daybookDets.from = day;
				vm.daybookDets.to = day;
				
			} else if(vm.daybookDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.daybookDets.from = day;
				vm.daybookDets.to = day;
			} else if(vm.daybookDets.type == 'This Week'){
				var date = moment();
				
				vm.daybookDets.from = date.clone().startOf('isoWeek');
				vm.daybookDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.daybookDets.type == 'This Month'){
				var date = new Date();
								
				vm.daybookDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.daybookDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.daybookDets.from+" "+vm.daybookDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.daybook')
        .controller('DaybookListController', DaybookListController);

    /** @ngInject */
    function DaybookListController($state, DaybookList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Daybook";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Daybook" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.daybookDB = DaybookList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.daybookDB);
        vm.listForm={};

        vm.daybookList = vm.daybookDB.daybookList;
        vm.periodID = localStorage.getItem('periodID');
		
		if(vm.daybookDB.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddDaybook = gotoAddDaybook;		
		vm.gotoDaybook = gotoDaybook;	
		vm.editDaybook = editDaybook;
		vm.deleteDaybook = deleteDaybook;
		vm.gotoLogin = gotoLogin;	
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddDaybook()
        {
			 //alert("Hi");
			 $state.go('app.daybook.add');
        } 
		
		function editDaybook(daybook_id)
        {
			 //alert(customer_id);
			 $state.go('app.daybook.edit', {daybook_id: daybook_id});
        }
					
		function gotoDaybook()
        {
			//alert("1");
            $state.go('app.daybook-list');
        }			
							
		function deleteDaybook(daybook_id)
        {
			//alert(tax_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this account daybook?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_daybook',param:{daybook_id:daybook_id},aToken:aToken,page:'daybook'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);									
							
							$mdToast.show(
								$mdToast.simple().textContent('Daybook Deleted').position('top right')
							);
							gotoDaybook();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(Listings, $state, $rootScope, msApi, $mdToast, $window)
    {
        var vm = this;
		
		$rootScope.pageTitle = "Dashboard";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Dashboard" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}
		
		// Data		
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		vm.listings = Listings.data;
		if(__env.isDebug) console.log("Input");
		if(__env.isDebug) console.log(vm.listings);
		vm.UserName = localStorage.getItem('UserName');
		vm.compDets = vm.listings.dbSAListings;
		if(__env.isDebug) console.log(vm.compDets);
		vm.role = localStorage.getItem('UserRole');
		vm.branch = vm.listings.branchID;
		vm.branchName = "";
		vm.selectPay = "";
		
		vm.payMode = ["Cash","Card","UPI","Paytm","Zomato","Uber","Swiggy"];
		
		for(var i=0;i<vm.listings.companyDets.length;i++){
			if(vm.listings.companyDets[i].branch_id == vm.branch){
				vm.branchName = vm.listings.companyDets[i].branch_name;
			}	
		}
		//alert(vm.branch);
		
		vm.statuslist = ['Today','This Week','This Month','This Year'];
		vm.colors = ['#f44336','#4caf50','#9c27b0','#2196f3','#009688','#cddc39','#ffc107','#795548','#607d8b','#e91e63'];
		
		
		// Methods
		vm.gotoOrderList = gotoOrderList;	
		vm.gotoReport = gotoReport;
		vm.listBillDets = listBillDets;
		vm.setType = setType;
		
		vm.others = {from:vm.listings.from,to:vm.listings.to,type:vm.listings.type};
		vm.payment = vm.listings.dbSABillsPayments;
		if(__env.isDebug) console.log(vm.payment);
		
		vm.logType = localStorage.getItem('UserType');
        //////////
		
		
		function setType(){
			//alert(vm.selectPay);
		}
		
		function gotoOrderList(pick)
        {
			//alert("Hi");
			$state.go('app.pickup-request-view', {cuspick_id: pick.cuspick_id});			
        }
		
		function gotoReport(comp){
			//$state.go('app.work-report');				
			vm.branch = comp.bil_branch_id;
			vm.branchName = comp.branch_city;
		}
		
		function listBillDets(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.others);
			/*var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.listBillDets@save', {param:{others:vm.others,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						vm.listings = response.data;
						vm.others = {from:vm.listings.from,to:vm.listings.to,type:vm.listings.type};
						vm.payment = vm.listings.dbSABillsPayments;
						if(__env.isDebug) console.log(vm.payment);
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}*/
			
			//alert(vm.others.type);
			$state.go('app.dashboard-list', {type: vm.others.type});			
		}
				 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.customer-selection',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.customer-selection', {
				url    : '/customer-selection',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/customer-selection/customer-selection.html',
						controller : 'CustomerSelectionController as vm'
					}
				},
				resolve: {					
					CustomerDets: function (msApi)
					{					
						return msApi.resolve('app.homeCustDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})
			.state('app.customer-selection-list', {
				url    : '/customer-selection',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/customer-selection/customer-selection.html',
						controller : 'CustomerSelectionController as vm'
					}
				},
				resolve: {					
					CustomerDets: function (msApi)
					{					
						return msApi.resolve('app.homeCustDets@get',{branchID:localStorage.getItem('BranchID')});
					}, 
				}
			})	
			;
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/customer-selection');
			
			// Api						
			msApiProvider.register('app.homeCustDets', ['homeCustDets']);
			msApiProvider.register('app.homeCustDets2', ['homeCustDets2']);
			msApiProvider.register('app.customerSave2', ['customerSave2']);
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('homedel', {
				title : 'Homedels',
				//icon  : 'icon-account-multiple',
				state : 'app.customer-selection',
				weight: 12
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customer-selection')
        .controller('CustomerSelectionController', CustomerSelectionController);

    /** @ngInject */
    function CustomerSelectionController($state, CustomerDets, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Home Delivery - Customer Detials";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="POS" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}
		
        // Data
        vm.customerDets = CustomerDets.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.customerDets);
        vm.search = '';
		vm.listCustomer = 1;

		vm.branchID = vm.customerDets.branchID;

		if(vm.customerDets.error == "1"){
			gotoLogin();
		}
		
		//vm.customerList = JSON.parse($window.localStorage['customerList']);
		vm.customerList = vm.customerDets.customerList;
      
        // Methods
        vm.addCustomer = addCustomer;
		vm.setCustomerDets = setCustomerDets;
		vm.gotoLogin = gotoLogin;
		vm.saveCustomer = saveCustomer;
		vm.searchCustomer = searchCustomer;
		        
        //////////
			
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function addCustomer()
        {
			 //alert("Hi");
			$state.go('app.customer.new');
			//vm.listCustomer = 0;
			//vm.customer = {customer_name:'', customer_branch_id:vm.branchID, customer_mobileno:'', customer_address:'', customer_status:'Active'};
        } 
		
        
		function setCustomerDets(cust)
        {
			localStorage.setItem('customerID',cust.customer_id);
			$state.go('app.dining-customer');
        }				

        function searchCustomer(){        	
        	if(__env.isDebug) console.log("Search Data");
			if(__env.isDebug) console.log(vm.search);
        	var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
	        	msApi.request('app.homeCustDets2@save', {param:{search:vm.search,type:"Search",branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'customer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						var input = response.data;
						vm.customerList = input.customerList;															
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		

        function saveCustomer()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.customer);		
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.customerSave2@save', {param:{customer:vm.customer,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'customer'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						var input = response.data;
						if(input.custID!=""){
							$mdToast.show(
								$mdToast.simple().textContent('Customer Added Successfully').position('top right')
							);	
							vm.listCustomer = 1;	
							vm.customerList = vm.input.customerList;
						}
											
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.customer')
        .controller('CustomerListController', CustomerListController);

    /** @ngInject */
    function CustomerListController($state, CustomerList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Customer";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Customers" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }		
		}
		
        // Data
        vm.customer = CustomerList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.customer);
        vm.listForm={};
		
		if(vm.customer.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddCustomer = gotoAddCustomer;		
		vm.gotocustomer = gotocustomer;	
		vm.editCustomer = editCustomer;
		vm.deleteCustomer = deleteCustomer;
		vm.gotoLogin = gotoLogin;
		vm.gotoPayments = gotoPayments;
		vm.toggleSidenav = toggleSidenav;
        
        //////////
		
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddCustomer()
        {
			 //alert("Hi");
			 $state.go('app.customer.add');
        } 
		
		function editCustomer(customer_id)
        {
			 //alert(customer_id);
			 $state.go('app.customer.edit', {customer_id: customer_id});
        }
		
		function gotocustomer()
        {
			//alert("1");
            $state.go('app.customer-list');
        }
		
		function gotoPayments(customer_id){
			$state.go('app.customer-payment', {customer_id: customer_id});
		}
						
		function deleteCustomer(customer_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.customer);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this customer?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_customer',param:{customer_id:customer_id},aToken:aToken,page:'customer'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Customer Deleted').position('top right')
							);
							gotocustomer();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		
		/** Nav Links **/
		
		vm.gotoBranchPage = gotoBranchPage;
		vm.gotoDepartmentPage = gotoDepartmentPage;
		vm.gotoPriceTagPage = gotoPriceTagPage;		
		vm.gotoCustomerPage = gotoCustomerPage;
		vm.gotoWaiterPage = gotoWaiterPage;
		vm.gotoStaffPage = gotoStaffPage;		
		vm.gotoSeatsPage = gotoSeatsPage;
		vm.gotoCategoryPage = gotoCategoryPage;
		vm.gotoItemPage = gotoItemPage;		
		vm.gotoPricingPage = gotoPricingPage;
		vm.gotoTaxPage = gotoTaxPage;
		vm.gotoSettingPage = gotoSettingPage;
		
		
		
		function gotoBranchPage()
        {
			//$state.go('app.customer');
        }
		
		function gotoDepartmentPage()
        {
			$state.go('app.department');
        }
		
		function gotoPriceTagPage()
        {
			$state.go('app.price-tag');
        }
				
		function gotoCustomerPage()
        {
			$state.go('app.customer');
        }
		
		function gotoWaiterPage()
        {
			$state.go('app.waiter');
        }
		
		function gotoStaffPage()
        {
			$state.go('app.staff');
        }
								
		function gotoSeatsPage()
        {
			$state.go('app.seats');
        }						
		
		function gotoCategoryPage()
        {
			$state.go('app.category');
        }
		
		function gotoItemPage()
        {
			$state.go('app.item');
        }										
		
		function gotoPricingPage()
        {
			$state.go('app.pricing');
        }
		
		function gotoTaxPage()
        {
			$state.go('app.tax');
        }
		
		function gotoSettingPage()
        {
			$state.go('app.settings');
        }
		
		
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.clear-sales')
        .controller('ClearSalesController', ClearSalesController);

    /** @ngInject */
    function ClearSalesController(ClearSalesList, $state, msApi, $window, __env, $mdToast, $rootScope, $mdDialog)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Clear Sales";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Clear Sales" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data   
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		    
		vm.clearsalesList = ClearSalesList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.clearsalesList);   
		vm.branchID = vm.clearsalesList.branchID;
		vm.modeList = vm.clearsalesList.modeList;
		vm.workperiodList = vm.clearsalesList.workperiodList;
		vm.salesDets = {periodID:vm.clearsalesList.periodID,mode:vm.clearsalesList.mode};
		
		vm.salesReportList = "";		
		vm.chkAll = '0';
		vm.blockBtn = 0;


        vm.totalAmt = 0;
        vm.totalNett = 0;
        vm.selectedTotalNett = 0;
        vm.selectPercent = '';


        // Methods
        vm.gotoLogin = gotoLogin;
        vm.gotoReport = gotoReport;
        vm.listReport = listReport;
        vm.selectAll = selectAll;
        vm.selectByPercent = selectByPercent;
        vm.updateSelectedTotal = updateSelectedTotal;
        vm.delBills = delBills;
        vm.select = select;

        function gotoLogin()
        {
            //alert("Hi");
            //$state.go('app.login');
            $mdToast.show(
                $mdToast.simple().textContent('Access Token Expired').position('top right')
            );
        }

        function selectAll(){
            //alert(vm.chkAll);
            if(vm.chkAll=='1'){
                vm.chkAll = '1';
                for(var i=0;i<vm.salesReportList.length;i++){
                    vm.salesReportList[i].bil_checked = '1';
                }
            } else if(vm.chkAll=='0'){
                vm.chkAll = '0';
                for(var i=0;i<vm.salesReportList.length;i++){
                    vm.salesReportList[i].bil_checked = '0';
                }
            }
            updateSelectedTotal();
        }

        function select(itm){
            updateSelectedTotal();
        }

        function selectByPercent(){
            var percent = parseFloat(vm.selectPercent);
            if(isNaN(percent) || percent < 0){
                percent = 0;
            }
            if(percent > 100){
                percent = 100;
            }
            if(!vm.salesReportList || vm.salesReportList.length === 0){
                vm.selectedTotalNett = 0;
                return;
            }

            for(var i=0;i<vm.salesReportList.length;i++){
                vm.salesReportList[i].bil_checked = '0';
            }
            vm.chkAll = '0';

            var target = (vm.totalNett * percent) / 100;
            var running = 0;
            for(var j=0;j<vm.salesReportList.length;j++){
                if (vm.salesReportList[j].bil_paymenttype.trim().toLowerCase()=="cash"){

                    
                    var rowAmount = parseFloat(vm.salesReportList[j].bil_totalnetamt);
                    if(isNaN(rowAmount) ){
                        rowAmount = 0;
                    }

                    var nextTotal = running + rowAmount;
                    if(nextTotal < target){
                        vm.salesReportList[j].bil_checked = '1';
                        running = nextTotal;
                        continue;
                    }

                    if(Math.abs(nextTotal - target) <= Math.abs(running - target)){
                        vm.salesReportList[j].bil_checked = '1';
                        running = nextTotal;
                    }
                    break;
                }
            }

            updateSelectedTotal();
        }

        function updateSelectedTotal(){
            vm.selectedTotalNett = 0;
            vm.chkAll = '1';

            if(!vm.salesReportList || vm.salesReportList.length === 0){
                vm.chkAll = '0';
                return;
            }

            for(var i=0;i<vm.salesReportList.length;i++){
                if(vm.salesReportList[i].bil_checked == 1 || vm.salesReportList[i].bil_checked == '1'){
                    var rowAmount = parseFloat(vm.salesReportList[i].bil_totalnetamt);
                    if(isNaN(rowAmount)){
                        rowAmount = 0;
                    }
                    vm.selectedTotalNett = vm.selectedTotalNett + rowAmount;
                } else {
                    vm.chkAll = '0';
                }
            }

            if(isNaN(vm.selectedTotalNett)){
                vm.selectedTotalNett = 0;
            }
        }

        function gotoReport()
        {
            //alert("1");
            $state.go('app.clear-sales-list');
        }

        function delBills(){
        	var confirm = $mdDialog.confirm()
				.title('Do you want to delete these selected bills.?')
				.htmlContent('If you want to delete selected bills. Once you delete this bill(s) unable roll back those bills again.')
				.ariaLabel('Delete Bills')
				.targetEvent()
				.ok('Delete Now')
				.cancel('No');
			$mdDialog.show(confirm).then(function ()
			{
				//alert("IF ");					               
				console.log(vm.salesReportList);
        	
				var aToken=localStorage.getItem('UserATK');
				msApi.request('app.delBillDets@save', {param:{salesReportList:vm.salesReportList,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'clear-sales'},
					// SUCCESS
					function (response){		
						//alert("IF");													
						console.log(response.data);
						if(response.data){
							$mdToast.show(
								$mdToast.simple().textContent('Bills Deleted Successfully').position('top right')
							);

							listReport();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);

			}, function ()
			{
			   	//alert("Else");	
			});	
        }
				
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.salesDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.clearSalesList2@save', {param:{salesDets:vm.salesDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'clear-sales'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.salesReportList = vm.output.dbBillsList;
					vm.periodID = vm.output.periodID;
					vm.mode = vm.output.mode;
					
					vm.salesDets = {periodID:vm.output.periodID,mode:vm.output.mode};
					vm.chkAll = '0';
					vm.blockBtn = 0;
		

                    vm.totalAmt = 0;
                    vm.totalNett = 0;
                    vm.selectedTotalNett = 0;
                    for(var i=0;i<vm.salesReportList.length;i++){
                        vm.salesReportList[i].bil_checked = '0';                        
                        vm.totalAmt = vm.totalAmt + parseFloat(vm.salesReportList[i].bil_totalamt);
                        vm.totalNett = vm.totalNett + parseFloat(vm.salesReportList[i].bil_totalnetamt);
                    }
                    updateSelectedTotal();
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}					
				
    }
})();






(function ()
{
    'use strict';

    angular
        .module('app.category-report')
        .controller('CategoryReportController', CategoryReportController);

    /** @ngInject */
    function CategoryReportController(CategoryReportList, $state, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Category wise Sales Report";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Category Report" && vm.pageID[i].status==0){ 
					$state.go('app.home'); 
				}
			}	
		}

		vm.wprptBlock=0; vm.salrptBlock=0; vm.verrptBlock=0; 
		vm.usrrptBlock=0;  vm.catrptBlock=0;  vm.itmstkrptBlock=0;
		vm.stkuprptBlock=0;  vm.itmreorptBlock=0;  vm.itmrptBlock=0;
		vm.dayrptBlock=0; vm.shexprptBlock=0; vm.varrptBlock=0; 
		vm.waitsalesrptBlock=0; vm.purchaserptBlock=0; vm.salexpBlock=0; vm.saltaxBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);				
			if(vm.page["wprptBlock"]==1){ vm.wprptBlock=1; }
			if(vm.page["salrptBlock"]==1){ vm.salrptBlock=1; }
			if(vm.page["verrptBlock"]==1){ vm.verrptBlock=1; }

			if(vm.page["usrrptBlock"]==1){ vm.usrrptBlock=1; }
			if(vm.page["catrptBlock"]==1){ vm.catrptBlock=1; }
			if(vm.page["itmstkrptBlock"]==1){ vm.itmstkrptBlock=1; }
			if(vm.page["stkuprptBlock"]==1){ vm.stkuprptBlock=1; }
			if(vm.page["itmreorptBlock"]==1){ vm.itmreorptBlock=1; }
			if(vm.page["itmrptBlock"]==1){ vm.itmrptBlock=1; }
			if(vm.page["dayrptBlock"]==1){ vm.dayrptBlock=1; }
			if(vm.page["shexprptBlock"]==1){ vm.shexprptBlock=1; }

			if(vm.page["varrptBlock"]==1){ vm.varrptBlock=1; }
			if(vm.page["waitsalesrptBlock"]==1){ vm.waitsalesrptBlock=1; }
			if(vm.page["purchaserptBlock"]==1){ vm.purchaserptBlock=1; }
			if(vm.page["salexpBlock"]==1){ vm.salexpBlock=1; }
			if(vm.page["saltaxBlock"]==1){ vm.saltaxBlock=1; }
		}
		
        // Data      
		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		 
		vm.categoryreportList = CategoryReportList.data;
		if(__env.isDebug) console.log("List");                
		if(__env.isDebug) console.log(vm.categoryreportList);   
		vm.branchID = vm.categoryreportList.branchID;
		vm.categoryList = vm.categoryreportList.categoryList;
		
		vm.dateList = ['Today','Yesterday','This Week','This Month'];		
		vm.categoryDets = {from:vm.categoryreportList.from,to:vm.categoryreportList.to,type:'Today',catID:vm.categoryreportList.catID};
		
		vm.categoryReportList = "";
		vm.totalAmt = 0;
		vm.totalTax = 0;
		vm.totalNet = 0;
		vm.periodIDs = "";

		
       	// Methods
        vm.gotoLogin = gotoLogin;	
		vm.printReport = printReport;
		vm.printItemsReport = printItemsReport;		
		vm.gotoReport = gotoReport;
		vm.listReport = listReport;
		
		vm.categoryPDFExport = categoryPDFExport;
		vm.categoryCSVExport = categoryCSVExport;
		vm.changeDate = changeDate;
		
		/*alert(vm.categoryDets.type);
		var date = new Date();
		vm.categoryDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		vm.categoryDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
		alert(vm.categoryDets.from+" "+vm.categoryDets.to);*/
		changeDate();
		
		/*for(var i=0;i<vm.categoryreportList.workReportBillItems.length;i++){
			vm.categoryreportList.workReportBillItems[i].bitm_tax = parseFloat((vm.categoryreportList.workReportBillItems[i].bitm_total * vm.tax)/100);
			
			vm.categoryreportList.workReportBillItems[i].bitm_taxtotal = parseFloat(vm.categoryreportList.workReportBillItems[i].bitm_tax) + parseFloat(vm.categoryreportList.workReportBillItems[i].bitm_total);
		}*/
		if(__env.isDebug) console.log(vm.categoryreportList.workReportBillItems);
		
        //////////
		
		function printWebUSB(data){
			if(__env.isDebug) console.log("In Dining PrintWebUSB");        		
			document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
		}
		
		function categoryPDFExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'categoryPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.categoryDets.mode+"|"+vm.categoryDets.from+"|"+vm.categoryDets.to;

			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'categoryPDFExport/'+vm.param;			 			 
        }
		
		function categoryCSVExport()
        {
			 //alert("Hi");			 
			 //alert(__env.apiUrl+'categoryPDFExport/'+vm.branchID);
			 vm.param = vm.branchID+"|"+vm.categoryDets.mode+"|"+vm.categoryDets.from+"|"+vm.categoryDets.to;
			 //alert(vm.param);
			 $window.location.href = __env.apiUrl+'categoryCSVExport/'+vm.param;			 			 
        }
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }		
		
		function gotoReport()
        {
			//alert("1");
            $state.go('app.category-report-list');
        }
		
		function printReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printWPReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'category-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
		
		function printItemsReport(){
			//$window.open(__env.apiUrl+'printWPReport/'+vm.branchID);	
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branchID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.printItmsReport5@save', {param:{branchID:vm.branchID},aToken:aToken,page:'category-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Report Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);						
						
						//alert(response.data);
						if(response.data){
							var prndata=response.prndata;							
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								if(__env.isUSB) printWebUSB(prndata);
							}							
							gotoReport();
						}										
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		}
        					
		
		//listReport();
		function listReport(){
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.categoryDets);
			
			var aToken=localStorage.getItem('UserATK');
			msApi.request('app.categoryReportList2@save', {param:{categoryDets:vm.categoryDets,branchID:localStorage.getItem('BranchID')},aToken:aToken,page:'category-report'},
				// SUCCESS
				function (response){		
					//alert("IF");							
					if(__env.isDebug) console.log("Report Success @ Print Bill");
					if(__env.isDebug) console.log(response.data);						
					
					vm.output = response.data;
					//alert(response.data);
					vm.branchID = vm.output.branchID;
					vm.categoryList = vm.output.categoryList;
					vm.categoryReportList = vm.output.workReportBillCats;
					vm.periodIDs = vm.output.workPeriodIDs;
					
					vm.categoryDets = {from:vm.output.from,to:vm.output.to,type:vm.output.type,catID:vm.output.catID};
					
					vm.totalAmt = 0;
					for(var i=0;i<vm.categoryReportList.length;i++){
						vm.totalAmt = vm.totalAmt + parseFloat(vm.categoryReportList[i].kotitem_totat);						
					}
														
				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					console.error(response.data);
				}
			);
		}
		
		
		function changeDate(){
			//alert(vm.categoryDets.type);	
			if(vm.categoryDets.type == 'Today'){
				var date = new Date();
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
				vm.categoryDets.from = day;
				vm.categoryDets.to = day;
				
			} else if(vm.categoryDets.type == 'Yesterday'){
				var date = new Date();	
				var day = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate()-1)).slice(-2);
				
				vm.categoryDets.from = day;
				vm.categoryDets.to = day;
			} else if(vm.categoryDets.type == 'This Week'){
				var date = moment();
				
				vm.categoryDets.from = date.clone().startOf('isoWeek');
				vm.categoryDets.to = date.clone().endOf('isoWeek');
				
			} else if(vm.categoryDets.type == 'This Month'){
				var date = new Date();
								
				vm.categoryDets.from = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + '1').slice(-2);
				vm.categoryDets.to = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
			}
			//alert(vm.categoryDets.from+" "+vm.categoryDets.to);	
			listReport();
		}
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.category')
        .controller('CategorysListController', CategorysListController);

    /** @ngInject */
    function CategorysListController($state, CategorysList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Category Pools";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Category Pools" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.category = CategorysList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.category);
        vm.listForm={};
		vm.chkAll = 0;
		
		vm.branchID = vm.category.branchID;
		//alert(vm.branchID);
		
		if(vm.category.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddCategorys = gotoAddCategorys;		
		vm.gotoCategorys = gotoCategorys;	
		vm.editCategorys = editCategorys;
		vm.deleteCategorys = deleteCategorys;
		vm.gotoLogin = gotoLogin;	
		vm.setItems = setItems;
		vm.selectAll = selectAll;
		vm.saveCategorys = saveCategorys;
        
        //////////
		
		function selectAll(){
			//alert(vm.chkAll);
			if(vm.chkAll==0){
				vm.chkAll = 1;	
				for(var i=0;i<vm.category.categoryList.length;i++){
					vm.category.categoryList[i].categorylist_selected = 1;
				}
			} else if(vm.chkAll==1){
				vm.chkAll = 0;	
				for(var i=0;i<vm.category.categoryList.length;i++){
					vm.category.categoryList[i].categorylist_selected = 0;
				}
			}	
		}
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddCategorys()
        {
			 //alert("Hi");
			 $state.go('app.category.add');
        } 
		
		function editCategorys(categorylist_id)
        {
			 //alert(customer_id);
			 $state.go('app.category.edit', {categorylist_id: categorylist_id});
        }
		
		function gotoCategorys()
        {
			//alert("1");
            $state.go('app.category-list');
        }
		
		function setItems(catID){
			//alert(catID);
			$state.go('app.category.items', {categorylist_id: catID});
		}
							
		function deleteCategorys(categorylist)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(categorylist);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			//alert(categorylist.categorylist_id);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				if(itemlist.itemlist_branchs>0){
					var msg="This category already selected for "+categorylist.categorylist_branchs+" branchs. Do you delete this category?";	
				} else {
					var msg="Do you delete this category?";	
				}		
				var r = confirm(msg);
				if (r == true) {
					msApi.request('app.categoryDel@save', {mode:'delete',table:'tbl_categorylist',param:{categorylist_id:categorylist.categorylist_id},aToken:aToken,page:'category'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Category Deleted').position('top right')
							);
							gotoCategorys();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
		
		function saveCategorys(categorylist_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.category.categoryList);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.saveCategorys@save', {param:{categoryList:vm.category.categoryList,branchID:vm.branchID},aToken:aToken,page:'category'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						$mdToast.show(
							$mdToast.simple().textContent('Category Saved').position('top right')
						);
						gotoCategorys();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.branch')
        .controller('BranchsListController', BranchsListController);

    /** @ngInject */
    function BranchsListController($state, BranchsList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Branchs";
		
        // Data
        vm.branch = BranchsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.branch);
        vm.listForm={};
		
		if(vm.branch.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddBranchs = gotoAddBranchs;		
		vm.gotoBranchs = gotoBranchs;	
		vm.editBranchs = editBranchs;
		vm.deleteBranchs = deleteBranchs;
		vm.gotoLogin = gotoLogin;			
        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddBranchs()
        {
			 //alert("Hi");
			 $state.go('app.branch.add');
        } 
		
		function editBranchs(branch_id)
        {
			 //alert(customer_id);
			 $state.go('app.branch.edit', {branch_id: branch_id});
        }
		
		function gotoBranchs()
        {
			//alert("1");
            $state.go('app.branch-list');
        }
				
							
		function deleteBranchs(branch_id)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.branch);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this branch?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_branch',param:{branch_id:branch_id},aToken:aToken,page:'branch'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Branch Deleted').position('top right')
							);
							gotoBranchs();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.bills',
            [
                // 3rd Party Dependencies
                
                'datatables',

            ]
        )
        .config(config);

       /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, __env)
    {

        //alert(localStorage.getItem('Admission Page'));		
		//if(localStorage.getItem('Staff Page')==1){
			//alert('2');
			$stateProvider
			.state('app.bills', {
				url    : '/bills',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/bills/bills.html',
						controller : 'BillsListController as vm'
					}
				},
				resolve: {					
					BillsList: function (msApi)
					{					
						return msApi.resolve('app.billsList@get',{branchID:localStorage.getItem('BranchID'),start:0,limit: __env.billCount,periodID:localStorage.getItem('periodID')});					
					}, 
				}
			})
			.state('app.bills-list', {
				url    : '/bills',
				views  : {
					'content@app': {
						templateUrl: 'app/main/apps/bills/bills.html',
						controller : 'BillsListController as vm'
					}
				},
				resolve: {					
					BillsList: function (msApi)
					{					
						return msApi.resolve('app.billsList@get',{branchID:localStorage.getItem('BranchID'),start:0,limit: __env.billCount,periodID:localStorage.getItem('periodID')});
					}, 
				}
			});
	
			// Translation
	        $translatePartialLoaderProvider.addPart('app/main/apps/bills');
			
			// Api						
			msApiProvider.register('app.billsList', ['billsList']);
			msApiProvider.register('app.billsList2', ['billsList2']);
			msApiProvider.register('app.cancelBill', ['cancelBill']);
			msApiProvider.register('app.changeTender', ['changeTender']);			
						
			
	
			// Navigation
			/*msNavigationServiceProvider.saveItem('bills', {
				title : 'Bills',
				//icon  : 'icon-account-multiple',
				state : 'app.bills',
				weight: 19
			});*/		
		//}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.bills')
        .controller('BillsListController', BillsListController);

    /** @ngInject */
    function BillsListController($state, BillsList, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope, $cookies, $mdDialog)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Bills";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Bills" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}
		
		
        // Data
        vm.bills = BillsList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.bills);

		vm.companyDets = JSON.parse($window.localStorage['companyDets']);		
		if(__env.isDebug) console.log(vm.companyDets);
		vm.roundofrate = (vm.companyDets[0]['branch_roundofrate'])/100;

		vm.payMode = "";
		vm.billCancel = 0;
		vm.showSummary = 0;


		vm.taxTotal = 0;
		vm.extraTotal = 0;
		vm.paymentTotal = 0;

		vm.seletedReason = '';
		vm.limit =  __env.billCount;
		//alert(vm.limit);

		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
		vm.branchID = vm.bills.branchID;
		vm.periodID = localStorage.getItem('periodID');
		vm.role = localStorage.getItem('UserRole');
		vm.billList2 = vm.bills.billsList;
		vm.reasonsList = vm.bills.billsReason;
		vm.billsCount2 = vm.bills.billsCount;
        vm.listForm={};

        vm.departmentList = JSON.parse($window.localStorage['departmentList']);
        vm.roleDeptList = JSON.parse($window.localStorage['roleDeptList']);
        vm.roleDept = [];
        for(var i=0;i<vm.roleDeptList.length;i++){
        	if(vm.roleDeptList[i].status==1){
        		vm.roleDept.push(vm.roleDeptList[i].dept_id);
        	}
        }
        if(__env.isDebug) console.log(vm.roleDept);

        vm.billList = [];
        for(var i=0;i<vm.billList2.length;i++){
        	if(vm.roleDept.indexOf(vm.billList2[i].bil_dept_id)!=-1){
        		vm.billList.push(vm.billList2[i]);
        	}
        }
        if(__env.isDebug) console.log(vm.billList);
        vm.billsCount = vm.billList.length;

        for(var i=0;i<vm.billList.length;i++){
        	
			//vm.billList[i].billTotal = Math.round(parseFloat(vm.billList[i].bil_totalamt) + parseFloat(vm.billList[i].bil_totalround) + parseFloat(vm.billList[i].bil_tottaxamt) - parseFloat(vm.billList[i].bil_discountamt) - parseFloat(vm.billList[i].bil_round));
			if (parseFloat(vm.roundofrate)==0.00){
				vm.billList[i].billTotal = parseFloat(vm.billList[i].bil_totalnetamt) + parseFloat(vm.billList[i].bil_totalround);
				vm.billList[i].discTotal = parseFloat(vm.billList[i].bil_discountamt) + parseFloat(vm.billList[i].bil_round);	
			}else{
				vm.billList[i].billTotal = Math.round(parseFloat(vm.billList[i].bil_totalnetamt) + parseFloat(vm.billList[i].bil_totalround));
				vm.billList[i].discTotal = Math.round(parseFloat(vm.billList[i].bil_discountamt) + parseFloat(vm.billList[i].bil_round));
			}
		}


		vm.seletedBill = 0;
		if(isNaN(BillsList.seletedBill)==false){
			vm.seletedBill = BillsList.seletedBill;

			for(var i=0;i<vm.billList.length;i++){
				if(vm.billList[i].bil_id == vm.seletedBill){
					selectBill(vm.billList[i]);
				}			
			}
		}
		

        /*vm.ifStaffCancell = 0;
        if(vm.role=="Admin"){
        	vm.ifStaffCancell = 1;
        } else if(vm.role=="Staff"){
        	if(vm.companyDets[0]['branch_staff_cancell']==1){
        		vm.ifStaffCancell = 1;
        	} else {
        		vm.ifStaffCancell = 0;
        	}
        }*/
        if(vm.companyDets[0]['branch_staff_cancell']==1){
        	vm.ifStaffCancell = 1;
        } else {
        	vm.ifStaffCancell = 0;
        }
        //alert(vm.ifStaffCancell);
		
		/*if(vm.bills.error == "1"){
			gotoLogin();
		} */
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
		vm.gotoLogin = gotoLogin;
        vm.selectBill = selectBill;		
		vm.selectReason = selectReason;				
		vm.cancelBills = cancelBills;
		vm.changeTender = changeTender;
		vm.changeTender2 = changeTender2;
		vm.billSummary = billSummary;
		vm.loadMore = loadMore;
		vm.gotoBill = gotoBill;
		vm.printTicket = printTicket;
		vm.changeTender = changeTender;
		vm.openClassesDialog = openClassesDialog;
		vm.closeDialog = closeDialog;
		        
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
		 
		function loadMore(){
			if(__env.isDebug) console.log("Save Data");			
			vm.start = vm.billList.length;
			
			//alert(vm.start+" "+vm.limit+" "+vm.periodID);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.billsList2@save', {param:{start:vm.start,limit:vm.limit,branchID:vm.branchID,periodID:vm.periodID,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'bills'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);	
						//vm.billList.push(response.data);
						vm.billList2=vm.billList.concat(response.data.billsList);
						vm.billsCount2 = response.data.billsCount;

						vm.billList = [];
				        for(var i=0;i<vm.billList2.length;i++){
				        	if(vm.roleDept.indexOf(vm.billList2[i].bil_dept_id)!=-1){
				        		vm.billList.push(vm.billList2[i]);
				        	}
				        }
				        if(__env.isDebug) console.log(vm.billList);
				        vm.billsCount = vm.billList.length;

				        for(var i=0;i<vm.billList.length;i++){
							if (parseFloat(vm.roundofrate)==0.00){
								vm.billList[i].billTotal = (parseFloat(vm.billList[i].bil_totalnetamt) + parseFloat(vm.billList[i].bil_totalround));
								vm.billList[i].discTotal = (parseFloat(vm.billList[i].bil_discountamt) + parseFloat(vm.billList[i].bil_round));
							}
							else{
								vm.billList[i].billTotal = Math.round(parseFloat(vm.billList[i].bil_totalnetamt) + parseFloat(vm.billList[i].bil_totalround));
								vm.billList[i].discTotal = Math.round(parseFloat(vm.billList[i].bil_discountamt) + parseFloat(vm.billList[i].bil_round));

							}
							
						}

						if(__env.isDebug) console.log(vm.billList);
						if(__env.isDebug) console.log(vm.billsCount);
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
		} 
        function selectBill(bill)
        {
			vm.seletedBill = bill.bil_id;
			vm.deptID = bill.bil_dept_id;
			//alert(vm.seletedBill);

			vm.billCancel = 0;
			for(var i=0;i<vm.departmentList.length;i++){
				if(vm.departmentList[i].department_id == vm.deptID){
					vm.payMode = (vm.departmentList[i].deptPayMode).split(",");				
				}
			}
			if(__env.isDebug) console.log(vm.payMode);

			vm.taxTotal = 0;
			vm.extraTotal = 0;
			vm.paymentTotal = 0;

			for(var i=0;i<vm.billList.length;i++){
				if(vm.billList[i].bil_id==vm.seletedBill){
					vm.taxList=vm.billList[i].billTaxList;
					for(var t=0;t<vm.taxList.length;t++){
						if(vm.taxList[t].tax_amt>0){
							vm.taxTotal = vm.taxTotal + parseFloat(vm.taxList[t].tax_amt);	
						} else {
							vm.taxTotal = vm.taxTotal + parseFloat(vm.taxList[t].tax_amt2);	
						}											
					}

					vm.extraList=vm.billList[i].billExtraList;
					for(var t=0;t<vm.extraList.length;t++){
						vm.extraTotal = vm.extraTotal + parseFloat(vm.extraList[t].extra_amt);																	
					}

					vm.paymentList=vm.billList[i].billPaymentList;
					for(var t=0;t<vm.paymentList.length;t++){
						vm.paymentTotal = vm.paymentTotal + parseFloat(vm.paymentList[t].bill_amount);																	
					}
				}
			}
        } 
		
		function selectReason(param)
        {
			 vm.seletedReason = param;
        } 
		
		function gotobills(){
			//$state.go('app.bills-list');	

			if($state.current.name=="app.bills"){
                $state.go('app.bills-list');                
            } else if($state.current.name=="app.bills-list"){
                $state.go('app.bills');                 
            } else {
                $state.go('app.bills'); 
            }
		}
		
						
		function cancelBills(reason)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.seletedBill);
			vm.seletedReason=reason;
			if(__env.isDebug) console.log(vm.seletedReason);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you want to cancel this bills?");
				if (r == true) {
					msApi.request('app.cancelBill@save', {param:{seletedBill:vm.seletedBill,seletedReason:vm.seletedReason,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'bills'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Bill Cancelled').position('top right')
							);
							gotobills();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }

        function changeTender2(mode)
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.seletedBill);
			vm.seletedMode=mode;
			if(__env.isDebug) console.log(vm.seletedMode);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you want to change tender of this bill?");
				if (r == true) {
					msApi.request('app.changeTender@save', {param:{seletedBill:vm.seletedBill,seletedMode:vm.seletedMode,UserID:localStorage.getItem('UserID')},aToken:aToken,page:'bills'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);		
							$mdToast.show(
								$mdToast.simple().textContent('Bill Tender Changed').position('top right')
							);
							vm.billCancel = 0;
							closeDialog();
							gotobills();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function gotoBill(bill){
			if(__env.isDebug) console.log("Bill Dets");
			if(__env.isDebug) console.log(bill);

			var deptType = bill.bil_type;			
			var billID =  bill.bil_id;
			//alert(deptType+" "+billID);
			localStorage.setItem('departmentType',deptType);
			localStorage.setItem('departmentID',bill.bil_dept_id);
			if(deptType=="Dining"){
				$state.go('app.dining-dining-bill', {bill_id: billID});
			} else if(deptType=="Home Delivery"){
				$state.go('app.dining-homedelivery-bill', {bill_id: billID});
			} else if(deptType=="Parcel"){
				$state.go('app.dining-parcel-bill', {bill_id: billID});
			} else if(deptType=="Retail"){
				$state.go('app.dining-retail-bill', {bill_id: billID});
			} else {
				$state.go('app.dining-online-bill', {bill_id: billID});
			}	


			vm.deptItems = "";
			vm.departmentList = JSON.parse($window.localStorage['departmentList']);
			for(var d=0;d<vm.departmentList.length;d++){
				if(vm.departmentList[d].department_id == bill.bil_dept_id){
					vm.deptItems = vm.departmentList[d].deptItems;
				}
			}
			
            vm.categoryList = JSON.parse($window.localStorage['categoryList']);
            vm.productList = JSON.parse($window.localStorage['productList']);

            for(var i=0;i<vm.categoryList.length;i++){
                vm.categoryList[i].deptShow = 0;
                if(vm.deptItems.length > 0){
                    for(var d=0;d<vm.deptItems.length;d++){
                        if(vm.deptItems[d].dept_map_category_id==0){
                            vm.categoryList[i].deptShow = 1;
                        } else {
                            if(vm.deptItems[d].dept_map_category_id == vm.categoryList[i].category_id){
                                vm.categoryList[i].deptShow = 1;
                            }   
                        }
                    }
                }
            }

            for(var i=0;i<vm.productList.length;i++){                               
                vm.productList[i].deptShow = 0;
                if(vm.deptItems.length > 0){
                    for(var d=0;d<vm.deptItems.length;d++){
                        if(vm.deptItems[d].dept_map_category_id==0 && vm.deptItems[d].dept_map_item_id==0){
                            vm.productList[i].deptShow = 1;
                        } else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id==0){
                            vm.productList[i].deptShow = 1;                             
                        } else if(vm.deptItems[d].dept_map_category_id!=0 && vm.deptItems[d].dept_map_category_id == vm.productList[i].catitm_category_id && vm.deptItems[d].dept_map_item_id!=0){
                            if(vm.deptItems[d].dept_map_item_id == vm.productList[i].item_id){
                                vm.productList[i].deptShow = 1;                             
                            }
                        }   
                    }
                }
            }

            $window.localStorage['categoryList'] = JSON.stringify(vm.categoryList);
            $window.localStorage['productList'] = JSON.stringify(vm.productList);	
		}
String.fromHtmlEntities = function(string) {
    return (string+"").replace(/&#\d+;/gm,function(s) {
        return String.fromCharCode(s.match(/\d+/gm)[0]);
    })
};
		function printTicket(billID)
        {
			//var billID = vm.paymentDet.bil_id;
			//alert(billID);
			//$window.open(__env.apiUrl+'printTicket/'+billID);
			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(billID);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				msApi.request('app.reprintTicket@save', {param:{billID:billID},aToken:aToken,page:'work-report'},
					// SUCCESS
					function (response){		
						//alert("IF");							
						if(__env.isDebug) console.log("Dining Success @ Print Bill");
						if(__env.isDebug) console.log(response.data);
						//printWebUSB("@@EaSiddique Kabab Centre - Head\n");
						vm.billDet = response.data;
						//alert(response.data);
						if(vm.billDet.billID){							
							
							var billID=vm.billDet.billID;							
							var prndata=vm.billDet.prndata;
							
							//alert(prndata);
							if (prndata){
								//if(__env.isDebug) console.log(prndata);
								//if(__env.isDebug) console.log("==========================");
								if(__env.isDebug) console.log(String.fromHtmlEntities(prndata));

								
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);									

									var printers="";
									var printerIP=$cookies.get("localPrinterIP");	
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										//findPrinter(inp[2],printerIP);
										printers=inp[2];

										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){												
											//findPrinter(vm.printer,printerIP);					
											printers=vm.printer;				
										} else {
											//findPrinter(inp[2],printerIP);
											printers=inp[2];
										}
									}
									//alert(printers);
									if(__env.isDebug) console.log(printers);

									//var config = qz.configs.create(printers, { encoding: 'ISO-8859-1' }); 
									//var config = { encoding: 'ISO-8859-1' };
									var config = "";
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									//status=printData(config, data);
									status=printData(data,printers,config,printerIP);
									if(__env.isDebug) console.log("Print Status => ".status);
								}
							}																					 
						}									
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		
		function changeTender(){
			if (vm.billCancel==1 || vm.billCancel==2) {
				vm.billCancel = 0;
			} else {
				vm.billCancel = 1;
			}
		}

		function billSummary(){
			if (vm.showSummary==1) {
				vm.showSummary = 0;
			} else {
				vm.showSummary = 1;
			}
		}
		
		function openClassesDialog(ev)
        {
        	BillsList.seletedBill =  vm.seletedBill;
            $mdDialog.show({
                controller         : 'BillsListController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/bills/dialogs/dialogs.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    BillsList	: BillsList
                }                
            });
        }

		function closeDialog()
        {
            $mdDialog.hide();
        }
		
								
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.billing')
        .controller('BillingListController', BillingListController);

    /** @ngInject */
    function BillingListController($state, BillingList, msApi, $mdSidenav, $window, __env, $mdToast, $rootScope, $cookies)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Billing";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="POS" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}
		
		
        // Data

		vm.c_s=localStorage.getItem('Currency_Sign');
		vm.c_d=localStorage.getItem('Currency_Decimals');
		
        vm.billing = BillingList;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.billing);
		vm.billDet = vm.billing.billDets;
		vm.billItmsDets = vm.billing.billItmsDets;
		vm.inputValue = '';
		vm.balance = 0;
		vm.paymentList = [];

		vm.departmentList = JSON.parse($window.localStorage['departmentList']);
		
		vm.billGross = parseFloat(vm.billDet.bil_totalamt);
		vm.billPaid = parseFloat(vm.billDet.bil_paidamt);
		vm.billNett = parseFloat(vm.billDet.bil_totalnetamt);
		vm.billRound = parseFloat(vm.billDet.bil_totalround);
		vm.billPay = parseFloat(vm.billDet.bil_totalnetamt)+parseFloat(vm.billDet.bil_totalround)-parseFloat(vm.billDet.bil_paidamt);
		vm.billTax = parseFloat(vm.billDet.bil_tottaxamt);
		vm.billExtra = parseFloat(vm.billDet.bil_totextraamt);
		
		vm.discountAmt = 0;
		if(vm.billDet.bil_discountamt){
			vm.discountAmt = parseFloat(vm.billDet.bil_discountamt);
		}
		
		vm.roundAmt = 0;
		if(vm.billDet.bil_round){
			vm.roundAmt = parseFloat(vm.billDet.bil_round);
		}
		
		vm.billNett = vm.billGross + vm.billRound + vm.billExtra + vm.billTax - vm.discountAmt - vm.roundAmt;

		vm.billPay = vm.billNett - vm.billPaid;

		vm.payment = {billAmt : vm.billGross, billExtra : vm.billExtra, taxAmt : vm.billTax, discountAmt : vm.discountAmt, roundAmt : vm.roundAmt, nettAmt : vm.billNett, payableAmt : vm.billPay, paidAmt : vm.billPaid};
		if(__env.isDebug) console.log(vm.payment);

		vm.payMode = "";
		for(var i=0;i<vm.departmentList.length;i++){
			if(vm.departmentList[i].department_id == vm.billDet.bil_dept_id){
				vm.payMode = (vm.departmentList[i].deptPayMode).split(",");				
			}
		}
		if(__env.isDebug) console.log(vm.payMode);	
		
		
        // Methods
        vm.gotoLogin = gotoLogin;
		vm.setPayable = setPayable;						
		
		//vm.gotoPayments = gotoPayments;
		vm.setSplitPayable = setSplitPayable;
		vm.sumPayable = sumPayable;
		vm.clearPayable = clearPayable;
		vm.closeBilling = closeBilling;
		vm.completeBill = completeBill;
		vm.completeBill2 = completeBill2;
		vm.gototable = gototable;
		vm.setDiscount = setDiscount;
		vm.setRound = setRound;
		vm.addInput = addInput;
		vm.clearInput = clearInput;
		vm.addCost = addCost;
		vm.printBill = printBill;
		vm.gotoBilling = gotoBilling;
		
        
     ///////
    	function printWebUSB(data){
			if(__env.isDebug) console.log("In Billing/Settle PrintWebUSB");        		
        	document.dispatchEvent(new CustomEvent('printwebusb', {detail: data}));
    	}
	////////////////////
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
		
		function setPayable(){
			//vm.payment.payableAmt = 0;	
			//vm.payment.payableAmt = vm.payment.nettAmt;	
			//vm.inputValue = vm.payment.nettAmt;

			vm.payment.payableAmt = vm.payment.payableAmt;	
			vm.inputValue = vm.payment.payableAmt;
		}
		
		function setSplitPayable(param){
			//alert(param);
			vm.payment.payableAmt = 0;
			vm.payment.payableAmt = parseFloat((vm.billNett-vm.billPaid)/param);	
		}
		
		function sumPayable(){
			//vm.payment.payableAmt = 0;
			vm.payment.payableAmt = parseFloat(vm.payment.payableAmt) + parseFloat(vm.billNett);	
		}
		
		function clearPayable(){
			vm.payment.payableAmt = 0;	
		}
		
		function closeBilling(){
			//$state.go('app.dining-list', {table_id: vm.billing.tableID});
			$state.go('app.table');
		}
		
		function setDiscount(){
			if(__env.isDebug) console.log(vm.payment);	
			var discount = parseFloat((parseFloat(vm.payment.billAmt + vm.billRound + vm.payment.billExtra + vm.payment.taxAmt)*parseFloat(vm.inputValue))/100);						
			vm.billDet.bil_discount = vm.inputValue;
			
			vm.payment.discountAmt = discount; 			
			vm.payment.nettAmt = Math.round((vm.payment.billAmt + vm.billRound + vm.payment.billExtra + vm.payment.taxAmt - vm.payment.discountAmt) - vm.payment.roundAmt);												
			vm.payment.payableAmt = Math.round(vm.payment.nettAmt - vm.payment.paidAmt);
			vm.inputValue = '';
			if(__env.isDebug) console.log(vm.payment);
		}
		
		function setRound(){	
			if(__env.isDebug) console.log(vm.payment);
			var rounding = parseFloat(vm.inputValue);							
			vm.billDet.bil_round = vm.inputValue;
			
			vm.payment.roundAmt = rounding;									
			vm.payment.nettAmt = Math.round((vm.payment.billAmt + vm.billRound + vm.payment.billExtra + vm.payment.taxAmt - vm.payment.discountAmt) - vm.payment.roundAmt);
			vm.payment.payableAmt = Math.round(vm.payment.nettAmt - vm.payment.paidAmt);
			vm.inputValue = '';
			if(__env.isDebug) console.log(vm.payment);
		}
				
		function addInput(input){
			//vm.inputValue = "";
			vm.inputValue = vm.inputValue+input;
		}
		
		function clearInput(){
			//vm.inputValue = vm.inputValue.substring(0, vm.inputValue.length - 1);
			vm.inputValue = '';
		}
		
		function addCost(input){
			//vm.inputValue = "";
			var inp = ''; if(vm.inputValue!=""){ inp =  parseFloat(vm.inputValue); }
			vm.inputValue = inp + parseFloat(input);
			
			vm.balance = vm.inputValue - vm.payment.nettAmt;
			if(vm.inputValue >= vm.payment.nettAmt){
				vm.payment.payableAmt = vm.payment.nettAmt;	
			}
		}
		
		function completeBill(type){
			vm.paid=0;
			for(var i=0;i<vm.paymentList.length;i++){
				if(vm.paymentList[i].bill_amount>0){
					vm.paid = vm.paid + parseFloat(vm.paymentList[i].bill_amount);
				}
			}
			var bilAmount = (vm.payment.billAmt + vm.billRound + vm.payment.billExtra + vm.payment.taxAmt - vm.payment.discountAmt - vm.payment.roundAmt) - vm.paid;
			if(__env.isDebug) console.log(bilAmount);
			var amt=vm.inputValue;
			vm.inputValue = '';
			var paidRate = 0;
			if(amt<=bilAmount){
				var obj={bill_branch_id:vm.billDet.bil_branch_id,bill_period_id:vm.billDet.bil_period_id,bill_bil_id:vm.billDet.bil_id,bill_type:type,bill_amount:amt};
				paidRate = amt;
			} else if(amt>bilAmount){
				var pamt = amt - bilAmount; 
				vm.balance = pamt;
				var obj={bill_branch_id:vm.billDet.bil_branch_id,bill_period_id:vm.billDet.bil_period_id,bill_bil_id:vm.billDet.bil_id,bill_type:type,bill_amount:bilAmount};
				paidRate = bilAmount;
			}
			
			if(__env.isDebug) console.log(vm.payment);

			vm.paymentList.push(obj);
			//vm.payment.paidAmt = vm.payment.paidAmt + parseFloat(paidRate);
			vm.payment.paidAmt = vm.paid + parseFloat(paidRate);
			vm.payment.payableAmt = Math.round(bilAmount - parseFloat(paidRate));
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.paymentList);
			if(__env.isDebug) console.log(vm.payment);
			if(vm.payment.payableAmt==0){
				completeBill2(type);	
			}

		}
		
		function completeBill2(type){			
			if(__env.isDebug) console.log("Save Data");
			//vm.payment.payableAmt = vm.inputValue;
			//vm.payment.nettAmt = vm.payment.nettAmt - vm.billRound;
			if(__env.isDebug) console.log(vm.billing.billDets);
			if(__env.isDebug) console.log(vm.payment);
			if(__env.isDebug) console.log(vm.paymentList);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.endBill@save', {param:{billDets:vm.billing.billDets,payment:vm.payment,paymentList:vm.paymentList,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Success");
						if(__env.isDebug) console.log(response);
						if(__env.isDebug) console.log(response.data);
						//alert(response.data);
						if(response.data){
							if(response.redirect==1){	
								$mdToast.show(
									$mdToast.simple().textContent('Transaction Completed').position('top right')
								);
								gototable();					
							} else {
								$mdToast.show(
									$mdToast.simple().textContent('Payment Completed').position('top right')
								);
								gotoBilling(response.data);					
							}
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
		
		function gotoDining(){
			//alert(dining_id);
			vm.deptType = localStorage.getItem('departmentType');
			if(vm.deptType=="Dining"){
				$state.go('app.table');
			} else if(vm.deptType=="Home Delivery"){
				$state.go('app.customer-selection');
			} else if(vm.deptType=="Parcel"){
				$state.go('app.dining-parcel');
			}			
		}
		
		function gotoBilling(dining_id){
			//alert(dining_id);
			$state.go('app.billing-list', {dining_id: dining_id});
		}
		
		function printBill(){			
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.billing.billDets);
			if(__env.isDebug) console.log(vm.payment);
			
			////connectAndPrint();
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				msApi.request('app.printBills@save', {param:{billDets:vm.billing.billDets,payment:vm.payment,branchID:localStorage.getItem('BranchID'),UserID:localStorage.getItem('UserID')},aToken:aToken,page:'pos'},
					// SUCCESS
					function (response){		
						//alert("IF");
						if(__env.isDebug) console.log("Billing Success at Print Dat");
						vm.billDet = response.data;
						//alert(response.data);
						if(vm.billDet.billID){
							//alert("In");
							
							var billID=vm.billDet.billID;
							$mdToast.show(
								$mdToast.simple().textContent('Order Saved').position('top right')
							);
							if(__env.isDebug) console.log("Start Print ");							
							
							var prndata=vm.billDet.prndata;
							
							//alert(prndata);
							if (prndata){
								if(__env.isDebug) console.log(prndata);
								//if(__env.isUSB) printWebUSB(prndata);
								var ar = prndata.split('::');
								for(var i=0;i<ar.length;i++){
									var inp = ar[i].split('~');
									if(__env.isDebug) console.log(inp);
									

									var printers="";
									//alert(inp[1]+" "+inp[2]);
									if(inp[1]==0){
										//findPrinter(inp[2],printerIP);
										printers=inp[2];

										//return qz.printers.find(inp[0], { encoding: 'ISO-8859-1' });
									} else if(inp[1]==1){
										vm.printer=$cookies.get("localPrinter");	
										//alert(vm.printer);
										if(vm.printer!=""){												
											//findPrinter(vm.printer,printerIP);					
											printers=vm.printer;				
										} else {
											//findPrinter(inp[2],printerIP);
											printers=inp[2];
										}
									}
									//alert(printers);
									if(__env.isDebug) console.log(printers);
									//alert(printers);
									console.log(printers);
									

									//var config = { encoding: 'ISO-8859-1' };
									var config = "";
									var data = [{type: 'pixel',format: 'html',flavor: 'plain',data: inp[0]}];
									//status=printData(config, data);
									status=printData(data,printers,config,printerIP);
									if(__env.isDebug) console.log("Print Status => ".status);
								}
							}
							
							gotoDining();
						}
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
		function gototable()
        {
			//alert("1");
            //$state.go('app.table-list');
			var deptType = localStorage.getItem('departmentType');
			//alert(deptType);
						
			if(deptType=="Dining"){
				$state.go('app.table');
			} else if(deptType=="Home Delivery"){
				$state.go('app.customer-selection');
			} else if(deptType=="Parcel"){
				$state.go('app.dining-parcel');
			} else {
				$state.go('app.dining-online');
			}
        }
												        		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.available')
        .controller('AvailableListController', AvailableListController);

    /** @ngInject */
    function AvailableListController($state, AvailableList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Item Available";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Item Availablity" && vm.pageID[i].status==0){ 
					 $state.go('app.home');
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.available = AvailableList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.available);	
		vm.branchID = vm.available.branchID;
		vm.periodID = vm.available.periodID;
		
		vm.items = vm.available.priceItmList;
		vm.availItmList = vm.available.availItmList;
		vm.btnBlock = 0;

		vm.listForm={};
		
		if(vm.available.error == "1"){
			gotoLogin();
		} 
        
		//vm.itmPriningList = [];
		for(var i=0;i<vm.items.length;i++){	
			vm.items[i].chk = 0;
			vm.items[i].label = "Available";
			vm.items[i].stock = 0;
			for(var j=0;j<vm.availItmList.length;j++){	
				if(vm.items[i].item_id==vm.availItmList[j].available_item_id && vm.items[i].itm_option_id==vm.availItmList[j].available_opt_id && vm.availItmList[j].available_status==1){
					if(vm.availItmList[j].available_stock==0){
						vm.items[i].label = "Unavailable";
					}
					vm.items[i].stock = vm.availItmList[j].available_stock;	
				}

			}
		}
		if(__env.isDebug) console.log(vm.items);
       	
        // Methods        		
		vm.gotoavailable = gotoavailable;	
		vm.saveUnavailable = saveUnavailable;
		vm.saveAvailable = saveAvailable;
		vm.gotoLogin = gotoLogin;
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }
        
		function gotoavailable()
        {
			//alert("1");
            //$state.go('app.available-list');

            if($state.current.name=="app.available"){
				$state.go('app.available-list');				
			} else if($state.current.name=="app.available-list"){
				$state.go('app.available');					
			}
        }

		function saveUnavailable()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.items);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				$mdToast.show(
					$mdToast.simple().textContent('Please wait until save complete').position('top right')
				);
				vm.btnBlock = 1;

				msApi.request('app.unavailableSave@save', {param:{items:vm.items,branchID:vm.branchID,periodID:vm.periodID},aToken:aToken,page:'available'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						vm.btnBlock = 0;
						$mdToast.show(
							$mdToast.simple().textContent('Item Unavailable Saved').position('top right')
						);						
						gotoavailable();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }		
						
		function saveAvailable()
        {
			if(__env.isDebug) console.log("Save Data");
			if(__env.isDebug) console.log(vm.items);
			
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){				
				$mdToast.show(
					$mdToast.simple().textContent('Please wait until save complete').position('top right')
				);
				vm.btnBlock = 1;

				msApi.request('app.availableSave@save', {param:{items:vm.items,branchID:vm.branchID,periodID:vm.periodID},aToken:aToken,page:'available'},
					// SUCCESS
					function (response){		
						//alert("IF");
						//if(__env.isDebug) console.log("Success");
						//if(__env.isDebug) console.log(response.data);
						//alert(response.data);		
						vm.btnBlock = 0;
						$mdToast.show(
							$mdToast.simple().textContent('Item Available Saved').position('top right')
						);						
						gotoavailable();					
					},
					// ERROR
					function (response){
						//alert("ELSE");
						if(__env.isDebug) console.log("Error");
						console.error(response.data);
					}
				);            
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.account-head')
        .controller('AccountheadListController', AccountheadListController);

    /** @ngInject */
    function AccountheadListController($state, AccountheadList, msApi, $window, __env, $mdToast, $rootScope)
    {
        
     	var vm = this;
		$rootScope.pageTitle = "Account Head";

		vm.pageID = "";
		if($window.localStorage['pageID']!=""){
			vm.pageID = JSON.parse($window.localStorage['pageID']);			
			for(var i=0;i<vm.pageID.length;i++){
				if(vm.pageID[i].page_name=="Account Head" && vm.pageID[i].status==0){ 
					 $state.go('app.home'); 
				}
			}	
		}

		vm.deptBlock=0; vm.waiterBlock=0; vm.tblcatBlock=0; vm.tableBlock=0; vm.customerBlock=0;
		vm.suppilerBlock=0; vm.pricetagBlock=0; vm.ordtagBlock=0; vm.itmpoolBlock=0; vm.catpoolBlock=0;
		vm.pricetBlock=0; vm.ingredBlock=0; vm.recipeBlock=0; vm.tempBlock=0; vm.printerBlock=0; 
		vm.printjobBlock=0; vm.usrrolesBlock=0; vm.usrBlock=0; vm.taxmasterBlock=0; vm.itmavailBlock=0; 
		vm.accheadBlock=0; vm.daybookBlock=0; vm.settBlock=0; vm.offerBlock=0; vm.extraBlock=0;
		vm.clearsalesBlock=0;

		if($window.localStorage['page']!=""){
			vm.page = JSON.parse($window.localStorage['page']);	
			if(vm.page["deptBlock"]==1){ vm.deptBlock=1; }
			if(vm.page["waiterBlock"]==1){ vm.waiterBlock=1; }
			if(vm.page["tblcatBlock"]==1){ vm.tblcatBlock=1; }
			if(vm.page["tableBlock"]==1){ vm.tableBlock=1; }
			if(vm.page["customerBlock"]==1){ vm.customerBlock=1; }
			if(vm.page["suppilerBlock"]==1){ vm.suppilerBlock=1; }
			if(vm.page["pricetagBlock"]==1){ vm.pricetagBlock=1; }
			if(vm.page["ordtagBlock"]==1){ vm.ordtagBlock=1; }

			if(vm.page["itmpoolBlock"]==1){ vm.itmpoolBlock=1; }
			if(vm.page["catpoolBlock"]==1){ vm.catpoolBlock=1; }
			if(vm.page["pricetBlock"]==1){ vm.pricetBlock=1; }
			if(vm.page["ingredBlock"]==1){ vm.ingredBlock=1; }
			if(vm.page["recipeBlock"]==1){ vm.recipeBlock=1; }
			if(vm.page["tempBlock"]==1){ vm.tempBlock=1; }
			if(vm.page["printerBlock"]==1){ vm.printerBlock=1; }
			if(vm.page["printjobBlock"]==1){ vm.printjobBlock=1; }
			
			if(vm.page["usrrolesBlock"]==1){ vm.usrrolesBlock=1; }
			if(vm.page["usrBlock"]==1){ vm.usrBlock=1; }
			if(vm.page["taxmasterBlock"]==1){ vm.taxmasterBlock=1; }
			if(vm.page["itmavailBlock"]==1){ vm.itmavailBlock=1; }
			if(vm.page["accheadBlock"]==1){ vm.accheadBlock=1; }
			if(vm.page["daybookBlock"]==1){ vm.daybookBlock=1; }
			if(vm.page["settBlock"]==1){ vm.settBlock=1; }	

			if(vm.page["offerBlock"]==1){ vm.offerBlock=1; }	
			if(vm.page["extraBlock"]==1){ vm.extraBlock=1; }	
			if(vm.page["clearsalesBlock"]==1){ vm.clearsalesBlock=1; }	
		}
		
        // Data
        vm.headDB = AccountheadList.data;
		if(__env.isDebug) console.log('List');
		if(__env.isDebug) console.log(vm.headDB);
        vm.listForm={};

        vm.headList = vm.headDB.accountheadList;
		
		if(vm.headDB.error == "1"){
			gotoLogin();
		} 
        		
       	vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };   
        // Methods
        vm.gotoAddAccounthead = gotoAddAccounthead;		
		vm.gotoAccounthead = gotoAccounthead;	
		vm.editAccounthead = editAccounthead;
		vm.deleteAccounthead = deleteAccounthead;
		vm.gotoLogin = gotoLogin;	
		
        //////////
		
		function gotoLogin()
        {
			//alert("Hi");
			//$state.go('app.login');
			$mdToast.show(
				$mdToast.simple().textContent('Access Token Expired').position('top right')
			);
        }

        /**
         * Go to add Admission
         */
        function gotoAddAccounthead()
        {
			 //alert("Hi");
			 $state.go('app.account-head.add');
        } 
		
		function editAccounthead(tax_id)
        {
			 //alert(customer_id);
			 $state.go('app.account-head.edit', {tax_id: tax_id});
        }
					
		function gotoAccounthead()
        {
			//alert("1");
            $state.go('app.account-head-list');
        }			
							
		function deleteAccounthead(achead_id)
        {
			//alert(tax_id);
			//if(__env.isDebug) console.log("Save Data");
			//if(__env.isDebug) console.log(vm.ordeTag);
			//if(__env.isDebug) console.log(vm.admission);
			//if(__env.isDebug) console.log(vm.sibling);
			var aToken=localStorage.getItem('UserATK');
			if(aToken!=""){
				var r = confirm("Do you delete this account head?");
				if (r == true) {
					msApi.request('app.actionDB@save', {mode:'delete',table:'tbl_account_head',param:{achead_id:achead_id},aToken:aToken,page:'account-head'},
						// SUCCESS
						function (response){		
							//alert("IF");
							//if(__env.isDebug) console.log("Success");
							//if(__env.isDebug) console.log(response.data);
							//alert(response.data);									
							
							$mdToast.show(
								$mdToast.simple().textContent('Account Head Deleted').position('top right')
							);
							gotoAccounthead();					
						},
						// ERROR
						function (response){
							//alert("ELSE");
							if(__env.isDebug) console.log("Error");
							console.error(response.data);
						}
					);            
				}
			} else {
				$mdToast.show(
					$mdToast.simple().textContent('Access Token Expired').position('top right')
				);
				//$state.go('app.login');	
			}
        }
						
				
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout, __env)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
			if(__env.isDebug) console.log(item);
			__env.searchID = item.catprod_id;
			localStorage.setItem('SearchID',item.catprod_id);			
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
				alert(val);
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date();
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());
			
			//if(__env.isDebug) console.log(registeredPalettes);
			//if(__env.isDebug) console.log(registeredPalettes);

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider(__env)
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
       // var baseUrl = 'http://dreamserver/workarea/fuse_parents/api_ci/';
	    var baseUrl = __env.apiUrl;
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;		
			//if(__env.isDebug) console.log("baseUrl="+baseUrl);
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
			//if(__env.isDebug) console.log("baseUrl="+baseUrl);
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {           
           	/*if(__env.isDebug) console.log('Filter Data');
			if(__env.isDebug) console.log(items);
			if(__env.isDebug) console.log(parameter);
			if(__env.isDebug) console.log(ids);*/
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = parseInt(ids[j]);
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {
            
            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
				
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, __env, $window)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };
		
		vm.departmentList = JSON.parse($window.localStorage['departmentList']);
		//if(__env.isDebug) console.log("Tootbar");
		//if(__env.isDebug) console.log(vm.departmentList);

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };
		
		vm.deptID = localStorage.getItem('departmentID');
		vm.role = localStorage.getItem('UserRole');
		vm.kotExist = localStorage.getItem('ifKOTExist');	
		alert(vm.kotExist);
		vm.main = 0;
		vm.show = 0;
		if(localStorage.getItem('periodID')!=""){
			vm.show = 1;
		}
		//alert(vm.deptID);
		//vm.AppSchoolName		= localStorage.getItem('AppSchoolName');
		vm.AppSchoolName		= "Distributer App";
		vm.CustomerName	= localStorage.getItem('UserName');
		//vm.SelectStudentRollNo	= localStorage.getItem('SelectStudentRollNo');
		vm.CustomerBranch = localStorage.getItem('UserBranchName');
		//vm.SelectStudentImage 	= localStorage.getItem('SelectStudentImage');
		
		vm.SelectStudentImg	= 'assets/images/avatars/profile.jpg';
		
		/*if(vm.SelectStudentImage!=""){			
			vm.SelectStudentImg	= __env.apiUrl+'view/userfiles/students/'+vm.SelectStudentImage;
		} else {
			vm.SelectStudentImg	= 'assets/images/avatars/profile.jpg';
		}*/

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;		
		vm.changeMenu = changeMenu;
		vm.setDepartment = setDepartment;
		vm.gotoHome = gotoHome;
		//vm.logout = logout;
				

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }
		
		function logout()
        {
			//alert("1");
            $state.go('app.login');
        }
		
		function setDepartment(dept){
			//alert(localStorage.getItem('periodID'));
			if(localStorage.getItem('periodID') != ''){
				//localStorage.setItem('customerID','');
				//localStorage.setItem('tableID','');
				localStorage.setItem('departmentID',dept.department_id);
				localStorage.setItem('departmentType',dept.department_type);
				//$state.go('app.dining');	
				
				vm.deptID = localStorage.getItem('departmentID');
				//alert(vm.deptID);
				vm.main = 0;	
				
				if(dept.department_type=="Dining"){
					$state.go('app.table');
				} else if(dept.department_type=="Home Delivery"){
					$state.go('app.customer-selection');
				} else if(dept.department_type=="Parcel"){
					$state.go('app.dining-parcel');
				} else {
					$state.go('app.dining-online');
				}
			} else {
				$state.go('app.home');
			}
		}
		
		function gotoHome(){
			vm.deptID = '';	
			vm.main = 1;	
			$state.go('app.home');	
		}


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        /*function logout()
        {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
		
		function changeMenu(){
			//alert("Hi");
			vm.SelectStudentName	= localStorage.getItem('SelectStudentName');
			
			if(__env.isDebug) console.log("Name "+localStorage.getItem('SelectStudentName'));
			
			vm.SelectStudentRollNo	= localStorage.getItem('SelectStudentRollNo');
			vm.SelectStudentClass 	= localStorage.getItem('SelectStudentClass');
			vm.SelectStudentImage 	= localStorage.getItem('SelectStudentImage');
			
			if(vm.SelectStudentImage!=""){			
				vm.SelectStudentImg	= __env.apiUrl+'view/userfiles/students/'+vm.SelectStudentImage;
			} else {
				vm.SelectStudentImg	= 'assets/images/avatars/profile.jpg';
			}
		}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi, $window, $rootScope, $state, $mdSidenav)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        /*msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );*/



        $rootScope.totalAlert = 0;
        vm.branchID = localStorage.getItem('BranchID');
        vm.alertList = JSON.parse($window.localStorage['customKots']);
        if(__env.isDebug) console.log("Alert List");
        if(__env.isDebug) console.log(vm.alertList);
        if(vm.alertList.length>0){
            $rootScope.totalAlert = vm.alertList.length;
        }

        $rootScope.$on('changeAlerts', function (events, data) {  
            //vm.param = data;  
            //alert("In");
            vm.alertList = "";
            vm.alertList = JSON.parse($window.localStorage['customKots']);
            if(__env.isDebug) console.log("Alert Call List");
            if(__env.isDebug) console.log(vm.alertList);
            if(vm.alertList.length>0){
                $rootScope.totalAlert = vm.alertList.length;
            }
        });
        // Methods
        vm.getCustomKots = getCustomKots;
        vm.gotoKot = gotoKot;

        //////////

        function gotoKot(alert)
        {                       
            if(__env.isDebug) console.log(alert);   
            $mdSidenav('quick-panel').toggle();  
            
            /*
            localStorage.setItem('departmentID',alert.customerkot_dept_id);
            localStorage.setItem('departmentType',alert.department_type);            
            localStorage.setItem('menuID',alert.customerkot_dept_id);  

            vm.departmentList = JSON.parse($window.localStorage['departmentList']);
            vm.deptTypeList = "";
            for(var d=0;d<vm.departmentList.length;d++){
                if(vm.departmentList[d].department_id == alert.customerkot_dept_id){
                    vm.deptFlow = vm.departmentList[d]['deptFlow'];
                    vm.deptType = vm.deptFlow[0].deptopt_option;
                    //vm.deptTypeList = '';
                    for(var i=1;i<vm.deptFlow.length;i++){
                        vm.deptTypeList = vm.deptTypeList+","+vm.deptFlow[i].deptopt_option;        
                    }
                }
            }
            vm.deptTypeList=vm.deptTypeList.substring(1);
            //alert(vm.deptType+" "+vm.deptTypeList);
            localStorage.setItem('deptTypeList',vm.deptTypeList);
            */

            /*
            if(alert.department_type=="Dining"){
                if($state.current.name=="app.dining-custom-bill"){
                    $state.go('app.dining-custom-bill-list', {bill_id: alert.customerkot_id});                
                } else if($state.current.name=="app.dining-custom-bill-list"){
                    $state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id});                 
                } else {
                    $state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id}); 
                }   
            } else if(alert.department_type=="Online"){
                if($state.current.name=="app.online-custom-bill"){
                    $state.go('app.online-custom-bill-list', {bill_id: alert.customerkot_id});                
                } else if($state.current.name=="app.online-custom-bill-list"){
                    $state.go('app.online-custom-bill', {bill_id: alert.customerkot_id});                 
                } else {
                    $state.go('app.online-custom-bill', {bill_id: alert.customerkot_id}); 
                }
            }*/

            $rootScope.$emit('setDepartment2',alert);       

            /*if($state.current.name=="app.dining-custom-bill"){
                $state.go('app.dining-custom-bill-list', {bill_id: alert.customerkot_id});                
            } else if($state.current.name=="app.dining-custom-bill-list"){
                $state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id});                 
            } else {
                $state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id}); 
            }*/  

            //$state.go('app.dining-custom-bill', {bill_id: alert.customerkot_id});                     
        }

        //getCustomKots();
        function getCustomKots(){
            vm.lastAlertTime = JSON.parse($window.localStorage['lastAlertTime']);
            if(__env.isDebug) console.log("Input Data");
            if(__env.isDebug) console.log(vm.lastAlertTime);
            msApi.request('app.getCustomKots@save', {param:{lastAlertTime:vm.lastAlertTime,branchID:vm.branchID}},
                // SUCCESS
                function (response){        
                    //alert("IF");
                    if(__env.isDebug) console.log("Success");
                    if(__env.isDebug) console.log(response.data);   
                    //alert(response.data.status);
                    if(response.data.status!=0){
                        //vm.selectedParentDet = response.data;
                        
                        if(__env.isDebug) console.log("Alert New List");
                        if(__env.isDebug) console.log(vm.alertList);
                        if(vm.alertList.length>0){
                            $rootScope.totalAlert = vm.alertList.length;
                        }
                    }
                },
                // ERROR
                function (response){
                    //alert("ELSE");
                    if(__env.isDebug) console.log("Error");
                    if(__env.isDebug) console.log(response.data);
                }
            );
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
     function config($stateProvider, msApiProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
		// Api
		msApiProvider.register('app.systemDets', ['systemDets']);        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $mdToast, $document, msApi, $state)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };
		
		vm.schoolMenuName = null;
		vm.schoolMenuLogo = null;

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
		
		getSystemDets(); 

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
		
		
		/** Get System Details  **/
		
		function getSystemDets()
        {						
			//alert('Hi');
			/*
			msApi.request('app.systemDets@save', {},
				// SUCCESS
				function (response){		
					//alert("IF");
					if(__env.isDebug) console.log("Success");
					if(__env.isDebug) console.log(response.data);	
					//alert(response.data);		
					vm.systemDets = response.data;
					vm.schoolMenuName = vm.systemDets.genset_school_name;
					vm.schoolMenuLogo = vm.systemDets.genset_logo;
					
					vm.schoolMenuName = "Clean Living";
					vm.schoolMenuLogo = "CL";					
					
					localStorage.setItem('AppSchoolName',vm.schoolMenuName);					

				},
				// ERROR
				function (response){
					//alert("ELSE");
					if(__env.isDebug) console.log("Error");
					if(__env.isDebug) console.log(response.data);
				}
			);
			*/
			vm.schoolMenuName = "RFQ App";
			vm.schoolMenuLogo = "RFQ";					
			
			localStorage.setItem('AppSchoolName',vm.schoolMenuName);
        }
		
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',
			'app.toolbar-inner',

            // Quick Panel
            'app.quick-panel',

            // Login Part
			'app.login',
			//'app.register',
			'app.forgot-password',			
			//'app.otp',
			'app.reset-password',			
			
			// Web Part			
			//'app.supplier',
			//'app.client',			
			//'app.rfq',				
			//'app.custom_fields',		
			
			
			// Master Part
			'app.dashboard',
			'app.branch',
			'app.customer',
			'app.supplier',
			'app.waiter',
			'app.staff',
			'app.scategory',
			'app.seats',
			'app.department',
			'app.price-tag',
			'app.tax',
			'app.category',
			'app.item',
			'app.ingredients',
			'app.pricing',
			'app.settings',
			'app.order-tag',
			'app.ordertagoption',
			'app.printers',
			'app.printerjobs',
			'app.support',
			'app.user',
			'app.roles',
			
			
			// POS Part
			'app.home',
			'app.work-period',
			'app.customer-selection',
			'app.table',
			'app.dining',
			'app.billing',
			'app.tickets',
			'app.work-report',
			'app.sales-report',
			'app.kot-report',
			'app.reportmenu',
			'app.warehousemenu',
			'app.managemenu',
			'app.bills',
			'app.template',
			'app.available',
			'app.account-head',
			'app.daybook',
			'app.offer',
			'app.extra',			
			
			// Inventory Part
			'app.purchase',
			'app.purchasei',
			'app.recipes',
			'app.warehouse',
			'app.stock-report',
			'app.transferin',
			'app.transfer',
			'app.inventory',
			'app.wastage',
			'app.variance',			

			'app.user-report',
			'app.category-report',
			'app.item-report',
			'app.item-stock-report',
			'app.opening-stock-report',
			'app.item-reorder-report',
			'app.daybook-report',
			'app.short-expiry-report',
			'app.variance-report',
			'app.ingredients-stock-update',
			'app.waiter-sales-report',
			'app.purchase-report',
			'app.sales-tax-report',
			'app.sales-intax-report',
			'app.units',
			'app.clear-sales',
			'app.report',
			'app.sales',
			'app.printer-testing',
			
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);
		
		

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
				//toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
				toolbar   : 'app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/main/apps/toolbar-inner/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/main/apps/toolbar-inner/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/main/apps/toolbar-inner/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/main/apps/toolbar-inner/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarControllerIn as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
		vm.value = "AAA";

        //////////
    }
})();
(function ()
{
    'use strict';
		var env = {};
		// Import variables if present (from env.js)
		if(window){ Object.assign(env, window.__env);	}
		
    angular
        .module('app.core')
				.constant('__env', env);					
				
			
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide)
    {
        // Put your common app configurations here

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  if(__env.isDebug) console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  if(__env.isDebug) console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  if(__env.isDebug) console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<div class=\"sidnav-bx\"><div class=\"sec-tlt\"><h4>Notifications</h4></div><div class=\"list\" \nng-repeat=\"alert in vm.alertList\" ng-click=\"vm.gotoKot(alert)\"><div layout=\"row\" layout-align=\"space-between\"><h4>\n#{{alert.customerkot_no}} - {{alert.customerkot_type}}</h4><span class=\"price\">{{alert.department_name}}</span></div>\n<div layout=\"row\" layout-align=\"space-between\"><span class=\"qty\">{{alert.customer_name}}</span> <span class=\"qty\">\nTable No: {{alert.table_name}}</span></div></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><div id=\"content-container\" flex \nlayout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar>\n<md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div>\n<md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation2.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div><div class=\"title\">{{result.catprod_prod_query}}</div><div class=\"description\" \nng-if=\"result.description\">{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.schoolMenuLogo}}</span> <span \nclass=\"logo-text\">{{vm.schoolMenuName}}</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" \nhide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/apps/account-head/account-head.html","<div id=\"account\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" \nng-click=\"vm.gotoAddAccounthead()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>New Account Head</span>\n</md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"tax-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\">Account Head</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.headList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>{{cat.achead_name}}\n</b></td><td align=\"center\">{{cat.achead_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editAccounthead(cat.achead_id)\"><md-tooltip md-direction=\"down\">Edit</md-tooltip><i \nclass=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteAccounthead(cat.achead_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i \nclass=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/available/available.html","<div id=\"available\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div></div><div\n class=\"list-content scrollable\" ms-scroll><div class=\"available-table-wrapper md-background-bg md-whiteframe-1dp\"><div\n layout=\"row\" layout-align=\"end\"><div class=\"search-bx\"><input type=\"text\" name=\"search\" ng-model=\"vm.search\" \nplaceholder=\"Search\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></div></div><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div \nclass=\"table-header\"></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\">Item Name</span></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\">Mirror Stock</span></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\">\n<span class=\"column-title\">Item Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.items | filter:vm.search\"><td align=\"center\"><md-checkbox md-no-ink ng-model=\"cat.chk\" \nclass=\"md-accent\" ng-checked=\"(cat.chk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox></td><td \nclass=\"text-left\" show-gt-sm><b>{{cat.item_name}} - {{cat.itm_option_name}}</b></td><td class=\"text-left\"><input \ntype=\"text\" name=\"stock\" ng-model=\"cat.stock\"></td><td class=\"text-left\"><b>{{cat.label}}</b></td></tr></tbody></table>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"brn-bx\"><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"vm.btnBlock==1\" ng-click=\"vm.saveUnavailable()\">\nSet Unavailabe</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"vm.btnBlock==1\" ng-click=\"vm.saveAvailable()\">Set Availabe</md-button></div></div></div></div>");
$templateCache.put("app/main/apps/billing/billing.html","<div id=\"billing\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div class=\"bill_1\" \nlayout=\"column\" layout-align=\"top\"><div layout=\"row\" layout-align=\"start\" class=\"md-grey-200-bg p-5\"><div \nlayout=\"column\"><span class=\"h4 grey-50-fg font-size-14 pl-5 grey-900-fg font-weight-900\"><label>\n#{{vm.billDet.bil_no}} <span translate=\"BILLING.TOPTABLE\">Table :</span></label>{{vm.billing.tableName}}</span></div>\n</div><div class=\"scroll\"><div class=\"contact-item\" ng-repeat=\"itm in vm.billItmsDets\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-16\">{{itm.bitm_qty}}</span>\n<span class=\"font-size-16 pl-10\">{{itm.item_name}}</span></div><div layout=\"column\" layout-align=\"end\"><p \nclass=\"m-0 font-size-16\">{{itm.bitm_total | number: vm.c_d}}</p></div></div></div></div><div \nclass=\"blnc md-grey-300-bg\"><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.payment.discountAmt!=\'\' || vm.payment.roundAmt!=\'\' || vm.payment.taxAmt!=\'\'\"><div class=\"select_1\" \nlayout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 black-600-fg\"><b translate=\"BILLING.BILL_AMOUNT\">\nBill Amount : </b></p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p \nclass=\"show-gt-md m-0 black-00-fg\"><b>{{vm.payment.billAmt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" \nlayout-align=\"space-between\" ng-if=\"vm.payment.billExtra!=\'\'\"><div class=\"select_1\" layout=\"column\" \nlayout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 black-600-fg\"><b translate=\"BILLING.EXTRA_AMOUNT\">Extra Amount : \n</b></p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 black-00-fg\"><b>\n{{vm.payment.billExtra | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.payment.taxAmt!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 black-600-fg\"><b translate=\"BILLING.TAX\">Tax : </b></p></div><div class=\"select_1\" \nlayout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 black-00-fg\"><b>{{vm.payment.taxAmt | number: vm.c_d}}</b>\n</p></div></div><div layout=\"row\" layout-align=\"space-between\" ng-if=\"vm.payment.discountAmt!=\'\'\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 black-600-fg\"><b \ntranslate=\"BILLING.DISCOUNT\">Discount : </b></p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p \nclass=\"show-gt-md m-0 black-00-fg\"><b>{{vm.payment.discountAmt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" \nlayout-align=\"space-between\" ng-if=\"vm.payment.roundAmt!=\'\'\"><div class=\"select_1\" layout=\"column\" \nlayout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 black-600-fg\"><b translate=\"BILLING.DISCOUNT\">Discount : </b></p>\n</div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 black-600-fg\"><b>\n{{vm.payment.roundAmt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.payment.nettAmt!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 black-600-fg\"><b translate=\"BILLING.NETT_AMOUNT\">Nett Amount : </b></p></div><div \nclass=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 black-600-fg\"><b>\n{{vm.payment.nettAmt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.payment.paidAmt!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 black-600-fg\"><b translate=\"BILLING.PAID\">Paid : </b></p></div><div class=\"select_1\" \nlayout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 black-600-fg\"><b>{{vm.payment.paidAmt | number: vm.c_d}}\n</b></p></div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" \nlayout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLING.BALANCE\">Balance : </b></p></div>\n<div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 red-900-fg\"><b>\n{{vm.payment.payableAmt | number: vm.c_d}}</b></p></div></div></div></div><div class=\"bill_2\" layout=\"column\" \nlayout-align=\"top\"><div class=\"blnc md-grey-300-bg\"><div class=\"md-red-400-bg\" layout=\"row\" layout-align=\"center\" \nng-if=\"vm.balance > 0\"><div class=\"bln-amt\" layout=\"column\" layout-align=\"start\"><h1><span \ntranslate=\"BILLING.BALANCE_TOPAY\">Balance to Pay :</span> {{vm.balance | number: vm.c_d}}</h1></div></div><div \nlayout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"\" \ntranslate=\"BILLING.TOTAL\">Total :</p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\">\n<md-input-container><p>{{vm.payment.nettAmt | number: vm.c_d}}</p></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"\" \ntranslate=\"BILLING.CHARGED\">Charged :</p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\">\n<md-input-container><input type=\"text\" name=\"inputValue\" ng-model=\"vm.inputValue\" \nng-disabled=\"vm.payment.payableAmt==0\"></md-input-container></div></div></div><div class=\"kypad\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"one\"><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-green-500-bg\" ng-click=\"vm.addCost(50)\"><span>50</span></md-button></div><div\n layout=\"row\" layout-align=\"center center\"><md-button class=\"num-btn md-raised md-background md-green-500-bg\" \nng-click=\"vm.addCost(100)\"><span>100</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-green-500-bg\" ng-click=\"vm.addCost(200)\"><span>200</span></md-button></div>\n<div layout=\"row\" layout-align=\"center center\"><md-button class=\"num-btn md-raised md-background md-green-500-bg\" \nng-click=\"vm.addCost(500)\"><span>500</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-green-500-bg\" ng-click=\"vm.addCost(1000)\"><span>1000</span></md-button></div>\n<div layout=\"row\" layout-align=\"center center\"><md-button class=\"num-btn md-raised md-background md-green-500-bg\" \nng-click=\"vm.addCost(2000)\"><span>2000</span></md-button></div></div><div class=\"two\"><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(1)\"><span>1</span></md-button></div><div \nlayout=\"column\" class=\"num-btn\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\" \nng-click=\"vm.addInput(2)\"><span>2</span></md-button></div><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(3)\"><span>3</span></md-button></div></div>\n<div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(4)\"><span>4</span></md-button></div><div \nlayout=\"column\" class=\"num-btn\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\" \nng-click=\"vm.addInput(5)\"><span>5</span></md-button></div><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(6)\"><span>6</span></md-button></div></div>\n<div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(7)\"><span>7</span></md-button></div><div \nlayout=\"column\" class=\"num-btn\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\" \nng-click=\"vm.addInput(8)\"><span>8</span></md-button></div><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(9)\"><span>9</span></md-button></div></div>\n<div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.addInput(\'.\')\"><span>.</span></md-button></div><div\n layout=\"column\" class=\"num-btn\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\" \nng-click=\"vm.addInput(0)\"><span>0</span></md-button></div><div layout=\"column\" class=\"num-btn\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\" ng-click=\"vm.clearInput()\"><span>C</span></md-button></div>\n</div></div><div class=\"three\"><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-purple-400-bg\" ng-click=\"vm.setPayable()\"><span translate=\"BILLING.ALL\">All\n</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-blue-300-bg\" ng-click=\"vm.setSplitPayable(\'2\')\" ng-disable=\"true\"><span>1/2\n</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-blue-300-bg\" ng-click=\"vm.setSplitPayable(\'3\')\" ng-disable=\"true\"><span>1/3\n</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-blue-300-bg\" ng-click=\"vm.setSplitPayable(\'5\')\" ng-disable=\"true\"><span>1/n\n</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"num-btn md-raised md-background md-purple-400-bg\" ng-click=\"vm.setPayable()\"><span \ntranslate=\"BILLING.TICKET_BTN\">Ticket</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button\n class=\"num-btn md-raised md-background md-purple-200-bg\" ng-click=\"vm.sumPayable()\" ng-disable=\"true\"><span>\n{{vm.billNett | number: vm.c_d}}</span></md-button></div></div></div><div layout=\"row\" layout-align=\"center center\">\n<div layout=\"column\" class=\"btm-btn\"><md-button class=\"btm-btn md-raised md-background md-green-600-bg grey-50-fg\" \nng-click=\"vm.setDiscount()\" ng-disabled=\"vm.inputValue==0\"><span translate=\"BILLING.DISCOUNT_PERCENT\">Discount %</span>\n</md-button></div><div layout=\"column\" class=\"btm-btn\"><md-button \nclass=\"btm-btn md-raised md-background md-grey-500-bg grey-50-fg\" ng-click=\"vm.setRound()\" \nng-disabled=\"vm.inputValue==0\"><span translate=\"BILLING.DISCOUNT_MINUS\">Discount (-)</span></md-button></div><div \nlayout=\"column\" class=\"btm-btn\"><md-button class=\"btm-btn md-raised md-background md-red-200-bg grey-900-fg\" \nng-click=\"vm.printBill()\"><span translate=\"BILLING.PRINT_BILL\">Print Bill</span></md-button></div></div></div><div \nclass=\"bill_3\" layout=\"column\" layout-align=\"top\" ms-scroll><div layout=\"row\" ng-repeat=\"pmode in vm.payMode\">\n<md-button class=\"rght-btn md-raised md-background grey-50-fg\" ng-disabled=\"vm.inputValue==\'\'\" \nng-click=\"vm.completeBill(pmode)\" style=\"background:#04738C\" ng-if=\"$index%6==0\"><span>{{pmode}}</span></md-button>\n<md-button class=\"rght-btn md-raised md-background grey-50-fg\" ng-disabled=\"vm.inputValue==\'\'\" \nng-click=\"vm.completeBill(pmode)\" style=\"background:#ffb74d\" ng-if=\"$index%6==1\"><span>{{pmode}}</span></md-button>\n<md-button class=\"rght-btn md-raised md-background md-blue-500-bg grey-50-fg\" ng-disabled=\"vm.inputValue==\'\'\" \nng-click=\"vm.completeBill(pmode)\" ng-if=\"$index%6==2\"><span>{{pmode}}</span></md-button><md-button \nclass=\"rght-btn md-raised md-background md-orange-500-bg grey-50-fg\" ng-disabled=\"vm.inputValue==\'\'\" \nng-click=\"vm.completeBill(pmode)\" ng-if=\"$index%6==3\"><span>{{pmode}}</span></md-button><md-button \nclass=\"rght-btn md-raised md-background md-green-500-bg grey-50-fg\" ng-disabled=\"vm.inputValue==\'\'\" \nng-click=\"vm.completeBill(pmode)\" ng-if=\"$index%6==4\"><span>{{pmode}}</span></md-button><md-button \nclass=\"rght-btn md-raised md-background md-pink-500-bg grey-50-fg\" ng-disabled=\"vm.inputValue==\'\'\" \nng-click=\"vm.completeBill(pmode)\" ng-if=\"$index%6==5\"><span>{{pmode}}</span></md-button></div><md-button \nclass=\"close-btn md-raised md-background md-red-300-bg grey-50-fg\" ng-disabled=\"vm.inputValue>0\" \nng-click=\"vm.closeBilling()\"><span translate=\"BILLING.CLOSE\">Close</span></md-button></div></div></div>");
$templateCache.put("app/main/apps/branch/branch.html","<div id=\"branch\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" layout-align=\"center start\"></div><div layout=\"column\" layout-align=\"start center\"><md-button \nclass=\"new-btn md-raised md-background md-blue-500-bg\" ng-click=\"vm.gotoAddBranchs()\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><span>New Branch</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"branch-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Branch Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"cat in vm.branch.branchList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" \nshow-gt-sm><b>{{cat.branch_name}}</b></td><td align=\"center\">{{cat.branch_status}}</td><td align=\"center\"><md-button \nclass=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.editBranchs(cat.branch_id)\"><span>Edit</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteBranchs(cat.branch_id)\">\n<span>Delete</span></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/apps/bills/bills.html","<div id=\"bills\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div layout=\"column\" \nclass=\"fst-bx\" ms-scroll><div layout=\"row\" class=\"tbl-bx\"><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"20\" \nflex-gt-xs=\"50\" align=\"center\" ng-repeat=\"bill in vm.billList\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nclass=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.selectBill(bill)\" \nng-if=\"bill.bil_id!=vm.seletedBill\"><ms-widget-front><div class=\"dng\" layout=\"row\" layout-align=\"center center\"><span>\n{{bill.bil_type}}</span></div><div class=\"tble\" layout=\"row\" layout-align=\"center center\"><span>{{bill.fullBillNo}}\n</span></div><div class=\"amt\" layout=\"row\" layout-align=\"center center\"><span>\nNett : {{bill.billTotal | number: vm.c_d}}</span></div><div class=\"dng\" ng-if=\"bill.bil_status==\'Completed\'\" \nlayout=\"row\" layout-align=\"center center\"><span><b>{{bill.bil_status}}</b></span></div><div class=\"dng4\" \nng-if=\"bill.bil_status==\'NAC\'\" layout=\"row\" layout-align=\"center center\"><span><b>{{bill.bil_status}}</b></span></div>\n<div class=\"dng2\" ng-if=\"bill.bil_status==\'Ordered\'\" layout=\"row\" layout-align=\"center center\"><span><b>\n{{bill.bil_status}}</b></span></div><div class=\"dng3\" ng-if=\"bill.bil_status==\'Cancelled\'\" layout=\"row\" \nlayout-align=\"center center\"><span><b>{{bill.bil_status}}</b></span></div><div class=\"amt\" layout=\"row\" \nlayout-align=\"center center\"><span><b>{{bill.bil_paymenttype}}</b></span></div></ms-widget-front></ms-widget><ms-widget\n flippable=\"true\" layout=\"column\" flex=\"100\" class=\"crd md-background md-green-100-bg grey-900-fg\" md-ink-ripple \nng-click=\"vm.selectBill(bill)\" ng-if=\"bill.bil_id==vm.seletedBill\"><ms-widget-front><div class=\"dng\" layout=\"row\" \nlayout-align=\"center center\"><span>{{bill.bil_type}}</span></div><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{bill.fullBillNo}}</span></div><div class=\"amt\" layout=\"row\" \nlayout-align=\"center center\"><span>Nett : {{bill.billTotal | number: vm.c_d}}</span></div><div class=\"dng\" \nng-if=\"bill.bil_status==\'Completed\'\" layout=\"row\" layout-align=\"center center\"><span><b>{{bill.bil_status}}</b></span>\n</div><div class=\"dng4\" ng-if=\"bill.bil_status==\'NAC\'\" layout=\"row\" layout-align=\"center center\"><span><b>\n{{bill.bil_status}}</b></span></div><div class=\"dng2\" ng-if=\"bill.bil_status==\'Ordered\'\" layout=\"row\" \nlayout-align=\"center center\"><span><b>{{bill.bil_status}}</b></span></div><div class=\"dng3\" \nng-if=\"bill.bil_status==\'Cancelled\'\" layout=\"row\" layout-align=\"center center\"><span><b>{{bill.bil_status}}</b></span>\n</div><div class=\"amt\" layout=\"row\" layout-align=\"center center\"><span><b>{{bill.bil_paymenttype}}</b></span></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" class=\"no-rec text-center\" layout-align=\"center center\" \nng-if=\"vm.billList.length==0\"><h2 translate=\"BILLS.NOBILL_FOUND\">No Bills Found</h2></div><div \nlayout-align=\"center center\" layout=\"row\" style=\"margin:auto\" ng-if=\"vm.billsCount>vm.billList.length\"><md-button \nclass=\"lodmor-btn md-raised md-background md-red-500-bg grey-50-fg\" ng-click=\"vm.loadMore()\"><span \ntranslate=\"BILLS.LOAD_MORE\">Load More..</span></md-button></div></div></div><div class=\"bill_1\" layout=\"column\" \nlayout-align=\"top\" ng-repeat=\"bil in vm.billList | filter:{bil_id:vm.seletedBill}:true\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"md-grey-200-bg p-5\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"h4 grey-50-fg font-size-14 pl-15 grey-900-fg font-weight-900\"><label><span translate=\"BILLS.BILLNO\">Bill No :\n</span>{{bil.fullBillNo}}</label><span ng-if=\"bil.table_name!=null\"><span translate=\"BILLS.TABLENO\">Table :</span>\n {{bil.table_name}}</span></span></div><div layout=\"column\" layout-align=\"end\"><span \nclass=\"h4 grey-50-fg font-size-14 pl-5 grey-900-fg font-weight-900\"><label>{{bil.bil_date}}</label></span></div></div>\n<div class=\"scroll\" ms-scroll ng-if=\"vm.showSummary==0\"><div class=\"contact-item\" ng-repeat=\"itm in bil.ticketItms\">\n<div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-16\">\n{{itm.bitm_qty}}</span><span class=\"font-size-16 pl-10\">{{itm.item_name}}<span ng-if=\"itm.itm_option_name!=\'Normal\'\">\n.{{itm.itm_option_name}}</span></span></div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-16\">\n{{itm.bitm_total | number: vm.c_d}}</p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-repeat=\"tag in itm.billitemTag\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-13\"></span><span \nclass=\"font-size-13 pl-10 red-900-fg\">{{tag.billitemtag_ordertag_name}}</span></div><div layout=\"column\" \nlayout-align=\"end\"><p class=\"m-0 font-size-13 red-900-fg\">{{tag.billitemtag_ordertag_rate | number: vm.c_d}}</p></div>\n</div></div></div><div class=\"blnc md-grey-300-bg scroll\" ms-scroll><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"bil.bil_totalamt>0\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLS.GROSS_TOTAL\">Gross Total : </b></p></div><div \nclass=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 red-900-fg\"><b>\n{{bil.bil_totalamt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"bil.bil_totextraamt>0\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLS.EXTRA_CHARGE\">Extra Charges : </b></p></div><div \nclass=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 red-900-fg\"><b>\n{{bil.bil_totextraamt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"bil.bil_tottaxamt>0\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLS.TAX\">Tax : </b></p></div><div class=\"select_1\" \nlayout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 red-900-fg\"><b>{{bil.bil_tottaxamt | number: vm.c_d}}</b>\n</p></div></div><div layout=\"row\" layout-align=\"space-between\" ng-if=\"bil.bil_discountamt>0\"><div class=\"select_1\" \nlayout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLS.DISCOUNT\">\nDiscount : </b></p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 red-900-fg\">\n<b>{{bil.bil_discountamt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 red-900-fg\"><b \ntranslate=\"BILLS.NETT_TOTAL\">Nett Total : </b></p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p \nclass=\"show-gt-md m-0 red-900-fg\"><b>{{bil.billTotal | number: vm.c_d}}</b></p></div></div><div \nclass=\"blnc md-grey-300-bg\" ng-if=\"vm.showSummary==1\"><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-3 black-900-fg\"><b \ntranslate=\"BILLS.TAX_SUMMARY\">Tax Summary : </b></p></div></div><div class=\"contact-item\" \nng-repeat=\"tax in bil.billTaxList | orderBy: \'tax_name\'\"><div layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"row\" layout-align=\"start\"><span class=\"font-size-14 pl-2\">{{tax.tax_name}} <span \nng-if=\"tax.tax_type==\'Exclusive\'\">(Excl.)</span> <span ng-if=\"tax.tax_type==\'Inclusive\'\">(Incl.)</span></span></div>\n<div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-14\" ng-if=\"tax.tax_type==\'Exclusive\'\">\n{{tax.tax_amt | number: vm.c_d}}</p><p class=\"m-0 font-size-14\" ng-if=\"tax.tax_type==\'Inclusive\'\">\n{{tax.tax_amt2 | number: vm.c_d}}</p></div></div></div><div class=\"contact-item\" ng-if=\"vm.taxTotal>0\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-15 pl-2\">\n</span></div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-16\">{{vm.taxTotal | number: vm.c_d}}</p>\n</div></div></div></div><div class=\"blnc md-grey-300-bg\" ng-if=\"vm.showSummary==1\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-3 black-900-fg\"><b translate=\"BILLS.EXTRA_SUMMARY\">Extra Summary : </b></p></div></div><div \nclass=\"contact-item\" ng-repeat=\"xtr in bil.billExtraList | orderBy: \'extra_name\'\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-14 pl-2\">{{xtr.extra_name}}\n</span></div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-14\">{{xtr.extra_amt | number: vm.c_d}}</p>\n</div></div></div><div class=\"contact-item\" ng-if=\"vm.extraTotal>0\"><div layout=\"row\" layout-align=\"space-between\"><div\n layout=\"row\" layout-align=\"start\"><span class=\"font-size-15 pl-2\"></span></div><div layout=\"column\" \nlayout-align=\"end\"><p class=\"m-0 font-size-16\">{{vm.extraTotal | number: vm.c_d}}</p></div></div></div></div><div \nclass=\"blnc md-grey-300-bg\" ng-if=\"vm.showSummary==1\"><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-3 black-900-fg\"><b \ntranslate=\"BILLS.PAYMENT_SUMMARY\">Payment Summary : </b></p></div></div><div class=\"contact-item\" \nng-repeat=\"pay in bil.billPaymentList\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start\"><span class=\"font-size-14 pl-2\">{{pay.bill_type}}</span></div><div layout=\"column\" \nlayout-align=\"end\"><p class=\"m-0 font-size-14\">{{pay.bill_amount | number: vm.c_d}}</p></div></div></div><div \nclass=\"contact-item\" ng-if=\"vm.paymentTotal>0\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start\"><span class=\"font-size-15 pl-2\"></span></div><div layout=\"column\" layout-align=\"end\"><p \nclass=\"m-0 font-size-16\">{{vm.paymentTotal | number: vm.c_d}}</p></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-between\" ng-if=\"(bil.bil_status==\'Completed\' || bil.bil_status==\'NAC\')\"><md-button type=\"submit\" \nng-if=\"vm.showSummary==0\" class=\"md-raised md-accent tp-btn md-orange-500-bg grey-50-fg padding-5\" aria-label=\"Submit\" \nng-click=\"vm.billSummary(bil.bil_id)\" style=\"width:50%\" translate=\"BILLS.SHOWSUM_BTN\">Show Summary</md-button>\n<md-button type=\"submit\" ng-if=\"vm.showSummary==1\" \nclass=\"md-raised md-accent tp-btn md-orange-500-bg grey-50-fg padding-5\" aria-label=\"Submit\" \nng-click=\"vm.billSummary(bil.bil_id)\" style=\"width:50%\" translate=\"BILLS.HIDESUM_BTN\">Hide Summary</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn md-blue-500-bg grey-50-fg padding-5\" aria-label=\"Submit\" \nng-click=\"vm.printTicket(bil.bil_id)\" ng-disabled=\"vm.showSummary==1\" style=\"width:50%\" \ntranslate=\"BILLS.REPRINT_TICKET\">Reprint Ticket</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-green-600-bg grey-50-fg padding-5\" aria-label=\"Submit\" \nng-click=\"vm.changeTender()\" ng-disabled=\"vm.showSummary==1\" style=\"width:50%\" translate=\"BILLS.CHNG_TENDER\">\nChange Tender</md-button></div></div><div ng-if=\"vm.billCancel==0 && vm.showSummary==0\"><div \nclass=\"blnc md-grey-300-bg\" ng-if=\"vm.ifStaffCancell==1 && (bil.bil_status==\'Completed\' || bil.bil_status==\'NAC\')\"><div\n layout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLS.BILLCANCEL_BY\">Bill Cancelled By : </b></p></div></div>\n</div><div class=\"tbl-scroll\" ms-scroll><div class=\"rht-crd\" layout=\"row\" \nng-if=\"vm.ifStaffCancell==1 && (bil.bil_status==\'Completed\' || bil.bil_status==\'NAC\')\"><div class=\"colm\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-xs=\"50\" align=\"center\" ng-repeat=\"reason in vm.reasonsList\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"crd md-background md-red-500-bg grey-50-fg\" \nmd-ink-ripple ng-click=\"vm.cancelBills(reason.reason_name)\"><ms-widget-front><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{reason.reason_name}}</span></div></ms-widget-front></ms-widget></div></div><div \nclass=\"rht-crd\" layout=\"row\" ng-if=\"bil.bil_status==\'Ordered\'\"><div class=\"colm\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"column\" class=\"cncl-bx\" layout-align=\"center\" flex><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-red-500-bg grey-50-fg\" aria-label=\"Submit\" ng-click=\"vm.gotoBill(bil)\" \ntranslate=\"BILLS.GOTO_BILL\">Goto Bill</md-button></div></div></div></div></div><div \nng-if=\"vm.billCancel==1 && vm.showSummary==0\"><div class=\"blnc md-grey-300-bg\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 red-900-fg\"><b translate=\"BILLS.SELECT_TENDER\">Select Tender : </b></p></div></div></div>\n<div class=\"tender-btn\" layout=\"row\" ms-scroll layout-wrap><div layout=\"column\" class=\"tender-column\" \nng-repeat=\"pmode in vm.payMode | limitTo : 3\"><md-button class=\"btm-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.changeTender2(pmode)\" style=\"background:#04738C\" ng-if=\"$index%6==0\"><span>{{pmode}}</span></md-button>\n<md-button class=\"btm-btn md-raised md-background grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nstyle=\"background:#ffb74d\" ng-if=\"$index%6==1\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-blue-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==2\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-orange-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==3\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-green-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==4\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-pink-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==5\"><span>{{pmode}}</span></md-button></div><div layout=\"column\" class=\"tender-column\"><md-button \nclass=\"btm-btn md-raised md-background grey-50-fg\" ng-click=\"vm.openClassesDialog($event)\" style=\"background:#04738C\">\n<span translate=\"BILLS.MORE_BTN\">More</span></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/category/category.html","<div id=\"category\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"end\"><div layout=\"column\" layout-align=\"start\"><md-button \nclass=\"new-btn md-raised\" ng-click=\"vm.saveCategorys()\"><span translate=\"CATEGORY.SAVE_CATEGORY\">Save to Category\n</span></md-button></div><div layout=\"column\" layout-align=\"start\"><md-button class=\"new-btn md-raised\" \nng-click=\"vm.gotoAddCategorys()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"CATEGORY.NEW_CATEGORY\">\nNew Category</span></md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-checkbox md-no-ink ng-model=\"vm.chkAll\" class=\"md-accent\" \nng-checked=\"(vm.chkAll==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-click=\"vm.selectAll()\"></md-checkbox></div>\n</th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CATEGORY.TABLE_CATNAME\">Category Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"CATEGORY.TABLE_STATUS\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CATEGORY.TABLE_ACTION\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.category.categoryList\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"cat.categorylist_selected\" class=\"md-accent\" ng-checked=\"(cat.categorylist_selected==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\"></md-checkbox></td><td align=\"left\" show-gt-sm><b>{{cat.categorylist_name}}</b></td><td \nalign=\"center\">{{cat.categorylist_status}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini md-orange-400-bg\" style=\"padding:0px 0px 2px 0px\" \nng-click=\"vm.setItems(cat.categorylist_id)\"><md-tooltip md-direction=\"down\"><span translate=\"CATEGORY.TABLE_SETITEM\">\nSet Items</span></md-tooltip><i class=\"icon icon-table-large\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editCategorys(cat.categorylist_id)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CATEGORY.TABLE_EDIT\">Edit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteCategorys(cat)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"CATEGORY.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/category-report/category-report.html","<div id=\"category-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"CATEGORYREPORT.CAT_NAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.categoryDets.catID\"><md-option ng-value=\"\" \ntranslate=\"CATEGORYREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.categoryDets.catID==op.category_id\">{{op.category_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><label class=\"inpt-lbl\" translate=\"CATEGORYREPORT.DATE\">Date:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"type\" ng-model=\"vm.categoryDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.categoryDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div></div><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"CATEGORYREPORT.FROM\">From:</label><md-datepicker name=\"from\" md-placeholder=\"Enter date\" \nng-model=\"vm.categoryDets.from\" flex></md-datepicker></div></div></div><div layout=\"column\" flex=\"50\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" \ntranslate=\"CATEGORYREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.categoryDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i><span translate=\"CATEGORYREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CATEGORYREPORT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CATEGORYREPORT.TABLE_CATNAME\">\nCategory Name</span></div></th><th class=\"secondary-text text-right\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CATEGORYREPORT.TABLE_AMOUNT\">Amount</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.categoryReportList\" ng-if=\"vm.categoryReportList.length>0\"><td align=\"center\">{{$index+1}}</td><td\n align=\"center\">{{itm.category_name}}</td><td style=\"text-align:right\">{{itm.kotitem_totat | number: vm.c_d}}</td></tr>\n</tbody><tr ng-if=\"vm.categoryReportList.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"2\"></td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalAmt | number: vm.c_d}}</td></tr></table></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/clear-sales/clear-sales.html","<div id=\"clear-sales\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\">Work Period :</label><md-input-container flex style=\"margin-top:-5px\"><md-select \nname=\"periodID\" ng-model=\"vm.salesDets.periodID\"><md-option ng-repeat=\"op in vm.workperiodList\" \nng-value=\"op.workperiod_id\" ng-selected=\"vm.salesDets.periodID==op\">\n{{op.workperiod_start_date}} - {{op.workperiod_end_date}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\">\nPayment Mode :</label><md-input-container flex style=\"margin-top:-5px\"><md-select name=\"mode\" \nng-model=\"vm.salesDets.mode\"><md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"op in vm.modeList\" \nng-value=\"op.bill_type\" ng-selected=\"vm.salesDets.mode==op\">{{op.bill_type}}</md-option></md-select>\n</md-input-container></div></div></div><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i>List Bills</md-button></div></form></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"clear-sales-table-wrapper md-background-bg md-whiteframe-1dp\">\n<div style=\"display: flex;justify-content: space-between;align-items: center;flex-direction: row-reverse\"><div><div \nlayout=\"row\" layout-align=\"end\"><md-button type=\"button\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" \nng-click=\"vm.delBills()\">Delete Bills</md-button></div><div class=\"clear-sales-summary\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.salesReportList.length>0\"><span class=\"summary-label\">Total Nett Amount of Bills:\n</span> <span class=\"summary-value\">{{vm.totalNett | number: vm.c_d}}</span></div></div><div \nclass=\"clear-sales-actions\" layout=\"row\" layout-align=\"start center\" layout-wrap ng-if=\"vm.salesReportList.length>0\">\n<md-input-container class=\"percentage-input\" md-no-float><h6>Enter Percentage</h6><input type=\"number\" min=\"0\" \nmax=\"100\" step=\"1\" ng-model=\"vm.selectPercent\" placeholder=\"per\" aria-label=\"per\"> <span class=\"md-suffix\">%</span>\n<md-button type=\"button\" class=\"md-raised md-accent tp-btn select-percent-btn\" aria-label=\"Select Bills\" \nng-click=\"vm.selectByPercent()\" style=\"margin-right: 5px;position: absolute;right: -61%\">Select</md-button>\n</md-input-container><div style=\"display: flex; justify-content: flex-start;align-items: center\"><div \nclass=\"selected-total-text\">Selected Total Amount: <span>{{vm.selectedTotalNett | number: vm.c_d}}</span></div></div>\n</div></div><table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><md-checkbox md-no-ink ng-model=\"vm.chkAll\" class=\"md-accent\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\" ng-change=\"vm.selectAll()\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Bill No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Mode</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Amount</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.salesReportList\" ng-if=\"vm.salesReportList.length>0\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"itm.bil_checked\" class=\"md-accent\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-change=\"vm.select(itm)\">\n</md-checkbox></td><td align=\"center\">{{$index+1}}</td><td align=\"center\">#{{itm.bil_no}}</td><td align=\"center\">\n{{itm.bil_date}}</td><td align=\"center\">{{itm.bil_paymenttype}}</td><td style=\"text-align:right\">\n{{itm.bil_totalamt | number: vm.c_d}}</td><td style=\"text-align:right\">{{itm.bil_totalnetamt | number: vm.c_d}}</td>\n</tr><tr ng-if=\"vm.salesReportList==\'\'\"><td style=\"text-align:center\" colspan=\"7\">No Bills Found</td></tr></tbody><tr \nng-if=\"vm.salesReportList.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"5\"></td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalAmt | number: vm.c_d}}</td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalNett | number: vm.c_d}}</td></tr></table></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/customer/customer.html","<div id=\"customer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div><div \nlayout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddCustomer()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"CUSTOMER.NEW_CUSTOMER\">New Customer</span></md-button>\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"customer-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CUSTOMER.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CUSTOMER.TABLE_CUSTOMERNAME\">Customer Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CUSTOMER.TABLE_MOBILENO\">Mobile No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CUSTOMER.TABLE_STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CUSTOMER.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.customer.customerList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.customer_name}}</b></td><td align=\"center\">{{cat.customer_mobileno}}</td><td align=\"center\">\n{{cat.customer_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editCustomer(cat.customer_id)\"><md-tooltip md-direction=\"down\"><span translate=\"CUSTOMER.TABLE_EDIT\">Edit\n</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteCustomer(cat.customer_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"CUSTOMER.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/customer-selection/customer-selection.html","<div id=\"customers\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div class=\"customers1\">\n<div layout=\"row\" layout-align=\"center\" class=\"hdng\"><h1 translate=\"CUSTOMERSELECTION.SELECT_CUSTOMER\">Select Customer\n</h1></div><div layout=\"row\" layout-align=\"space-between\" class=\"mt-10\" ng-if=\"vm.listCustomer==1\"><div class=\"search\" \nlayout=\"row\" layout-align=\"start\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" ng-model=\"vm.search\" ng-keyup=\"vm.searchCustomer()\" flex></div>\n<div layout=\"row\" layout-align=\"end\"><md-button translate=\"CUSTOMERSELECTION.NEW_CUSTOMER\" class=\"new-btn md-raised\" \nlayout=\"row\" layout-align=\"center\" ng-click=\"vm.addCustomer()\">New Customer</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"clnt-bx\" ng-if=\"vm.listCustomer==1\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"cust in vm.customerList\"><md-button class=\"tp-btn md-raised md-background grey-800-fg\" \nng-click=\"vm.setCustomerDets(cust)\"><span>{{cust.customer_name}}<br><span style=\"font-size: 13px; font-style: italic\">\n({{cust.customer_mobileno}})</span></span></md-button></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"clnt-bx\" ng-if=\"vm.listCustomer==0\"><form name=\"customerForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"CUSTOMERSELECTION.CUSTOMER_DETAILS\">Customer Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"CUSTOMERSELECTION.CUSTOMER_NAME\">Customer Name</label>\n<input type=\"text\" name=\"customer_name\" ng-model=\"vm.customer.customer_name\" required><div \nng-messages=\"customerForm.customer_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CUSTOMERSELECTION.ALERT_SELECT_CUSTOMER\">Customer Name field is required.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"CUSTOMERSELECTION.CUSTOMER_MOBILE\">\nMobile No</label><input type=\"text\" name=\"customer_mobileno\" ng-model=\"vm.customer.customer_mobileno\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CUSTOMERSELECTION.CUSTOMER_ADDRESS\">Address</label><input type=\"text\" name=\"customer_address\" \nng-model=\"vm.customer.customer_address\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-button translate=\"CUSTOMERSELECTION.BACK\" class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoCustomer()\">Back</md-button><md-button translate=\"CUSTOMERSELECTION.SUBMIT\" type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"customerForm.$invalid || customerForm.$pristine\" \nng-click=\"vm.saveCustomer()\">Submit</md-button></div></form></div></div><div class=\"customers2\"><div layout=\"row\" \nlayout-align=\"center\" class=\"hdng\"><h1 translate=\"CUSTOMERSELECTION.CUSTOMER_KOT\">Customer KOT</h1></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"clnt-bx\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"cust in vm.customerDets.homeCustDets\"><md-button \nclass=\"tp-btn md-raised md-background md-yellow-700-bg grey-800-fg\" ng-click=\"vm.setCustomerDets(cust)\"><span>\n{{cust.customer_name}}</span></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\" ms-scroll><div class=\"head\" layout=\"row\" layout-align=\"start-between\"><div layout=\"row\" \nng-if=\"vm.role==\'Super Admin\'\"><div layout=\"row\" class=\"date\" layout-align=\"right\"><label>From:</label><md-datepicker \nname=\"date\" md-placeholder=\"Enter date\" ng-model=\"vm.others.from\" ng-change=\"vm.listBillDets1()\" flex></md-datepicker>\n</div><div layout=\"row\" class=\"date\" layout-align=\"right\"><label>To:</label><md-datepicker name=\"date\" \nmd-placeholder=\"Enter date\" ng-model=\"vm.others.to\" ng-change=\"vm.listBillDets1()\" flex></md-datepicker></div><div \nclass=\"select_1\" layout=\"row\" layout-align=\"right\"><label>Date Range</label><md-select \nclass=\"simplified select-class flex md-default-theme\" ng-model=\"vm.others.type\" placeholder=\"-- Select --\" \nng-change=\"vm.listBillDets1()\"><md-option class=\"border-bottom\"><em>Select Class</em></md-option><md-option \nng-repeat=\"classop in vm.statuslist\" ng-value=\"classop\" ng-selected=\"vm.others.type==classop\">{{classop}}</md-option>\n</md-select></div><div layout=\"row\" layout-align=\"right\"><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.listBillDets()\">List</md-button></div></div></div><div layout=\"row\" \nlayout-align=\"space-between\" ng-if=\"vm.role==\'Super Admin\'\"><ms-widget layout=\"column\" layout-align=\"left\" flex=\"100\" \nflex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Sales</div></div><div class=\"p-16\" ng-if=\"vm.compDets.length>0\">\n<c3chart bindto-id=\"pie-plot2-chart\"><chart-column ng-repeat=\"comp in vm.compDets\" column-id=\"{{comp.branch_city}}\" \ncolumn-values=\"{{comp.sm_nett}}\" column-color=\"{{vm.colors[$index]}}\" column-type=\"pie\"><chart-pie expand=\"true\">\n</c3chart></div></ms-widget-front></ms-widget><div class=\"dashboar_group\" layout=\"row\" layout-align=\"right\" flex=\"100\" \nflex-gt-sm=\"75\"><div layout=\"column\" flex=\"100\"><div class=\"widget_front white-bg\"><table \nclass=\"simple font-weight-600\" ms-responsive-table><thead><tr><th class=\"secondary-text text-center\"><div \nclass=\"table-header font-weight-600\"><span class=\"column-title\">S.No</span></div></th><th \nclass=\"secondary-text text-center font-weight-600\"><div class=\"table-header\"><span class=\"column-title\">Outlet Name\n</span></div></th><th class=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span \nclass=\"column-title\">Sales</span></div></th><th class=\"secondary-text text-center\"><div \nclass=\"table-header font-weight-600\"><span class=\"column-title\">Tax (+)</span></div></th><th \nclass=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span class=\"column-title\">Discount (-)\n</span></div></th><th class=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span \nclass=\"column-title\">Round (-)</span></div></th><th class=\"secondary-text text-center\"><div \nclass=\"table-header font-weight-600\"><span class=\"column-title\">Nett Total</span></div></th></tr></thead><tbody><tr \nng-repeat=\"comp in vm.compDets\" ng-click=\"vm.gotoReport(comp)\"><td align=\"center\">{{$index+1}}</td><td align=\"center\">\n{{comp.branch_name}} - {{comp.branch_city}}</td><td style=\"text-align:right\">{{comp.sm_gross | number: vm.c_d}}</td><td\n style=\"text-align:right\">{{comp.sm_tax | number: vm.c_d}}</td><td style=\"text-align:right\">\n{{comp.sm_discount | number: vm.c_d}}</td><td style=\"text-align:right\">{{comp.sm_round | number: vm.c_d}}</td><td \nstyle=\"text-align:right\">{{comp.sm_nett | number: vm.c_d}}</td></tr></tbody></table></div></div></div></div><div \nclass=\"second\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"left\">\n<h3 class=\"user_name\">Outlet Name :&nbsp;<span class=\"font-weight-600\" style=\"color:#4285f4\">{{vm.branchName}}</span>\n</h3></div><div class=\"select_1 mr-10\" layout=\"column\" layout-align=\"right\"><md-input-container flex><label \nclass=\"secondary-text\">Payment Mode</label><md-select ng-model=\"vm.selectPay\" ng-change=\"vm.setType()\" flex><md-option \nng-value=\"\">All</md-option><md-option ng-repeat=\"op in vm.payMode\" ng-value=\"op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" layout-align=\"space-between\"><ms-widget layout=\"column\" \nlayout-align=\"left\" flex=\"100\" flex-gt-sm=\"25\" style=\"height:450px\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Tender</div></div><div \nclass=\"p-16\" ng-if=\"(vm.payment | filter:{bil_branch_id:vm.branch}).length>0\"><c3chart bindto-id=\"pie-plot1-chart\">\n<chart-column ng-repeat=\"pay in vm.payment | filter:{bil_branch_id:vm.branch}\" column-id=\"{{pay.bil_paymenttype}}\" \ncolumn-values=\"{{pay.sm_nett}}\" column-color=\"{{vm.colors[$index]}}\" column-type=\"pie\"><chart-pie expand=\"true\">\n</c3chart></div></ms-widget-front></ms-widget><div class=\"dashboar_group\" layout=\"row\" layout-align=\"right\" flex=\"100\" \nflex-gt-sm=\"75\"><div layout=\"column\" flex=\"100\"><div class=\"widget_front white-bg\"><table \nclass=\"simple font-weight-600\" ms-responsive-table><thead><tr><th class=\"secondary-text text-center\"><div \nclass=\"table-header font-weight-600\"><span class=\"column-title\">S.No</span></div></th><th \nclass=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span class=\"column-title\">Bill.No</span>\n</div></th><th class=\"secondary-text text-center font-weight-600\"><div class=\"table-header\"><span class=\"column-title\">\nDate</span></div></th><th class=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text text-center\"><div \nclass=\"table-header font-weight-600\"><span class=\"column-title\">Tax</span></div></th><th \nclass=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span class=\"column-title\">Total</span>\n</div></th><th class=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span class=\"column-title\">\nPayment Type</span></div></th><th class=\"secondary-text text-center\"><div class=\"table-header font-weight-600\"><span \nclass=\"column-title\">User</span></div></th></tr></thead><tbody><tr \nng-repeat=\"bil in vm.listings.dbListingBills | filter:{bil_branch_id:vm.branch} | filter:{bil_paymenttype:vm.selectPay}\">\n<td align=\"center\">{{$index+1}}</td><td align=\"center\">#{{bil.bil_no}}</td><td align=\"center\">{{bil.bil_date}}</td><td \nstyle=\"text-align:right\">{{bil.bil_totalamt | number: vm.c_d}}</td><td style=\"text-align:right\">\n{{bil.bil_tottaxamt | number: vm.c_d}}</td><td style=\"text-align:right\">{{bil.bil_totalnetamt | number: vm.c_d}}</td>\n<td align=\"center\">{{bil.bil_paymenttype}}</td><td align=\"center\">{{bil.usr_name}}</td></tr><tr \nng-if=\"(vm.listings.dbListingBills | filter:{bil_branch_id:vm.branch}).length==0\"><td align=\"center\" colspan=\"8\"><b>\nNo Records</b></td></tr></tbody></table></div></div></div></div></div><div class=\"second\" layout=\"column\" \nng-if=\"vm.role==\'Super Admin\'\"><h3 class=\"user_name\">Sales Summary</h3><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pt-8 pb-20\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"center_font blue-grey-fg font-size-30 line-height-72\">{{vm.listings.dbSAToday | number: vm.c_d}}</div></div><div\n class=\"bottom_panel_1 md-blue-bg white-fg\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"h2 secondary-text text-truncate font-weight-900\">Today</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pt-8 pb-20\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"center_font blue-grey-fg font-size-30 line-height-72\">{{vm.listings.dbSAWeek | number: vm.c_d}}</div></div><div \nclass=\"bottom_panel_1 md-blue-grey-bg white-fg\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"h2 secondary-text text-truncate font-weight-900\">This Week</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pt-8 pb-20\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"center_font blue-grey-fg font-size-30 line-height-72\">{{vm.listings.dbSAMonth | number: vm.c_d}}</div></div><div\n class=\"bottom_panel_1 md-orange-bg white-fg\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"h2 secondary-text text-truncate font-weight-900\">This Month</span></div></ms-widget-front></ms-widget><ms-widget\n flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pt-8 pb-20\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"center_font blue-grey-fg font-size-30 line-height-72\">{{vm.listings.dbSAYear | number: vm.c_d}}</div></div><div \nclass=\"bottom_panel_1 md-blue-grey-bg white-fg\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"h2 secondary-text text-truncate font-weight-900\">This Year</span></div></ms-widget-front></ms-widget></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/daybook/daybook.html","<div id=\"daybook\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-if=\"vm.periodID!=\'\'\" \nng-click=\"vm.gotoAddDaybook()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>New Daybook</span></md-button></div>\n</div><div class=\"list-content scrollable\" ms-scroll><div class=\"tax-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Account Head\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.daybookList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.achead_name}}</b></td><td align=\"center\">{{cat.daybook_type}}</td><td align=\"center\">{{cat.daybook_amount}}</td>\n<td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" ng-click=\"vm.editDaybook(cat.daybook_id)\" \nng-if=\"vm.periodID!=\'\'\"><md-tooltip md-direction=\"down\">Edit</md-tooltip><i class=\"icon icon-table-edit\"></i>\n</md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteDaybook(cat.daybook_id)\" \nng-if=\"vm.periodID!=\'\'\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\"></i></md-button>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/daybook-report/daybook-report.html","<div id=\"daybook-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"DAYBOOKREPORT.ACOUNT_HEAD\">Account Head:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"accID\" ng-model=\"vm.daybookDets.accID\"><md-option ng-value=\"\" \ntranslate=\"DAYBOOKREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.accountheadList\" \nng-value=\"op.achead_id\" ng-selected=\"vm.daybookDets.accID==op.achead_id\">{{op.achead_name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><label class=\"inpt-lbl\" translate=\"DAYBOOKREPORT.DATE\">Date:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"type\" ng-model=\"vm.daybookDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.daybookDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div></div><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"DAYBOOKREPORT.FROM\">From:</label><md-datepicker name=\"from\" md-placeholder=\"Enter date\" \nng-model=\"vm.daybookDets.from\" flex></md-datepicker></div></div></div><div layout=\"column\" flex=\"50\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" \ntranslate=\"DAYBOOKREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.daybookDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i> <span translate=\"DAYBOOKREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"daybook-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"DAYBOOKREPORT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DAYBOOKREPORT.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"DAYBOOKREPORT.TABLE_ACCOUNTHEAD\">Account Head</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DAYBOOKREPORT.TABLE_INCOME\">Income</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"DAYBOOKREPORT.TABLE_EXPENSES\">Expenses</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DAYBOOKREPORT.TABLE_REMARK\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.daybookReportList\" ng-if=\"vm.daybookReportList.length>0\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"center\">{{itm.daybook_date2}}</td><td align=\"center\">{{itm.achead_name}}</td><td style=\"text-align:right\">\n{{itm.inAmt | number: vm.c_d}}</td><td style=\"text-align:right\">{{itm.expAmt | number: vm.c_d}}</td><td align=\"left\">\n{{itm.daybook_remarks}}</td></tr></tbody><tr ng-if=\"vm.daybookReportList.length>0\" class=\"btm-row\"><td align=\"center\" \ncolspan=\"3\"></td><td style=\"text-align:right;background:#00a931\">{{vm.totalInAmt | number: vm.c_d}}</td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalExpAmt | number: vm.c_d}}</td><td align=\"center\"></td></tr>\n</table></div></div></div></div></div>");
$templateCache.put("app/main/apps/department/department.html","<div id=\"department\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised md-background\" \nng-click=\"vm.gotoAddDepartment()\"><md-icon md-font-icon=\"icon-account\"></md-icon><span \ntranslate=\"DEPARTMENT.NEW_DEPARTMENTBTN\">New Department</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"department-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DEPARTMENT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\">\n<span class=\"column-title\" translate=\"DEPARTMENT.TABLE_DEPARTNAME\">Department Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"DEPARTMENT.TABLE_PRICETAG\">\nPrice Tag</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"DEPARTMENT.TABLE_STATUS\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"DEPARTMENT.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.department.departmentList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.department_name}}</b></td><td align=\"center\" ng-if=\"cat.department_price_tag_id!=0\">{{cat.price_tag_name}}</td>\n<td align=\"center\" ng-if=\"cat.department_price_tag_id==0\">***</td><td align=\"center\">{{cat.department_status}}</td><td \nalign=\"center\"><md-button class=\"actn-btn md-fab md-mini md-orange-500-bg\" style=\"padding-bottom:5px\" \nng-click=\"vm.flowDepartment(cat.department_id)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"DEPARTMENT.TABLE_FLOW\">Flow</span></md-tooltip><i class=\"icon icon-sitemap\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editDepartment(cat.department_id)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"DEPARTMENT.TABLE_EDIT\">Edit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteDepartment(cat.department_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"DEPARTMENT.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\">\n</i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/dining/dining.html","<div id=\"dining\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div class=\"client_1\" \nlayout=\"column\" layout-align=\"top\"><div class=\"scroll\" ms-scroll><div class=\"one\" ng-if=\"vm.itemMenu==0\"><div \nlayout=\"row\" ng-if=\"vm.deptType==\'Dining\'\"><md-button class=\"left-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.gototable()\" style=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/dinner-table.png\"> <span \ntranslate=\"DINING.CHANGE_TABLE\">Change Table</span></md-button></div><div layout=\"row\" ng-if=\"vm.deptType!=\'\'\">\n<md-button class=\"left-btn md-raised md-background grey-50-fg\" ng-click=\"vm.selectCustomer()\" \nstyle=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/customer.png\"> <span \ntranslate=\"DINING.SELECT_CUSTOMER\">Select Customer</span></md-button></div><div layout=\"row\" \nng-if=\"vm.deptType==\'Dining\'\"><md-button class=\"left-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.selectWaiter()\" style=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/customer.png\"> <span \ntranslate=\"DINING.SELECT_WAITER\">Select Waiter</span></md-button></div><div layout=\"row\" ng-if=\"vm.deptType==\'Online\'\">\n<md-button class=\"left-btn md-raised md-background grey-50-fg\" ng-click=\"vm.selectOrderID()\" \nstyle=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/billls.png\"> <span translate=\"DINING.SET_ORDERID\">\nSet Order ID</span></md-button></div><div layout=\"row\" ng-if=\"vm.deptType==\'Parcel\'\"><md-button \nclass=\"left-btn md-raised md-background grey-50-fg\" ng-click=\"vm.selectPendParcel()\" style=\"background:#42557c\"><img \nclass=\"left-img\" ng-src=\"assets/img/billls.png\"> <span translate=\"DINING.PENDING_PARCEL\">Pending Parcel</span>\n</md-button></div><div layout=\"row\" ng-if=\"vm.deptType==\'Retail\'\"><md-button \nclass=\"left-btn md-raised md-background grey-50-fg\" ng-click=\"vm.selectPendRetail()\" style=\"background:#42557c\"><img \nclass=\"left-img\" ng-src=\"assets/img/billls.png\"> <span translate=\"DINING.DUE_BILLS\">Due Bills</span></md-button></div>\n<div layout=\"row\"><md-button class=\"left-btn md-raised md-background md-red-400-bg grey-50-fg\" \nng-click=\"vm.printBill()\" ng-disabled=\"vm.kotItems.length==0 || vm.saveFlag==0\"><img class=\"left-img\" \nng-src=\"assets/img/sales bills.png\"> <span translate=\"DINING.PRINT_BILLS\">Print Bill</span></md-button></div><div \nlayout=\"row\"><md-button class=\"left-btn md-raised md-background grey-50-fg\" ng-click=\"vm.gotoTicketNote()\" \nstyle=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/billls.png\"> <span translate=\"DINING.TICKET_NOTE\">\nTicket Note</span></md-button></div><div layout=\"row\" ng-if=\"vm.discBlock==0\"><md-button \nclass=\"left-btn md-raised md-background grey-50-fg\" ng-disabled=\"vm.kotItems.length==0 && vm.discBlock==0\" \nng-click=\"vm.showDiscount()\" style=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/plus-minus.png\"> <span\n translate=\"DINING.ADDON\">Addon\'s</span></md-button></div><div layout=\"row\" \nng-if=\"vm.allKotBlock==0 && vm.printcKotBtnShow==1\"><md-button \nclass=\"left-btn md-raised md-background md-green-400-bg grey-50-fg\" ng-click=\"vm.printAllKOT()\" \nng-disabled=\"vm.billAddons.bil_print==0 || vm.kotItems.length==0 || vm.existBtn==1 || vm.saveFlag==0\"><img \nclass=\"left-img\" ng-src=\"assets/img/sales bills.png\"> <span translate=\"DINING.PRINT_KOT\">Print C KOT</span></md-button>\n</div><div layout=\"row\"><md-button class=\"left-btn md-raised md-background grey-50-fg\" ng-click=\"vm.gotoClearAll()\" \nng-disabled=\"vm.kotItems.length==0\" style=\"background:#42557c\"><img class=\"left-img\" ng-src=\"assets/img/close.png\"> \n<span translate=\"DINING.CLEAR_ALL\">Clear All</span></md-button></div></div><div class=\"two\" ng-if=\"vm.itemMenu==1\"><div\n layout=\"row\"><md-button class=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\" ng-click=\"vm.increase()\" \nng-disabled=\"vm.plusDisp==0\"><span>(+)</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\" ng-click=\"vm.decrease()\" \nng-disabled=\"vm.minusDisp==0\"><span>(-)</span></md-button></div><div layout=\"row\" \nng-if=\"vm.giftShow==1 && vm.giftBlock==0\"><md-button \nclass=\"left-btn md-raised kot-btn md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.setAsGift()\" \nng-disabled=\"vm.giftDisp==0 || (vm.billAddons.bil_print==1 && vm.giftHide==0)\" translate=\"DINING.GIFT\"><span>Gift\n</span></md-button></div><div layout=\"row\" ng-if=\"vm.giftShow==0 && vm.giftBlock==0\"><md-button \nclass=\"left-btn md-raised kot-btn md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.cancelGift()\" \nng-disabled=\"vm.giftDisp==0 || (vm.billAddons.bil_print==1 && vm.giftHide==0)\"><span translate=\"DINING.CANCEL_GIFT\">\nCancel Gift</span></md-button></div><div layout=\"row\" ng-if=\"vm.voidShow==1 && vm.voidBlock==0\"><md-button \nclass=\"left-btn md-raised kot-btn md-background md-orange-400-bg grey-50-fg\" ng-click=\"vm.setAsVoid()\" \nng-disabled=\"vm.voidDisp==0 || (vm.billAddons.bil_print==1 && vm.voidHide==0)\"><span translate=\"DINING.VOID\">Void\n</span></md-button></div><div layout=\"row\" ng-if=\"vm.voidShow==0 && vm.voidBlock==0\"><md-button \nclass=\"left-btn md-raised kot-btn md-background md-orange-400-bg grey-50-fg\" ng-click=\"vm.cancelVoid()\" \nng-disabled=\"vm.voidDisp==0 || (vm.billAddons.bil_print==1 && vm.voidHide==0)\"><span translate=\"DINING.CANCEL_VOID\">\nCancel Void</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\" ng-click=\"vm.removeItem()\" \nng-disabled=\"vm.cancelDisp == 0\"><span translate=\"DINING.CANCEL\">Cancel</span></md-button></div></div><div class=\"two\" \nng-if=\"vm.kotMenu==1\"><div layout=\"row\" ng-if=\"vm.voidShow==1\"><md-button \nclass=\"left-btn md-raised md-background md-orange-400-bg grey-50-fg\" ng-click=\"vm.reprintKOT(vm.kotID)\" \nng-disabled=\"vm.voidDisp==0\"><span translate=\"DINING.REPRINT_KOT\">Reprint KOT</span></md-button></div></div></div>\n</div><div class=\"client_2\"><div layout=\"row\" layout-align=\"space-between\" style=\"background:#42557c\"><div \nclass=\"column\" layout-align=\"start\"><div layout=\"row\"><span class=\"h3 grey-50-fg pl-5 pt-5\" ng-if=\"vm.billDet.bil_no\">\n<b>#{{vm.billDet.bil_no}}</b></span> <span class=\"h3 grey-50-fg pl-5 pt-5\" ng-if=\"vm.billDet.tableName\"><span \nclass=\"font-weight-500\" translate=\"DINING.TABLE_NO\">Table :</span> {{vm.billDet.tableName}}</span> <span \nclass=\"h3 grey-50-fg pl-5 pt-5\" ng-if=\"vm.billDet.customerName\"><span class=\"font-weight-500\" \ntranslate=\"DINING.CUSTOMER_NAME\">Customer :</span> {{vm.billDet.customerName}}</span></div><div layout=\"row\"><span \nclass=\"h4 grey-50-fg pl-5 pb-5\"><span class=\"font-weight-500\" translate=\"DINING.TABLE_STATUS\">Status :</span>\n {{vm.billDet.status}}</span></div></div><div class=\"column mr-10\" layout-align=\"end\"><div layout=\"row\"><span \nclass=\"h3 grey-50-fg pl-5 pt-5\" ng-if=\"vm.customerName\"><span class=\"font-weight-500\" translate=\"DINING.CUSTOMER_NAME\">\nCustomer :</span> {{vm.customerName}}</span> <span class=\"h3 grey-50-fg pl-5 pt-5\" ng-if=\"vm.waiterName\"><span \nclass=\"font-weight-500\" translate=\"DINING.WAITER_NAME\">Waiter :</span> {{vm.waiterName}}</span></div></div></div><div \nclass=\"scroll\" ms-scroll><div class=\"itmsList\" ng-repeat=\"kot in vm.billDet.kotDets\"><div layout=\"row\" \nlayout-align=\"start\" class=\"stip md-grey-200-bg\" ng-click=\"vm.showReprint(kot.kot_id)\"><div layout=\"column\"><span \nclass=\"h4 grey-50-fg font-size-12 pl-5 grey-700-fg\"><span class=\"font-weight-500\" translate=\"DINING.ORDER_NO\">Ord.NO :\n</span> {{kot.kot_no}} - {{vm.UserName}} {{kot.kot_date}}</span></div></div><div \nng-repeat=\"ki in vm.kotItems | filter:{kotitem_kot_id:kot.kot_id} | orderBy:\'$index\':true\" \nng-if=\"ki.kotitem_kot_id!=\'\'\" ng-click=\"vm.showSubMenu(ki)\" \nng-class=\"{true: \'contact-item md-green-200-bg\', false: \'contact-item\'}[ki.kotitem_id == vm.selectedItm]\"><div \nng-if=\"ki.kotitem_status==\'Submitted\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div \nalign=\"left\" layout=\"row\" layout-align=\"start\"><span class=\"font-size-18 font-weight-500 red-900-fg\">{{ki.kotitem_qty}}\n</span><span class=\"font-size-18 m-0 pl-5 font-weight-500 red-900-fg\" ng-if=\"ki.kotitem_sub_qty>0\">\n({{ki.kotitem_sub_qty}})</span><span class=\"font-weight-500 font-size-18 m-0 pl-25 red-900-fg\">{{ki.kotitem_itm_name}}\n</span></div><div align=\"right\" class=\"font-size-18 font-weight-500 red-900-fg\" layout=\"column\" layout-align=\"end\">\n{{ki.kotitem_totat | number: vm.c_d}}</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" \nlayout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">{{ki.kotitem_status}}</p>\n</div></div><div layout=\"row\" layout-align=\"space-between\" ng-repeat=\"kio in ki.kotitem_orderTagsList\" \nng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" layout-align=\"start\"><span \nclass=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span></div><div align=\"right\" \nclass=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div><div \nng-if=\"ki.kotitem_status==\'Submitted-Void\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div \nalign=\"left\" layout=\"row\" layout-align=\"start\"><s class=\"font-size-18 font-weight-600 grey-500-fg\">{{ki.kotitem_qty}}\n</s><s class=\"font-weight-600 font-size-18 m-0 pl-5 grey-500-fg\" ng-if=\"ki.kotitem_sub_qty > 0\">\n({{ki.kotitem_sub_qty}})</s><s class=\"font-weight-600 font-size-18 m-0 pl-25 grey-500-fg\">{{ki.kotitem_itm_name}}</s>\n</div><div align=\"right\" class=\"font-size-18 font-weight-600 grey-500-fg\" layout=\"column\" layout-align=\"end\"><s>\n{{ki.kotitem_totat | number: vm.c_d}}</s></div></div><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 grey-500-fg\"><s>\n{{ki.kotitem_status}}</s></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-repeat=\"kio in ki.kotitem_orderTagsList\" ng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" \nlayout-align=\"start\"><span class=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span>\n</div><div align=\"right\" class=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div><div \nng-if=\"(ki.kotitem_status==\'New-Gift\' || ki.kotitem_status==\'Submitted-Gift\') && ki.kotitem_qty>0\"><div layout=\"row\" \nlayout-align=\"space-between\"><div align=\"left\" layout=\"row\" layout-align=\"start\"><span \nclass=\"font-size-18 font-weight-600 blue-500-fg\">{{ki.kotitem_qty}}</span><span \nclass=\"font-weight-600 font-size-18 m-0 pl-5 blue-500-fg\" ng-if=\"ki.kotitem_sub_qty > 0\">({{ki.kotitem_sub_qty}})\n</span><span class=\"font-weight-600 font-size-18 m-0 pl-25 blue-500-fg\">{{ki.kotitem_itm_name}}</span></div><div \nalign=\"right\" class=\"font-size-18 font-weight-600 blue-500-fg\" layout=\"column\" layout-align=\"end\"><span>\n{{ki.kotitem_totat | number: vm.c_d}}</span></div></div><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 blue-500-fg\"><span>\n{{ki.kotitem_status}}</span></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-repeat=\"kio in ki.kotitem_orderTagsList\" ng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" \nlayout-align=\"start\"><span class=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span>\n</div><div align=\"right\" class=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div><div \nng-if=\"ki.kotitem_status==\'New-Void\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div \nalign=\"left\" layout=\"row\" layout-align=\"start\"><s class=\"font-size-18 font-weight-600 grey-500-fg\">{{ki.kotitem_qty}}\n</s><s class=\"font-weight-600 font-size-18 m-0 pl-5 grey-500-fg\" ng-if=\"ki.kotitem_sub_qty > 0\">\n({{ki.kotitem_sub_qty}})</s><s class=\"font-weight-600 font-size-18 m-0 pl-25 grey-500-fg\">{{ki.kotitem_itm_name}}</s>\n</div><div align=\"right\" class=\"font-size-18 font-weight-600 grey-500-fg\" layout=\"column\" layout-align=\"end\"><s>\n{{ki.kotitem_totat | number: vm.c_d}}</s></div></div><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 grey-500-fg\"><s>\n{{ki.kotitem_status}} {{ki.kotitem_orderTagsList.length}}</s></p></div></div><div layout=\"row\" \nlayout-align=\"space-between\" ng-repeat=\"kio in ki.kotitem_orderTagsList\" ng-if=\"ki.kotitem_orderTagsList.length>0\"><div\n align=\"left\" layout=\"row\" layout-align=\"start\"><span class=\"font-weight-600 font-size-12 orange-900-fg\">\n{{kio.kotitemtag_ordertag_name}}</span></div><div align=\"right\" class=\"font-size-12 font-weight-600 orange-900-fg\" \nlayout=\"column\" layout-align=\"end\">{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div></div></div><div \nclass=\"itmsList\"><div layout=\"row\" layout-align=\"start\" class=\"stip md-grey-200-bg\" \nng-if=\"vm.billDet.status == \'New Orders\'\"><div layout=\"column\"><span \nclass=\"h4 grey-50-fg font-size-12 pl-5 grey-700-fg\"><b translate=\"DINING.NEW_ORDER\">New Order</b></span></div></div>\n<div ng-repeat=\"ki in vm.kotItems | filter:{kotitem_kot_id:\'\'} | orderBy:\'$index\':false\" \nng-if=\"ki.kotitem_kot_id==\'\' && vm.ifCustomOrder!=\'\'\" ng-click=\"vm.showSubMenu(ki)\" \nng-class=\"{true: \'contact-item md-green-200-bg\', false: \'contact-item\'}[ki.kotitem_id == vm.selectedItm]\"><div \nng-if=\"ki.kotitem_type==\'Custom\' && !ki.kotitem_qty\"><div layout=\"row\" layout-align=\"space-between\" \nclass=\"custom-stip\"><span class=\"\">{{ki.kotitem_ordno}}</span></div></div><div \nng-if=\"ki.kotitem_status==\'New\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div align=\"left\" \nlayout=\"row\" layout-align=\"start\"><span class=\"font-size-18 font-weight-600 black-900-fg\">{{ki.kotitem_qty}}</span>\n<span class=\"font-weight-600 font-size-18 m-0 pl-25\">{{ki.kotitem_itm_name}}</span></div><div align=\"right\" \nclass=\"font-size-18 font-weight-600 black-900-fg\" layout=\"column\" layout-align=\"end\">\n{{ki.kotitem_totat | number: vm.c_d}}</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" \nlayout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 black-900-fg\">{{ki.kotitem_status}}</p>\n</div></div><div layout=\"row\" layout-align=\"space-between\" ng-repeat=\"kio in ki.kotitem_orderTagsList\" \nng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" layout-align=\"start\"><span \nclass=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span></div><div align=\"right\" \nclass=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div></div><div \nng-repeat=\"ki in vm.kotItems | filter:{kotitem_kot_id:\'\'} | orderBy:\'$index\':true\" \nng-if=\"ki.kotitem_kot_id==\'\' && vm.ifCustomOrder==\'\'\" ng-click=\"vm.showSubMenu(ki)\" \nng-class=\"{true: \'contact-item md-green-200-bg\', false: \'contact-item\'}[ki.kotitem_id == vm.selectedItm]\"><div \nng-if=\"ki.kotitem_status==\'New\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div align=\"left\" \nlayout=\"row\" layout-align=\"start\"><span class=\"font-size-18 font-weight-600 black-900-fg\">{{ki.kotitem_qty}}</span>\n<span class=\"font-weight-600 font-size-18 m-0 pl-25\">{{ki.kotitem_itm_name}}</span></div><div align=\"right\" \nclass=\"font-size-18 font-weight-600 black-900-fg\" layout=\"column\" layout-align=\"end\">\n{{ki.kotitem_totat | number: vm.c_d}}</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" \nlayout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 black-900-fg\">{{ki.kotitem_status}}</p>\n</div></div><div layout=\"row\" layout-align=\"space-between\" ng-repeat=\"kio in ki.kotitem_orderTagsList\" \nng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" layout-align=\"start\"><span \nclass=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span></div><div align=\"right\" \nclass=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div><div \nng-if=\"ki.kotitem_status==\'New-Gift\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div \nalign=\"left\" layout=\"row\" layout-align=\"start\"><span class=\"font-size-18 font-weight-600 blue-500-fg\">\n{{ki.kotitem_qty}}</span><span class=\"font-weight-600 font-size-18 m-0 pl-5 blue-500-fg\" \nng-if=\"ki.kotitem_sub_qty > 0\">({{ki.kotitem_sub_qty}})</span><span \nclass=\"font-weight-600 font-size-18 m-0 pl-25 blue-500-fg\">{{ki.kotitem_itm_name}}</span></div><div align=\"right\" \nclass=\"font-size-18 font-weight-600 blue-500-fg\" layout=\"column\" layout-align=\"end\"><span>\n{{ki.kotitem_totat | number: vm.c_d}}</span></div></div><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 blue-500-fg\"><span>\n{{ki.kotitem_status}}</span></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-repeat=\"kio in ki.kotitem_orderTagsList\" ng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" \nlayout-align=\"start\"><span class=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span>\n</div><div align=\"right\" class=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div><div \nng-if=\"ki.kotitem_status==\'New-Void\' && ki.kotitem_qty>0\"><div layout=\"row\" layout-align=\"space-between\"><div \nalign=\"left\" layout=\"row\" layout-align=\"start\"><s class=\"font-size-18 font-weight-600 grey-500-fg\">{{ki.kotitem_qty}}\n</s><s class=\"font-weight-600 font-size-18 m-0 pl-5 grey-500-fg\" ng-if=\"ki.kotitem_sub_qty > 0\">\n({{ki.kotitem_sub_qty}})</s><s class=\"font-weight-600 font-size-18 m-0 pl-25 grey-500-fg\">{{ki.kotitem_itm_name}}</s>\n</div><div align=\"right\" class=\"font-size-18 font-weight-600 grey-500-fg\" layout=\"column\" layout-align=\"end\"><s>\n{{ki.kotitem_totat | number: vm.c_d}}</s></div></div><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 grey-500-fg\"><s>\n{{ki.kotitem_status}}</s></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-repeat=\"kio in ki.kotitem_orderTagsList\" ng-if=\"ki.kotitem_orderTagsList.length>0\"><div align=\"left\" layout=\"row\" \nlayout-align=\"start\"><span class=\"font-weight-600 font-size-12 orange-900-fg\">{{kio.kotitemtag_ordertag_name}}</span>\n</div><div align=\"right\" class=\"font-size-12 font-weight-600 orange-900-fg\" layout=\"column\" layout-align=\"end\">\n{{kio.kotitemtag_ordertag_rate | number: vm.c_d}}</div></div></div></div></div></div><div class=\"blnc\"><div \nlayout=\"row\" layout-align=\"space-between\"><p class=\"show-gt-sm m-0 pt-5 black-900-fg\"><span class=\"font-weight-500\">\n{{vm.billAddons.billNotes}}</span></p></div><div class=\"pb-5\" layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"row\" layout-align=\"space-between\" layout-wrap class=\"padding-right-8\" \nstyle=\"border-right:1px solid #ddd;width:70%;min-width:70%\" ng-if=\"vm.kotItems.length > 0\"><div class=\"select_1 pt-5\" \nlayout=\"row\" flex=\"50\" ng-if=\"vm.billAddons.bil_tottaxamt!=0\"><p \nclass=\"show-gt-sm m-0 mr-5 black-600-fg font-weight-400\" translate=\"DINING.BILL_AMOUNT\">Bill Amount :</p><p \nclass=\"show-gt-md m-0 black-600-fg font-weight-500\">{{vm.billAddons.bil_totalamt | number: vm.c_d}}</p></div><div \nclass=\"select_1 pt-5\" style=\"text-align: right\" layout=\"row\" flex=\"50\" ng-if=\"vm.billAddons.bil_totextraamt!=0\"><p \nclass=\"show-gt-sm m-0 mr-5 black-600-fg font-weight-400\" translate=\"DINING.EXTRA_CHARGE\">Extra Charges :</p><p \nclass=\"show-gt-md m-0 black-600-fg font-weight-500\">{{vm.billAddons.bil_totextraamt | number: vm.c_d}}</p></div><div \nclass=\"select_1 pt-5\" layout=\"row\" flex=\"50\" ng-if=\"vm.billAddons.bil_tottaxamt!=0\"><p \nclass=\"show-gt-sm m-0 mr-5 black-600-fg font-weight-400\" translate=\"DINING.TAX\">Tax :</p><p \nclass=\"show-gt-md m-0 black-600-fg font-weight-500\">{{vm.billAddons.bil_tottaxamt | number: vm.c_d}}</p></div><div \nclass=\"select_1 pt-5\" layout=\"row\" flex=\"50\" ng-if=\"vm.billAddons.bil_totaldiscount!=0\"><p \nclass=\"show-gt-sm m-0 mr-5 black-600-fg font-weight-400\" translate=\"DINING.DISCOUNT\">Discount :</p><p \nclass=\"show-gt-md m-0 black-600-fg\"><span class=\"font-weight-500\">{{vm.billAddons.bil_totaldiscount | number: vm.c_d}}\n</span></p></div></div><div class=\"select_1 pt-5 pl-8\" layout=\"row\" layout-align=\"start center\" \nstyle=\"width:30%;min-width:30%\" ng-if=\"vm.kotItems.length > 0\"><p \nclass=\"show-gt-sm m-0 mr-5 red-900-fg font-weight-400\" translate=\"DINING.BALANCE\">Balance :</p><p \nclass=\"show-gt-md m-0 red-900-fg font-weight-700\" style=\"font-size:20px\">{{vm.totalAmountFinal | number: vm.c_d}}</p>\n</div></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"vm.deptType!=\'Online\'\"><div layout=\"column\" \nclass=\"btm-btn\" ng-if=\"vm.ifSettleBtnShow==1\"><md-button \nclass=\"btm-btn md-raised md-background md-green-600-bg grey-50-fg\" ng-click=\"vm.saveBill()\" \nng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) || vm.saveFlag==0\"><span>{{vm.settleBtnLabel}}</span>\n</md-button></div><div layout=\"column\" class=\"btm-btn\" ng-if=\"vm.ifKotBtnShow==1\"><md-button \nclass=\"btm-btn kot-btn md-raised md-background md-teal-600-bg grey-50-fg\" ng-click=\"vm.saveKOT()\" \nng-disabled=\"vm.kotItems.length==0 || vm.existBtn==0 || vm.saveFlag==0\"><span>{{vm.kotBtnLabel}}</span></md-button>\n</div><div layout=\"column\" class=\"btm-btn\"><md-button class=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" \nng-click=\"vm.gotoExit()\"><span translate=\"DINING.EXIT\">Exit</span></md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" class=\"btm-btn\" ng-repeat=\"pmode in vm.payMode | limitTo:3\">\n<md-button class=\"btm-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline(pmode)\" \nng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) || vm.saveFlag==0\" style=\"background:#04738C\" \nng-if=\"$index%6==0\"><span>{{pmode}}</span></md-button><md-button class=\"btm-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline(pmode)\" ng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) || vm.saveFlag==0\" \nstyle=\"background:#ffb74d\" ng-if=\"$index%6==1\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-blue-500-bg grey-50-fg\" ng-click=\"vm.closeBillasOnline(pmode)\" \nng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) || vm.saveFlag==0\" ng-if=\"$index%6==2\"><span>{{pmode}}\n</span></md-button><md-button class=\"btm-btn md-raised md-background md-orange-500-bg grey-50-fg\" \nng-click=\"vm.closeBillasOnline(pmode)\" \nng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) vm.kotItems.length==0 || vm.saveFlag==0\" \nng-if=\"$index%6==3\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-green-500-bg grey-50-fg\" ng-click=\"vm.closeBillasOnline(pmode)\" \nng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) vm.kotItems.length==0 || vm.saveFlag==0\" \nng-if=\"$index%6==4\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-pink-500-bg grey-50-fg\" ng-click=\"vm.closeBillasOnline(pmode)\" \nng-disabled=\"(vm.billAddons.bil_print==0 && vm.showMode==0) || vm.saveFlag==0\" ng-if=\"$index%6==5\"><span>{{pmode}}\n</span></md-button></div></div></div></div><div class=\"sidenav\" ng-if=\"vm.sideItms==1\"><div class=\"client_3\" ms-scroll>\n<div class=\"scroll\" ms-scroll><div ng-repeat=\"cat in vm.categoryList | filter:{deptShow:1}\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"cat.category_color==1\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"grey cntr-btn\" md-ink-ripple ng-click=\"vm.setCategory(cat.category_id)\" \nstyle=\"background:#4FADAC\"><ms-widget-front layout-align=\"center center\"><div class=\"img-bx\" layout=\"row\" \nlayout-align=\"center center\"></div><div class=\"cat-nm\" layout=\"row\" style=\"background:none;align-items:center\"><span>\n{{cat.category_name}}</span></div><div class=\"item-count\" layout=\"row\" layout-align=\"center center\"><span>\n{{cat.itemsCount}}</span></div></ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"cat.category_color==2\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"grey cntr-btn\" \nmd-ink-ripple ng-click=\"vm.setCategory(cat.category_id)\" style=\"background:#D95578\"><ms-widget-front \nlayout-align=\"center center\"><div class=\"img-bx\" layout=\"row\" layout-align=\"center center\"></div><div class=\"cat-nm\" \nlayout=\"row\" style=\"background:none;align-items:center\"><span>{{cat.category_name}}</span></div><div \nclass=\"item-count\" layout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}</span></div></ms-widget-front>\n</ms-widget></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"cat.category_color==3\"><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" class=\"grey cntr-btn\" md-ink-ripple \nng-click=\"vm.setCategory(cat.category_id)\" style=\"background:#ffb74d\"><ms-widget-front layout-align=\"center center\">\n<div class=\"img-bx\" layout=\"row\" layout-align=\"center center\"></div><div class=\"cat-nm\" layout=\"row\" \nstyle=\"background:none;align-items:center\"><span>{{cat.category_name}}</span></div><div class=\"item-count\" \nlayout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}</span></div></ms-widget-front></ms-widget></div><div\n layout=\"row\" layout-align=\"center center\" ng-if=\"cat.category_color==0\"><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" class=\"grey cntr-btn\" md-ink-ripple ng-click=\"vm.setCategory(cat.category_id)\" style=\"background:#FF9B71\">\n<ms-widget-front layout-align=\"center center\"><div class=\"img-bx\" layout=\"row\" layout-align=\"center center\"></div><div \nclass=\"cat-nm\" layout=\"row\" style=\"background:none;align-items:center\"><span>{{cat.category_name}}</span></div><div \nclass=\"item-count\" layout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}</span></div></ms-widget-front>\n</ms-widget></div></div></div></div><div class=\"client_4\"><div id=\"itmHolder\" class=\"scroll\" ms-scroll \nng-style=\"vm.itmstyle\"><div layout=\"row\" layout-align=\"start center\" class=\"itm-bx\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"itm in vm.productList | filter:{catitm_category_id:vm.selCatID}:true | filter:{deptShow:1}\" \nlayout-align=\"start left\" ng-if=\"vm.catInp==1\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"cntr-btn\" md-ink-ripple ng-click=\"vm.addItmtoKot(itm)\" \nng-if=\"itm.unavailableStatus==0\"><ms-widget-front><div class=\"img-bx\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"itm-img\" ng-src=\"{{itm.image}}\"></div><div class=\"itm-nm-bx\" layout=\"row\" layout-align=\"center\" \nstyle=\"align-items:center;background:none\"><span class=\"itm-nm\">{{itm.item_name}}</span></div><div class=\"rate\" \nlayout=\"column\" layout-align=\"end\"><span>{{vm.c_s}} {{itm.item_price | number:vm.c_d}}</span></div><span class=\"stock\" \nng-if=\"itm.item_stock>0\">{{itm.item_stock}}</span></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"cntr-btn\" md-ink-ripple \nng-if=\"itm.unavailableStatus==1\"><ms-widget-front><div class=\"img-bx\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"itm-img\" ng-src=\"{{itm.image}}\"></div><div class=\"itm-nm-bx\" layout=\"row\" layout-align=\"center\" \nstyle=\"align-items:center;background:none\"><span class=\"itm-nm\">{{itm.item_name}}</span></div><div class=\"rate\" \nlayout=\"column\" layout-align=\"end\"><span translate=\"DINING.SOLD_OUT\">Sold Out</span></div></ms-widget-front>\n</ms-widget></div><div class=\"colm\" layout=\"column\" \nng-repeat=\"itm in filtered = (vm.productList | filter: vm.searchItm | filter:{deptShow:1}) | limitTo:20\" \nlayout-align=\"start left\" ng-if=\"vm.catInp==0\"><ms-widget flippable=\"true\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" class=\"cntr-btn\" md-ink-ripple ng-click=\"vm.addItmtoKot(itm)\" \nng-if=\"itm.unavailableStatus==0\"><ms-widget-front layout-align=\"center center\"><div class=\"img-bx\" layout=\"row\" \nlayout-align=\"center center\"><img class=\"itm-img\" ng-src=\"{{itm.image}}\"></div><div class=\"itm-nm-bx\" layout=\"row\" \nlayout-align=\"center\" style=\"align-items:center;background:none\"><span class=\"itm-nm\">{{itm.item_name}}</span></div>\n<div class=\"rate\" layout=\"column\" layout-align=\"end\"><span>{{vm.c_s}} {{itm.item_price | number:vm.c_d}}</span></div>\n<span class=\"stock\" ng-if=\"itm.item_stock>0\">{{itm.item_stock}}</span></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" layout-align=\"center center\" flex=\"100\" class=\"cntr-btn\" md-ink-ripple \nng-if=\"itm.unavailableStatus==1\"><ms-widget-front layout-align=\"center center\"><div class=\"img-bx\" layout=\"row\" \nlayout-align=\"center center\"><img class=\"itm-img\" ng-src=\"{{itm.image}}\"></div><div class=\"itm-nm-bx\" layout=\"row\" \nlayout-align=\"center\" style=\"align-items:center;background:none\"><span class=\"itm-nm\">{{itm.item_name}}</span></div>\n<div class=\"rate\" layout=\"column\" layout-align=\"end\"><span translate=\"DINING.SOLD_OUT\">Sold Out</span></div>\n</ms-widget-front></ms-widget></div></div><div class=\"fxd-colm\" ng-if=\"vm.catInp==0 && filtered.length > 20\"><span \ntranslate=\"DINING.SHOWING\">Showing</span> <span style=\"font-size:18px;font-weight:700\">20 out of {{filtered.length}}\n</span></div></div><div class=\"kypad\"><md-button class=\"md-fab md-mini\" aria-label=\"Eat cake\" \nng-click=\"vm.showKeyboard()\" ng-if=\"vm.key==1\"><i class=\"icon icon-keyboard s35 pt-10 green-50-fg\"></i></md-button>\n<table class=\"simple\" ms-responsive-table ng-style=\"vm.keystyle\"><thead></thead><tbody><tr><td colspan=\"3\">\n<md-input-container flex class=\"inpt\"><input type=\"text\" name=\"input\" id=\"input\" ng-model=\"vm.input\" \nng-bind=\"vm.input\" ng-keyup=\"vm.checkInput()\"></md-input-container><md-button \nclass=\"clr-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.clearInput()\"><span>C</span></md-button>\n</td></tr><tr><td style=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background\" \nng-click=\"vm.addInput(\'1\')\"><span>1</span></md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'2\')\"><span>2</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'3\')\">\n<span>3</span></md-button></td></tr><tr><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'4\')\"><span>4</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'5\')\">\n<span>5</span></md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'6\')\"><span>6</span></md-button></td></tr><tr><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'7\')\">\n<span>7</span></md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'8\')\"><span>8</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'9\')\">\n<span>9</span></md-button></td></tr><tr><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background\" ng-disabled=\"true\"><span>,</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background\" ng-click=\"vm.addInput(\'0\')\">\n<span>0</span></md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background\" ng-disabled=\"false\" ng-click=\"vm.hideKeyboard()\"><i \nclass=\"icon icon-keyboard-off s35\" style=\"color:#fff\"></i></md-button></td></tr></tbody></table></div></div></div><div \nclass=\"sidenav-two\" ng-if=\"vm.sideMessage==1\"><div class=\"client_5\" ng-if=\"vm.nacMessage==1\"><h3 class=\"tlt\" \ntranslate=\"DINING.REASON_NAC\">Reason for NAC</h3><div class=\"client_5bx1\"><div class=\"search-bx\" layout=\"row\" \nlayout-align=\"start center\"><input type=\"text\" name=\"searchCust\" ng-model=\"vm.extraMsg\" placeholder=\"Reason for NAC\" \nstyle=\"margin:0px\"><md-button class=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" \nng-click=\"vm.closeBillasOnline2(\'NAC\')\"><span>Save as NAC</span></md-button></div></div></div><div class=\"client_5\" \nng-if=\"vm.giftMessage==1\"><h3 class=\"tlt\" translate=\"DINING.REASON_GIFT\">Reason for Gift</h3><div class=\"client_5bx1\">\n<div class=\"search-bx\" layout=\"row\" layout-align=\"start center\"><input type=\"text\" name=\"searchCust\" \nng-model=\"vm.extraMsg\" placeholder=\"Reason for Gift\" style=\"margin:0px\"><md-button \nclass=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" ng-click=\"vm.setAsGift2()\"><span>Gift Now</span>\n</md-button></div></div></div><div class=\"client_5\" ng-if=\"vm.voidMessage==1\"><h3 class=\"tlt\" \ntranslate=\"DINING.REASON_VOID\">Reason for Void</h3><div class=\"client_5bx1\"><div class=\"search-bx\" layout=\"row\" \nlayout-align=\"start center\"><input type=\"text\" name=\"extraMsg\" ng-model=\"vm.extraMsg\" placeholder=\"Reason for Void\" \nstyle=\"margin:0px\"><md-button class=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" \nng-click=\"vm.setAsVoid2()\"><span>Void Now</span></md-button></div></div></div></div><div class=\"sidenav-two\" \nng-if=\"vm.sideOpts==1\"><div class=\"client_5\"><h3 class=\"tlt\" translate=\"DINING.PORTION\">Portions</h3><div layout=\"row\" \nlayout-align=\"start center\" class=\"clnt-bx\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"opt in vm.itmOptions | filter:{item_price_tag_id:vm.seletedPriceTag}:true\"><md-button \nclass=\"tp-btn md-raised md-background md-grey-300-bg grey-800-fg\" ng-click=\"vm.changeItmOption(opt)\" \nng-if=\"opt.unavailabeleStatus==0\"><span>{{opt.itm_option_name}}</span></md-button><md-button \nclass=\"tp-btn md-raised md-background md-grey-300-bg grey-800-fg\" ng-if=\"opt.unavailabeleStatus==1\"><span>\n{{opt.itm_option_name}}</span></md-button></div></div></div><div class=\"client_5\" ng-repeat=\"tags in vm.orderTagList\">\n<h3 class=\"tlt\">{{tags.order_tag_name}}</h3><div class=\"client_5-inr\"><div layout=\"row\" layout-wrap \nlayout-align=\"start left\"><h3 class=\"chip\" ng-repeat=\"tag in vm.selOrderTags\">{{tag.kotitemtag_ordertag_name}} <span \nng-click=\"vm.removeTags(tag.kotitemtag_tag_id)\" ng-if=\"vm.selOrderTagStatus==\'New\'\"><md-icon md-font-icon=\"icon-close\" \nclass=\"icon\"></md-icon></span></h3></div><div layout=\"row\" layout-wrap layout-align=\"start left\"><input type=\"text\" \nname=\"tag_name\" id=\"tag_name\" ng-model=\"vm.orderTagOpt.tag_name\" placeholder=\"Kitchen Note\"> <input type=\"text\" \nname=\"tag_rate\" ng-model=\"vm.orderTagOpt.tag_rate\" placeholder=\"Price\"><md-button \nclass=\"add-btn md-raised md-background md-green-500-bg grey-50-fg\" ng-click=\"vm.setOrderTags2(vm.orderTagOpt.tag_opt)\">\n<span translate=\"DINING.ADD\">Add</span></md-button></div><div ng-if=\"vm.orderTagErr==1\" layout=\"row\" layout-wrap \nlayout-align=\"start left\" style=\"color: red; font-weight: 600; font-size: 14px\"><b translate=\"DINING.ALERT_KITNOTE\">\nPlease enter kitchen notes.</b></div><div layout=\"row\" layout-wrap layout-align=\"start left\"><b \ntranslate=\"DINING.ALERT_KITNOTE_AMOUNT\">(kitchen notes amount will added to each item)</b></div></div><div \nlayout=\"row\" layout-align=\"start\" class=\"clnt-bx ordr-tag\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"tagOp in tags.orderTagOptions\"><md-button class=\"tp-btn md-raised md-background md-grey-300-bg grey-800-fg\" \nng-click=\"vm.setOrderTags(tagOp)\" ng-if=\"tagOp.status==0\"><span>{{tagOp.ordertagoption_name}}</span></md-button>\n<md-button class=\"tp-btn md-raised md-background md-red-300-bg grey-800-fg\" ng-click=\"vm.setOrderTags(tagOp)\" \nng-if=\"tagOp.status==1\"><span>{{tagOp.ordertagoption_name}}</span></md-button></div></div></div><div class=\"client_5\">\n<div class=\"kypad\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeTicketNote()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div></div><div class=\"sidenav-two\" \nng-if=\"vm.sideRetails==1\"><div class=\"client_5\"><div class=\"client_5bx1\"><div class=\"search-bx\" layout=\"row\" \nlayout-align=\"start center\"><input type=\"text\" name=\"retailItm\" id=\"retailItm\" ng-model=\"vm.retailDets.retailItm\" \nplaceholder=\"Item\" style=\"margin:0px 5px 0px 0px\" ng-keyup=\"$event.keyCode == 13 ? vm.getItmDets() : null\" \nng-change=\"vm.getItmDets2()\"><h4 class=\"m-0 pr-5\"><b>{{vm.retailDets.retailItmUnit}}</b></h4><input type=\"text\" \nname=\"retailQty\" id=\"retailQty\" ng-model=\"vm.retailDets.retailQty\" placeholder=\"Qty\" \nstyle=\"margin:0px 5px 0px 0px; width:150px\" ng-keyup=\"$event.keyCode == 13 ? vm.gotoAdd() : null\"><md-button \nid=\"retailAddBtn\" class=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" \nng-click=\"vm.addItmtoKotRetails()\" style=\"border-radius:7px;margin-left:5px\" \nng-disabled=\"vm.retailDets.retailQty==\'\' || vm.retailDets.retailQty==0\"><span translate=\"DINING.ADD\">Add</span>\n</md-button><md-button class=\"add-btn md-raised md-background md-red-600-bg\" \nstyle=\"min-width:50px;border-radius:7px;margin-left:5px\" ng-click=\"vm.clearRetailItm()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"grey-50-fg\"></md-icon></md-button></div><div class=\"tble-indication\" layout=\"row\" \nlayout-align=\"start center\"><h6 translate=\"DINING.INDIC_MINQTY\"><span style=\"background:rgba(67, 160, 71, 0.5)\"></span>\n Item Reached Min-Qty</h6><h6 translate=\"DINING.INDIC_EXPIRED\"><span style=\"background:rgba(229, 57, 53, 0.5)\"></span>\n Item Expired</h6><h6 translate=\"DINING.INDIC_SHOR_EXPIRED\"><span style=\"background:rgba(255, 183, 77, 0.5)\"></span>\n Item Short Expired</h6></div><div><div class=\"cutsmr-tbl cutsmr-tbl2\"><table><thead><tr><th></th><th \ntranslate=\"DINING.CUSTBL_CODE\">Code</th><th translate=\"DINING.CUSTBL_ITEM\" style=\"text-align:left!important\">Item</th>\n<th translate=\"DINING.CUSTBL_AVAILABILITYQTY\">Available Qty</th><th translate=\"DINING.CUSTBL_PRICE\">Price</th><th \ntranslate=\"DINING.CUSTBL_BATCH\" style=\"width:160px\">Batch</th></tr></thead><tbody \nng-repeat=\"itm in vm.productList | filter:{deptShow:1} | filter:vm.retailDets.retailItm\"><tr \nng-click=\"vm.selRetailItm(itm)\"><td align=\"center\"><div layout=\"row\" layout-align=\"center center\"><h6 \nng-if=\"itm.isExpired==0\" style=\"margin:0px 5px 0px 0px\"><span style=\"background:rgba(229, 57, 53, 0.5);margin:0px\">\n</span></h6><h6 ng-if=\"itm.isShortExpired==0\" style=\"margin:0px 5px 0px 0px\"><span \nstyle=\"background:rgba(255, 183, 77, 0.5);margin:0px\"></span></h6><h6 ng-if=\"itm.minReorder==1\" \nstyle=\"margin:0px 5px 0px 0px\"><span style=\"background:rgba(67, 160, 71, 0.5);margin:0px\"></span></h6></div></td><td \nalign=\"center\">{{itm.item_code}}</td><td align=\"left\">{{itm.item_name}}</td><td align=\"center\">\n{{itm.item_currqty | number: vm.c_d}} {{itm.unit_name}}</td><td align=\"right\">{{itm.item_price | number: vm.c_d}}</td>\n<td align=\"center\"><span ng-if=\"itm.lastBatch==\'00/00/0000\'\">- </span><span ng-if=\"itm.lastBatch!=\'00/00/0000\'\">\n{{itm.lastBatch}}</span><md-icon md-font-icon=\"icon-chevron-down\" ng-style=\"vm.retailtblarrow\" \nng-if=\"itm.batchList.length>1\"></md-icon></td></tr><tr class=\"sub-tbl\" \nng-if=\"itm.batchList.length>1 && itm.showBatch==1\" ng-repeat=\"batch in itm.batchList\" \nng-click=\"vm.selRetailItmBatch(itm,batch)\"><td align=\"center\" colspan=\"3\"><h6 ng-if=\"batch.isExpired==0\"><span \nstyle=\"background:rgba(229, 57, 53, 0.5)\"></span></h6><h6 ng-if=\"batch.isShortExpired==0\"><span \nstyle=\"background:rgba(255, 183, 77, 0.5)\"></span></h6></td><td align=\"center\">\n{{batch.inventory_currqty | number: vm.c_d}} {{itm.unit_name}}</td><td align=\"right\">\n{{batch.inventory_selling_price | number: vm.c_d}}</td><td align=\"center\"><span \nng-if=\"batch.inventory_expiry_date2==\'00/00/0000\'\">- </span><span ng-if=\"batch.inventory_expiry_date2!=\'00/00/0000\'\">\n{{batch.inventory_expiry_date2}}</span></td></tr></tbody></table></div></div></div></div></div><div \nclass=\"sidenav-two\" ng-if=\"vm.sideCust==1\"><div class=\"client_5\"><div class=\"client_5bx1\" ng-if=\"vm.customerBox==2\">\n<div class=\"search-bx\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.listCustomer==1\"><input type=\"text\" \nname=\"bil_timing\" ng-model=\"vm.billAddons.bil_timing\" placeholder=\"Preparation Time (In min(s) only)\" \nstyle=\"margin:0px\"></div></div><div class=\"client_5bx1\" ng-if=\"vm.customerBox==1\"><div class=\"search-bx\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.listCustomer==1\"><input type=\"text\" name=\"searchCust\" ng-model=\"vm.searchCust\" \nplaceholder=\"Search Customer\" ng-keyup=\"vm.searchCustomer()\" style=\"margin:0px\"><md-button \nclass=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" ng-click=\"vm.addCustomer()\"><span \ntranslate=\"DINING.ADD\">Add</span></md-button></div><div class=\"search-bx\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.listCustomer==0\"><form name=\"customerForm\" class=\"md-inline-form\" novalidate><h3 \nclass=\"m-0 font-size-16 pt-20 pb-10\" translate=\"DINING.ADDCUSTOMER\">Add Customer</h3><div layout=\"row\" \nlayout-align=\"start center\"><input type=\"text\" name=\"customer_name\" ng-model=\"vm.customer.customer_name\" required \nplaceholder=\"Customer Name\"> <input type=\"text\" name=\"customer_mobileno\" ng-model=\"vm.customer.customer_mobileno\" \nplaceholder=\"Customer Mobile No\"></div><div layout=\"row\" layout-align=\"start center\"><textarea \nplaceholder=\"Customer Address\" name=\"customer_address\" rows=\"3\" ng-model=\"vm.customer.customer_address\"></textarea>\n</div><br><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" ng-click=\"vm.saveCustomer()\"><span>Save</span>\n</md-button><md-button class=\"add-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.resetCustomer()\">\n<span>Cancel</span></md-button></div></form></div><div ng-if=\"vm.listCustomer==1\"><div class=\"cutsmr-tbl\"><table>\n<thead><tr><th translate=\"DINING.CUSTBLE_CUSNAME\">Customer Name</th><th translate=\"DINING.CUSTBLE_CUSMOB\">\nCustomer Mobile No</th></tr></thead><tbody><tr ng-repeat=\"cust in vm.customerList\" \nng-style=\"{\'background\':vm.billAddons.bil_cusid==cust.customer_id ? \'rgba(67, 160, 71, 0.3)\' : \'\' }\" \nng-click=\"vm.setCustomerDets(cust)\"><td>{{cust.customer_name}}</td><td>{{cust.customer_mobileno}}</td></tr></tbody>\n</table></div></div><div layout=\"row\" layout-align=\"start center\" class=\"clnt-bx\"></div></div><div class=\"client_5bx2\" \nng-if=\"vm.customerBox==0\"><div class=\"ac-container\"><div class=\"acrndn-bx\"><input id=\"ac-1\" name=\"accordion-1\" \ntype=\"radio\" checked=\"checked\"><label for=\"ac-1\" translate=\"DINING.ACCRDION_CUSDTLS\">Customer Details <i \nclass=\"icon icon-chevron-down\"></i></label><article><div class=\"dtls\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div layout=\"column\" flex=\"50\"><h4 translate=\"DINING.ACCRDION_CUSNAME\">Customer Name</h4><span>\n{{vm.customerName}}</span></div><div layout=\"column\" flex=\"50\"><h4 translate=\"DINING.ACCRDION_CUSMOB\">\nCustomer Mobile No</h4><span>{{vm.customerMobile}}</span></div><div layout=\"column\" flex=\"100\"><h4 \ntranslate=\"DINING.ACCRDION_CUSADDRESS\">Customer Address</h4><span>{{vm.customerAddress}}</span></div><div \nlayout=\"column\" flex=\"100\" ng-if=\"vm.activeTbl==1\"><div class=\"alert\" translate=\"DINING.ALERT_DIFFUSER\">\nDifferent users using same, Please change table</div></div><div layout=\"column\" flex=\"100\" ng-if=\"vm.ifCustomType!=\'\'\">\n<div translate=\"DINING.ALERT_CLSORDER\" class=\"alert\" ng-if=\"vm.ifCustomType==\'Billing\'\">\nCustomer want bill for close the order.</div></div><div layout=\"column\" flex=\"100\" ng-if=\"vm.ifCustomNotes.length>0\" \nclass=\"note\"><h4 translate=\"DINING.ACCRDION_CUSDNOTE\">Notes</h4><div ng-repeat=\"note in vm.ifCustomNotes\" \nng-if=\"!note.customerkot_notes==\'\'\"><span>#{{note.customerkot_no}}</span><p>{{note.customerkot_notes}}</p></div></div>\n</div></article></div><div class=\"acrndn-bx\"><input id=\"ac-2\" name=\"accordion-1\" type=\"radio\"><label for=\"ac-2\" \ntranslate=\"DINING.ACCRDION_RCNTBILL\">Recent Bills <i class=\"icon icon-chevron-down\"></i></label><article><div \nclass=\"tbl\"><div layout=\"row\" layout-wrap class=\"card-bx\"><div class=\"card\" ng-repeat=\"recent in vm.customerRecent\" \nng-click=\"vm.customertbleHideshow(recent.bil_id)\"><span>{{recent.bil_date}}</span><div layout=\"row\" \nlayout-align=\"space-between\"><h6 style=\"color:#34a353\">{{recent.bil_type}}</h6><h6>\n{{vm.c_s}} {{recent.nettTotal | number: vm.c_d}}</h6></div></div></div><div \nng-repeat=\"recent in vm.customerRecent | filter:{bil_id:vm.customerBillID}:true\"><div class=\"bls-dtls\"><div \nlayout=\"row\" layout-align=\"space-between\"><h6 class=\"bill-no m-0\" translate=\"DINING.ACCRDION_BILNO\">Bill No: <span \nstyle=\"color:#34a353\">{{recent.bil_no}}</span></h6><h6 class=\"bill-no m-0\">{{recent.bil_date}}</h6></div><div \nlayout=\"row\" layout-align=\"space-between\"><h6 class=\"bill-no pt-0 m-0\" translate=\"DINING.ACCRDION_DEPTNAM\">Dept. Name: \n<span style=\"color:#34a353\">{{recent.bil_type}}</span></h6></div><div class=\"scroll\"><div layout=\"column\" \nlayout-align=\"space-between\" style=\"border-bottom: 1px solid rgba(0,0,0,0.10)\" ng-repeat=\"itm in recent.itmList\"><div \nlayout=\"row\" layout-align=\"start\"><span>{{itm.bitm_qty}}</span> <span>{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></span></div><div \nng-if=\"itm.orderTagsList.length>0\" ng-repeat=\"order in itm.orderTagsList\" class=\"option\"><span>\n*** {{order.billitemtag_ordertag_name}}</span></div></div></div><div class=\"blnc\"><div layout=\"row\" \nlayout-align=\"space-between\"><h5 class=\"m-0\" translate=\"DINING.TOTAL_GROSS\">Gross Total:</h5><span>\n{{vm.c_s}} {{recent.bil_totalamt | number: vm.c_d}}</span></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"(recent.bil_discountamt + recent.bil_round)>0\"><h5 class=\"m-0\" translate=\"DINING.TOTAL_DISCOUNT\">Discount:</h5>\n<span>{{vm.c_s}} {{recent.discTotal | number: vm.c_d}}</span></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"recent.bil_tottaxamt>0\"><h5 class=\"m-0\" translate=\"DINING.TOTAL_TAX\">Tax:</h5><span>\n{{vm.c_s}} {{recent.bil_tottaxamt | number: vm.c_d}}</span></div><div layout=\"row\" layout-align=\"space-between\"><h5 \nclass=\"m-0\" translate=\"DINING.TOTAL_NETT\">Nett Total:</h5><span>{{vm.c_s}} {{recent.nettTotal | number: vm.c_d}}</span>\n</div></div></div></div></div></article></div></div></div><div class=\"kypad\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"btm-btn md-raised md-background md-green-400-bg grey-50-fg\" \nng-click=\"vm.changeTimeBox()\"><span translate=\"DINING.SETTIME_BTN\">Set Time</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-orange-400-bg grey-50-fg\" ng-click=\"vm.changeCustomerBox()\"><span \ntranslate=\"DINING.CHANGEBTN\">Change</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeTicketNote()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div><div class=\"sidenav-two\" \nng-if=\"vm.sideOrderNo==1\"><div class=\"client_5\"><div layout=\"row\" layout-align=\"left\" class=\"tp-bx\"><h3 \nclass=\"m-0 font-size-16 font-weight-500 pt-5\" style=\"\" translate=\"DINING.GROSSID\">Order ID :</h3><md-input-container \nflex><input type=\"text\" name=\"price_tag_name\" ng-model=\"vm.billAddons.bil_orderID\" required></md-input-container>\n<md-button class=\"md-fab md-mini cls-btn\" ng-click=\"vm.closeTicketNote()\"><md-icon md-font-icon=\"icon-check\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-check\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</md-button></div><div class=\"kypad\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" \nng-click=\"vm.closeTicketNote()\"><span translate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div>\n</div><div class=\"sidenav-two\" ng-if=\"vm.sideWaiter==1\"><div class=\"client_5\"><div layout=\"row\" layout-align=\"left\" \nclass=\"tp-bx\"><h3 class=\"m-0 font-size-16 font-weight-500 pt-5\" style=\"\" translate=\"DINING.WAITERREFNO\">\nWaiter Reference No :</h3><md-input-container flex><input type=\"text\" name=\"price_tag_name\" \nng-model=\"vm.billAddons.bil_kotrefno\" required></md-input-container><md-button class=\"md-fab md-mini cls-btn\" \nng-click=\"vm.closeTicketNote()\"><md-icon md-font-icon=\"icon-check\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-check\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</md-button></div><h3 class=\"m-0 font-size-16 pl-10 pt-20\" translate=\"DINING.SIDNAV_WAITER\">Waiters</h3><hr><div \nlayout=\"row\" layout-align=\"start center\" class=\"clnt-bx\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"wait in vm.waiterList\"><md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.setWaiterDets(wait)\" \nng-if=\"vm.billAddons.bil_stfid!=wait.waiter_id\"><span>{{wait.waiter_name}}</span></md-button><md-button \nclass=\"tp-btn btn-active md-raised md-background\" ng-click=\"vm.setWaiterDets(wait)\" \nng-if=\"vm.billAddons.bil_stfid==wait.waiter_id\"><span>{{wait.waiter_name}}</span></md-button></div></div><div \nclass=\"kypad\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeTicketNote()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div></div><div class=\"sidenav-two\" \nng-if=\"vm.sidePendparcel==1\"><div class=\"client_5\"><h3 class=\"m-0 font-size-16 pl-10 pt-20\" \ntranslate=\"DINING.SIDNAV_PENDINGBILL\">Pending Bills</h3><hr><div layout=\"row\" layout-align=\"start\" class=\"clnt-bx\" \nstyle=\"height: calc(72vh - 0px);overflow: auto;padding-top: 5%\"><div class=\"colm\" layout=\"column\" \nng-repeat=\"bill in vm.pendParcelBills\"><md-button class=\"tp-btn md-raised md-background\" \nng-click=\"vm.setPendingBill(bill)\" ng-if=\"vm.billDet.billDets.bil_id!=bill.bil_id\"><span>#{{bill.bil_no}}<br>\n{{bill.pendTotal | number: vm.c_d}}</span></md-button><md-button class=\"tp-btn btn-active md-raised md-background\" \nng-click=\"vm.setPendingBill(bill)\" ng-if=\"vm.billDet.billDets.bil_id==bill.bil_id\"><span>{{bill.bil_no}}<br>\n{{bill.pendTotal | number: vm.c_d}}</span></md-button></div></div><div class=\"kypad\"><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeTicketNote()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div></div><div class=\"sidenav-two\" \nng-if=\"vm.sidePendRetail==1\"><div class=\"client_5\"><h3 class=\"m-0 font-size-16 pl-10 pt-20\" \ntranslate=\"DINING.SIDNAV_DUEBILL\">Due Bills</h3><hr><div layout=\"row\" layout-align=\"start center\" class=\"clnt-bx\"><div \nclass=\"colm\" layout=\"column\" ng-repeat=\"bill in vm.pendRetailBills\"><md-button class=\"tp-btn md-raised md-background\" \nng-click=\"vm.gotoSettle(bill.bil_id)\" ng-if=\"vm.billDet.billDets.bil_id!=bill.bil_id\"><span>#{{bill.bil_no}}<br>\n{{bill.pendTotal | number: vm.c_d}}</span></md-button><md-button class=\"tp-btn btn-active md-raised md-background\" \nng-click=\"vm.gotoSettle(bill.bil_id)\" ng-if=\"vm.billDet.billDets.bil_id==bill.bil_id\"><span>{{bill.bil_no}}<br>\n{{bill.pendTotal | number: vm.c_d}}</span></md-button></div></div><div class=\"kypad\"><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeRetailBills()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div></div><div \nclass=\"sidenav-two discount-sec\" ng-if=\"vm.sideDiscount==1\"><div class=\"client_5\"><h3 \nclass=\"m-0 font-size-16 pl-10 pt-20\" translate=\"DINING.SIDNAV_BILLDIS\">Bill Discount</h3><hr><div layout=\"row\" \nlayout-align=\"start center\" class=\"clnt-bx\"><div class=\"search-bx\" layout=\"row\" layout-align=\"start center\"><input \ntype=\"text\" name=\"discountRate\" id=\"discountRate\" ng-model=\"vm.discountDets.discountRate\" \nplaceholder=\"In Percentage(%)\" style=\"margin:0px 5px 0px 0px\" \nng-keyup=\"$event.keyCode == 13 ? vm.getDiscAmount() : null\" ng-blur=\"vm.getDiscAmount()\"> <input type=\"text\" \nname=\"discountAmount\" id=\"discountAmount\" ng-model=\"vm.discountDets.discountAmount\" placeholder=\"In Amount\" \nstyle=\"margin:0px 5px 0px 0px; width:150px\" ng-keyup=\"$event.keyCode == 13 ? vm.gotoDiscAdd() : vm.getDiscAmt($event)\">\n<md-button id=\"discountAddBtn\" class=\"add-btn md-raised md-background md-green-600-bg grey-50-fg\" \nng-click=\"vm.addDiscounttoKot()\" style=\"border-radius:7px;margin-left:5px\" ng-disabled=\"vm.discountAddDis==0\"><span \ntranslate=\"DINING.ADD\">Add</span></md-button><md-button class=\"add-btn md-raised md-background md-red-600-bg\" \nstyle=\"min-width:50px;border-radius:7px;margin-left:5px\" ng-click=\"vm.clearDiscountItm()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"grey-50-fg\"></md-icon></md-button></div></div><div class=\"discount-scroll\"><h3 \nclass=\"m-0 font-size-16 pl-10 pt-20\" ng-if=\"vm.taxSummary.length > 0\" translate=\"DINING.SIDNAV_BILLTAXSUM\">\nBill Tax Summary</h3><hr><div layout=\"row\" layout-align=\"start center\" class=\"clnt-bx\" \nng-if=\"vm.taxSummary.length > 0\"><div class=\"cutsmr-tbl discount-tbl\"><table><thead><tr><th style=\"text-align: center\" \ntranslate=\"DINING.SIDNAV_TAXNAME\">Tax Name</th><th style=\"text-align: center\" translate=\"DINING.SIDNAV_EXTAXAMT\">\nExclusive Tax Amount</th><th style=\"text-align: center\" translate=\"DINING.SIDNAV_INTAXAMT\">Inclusive Tax Amount</th>\n</tr></thead><tbody><tr ng-repeat=\"tax in vm.taxSummary\" ng-if=\"tax.tax_total>0 || tax.tax_total2>0\"><td align=\"left\">\n<b>{{tax.tax_name}}</b></td><td align=\"right\"><b>{{tax.tax_total | number: vm.c_d}}</b></td><td align=\"right\"><b>\n{{tax.tax_total2 | number: vm.c_d}}</b></td></tr></tbody><thead><tr><th style=\"text-align: center\" \ntranslate=\"DINING.SIDNAV_TOTALTAX\">Total Tax</th><th style=\"text-align: right\">\n{{vm.billAddons.bil_tottaxamt | number: vm.c_d}}</th><th style=\"text-align: right\">\n{{(vm.billAddons.bil_totaltaxamt-vm.billAddons.bil_tottaxamt) | number: vm.c_d}}</th></tr></thead></table></div></div>\n<h3 class=\"m-0 font-size-16 pl-10 pt-20\" ng-if=\"vm.extraSummary.length > 0\" translate=\"DINING.SIDNAV_BILEXTRA\">\nBill Extra Summary</h3><hr><div layout=\"row\" layout-align=\"start center\" class=\"clnt-bx\" \nng-if=\"vm.extraSummary.length > 0\"><div class=\"cutsmr-tbl discount-tbl\"><table><thead><tr><th \nstyle=\"text-align:center\" translate=\"DINING.SIDNAV_EXTRANM\">Extra Name</th><th style=\"text-align:center\" \ntranslate=\"DINING.SIDNAV_EXTRAAMT\">Extra Amount</th><th style=\"text-align:center\" translate=\"DINING.SIDNAV_EXTRAACTN\">\nAction</th></tr></thead><tbody><tr ng-repeat=\"extra in vm.extraSummary\" ng-if=\"extra.extra_total>0\"><td align=\"left\">\n<b>{{extra.extra_name}}</b><div class=\"pass-help\"><span><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n</span><div class=\"pass-help-bx\"><table><tr ng-repeat=\"itm in extra.itmList\"><td>{{itm.itmName}}</td><td>\n{{vm.c_s}} {{itm.itmRate | number: vm.c_d}}</td></tr></table></div></div></td><td align=\"right\"><b>\n{{extra.extra_total | number: vm.c_d}}</b></td><td align=\"center\"><md-button class=\"md-icon-button md-accent\" \naria-label=\"Favorite\" ng-click=\"vm.removeExtra(extra)\" ng-if=\"extra.extra_inclRemove==1\"><md-icon \nmd-font-icon=\"icon-close\" class=\"red-700-fg\"></md-icon></md-button></td></tr></tbody><thead><tr><th \nstyle=\"text-align: center\" translate=\"DINING.SIDNAV_TOTLEXTRA\">Total Extra</th><th style=\"text-align: right\">\n{{vm.billAddons.bil_totextraamt | number: vm.c_d}}</th><th style=\"text-align: center\"></th></tr></thead></table></div>\n</div></div><div class=\"kypad\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeTicketNote()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div></div><div class=\"sidenav-three\" \nng-if=\"vm.sideNote==1\"><div class=\"client_6\"><div class=\"txt-ara\"><textarea ng-model=\"vm.billAddons.billNotes\" \nclass=\"pb-32\" rows=\"20\" cols=\"102\" placeholder=\"Please Click and Type Here\"></textarea></div><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\" ng-click=\"vm.closeTicketNote()\"><span \ntranslate=\"DINING.CLOSE_BTN\">Close</span></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/dining/dining_old.html","<div id=\"dining\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div class=\"client_1\" \nlayout=\"column\" layout-align=\"top\"><div class=\"one\"><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-grey-500-bg grey-50-fg\"><img class=\"left-img\" \nng-src=\"assets/img/dinner-table.png\"> <span>Change Table</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-grey-500-bg grey-50-fg\"><img class=\"left-img\" \nng-src=\"assets/img/customer.png\"> <span>Select Customer</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-grey-500-bg grey-50-fg\"><img class=\"left-img\" \nng-src=\"assets/img/billls.png\"> <span>Ticket Note</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-red-400-bg grey-50-fg\"><img class=\"left-img\" \nng-src=\"assets/img/sales bills.png\"> <span>Print Bill</span></md-button></div></div><div class=\"two\"><div layout=\"row\">\n<md-button class=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\"><span>(+)</span></md-button></div><div \nlayout=\"row\"><md-button class=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\"><span>(-)</span>\n</md-button></div><div layout=\"row\"><md-button class=\"left-btn md-raised md-background md-red-400-bg grey-50-fg\"><span>\nGift</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-orange-400-bg grey-50-fg\"><span>Void</span></md-button></div><div \nlayout=\"row\"><md-button class=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\"><span>Cancel</span>\n</md-button></div><div layout=\"row\"><md-button class=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\">\n<span>Move</span></md-button></div><div layout=\"row\"><md-button \nclass=\"left-btn md-raised md-background md-grey-300-bg grey-900-fg\"><span>Change Price</span></md-button></div></div>\n</div><div class=\"client_2\"><div layout=\"column\" layout-align=\"start\" class=\"md-grey-400-bg\"><div layout=\"row\"><span \nclass=\"h4 grey-50-fg pl-5 pt-5\"><b>Table :</b> {{vm.billDet.tableName}}</span></div><div layout=\"row\"><span \nclass=\"h4 grey-50-fg pl-5 pb-5\"><b>Status :</b> {{vm.billDet.status}}</span></div></div><div layout=\"row\" \nlayout-align=\"start\" class=\"md-grey-200-bg\"><div layout=\"column\"><span \nclass=\"h4 grey-50-fg font-size-12 pl-5 grey-700-fg\"><b>Ord.NO :</b> {{vm.billDet.kotNo}}</span></div><div \nlayout=\"column\"><span class=\"h4 grey-50-fg font-size-12 pl-20 grey-700-fg\"><b>Status :</b> Administrator</span></div>\n</div><div class=\"scroll\"><div class=\"contact-item\" ng-repeat=\"ki in vm.kotItems\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">{{ki.kotitem_qty}}</span></div><div layout=\"column\" \nlayout-align=\"start\"><p class=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">{{ki.kotitem_itm_name}}</p>\n</div><div class=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">\n{{ki.kotitem_totat | number: vm.c_d}}</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" \nlayout=\"column\" layout-align=\"start\"><p class=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">{{ki.kotitem_status}}</p>\n</div></div></div><div class=\"contact-item\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"start\"><span class=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" \nlayout-align=\"start\"><p class=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p>\n</div><div class=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div \nlayout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div><div class=\"contact-item\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"font-size-16 font-weight-600 red-900-fg\">1</span></div><div layout=\"column\" layout-align=\"start\"><p \nclass=\"font-weight-600 font-size-16 m-0 red-900-fg\" layout=\"column\">SCHEZWAN EGG FRIDERICE</p></div><div \nclass=\"font-size-16 font-weight-600 red-900-fg\" layout=\"column\" layout-align=\"end\">130.00</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"email hide show-gt-sm m-0 pt-5 red-900-fg\">Submitted</p></div></div></div></div><div class=\"blnc\"><div \nlayout=\"row\" layout-align=\"space-between\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 red-900-fg\"><b>Balance : </b></p></div><div class=\"select_1\" layout=\"column\" \nlayout-align=\"end\"><p class=\"show-gt-md m-0 red-900-fg\"><b>1,010.00</b></p></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" class=\"btm-btn\"><md-button \nclass=\"btm-btn md-raised md-background md-green-600-bg grey-50-fg\"><span>Settle</span></md-button></div><div \nlayout=\"column\" class=\"btm-btn\"><md-button class=\"btm-btn md-raised md-background md-grey-500-bg grey-50-fg\"><span>KOT\n</span></md-button></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" class=\"btm-btn\">\n<md-button class=\"btm-btn md-raised md-background md-blue-500-bg grey-50-fg\"><span>Cash</span></md-button></div><div \nlayout=\"column\" class=\"btm-btn\"><md-button class=\"btm-btn md-raised md-background md-orange-500-bg grey-50-fg\"><span>\nCard</span></md-button></div></div></div></div><div class=\"sidenav\"><div class=\"client_3\"><div \nng-repeat=\"cat in vm.categoryList\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"cat.category_color==1\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"md-blue-900-bg grey cntr-btn\" md-ink-ripple \nng-click=\"vm.setCategory(cat.category_id)\"><ms-widget-front><div class=\"border-top rt-bx\" layout=\"row\" \nlayout-align=\"center\"><div class=\"rate1\" layout=\"row\" layout-align=\"start\"><img class=\"cat-img\" ng-src=\"{{cat.image}}\" \nflex=\"100\"></div><div class=\"md-red-400-bg rate2\" layout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}\n</span></div></div><div class=\"cnct\" layout=\"row\" layout-align=\"center center\"><span>{{cat.category_name}}</span></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"cat.category_color==2\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"md-pink-500-bg grey cntr-btn\" md-ink-ripple \nng-click=\"vm.setCategory(cat.category_id)\"><ms-widget-front><div class=\"border-top rt-bx\" layout=\"row\" \nlayout-align=\"center\"><div class=\"rate1\" layout=\"row\" layout-align=\"start\"><img class=\"cat-img\" ng-src=\"{{cat.image}}\" \nflex=\"100\"></div><div class=\"md-red-400-bg rate2\" layout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}\n</span></div></div><div class=\"cnct\" layout=\"row\" layout-align=\"center center\"><span>{{cat.category_name}}</span></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"cat.category_color==3\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"md-orange-300-bg grey cntr-btn\" md-ink-ripple \nng-click=\"vm.setCategory(cat.category_id)\"><ms-widget-front><div class=\"border-top rt-bx\" layout=\"row\" \nlayout-align=\"center\"><div class=\"rate1\" layout=\"row\" layout-align=\"start\"><img class=\"cat-img\" ng-src=\"{{cat.image}}\" \nflex=\"100\"></div><div class=\"md-red-400-bg rate2\" layout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}\n</span></div></div><div class=\"cnct\" layout=\"row\" layout-align=\"center center\"><span>{{cat.category_name}}</span></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"cat.category_color==0\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"md-deep-orange-500-bg grey cntr-btn\" md-ink-ripple \nng-click=\"vm.setCategory(cat.category_id)\"><ms-widget-front><div class=\"border-top rt-bx\" layout=\"row\" \nlayout-align=\"center\"><div class=\"rate1\" layout=\"row\" layout-align=\"start\"><img class=\"cat-img\" ng-src=\"{{cat.image}}\" \nflex=\"100\"></div><div class=\"md-red-400-bg rate2\" layout=\"row\" layout-align=\"center center\"><span>{{cat.itemsCount}}\n</span></div></div><div class=\"cnct\" layout=\"row\" layout-align=\"center center\"><span>{{cat.category_name}}</span></div>\n</ms-widget-front></ms-widget></div></div></div><div class=\"client_4\"><div class=\"scroll\"><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" ng-repeat=\"itm in vm.productList | filter:{item_catid:vm.selCatID}\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" class=\"md-blue-900-bg grey cntr-btn\" md-ink-ripple \nng-click=\"vm.addItmtoKot(itm.item_id)\"><ms-widget-front><div class=\"\" layout=\"row\" layout-align=\"end top\"><img \nclass=\"itm-img\" ng-src=\"{{itm.image}}\" flex=\"100\"></div><div class=\"border-top rt-bx\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"\" layout=\"column\" layout-align=\"start\"><span style=\"font-size:16px\">\n{{itm.item_name}}</span></div><div class=\"md-red-400-bg rate\" layout=\"column\" layout-align=\"end\"><span><md-icon \nmd-font-icon=\"icon-currency-inr\" class=\"grey-50-fg\" style=\"font-size:18px\"></md-icon>\n{{itm.item_selling_price | number: vm.c_d}}</span></div></div></ms-widget-front></ms-widget></div></div></div><div \nclass=\"kypad\"><table class=\"simple\" ms-responsive-table><thead></thead><tbody><tr><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\"><span>1</span>\n</md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\"><span>2</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\"><span>3</span>\n</md-button></td></tr><tr><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\"><span>4</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\"><span>5</span>\n</md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\"><span>6</span></md-button></td></tr><tr><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\"><span>7</span>\n</md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\"><span>8</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\"><span>9</span>\n</md-button></td></tr><tr><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\"><span>,</span></md-button></td><td \nstyle=\"text-align:center !important\"><md-button class=\"num-btn md-raised md-background md-grey-300-bg\"><span>0</span>\n</md-button></td><td style=\"text-align:center !important\"><md-button \nclass=\"num-btn md-raised md-background md-grey-300-bg\"><span>X</span></md-button></td></tr></tbody></table></div></div>\n</div><div class=\"sidenav-two\"><div class=\"client_5\"><h4 class=\"m-0 font-size-16 pl-10 pt-20\">Portions</h4><div \nlayout=\"row\" layout-align=\"start center\" class=\"ml-10\"><div layout=\"column\"><md-button \nclass=\"tp-btn md-raised md-background md-grey-300-bg grey-800-fg\"><span>Normal</span></md-button></div><div \nlayout=\"column\"><md-button class=\"tp-btn md-raised md-background md-grey-300-bg grey-800-fg\"><span>Big</span>\n</md-button></div></div><div class=\"kypad\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"btm-btn md-raised md-background md-grey-300-bg grey-900-fg\"><span>Remove</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\"><span>Close</span></md-button></div></div></div></div>\n</div><div class=\"sidenav-three\"><div class=\"client_6\"><div class=\"kypad\"><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"key-btn md-raised md-background\"><span>.</span></md-button></div><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"key-btn md-raised md-background\"><span>1</span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>2</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>3</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>4</span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>5</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>6\n</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\">\n<span>7</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"key-btn md-raised md-background\"><span>8</span></md-button></div><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"key-btn md-raised md-background\"><span>9</span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>0</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"lngh-btn md-raised md-background\"><span>Backspace</span>\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"lngh-btn md-raised md-backgroun\"><span>Tab</span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>q</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>w</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>e</span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>r</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>t\n</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\">\n<span>y</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"key-btn md-raised md-background\"><span>u</span></md-button></div><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"key-btn md-raised md-background\"><span>i</span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>o</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>p</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>[</span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>]</span>\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"lngh-btn md-raised md-background\"><span>caps </span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>a</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>s</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>d</span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>f</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>g\n</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\">\n<span>h</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"key-btn md-raised md-background\"><span>j</span></md-button></div><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"key-btn md-raised md-background\"><span>k</span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>l</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>;</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>#</span></md-button>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"lngh-btn md-raised md-background\"><span><md-icon md-font-icon=\"icon-arrow-up-bold\"></md-icon></span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>z</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>x\n</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\">\n<span>c</span></md-button></div><div layout=\"column\" style=\"width:100%\"><md-button \nclass=\"key-btn md-raised md-background\"><span>v</span></md-button></div><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"key-btn md-raised md-background\"><span>b</span></md-button></div><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>n</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>m</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>/</span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>\\</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"lngh-btn md-raised md-background\"><span>\nEnter</span></md-button></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" \nstyle=\"width:100%\"><md-button class=\"lngh-btn md-raised md-background\"><span>\'</span></md-button></div><div \nlayout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>-</span></md-button></div>\n<div layout=\"column\" style=\"width:100%\"><md-button class=\"spc-btn md-raised md-background\"><span></span></md-button>\n</div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>,</span>\n</md-button></div><div layout=\"column\" style=\"width:100%\"><md-button class=\"key-btn md-raised md-background\"><span>\"\n</span></md-button></div></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:100%\">\n<md-button class=\"btm-btn md-raised md-background md-red-400-bg grey-50-fg\"><span>Close</span></md-button></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/extra/extra.html","<div id=\"extra\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddExtra()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>New Extra</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"extra-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Extra Name</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Type</span></div>\n</th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Rate</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.ordeTag.extraList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.extra_name}}</b></td><td align=\"center\">{{cat.extra_type}}</td><td align=\"right\">\n{{cat.extra_rate | number: vm.c_d}}</td><td align=\"center\">{{cat.extra_status}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editExtra(cat.extra_id)\"><md-tooltip md-direction=\"down\">Edit</md-tooltip>\n<i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteExtra(cat.extra_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\">\n</i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/forgot-password/forgot.html","<div id=\"forgot\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img class=\"scl-logo\" ng-src=\"{{vm.files.url}}\"></div><div class=\"title\">Recover your password</div><form \nname=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"mobileno\" ng-model=\"vm.forgotData.mobileno\" placeholder=\"Mobile No\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.MOBILENO\" ng-pattern=\"/^[0-9]{10}$/\" md-minlength=\"10\" md-maxlength=\"10\" \nrequired><div ng-messages=\"forgotPasswordForm.mobileno.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.MOBILE_REQUIRED\">Mobile field is required</span></div><div\n ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.MOBILE_MUST_VALID\">Mobile must be a valid mobile number\n</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-click=\"vm.checkAccount()\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login\n</a></div></div></div></div>");
$templateCache.put("app/main/apps/home/home.html","<div id=\"menu\" class=\"page-layout simple fullwidth\" ms-scroll><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-lg\')\" md-component-id=\"Sidenavfour\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/sidenavs/sidenavs.html\'\"></div></md-sidenav><div class=\"center\" layout=\"row\" flex><div \nlayout=\"row\" layout-align=\"start center\" class=\"clnt-bx\" ms-scroll><div layout-align=\"center\" layout=\"row\" \nclass=\"alrt md-background md-red-50-bg grey\" ng-if=\"vm.periodList.periodDets==\'\'\"><span \nclass=\"font-size-24 font-weight-600 red-300-fg\" translate=\"HOME.WORK_PERIOD_NOT\">Work Period Not Yet Started.</span>\n</div><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoWorkPeriod()\" ng-disabled=\"vm.workBlock==1\"><img \nclass=\"icon-img\" ng-src=\"assets/img/sand-clock.png\"> <span translate=\"HOME.WORK_PERIOD\">Work Periods</span></md-button>\n</div><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoPOS()\" ng-disabled=\"vm.posBlock==1 || vm.showPOS==0\"><img \nclass=\"icon-img\" ng-src=\"assets/img/pos.png\"> <span translate=\"HOME.POS\">POS</span></md-button></div><div class=\"colm\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button class=\"tp-btn md-raised md-background\" \nng-click=\"vm.gotoTickets()\" ng-disabled=\"vm.ticketBlock==1\"><img class=\"icon-img\" ng-src=\"assets/img/tickets.png\"> \n<span translate=\"HOME.TICKET\">Tickets</span></md-button></div><div class=\"colm\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoDashboard()\" \nng-disabled=\"vm.dashBlock==1\"><img class=\"icon-img\" ng-src=\"assets/img/account.png\"> <span translate=\"HOME.DASHBOARD\">\nDashboard</span></md-button></div><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\">\n<md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.warehouse()\" ng-disabled=\"vm.wareBlock==1\"><img \nclass=\"icon-img\" ng-src=\"assets/img/warehouse.png\"> <span translate=\"HOME.WAREHOUSE\">Warehouses</span></md-button>\n</div><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.department()\" ng-disabled=\"vm.manageBlock==1\"><img \nclass=\"icon-img\" ng-src=\"assets/img/manage.png\"> <span translate=\"HOME.MANAGE\">Manage</span></md-button></div><div \nclass=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.reports()\" ng-disabled=\"vm.rptBlock==1\"><img class=\"icon-img\" \nng-src=\"assets/img/report.png\"> <span translate=\"HOME.REPORT\">Reports</span></md-button></div><div class=\"colm\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"33\" flex-gt-xs=\"50\"><md-button class=\"tp-btn md-raised md-background\" \nng-click=\"vm.support()\" ng-disabled=\"vm.supBlock==1\"><img class=\"icon-img\" ng-src=\"assets/img/support.png\"> <span \ntranslate=\"HOME.SUPPORT\">Support</span></md-button></div><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"33\" \nflex-gt-xs=\"50\"><md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.logout()\"><img class=\"icon-img\" \nng-src=\"assets/img/logout.png\"> <span translate=\"HOME.LOGOUT\">Logout</span></md-button></div></div></div></div>");
$templateCache.put("app/main/apps/home/home_old.html","<div id=\"menu-old\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"start center\" class=\"clnt-bx\"><div layout-align=\"center\" layout=\"row\" \nclass=\"alrt md-background md-red-50-bg grey\" ng-if=\"vm.periodList.periodDets==\'\'\"><span \nclass=\"font-size-24 font-weight-600 red-300-fg\">Work Period not Started, Please Start it.</span></div><div \nclass=\"colm\" layout=\"column\"><md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoWorkPeriod()\"><img \nclass=\"icon-img\" ng-src=\"assets/img/sand-clock.png\"> <span>Work Periods</span></md-button></div><div class=\"colm\" \nlayout=\"column\"><md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoPOS()\" ng-disabled=\"vm.showPOS==0\">\n<img class=\"icon-img\" ng-src=\"assets/img/pos.png\"> <span>POS</span></md-button></div><div class=\"colm\" layout=\"column\">\n<md-button class=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoTickets()\"><img class=\"icon-img\" \nng-src=\"assets/img/sand-clock.png\"> <span>Tickets</span></md-button></div><div class=\"colm\" layout=\"column\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.gotoDashboard()\"><img class=\"icon-img\" \nng-src=\"assets/img/sand-clock.png\"> <span>Dashboard</span></md-button></div><div class=\"colm\" layout=\"column\">\n<md-button class=\"tp-btn md-raised md-background\" ng-disabled=\"true\"><img class=\"icon-img\" \nng-src=\"assets/img/sand-clock.png\"> <span>Warehouses</span></md-button></div><div class=\"colm\" layout=\"column\">\n<md-button class=\"tp-btn md-raised md-background\" ng-disabled=\"true\"><img class=\"icon-img\" \nng-src=\"assets/img/sand-clock.png\"> <span>Support</span></md-button></div><div class=\"colm\" layout=\"column\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.reports()\"><img class=\"icon-img\" \nng-src=\"assets/img/sand-clock.png\"> <span>Reports</span></md-button></div><div class=\"colm\" layout=\"column\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-disabled=\"true\"><img class=\"icon-img\" ng-src=\"assets/img/sand-clock.png\"> \n<span>Manage</span></md-button></div><div class=\"colm\" layout=\"column\"><md-button \nclass=\"tp-btn md-raised md-background\" ng-click=\"vm.logout()\"><img class=\"icon-img\" ng-src=\"assets/img/sand-clock.png\">\n <span>Logout</span></md-button></div></div></div></div>");
$templateCache.put("app/main/apps/ingredients/ingredients.html","<div id=\"ingredients\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" \nng-click=\"vm.gotoAddIngredients()\"><md-icon md-font-icon=\"icon-account\"></md-icon><span \ntranslate=\"INGREDIENT.NEW_INGREDIENT_BTN\">New Ingredients</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"ingredients-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"INGREDIENT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\">\n<span class=\"column-title\" translate=\"INGREDIENT.TABLE_INGREDNAME\">Ingredients Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"INGREDIENT.TABLE_STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"INGREDIENT.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.ingredients.ingredientsList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.ingredients_name}}</b></td><td align=\"center\">{{cat.ingredients_status}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editIngredients(cat.ingredients_id)\"><md-tooltip md-direction=\"down\"><span\n translate=\"INGREDIENT.TABLE_EDIT\">Edit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteIngredients(cat.ingredients_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"INGREDIENT.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\">\n</i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/ingredients-stock-update/ingredients-stock-update.html","<div id=\"ingredients-stock-update\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"varianceForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"INGREDIENT_STOCK.TOP_TITLE\">Ingredients Physical Stock Update</h2></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"search-bx\"><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" ng-model=\"vm.search\" type=\"text\" placeholder=\"Search..\" flex></div><md-button \ntranslate=\"INGREDIENT_STOCK.SAVE_STOCKBTN\" type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-click=\"vm.saveStockUpdate()\">Save Stock</md-button></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-5\">\n<table class=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th class=\"text-center\" \ntranslate=\"INGREDIENT_STOCK.TBL_SNO\">S.No</th><th class=\"text-center\" style=\"max-width:200px; min-width:200px\" \ntranslate=\"INGREDIENT_STOCK.TBL_INGRENAME\">Ingredients Name</th><th class=\"text-center\" \nstyle=\"max-width:100px;min-width:100px\" translate=\"INGREDIENT_STOCK.TBL_CURENTSTOCK\">Current Stock</th><th \nclass=\"text-center\" style=\"max-width:100px;min-width:100px\" translate=\"INGREDIENT_STOCK.TBL_PHYSICSTOCK\">Physical Stock\n</th><th class=\"text-center\" style=\"max-width:100px;min-width:100px\" translate=\"INGREDIENT_STOCK.TBL_VARIANCEQTY\">\nVariance Qty</th><th class=\"text-center\" style=\"max-width:150px;min-width:150px\" \ntranslate=\"INGREDIENT_STOCK.TBL_REMARK\">Remarks</th></tr></thead><tbody><tr ng-if=\"vm.itemStockList.length>0\" \nng-repeat=\"itm in vm.itemStockList | filter:vm.search\"><td class=\"text-center\">{{$index+1}}</td><td class=\"text-left\">\n<h6>{{itm.ingredients_name}}</h6></td><td class=\"text-center\">{{itm.wstock_hqty | number: vm.c_d}} {{itm.unit_name}}\n</td><td class=\"text-center\"><input type=\"text\" name=\"physicalQty\" ng-model=\"itm.physicalQty\" \nng-change=\"vm.setStockUpdate()\"></td><td class=\"text-center\">{{itm.varianceQty | number: vm.c_d}} {{itm.unit_name}}\n</td><td class=\"text-center\"><textarea name=\"remarks\" ng-model=\"itm.remarks\" rows=\"2\"></textarea></td></tr><tr \nng-if=\"vm.itemStockList.length==0\"><td colspan=\"6\" class=\"text-center\" translate=\"INGREDIENT_STOCK.TBL_NORECORD\">\nNo Records</td></tr></tbody></table></div></ms-widget-front></ms-widget></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/item/item.html","<div id=\"item\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"end\"><div layout=\"column\" layout-align=\"start\"><md-button \nclass=\"new-btn md-raised\" ng-click=\"vm.saveItems()\" ng-disabled=\"vm.blockBtn==1\"><span translate=\"ITEM.SAVEITEM\">\nSave to Items</span></md-button></div><div layout=\"column\" layout-align=\"start\"><md-button class=\"new-btn md-raised\" \nng-click=\"vm.gotoAddItem()\" ng-disabled=\"vm.blockBtn==1\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"ITEM.NEWITEM\">New Item</span></md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"item-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><md-checkbox md-no-ink ng-model=\"vm.chkAll\" class=\"md-accent\" ng-checked=\"(vm.chkAll==1)\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-click=\"vm.selectAll()\"></md-checkbox></th><th class=\"secondary-text\" \nshow-gt-sm><div class=\"table-header\"><span class=\"column-title\" translate=\"ITEM.ITEMNAME\">Item Name</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ITEM.IS_PORTION\">Is Portion\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEM.WAREHOUSE\">Warehouse</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ITEM.ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.item.itemList\"><td align=\"center\"><md-checkbox md-no-ink ng-model=\"cat.itemlist_selected\" \nclass=\"md-accent\" ng-checked=\"(cat.itemlist_selected==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox></td>\n<td align=\"left\" show-gt-sm><b>{{cat.itemlist_name}}</b></td><td align=\"center\" ng-if=\"cat.itemlist_isoption==0\" \ntranslate=\"ITEM.TABLE_NO\">No</td><td align=\"center\" ng-if=\"cat.itemlist_isoption==1\" translate=\"ITEM.TABLE_YES\">Yes\n</td><td align=\"center\"><md-input-container flex><md-select name=\"itemlist_warehouse\" \nng-model=\"cat.itemlist_warehouse\"><md-option ng-repeat=\"op in vm.warehouseList\" ng-value=\"op.warehouse_id\" \nng-selected=\"vm.warehouseList.length==1 || cat.itemlist_warehouse==op.warehouse_id\">{{op.warehouse_name}}</md-option>\n</md-select></md-input-container></td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editItem(cat.itemlist_id)\"><md-tooltip md-direction=\"down\"><pan translate=\"ITEM.TABLE_EDIT\">Edit</pan>\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteItem(cat)\"><md-tooltip md-direction=\"down\"><span translate=\"ITEM.TABLE_DELETE\">Delete</span>\n</md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/inventory/inventory.html","<div id=\"inventory\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"inventoryForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"INVENTORY.OSTOCK_ENTRY\">Opening Stock Entry</h2></div><div layout=\"row\" \nlayout-align=\"start center\" layout-gt-xs=\"row\" flex class=\"flex\"><label translate=\"INVENTORY.DATE\" layout=\"row\" \nclass=\"font-size-16\" style=\"padding:13px 0px 0px 13px\">Date :</label><md-datepicker name=\"date\" \nmd-placeholder=\"Select date\" ng-model=\"vm.inventory.date\"></md-datepicker></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div translate=\"INVENTORY.ITEM_INVENTORY\" \nclass=\"h3 text-bold\" style=\"color:#009716\">Item Inventory</div></div><div class=\"p-5\"><table class=\"simple\" \nms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th translate=\"INVENTORY.TBL_ITEMNAME\" class=\"text-center\" \nstyle=\"max-width:200px; min-width:200px\">Item Name</th><th translate=\"INVENTORY.TBL_ITEMQTY\" class=\"text-center\" \nstyle=\"max-width:100px; min-width:100px\">Qty</th><th translate=\"INVENTORY.TBL_COSTPRICE\" class=\"text-center\" \nstyle=\"max-width:120px; min-width:120px\">Cost Price</th><th translate=\"INVENTORY.TBL_SELLPRICE\" class=\"text-center\" \nstyle=\"max-width:120px; min-width:120px\">Selling Price</th><th translate=\"INVENTORY.TBL_PRODDATE\" class=\"text-center\" \nstyle=\"max-width:120px; min-width:120px\">Prod. Date</th><th translate=\"INVENTORY.TBL_EXPTINDATE\" class=\"text-center\" \nstyle=\"max-width:80px; min-width:80px\">Expiry In Day(s)</th><th translate=\"INVENTORY.TBL_EXPRYDATE\" \nclass=\"text-center\" style=\"max-width:120px; min-width:120px\">Expiry Date</th><th translate=\"INVENTORY.TBL_ACTION\" \nclass=\"text-center\" style=\"max-width:80px; min-width:80px\">Action</th></tr></thead><tbody ng-if=\"vm.productInsert==1\" \nng-repeat=\"itm in vm.inventoryItems\"><tr><td class=\"name tbl text-center\" valign=\"top\"><md-autocomplete \nng-disabled=\"itm.isDisabled\" md-no-cache=\"itm.noCache\" md-selected-item=\"itm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(itm.searchText)\" md-search-text=\"itm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(itm.searchText)\" \nmd-item-text=\"item.item_name\" md-min-length=\"1\" placeholder=\"Select Items\" \nmd-menu-class=\"autocomplete-custom-template\" md-dropdown-position=\"bottom\"><md-item-template><span class=\"item-title\">\n<span>{{item.item_name}} </span></span><span class=\"item-metadata\"><span><span translate=\"INVENTORY.TBL_CODE\">Code :\n</span> <strong>{{item.item_code}}</strong> </span><span><span translate=\"INVENTORY.TBL_BARCODE\">Barcode :</span> \n<strong>{{item.item_barcode}}</strong></span></span></md-item-template></md-autocomplete></td><td \nclass=\"name tbl text-left\" valign=\"top\"><input type=\"text\" name=\"itms_qty{{$index}}\" id=\"itms_qty{{$index}}\" \nng-model=\"itm.itms_qty\"><label>{{itm.itms_unit_name}}</label></td><td class=\"name tbl text-center\" valign=\"top\"><input \ntype=\"text\" name=\"itms_cost_price\" ng-model=\"itm.itms_cost_price\"></td><td class=\"name tbl text-center\" valign=\"top\">\n<input type=\"text\" name=\"itms_selling_price\" ng-model=\"itm.itms_selling_price\" ng-disabled=\"true\"></td><td \nclass=\"name tbl text-center\" valign=\"top\"><md-datepicker name=\"itms_prod_date\" md-placeholder=\"Select date\" \nng-model=\"itm.itms_prod_date\" ng-change=\"vm.getExpDate(itm)\"></md-datepicker></td><td class=\"name tbl text-center\" \nvalign=\"top\"><input type=\"text\" name=\"itms_expiry_days\" ng-model=\"itm.itms_expiry_days\" ng-change=\"vm.getExpDate(itm)\">\n</td><td class=\"name tbl text-center\" valign=\"top\"><md-datepicker name=\"itms_expiry_date\" md-placeholder=\"Select date\" \nng-model=\"itm.itms_expiry_date\"></md-datepicker></td><td class=\"name tbl text-center\" valign=\"top\"><md-button \nclass=\"md-fab md-mini md-red-700-bg\" ng-click=\"vm.removeProduct(itm.itms_id)\" ng-if=\"(itm.itms_remove==true)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button translate=\"INVENTORY.CLRBTN\" class=\"md-raised btm-btn\" \naria-label=\"Go to Staffs\" ng-click=\"vm.gotoInventory()\">Clear All</md-button><md-button translate=\"INVENTORY.SAVE_BTN\" \ntype=\"button\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-click=\"vm.saveInventory()\">Save</md-button>\n</div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/inventory/purchase_old.html","<div id=\"supplier\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n</div><div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised md-background\" \nng-click=\"vm.gotoAddPurchase()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"PURCHASELIST.NEWPURCHASE\">\nNew Purchase</span></md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"supplier-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.SNO\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PURCHASELIST.PURCHASENO\">Purchase No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.DATE\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.CUSTNAME\">\nSupplier Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PURCHASELIST.TYPE\">Warehouse Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"PURCHASELIST.NETTAMT\">Nett Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.ACTION\">Action</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"sal in vm.purchase.purchaseList\"><td align=\"center\">{{$index+1}}</td><td align=\"center\" \nshow-gt-sm><b>#{{sal.purchase_pre}}-{{sal.purchase_no}}</b></td><td align=\"center\">{{sal.purchase_date}}</td><td \nalign=\"center\" show-gt-sm><b>{{sal.supplier_name}}</b></td><td align=\"center\" show-gt-sm><b>{{sal.warehouse_name}}</b>\n</td><td align=\"center\">{{sal.purchase_total_net | number: vm.c_d}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editPurchase(sal.purchase_id)\"><md-tooltip md-direction=\"down\">Edit\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deletePurchase(sal.purchase_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i \nclass=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/item-reorder-report/item-reorder-report.html","<div id=\"item-reorder-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"ITEMREORDERRPT.CATNAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.reorderstockDets.catID\"><md-option ng-value=\"\" \ntranslate=\"ITEMREORDERRPT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.reorderstockDets.catID==op.category_id\">{{op.category_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><label class=\"inpt-lbl\" translate=\"ITEMREORDERRPT.ITEMNAME\">Item Name:</label><md-input-container \nflex style=\"margin-top:-5px\"><md-select name=\"itmID\" ng-model=\"vm.reorderstockDets.itmID\"><md-option ng-value=\"\" \ntranslate=\"ITEMREORDERRPT.SELECT_ALL\">All</md-option><md-option \nng-repeat=\"op in vm.itemList | filter:{catitm_category_id:vm.reorderstockDets.catID}:true\" ng-value=\"op.item_id\" \nng-selected=\"vm.reorderstockDets.itmID==op.item_id\">{{op.item_name}}</md-option></md-select></md-input-container></div>\n</div></div><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" \naria-label=\"Submit\" ng-click=\"vm.listReport()\"><i class=\"icon icon-format-list-bulleted\"></i> <span \ntranslate=\"ITEMREORDERRPT.LISTITEM_BTN\">List Items</span></md-button></div></form></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div \nclass=\"item-reorder-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMREORDERRPT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ITEMREORDERRPT.TABLE_ITEMNAME\">\nItem Name</span></div></th><th class=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEMREORDERRPT.TABLE_MINQTY\">Min. Qty</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMREORDERRPT.TABLE_CURRENTQTY\">Current Qty</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.itemReorderReport\" ng-if=\"vm.itemReorderReport.length>0\"><td \nalign=\"center\">{{$index+1}}</td><td align=\"center\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td \nalign=\"center\">{{itm.item_reorder_min_level}} {{itm.unit_name}}</td><td align=\"center\">\n{{itm.item_currqty}} {{itm.unit_name}}</td></tr></tbody><tr ng-if=\"vm.itemReorderReport.length>0\" class=\"btm-row\"><td \nalign=\"center\" colspan=\"3\"></td><td style=\"text-align:center; background:#00a931\">{{vm.totalStock | number: vm.c_d}}\n</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/item-report/item-report.html","<div id=\"item-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"ITEMREPORT.CAT_NAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.itemDets.catID\"><md-option ng-value=\"\" \ntranslate=\"ITEMREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.itemDets.catID==op.category_id\">{{op.category_name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><label class=\"inpt-lbl\" translate=\"ITEMREPORT.ITEM_NAME\">Item Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"itmID\" ng-model=\"vm.itemDets.itmID\"><md-option ng-value=\"\" \ntranslate=\"ITEMREPORT.SELECT_ALL\">All</md-option><md-option \nng-repeat=\"op in vm.itemList | filter:{catitm_category_id:vm.itemDets.catID}:true\" ng-value=\"op.item_id\" \nng-selected=\"vm.itemDets.itmID==op.item_id\">{{op.item_name}}</md-option></md-select></md-input-container></div></div>\n</div><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"40\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" translate=\"ITEMREPORT.DATE\">Date:\n</label><md-input-container flex style=\"margin-top:-5px\"><md-select name=\"type\" ng-model=\"vm.itemDets.type\" \nng-change=\"vm.changeDate()\"><md-option ng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.itemDets.type==op\">\n{{op}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\">\n<div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"ITEMREPORT.FROM\">From:</label>\n<md-datepicker name=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.itemDets.from\" flex></md-datepicker></div></div>\n</div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label\n class=\"inpt-lbl\" translate=\"ITEMREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.itemDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i><span translate=\"ITEMREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"item-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"ITEMREPORT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMREPORT.TABLE_ITEMNAME\">Item Name</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEMREPORT.TABLE_QTY\">Qty</span></div></th><th class=\"secondary-text text-right\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"ITEMREPORT.TABLE_TOTAL\">Total</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.itemReportList\" ng-if=\"vm.itemReportList.length>0\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"center\">{{itm.item_name}} <span ng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">\n- {{itm.itm_option_name}}</span></td><td align=\"center\">{{itm.bitm_qty}}</td><td style=\"text-align:right\">\n{{itm.bitm_total | number: vm.c_d}}</td></tr></tbody><tr ng-if=\"vm.itemReportList.length>0\" class=\"btm-row\"><td \nalign=\"center\" colspan=\"3\"></td><td style=\"text-align:right;background:#00a931\">{{vm.totalAmt | number: vm.c_d}}</td>\n</tr></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/item-stock-report/item-stock-report.html","<div id=\"item-stock-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"ITEMSTOCKREPORT.CATNAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.itmStockList.catID\"><md-option ng-value=\"\" \ntranslate=\"ITEMSTOCKREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.itmStockList.catID==op.category_id\">{{op.category_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><label class=\"inpt-lbl\" translate=\"ITEMSTOCKREPORT.ITEM_NAME\">Item Name:</label><md-input-container \nflex style=\"margin-top:-5px\"><md-select name=\"itmID\" ng-model=\"vm.itmStockList.itmID\"><md-option ng-value=\"\" \ntranslate=\"ITEMSTOCKREPORT.SELECT_ALL\">All</md-option><md-option \nng-repeat=\"op in vm.itemList | filter:{catitm_category_id:vm.itmStockList.catID}:true\" ng-value=\"op.item_id\" \nng-selected=\"vm.itmStockList.itmID==op.item_id\">{{op.item_name}}</md-option></md-select></md-input-container></div>\n</div></div><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" \naria-label=\"Submit\" ng-click=\"vm.listReport()\"><i class=\"icon icon-format-list-bulleted\"></i> <span \ntranslate=\"ITEMSTOCKREPORT.LISTITEM_BTN\">List Items</span></md-button></div></form></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div \nclass=\"item-stock-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMSTOCKREPORT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ITEMSTOCKREPORT.TABLE_ITEMNAME\">\nItem Name</span></div></th><th class=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEMSTOCKREPORT.TABLE_INWARDQTY\">Inward Qty</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMSTOCKREPORT.TABLE_SALEQTY\">Sales Qty</span></div></th>\n<th class=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEMSTOCKREPORT.TABLE_WASTQTY\">Wastage Qty</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMSTOCKREPORT.TABLE_VARIENCEQTY\">Variance Qty</span></div>\n</th><th class=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEMSTOCKREPORT.TABLE_CURRENTQTY\">Current Qty</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEMSTOCKREPORT.TABLE_CURRENTVALUE\">Current Value</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.itemStockReport\" ng-if=\"vm.itemStockReport.length>0\"><td \nalign=\"center\">{{$index+1}}</td><td align=\"left\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td \nalign=\"center\"><span ng-if=\"itm.openingStock>0\">{{itm.openingStock | number: vm.c_d}} {{itm.unit_name}}</span> <span \nng-if=\"itm.openingStock==0\">-</span></td><td align=\"center\"><span ng-if=\"itm.salesStock>0\">\n{{itm.salesStock | number: vm.c_d}} {{itm.unit_name}}</span> <span ng-if=\"itm.salesStock==0\">-</span></td><td \nalign=\"center\"><span ng-if=\"itm.wastageStock>0\">{{itm.wastageStock | number: vm.c_d}} {{itm.unit_name}}</span> <span \nng-if=\"itm.wastageStock==0\">-</span></td><td align=\"center\"><span ng-if=\"itm.varianceStock>0\">\n{{itm.varianceStock | number: vm.c_d}} {{itm.unit_name}}</span> <span ng-if=\"itm.varianceStock==0\">-</span></td><td \nalign=\"center\"><span ng-if=\"itm.item_currqty>0\">{{itm.item_currqty | number: vm.c_d}} {{itm.unit_name}}</span> <span \nng-if=\"itm.item_currqty==0\">-</span></td><td align=\"right\" style=\"text-align:right\"><span ng-if=\"itm.currStockValue>0\">\n{{itm.currStockValue | number: vm.c_d}}</span> <span ng-if=\"itm.currStockValue==0\">-</span></td></tr></tbody><tr \nng-if=\"vm.itemStockReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"2\"></td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalOpStock | number: vm.c_d}}</td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalSalesStock | number: vm.c_d}}</td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalWasteStock | number: vm.c_d}}</td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalVarStock | number: vm.c_d}}</td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalCurrStock | number: vm.c_d}}</td><td \nstyle=\"text-align:right; background:#00a931\">{{vm.totalCurrValue | number: vm.c_d}}</td></tr></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/kot-report/kot-report.html","<div id=\"kot-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"KOTREPORT.BILL_NO\">Bill No:</label><md-input-container flex><input \nng-model=\"vm.salesDets.billno\"></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\">\n<div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" translate=\"KOTREPORT.PAYMENT_MODE\">Payment Mode:</label>\n<md-input-container flex><md-select name=\"mode\" ng-model=\"vm.salesDets.mode\"><md-option ng-value=\"\" \ntranslate=\"KOTREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.payMode\" ng-value=\"op\" \nng-selected=\"vm.salesDets.mode==op\">{{op}}</md-option></md-select></md-input-container></div></div></div><div \nlayout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div \nlayout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" translate=\"KOTREPORT.BILL_DATE\">Date:</label><md-input-container\n flex><md-select name=\"type\" ng-model=\"vm.salesDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.salesDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"KOTREPORT.FROM\">From:</label><md-datepicker \nname=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.salesDets.from\" flex></md-datepicker></div><div layout=\"row\" \nclass=\"ml-40\"><label class=\"inpt-lbl\" translate=\"KOTREPORT.TO\">To:</label><md-datepicker name=\"to\" \nmd-placeholder=\"Enter date\" ng-model=\"vm.salesDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" \nng-click=\"vm.listReport()\"><i class=\"icon icon-format-list-bulleted\"></i> <span translate=\"KOTREPORT.LISTBILL_BTN\">\nList Bills</span></md-button></div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"kot-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg first-tbl\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"KOTREPORT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_BILLNO\">Bill No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_DATE\">Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"KOTREPORT.TABLE_AMOUNT\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"KOTREPORT.TABLE_TOTALAMOUNT\">Total Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_MODE\">Mode</span></div></th></tr>\n</thead><tbody ng-repeat=\"itm in vm.kotReportList\" ng-if=\"vm.kotReportList.length>0\"><tr><td align=\"center\">\n{{$index+1}}</td><td align=\"center\"><span translate=\"KOTREPORT.TABLE_BILLNO\">Bill No</span> : {{itm.bil_no}}</td><td \nalign=\"center\">{{itm.bil_date}}</td><td style=\"text-align:right\">{{itm.bil_totalamt | number: vm.c_d}}</td><td \nstyle=\"text-align:right\">{{itm.bil_totalnetamt | number: vm.c_d}}</td><td align=\"center\">{{itm.bil_paymenttype}}</td>\n</tr><tr><td align=\"center\" colspan=\"6\" style=\"padding:0px 10px 10px 10px;background:#292e39\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg second-tbl\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_KOTNO\">KOT No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"KOTREPORT.TABLE_KOTREFNO\">KOT Ref No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"KOTREPORT.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_TABLENAME\">Table Name</span></div></th></tr>\n</thead><tbody ng-repeat=\"kot in itm.kotList\" ng-if=\"itm.kotList.length>0\" class=\"second-tbl\"><tr><td align=\"center\">\n{{$index+1}}</td><td align=\"center\"><span translate=\"KOTREPORT.TABLE_KOTNO\">KOT No</span> : {{kot.kot_no}}</td><td \nalign=\"center\">{{kot.kot_ref_no}}</td><td align=\"center\">{{kot.kot_date}}</td><td align=\"center\">{{kot.table_name}}\n</td></tr><tr><td align=\"center\" colspan=\"5\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg third-tbl\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"KOTREPORT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_ITEMNAME\">Item Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_QTY\">Qty</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"KOTREPORT.TABLE_RATE\">Rate</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"KOTREPORT.TABLE_TOTAL\">Total</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"KOTREPORT.TABLE_STATUS\">Status</span></div></th></tr>\n</thead><tbody ng-repeat=\"kotitm in itm.kotsItmsList | filter:{kotitem_kot_id:kot.kot_id}:true\" \nng-if=\"(itm.kotsItmsList | filter:{kotitem_kot_id:kot.kot_id}).length>0\" class=\"third-tbl\"><tr><td align=\"center\">\n{{$index+1}}</td><td style=\"text-align:left\">{{kotitm.item_name}} <span ng-if=\"kotitm.itm_option_name!=\'Normal\'\">\n{{kotitm.itm_option_name}}</span></td><td align=\"center\">{{kotitm.bitm_qty}}</td><td style=\"text-align:right\">\n{{kotitm.bitm_amt | number: vm.c_d}}</td><td style=\"text-align:right\">{{kotitm.bitm_total | number: vm.c_d}}</td><td \nalign=\"center\">{{kotitm.kotitem_status}}</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody><tr \nng-if=\"vm.kotReportList.length>0\"><td align=\"center\" colspan=\"3\"></td><td style=\"text-align:right\">\n{{vm.totalAmt | number: vm.c_d}}</td><td style=\"text-align:right\">{{vm.totalNet | number: vm.c_d}}</td><td \nalign=\"center\"></td></tr></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/login/signin.html","<div id=\"signin1\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<img class=\"scl-logo\" ng-src=\"{{vm.clientLogo}}\"></div><div class=\"title\">{{vm.clientName}}</div></div><div \nid=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div \nclass=\"logo\" hide-gt-sm><img class=\"scl-logo\" ng-src=\"{{vm.clientLogo}}\"></div><div class=\"title text-center\" \nhide-gt-sm>{{vm.clientName}}</div><div class=\"title text-center\" hide show-gt-sm>Log in to your account</div><div \nlayout-align=\"center\" layout=\"row\" class=\"alrt md-background md-red-50-bg grey\" ng-if=\"vm.clientStatus!=0\"><span \nclass=\"font-size-20 font-weight-600 red-300-fg\">{{vm.clientStatusLabel}}</span></div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"mobileno\" ng-model=\"vm.loginData.mobileno\" \nplaceholder=\"Username\" translate translate-attr-placeholder=\"LOGIN.MOBILENO\" ng-pattern=\"^$|^[A-Za-z0-9]+\" required>\n<div ng-messages=\"loginForm.mobileno.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.MOBILE_REQUIRED\">Username field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.MOBILE_MUST_VALID\">Username must be a valid entry</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.loginData.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required>\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-button\n type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.clientStatus!=0\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.checkLogin()\">LOG IN</md-button><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"></div></form>\n</div><div class=\"designby\" layout=\"column\" layout-align=\"end center\"><span>Powered By :</span><div class=\"app-logo\">\n<img class=\"icon-img mt-5\" ng-src=\"assets/img/quicklogo.png\"></div><p ng-if=\"vm.clientVersion!=\'\'\">{{vm.clientVersion}}\n</p></div></div></div>");
$templateCache.put("app/main/apps/managemenu/managemenu.html","<div class=\"managemenu\"><ms-nav><ms-nav-item ms-nav-toggle ng-if=\"vm.deptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.department\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Departments</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.waiterBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.waiter\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> \n<span class=\"ms-nav-label\">Waiters</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.tblcatBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.scategory\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">Tables Categories</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.tableBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.seats\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Tables/Seats</span></a></ms-nav-item><ms-nav-item\n ms-nav-toggle ng-if=\"vm.customerBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.customer\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Customers</span></a>\n</ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.suppilerBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.supplier\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Suppliers</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.pricetagBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.price-tag\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">Price Tags</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.ordtagBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.order-tag\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Order Tags</span></a></ms-nav-item><ms-nav-item \nms-nav-toggle ng-if=\"vm.itmpoolBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.item\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Item Pools</span></a></ms-nav-item><ms-nav-item \nms-nav-toggle ng-if=\"vm.catpoolBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.category\" ui-sref-active=\"active\">\n<i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Category Pools</span></a></ms-nav-item>\n<ms-nav-item ms-nav-toggle ng-if=\"vm.pricetBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.pricing\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Pricings</span></a>\n</ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.ingredBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.ingredients\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Ingredients</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.recipeBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.recipes\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i>\n <span class=\"ms-nav-label\">Recipes</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.tempBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.template\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">Templates</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.printerBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.printers\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Printers</span></a></ms-nav-item><ms-nav-item \nms-nav-toggle ng-if=\"vm.printjobBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.printerjobs\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Printer Jobs</span>\n</a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.usrrolesBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.roles\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">\nUsers Roles</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.usrBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.user\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">\nUsers</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.taxmasterBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.tax\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">\nTax Master</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.itmavailBlock==0\"><a ms-nav-button \nmd-ink-ripple ui-sref=\"app.available\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Item Availablity</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.accheadBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.account-head\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Account Head</span></a></ms-nav-item><ms-nav-item\n ms-nav-toggle ng-if=\"vm.daybookBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.daybook\" ui-sref-active=\"active\">\n<i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Daybook</span></a></ms-nav-item><ms-nav-item \nms-nav-toggle ng-if=\"vm.offerBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.offer\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Offers</span></a></ms-nav-item><ms-nav-item \nms-nav-toggle ng-if=\"vm.extraBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.extra\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Extra Charges</span></a></ms-nav-item>\n<ms-nav-item ms-nav-toggle ng-if=\"vm.settBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.units\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Units</span></a>\n</ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.settBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.settings\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Settings</span></a>\n</ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.clearsalesBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.clear-sales\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Clear Sales</span></a></ms-nav-item></ms-nav></div>");
$templateCache.put("app/main/apps/offer/offer.html","<div id=\"offer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddOffer()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>New Offer</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"offer-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Offer Name</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Type</span></div>\n</th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Rate</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.ordeTag.offerList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.offer_name}}</b></td><td align=\"center\">{{cat.offer_type}}</td><td align=\"right\">\n{{cat.offer_rate | number: vm.c_d}}</td><td align=\"center\">{{cat.offer_status}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editOffer(cat.offer_id)\"><md-tooltip md-direction=\"down\">Edit</md-tooltip>\n<i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteOffer(cat.offer_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\">\n</i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/opening-stock-report/opening-stock-report.html","<div id=\"opening-stock-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"OPENSTOCKREPORT.CATNAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.openingstockDets.catID\"><md-option ng-value=\"\" \ntranslate=\"OPENSTOCKREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.openingstockDets.catID==op.category_id\">{{op.category_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><label class=\"inpt-lbl\" translate=\"OPENSTOCKREPORT.ITEM_NAME\">Item Name:</label><md-input-container \nflex style=\"margin-top:-5px\"><md-select name=\"itmID\" ng-model=\"vm.openingstockDets.itmID\"><md-option ng-value=\"\" \ntranslate=\"OPENSTOCKREPORT.SELECT_ALL\">All</md-option><md-option \nng-repeat=\"op in vm.itemList | filter:{catitm_category_id:vm.openingstockDets.catID}:true\" ng-value=\"op.item_id\" \nng-selected=\"vm.openingstockDets.itmID==op.item_id\">{{op.item_name}}</md-option></md-select></md-input-container></div>\n</div></div><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"40\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" translate=\"OPENSTOCKREPORT.DATE\">\nDate:</label><md-input-container flex style=\"margin-top:-5px\"><md-select name=\"type\" \nng-model=\"vm.openingstockDets.type\" ng-change=\"vm.changeDate()\"><md-option ng-repeat=\"op in vm.dateList\" ng-value=\"op\" \nng-selected=\"vm.openingstockDets.type==op\">{{op}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"OPENSTOCKREPORT.FROM\">From:</label><md-datepicker name=\"from\" md-placeholder=\"Enter date\" \nng-model=\"vm.openingstockDets.from\" flex></md-datepicker></div></div></div><div layout=\"column\" flex=\"30\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" \ntranslate=\"OPENSTOCKREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.openingstockDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i> <span translate=\"OPENSTOCKREPORT.LISTBILL_BTN\">List Bills</span>\n</md-button></div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"opening-stock-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" \nstyle=\"width: 8%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"OPENSTOCKREPORT.TABLE_SNO\">S.No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OPENSTOCKREPORT.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\" translate=\"OPENSTOCKREPORT.TABLE_ITEMNAME\">Item Name</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OPENSTOCKREPORT.TABLE_QTY\">Qty</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.itemInventoryReport\" ng-if=\"vm.itemInventoryReport.length>0\"><td align=\"center\">{{$index+1}}</td>\n<td align=\"center\">{{itm.inventory_date2}}</td><td align=\"center\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td \nalign=\"center\">{{itm.inventory_qty | number: vm.c_d}} {{itm.unit_name}}</td></tr></tbody><tr \nng-if=\"vm.itemInventoryReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"3\"></td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalStock | number: vm.c_d}}</td></tr></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/order-tag/order-tag.html","<div id=\"order_tag\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddOrderTag()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"ORDERTAG.NEW_ORDERTAG\">New Order Tags</span>\n</md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"order_tag-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ORDERTAG.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORDERTAG.TABLE_ORDERTAGNAME\">Order Tag Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORDERTAG.TABLE_STATUS\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ORDERTAG.TABLE_ACTION\">Action\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"cat in vm.ordeTag.orderTagList\"><td align=\"center\">{{$index+1}}\n</td><td align=\"left\" show-gt-sm><b>{{cat.order_tag_name}}</b></td><td align=\"center\">{{cat.order_tag_status}}</td><td \nalign=\"center\"><md-button class=\"actn-btn md-fab md-mini md-orange-400-bg\" style=\"padding:0px 0px 2px 0px\" \nng-click=\"vm.optionOrderTag(cat.order_tag_id)\"><md-tooltip md-direction=\"down\"><span translate=\"ORDERTAG.TABLE_OPTION\">\nOption</span></md-tooltip><i class=\"icon icon-table-large\"></i></md-button><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editOrderTag(cat.order_tag_id)\"><md-tooltip md-direction=\"down\"><span translate=\"ORDERTAG.TABLE_EDIT\">Edit\n</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteOrderTag(cat.order_tag_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"ORDERTAG.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/price-tag/price-tag.html","<div id=\"price_tag\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddPriceTags()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"PRICETAG.NEW_PRICETAG\">New Price Tags</span>\n</md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"price_tag-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PRICETAG.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PRICETAG.TABLE_PRICETAG_NAME\">Price Tag Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PRICETAG.TABLE_DESCRIPTION\">Description</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PRICETAG.TABLE_STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PRICETAG.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.price_tag.price_tagList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.price_tag_name}}</b></td><td align=\"center\">{{cat.price_tag_name}}</td><td align=\"center\">\n{{cat.price_tag_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editPriceTags(cat.price_tag_id)\"><md-tooltip md-direction=\"down\"><span translate=\"PRICETAG.TABLE_EDIT\">\nEdit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deletePriceTags(cat.price_tag_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"PRICETAG.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/pricing/pricing.html","<div id=\"pricing\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div></div><div\n class=\"list-content scrollable\" ms-scroll><div class=\"pricing-table-wrapper md-background-bg md-whiteframe-1dp\"><div \nclass=\"search\" layout=\"row\" layout-align=\"end center\"><span translate=\"PRICING.SEARCH\">Search: </span><input \ntype=\"text\" placeholder=\"Search\" ng-model=\"vm.search\"></div><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PRICING.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PRICING.TABLE_ITEMNAME\">Item Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PRICING.TABLE_OPTION\">Option\n</span></div></th><th class=\"secondary-text\" ng-repeat=\"tag in vm.tags | orderBy:\'price_tag_id\'\"><div \nclass=\"table-header\"><span class=\"column-title\">{{tag.price_tag_name}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.items | filter:vm.search\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.item_name}}</b></td><td align=\"center\">{{cat.itm_option_name}}</td><td align=\"center\" \nng-repeat=\"tag in cat.itmTags | orderBy:\'item_price_tag_id\' \">Rs: <input type=\"text\" name=\"item_price_price\" \nng-model=\"tag.item_price_price\"></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"brn-bx\"><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"vm.btnBlock==1\" ng-click=\"vm.savePricing()\" translate=\"PRICING.SAVE_BTN\">Save</md-button></div></div>\n</div></div>");
$templateCache.put("app/main/apps/printer-testing/printer-testing.html","<div id=\"printer-testing\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.testPrint()\"><i \nclass=\"icon icon-format-list-bulleted\"></i> Print Test</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/printers/printers.html","<div id=\"printers\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddPrinters()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>New Printers</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"printers-table-wrapper md-background-bg md-whiteframe-1dp\"><table\n class=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\" style=\"width:10%\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm style=\"width:40%\"><div \nclass=\"table-header\"><span class=\"column-title\">Printer Name</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"cat in vm.ordeTag.printersList\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"left\" show-gt-sm><b>{{cat.printers_name}}</b></td><td align=\"center\">{{cat.printers_status}}</td><td \nalign=\"center\"><md-button class=\"actn-btn md-fab md-mini\" ng-click=\"vm.editPrinters(cat.printers_id)\"><md-tooltip \nmd-direction=\"down\">Edit</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deletePrinters(cat.printers_id)\"><md-tooltip \nmd-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/apps/purchase/purchase.html","<div id=\"supplier\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n</div><div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised md-background\" \nng-click=\"vm.gotoAddPurchase()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"PURCHASELIST.NEWPURCHASE\">\nNew Purchase</span></md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"supplier-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.SNO\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PURCHASELIST.PURCHASENO\">Purchase No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.DATE\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.CUSTNAME\">\nSupplier Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PURCHASELIST.TYPE\">Warehouse Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"PURCHASELIST.NETTAMT\">Nett Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASELIST.ACTION\">Action</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"sal in vm.purchase.purchaseList\"><td align=\"center\">{{$index+1}}</td><td align=\"center\" \nshow-gt-sm><b>#{{sal.purchase_pre}}-{{sal.purchase_no}}</b></td><td align=\"center\">{{sal.purchase_date}}</td><td \nalign=\"center\" show-gt-sm><b>{{sal.supplier_name}}</b></td><td align=\"center\" show-gt-sm><b>{{sal.warehouse_name}}</b>\n</td><td align=\"center\">{{sal.purchase_total_net | number: vm.c_d}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editPurchase(sal.purchase_id)\"><md-tooltip md-direction=\"down\">Edit\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deletePurchase(sal.purchase_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i \nclass=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/purchase-report/purchase-report.html","<div id=\"purchase-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"40\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"PURCHASEREPORT.DATE\">Date:</label><md-input-container flex style=\"margin-top:-5px\">\n<md-select name=\"type\" ng-model=\"vm.purchaseDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.purchaseDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"PURCHASEREPORT.FROM\">From:</label><md-datepicker \nname=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.purchaseDets.from\" flex></md-datepicker></div></div></div><div \nlayout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"PURCHASEREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.purchaseDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i> <span translate=\"PURCHASEREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"opening-stock-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text text-center\" \nstyle=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASEREPORT.TABLE_SNO\">S.No\n</span></div></th><th class=\"secondary-text text-center\" style=\"width: 10%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PURCHASEREPORT.TABLE_PURCHASENO\">Purchase No</span></div></th><th \nclass=\"secondary-text text-center\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PURCHASEREPORT.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text text-center\" style=\"width: 25%\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"PURCHASEREPORT.TABLE_SUPPLIERNAME\">Supplier Name</span>\n</div></th><th class=\"secondary-text text-center\" style=\"width: 20%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PURCHASEREPORT.TABLE_TOTALQTY\">Total Qty</span></div></th><th \nclass=\"secondary-text text-center\" style=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PURCHASEREPORT.TABLE_TOTALNETT\">Total Nett</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.purchaseReport\" ng-if=\"vm.purchaseReport.length>0\"><td class=\"text-center\">{{$index+1}}</td><td \nclass=\"text-center\">#{{itm.purchase_pre}}-{{itm.purchase_no}}</td><td class=\"text-center\">{{itm.purchase_date}}</td><td\n style=\"text-align: left\">{{itm.supplier_name}}</td><td class=\"text-center\">{{itm.purchase_total_qty}}</td><td \nstyle=\"text-align: right\">{{itm.purchase_total_net | number: vm.c_d}}</td></tr></tbody><tr \nng-if=\"vm.purchaseReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"5\"></td><td \nstyle=\"text-align:right; background:#00a931\">{{vm.totalPurchase | number: vm.c_d}}</td></tr></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/purchasei/purchasei.html","<div id=\"supplier\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"content md-background-bg\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"center start\"></div><div layout=\"column\" layout-align=\"start center\"><md-button \nclass=\"new-btn md-raised md-background md-blue-500-bg\" ng-click=\"vm.gotoAddPurchasei()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span>New Purchase</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"supplier-table-wrapper md-background-bg md-whiteframe-1dp\"><table\n class=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Purchasei No</span></div>\n</th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Supplier Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Warehouse Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nett Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"sal in vm.purchasei.purchaseiList\"><td align=\"center\">{{$index+1}}</td><td align=\"center\" \nshow-gt-sm><b>#{{sal.purchasei_pre}}-{{sal.purchasei_no}}</b></td><td align=\"center\">{{sal.purchasei_date}}</td><td \nalign=\"center\" show-gt-sm><b>{{sal.supplier_name}}</b></td><td align=\"center\" show-gt-sm><b>{{sal.warehouse_name}}</b>\n</td><td align=\"center\">{{sal.purchasei_total_net | number: vm.c_d}}</td><td align=\"center\"><md-button \nclass=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.editPurchasei(sal.purchasei_id)\"><span>Edit</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" \nng-click=\"vm.deletePurchasei(sal.purchasei_id)\"><span>Delete</span></md-button></td></tr></tbody></table></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/recipes/recipes.html","<div id=\"recipes\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddRecipes()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"RECIPES.NEW_RECIPES\">New Recipes</span></md-button></div>\n</div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"recipes-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"RECIPES.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RECIPES.TABLE_RECENAME\">Recipes Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"RECIPES.TABLE_OPTION\">Option Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"RECIPES.TABLE_ACTION\">Action</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"recipe in vm.recipes.recipesList | orderBy:[\'itemlist_name\',\'itmlist_option_name\']:true\">\n<td align=\"center\">{{$index+1}}</td><td align=\"center\"><b>{{recipe.itemlist_name}}</b></td><td align=\"center\"><b>\n{{recipe.itmlist_option_name}}</b></td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editRecipes(recipe.recipes_id)\"><md-tooltip md-direction=\"down\"><span translate=\"RECIPES.EDIT\">Edit</span>\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteRecipes(recipe.recipes_id)\"><md-tooltip md-direction=\"down\"><span translate=\"RECIPES.DELETE\">Delete\n</span></md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/report/report.html","<div id=\"report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><h1 \nstyle=\"padding-left: 40px; font-weight: 500\" translate=\"REPORT.PAGE_TITLE\">Reports</h1><div class=\"content\"><a \ntranslate=\"REPORT.WRK_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.wprptBlock==0\" ui-sref=\"app.work-report\" \nui-sref-active=\"active\">Work Report </a><a translate=\"REPORT.SALE_EXPORT\" ms-nav-button md-ink-ripple \nng-if=\"vm.salexpBlock==0\" ui-sref=\"app.sales\" ui-sref-active=\"active\">Sales Exports </a><a \ntranslate=\"REPORT.SALE_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.salrptBlock==0\" ui-sref=\"app.sales-report\" \nui-sref-active=\"active\">Sales Report </a><a translate=\"REPORT.VERIFICATION_REPORT\" ms-nav-button md-ink-ripple \nng-if=\"vm.verrptBlock==0\" ui-sref=\"app.kot-report\" ui-sref-active=\"active\">Verification Report </a><a \ntranslate=\"REPORT.WAITER_SALE_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.waitsalesrptBlock==0\" \nui-sref=\"app.waiter-sales-report\" ui-sref-active=\"active\">Waiter Sales Report </a><a \ntranslate=\"REPORT.SALEX_TAXREPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.saltaxBlock==0\" \nui-sref=\"app.sales-tax-report\" ui-sref-active=\"active\">Sales Excl. Tax Report </a><a \ntranslate=\"REPORT.SALIN_TAXREPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.saltaxBlock==0\" \nui-sref=\"app.sales-intax-report\" ui-sref-active=\"active\">Sales Incl. Tax Report </a><a \ntranslate=\"REPORT.PURCHASE_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.purchaserptBlock==0\" \nui-sref=\"app.purchase-report\" ui-sref-active=\"active\">Purchase Report </a><a translate=\"REPORT.USER_REPORT\" \nms-nav-button md-ink-ripple ng-if=\"vm.usrrptBlock==0\" ui-sref=\"app.user-report\" ui-sref-active=\"active\">User Report \n</a><a translate=\"REPORT.CATSALE_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.catrptBlock==0\" \nui-sref=\"app.category-report\" ui-sref-active=\"active\">Category wise Sales Report </a><a \ntranslate=\"REPORT.ITMSALE_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.itmrptBlock==0\" ui-sref=\"app.item-report\" \nui-sref-active=\"active\">Item wise Sales Report </a><a translate=\"REPORT.CRNTSTOCK_REPORT\" ms-nav-button md-ink-ripple \nng-if=\"vm.itmstkrptBlock==0\" ui-sref=\"app.item-stock-report\" ui-sref-active=\"active\">Current Stock Report </a><a \ntranslate=\"REPORT.OPENSTOCK_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.stkuprptBlock==0\" \nui-sref=\"app.opening-stock-report\" ui-sref-active=\"active\">Opening Stock Report </a><a \ntranslate=\"REPORT.ITEMREORDER_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.itmreorptBlock==0\" \nui-sref=\"app.item-reorder-report\" ui-sref-active=\"active\">Item Reorder Report </a><a \ntranslate=\"REPORT.SHORTEXP_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.shexprptBlock==0\" \nui-sref=\"app.short-expiry-report\" ui-sref-active=\"active\">Short Expiry Report </a><a \ntranslate=\"REPORT.VARIANCE_REPORT\" ms-nav-button md-ink-ripple ng-if=\"vm.varrptBlock==0\" ui-sref=\"app.variance-report\" \nui-sref-active=\"active\">Variance Report </a><a translate=\"REPORT.DAYBOOK_REPORT\" translate=\"REPORT.WRK_REPORT\" \nms-nav-button md-ink-ripple ng-if=\"vm.dayrptBlock==0\" ui-sref=\"app.daybook-report\" ui-sref-active=\"active\">\nDaybook Report</a></div></div></div>");
$templateCache.put("app/main/apps/reportmenu/accordion.html","<div class=\"accordion\"><ms-nav><ms-nav-item ms-nav-toggle><a ms-nav-button md-ink-ripple ui-sref=\"app.report\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Reports List</span>\n</a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.wprptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.work-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Work Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.salexpBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.sales\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> \n<span class=\"ms-nav-label\">Sales Exports</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.salrptBlock==0\">\n<a ms-nav-button md-ink-ripple ui-sref=\"app.sales-report\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Sales Report</span></a></ms-nav-item><ms-nav-item\n ms-nav-toggle ng-if=\"vm.verrptBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.kot-report\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Verification Report\n</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.waitsalesrptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.waiter-sales-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Waiter Sales Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.saltaxBlock==0\">\n<a ms-nav-button md-ink-ripple ui-sref=\"app.sales-tax-report\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Sales Excl. Tax Report</span></a></ms-nav-item>\n<ms-nav-item ms-nav-toggle ng-if=\"vm.saltaxBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.sales-intax-report\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Sales Incl. Tax Report\n</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.purchaserptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.purchase-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Purcahse Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.usrrptBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.user-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">User Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.catrptBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.category-report\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Category wise Sales Report</span></a>\n</ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.itmrptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.item-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Item wise Sales Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.itmstkrptBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.item-stock-report\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Current Stock Report</span></a></ms-nav-item>\n<ms-nav-item ms-nav-toggle ng-if=\"vm.stkuprptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.opening-stock-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Opening Stock Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.itmreorptBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.item-reorder-report\" ui-sref-active=\"active\">\n<i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Item Reorder Report</span></a></ms-nav-item>\n<ms-nav-item ms-nav-toggle ng-if=\"vm.shexprptBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.short-expiry-report\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Short Expiry Report</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.varrptBlock==0\">\n<a ms-nav-button md-ink-ripple ui-sref=\"app.variance-report\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Variance Report</span></a></ms-nav-item>\n<ms-nav-item ms-nav-toggle ng-if=\"vm.dayrptBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.daybook-report\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Daybook Report</span>\n</a></ms-nav-item></ms-nav></div>");
$templateCache.put("app/main/apps/reportmenu/reportmenu.html","<div id=\"reportmenu\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/demo/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/apps/work-report/work-report.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/apps/reset-password/reset-password.html","<div id=\"reset-password1\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<img class=\"scl-logo\" ng-src=\"{{vm.files.url}}\"></div><div class=\"title\">Reset your password</div><form \nname=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"otp_no\" \nng-model=\"vm.resetData.otp_no\" placeholder=\"OTP\" translate translate-attr-placeholder=\"RESETPASSWORD.OTPP\" \nng-pattern=\"/^[a-zA-Z0-9]+$/\" md-minlength=\"7\" md-maxlength=\"7\" required><div \nng-messages=\"resetPasswordForm.otp_no.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.OTP_REQUIRED\">OTP field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.OTP_MUST_VALID\">OTP must be a valid</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.resetData.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nrequired><div ng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.resetData.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-if=\"vm.resetData.password!=vm.resetData.passwordConfirm\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_MISS_CONFIRM_REQUIRED\">Password (Confirm) not matched with Password</span>\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" \nng-click=\"vm.resetPassword()\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/apps/roles/roles.html","<div id=\"roles\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div><div \nlayout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddRoles()\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><span>New Roles</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"roles-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"roles in vm.roles.rolesList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{roles.roles_name}}</b></td><td align=\"center\">{{roles.roles_status}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editRoles(roles.roles_id)\"><md-tooltip md-direction=\"down\">Edit\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteRoles(roles.roles_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i \nclass=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/sales/sales.html","<div id=\"sales\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"33\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"SALES.DATE\">Date :</label><md-input-container flex style=\"margin-top:-5px\">\n<md-select name=\"type\" ng-model=\"vm.salesDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.salesDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"33\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"SALES.FROM\">From :</label><md-datepicker name=\"from\" \nmd-placeholder=\"Enter date\" ng-model=\"vm.salesDets.from\" ng-change=\"vm.listReport()\" flex></md-datepicker></div></div>\n</div><div layout=\"column\" flex=\"33\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label\n class=\"inpt-lbl\" translate=\"SALES.TO\">To :</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.salesDets.to\" ng-change=\"vm.listReport()\" flex></md-datepicker></div></div></div></div><div layout=\"row\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" \naria-label=\"Submit\" ng-click=\"vm.salesExport()\"><i class=\"icon icon-box-download\"></i> <span \ntranslate=\"SALES.DWNSALECSV\">Download Sales CSV</span></md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" aria-label=\"Submit\" ng-click=\"vm.taxExport()\"><i \nclass=\"icon icon-box-download\"></i> <span translate=\"SALES.DWNTAXCSV\">Download Tax CSV</span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" aria-label=\"Submit\" \nng-click=\"vm.realisationExport()\"><i class=\"icon icon-box-download\"></i> <span translate=\"SALES.DWNRECEIPTCSV\">\nDownload Receipt CSV</span></md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/sales-intax-report/sales-intax-report.html","<div id=\"sales-intax-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"40\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"SALEINTAXREPORT.DATE\">Date:</label><md-input-container flex style=\"margin-top:-5px\">\n<md-select name=\"type\" ng-model=\"vm.salesTaxDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.salesTaxDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"SALEINTAXREPORT.FROM\">From:</label><md-datepicker \nname=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.salesTaxDets.from\" flex></md-datepicker></div></div></div><div \nlayout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"SALEINTAXREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.salesTaxDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i><span translate=\"SALEINTAXREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"opening-stock-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text text-center\" \nstyle=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALEINTAXREPORT.TABLE_SNO\">S.No\n</span></div></th><th class=\"secondary-text text-center\" style=\"width: 15%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SALEINTAXREPORT.TABLE_DATE\">Date</span></div></th><th \nclass=\"secondary-text text-center\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALEINTAXREPORT.TABLE_BILLCOUNT\">Bill Count</span></div></th><th class=\"secondary-text text-center\" \nstyle=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALEINTAXREPORT.TABLE_BILLAMOUNT\">\nBill Amount</span></div></th><th class=\"secondary-text text-center\" style=\"width: 20%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SALEINTAXREPORT.TABLE_TAXAMOUNT\">Tax Amount</span></div></th><th \nclass=\"secondary-text text-center\" style=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALEINTAXREPORT.TABLE_TOTALAMOUNT\">Total Amount</span></div></th></tr></thead><tbody \nng-repeat=\"itm in vm.salesInTaxReport\" ng-if=\"vm.salesInTaxReport.length>0\"><tr><td class=\"text-center\">{{$index+1}}\n</td><td class=\"text-center\">{{itm.date}}</td><td class=\"text-center\">{{itm.billCount}}</td><td \nstyle=\"text-align:right\">{{itm.billAmount | number: vm.c_d}}</td><td style=\"text-align:right\">\n{{itm.taxAmount | number: vm.c_d}}</td><td style=\"text-align:right\">{{itm.totalAmount | number: vm.c_d}}</td></tr>\n</tbody><tr ng-if=\"vm.salesInTaxReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"2\"></td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalBills}}</td><td style=\"text-align:right; background:#00a931\">\n{{vm.totalAmount | number: vm.c_d}}</td><td style=\"text-align:right; background:#00a931\">\n{{vm.totalTaxs | number: vm.c_d}}</td><td style=\"text-align:right; background:#00a931\">\n{{vm.totalNett | number: vm.c_d}}</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/sales-report/sales-report.html","<div id=\"sales-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"SALEREPORT.PAYMENT_MODE\">Payment Mode :</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"mode\" ng-model=\"vm.salesDets.mode\"><md-option ng-value=\"\" \ntranslate=\"SALEREPORT.SELECTALL\">All</md-option><md-option ng-repeat=\"op in vm.payMode\" ng-value=\"op\" \nng-selected=\"vm.salesDets.mode==op\">{{op}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" \ntranslate=\"SALEREPORT.PAYMENT_DATE\">Date :</label><md-input-container flex style=\"margin-top:-5px\"><md-select \nname=\"type\" ng-model=\"vm.salesDets.type\" ng-change=\"vm.changeDate()\"><md-option ng-repeat=\"op in vm.dateList\" \nng-value=\"op\" ng-selected=\"vm.salesDets.type==op\">{{op}}</md-option></md-select></md-input-container></div></div></div>\n<div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\">\n<div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"SALEREPORT.PAYMENT_FROM\">\nFrom :</label><md-datepicker name=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.salesDets.from\" flex></md-datepicker>\n</div></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div \nlayout=\"row\"><label class=\"inpt-lbl\" translate=\"SALEREPORT.PAYMENT_TO\">To :</label><md-datepicker name=\"to\" \nmd-placeholder=\"Enter date\" ng-model=\"vm.salesDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" \nng-click=\"vm.listReport()\"><i class=\"icon icon-format-list-bulleted\"></i> <span translate=\"SALEREPORT.LISTBILL_BTN\">\nList Bills</span></md-button><md-button type=\"submit\" class=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" \naria-label=\"Submit\" ng-click=\"vm.salesPDFExport()\"><i class=\"icon icon-box-download\"></i> <span \ntranslate=\"SALEREPORT.DOWNLOADPDF_BTN\">Download as PDF</span></md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" aria-label=\"Submit\" ng-click=\"vm.salesCSVExport()\"><i \nclass=\"icon icon-box-download\"></i> <span translate=\"SALEREPORT.DOWNLOADCSV_BTN\">Download as CSV</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"sales-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SALEREPORT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALEREPORT.TABLE_BILLNO\">Bill No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALEREPORT.TABLE_DATE\">Date\n</span></div></th><th class=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALEREPORT.TABLE_AMOUNT\">Amount</span></div></th><th class=\"secondary-text text-right\" ng-if=\"vm.tax>0\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"SALEREPORT.TABLE_TAX\">Tax</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALEREPORT.TABLE_TOTALAMOUNT\">\nTotal Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALEREPORT.TABLE_MODE\">Mode</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.salesReportList\" \nng-if=\"vm.salesReportList.length>0\"><td align=\"center\">{{$index+1}}</td><td align=\"center\">{{itm.bil_no}}</td><td \nalign=\"center\">{{itm.bil_date}}</td><td style=\"text-align:right\">{{itm.bil_totalamt | number: vm.c_d}}</td><td \nstyle=\"text-align:right\">{{itm.bil_tottaxamt | number: vm.c_d}}</td><td style=\"text-align:right\">\n{{itm.bil_totalnetamt | number: vm.c_d}}</td><td align=\"center\">{{itm.bil_paymenttype}}</td></tr></tbody><tr \nng-if=\"vm.salesReportList.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"3\"></td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalAmt | number: vm.c_d}}</td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalTax | number: vm.c_d}}</td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalNet | number: vm.c_d}}</td><td align=\"center\"></td></tr></table>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/sales-tax-report/sales-tax-report.html","<div id=\"sales-tax-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"40\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"SALETAXREPORT.DATE\">Date:</label><md-input-container flex style=\"margin-top:-5px\">\n<md-select name=\"type\" ng-model=\"vm.salesTaxDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.salesTaxDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"SALETAXREPORT.FROM\">From:</label><md-datepicker \nname=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.salesTaxDets.from\" flex></md-datepicker></div></div></div><div \nlayout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"SALETAXREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.salesTaxDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i><span translate=\"SALETAXREPORT.LISTNILL_BTN\">List Bills</span></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" aria-label=\"Submit\" \nng-click=\"vm.salesTaxCSVExport()\"><i class=\"icon icon-box-download\"></i> <span translate=\"SALETAXREPORT.DWLDCSV_BTN\">\nDownload as CSV</span></md-button></div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"opening-stock-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text text-center\" \nstyle=\"width: 10%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALETAXREPORT.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text text-center\" style=\"width: 15%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SALETAXREPORT.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text text-center\" \nstyle=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALETAXREPORT.TABLE_BILLCOUNT\">\nBill Count</span></div></th><th class=\"secondary-text text-center\" style=\"width: 20%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SALETAXREPORT.TABLE_BILLAMOUNT\">Bill Amount</span></div></th><th \nclass=\"secondary-text text-center\" style=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALETAXREPORT.TABLE_TAXAMOUNT\">Tax Amount</span></div></th><th class=\"secondary-text text-center\" \nstyle=\"width: 20%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SALETAXREPORT.TABLE_TOTALAMOUNT\">\nTotal Amount</span></div></th></tr></thead><tbody ng-repeat=\"itm in vm.salesTaxReport\" \nng-if=\"vm.salesTaxReport.length>0\"><tr><td class=\"text-center\">{{$index+1}}</td><td class=\"text-center\">{{itm.date}}\n</td><td class=\"text-center\">{{itm.billCount}}</td><td style=\"text-align:right\">{{itm.billAmount | number: vm.c_d}}\n</td><td style=\"text-align:right\">{{itm.taxAmount | number: vm.c_d}}</td><td style=\"text-align:right\">\n{{itm.totalAmount | number: vm.c_d}}</td></tr></tbody><tr ng-if=\"vm.salesTaxReport.length>0\" class=\"btm-row\"><td \nalign=\"center\" colspan=\"2\"></td><td style=\"text-align:center; background:#00a931\">{{vm.totalBills}}</td><td \nstyle=\"text-align:right; background:#00a931\">{{vm.totalAmount | number: vm.c_d}}</td><td \nstyle=\"text-align:right; background:#00a931\">{{vm.totalTaxs | number: vm.c_d}}</td><td \nstyle=\"text-align:right; background:#00a931\">{{vm.totalNett | number: vm.c_d}}</td></tr></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/scategory/scategory.html","<div id=\"scategory\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddScategory()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"SCATEGORY.NEW_TABLE\">New Table</span></md-button></div>\n</div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"scategory-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SCATEGORY.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SCATEGORY.TABLE_CATNAME\">Category Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SCATEGORY.TABLE_ORDER\">Order</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SCATEGORY.TABLE_STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SCATEGORY.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.scategory.scategoryList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.scategory_name}}</b></td><td align=\"center\">{{cat.scategory_order}}</td><td align=\"center\">\n{{cat.scategory_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editScategory(cat.scategory_id)\"><md-tooltip md-direction=\"down\"><span translate=\"SCATEGORY.TABLE_EDIT\">\nEdit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteScategory(cat.scategory_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"SCATEGORY.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/seats/seats.html","<div id=\"seats\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddSeats()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"SEATS.NEW_TABLE\">New Table</span></md-button></div>\n</div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"seats-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SEATS.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SEATS.TABLE_TBLENAME\">Table Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\" translate=\"SEATS.TABLE_ORDER\">Order</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SEATS.TABLE_STATUS\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SEATS.TABLE_ACTION\">Action\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"cat in vm.seats.seatsList\"><td align=\"center\">{{$index+1}}</td><td\n align=\"left\" show-gt-sm><b>{{cat.table_name}}</b></td><td align=\"center\">{{cat.table_order}}</td><td align=\"center\">\n{{cat.table_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editSeats(cat.table_id)\"><md-tooltip md-direction=\"down\"><span translate=\"SEATS.TABLE_EDIT\">Edit</span>\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteSeats(cat.table_id)\"><md-tooltip md-direction=\"down\"><span translate=\"SEATS.TABLE_DELETE\">Delete\n</span></md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/settings/settings.html","<div id=\"new_settings\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll>\n<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"settingsForm\" class=\"md-inline-form\" novalidate><div\n class=\"form-title\"><h2>Settings Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label>Company Name</label><input type=\"text\" name=\"branch_name\" ng-model=\"vm.settings.branch_name\" ng-disabled=\"1\" \nrequired><div ng-messages=\"settingsForm.branch_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCompany Name field is required.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Address</label><textarea name=\"branch_address\" ng-model=\"vm.settings.branch_address\"></textarea>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>\nCity</label><input type=\"text\" name=\"branch_city\" ng-model=\"vm.settings.branch_city\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Country</label><input type=\"text\" name=\"branch_country\" \nng-model=\"vm.settings.branch_country\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Mobile No 1</label><input type=\"text\" name=\"branch_mobile1\" \nng-model=\"vm.settings.branch_mobile1\"></md-input-container><md-input-container class=\"md-block\" flex><label>Mobile No 2\n</label><input type=\"text\" name=\"branch_mobile2\" ng-model=\"vm.settings.branch_mobile2\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Email ID(s)</label><input \ntype=\"text\" name=\"branch_to_mailid\" ng-model=\"vm.settings.branch_to_mailid\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>GST No</label><input type=\"text\" name=\"branch_tin\" ng-model=\"vm.settings.branch_tin\" \nng-disabled=\"1\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Bill No Sequence</label><md-select name=\"branch_bill_sequence\" \nng-model=\"vm.settings.branch_bill_sequence\" ng-disabled=\"1\"><md-option ng-repeat=\"op in vm.billSeq\" ng-value=\"op\">\n{{op}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox md-no-ink \nng-model=\"vm.settings.branch_kitchennote_settings\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_kitchennote_settings==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Include Kitchen Note Price</span></md-input-container><md-input-container class=\"md-block\" flex>\n<md-checkbox md-no-ink ng-model=\"vm.settings.branch_staff_cancell\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_staff_cancell==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Allow Staff to Cancel Bills</span></md-input-container><md-input-container class=\"md-block\" flex>\n<md-checkbox md-no-ink ng-model=\"vm.settings.branch_wp_printing\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_wp_printing==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Download Bill When Work Period End</span></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Default Printer Name</label><md-select name=\"branch_wp_printer\" \nng-model=\"vm.settings.branch_wp_printer\"><md-option ng-repeat=\"op in vm.printersList\" ng-value=\"op.printers_id\">\n{{op.printers_name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>\nDefault Printer Size</label><input type=\"text\" name=\"branch_printer_size\" ng-model=\"vm.settings.branch_printer_size\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Min. Price Round of Rate (In Paisa Only)</label>\n<input type=\"text\" name=\"branch_roundofrate\" ng-model=\"vm.settings.branch_roundofrate\"> <span class=\"term\">\nBill decimal is >= given rate. its convert to 1</span></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label>Reminder Expiry</label><md-select \nname=\"branch_short_expiry\" ng-model=\"vm.settings.branch_short_expiry\"><md-option ng-repeat=\"op in vm.expiryDays\" \nng-value=\"op\">{{op}} Days Before</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Default Bill Prefix</label><input type=\"text\" name=\"branch_bill_prefix\" \nng-model=\"vm.settings.branch_bill_prefix\"> <span>\nCY - Current Year (eg:19), CURY - Current Year Full (eg:2019), FINY - Financial Year (eg:1920)</span>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Default Bill No Length</label><input type=\"text\" \nname=\"branch_bill_no_length\" ng-model=\"vm.settings.branch_bill_no_length\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><md-checkbox md-no-ink \nng-model=\"vm.settings.branch_showpaymentmodebeforeprint\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_showpaymentmodebeforeprint==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox>\n<span class=\"term\">Enable Payment Mode(s) Before Print Bill</span></md-input-container><md-input-container \nclass=\"md-block\" flex><md-checkbox md-no-ink ng-model=\"vm.settings.branch_anable_nacreason\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_anable_nacreason==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable NAC Reason</span></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nmd-no-ink ng-model=\"vm.settings.branch_anable_voidreason\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_anable_voidreason==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Void Reason</span></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nmd-no-ink ng-model=\"vm.settings.branch_anable_giftreason\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_anable_giftreason==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Gift Reason</span></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><md-checkbox md-no-ink ng-model=\"vm.settings.branch_showvoidafterprint\" \nclass=\"md-accent\" ng-checked=\"(vm.settings.branch_showvoidafterprint==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">\n</md-checkbox><span class=\"term\">Enable Void After Print Bill</span></md-input-container><md-input-container \nclass=\"md-block\" flex><md-checkbox md-no-ink ng-model=\"vm.settings.branch_showgiftafterprint\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_showgiftafterprint==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Gift After Print Bill</span></md-input-container><md-input-container class=\"md-block\" flex>\n</md-input-container><md-input-container class=\"md-block\" flex></md-input-container></div><div class=\"form-title\"><h2>\nMobile App Settings</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex>\n<md-checkbox md-no-ink ng-model=\"vm.settings.branch_app_enable_void\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_app_enable_void==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Void in App</span></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nmd-no-ink ng-model=\"vm.settings.branch_app_enable_gift\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_app_enable_gift==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Gift in App</span></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nmd-no-ink ng-model=\"vm.settings.branch_app_enable_waiters\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_app_enable_waiters==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Waiter Selection</span></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nmd-no-ink ng-model=\"vm.settings.branch_app_enable_print\" class=\"md-accent\" \nng-checked=\"(vm.settings.branch_app_enable_print==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\">Enable Print Bill</span></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><md-checkbox md-no-ink ng-model=\"vm.settings.branch_app_lock_table_print\" \nclass=\"md-accent\" ng-checked=\"(vm.settings.branch_app_lock_table_print==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">\n</md-checkbox><span class=\"term\">Lock Table after Print Bill</span></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"settingsForm.$invalid || settingsForm.$pristine\" ng-click=\"vm.saveSettings()\">Submit</md-button></div>\n</form></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/short-expiry-report/short-expiry-report.html","<div id=\"short-expiry-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"SHORTEXPIRYREPORT.CATNAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.shortStockDets.catID\"><md-option ng-value=\"\" \ntranslate=\"SHORTEXPIRYREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.shortStockDets.catID==op.category_id\">{{op.category_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><label class=\"inpt-lbl\" translate=\"SHORTEXPIRYREPORT.ITEM_NAME\">Item Name:</label><md-input-container\n flex style=\"margin-top:-5px\"><md-select name=\"itmID\" ng-model=\"vm.shortStockDets.itmID\"><md-option ng-value=\"\" \ntranslate=\"SHORTEXPIRYREPORT.SELECT_ALL\">All</md-option><md-option \nng-repeat=\"op in vm.itemList | filter:{catitm_category_id:vm.shortStockDets.catID}:true\" ng-value=\"op.item_id\" \nng-selected=\"vm.shortStockDets.itmID==op.item_id\">{{op.item_name}}</md-option></md-select></md-input-container></div>\n</div></div><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" \naria-label=\"Submit\" ng-click=\"vm.listReport()\"><i class=\"icon icon-format-list-bulleted\"></i> <span \ntranslate=\"SHORTEXPIRYREPORT.LISTITEM_BTN\">List Items</span></md-button></div></form></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div \nclass=\"short-expiry-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHORTEXPIRYREPORT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHORTEXPIRYREPORT.TABLE_ITEMNAME\">Item Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHORTEXPIRYREPORT.TABLE_INWARDQTY\">Inward Qty</span></div>\n</th><th class=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SHORTEXPIRYREPORT.TABLE_CURRENTQTY\">Current Qty</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SHORTEXPIRYREPORT.TABLE_EXPIRYON\">Expiry On</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.shortExpiryReport\" ng-if=\"vm.shortExpiryReport.length>0\"><td \nalign=\"center\">{{$index+1}}</td><td align=\"center\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td \nalign=\"center\">{{itm.inventory_qty | number: vm.c_d}} {{itm.unit_name}}</td><td align=\"center\">\n{{itm.inventory_currqty | number: vm.c_d}} {{itm.unit_name}}</td><td align=\"center\">{{itm.inventory_expiry_date2}}</td>\n</tr></tbody><tr ng-if=\"vm.shortExpiryReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"2\"></td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalStock | number: vm.c_d}}</td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalStock2 | number: vm.c_d}}</td><td \nstyle=\"text-align:center; background:#00a931\"></td></tr></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/sidenavs/sidenavs.html","<div class=\"sidnav-bx\"><div class=\"sec-tlt\"><h4>Notifications</h4></div><div class=\"list\" \nng-repeat=\"alert in vm.alertList\" ng-click=\"vm.orderdets()\"><div layout=\"row\" layout-align=\"space-between\"><h4>\n#{{alert.customerkot_no}}</h4><span class=\"price\">{{alert.department_name}}</span></div><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"qty\">{{alert.customer_name}}</span> <span class=\"qty\">\nTable No: {{alert.table_name}}</span></div></div></div>");
$templateCache.put("app/main/apps/staff/staff.html","<div id=\"staff\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" layout-align=\"center start\"></div><div layout=\"column\" layout-align=\"start center\"><md-button \nclass=\"new-btn md-raised md-background md-blue-500-bg\" ng-click=\"vm.gotoAddStaff()\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><span translate=\"STAFFLIST.NEWSTAFF\">New Staff</span></md-button></div></div><div\n class=\"list-content scrollable\" ms-scroll><div class=\"staff-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"STAFFLIST.SNO\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"STAFFLIST.NAME\">Company Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"STAFFLIST.Designation\">Designation</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"STAFFLIST.MOBILE\">Mobile No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"STAFFLIST.EMAIL\">Email ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"STAFFLIST.STATUS\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"STAFFLIST.ACTION\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.staff.staffList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.staff_name}}</b></td><td align=\"center\">{{cat.staff_designation}}</td><td align=\"center\">{{cat.staff_mobile}}\n</td><td align=\"center\">{{cat.staff_email}}</td><td align=\"center\">{{cat.staff_status}}</td><td align=\"center\">\n<md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.editStaff(cat.staff_id)\" \ntranslate=\"STAFFLIST.EDIT\"><span>Edit</span></md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" \nng-click=\"vm.deleteStaff(cat.staff_id)\" translate=\"STAFFLIST.DELETE\"><span>Delete</span></md-button></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/apps/stock-report/stock-report.html","<div id=\"stockreport\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"stockreport-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"STOCKREPORT.SNO\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"STOCKREPORT.WARE_NAME\">Warehouse Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"STOCKREPORT.INGRE_NAME\">Ingredient Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"STOCKREPORT.HAND_QTY\">Hand Qty\n</span></div></th></tr></thead><tbody ng-repeat=\"sal in vm.stockList\"><tr ng-if=\"sal.wstock_type==1\"><td \nalign=\"center\" style=\"color:#000000; font-weight:700\">{{$index+1}}</td><td align=\"left\" \nstyle=\"color:#000000; font-weight:700\"><b>{{sal.warehouse_name}}</b></td><td align=\"left\" \nstyle=\"color:#000000; font-weight:700\"><b>{{sal.ingredients_name}}</b></td><td align=\"center\" \nstyle=\"color:#000000; font-weight:700\"><b>{{sal.wstock_hqty | number : 3}} {{sal.unit_name}}</b></td></tr><tr \nng-if=\"sal.wstock_type==2\"><td align=\"center\" style=\"color:#FF0000; font-weight:700\">{{$index+1}}</td><td align=\"left\" \nstyle=\"color:#FF0000; font-weight:700\"><b>{{sal.warehouse_name}}</b></td><td align=\"left\" \nstyle=\"color:#FF0000; font-weight:700\"><b>{{sal.ingredients_name}}</b></td><td align=\"center\" \nstyle=\"color:#FF0000; font-weight:700\"><b>{{sal.wstock_hqty | number : 3}} {{sal.unit_name}}</b></td></tr><tr \nng-if=\"sal.wstock_type==3\"><td align=\"center\" style=\"color:#0033CC; font-weight:700\">{{$index+1}}</td><td align=\"left\" \nstyle=\"color:#0033CC; font-weight:700\"><b>{{sal.warehouse_name}}</b></td><td align=\"left\" \nstyle=\"color:#0033CC; font-weight:700\"><b>{{sal.ingredients_name}}</b></td><td align=\"center\" \nstyle=\"color:#0033CC; font-weight:700\"><b>{{sal.wstock_hqty | number : 3}} {{sal.unit_name}}</b></td></tr></tbody>\n</table></div><div layout=\"row\" layout-align=\"\"><div layout=\"row\" class=\"mean\"><span style=\"background:#0033CC\"></span>\n<h3 translate=\"STOCKREPORT.REACH_MAX\">Reached Maximum</h3></div><div layout=\"row\" class=\"mean\"><span \nstyle=\"background:#FF0000\"></span><h3 translate=\"STOCKREPORT.REACH_MIN\">Reached Minimum</h3></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/stock-update-report/stock-update-report.html","<div id=\"stock-update-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\">Item Name :</label><md-input-container flex style=\"margin-top:-5px\"><md-select name=\"itmID\" \nng-model=\"vm.stockupdateDets.itmID\"><md-option ng-value=\"\">All</md-option><md-option ng-repeat=\"op in vm.itemList\" \nng-value=\"op.item_id\" ng-selected=\"vm.stockupdateDets.itmID==op.item_id\">{{op.item_name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><label class=\"inpt-lbl\">Date :</label><md-input-container flex style=\"margin-top:-5px\"><md-select \nname=\"type\" ng-model=\"vm.stockupdateDets.type\" ng-change=\"vm.changeDate()\"><md-option ng-repeat=\"op in vm.dateList\" \nng-value=\"op\" ng-selected=\"vm.stockupdateDets.type==op\">{{op}}</md-option></md-select></md-input-container></div></div>\n</div><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"50\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\">From:</label>\n<md-datepicker name=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.stockupdateDets.from\" flex></md-datepicker></div>\n</div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\">\n<label class=\"inpt-lbl\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.stockupdateDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i>List Bills</md-button></div></form></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div \nclass=\"stock-update-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Item Name</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\">Qty</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.itemInventoryReport\" ng-if=\"vm.itemInventoryReport.length>0\"><td align=\"center\">{{$index+1}}</td>\n<td align=\"center\">{{itm.inventory_date2}}</td><td align=\"center\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td \nalign=\"center\">{{itm.inventory_qty | number: vm.c_d}} {{itm.unit_name}}</td></tr></tbody><tr \nng-if=\"vm.itemInventoryReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"3\"></td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalStock | number: vm.c_d}}</td></tr></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/supplier/supplier.html","<div id=\"supplier\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div><div \nlayout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddSupplier()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"SUPPLIER.NEW_SUPPLIER\">New Supplier</span></md-button>\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"supplier-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUPPLIER.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUPPLIER.TABLE_SUPPLIER_NAME\">Supplier Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUPPLIER.TABLE_MOBIENO\">Mobile No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUPPLIER.TABLE_STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUPPLIER.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.supplier.supplierList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.supplier_name}}</b></td><td align=\"center\">{{cat.supplier_mobileno}}</td><td align=\"center\">\n{{cat.supplier_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editSupplier(cat.supplier_id)\"><md-tooltip md-direction=\"down\"><span translate=\"SUPPLIER.TABLE_EDIT\">Edit\n</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteSupplier(cat.supplier_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"SUPPLIER.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/support/support.html","<div id=\"support\" class=\"page-layout simple fullwidth\" ms-scroll><div class=\"center\" layout=\"row\" flex><div \nclass=\"support1\"><h4>Customer Service & Support Delivered by IT Professionals</h4><p>\nService and support is at the heart of what we do and we know the importance of keeping our customers happy.</p><div \nclass=\"support1-bx1\"><span><md-icon md-font-icon=\"icon-headset\"></md-icon></span><p>\nWe’ll be there to assist you whenever you need help with QuickPOS software. Our support team is readily available to answer any of your QuickPOS software questions via e-mail, telephone, remote desktop and live chat support.\n</p></div><div class=\"support1-bx2\"><h4>Contact Support</h4><label>Email:</label><span>posstationtrichy@gmail.com\n</span><label>Phone:</label><span>+91 99650 19000</span></div></div></div></div>");
$templateCache.put("app/main/apps/tables/content.html","<div layout=\"row\" class=\"tbl-bx\"><div class=\"colm\" layout=\"column\" flex=\"100\" flex-gt-sm=\"20\" flex-gt-xs=\"50\" \nalign=\"center\" ng-repeat=\"tbl in vm.table | filter:{table_scategory_id:vm.catID}:true\"><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" class=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple \nng-click=\"vm.gotoDining(tbl.table_id)\" ng-if=\"tbl.status==0\"><ms-widget-front><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{tbl.table_name}}</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" class=\"crd md-background md-orange-200-bg grey-900-fg\" md-ink-ripple \nng-click=\"vm.gotoDining(tbl.table_id)\" ng-if=\"tbl.status==1\"><ms-widget-front><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{tbl.table_name}}</span></div><div layout=\"row\" layout-align=\"space-between\" \nclass=\"dtamd\"><div class=\"dt\" layout=\"column\" layout-align=\"start\"><span>Started On :<label \nclass=\"font-weight-900 red-300-fg\">{{tbl.startON}}</label></span></div><div class=\"amd\" layout=\"column\" \nlayout-align=\"end\"><span class=\"font-weight-900 red-300-fg\"><i class=\"icon icon-currency-inr\"></i>\n {{tbl.amount | number: vm.c_d}}</span></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" class=\"crd md-background md-red-300-bg grey-900-fg\" md-ink-ripple \nng-click=\"vm.gotoDining(tbl.table_id)\" ng-if=\"tbl.status==2\"><ms-widget-front><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{tbl.table_name}}</span></div><div layout=\"row\" layout-align=\"space-between\" \nclass=\"dtamd\"><div class=\"dt\" layout=\"column\" layout-align=\"start\"><span>Started On :<label \nclass=\"font-weight-900 orange-300-fg\">{{tbl.startON}}</label></span></div><div class=\"amd\" layout=\"column\" \nlayout-align=\"end\"><span class=\"font-weight-900 orange-300-fg\"><i class=\"icon icon-currency-inr\"></i>\n {{tbl.amount | number: vm.c_d}}</span></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/apps/tables/table.html","<div id=\"tables\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"column\" layout-align=\"start center\">\n<div class=\"refrsh-btn-bx\"><md-button class=\"refrsh-btn md-background md-green-600-bg grey-50-fg\" \nng-click=\"vm.refreshTable()\"><md-icon md-font-icon=\"icon-refresh\" class=\"grey-50-fg\"></md-icon><span \ntranslate=\"TABLE.REFRESH_BTN\">Refresh</span></md-button></div><md-tabs md-dynamic-height><md-tab \nng-repeat=\"cat in vm.category | filter:{scategory_dept_id:vm.deptID}:true\" label=\"{{cat.scategory_name}}\" \nng-click=\"vm.setCategory(cat.scategory_id)\"><md-tab-body><div layout=\"row\" class=\"tbl-bx\"><div class=\"colm\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"20\" flex-gt-xs=\"50\" align=\"center\" \nng-repeat=\"tbl in vm.table | filter:{tableDeptID:vm.deptID,table_scategory_id:vm.catID}:true\"><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" class=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple \nng-click=\"vm.gotoDining(tbl.table_id)\" ng-if=\"tbl.status==0\"><ms-widget-front><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{tbl.table_name}}</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" class=\"crd md-background md-red-300-bg grey-900-fg\" md-ink-ripple \nng-click=\"vm.gotoDining(tbl.table_id)\" ng-if=\"tbl.status==1\"><ms-widget-front><div class=\"tble\" layout=\"row\" \nlayout-align=\"center center\"><span>{{tbl.table_name}}</span></div><div layout=\"row\" layout-align=\"space-between\" \nclass=\"dtamd\"><div class=\"dt\" layout=\"column\" layout-align=\"start\"><span><label class=\"font-weight-900 orange-100-fg\">\n{{tbl.time}}</label></span></div><div class=\"amd\" layout=\"column\" layout-align=\"end\"><span \nclass=\"font-weight-900 orange-100-fg\">{{vm.c_s}} {{tbl.amount | number:vm.c_d}}</span></div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nclass=\"crd md-background md-green-500-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.gotoDining(tbl.table_id)\" \nng-if=\"tbl.status==2\"><ms-widget-front><div class=\"tble\" layout=\"row\" layout-align=\"center center\"><span>\n{{tbl.table_name}}</span></div><div layout=\"row\" layout-align=\"space-between\" class=\"dtamd\"><div class=\"dt\" \nlayout=\"column\" layout-align=\"start\"><span><label class=\"font-weight-900 grey-50-fg\">{{tbl.time}}</label></span></div>\n<div class=\"amd\" layout=\"column\" layout-align=\"end\"><span class=\"font-weight-900 grey-50-fg\">\n{{vm.c_s}} {{tbl.amount | number:vm.c_d}}</span></div></div></ms-widget-front></ms-widget></div></div></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/tax/tax.html","<div id=\"tax\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddTax()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>New Tax</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"tax-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Tax Name</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Rate</span></div>\n</th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.ordeTag.taxList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.tax_name}}</b></td><td align=\"right\">{{cat.tax_rate | number: vm.c_d}}</td><td align=\"center\">{{cat.tax_type}}\n</td><td align=\"center\">{{cat.tax_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editTax(cat.tax_id)\"><md-tooltip md-direction=\"down\">Edit</md-tooltip><i class=\"icon icon-table-edit\"></i>\n</md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteTax(cat.tax_id)\"><md-tooltip \nmd-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/apps/template/template.html","<div id=\"template\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddTemplates()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>New Template</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"template-table-wrapper md-background-bg md-whiteframe-1dp\"><table\n class=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Template Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"temp in vm.template.templateList\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"left\" show-gt-sm><b>{{temp.template_name}}</b></td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editTemplates(temp.template_id)\"><md-tooltip md-direction=\"down\">Edit\n</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteTemplates(temp.template_id)\"><md-tooltip md-direction=\"down\">Delete</md-tooltip><i \nclass=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/transfer/transfer.html","<div id=\"transfer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n</div><div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised md-background\" \nng-click=\"vm.gotoAddTransfer()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"TRANSFER.NEW_TRANSFERBTN\">\nNew Transfer</span></md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"transfer-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSFER.TBL_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSFER.TBL_TRANSFERNO\">Transfer No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TRANSFER.TBL_DATE\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSFER.TBL_FRMBRANCH\">\nFrom Branch</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSFER.TBL_FRMWAREHOUSE\">From Warehouse</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TRANSFER.TBL_TOBRANCH\">To Branch</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSFER.TBL_TOWAREHOUSE\">\nTo Warehouse</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSFER.TBL_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"sal in vm.transfer.transferList\"><td align=\"center\">{{$index+1}}</td><td align=\"center\"><b>\n#{{sal.transfer_pre}}-{{sal.transfer_no}}</b></td><td align=\"center\">{{sal.transfer_date}}</td><td align=\"center\"><b>\n{{sal.fromBranch}}</b></td><td align=\"center\"><b>{{sal.fromWarehouse}}</b></td><td align=\"center\"><b>{{sal.toBranch}}\n</b></td><td align=\"center\"><b>{{sal.toWarehouse}}</b></td><td align=\"center\"><md-button \nclass=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.editTransfer(sal.transfer_id)\"><span \ntranslate=\"TRANSFER.TBL_EDIT\">Edit</span></md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" \nng-click=\"vm.deleteTransfer(sal.transfer_id)\"><span translate=\"TRANSFER.TBL_DELETE\">Delete</span></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/tickets/tickets.html","<div id=\"tickets\" class=\"page-layout simple fullwidth\"><div class=\"list-content\"><div class=\"admission-content\" \nlayout=\"column\"><div class=\"form-wrapper\" flex=\"100\"><form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"row\" flex class=\"flex\"><label \ntranslate=\"TICKETS.FROM\">From:</label><md-datepicker name=\"fromDate\" md-placeholder=\"Enter date\" \nng-model=\"vm.tickets.fromDate\" flex></md-datepicker></div><div layout=\"row\" flex class=\"flex\"><label class=\"pl-20\" \ntranslate=\"TICKETS.TO\">To:</label><md-datepicker name=\"toDate\" md-placeholder=\"Enter date\" \nng-model=\"vm.tickets.toDate\" flex></md-datepicker></div></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\" style=\"padding:17px 0px 0px 0px\"><div layout=\"row\" flex class=\"flex\"><label \nclass=\"inpt-lbl\" translate=\"TICKETS.PAYMENT_MODE\">Payment Mode:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"mode\" ng-model=\"vm.tickets.mode\"><md-option ng-value=\"\" \ntranslate=\"TICKETS.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.payMode\" ng-value=\"op\" \nng-selected=\"vm.tickets.mode==op\">{{op}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex \nclass=\"flex\"><label class=\"pl-20\" translate=\"TICKETS.STATUS\">Status:</label><md-input-container flex><md-select \nname=\"status\" ng-model=\"vm.tickets.status\"><md-option ng-value=\"\" translate=\"TICKETS.SELECT_ALL\">All</md-option>\n<md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl pl-20\" translate=\"TICKETS.BILLNO\">Bill No:</label>\n<md-input-container flex style=\"margin-top:-5px\"><input ng-model=\"vm.tickets.billno\" \nmd-placeholder=\"Enter Bill No Only Eg.: 1 or 12 or 123 \"></md-input-container></div></div><div layout=\"row\" \nlayout-gt-xs=\"row\"><div layout=\"row\" layout-align=\"center center\" flex class=\"flex\"><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listTickets()\"><span translate=\"TICKETS.LIST_BTN\">\nList</span></md-button></div></div></form></div></div><div \nclass=\"tickets-table-wrapper md-background-bg md-whiteframe-1dp\" ms-scroll><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TICKETS.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\" \nstyle=\"min-width:50px\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TICKETS.TABLE_TICKETNO\">\nTickets No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TICKETS.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TICKETS.TABLE_TYPE\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TICKETS.TABLE_TABLE\">Table</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TICKETS.TABLE_CUSTOMER\">Customer\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TICKETS.TABLE_NETTAMOUNT\">Nett Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"TICKETS.TABLE_STATUS\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TICKETS.TABLE_MODE\">Mode</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.ticketDets\" ng-click=\"vm.showItms(cat.bil_id)\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"center\">#{{cat.fullBillNo}}</td><td align=\"center\">{{cat.bil_date}}</td><td align=\"center\">{{cat.bil_type}}</td>\n<td align=\"center\" ng-if=\"cat.table_name!=null\">{{cat.table_name}}</td><td align=\"center\" ng-if=\"cat.table_name==null\">\n-</td><td align=\"center\" ng-if=\"cat.customer_name!=null\">{{cat.customer_name}}</td><td align=\"center\" \nng-if=\"cat.customer_name==null\">-</td><td align=\"right\">{{cat.billTotal | number: vm.c_d}}</td><td align=\"center\">\n{{cat.bil_status}}</td><td align=\"center\">{{cat.bil_paymenttype}}</td></tr><tr ng-if=\"vm.ticketDets.length==0\"><td \ncolspan=\"11\" translate=\"TICKETS.TABLE_NOTICKET_FOUND\">No Tickets Found</td></tr></tbody></table></div></div><div \nclass=\"bill_1\" layout=\"column\" layout-align=\"top\" ng-if=\"vm.paymentDet.bil_id!=\'\'\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"md-grey-200-bg p-5\"><div layout=\"column\" layout-align=\"start\"><span \nclass=\"h4 grey-50-fg font-size-16 pl-5 grey-900-fg font-weight-900\"><label>#{{vm.paymentDet.fullBillNo}}</label></span>\n</div><div layout=\"column\" layout-align=\"end\"><span \nclass=\"h4 grey-50-fg font-size-16 pl-5 grey-900-fg font-weight-900\"><label>{{vm.paymentDet.bil_status}}</label></span>\n</div></div><div class=\"scroll\" ng-if=\"vm.showSummary==0\"><div class=\"contact-item\" \nng-repeat=\"itm in vm.paymentDet.ticketItms\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start\"><span class=\"font-size-16\">{{itm.bitm_qty}}</span><span class=\"font-size-16 pl-10\">\n{{itm.item_name}}<span ng-if=\"itm.itm_option_name!=\'Normal\'\">.{{itm.itm_option_name}}</span></span></div><div \nlayout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-16\">{{itm.bitm_total | number: vm.c_d}}</p></div></div><div \nlayout=\"row\" layout-align=\"space-between\" ng-repeat=\"tag in itm.billitemTag\"><div layout=\"row\" layout-align=\"start\">\n<span class=\"font-size-13\"></span><span class=\"font-size-13 pl-10 red-900-fg\">{{tag.billitemtag_ordertag_name}}</span>\n</div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-13 red-900-fg\">\n{{tag.billitemtag_ordertag_rate | number: vm.c_d}}</p></div></div></div></div><div class=\"scroll\" \nng-if=\"vm.showSummary==1\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-3 black-900-fg\"><b translate=\"TICKETS.TAX_SUMMARY\">Tax Summary: </b></p></div><div \nclass=\"contact-item\" ng-repeat=\"tax in vm.paymentDet.billTaxList | orderBy: \'tax_name\'\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-14 pl-2\">{{tax.tax_name}} \n<span ng-if=\"tax.tax_type==\'Exclusive\'\">(Excl.)</span> <span ng-if=\"tax.tax_type==\'Inclusive\'\">(Incl.)</span></span>\n</div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-14\" ng-if=\"tax.tax_type==\'Exclusive\'\">\n{{tax.tax_amt | number: vm.c_d}}</p><p class=\"m-0 font-size-14\" ng-if=\"tax.tax_type==\'Inclusive\'\">\n{{tax.tax_amt2 | number: vm.c_d}}</p></div></div></div><div class=\"contact-item\" ng-if=\"vm.taxTotal>0\"><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-14 pl-2\">\n</span></div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-14\">{{vm.taxTotal | number: vm.c_d}}</p>\n</div></div></div><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-3 black-900-fg\"><b translate=\"TICKETS.EXTRA_SUMMARY\">Extra Summary: </b></p></div><div \nclass=\"contact-item\" ng-repeat=\"xtr in vm.paymentDet.billExtraList | orderBy: \'extra_name\'\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start\"><span class=\"font-size-14 pl-2\">{{xtr.extra_name}}\n</span></div><div layout=\"column\" layout-align=\"end\"><p class=\"m-0 font-size-16\">{{vm.extraTotal | number: vm.c_d}}</p>\n</div></div></div><div class=\"contact-item\" ng-if=\"vm.extraTotal>0\"><div layout=\"row\" layout-align=\"space-between\"><div\n layout=\"row\" layout-align=\"start\"><span class=\"font-size-14 pl-2\"></span></div><div layout=\"column\" \nlayout-align=\"end\"><p class=\"m-0 font-size-14\">{{vm.extraTotal | number: vm.c_d}}</p></div></div></div><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-3 black-900-fg\"><b \ntranslate=\"TICKETS.PAYMENT_SUMMARY\">Payment Summary: </b></p></div><div class=\"contact-item\" \nng-repeat=\"pay in vm.paymentDet.billPaymentList\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start\"><span class=\"font-size-14 pl-2\">{{pay.bill_type}}</span></div><div layout=\"column\" \nlayout-align=\"end\"><p class=\"m-0 font-size-14\">{{pay.bill_amount | number: vm.c_d}}</p></div></div></div><div \nclass=\"contact-item\" ng-if=\"vm.paymentTotal>0\"><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start\"><span class=\"font-size-14 pl-2\"></span></div><div layout=\"column\" layout-align=\"end\"><p \nclass=\"m-0 font-size-14\">{{vm.paymentTotal | number: vm.c_d}}</p></div></div></div></div><div \nclass=\"blnc md-grey-300-bg\" ng-if=\"vm.paymentDet!=\'\'\"><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.paymentDet.bil_totalamt!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 grey-900-fg\"><b translate=\"TICKETS.BILL_AMOUNT\">Bill Amount: </b></p></div><div \nclass=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 grey-900-fg\"><b>\n{{vm.paymentDet.bil_totalamt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.paymentDet.bil_totextraamt!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 grey-900-fg\"><b translate=\"TICKETS.EXTRA_CHARGE\">Extra Charges: </b></p></div><div \nclass=\"select_1\" layout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 grey-900-fg\"><b>\n{{vm.paymentDet.bil_totextraamt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.paymentDet.bil_tottaxamt!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 grey-900-fg\"><b translate=\"TICKETS.TAX\">Tax: </b></p></div><div class=\"select_1\" \nlayout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 grey-900-fg\"><b>\n{{vm.paymentDet.bil_tottaxamt | number: vm.c_d}}</b></p></div></div><div layout=\"row\" layout-align=\"space-between\" \nng-if=\"vm.discount!=\'\'\"><div class=\"select_1\" layout=\"column\" layout-align=\"start\"><p \nclass=\"show-gt-sm m-0 pt-5 grey-900-fg\"><b translate=\"TICKETS.DISCOUNT\">Discount: </b></p></div><div class=\"select_1\" \nlayout=\"column\" layout-align=\"end\"><p class=\"show-gt-md m-0 grey-900-fg\"><b>{{vm.discount | number: vm.c_d}}</b></p>\n</div></div><div layout=\"row\" layout-align=\"space-between\" ng-if=\"vm.paymentDet.bil_totalnetamt!=\'\'\"><div \nclass=\"select_1\" layout=\"column\" layout-align=\"start\"><p class=\"show-gt-sm m-0 pt-5 red-900-fg\"><b \ntranslate=\"TICKETS.BALANCE\">Balance: </b></p></div><div class=\"select_1\" layout=\"column\" layout-align=\"end\"><p \nclass=\"show-gt-md m-0 red-900-fg\"><b>{{vm.paymentDet.billTotal | number: vm.c_d}}</b></p></div></div></div><div \nclass=\"cncl-tckt\" ng-if=\"vm.paymentDet.bil_status==\'Ordered\'\"><div layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" class=\"cncl-bx\" layout-align=\"start\" ng-if=\"vm.reasonTag == 0\" flex><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-red-500-bg grey-50-fg\" aria-label=\"Submit\" \nng-click=\"vm.gotoTicket(vm.paymentDet)\"><span translate=\"TICKETS.GOTO_TICKETS\">Goto Ticket</span></md-button></div>\n</div></div><div class=\"cncl-tckt\" ng-if=\"vm.paymentDet.bil_status==\'Completed\'\"><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" class=\"cncl-bx\" layout-align=\"start\" flex><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-orange-500-bg grey-40-fg\" aria-label=\"Submit\" ng-if=\"vm.showSummary==0\" \nng-click=\"vm.billSummary()\"><span translate=\"TICKETS.SHOW_SUMMARY\">Show Summary</span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent tp-btn md-orange-500-bg grey-40-fg\" aria-label=\"Submit\" \nng-if=\"vm.showSummary==1\" ng-click=\"vm.billSummary()\"><span translate=\"TICKETS.HIDE_SUMMARY\">Hide Summary</span>\n</md-button></div><div layout=\"column\" class=\"cncl-bx\" layout-align=\"start\" ng-if=\"vm.reasonTag == 0\" flex><md-button \ntype=\"submit\" class=\"md-raised md-accent tp-btn md-red-500-bg grey-40-fg\" aria-label=\"Submit\" \nng-disable=\"vm.showSummary==1\" ng-click=\"vm.cancelTicket()\"><span translate=\"TICKETS.CANCEL_TICKET\">Cancel Ticket\n</span></md-button></div><div layout=\"column\" class=\"cncl-bx\" layout-align=\"end\" ng-if=\"vm.reasonTag == 0\" flex>\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn md-blue-500-bg grey-40-fg\" aria-label=\"Submit\" \nng-disable=\"vm.showSummary==1\" ng-click=\"vm.printTicket()\"><span translate=\"TICKETS.REPRINT_TICKET\">Reprint Ticket\n</span></md-button></div></div><div layout=\"row\" flex class=\"flex cncl-bx\" layout-align=\"center center\" \nng-if=\"vm.reasonTag ==  1\"><textarea placeholder=\"Reason For Cancellation\" ng-model=\"vm.paymentDet.bil_remarks\">\n</textarea></div><div layout=\"row\" flex class=\"flex cncl-bx\" layout-align=\"center center\" ng-if=\"vm.reasonTag ==  1\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn md-blue-500-bg grey-50-fg\" aria-label=\"Submit\" \nng-click=\"vm.saveTickets()\"><span translate=\"TICKETS.SAVE_BTN\">Save</span></md-button></div></div><div \nclass=\"cncl-tckt\" ng-if=\"vm.paymentDet.bil_status==\'Cancelled\'\"><div layout=\"row\" flex class=\"flex cncl-bx\" \nlayout-align=\"star\"><label><span translate=\"TICKETS.REMARK\">Remarks:</span> {{vm.paymentDet.bil_remarks}}</label></div>\n</div></div></div>");
$templateCache.put("app/main/apps/transferin/transferin.html","<div id=\"transfer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"transfer-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSFERIN.SNO\">S.No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSFERIN.TRANSFERNO\">Transfer No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TRANSFERIN.DATE\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSFERIN.FRMBRANCH\">\nFrom Branch</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSFERIN.FRMWAREHOUSE\">From Warehouse</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TRANSFERIN.TOBRANCH\">To Branch</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSFERIN.TOWAREHOUSE\">\nTo Warehouse</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSFERIN.ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"sal in vm.transfer.transferList\"><td align=\"center\">{{$index+1}}</td><td align=\"center\"><b>\n#{{sal.transfer_pre}}-{{sal.transfer_no}}</b></td><td align=\"center\">{{sal.transfer_date}}</td><td align=\"center\"><b>\n{{sal.fromBranch}}</b></td><td align=\"center\"><b>{{sal.fromWarehouse}}</b></td><td align=\"center\"><b>{{sal.toBranch}}\n</b></td><td align=\"center\"><b>{{sal.toWarehouse}}</b></td><td align=\"center\"><md-button \nclass=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.editTransferin(sal.transfer_id)\"><span \ntranslate=\"TRANSFERIN.RECEIVE\">Receive</span></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/units/units.html","<div id=\"units\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddUnits()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>New Unit</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"units-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Unit Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"cat in vm.units.unitsList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" \nshow-gt-sm><b>{{cat.unit_name}}</b></td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editUnits(cat.unit_id)\"><md-tooltip md-direction=\"down\">Edit</md-tooltip><i class=\"icon icon-table-edit\">\n</i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteUnits(cat.unit_id)\">\n<md-tooltip md-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/apps/user/user.html","<div id=\"user\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div><div \nlayout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddUser()\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><span>New User</span></md-button></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"user-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"user in vm.user.userList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{user.usr_name}}</b></td><td align=\"center\">{{user.usr_type}}</td><td align=\"center\">{{user.usr_status}}</td><td \nalign=\"center\"><md-button class=\"actn-btn md-fab md-mini\" ng-click=\"vm.editUser(user.usr_id)\"><md-tooltip \nmd-direction=\"down\">Edit</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteUser(user.usr_id)\"><md-tooltip md-direction=\"down\">\nDelete</md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/user-report/user-report.html","<div id=\"user-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"USERREPORT.USER_NAME\">User Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"userID\" ng-model=\"vm.userDets.userID\"><md-option ng-value=\"\">All</md-option>\n<md-option ng-repeat=\"op in vm.userList\" ng-value=\"op.usr_id\" ng-selected=\"vm.userDets.userID==op.usr_id\">\n{{op.usr_name}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" translate=\"USERREPORT.DATE\">Date:\n</label><md-input-container flex style=\"margin-top:-5px\"><md-select name=\"type\" ng-model=\"vm.userDets.type\" \nng-change=\"vm.changeDate()\"><md-option ng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.userDets.type==op\">\n{{op}}</md-option></md-select></md-input-container></div></div></div><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<div layout=\"row\"><label class=\"inpt-lbl\" translate=\"USERREPORT.FROM\">From:</label><md-datepicker name=\"from\" \nmd-placeholder=\"Enter date\" ng-model=\"vm.userDets.from\" flex></md-datepicker></div></div></div><div layout=\"column\" \nflex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" \ntranslate=\"USERREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" ng-model=\"vm.userDets.to\" \nflex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i> <span translate=\"USERREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"user-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"USERREPORT.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"USERREPORT.TABLE_USERNAME\">User Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERREPORT.TABLE_BILLNO\">Bill No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERREPORT.TABLE_DATE\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"USERREPORT.TABLE_TOTALAMOUNT\">Total Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"USERREPORT.TABLE_MODE\">Mode</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"itm in vm.userReportList\" ng-if=\"vm.userReportList.length>0\"><td align=\"center\">\n{{$index+1}}</td><td align=\"center\">{{itm.usr_name}}</td><td align=\"center\">{{itm.bil_no}}</td><td align=\"center\">\n{{itm.bil_date}}</td><td style=\"text-align:right\">{{itm.bil_totalnetamt | number: vm.c_d}}</td><td align=\"center\">\n{{itm.bil_paymenttype}}</td></tr></tbody><tr ng-if=\"vm.userReportList.length>0\" class=\"btm-row\"><td align=\"center\" \ncolspan=\"3\"></td><td style=\"text-align:right;background:#00a931\">{{vm.totalAmt | number: vm.c_d}}</td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalTax | number: vm.c_d}}</td><td \nstyle=\"text-align:right;background:#00a931\">{{vm.totalNet | number: vm.c_d}}</td><td align=\"center\"></td></tr></table>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/variance/variance.html","<div id=\"variance\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"varianceForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2>Physical Stock Update</h2></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bx\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" flex></div><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-click=\"vm.saveVariance()\">Save Variances</md-button></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-5\"><table class=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th \nclass=\"text-center\">S.No</th><th class=\"text-center\" style=\"max-width:200px; min-width:200px\">Item Name</th><th \nclass=\"text-center\" style=\"max-width:100px;min-width:100px\">Current Stock</th><th class=\"text-center\" \nstyle=\"max-width:100px;min-width:100px\">Physical Stock</th><th class=\"text-center\" \nstyle=\"max-width:100px;min-width:100px\">Variance Qty</th><th class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\">Remarks</th></tr></thead><tbody><tr ng-if=\"vm.itemStockList.length>0\" \nng-repeat=\"itm in vm.itemStockList | filter:vm.search\"><td class=\"text-center\">{{$index+1}}</td><td class=\"text-left\">\n<h6>{{itm.item_name}}</h6></td><td class=\"text-center\">{{itm.item_currqty | number: vm.c_d}} {{itm.unit_name}}</td><td \nclass=\"text-center\"><input type=\"text\" name=\"physicalQty\" ng-model=\"itm.physicalQty\" ng-change=\"vm.setVariance()\"></td>\n<td class=\"text-center\">{{itm.varianceQty | number: vm.c_d}} {{itm.unit_name}}</td><td class=\"text-center\"><textarea \nname=\"remarks\" ng-model=\"itm.remarks\" rows=\"2\"></textarea></td></tr><tr ng-if=\"vm.itemStockList.length==0\"><td \ncolspan=\"6\" class=\"text-center\">No Records</td></tr></tbody></table></div></ms-widget-front></ms-widget></div></form>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/variance-report/variance-report.html","<div id=\"variance-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"VARIANCEREPORT.CATNAME\">Category Name:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"catID\" ng-model=\"vm.varianceDets.catID\"><md-option ng-value=\"\" \ntranslate=\"VARIANCEREPORT.SELECT_ALL\">All</md-option><md-option ng-repeat=\"op in vm.categoryList\" \nng-value=\"op.category_id\" ng-selected=\"vm.varianceDets.catID==op.category_id\">{{op.category_name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><label class=\"inpt-lbl\" translate=\"VARIANCEREPORT.ITEM_NAME\">Item Name:</label><md-input-container \nflex style=\"margin-top:-5px\"><md-select name=\"itmID\" ng-model=\"vm.varianceDets.itmID\"><md-option ng-value=\"\" \ntranslate=\"VARIANCEREPORT.SELECT_ALL\">All</md-option><md-option \nng-repeat=\"op in vm.itemList | filter:{catitm_category_id:vm.varianceDets.catID}:true\" ng-value=\"op.item_id\" \nng-selected=\"vm.varianceDets.itmID==op.item_id\">{{op.item_name}}</md-option></md-select></md-input-container></div>\n</div></div><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"40\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><label class=\"inpt-lbl\" translate=\"VARIANCEREPORT.DATE\">Date:\n</label><md-input-container flex style=\"margin-top:-5px\"><md-select name=\"type\" ng-model=\"vm.varianceDets.type\" \nng-change=\"vm.changeDate()\"><md-option ng-repeat=\"op in vm.dateList\" ng-value=\"op\" \nng-selected=\"vm.varianceDets.type==op\">{{op}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"VARIANCEREPORT.FROM\">From:</label><md-datepicker name=\"from\" md-placeholder=\"Enter date\" \nng-model=\"vm.varianceDets.from\" flex></md-datepicker></div></div></div><div layout=\"column\" flex=\"30\" \nclass=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" \ntranslate=\"VARIANCEREPORT.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.varianceDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"row\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.listReport()\"><i \nclass=\"icon icon-format-list-bulleted\"></i> <span translate=\"VARIANCEREPORT.LISTBILL_BTN\">List Bills</span></md-button>\n</div></form></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"variance-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 8%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"VARIANCEREPORT.TABLE_SNO\">S.No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"VARIANCEREPORT.TABLE_DATE\">Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"VARIANCEREPORT.TABLE_ITEMNAME\">Item Name</span></div></th><th class=\"secondary-text text-right\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"VARIANCEREPORT.TABLE_QTY\">Qty</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"VARIANCEREPORT.TABLE_REMARK\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.varianceReport\" ng-if=\"vm.varianceReport.length>0\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"center\">{{itm.variance_date2}}</td><td align=\"center\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=null && itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td \nalign=\"center\">{{itm.variance_qty | number: vm.c_d}} {{itm.unit_name}}</td><td align=\"left\">{{itm.variance_remarks}}\n</td></tr></tbody><tr ng-if=\"vm.varianceReport.length>0\" class=\"btm-row\"><td align=\"center\" colspan=\"3\"></td><td \nstyle=\"text-align:center; background:#00a931\">{{vm.totalStock | number: vm.c_d}}</td><td align=\"center\"></td></tr>\n</table></div></div></div></div></div>");
$templateCache.put("app/main/apps/waiter/waiter.html","<div id=\"waiter\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoAddWaiter()\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span translate=\"WAITER.NEW_WAITER\">New Waiter</span></md-button></div>\n</div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"waiter-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WAITER.TABLE_SNO\">S.No</span>\n</div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WAITER.TABLE_WAITERNAME\">Waiter Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"WAITER.TABLE_MOBILENO\">Mobile No</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"WAITER.TABLE_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WAITER.TABLE_STATUS\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WAITER.TABLE_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.waiter.waiterList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.waiter_name}}</b></td><td align=\"center\">{{cat.waiter_mobileno}}</td><td align=\"center\">{{cat.waiter_type}}</td>\n<td align=\"center\">{{cat.waiter_status}}</td><td align=\"center\"><md-button \nclass=\"actn-btn md-fab md-mini md-orange-400-bg\" style=\"padding:0px 0px 2px 0px\" \nng-click=\"vm.setTables(cat.waiter_id)\"><md-tooltip md-direction=\"down\"><span translate=\"WAITER.TABLE_SETTABLE\">\nSet Tables</span></md-tooltip><i class=\"icon icon-table-large\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini\" ng-click=\"vm.editWaiter(cat.waiter_id)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"WAITER.TABLE_EDIT\">Edit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteWaiter(cat.waiter_id)\"><md-tooltip \nmd-direction=\"down\"><span translate=\"WAITER.TABLE_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/waiter-sales-report/waiter-sales-report.html","<div id=\"waiter-sales-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"40\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"WAITERSALEREPORT.DATE\">Date:</label><md-input-container flex \nstyle=\"margin-top:-5px\"><md-select name=\"type\" ng-model=\"vm.waiterSalesDets.type\" ng-change=\"vm.changeDate()\">\n<md-option ng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.waiterSalesDets.type==op\">{{op}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" \nflex class=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"WAITERSALEREPORT.FROM\">From:</label>\n<md-datepicker name=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.waiterSalesDets.from\" flex></md-datepicker></div>\n</div></div><div layout=\"column\" flex=\"30\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\">\n<label class=\"inpt-lbl\" translate=\"WAITERSALEREPORT.TO\">To:</label><md-datepicker name=\"to\" \nmd-placeholder=\"Enter date\" ng-model=\"vm.waiterSalesDets.to\" flex></md-datepicker></div></div></div></div><div \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" \nng-click=\"vm.listReport()\"><i class=\"icon icon-format-list-bulleted\"></i> <span \ntranslate=\"WAITERSALEREPORT.LISTBILL_BTN\">List Bills</span></md-button></div></form></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div \nclass=\"opening-stock-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text text-center\" \nstyle=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WAITERSALEREPORT.TABLE_SNO\">S.No\n</span></div></th><th class=\"secondary-text text-center\" style=\"width: 70%\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WAITERSALEREPORT.TABLE_WAITERNAME\">Waiter Name</span></div></th><th \nclass=\"secondary-text text-center\" style=\"width: 15%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WAITERSALEREPORT.TABLE_TOTALBILL\">Total Bills</span></div></th></tr></thead><tbody \nng-repeat=\"itm in vm.waiterSalesReport\" ng-if=\"vm.waiterSalesReport.length>0\"><tr><td class=\"text-center\">{{$index+1}}\n</td><td style=\"text-align: left\">{{itm.waiter_name}}</td><td class=\"text-center\">{{itm.bilCount}}</td></tr><tr><td>\n</td><td><table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text text-center\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WAITERSALEREPORT.TABLE_TENDERNAME\">Tender Name</span></div></th><th class=\"secondary-text text-center\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"WAITERSALEREPORT.TABLE_TOTALAMOUNT\">Total Amount\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"amt in itm.modeList\" ng-if=\"itm.modeList.length>0\"><td \nstyle=\"text-align: left\">{{amt.bill_type}}</td><td style=\"text-align: right\">{{amt.bilAmt | number: vm.c_d}}</td></tr>\n</tbody></table></td><td></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/warehouse/warehouse.html","<div id=\"warehouse\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n</div><div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised md-background\" \nng-click=\"vm.gotoAddWarehouse()\"><md-icon md-font-icon=\"icon-account\"></md-icon><span \ntranslate=\"WAREHOUSE.NEW_WAREHOUSE\">New Warehouse</span></md-button></div></div><div class=\"list-content scrollable\" \nms-scroll><div class=\"warehouse-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WAREHOUSE.TBL_SNO\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div class=\"table-header\">\n<span class=\"column-title\" translate=\"WAREHOUSE.TBL_WRHOUSENAME\">Warehouse Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WAREHOUSE.TBL_BRANCHNAME\">\nBranch Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WAREHOUSE.TBL_STATUS\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WAREHOUSE.TBL_ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.warehouse.warehouseList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" show-gt-sm><b>\n{{cat.warehouse_name}}</b></td><td align=\"center\">{{cat.branch_name}}</td><td align=\"center\">{{cat.warehouse_status}}\n</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" ng-click=\"vm.editWarehouse(cat.warehouse_id)\">\n<md-tooltip md-direction=\"down\"><span translate=\"WAREHOUSE.TBL_ACTION_EDIT\">Edit</span></md-tooltip><i \nclass=\"icon icon-table-edit\"></i></md-button><md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" \nng-click=\"vm.deleteWarehouse(cat.warehouse_id)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"WAREHOUSE.TBL_ACTION_DELETE\">Delete</span></md-tooltip><i class=\"icon icon-delete\"></i></md-button></td>\n</tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/wastage/wastage.html","<div id=\"wastage\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"wastageForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2>Expired Batch List</h2></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"search-bx\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" flex></div><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-click=\"vm.saveWastage()\">Save as Wastage</md-button></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-5\"><table class=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th \nclass=\"text-center\"><md-checkbox md-no-ink ng-model=\"vm.mainChk\" ng-checked=\"(vm.mainChk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\" class=\"md-accent\" ng-click=\"vm.selectAll()\"></md-checkbox></th><th class=\"text-center\" \nstyle=\"max-width:250px; min-width:250px\">Item Name</th><th class=\"text-center\" style=\"max-width:80px;min-width:80px\">\nInward Qty</th><th class=\"text-center\" style=\"max-width:80px;min-width:80px\">Curr. Qty</th><th class=\"text-center\" \nstyle=\"max-width:80px;min-width:80px\">Wastage Qty</th><th class=\"text-center\" style=\"max-width:80px;min-width:80px\">\nProd. Date</th><th class=\"text-center\" style=\"max-width:80px;min-width:80px\">Expiry Date</th></tr></thead><tbody><tr \nng-if=\"vm.batchList.length>0\" ng-repeat=\"itm in vm.batchList | filter:vm.search\"><td class=\"text-center\"><md-checkbox \nmd-no-ink ng-model=\"itm.selectedchk\" ng-checked=\"(itm.selectedchk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nclass=\"md-accent\"></md-checkbox></td><td class=\"text-left\"><h6>{{itm.item_name}}</h6></td><td class=\"text-center\">\n{{itm.inventory_qty | number: vm.c_d }} {{itm.unit_name}}</td><td class=\"text-center\">\n{{itm.inventory_currqty | number: vm.c_d}} {{itm.unit_name}}</td><td class=\"text-center\"><input type=\"text\" \nname=\"wastageQty\" ng-model=\"itm.wastageQty\" style=\"width: 120px\" ng-disabled=\"itm.selectedchk==0\"></td><td \nclass=\"text-center\">{{itm.inventory_prod_date}}</td><td class=\"text-center\">{{itm.inventory_expiry_date2}}</td></tr><tr\n ng-if=\"vm.batchList.length==0\"><td colspan=\"7\" class=\"text-center\">No Records</td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/work-period/work-period.html","<div id=\"homedel\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><div class=\"workperiod1\" \nng-if=\"vm.listCell==1\"><div layout=\"column\" layout-align=\"start\" class=\"left-cnt\"><h5 \ntranslate=\"WORKPERIOD.WORK_PERIOD_DETAILS\">Work Period Details</h5></div><div layout=\"column\" layout-align=\"start\" \nclass=\"left-cnt\"><p ng-repeat=\"period in vm.periodList.workperiodList\"><span>{{period.workperiod_start_date}}</span> - \n<span>{{period.workperiod_end_date}}</span></p></div></div><div class=\"workperiod3\" ng-if=\"vm.startCell==1\"><div \nlayout=\"column\" layout-align=\"start\" class=\"left-cnt\"><h5 translate=\"WORKPERIOD.WORK_PERIOD_DETAILS\">\nWork Period Details</h5></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" class=\"left-cnt\">\n<md-input-container flex><label translate=\"WORKPERIOD.OPENPCASH\">Opening Petty Cash</label><input type=\"text\" \nname=\"workperiod_start_amount\" ng-model=\"vm.startperiod.workperiod_start_amount\"></md-input-container>\n<md-input-container flex><label translate=\"WORKPERIOD.DESCRIPTION\">Description</label><input type=\"text\" \nname=\"workperiod_start_description\" ng-model=\"vm.startperiod.workperiod_start_description\"></md-input-container></div>\n<div layout=\"row\" layout-align=\"start\" class=\"left-cnt\"><md-button translate=\"WORKPERIOD.START_WORKPERIOD\" \nclass=\"new-btn md-raised md-background md-grey-300-bg\" layout=\"row\" layout-align=\"center\" ng-click=\"vm.saveStart()\">\nStart Work Period</md-button><md-button translate=\"WORKPERIOD.CANCEL\" \nclass=\"new-btn md-raised md-background md-grey-300-bg\" layout=\"row\" layout-align=\"center\" ng-click=\"vm.cancelPeriod()\">\nCancel</md-button></div></div><div class=\"workperiod3\" ng-if=\"vm.endCell==1\"><div layout=\"column\" layout-align=\"start\" \nclass=\"left-cnt\"><h5 translate=\"WORKPERIOD.WORK_PERIOD_DETAILS\">Work Period Details</h5></div><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" class=\"left-cnt\"><md-input-container flex><label \ntranslate=\"WORKPERIOD.CLOSEPCASH\">Closing Petty Cash</label><input type=\"text\" name=\"workperiod_end_amount\" \nng-model=\"vm.endperiod.workperiod_end_amount\"></md-input-container><md-input-container flex><label \ntranslate=\"WORKPERIOD.DESCRIPTION\">Description</label><input type=\"text\" name=\"workperiod_end_description\" \nng-model=\"vm.endperiod.workperiod_end_description\"></md-input-container></div><div layout=\"row\" layout-align=\"start\" \nclass=\"left-cnt\"><md-button translate=\"WORKPERIOD.END_WORKPERIOD\" \nclass=\"new-btn md-raised md-background md-grey-300-bg\" layout=\"row\" layout-align=\"center\" ng-click=\"vm.saveEnd()\" \nng-disabled=\"vm.endSave==1\">End Work Period</md-button><md-button translate=\"WORKPERIOD.CANCEL\" \nclass=\"new-btn md-raised md-background md-grey-300-bg\" layout=\"row\" layout-align=\"center\" ng-click=\"vm.cancelPeriod()\" \nng-disabled=\"vm.endSave==1\">Cancel</md-button></div></div><div class=\"workperiod2\"><div ng-if=\"vm.periodID!=\'\'\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"side-cnt\"><p translate=\"WORKPERIOD.DT_WRKPRDSTART\">\nDate of Work Period Start:</p><span class=\"pl-5\">{{vm.periodList.periodDets.workperiod_date}}</span></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"side-cnt\"><p translate=\"WORKPERIOD.TM_WRKPRDSTART\">\nTime of Work Period Start:</p><span class=\"pl-5\">{{vm.periodList.periodDets.workperiod_time}}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"side-cnt\"><md-button translate=\"WORKPERIOD.START_WORKPERIOD\" \nclass=\"new-btn md-raised md-background md-grey-300-bg\" layout=\"row\" layout-align=\"center\" ng-click=\"vm.startPeriod()\" \nng-disabled=\"vm.periodStatus==1\">Start Work Period</md-button></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"side-cnt\"><md-button translate=\"WORKPERIOD.END_WORKPERIOD\" \nclass=\"new-btn md-raised md-background md-grey-300-bg\" layout=\"row\" layout-align=\"center\" ng-click=\"vm.endPeriod()\" \nng-disabled=\"vm.periodStatus==0 || vm.periodList.pendingBills > 0\">End Work Period</md-button></div><div \nlayout=\"column\" layout-align=\"start left\" class=\"side-cnt\" ng-if=\"vm.periodList.pendingBills > 0\"><label><span \ntranslate=\"WORKPERIOD.ALERTONE\">There are</span> {{vm.periodList.pendingBills}} <span translate=\"WORKPERIOD.ALERTTWO\">\nBills/Tickets Opened.</span></label><label translate=\"WORKPERIOD.ALERTTHREE\">\nUnable to end period until Bills/Tickets Opened.</label></div></div></div></div>");
$templateCache.put("app/main/apps/warehousemenu/warehousemenu.html","<div class=\"warehousemenu\"><ms-nav><ms-nav-item ms-nav-toggle ng-if=\"vm.warmasterageBlock==0\"><a ms-nav-button \nmd-ink-ripple ui-sref=\"app.warehouse\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Warehouse</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.purBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.purchase\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">Purchase Ingredients</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.ivarianceBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.ingredients-stock-update\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">\nIngredients Physical Stock Update</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.transinBlock==0\"><a \nms-nav-button md-ink-ripple ui-sref=\"app.transferin\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">Transfer In</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.transoutBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.transfer\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Transfer Out</span></a></ms-nav-item><ms-nav-item\n ms-nav-toggle ng-if=\"vm.stkrptBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.stock-report\" \nui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Stock Report</span>\n</a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.inventoryBlock==0\"><a ms-nav-button md-ink-ripple \nui-sref=\"app.inventory\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\"></i> <span \nclass=\"ms-nav-label\">Opening Stock Entry</span></a></ms-nav-item><ms-nav-item ms-nav-toggle ng-if=\"vm.wasteBlock==0\"><a\n ms-nav-button md-ink-ripple ui-sref=\"app.wastage\" ui-sref-active=\"active\"><i class=\"icon-chevron-double-right s16\">\n</i> <span class=\"ms-nav-label\">Wastage Entry</span></a></ms-nav-item><ms-nav-item ms-nav-toggle \nng-if=\"vm.varianceBlock==0\"><a ms-nav-button md-ink-ripple ui-sref=\"app.variance\" ui-sref-active=\"active\"><i \nclass=\"icon-chevron-double-right s16\"></i> <span class=\"ms-nav-label\">Physical Stock Update</span></a></ms-nav-item>\n</ms-nav></div>");
$templateCache.put("app/main/apps/work-report/work-report.html","<div id=\"work-report\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/reportmenu/accordion.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"ticketForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"start left\"><h2 style=\"margin:0px 0px 30px 0px\"><span translate=\"WORK_PERIOD.PGTLT_WRKPRD\">\nWork Period Reports</span> <span ng-if=\"vm.periodIDs!=\'\'\"><span translate=\"WORK_PERIOD.PGTLT_BETWEN\">Between</span>\n {{vm.workreportList.workPeriodLabel}}</span></h2></div><div layout=\"row\" layout-gt-xs=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" flex=\"50\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\">\n<label class=\"inpt-lbl\" translate=\"WORK_PERIOD.DATE\">Date :</label><md-input-container flex style=\"margin-top:-5px\">\n<md-select name=\"type\" ng-model=\"vm.salesDets.type\" ng-change=\"vm.changeDate()\"><md-option \nng-repeat=\"op in vm.dateList\" ng-value=\"op\" ng-selected=\"vm.salesDets.type==op\">{{op}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" flex=\"25\" class=\"admin-frm-inr\"><div layout=\"row\" flex \nclass=\"flex\"><div layout=\"row\"><label class=\"inpt-lbl\" translate=\"WORK_PERIOD.FROM\">From:</label><md-datepicker \nname=\"from\" md-placeholder=\"Enter date\" ng-model=\"vm.salesDets.from\" flex></md-datepicker></div></div></div><div \nlayout=\"column\" flex=\"25\" class=\"admin-frm-inr\"><div layout=\"row\" flex class=\"flex\"><div layout=\"row\"><label \nclass=\"inpt-lbl\" translate=\"WORK_PERIOD.TO\">To:</label><md-datepicker name=\"to\" md-placeholder=\"Enter date\" \nng-model=\"vm.salesDets.to\" flex></md-datepicker></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"center center\" style=\"margin-top:30px\"><div layout=\"row\"><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn\" aria-label=\"Submit\" ng-click=\"vm.workReportDets()\"><i \nclass=\"icon icon-format-list-bulleted\"></i><span translate=\"WORK_PERIOD.LIST_BILL\">List Bills</span></md-button></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between\" style=\"margin-top:30px\"><div layout=\"row\">\n<md-button type=\"submit\" class=\"md-raised md-accent tp-btn\" ng-disabled=\"vm.periodIDs==\'\'\" aria-label=\"Submit\" \nng-click=\"vm.printReport()\"><i class=\"icon icon-printer\"></i> <span translate=\"WORK_PERIOD.PRINT_BILL\">Print All</span>\n</md-button></div><div layout=\"row\"><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" ng-disabled=\"vm.periodIDs==\'\'\" aria-label=\"Submit\" \nng-click=\"vm.wprPDFExport()\"><i class=\"icon icon-box-download\"></i><span translate=\"WORK_PERIOD.DWNLD_PDF\">\nDownload as PDF</span></md-button></div><div layout=\"row\"><md-button type=\"submit\" \nclass=\"md-raised md-accent tp-btn md-teal-500-bg grey-50-fg\" ng-disabled=\"vm.periodIDs==\'\'\" aria-label=\"Submit\" \nng-click=\"vm.wprCSVExport()\"><i class=\"icon icon-box-download\"></i><span translate=\"WORK_PERIOD.DWNLD_CSV\">\nDownload as CSV</span></md-button></div></div></form></div></div><div layout=\"row\" ng-if=\"vm.periodIDs!=\'\'\"><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_SALE\">\nSales</span></div></th></tr></thead><tbody><tr ng-if=\"vm.workreportList.workReportSales.sm_gross > 0\"><td \nalign=\"center\" translate=\"WORK_PERIOD.BXCNCT_SALETOTAL\">Sales Total</td><td style=\"text-align:right\">\n{{vm.workreportList.workReportSales.sm_gross | number: vm.c_d}}</td></tr><tr \nng-if=\"vm.workreportList.workReportSales.sm_extra > 0\"><td align=\"center\" translate=\"WORK_PERIOD.BXCNCT_EXTRATOTAL\">\nExtra Charges Total</td><td style=\"text-align:right\">+{{vm.workreportList.workReportSales.sm_extra | number: vm.c_d}}\n</td></tr><tr ng-if=\"vm.workreportList.workReportSales.sm_tax > 0\"><td align=\"center\" \ntranslate=\"WORK_PERIOD.BXCNCT_TAXTOTAL\">Tax Total</td><td style=\"text-align:right\">\n+{{vm.workreportList.workReportSales.sm_tax | number: vm.c_d}}</td></tr><tr \nng-if=\"vm.workreportList.workReportSales.sm_discountTotal > 0\"><td align=\"center\" \ntranslate=\"WORK_PERIOD.BXCNCT_DISCOUNTTOTAL\">Disount Total</td><td style=\"text-align:right\">\n-{{vm.workreportList.workReportSales.sm_discountTotal | number: vm.c_d}}</td></tr><tr \nng-if=\"vm.workreportList.workReportSales.sm_nett > 0\"><td align=\"center\" translate=\"WORK_PERIOD.BXCNCT_NETTOTAL\">\nNett Total</td><td style=\"text-align:right\">{{vm.workreportList.workReportSales.sm_nett | number: vm.c_d}}</td></tr>\n</tbody></table></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" class=\"secondary-text tp-hdr\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_CASHFLOW\">Cash Flow</span></div></th></tr>\n</thead><tbody><tr ng-if=\"vm.workreportList.workReportSalesNett > 0\"><td align=\"center\" \ntranslate=\"WORK_PERIOD.BXCNCT_TOTALSALE\">Total Sales</td><td style=\"text-align:right\">\n{{vm.workreportList.workReportSalesNett | number: vm.c_d}}</td></tr><tr \nng-if=\"vm.workreportList.workReportTotalIncomes > 0\"><td align=\"center\" translate=\"WORK_PERIOD.BXCNCT_TOTALINCOME\">\nTotal Income</td><td style=\"text-align:right\">+{{vm.workreportList.workReportTotalIncomes | number: vm.c_d}}</td></tr>\n<tr ng-if=\"vm.workreportList.workReportTotalExpenses > 0\"><td align=\"center\" \ntranslate=\"WORK_PERIOD.BXCNCT_TOTALEXPENSE\">Total Expenses</td><td style=\"text-align:right\">\n-{{vm.workreportList.workReportTotalExpenses | number: vm.c_d}}</td></tr><tr \nng-if=\"vm.workreportList.workReportTotalCash > 0\"><td align=\"center\" translate=\"WORK_PERIOD.BXCNCT_NETTOTAL\">Nett Total\n</td><td style=\"text-align:right\">{{vm.workreportList.workReportTotalCash | number: vm.c_d}}</td></tr></tbody></table>\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" class=\"secondary-text tp-hdr\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_INCOME\">Income</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"income in vm.workreportList.workReportIncome\" ng-if=\"income.bill_amount > 0\"><td \nalign=\"center\">{{income.bill_type}}</td><td style=\"text-align:right\">{{income.bill_amount | number: vm.c_d}}</td></tr>\n</tbody></table></div></div></div><div layout=\"row\" ng-if=\"vm.periodIDs!=\'\'\"><div class=\"list-content scrollable\" \nms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_DEPARTMENTSALES\">Department Sales</span></div></th></tr></thead><tbody><tr \nng-repeat=\"dept in vm.workreportList.workReportDeptSales\" ng-if=\"dept.sm_nett > 0\"><td align=\"center\">{{dept.bil_type}}\n</td><td style=\"text-align:right\">{{dept.sm_nett | number: vm.c_d}}</td></tr></tbody></table></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_OTHERINCOME\">Other Income</span></div></th></tr></thead><tbody><tr \nng-repeat=\"income in vm.workreportList.workReportIncomes\" ng-if=\"income.amount > 0\"><td align=\"center\">\n{{income.achead_name}}</td><td style=\"text-align:right\">{{income.amount | number: vm.c_d}}</td></tr></tbody></table>\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" class=\"secondary-text tp-hdr\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_OTHEREXPENSE\">Other Expenses</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"exp in vm.workreportList.workReportExpenses\" ng-if=\"exp.amount > 0\"><td \nalign=\"center\">{{exp.achead_name}}</td><td style=\"text-align:right\">{{exp.amount | number: vm.c_d}}</td></tr></tbody>\n</table></div></div></div><div layout=\"row\" ng-if=\"vm.periodIDs!=\'\'\"><div class=\"list-content scrollable\" ms-scroll>\n<div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" class=\"secondary-text tp-hdr\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_ORDERKOT\">Orders/KOTs</span></div></th>\n</tr></thead><tbody><tr><td align=\"center\" translate=\"WORK_PERIOD.BXTLT_ORDERCONT\">Order Count</td><td \nstyle=\"text-align:right\">{{vm.workreportList.workReportOrdersCount}}</td></tr><tr \nng-repeat=\"order in vm.workreportList.workReportOrders\" ng-if=\"order.orderAmt > 0\"><td align=\"center\">\n{{order.kot_status}}</td><td style=\"text-align:right\">{{order.orderAmt | number: vm.c_d}}</td></tr></tbody></table>\n</div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"3\" class=\"secondary-text tp-hdr\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_BILLSTATUS\">Tickets/Bills Status</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"order in vm.workreportList.workReportStatuBills\" \nng-if=\"order.billAmt > 0\"><td align=\"center\">{{order.bil_status}}</td><td align=\"center\">{{order.billCnt}}</td><td \nstyle=\"text-align:right\">{{order.billAmt | number: vm.c_d}}</td></tr></tbody></table></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_BILLPAYMENT\">Tickets/Bills Payments</span></div></th></tr></thead><tbody><tr><td \nalign=\"center\" translate=\"WORK_PERIOD.BXTLT_ORDERCONT\">Order Count</td><td style=\"text-align:right\">\n{{vm.workreportList.workReportBillsCount}}</td></tr><tr ng-repeat=\"order in vm.workreportList.workReportBills\" \nng-if=\"order.billAmt > 0\"><td align=\"center\">{{order.bil_paystatus}}</td><td style=\"text-align:right\">\n{{order.billAmt | number: vm.c_d}}</td></tr></tbody></table></div></div></div><div layout=\"row\" \nng-if=\"vm.periodIDs!=\'\'\" style=\"width:100%\"><div layout=\"column\" style=\"width:45%\"><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"4\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_EXCHARGE_SUMMARY\">Extra Charges Summary</span></div></th></tr></thead><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_EXTRA_NAME\">Extra Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_NETAMOUNT\">Nett Amount</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workReportExtraBills\"><td align=\"left\">\n{{itm.extra_name}}</td><td style=\"text-align:right\">{{itm.smTotal | number: vm.c_d}}</td></tr></tbody><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORK_PERIOD.BXTLT_TOTALEXTRA\">Total Extras</span></div></th><th \nclass=\"secondary-text text-right\"><div class=\"table-header\"><span class=\"column-title\">\n{{vm.extraTotal | number: vm.c_d}}</span></div></th></tr></thead></table></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"5\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_NACBILL\">NAC Tickets/Bills</span></div></th></tr></thead><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 20px;min-width:20px;padding-left:10px\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_BILLNO\">Bill No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_BILLDATE\">Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_BILLTYPE\">Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_NETAMOUNT\">Nett Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_REASON\">\nReason</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workReportNACBills\"><td \nalign=\"center\">{{itm.bil_no}}</td><td align=\"center\">{{itm.bil_date}}</td><td align=\"center\">{{itm.bil_type}}</td><td \nstyle=\"text-align:right\">{{itm.bil_totalnetamt | number: vm.c_d}}</td><td align=\"left\">{{itm.bil_remarks}}</td></tr>\n</tbody></table></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"4\" class=\"secondary-text tp-hdr\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_CANCELBILL\">Cancelled Tickets/Bills\n</span></div></th></tr></thead><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" \nstyle=\"width: 20px;min-width:20px;padding-left:10px\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_BILLNO\">Bill No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_BILLDATE\">Date</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTLT_BILLTYPE\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_NETAMOUNT\">\nNett Amount</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workReportCancelBills\"><td \nalign=\"center\">{{itm.bil_no}}</td><td align=\"center\">{{itm.bil_date}}</td><td align=\"center\">{{itm.bil_type}}</td><td \nstyle=\"text-align:right\">{{itm.bil_totalnetamt | number: vm.c_d}}</td></tr></tbody></table></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"2\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_BILLCATLIST\">Bill Category List</span></div></th></tr></thead><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width: 70%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_CATEGORYNAME\">Category Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_AMOUNT\">Amount</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.workreportList.workReportBillCats\"><td style=\"text-align:left\">{{itm.category_name}}</td><td \nstyle=\"text-align:right\">{{itm.kotitem_totat | number: vm.c_d}}</td></tr></tbody></table></div></div><div \nclass=\"list-content scrollable\" ms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\">\n<table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"5\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_VOIDITEM\">Void Items</span></div></th></tr><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_PRODUCT\">\nProduct</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_QUANTITY\">Qty</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_AMOUNT\">Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_BY\">By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_REASON\">\nReason</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workReportBillVoidItems\" \nng-if=\"!itm.kotitem_itm_id==\'\'\"><td style=\"text-align:left\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td align=\"center\">{{itm.kotitem_qty}}</td>\n<td style=\"text-align:right\">{{itm.kotitem_totat | number: vm.c_d}}</td><td align=\"center\">{{itm.usr_name}}</td><td \nalign=\"left\">{{itm.kotitem_message}}</td></tr></tbody></table></div></div><div class=\"list-content scrollable\" \nms-scroll><div class=\"work-report-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"5\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_GIFTITEM\">Gifted Items</span></div></th></tr><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_PRODUCT\">\nProduct</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_QUANTITY\">Qty</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_AMOUNT\">Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_BY\">By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_REASON\">\nReason</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workReportBillGiftItems\" \nng-if=\"!itm.kotitem_itm_id==\'\'\"><td style=\"text-align:left\">{{itm.item_name}} <span \nng-if=\"itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}</span></td><td align=\"center\">{{itm.kotitem_qty}}</td>\n<td style=\"text-align:right\">{{itm.kotitem_totat | number: vm.c_d}}</td><td align=\"center\">{{itm.usr_name}}</td><td \nalign=\"left\">{{itm.kotitem_message}}</td></tr></tbody></table></div></div></div><div layout=\"column\" style=\"width:55%\">\n<div class=\"list-content\"><div class=\"work-report-table-wrapper billed-table md-background-bg md-whiteframe-1dp\" \nms-scroll><table class=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th \ncolspan=\"2\" class=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_BILLEDITEM\">Billed Items</span></div></th><th class=\"secondary-text tp-hdr\"><div \nclass=\"text-right\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-click=\"vm.salesItmsPDFExport()\"><span translate=\"WORK_PERIOD.DOWNLOAD_BTN\">Download</span></md-button></div></th>\n</tr><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"min-width:230px\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_PRODUCT\">Product</span></div></th><th class=\"secondary-text\" \nstyle=\"width:20px;min-width:20px\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_QUANTITY\">Qty</span></div></th><th class=\"secondary-text\" style=\"min-width: 70px\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_AMOUNT\">Amount</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workReportBillItems\" ng-if=\"!itm.bitm_itmid==\'\'\"><td \nstyle=\"text-align:left\"><b>{{itm.item_name}} <span ng-if=\"itm.itm_option_name!=\'Normal\'\">- {{itm.itm_option_name}}\n</span></b></td><td align=\"center\">{{itm.bitm_qty}}</td><td style=\"text-align:right\">\n{{itm.bitm_total | number: vm.c_d}}</td></tr></tbody></table></div></div><div class=\"list-content\"><div \nclass=\"work-report-table-wrapper billed-table md-background-bg md-whiteframe-1dp\" ms-scroll><table class=\"simple\" \nms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg title\"><th colspan=\"3\" \nclass=\"secondary-text tp-hdr\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTLT_KITCHENNOTELIST\">Kitchen Note List</span></div></th></tr><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\" style=\"min-width:230px\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_NOTE\">Note</span></div></th><th class=\"secondary-text\" \nstyle=\"width:20px;min-width:20px\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_PERIOD.BXTCNCT_COUNT\">Count</span></div></th><th class=\"secondary-text\" style=\"min-width: 70px\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_PERIOD.BXTCNCT_AMOUNT\">Amount</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"itm in vm.workreportList.workOrderTags\" ng-if=\"!itm.kotitemtag_ordertag_name==\'\'\"><td \nstyle=\"text-align:left\"><b>{{itm.kotitemtag_ordertag_name}}</b></td><td align=\"center\">{{itm.orderCount}}</td><td \nstyle=\"text-align:right\">{{itm.orderAmt | number: vm.c_d}}</td></tr></tbody></table></div></div></div></div><div \nlayout=\"row\"></div></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\" style=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button\n id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><img md-menu-align-target class=\"ml-20 mr-10\" \nsrc=\"assets/img/icon.png\"> <span class=\"ml-1 mr-10\" style=\"font-size:22px; color:#00A931; font-weight:600\" \nng-bind=\"pageTitle+\'\'\"></span></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent mr-10 pr-10\" md-diameter=\"32\">\n</md-progress-circular><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"dept in vm.departmentList\" \nng-if=\"vm.role!=\'Super Admin\'\"><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"language-button\" ng-click=\"vm.setDepartment(dept)\" aria-label=\"{{dept.department_name}}\" \nng-if=\"vm.deptID!=dept.department_id\" ng-disabled=\"vm.kotExist==1\"><h3>{{dept.department_name}}</h3>|</md-button><div \nclass=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"language-button tool-active\" \nng-click=\"vm.setDepartment(dept)\" aria-label=\"{{dept.department_name}}\" ng-if=\"vm.deptID==dept.department_id\"><h3>\n{{dept.department_name}}</h3>|</md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.role==\'Super Admin\'\"><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"language-button\" ui-sref=\"app.dashboard\" aria-label=\"Logout\"><h3>Home</h3></md-button><div \nclass=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"language-button\" ng-click=\"vm.logout()\" \naria-label=\"Logout\"><h3>Logout</h3></md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.role!=\'Super Admin\'\"><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"language-button tool-active\" ng-click=\"vm.gotoHome()\" aria-label=\"Main Menu\" ng-if=\"vm.main==1\"><h3>Main Menu\n</h3></md-button><md-button id=\"quick-panel-toggle\" class=\"language-button\" ng-click=\"vm.gotoHome()\" \naria-label=\"Main Menu\" ng-if=\"vm.main==0\"><h3>Main Menu</h3></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.role==\'Admin\'\"><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\">\n<md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-cog\" class=\"icon s16\" \nhide-xs></md-icon></div><span class=\"username\" hide show-gt-sm>Manage</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.department\"><span class=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Departments</b></span>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.price-tag\"><span class=\"username text-bold font-size-14\" \nstyle=\"cursor:pointer\"><b>Price Tags</b></span></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.customer\">\n<span class=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Customers</b></span></md-menu-item>\n<md-menu-item class=\"md-indent\" ui-sref=\"app.waiter\"><span class=\"username text-bold font-size-14\" \nstyle=\"cursor:pointer\"><b>Waiters</b></span></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.scategory\">\n<span class=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Tables Categories</b></span></md-menu-item>\n<md-menu-item class=\"md-indent\" ui-sref=\"app.seats\"><span class=\"username text-bold font-size-14\" \nstyle=\"cursor:pointer\"><b>Tables/Seats</b></span></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.category\">\n<span class=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Categories</b></span></md-menu-item>\n<md-menu-item class=\"md-indent\" ui-sref=\"app.item\"><span class=\"username text-bold font-size-14\" \nstyle=\"cursor:pointer\"><b>Items</b></span></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.pricing\"><span \nclass=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Pricings</b></span></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.order-tag\"><span class=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>\nOrder Tags</b></span></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.printers\"><span \nclass=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Printers</b></span></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.printerjobs\"><span class=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>\nPrinter Jobs</b></span></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.settings\"><span \nclass=\"username text-bold font-size-14\" style=\"cursor:pointer\"><b>Settings</b></span></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"{{vm.SelectStudentImg}}\"></div><span \nclass=\"username\" hide show-gt-sm>{{vm.CustomerName}}</span></div></md-button></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/main/apps/printerjobs/printerjobs.html","<div id=\"printerjobs\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"column\" layout-align=\"start center\"><md-button class=\"new-btn md-raised\" \nng-click=\"vm.gotoAddPrinterjobs()\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>New Printerjobs</span>\n</md-button></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"printerjobs-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"dataTables row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">S.No</span></div></th><th \nclass=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Printer Name</span></div></th>\n<th class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"cat in vm.ordeTag.printerjobsList\"><td align=\"center\">{{$index+1}}</td><td align=\"left\" \nshow-gt-sm><b>{{cat.printerjobs_name}}</b></td><td align=\"center\">{{cat.printerjobs_type}}</td><td align=\"center\">\n<md-button class=\"actn-btn md-fab md-mini\" ng-click=\"vm.editPrinterjobs(cat.printerjobs_id)\"><md-tooltip \nmd-direction=\"down\">Edit</md-tooltip><i class=\"icon icon-table-edit\"></i></md-button><md-button \nclass=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deletePrinterjobs(cat.printerjobs_id)\"><md-tooltip \nmd-direction=\"down\">Delete</md-tooltip><i class=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/apps/ordertagoption/ordertagoption.html","<div id=\"ordertagoption\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"header row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div>\n<div layout=\"row\" layout-align=\"start start\"><md-button class=\"new-btn md-raised\" ng-click=\"vm.gotoOrderTag()\"><span \ntranslate=\"ORDERTAG_OPTION.BACKBTN\">Back</span></md-button><md-button class=\"new-btn md-raised\" \nng-click=\"vm.gotoAddOrdertagoptions(vm.orderTagID)\"><md-icon md-font-icon=\"icon-account\"></md-icon><span \ntranslate=\"ORDERTAG_OPTION.NEWOPTION\">New Option</span></md-button></div></div><div class=\"list-content scrollable\" \nms-scroll><div class=\"ordertagoption-table-wrapper md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTables row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"md-accent-bg\"><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORDERTAG_OPTION.TABLE_SNO\">S.No</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORDERTAG_OPTION.TABLE_OPTNNAME\">Option Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORDERTAG_OPTION.TABLE_RATE\">Rate</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\" translate=\"ORDERTAG_OPTION.TABLE_STATUS\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORDERTAG_OPTION.TABLE_ACTION\">Action</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"cat in vm.ordertagoption.ordertagoptionList\"><td align=\"center\">{{$index+1}}</td><td \nalign=\"left\" show-gt-sm><b>{{cat.ordertagoption_name}}</b></td><td align=\"center\">{{cat.ordertagoption_rate}}</td><td \nalign=\"center\">{{cat.ordertagoption_status}}</td><td align=\"center\"><md-button class=\"actn-btn md-fab md-mini\" \nng-click=\"vm.editOrdertagoptions(cat.ordertagoption_id)\"><md-tooltip md-direction=\"down\"><span \ntranslate=\"ORDERTAG_OPTION.TABLE_EDIT\">Edit</span></md-tooltip><i class=\"icon icon-table-edit\"></i></md-button>\n<md-button class=\"actn-btn md-fab md-mini md-red-400-bg\" ng-click=\"vm.deleteOrdertagoptions(cat.ordertagoption_id)\">\n<md-tooltip md-direction=\"down\"><span translate=\"ORDERTAG_OPTION.TABLE_DELETE\">Delete</span></md-tooltip><i \nclass=\"icon icon-delete\"></i></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/account-head/new_account-head/new_account-head.html","<div id=\"new_tax\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper style=\"padding:0px\"><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><form name=\"headForm\" class=\"md-inline-form fst-frm\" novalidate><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div class=\"form-title\"><h2>\nAccount Head Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nAccount Head Name</label><input type=\"text\" name=\"achead_name\" ng-model=\"vm.head.achead_name\" required><div \nng-messages=\"headForm.achead_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Account Head field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Status</label><md-select name=\"achead_status\" \nng-model=\"vm.head.achead_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container></div></div></div><div class=\"main scrollable\" ms-scroll><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Tax\" \nng-click=\"vm.gotoAccounthead()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"headForm.$invalid || headForm.$pristine\" ng-click=\"vm.saveAccounthead()\">Submit\n</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/bills/dialogs/dialogs.html","<md-dialog class=\"tender-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"top-bar\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Select Tender</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CLASSES.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"tender-btn-bx\" layout=\"row\" layout-wrap><div layout=\"column\" ng-repeat=\"pmode in vm.payMode\"><md-button \nclass=\"btm-btn md-raised md-background grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" style=\"background:#04738C\" \nng-if=\"$index%6==0\"><span>{{pmode}}</span></md-button><md-button class=\"btm-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.changeTender2(pmode)\" style=\"background:#ffb74d\" ng-if=\"$index%6==1\"><span>{{pmode}}</span></md-button>\n<md-button class=\"btm-btn md-raised md-background md-blue-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==2\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-orange-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==3\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-green-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==4\"><span>{{pmode}}</span></md-button><md-button \nclass=\"btm-btn md-raised md-background md-pink-500-bg grey-50-fg\" ng-click=\"vm.changeTender2(pmode)\" \nng-if=\"$index%6==5\"><span>{{pmode}}</span></md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/branch/new_branch/new_branch.html","<div id=\"new_branch\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"admission-content\" \nlayout=\"column\"><div class=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form \nname=\"branchForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\"><h2>Branch Details</h2></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Branch Name</label><input type=\"text\" \nname=\"branch_name\" ng-model=\"vm.branch.branch_name\" required><div ng-messages=\"branchForm.branch_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Branch Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Description</label><input type=\"text\" name=\"branch_description\" \nng-model=\"vm.branch.branch_description\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Status</label><md-select name=\"branch_status\" ng-model=\"vm.branch.branch_status\">\n<md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option></md-select></md-input-container>\n<md-input-container flex></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Branchs\" ng-click=\"vm.gotoBranchs()\">Back</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"branchForm.$invalid || branchForm.$pristine\" ng-click=\"vm.saveBranchs()\">Submit</md-button></div></form>\n</div></div></div></div>");
$templateCache.put("app/main/apps/category/items/items_list.html","<div id=\"category-item\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"row\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"></div></div><div\n class=\"list-content scrollable\" ms-scroll><div class=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><div \nclass=\"search\" layout=\"row\" layout-align=\"end center\"><span translate=\"ITEM_CATEGORY.TABLE_SEARCH\">Search: </span>\n<input type=\"text\" placeholder=\"Search\" ng-model=\"vm.search\"></div><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span \nclass=\"column-title\"><md-checkbox md-no-ink ng-model=\"vm.mainChk\" ng-checked=\"(vm.mainChk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\" class=\"md-accent\" ng-click=\"vm.selectAll()\"></md-checkbox></span></div></th><th \nclass=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ITEM_CATEGORY.ITEM_NAME\">Item Name</span></div></th><th class=\"secondary-text\" show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ITEM_CATEGORY.ORDER_INDEX\">Order Index</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"cat in vm.items | filter:vm.search | orderBy : [\'selectedchk\']:false\"><td \nalign=\"center\"><md-checkbox md-no-ink ng-model=\"cat.selectedchk\" ng-checked=\"(cat.selectedchk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\" class=\"md-accent\"></md-checkbox></td><td align=\"left\" show-gt-sm><b>{{cat.item_name}}</b></td><td \nalign=\"center\"><input type=\"text\" name=\"order\" ng-model=\"cat.order\" placeholder=\"Enter Item Order Index\"></td></tr>\n</tbody></table></div><div layout=\"row\" layout-align=\"center center\" class=\"brn-bx\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Categorys\" ng-click=\"vm.gotoCategorys()\" \ntranslate=\"ITEM_CATEGORY.BACK_BTN\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" ng-click=\"vm.saveCatItems()\" \ntranslate=\"ITEM_CATEGORY.SUBMIT_BTN\">Submit</md-button></div></div></div></div>");
$templateCache.put("app/main/apps/category/new_category/new_category.html","<div id=\"new_category\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"categoryForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_CATEGORY.CAT_DETAILS\">Category Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_CATEGORY.CAT_NAME\">Category Name</label><input \ntype=\"text\" name=\"categorylist_name\" ng-model=\"vm.category.categorylist_name\" required><div \nng-messages=\"categoryForm.categorylist_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_CATEGORY.ALERT_CAT_NAME\">Categorys Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_CATEGORY.ORDER_INDEX\">Order Index</label><input \ntype=\"text\" name=\"categorylist_order\" ng-model=\"vm.category.categorylist_order\"></md-input-container>\n<md-input-container flex><label translate=\"NEW_CATEGORY.STATUS\">Status</label><md-select name=\"categorylist_status\" \nng-model=\"vm.category.categorylist_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.category.categorylist_id!=\'\'\">\n<md-input-container flex><label translate=\"NEW_CATEGORY.UPLOAD_IMAGE\">Upload Image</label><br><div id=\"file-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload($file, $message)\" \nflow-file-added=\"vm.fileAdded($file, $message)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-file-error=\"vm.fileError($file, $message, $flow)\" flow-error=\"vm.fileError2($file, $message, $flow)\" \nflow-complete=\"vm.uploadComplete()\"><md-button flow-btn class=\"md-raised md-warn\" \ntranslate=\"NEW_CATEGORY.UPLOAD_IMAGE\">Upload Image</md-button></div></md-input-container><md-input-container flex>\n<label translate=\"NEW_CATEGORY.UPLOADED_IMG\">Uploaded Image</label><br><div style=\"margin:20px\" ng-if=\"vm.files.url\">\n<img src=\"{{vm.files.url}}\" width=\"180\"></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Categorys\" \nng-click=\"vm.gotoCategorys()\" translate=\"NEW_CATEGORY.BACK_BTN\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" \nng-click=\"vm.saveCategorys()\" translate=\"NEW_CATEGORY.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/customer/new_customer/new_customer.html","<div id=\"new_customer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\" flex><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"customerForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_CUSTOMER.CUSTOMER_DTLS\">Customer Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_CUSTOMER.CUS_NAME\">Customer Name</label><input \ntype=\"text\" name=\"customer_name\" ng-model=\"vm.customer.customer_name\" required><div \nng-messages=\"customerForm.customer_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_CUSTOMER.ALERT_CUSNAME\">Customer Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_CUSTOMER.MOBILENO\">Mobile No</label><input type=\"text\" \nname=\"customer_mobileno\" ng-model=\"vm.customer.customer_mobileno\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"NEW_CUSTOMER.ADDRESS\">Address</label>\n<input type=\"text\" name=\"customer_address\" ng-model=\"vm.customer.customer_address\"></md-input-container>\n<md-input-container flex><label translate=\"NEW_CUSTOMER.STATUS\">Status</label><md-select name=\"customer_status\" \nng-model=\"vm.customer.customer_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoCustomer()\" translate=\"NEW_CUSTOMER.BACK_BTN\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"customerForm.$invalid || customerForm.$pristine\" ng-click=\"vm.saveCustomer()\" \ntranslate=\"NEW_CUSTOMER.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/customer/sidenavs/customer-sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list><md-subheader class=\"sub_header\">Navigation</md-subheader>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoDepartmentPage()\"><span>Departments</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoPriceTagPage()\"><span>Price Tags</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCustomerPage()\"><span>Customers</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoWaiterPage()\"><span>Waiters</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoStaffPage()\"><span>Staffs</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoSeatsPage()\"><span>Tables/Seats</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCategoryPage()\"><span>Categorys</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoItemPage()\"><span>Items</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoPricingPage()\"><span>Pricings</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoTaxPage()\"><span>Tax</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoSettingPage()\"><span>Settings</span></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/daybook/new_daybook/new_daybook.html","<div id=\"new_tax\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper style=\"padding:0px\"><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><form name=\"daybookForm\" class=\"md-inline-form fst-frm\" novalidate><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div class=\"form-title\"><h2>\nDaybook Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Account Head</label>\n<md-select name=\"daybook_head_id\" ng-model=\"vm.daybook.daybook_head_id\"><md-option ng-repeat=\"op in vm.head\" \nng-value=\"op.achead_id\">{{op.achead_name}}</md-option></md-select></md-input-container><md-input-container flex><label>\nType</label><md-select name=\"daybook_type\" ng-model=\"vm.daybook.daybook_type\"><md-option \nng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Amount</label><input type=\"text\" \nname=\"daybook_amount\" ng-model=\"vm.daybook.daybook_amount\" required><div \nng-messages=\"daybookForm.daybook_amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Amount field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Remarks</label><input type=\"text\" \nname=\"daybook_remarks\" ng-model=\"vm.daybook.daybook_remarks\"></md-input-container></div></div></div><div \nclass=\"main scrollable\" ms-scroll><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" \naria-label=\"Go to Tax\" ng-click=\"vm.gotoDaybook()\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"daybookForm.$invalid || daybookForm.$pristine\" \nng-click=\"vm.saveDaybook()\">Submit</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/department/flow_department/flow_department.html","<div id=\"flow_department\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"departmentForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"FLOW_DEPARTMENT.FLOW_DETAILS\">Department Flow Details</h2></div><table \nclass=\"simple\" ms-responsive-table><thead style=\"background: #00a931\"><tr class=\"\"><th \nclass=\"secondary-text text-center\"><div class=\"table-header\"></div></th><th class=\"secondary-text text-center\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"FLOW_DEPARTMENT.OPTION_NAME\">Option Name</span></div></th>\n<th class=\"secondary-text text-center\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"FLOW_DEPARTMENT.ORDER_INDEX\">Order Index</span></div></th></tr></thead><tbody><tr \nng-repeat=\"opt in vm.deptOpts | orderBy:\'orderIndex\':true\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"opt.selectedChk\" class=\"md-accent\" ng-checked=\"(opt.selectedChk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\"></md-checkbox></td><td align=\"left\" show-gt-sm><b>{{opt.deptopt_name}}</b></td><td align=\"center\">\n<input type=\"text\" name=\"orderIndex\" ng-model=\"opt.orderIndex\"></td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoDepartment()\" translate=\"FLOW_DEPARTMENT.BACK_BTN\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"departmentForm.$invalid || departmentForm.$pristine\" ng-click=\"vm.saveDepartmentFlow()\" \ntranslate=\"FLOW_DEPARTMENT.SAVE_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/department/new_department/new_department.html","<div id=\"new_department\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"departmentForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_DEPARTMENT.DEPARTDTLS\">Department Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_DEPARTMENT.DEPARTNAME\">Department Name</label><input \ntype=\"text\" name=\"department_name\" ng-model=\"vm.department.department_name\" required><div \nng-messages=\"departmentForm.department_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_DEPARTMENT.ALERT_DEPARTNAME\">Department Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"NEW_DEPARTMENT.PRICETAG\">Price Tag</label><md-select \nname=\"department_price_tag_id\" ng-model=\"vm.department.department_price_tag_id\"><md-option ng-value=\"0\"></md-option>\n<md-option ng-repeat=\"op in vm.priceTags\" ng-value=\"op.price_tag_id\">{{op.price_tag_name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"NEW_DEPARTMENT.KOTJOBS\">KOT Jobs</label><md-select name=\"department_kot_jobs_id\" \nng-model=\"vm.department.department_kot_jobs_id\" multiple=\"multiple\"><md-option \nng-repeat=\"op in vm.printerJobs | filter:{printerjobs_type:\'KOTs\'}\" ng-value=\"op.printerjobs_id\">\n{{op.printerjobs_type}} - {{op.printerjobs_name}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"NEW_DEPARTMENT.BILLJOBS\">Bill Jobs</label><md-select name=\"department_bill_jobs_id\" \nng-model=\"vm.department.department_bill_jobs_id\" multiple=\"multiple\"><md-option ng-repeat=\"op in vm.printerJobs\" \nng-value=\"op.printerjobs_id\">{{op.printerjobs_type}} - {{op.printerjobs_name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container flex=\"33\"><label \ntranslate=\"NEW_DEPARTMENT.TYPE\">Type</label><md-select name=\"department_type\" ng-model=\"vm.department.department_type\" \nng-change=\"vm.setType()\"><md-option ng-repeat=\"op in vm.typelist\" ng-value=\"op\">{{op}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"33\"><label translate=\"NEW_DEPARTMENT.PAYMENTMODE\">Payment Mode Button\n</label><input type=\"text\" name=\"department_mode_btns\" ng-model=\"vm.department.department_mode_btns\" required><div \nng-messages=\"departmentForm.department_mode_btns.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_DEPARTMENT.ALERT_PAYMENTMODE\">Payment Mode Button field is required.</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox md-no-ink \nng-model=\"vm.department.department_ifshowkot\" class=\"md-accent\" ng-checked=\"(vm.department.department_ifshowkot==1)\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-click=\"vm.setKOTBtn()\"></md-checkbox><span class=\"term\" \ntranslate=\"NEW_DEPARTMENT.ADKOTBTN\">If Add KOT Button</span></md-input-container><md-input-container flex \nng-if=\"vm.department.department_ifshowkot==1\"><label translate=\"NEW_DEPARTMENT.KOTBTNLBL\">KOT Button Label</label>\n<input type=\"text\" name=\"department_kotlable\" ng-model=\"vm.department.department_kotlable\"></md-input-container>\n<md-input-container flex><md-checkbox md-no-ink ng-model=\"vm.department.department_ifshowsettle\" class=\"md-accent\" \nng-checked=\"(vm.department.department_ifshowsettle==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-click=\"vm.setSettleBtn()\"></md-checkbox><span class=\"term\" translate=\"NEW_DEPARTMENT.ADSETTLEBTN\">\nIf Add Settle Button</span></md-input-container><md-input-container flex \nng-if=\"vm.department.department_ifshowsettle==1\"><label translate=\"NEW_DEPARTMENT.SETTLEBTNLBL\">Settle Button Label\n</label><input type=\"text\" name=\"department_settlelable\" ng-model=\"vm.department.department_settlelable\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex>\n<md-checkbox md-no-ink ng-model=\"vm.department.department_showprintkot\" class=\"md-accent\" \nng-checked=\"(vm.department.department_showprintkot==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span \nclass=\"term\" translate=\"NEW_DEPARTMENT.PRINTCKOT\">Enable Print C KOT</span></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"vm.showHold==1\" flex><md-checkbox md-no-ink ng-model=\"vm.department.department_holdpage\" \nclass=\"md-accent\" ng-checked=\"(vm.department.department_holdpage==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">\n</md-checkbox><span class=\"term\" translate=\"NEW_DEPARTMENT.HOLD_ORDER\">Hold Order on Bill Print</span>\n</md-input-container><md-input-container flex><label translate=\"NEW_DEPARTMENT.STATUS\">Status</label><md-select \nname=\"department_status\" ng-model=\"vm.department.department_status\"><md-option ng-repeat=\"op in vm.statuslist\" \nng-value=\"op\">{{op}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.showHold==0\" flex></md-input-container></div><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:33%\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"NEW_DEPARTMENT.TABLE_CATEGORY\">Category</span></div></th><th \nclass=\"secondary-text\" style=\"width:33%\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"NEW_DEPARTMENT.TABLE_PRODUCT\">Product</span></div></th><th class=\"secondary-text\" style=\"width:33%\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"NEW_DEPARTMENT.TABLE_ACTION\">Action</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"itm in vm.deptMapItems\"><td align=\"left\"><md-select name=\"order_tag_category_id\" \nng-model=\"itm.dept_map_category_id\"><md-option ng-value=\"0\" ng-selected=\"itm.dept_map_category_id==0\">*</md-option>\n<md-option ng-repeat=\"op in vm.categorys\" ng-value=\"op.category_id\" \nng-selected=\"itm.dept_map_category_id==op.category_id\">{{op.category_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.dept_map_item_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.dept_map_item_id==0\">*</md-option><md-option \nng-repeat=\"op in vm.items | filter:{catitm_category_id:itm.dept_map_category_id}:true\" ng-value=\"op.item_id\" \nng-selected=\"itm.dept_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td align=\"center\">\n<md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span \ntranslate=\"NEW_DEPARTMENT.TABLE_ADDBTN\">Add</span></md-button><md-button \nclass=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.dept_map_id)\"><span \ntranslate=\"NEW_DEPARTMENT.TABLE_DELETEBTN\">Delete</span></md-button></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoDepartment()\"><span translate=\"NEW_DEPARTMENT.TABLE_BACK\">Back</span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"departmentForm.$invalid || departmentForm.$pristine\" ng-click=\"vm.saveDepartment()\" \ntranslate=\"NEW_DEPARTMENT.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/extra/new_extra/new_extra.html","<div id=\"new_extra\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper style=\"padding:0px\"><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><form name=\"extraForm\" class=\"md-inline-form fst-frm\" novalidate><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div class=\"form-title\"><h2>\nExtra Details</h2></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label>Extra Name</label>\n<input type=\"text\" name=\"extra_name\" ng-model=\"vm.extra.extra_name\" required><div \nng-messages=\"extraForm.extra_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Extra Name field is required.\n</span></div></div></md-input-container><md-input-container flex=\"50\"><label>Status</label><md-select \nname=\"extra_status\" ng-model=\"vm.extra.extra_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container flex=\"50\">\n<label>Type</label><md-select name=\"extra_type\" ng-model=\"vm.extra.extra_type\" required><md-option \nng-repeat=\"op in vm.typelist\" ng-value=\"op\">{{op}}</md-option></md-select><div \nng-messages=\"extraForm.extra_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Extra Type field is required.\n</span></div></div></md-input-container><md-input-container flex=\"50\"><label>Extra Rate</label><input type=\"text\" \nname=\"extra_rate\" ng-model=\"vm.extra.extra_rate\" required><div ng-messages=\"extraForm.extra_rate.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Extra Rate field is required.</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><md-checkbox md-no-ink \nng-model=\"vm.extra.extra_billable\" class=\"md-accent\" ng-checked=\"(vm.extra.extra_billable==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\"></md-checkbox><span class=\"term\">Billable</span></md-input-container><md-input-container \nclass=\"md-block\" flex><md-checkbox md-no-ink ng-model=\"vm.extra.extra_inclTax\" class=\"md-accent\" \nng-checked=\"(vm.extra.extra_inclTax==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span class=\"term\">\nTaxable</span></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox md-no-ink \nng-model=\"vm.extra.extra_inclDiscount\" class=\"md-accent\" ng-checked=\"(vm.extra.extra_inclDiscount==1)\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox><span class=\"term\">Discountable</span></md-input-container>\n<md-input-container class=\"md-block\" flex><md-checkbox md-no-ink ng-model=\"vm.extra.extra_inclRemove\" \nclass=\"md-accent\" ng-checked=\"(vm.extra.extra_inclRemove==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox>\n<span class=\"term\">Removable</span></md-input-container></div></div></div><div class=\"main scrollable\" ms-scroll><div \nclass=\"category-table-wrapper pt-20 md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table>\n<thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:25%\"><div \nclass=\"table-header\"><span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Product</span></div></th>\n<th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.extraMapItems\"><td align=\"left\"><md-select name=\"order_tag_dept_id\" \nng-model=\"itm.extra_map_department_id\"><md-option ng-value=\"0\" ng-selected=\"itm.extra_map_department_id==0\">*\n</md-option><md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.extra_map_department_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_category_id\" ng-model=\"itm.extra_map_category_id\" \nng-disabled=\"vm.extra.extra_billable==1\"><md-option ng-value=\"0\" ng-selected=\"itm.extra_map_category_id==0\">*\n</md-option><md-option ng-repeat=\"op in vm.categorys\" ng-value=\"op.category_id\" \nng-selected=\"itm.extra_map_category_id==op.category_id\">{{op.category_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.extra_map_item_id\" \nng-disabled=\"vm.extra.extra_billable==1\"><md-option ng-value=\"0\" ng-selected=\"itm.extra_map_item_id==0\">*</md-option>\n<md-option ng-repeat=\"op in vm.items | filter:{catitm_category_id:itm.extra_map_category_id}:true\" \nng-value=\"op.item_id\" ng-selected=\"itm.extra_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td \nalign=\"center\"><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.extra_map_id)\">\n<span>Delete</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"padding-top-5\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Extra\" ng-click=\"vm.gotoExtra()\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"extraForm.$invalid || extraForm.$pristine\" ng-click=\"vm.saveExtra()\">Submit</md-button></div></div></form>\n</div></div></div>");
$templateCache.put("app/main/apps/ingredients/new_ingredients/new_ingredients.html","<div id=\"new_ingredients\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"ingredientsForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_INGREDIENT.INGREDIENT_DTLS\">Ingredients Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_INGREDIENT.INGREDIENT_NAME\">Ingredients Name</label>\n<input type=\"text\" name=\"ingredients_name\" ng-model=\"vm.ingredients.ingredients_name\" required><div \nng-messages=\"ingredientsForm.ingredients_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_INGREDIENT.ALERT_INGREDIENT_NAME\">Ingredients Name field is required.</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"NEW_INGREDIENT.STATUS\">Status</label><md-select \nname=\"ingredients_status\" ng-model=\"vm.ingredients.ingredients_status\"><md-option ng-repeat=\"op in vm.statuslist\" \nng-value=\"op\">{{op}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"NEW_INGREDIENT.MINIMUN_QTY\">Minimum Qty</label><input type=\"text\" \nname=\"ingredients_min_qty\" ng-model=\"vm.ingredients.ingredients_min_qty\"></md-input-container><md-input-container flex>\n<label translate=\"NEW_INGREDIENT.MAXIMUM_QTY\">Maximum Qty</label><input type=\"text\" name=\"ingredients_max_qty\" \nng-model=\"vm.ingredients.ingredients_max_qty\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"NEW_INGREDIENT.TRANSACTION_UNIT\">Transaction Unit</label><md-select \nname=\"ingredients_transferunit_id\" ng-model=\"vm.ingredients.ingredients_transferunit_id\"><md-option \nng-repeat=\"op in vm.units\" ng-value=\"op.unit_id\">{{op.unit_name}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"NEW_INGREDIENT.BASE_UBIT\">Base Unit</label><md-select \nname=\"ingredients_baseunit_id\" ng-model=\"vm.ingredients.ingredients_baseunit_id\"><md-option ng-repeat=\"op in vm.units\" \nng-value=\"op.unit_id\">{{op.unit_name}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_INGREDIENT.MULTIPLE_COUNT\">Multiple Count</label>\n<input type=\"text\" name=\"ingredients_mulitples\" ng-model=\"vm.ingredients.ingredients_mulitples\"></md-input-container>\n<md-input-container flex><label></label></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoIngredients()\" \ntranslate=\"NEW_INGREDIENT.BACK_BTN\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"ingredientsForm.$invalid\" ng-click=\"vm.saveIngredients()\" \ntranslate=\"NEW_INGREDIENT.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/item/new_item/new_item.html","<div id=\"new_item\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"itemForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEWITEM.ITEM_DETAILS\">Item Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"NEWITEM.ITEM_NAME\">Item Name</label><input type=\"text\" name=\"itemlist_name\" \nng-model=\"vm.item.itemlist_name\" required><div ng-messages=\"itemForm.itemlist_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"NEWITEM.ALERT_ITEM_DNAME\">Item Name field is required.</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"NEWITEM.ITEM_CODE\">Item Code</label><input type=\"text\" \nname=\"itemlist_code\" ng-model=\"vm.item.itemlist_code\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEWITEM.ITEM_BARCOE\">Item Barcode</label><input \ntype=\"text\" name=\"itemlist_barcode\" ng-model=\"vm.item.itemlist_barcode\"></md-input-container><md-input-container flex>\n<label translate=\"NEWITEM.ITEM_UNIT\">Unit</label><md-select name=\"itemlist_unit_id\" \nng-model=\"vm.item.itemlist_unit_id\"><md-option ng-repeat=\"op in vm.unitsList\" ng-value=\"op.unit_id\" \nng-selected=\"vm.item.itemlist_unit_id==op.unit_id\">{{op.unit_name}}</md-option></md-select></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox md-no-ink \nng-model=\"vm.item.itemlist_is_inventory\" class=\"md-accent\" ng-checked=\"(vm.item.itemlist_is_inventory==1)\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" translate=\"NEWITEM.CHECK_INVENTORYITEM\">Is Inventory Item</md-checkbox>\n</md-input-container><md-input-container flex><label translate=\"NEWITEM.RECORD_MINLEVEL\">Reorder Min Level</label>\n<input type=\"text\" name=\"itemlist_reorder_min_level\" ng-model=\"vm.item.itemlist_reorder_min_level\">\n</md-input-container><md-input-container flex><label translate=\"NEWITEM.RECORD_MAXLEVEL\">Reorder Max Level</label>\n<input type=\"text\" name=\"itemlist_reorder_max_level\" ng-model=\"vm.item.itemlist_reorder_max_level\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"NEWITEM.TYPE\">Type</label><md-select name=\"itemlist_type\" ng-model=\"vm.item.itemlist_type\"><md-option \nng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option></md-select></md-input-container><md-input-container \nflex><label translate=\"NEWITEM.ITEM_IMAGE\">Item Image</label><br><div id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload($file, $message)\" \nflow-file-added=\"vm.fileAdded($file, $message)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-file-error=\"vm.fileError($file, $message, $flow)\" flow-error=\"vm.fileError2($file, $message, $flow)\" \nflow-complete=\"vm.uploadComplete()\"><md-button flow-btn class=\"md-raised md-warn\" translate=\"NEWITEM.UPLOAD_IMAGE\">\nUpload Image</md-button></div><div class=\"widget-group text-center\" layout=\"row\" flex layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"30\" ng-if=\"vm.files.url\"><img src=\"{{vm.files.url}}\" \nstyle=\"width:120px\"><br><md-button ng-click=\"vm.removeImage()\"><b translate=\"NEWITEM.REMOVE_IMAGES\">Remove Image</b>\n</md-button></ms-widget></div></md-input-container></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3 text-bold\" \ntranslate=\"NEWITEM.PORTION_DETAILS\">Portion Details</div></div><div class=\"p-5\"><table class=\"simple\" \nms-responsive-table><thead><tr class=\"\"><th translate=\"NEWITEM.TABLE_SNO\" class=\"text-left\" \nstyle=\"max-width:40px;min-width:30px;padding-left:5px\">S.No</th><th translate=\"NEWITEM.TABLE_NAME\" class=\"text-center\">\nName</th><th translate=\"NEWITEM.TABLE_ORDERINDEX\" class=\"text-center\">Order Index</th><th \ntranslate=\"NEWITEM.TABLE_ACTION\" class=\"text-center\">Action</th></tr></thead><tbody ng-repeat=\"itm in vm.optionsList\">\n<tr><td class=\"name text-center\" style=\"max-width:10px;min-width:10px\">{{$index+1}}</td><td class=\"name text-center\">\n<input type=\"text\" layout=\"row\" name=\"itmlist_option_name\" ng-model=\"itm.itmlist_option_name\"></td><td \nclass=\"name text-center\"><input type=\"text\" name=\"itmlist_option_order\" ng-model=\"itm.itmlist_option_order\"></td><td \nclass=\"name text-center\"><md-button class=\"md-fab md-mini md-green-700-bg\" ng-click=\"vm.addOption()\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-fab md-mini md-red-700-bg\" \nng-click=\"vm.removeOption(itm.itmlist_option_id)\"><md-icon md-font-icon=\"icon-close\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoItem()\" \ntranslate=\"NEWITEM.BACK_BTN\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"itemForm.$invalid\" ng-click=\"vm.saveItem()\" translate=\"NEWITEM.SUBMIT_BTN\">Submit\n</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/offer/new_offer/new_offer.html","<div id=\"new_offer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper style=\"padding:0px\"><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><form name=\"offerForm\" class=\"md-inline-form fst-frm\" novalidate><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div class=\"form-title\"><h2>\nOffer Details</h2></div><div layout=\"row\" layout-gt-xs=\"row\"><md-input-container flex=\"33\"><label>Offer Name</label>\n<input type=\"text\" name=\"offer_name\" ng-model=\"vm.offer.offer_name\" required><div \nng-messages=\"offerForm.offer_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Offer Name field is required.\n</span></div></div></md-input-container><md-input-container flex=\"33\"><label>Type</label><md-select name=\"offer_type\" \nng-model=\"vm.offer.offer_type\" required><md-option ng-repeat=\"op in vm.typelist\" ng-value=\"op\">{{op}}</md-option>\n</md-select><div ng-messages=\"offerForm.offer_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nOffer Type field is required.</span></div></div></md-input-container><md-input-container flex=\"33\"><label>Offer Rate\n</label><input type=\"text\" name=\"offer_rate\" ng-model=\"vm.offer.offer_rate\" required><div \nng-messages=\"offerForm.offer_rate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Offer Rate field is required.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\"><div layout=\"column\" flex=\"33\">\n<label class=\"inpt-lbl\">From:</label><md-datepicker name=\"offer_from\" md-placeholder=\"Enter date\" \nng-model=\"vm.offer.offer_from\" flex style=\"margin-top:0px;width:100%\"></md-datepicker></div><div layout=\"column\" \nflex=\"33\"><label class=\"inpt-lbl\">To:</label><md-datepicker name=\"offer_to\" md-placeholder=\"Enter date\" \nng-model=\"vm.offer.offer_to\" flex style=\"margin-top:0px;width:100%\"></md-datepicker></div><md-input-container \nflex=\"33\"><label>Status</label><md-select name=\"offer_status\" ng-model=\"vm.offer.offer_status\"><md-option \nng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option></md-select></md-input-container></div></div></div><div\n class=\"main scrollable\" ms-scroll><div class=\"category-table-wrapper pt-20 md-background-bg md-whiteframe-1dp\"><table \nclass=\"simple\" ms-responsive-table><thead class=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Department</span></div></th><th \nclass=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div>\n</th><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Product</span>\n</div></th><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.offerMapItems\"><td align=\"left\"><md-select \nname=\"order_tag_dept_id\" ng-model=\"itm.offer_map_department_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.offer_map_department_id==0\">*</md-option><md-option ng-repeat=\"op in vm.depts\" \nng-value=\"op.department_id\" ng-selected=\"itm.offer_map_department_id==op.department_id\">{{op.department_name}}\n</md-option></md-select></td><td align=\"left\"><md-select name=\"order_tag_category_id\" \nng-model=\"itm.offer_map_category_id\"><md-option ng-value=\"0\" ng-selected=\"itm.offer_map_category_id==0\">*</md-option>\n<md-option ng-repeat=\"op in vm.categorys\" ng-value=\"op.category_id\" \nng-selected=\"itm.offer_map_category_id==op.category_id\">{{op.category_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.offer_map_item_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.offer_map_item_id==0\">*</md-option><md-option ng-repeat=\"op in vm.items\" ng-value=\"op.item_id\" \nng-selected=\"itm.offer_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td align=\"center\">\n<md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span></md-button>\n<md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.offer_map_id)\"><span>Delete\n</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"padding-top-5\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Offer\" ng-click=\"vm.gotoOffer()\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"offerForm.$invalid || offerForm.$pristine\" ng-click=\"vm.saveOffer()\">Submit</md-button></div></div></form>\n</div></div></div>");
$templateCache.put("app/main/apps/order-tag/mapping/order_tag_mapping.html","<div id=\"category\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div\n layout=\"column\" layout-align=\"center start\"></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">User Role</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Department</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ticket Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Product</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"itm in vm.orderTagItems\"><td \nalign=\"center\"><md-select name=\"order_tag_role_id\" ng-model=\"itm.order_tag_role_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.order_tag_role_id==0\">*</md-option><md-option ng-repeat=\"op in vm.roles\" ng-value=\"op.role_id\" \nng-selected=\"itm.order_tag_role_id==op.role_id\">{{op.role_name}}</md-option></md-select></td><td align=\"center\">\n<md-select name=\"order_tag_dept_id\" ng-model=\"itm.order_tag_dept_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.order_tag_dept_id==0\">*</md-option><md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.order_tag_dept_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"center\"><md-select name=\"order_tag_ticket_id\" ng-model=\"itm.order_tag_ticket_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.order_tag_ticket_id==0\">*</md-option></md-select></td><td align=\"center\"><md-select \nname=\"order_tag_category_id\" ng-model=\"itm.order_tag_category_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.order_tag_category_id==0\">*</md-option><md-option ng-repeat=\"op in vm.categorys\" \nng-value=\"op.category_id\" ng-selected=\"itm.order_tag_category_id==op.category_id\">{{op.category_name}}</md-option>\n</md-select></td><td align=\"center\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.order_tag_item_id\"><md-option \nng-value=\"0\" ng-selected=\"itm.order_tag_item_id==0\">*</md-option><md-option ng-repeat=\"op in vm.items\" \nng-value=\"op.item_id\" ng-selected=\"itm.order_tag_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td \nalign=\"center\"><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" \nng-click=\"vm.deleteRow(itm.order_tag_items_id)\"><span>Delete</span></md-button></td></tr></tbody></table></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-blue-500-bg grey-50-fg\" \naria-label=\"Go to OrderTags\" ng-click=\"vm.gotoOrderTags()\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" \nng-click=\"vm.saveOrderTageItems()\">Submit</md-button></div></div></div>");
$templateCache.put("app/main/apps/order-tag/new_order-tag/new_order-tag.html","<div id=\"new_ordertag\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"orderTagForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_ORDERTAG.ORDERTAG_DETAILS\">Order Tag Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_ORDERTAG.ORDERTAG_NAME\">Order Tag Name</label><input \ntype=\"text\" name=\"order_tag_name\" ng-model=\"vm.orderTag.order_tag_name\" required><div \nng-messages=\"orderTagForm.order_tag_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_ORDERTAG.ALERT_ORDERTAG_NAME\">Order Tag Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"NEW_ORDERTAG.STATUS\">Status</label><md-select name=\"order_tag_status\" \nng-model=\"vm.orderTag.order_tag_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-block\" \nflex><md-checkbox md-no-ink ng-model=\"vm.orderTag.order_tag_addprice\" class=\"md-accent\" \nng-checked=\"(vm.orderTag.order_tag_addprice==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"true\">\n</md-checkbox><span class=\"term\" translate=\"NEW_ORDERTAG.ADD_TAGPRICE\">Add Tag Price to Order Price</span>\n</md-input-container><md-input-container class=\"md-block\" flex><md-checkbox md-no-ink \nng-model=\"vm.orderTag.order_tag_taxfree\" class=\"md-accent\" ng-checked=\"(vm.orderTag.order_tag_taxfree==1)\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"true\"></md-checkbox><span class=\"term\" \ntranslate=\"NEW_ORDERTAG.TAX_FREE\">Tax Free</span></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to OrderTag\" \nng-click=\"vm.gotoOrderTag()\" translate=\"NEW_ORDERTAG.BACK_BTN\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"orderTagForm.$invalid || orderTagForm.$pristine\" \nng-click=\"vm.saveOrderTag()\" translate=\"NEW_ORDERTAG.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/price-tag/new_price-tag/new_price-tag.html","<div id=\"new_price_tag\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"price_tagForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_PRICETAG.PRICETAG_DTLS\">Price Tags Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_PRICETAG.PRICETAG_NAME\">Price Tags Name</label><input\n type=\"text\" name=\"price_tag_name\" ng-model=\"vm.price_tag.price_tag_name\" required><div \nng-messages=\"price_tagForm.price_tag_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_PRICETAG.ALERT_PRICETAG_NAME\">Price Tags Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_PRICETAG.DESCRIPTION\">Description</label><input \ntype=\"text\" name=\"price_tag_discription\" ng-model=\"vm.price_tag.price_tag_discription\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_PRICETAG.STATUS\">Status</label>\n<md-select name=\"price_tag_status\" ng-model=\"vm.price_tag.price_tag_status\"><md-option ng-repeat=\"op in vm.statuslist\" \nng-value=\"op\">{{op}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" \naria-label=\"Go to Price Tags\" ng-click=\"vm.gotoPriceTags()\" translate=\"NEW_PRICETAG.BACK_BTN\">Back</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"price_tagForm.$invalid || price_tagForm.$pristine\" ng-click=\"vm.savePriceTags()\" \ntranslate=\"NEW_PRICETAG.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/printers/new_printers/new_printers.html","<div id=\"new_printers\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll>\n<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"printersForm\" class=\"md-inline-form\" novalidate><div\n class=\"form-title\"><h2>Printer Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label>Printer Name</label><input type=\"text\" name=\"printers_name\" ng-model=\"vm.printers.printers_name\" required><div \nng-messages=\"printersForm.printers_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPrinter Name field is required.</span></div></div></md-input-container><md-input-container flex><label>Device</label>\n<input type=\"text\" name=\"printers_device\" ng-model=\"vm.printers.printers_device\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Status</label><md-select name=\"printers_status\" \nng-model=\"vm.printers.printers_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container><md-input-container flex></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Printers\" \nng-click=\"vm.gotoPrinters()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"printersForm.$invalid || printersForm.$pristine\" ng-click=\"vm.savePrinters()\">Submit\n</md-button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/printers/mapping/printers_mapping.html","<div id=\"category\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div\n layout=\"column\" layout-align=\"center start\"></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\">\n<span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\" style=\"width:25%\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\" style=\"width:25%\">\n<div class=\"table-header\"><span class=\"column-title\">Product</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.printerMapItems\"><td align=\"left\"><md-select name=\"order_tag_dept_id\" \nng-model=\"itm.print_map_department_id\"><md-option ng-value=\"0\" ng-selected=\"itm.print_map_department_id==0\">*\n</md-option><md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.print_map_department_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_category_id\" ng-model=\"itm.print_map_category_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.print_map_category_id==0\">*</md-option><md-option ng-repeat=\"op in vm.categorys\" \nng-value=\"op.category_id\" ng-selected=\"itm.print_map_category_id==op.category_id\">{{op.category_name}}</md-option>\n</md-select></td><td align=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.print_map_item_id\"><md-option \nng-value=\"0\" ng-selected=\"itm.print_map_item_id==0\">*</md-option><md-option ng-repeat=\"op in vm.items\" \nng-value=\"op.item_id\" ng-selected=\"itm.print_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td \nalign=\"center\"><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.print_map_id)\">\n<span>Delete</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Printers\" ng-click=\"vm.gotoPrinters()\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" ng-click=\"vm.savePrintersItems()\">Submit</md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/purchase/new_purchase/new_purchase.html","<div id=\"new_purchase\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"purchaseForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEWPURCHASE.SALESDET\">Purchase Details</h2></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background:#00a931\"><div class=\"h3 grey-50-fg\" translate=\"NEWPURCHASE.CUSTOMERDET\">Supplier Details</div></div>\n<div class=\"p-16 ctmr-frm\"><div layout=\"row\" layout-gt-xs=\"row\" layout-align=\"start center\"><label \nclass=\"font-size-16\" translate=\"NEWPURCHASE.CUSTNAME\" style=\"margin-top:-30px\">Supplier Name :</label>\n<md-input-container flex class=\"m-0 p-0 pl-10\"><md-autocomplete ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.supplier_name\" md-min-length=\"1\" \nmd-menu-class=\"autocomplete-custom-template\" md-dropdown-position=\"bottom\" required><md-item-template><span \nclass=\"item-title\"><span>{{item.supplier_name}}</span></span></md-item-template></md-autocomplete><div \nng-messages=\"purchaseForm.supplier_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEWPURCHASE.ERRORS.NAME_REQUIRED\">Supplier Name field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\"><span translate=\"NEWPURCHASE.CUSTMOBILE\">\nSupplier Mobile No</span> : {{vm.supplier.supplier_mobile}}</label></div><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"mt-10\"><label class=\"font-size-16\"><span translate=\"NEWPURCHASE.CUSTADDRESS\">Supplier Address</span>\n : {{vm.supplier.supplier_address}}</label></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"background:#00a931\"><div class=\"h3 grey-50-fg\" \ntranslate=\"NEWPURCHASE.BILLDET\">Bill Details</div></div><div class=\"p-16 scnd-form\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><label class=\"font-size-16\"><span translate=\"NEWPURCHASE.BILLNO\">Bill No</span> : <input \ntype=\"text\" name=\"purchase_fullno\" ng-model=\"vm.purchase_fullno\"></label></div><div layout=\"row\" layout-gt-xs=\"row\" \nflex class=\"flex\"><label layout=\"row\" class=\"font-size-16\" translate=\"NEWPURCHASE.DATE\">Date :</label><md-datepicker \nname=\"date\" md-placeholder=\"Enter date\" ng-model=\"vm.purchase.purchase_date\"></md-datepicker></div><div layout=\"row\" \nlayout-gt-xs=\"row\" flex class=\"flex\"><label class=\"font-size-16\" style=\"padding-top:10px\">Warehouse :</label><md-select\n class=\"simplified select-class md-default-theme\" ng-model=\"vm.purchase.purchase_warehouse_id\" \nname=\"purchase_warehouse_id\" required><md-option ng-repeat=\"op in vm.warehouseList\" ng-value=\"op.warehouse_id\" \nng-selected=\"op.warehouse_id==vm.purchase.purchase_warehouse_id\">{{op.warehouse_name}}</md-option></md-select></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3 text-bold\" translate=\"NEWPURCHASE.ITEMDETS\">\nItem Details</div></div><div class=\"p-5\"><table class=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\">\n<th class=\"text-center\" style=\"max-width:40px;min-width:40px;padding-left:20px\" translate=\"NEWPURCHASE.ITEMSNO\">S.No\n</th><th class=\"text-center\" translate=\"NEWPURCHASE.ITEMNAME\">Name</th><th class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\" translate=\"NEWPURCHASE.ITEMUNIT\">Unit</th><th class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\" translate=\"NEWPURCHASE.ITEMPRICE\">Price</th><th class=\"text-center\" \ntranslate=\"NEWPURCHASE.ITEMQTY\">Qty</th><th class=\"text-center\" translate=\"NEWPURCHASE.ITEMTOTAL\">Total</th><th \nclass=\"text-center\" translate=\"NEWPURCHASE.ITEMACTION\">Action</th></tr></thead><tbody \nng-repeat=\"itm in vm.purchaseItems\"><tr><td class=\"name tbl text-center\" style=\"max-width:50px;min-width:50px\">\n{{$index+1}}</td><td class=\"name tbl text-center\"><md-autocomplete ng-disabled=\"itm.isDisabled2\" \nmd-no-cache=\"itm.noCache2\" md-selected-item=\"itm.selectedItem2\" \nmd-search-text-change=\"vm.searchTextChange2(itm.searchText2)\" md-search-text=\"itm.searchText2\" \nmd-selected-item-change=\"vm.selectedItemChange2(item)\" md-items=\"item in vm.querySearch2(itm.searchText2)\" \nmd-item-text=\"item.ingredients_name\" md-min-length=\"1\" placeholder=\"Select Ingredients\" \nmd-menu-class=\"autocomplete-custom-template\"><md-item-template><span class=\"item-title\"><span>{{item.ingredients_name}}\n</span></span></md-item-template></md-autocomplete></td><td class=\"name tbl text-center\" \nstyle=\"max-width:150px;min-width:150px\">{{itm.prod_unit_name}}</td><td class=\"name tbl text-center\" \nstyle=\"max-width:150px;min-width:150px\"><input type=\"text\" name=\"prod_price\" ng-model=\"itm.prod_price\" \nng-change=\"vm.sumTotal()\"></td><td class=\"name tbl text-center\"><input type=\"text\" name=\"prod_qty\" \nng-model=\"itm.prod_qty\" ng-change=\"vm.sumTotal()\"></td><td class=\"name tbl text-right\" style=\"padding-right:15px\">\n{{itm.prod_total}}</td><td class=\"name tbl text-center\"><md-button class=\"md-fab md-mini md-red-700-bg\" \nng-click=\"vm.removeProduct(itm.prod_id)\" ng-if=\"(itm.prod_remove==true)\"><md-icon md-font-icon=\"icon-close\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</md-button></td></tr></tbody><thead><tr class=\"total\"><th class=\"name text-center grey-50-fg\"></th><th \nclass=\"name text-center grey-50-fg\"></th><th class=\"name text-center grey-50-fg\"></th><th \nclass=\"name text-center grey-50-fg\"></th><th class=\"name text-center grey-50-fg\">{{vm.purchase.purchase_total_qty}}\n</th><th class=\"name text-center grey-50-fg\"></th><th class=\"name text-right grey-50-fg\">\n{{vm.purchase.purchase_total_gross | number: vm.c_d}}</th></tr></thead></table></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div><table class=\"simple\" ms-responsive-table><tr><td class=\"name text-right md-green-200-bg\" \nstyle=\"padding:10px 5px 10px 0px\">Gross Amount</td><td class=\"name text-center\"><i \nclass=\"icon icon-currency-inr grey-900-fg\" style=\"font-size:16px\"></i></td><td class=\"name text-center\">\n{{vm.purchase.purchase_total_gross | number: vm.c_d}}</td></tr><tr><td class=\"name text-right md-green-200-bg\" \nstyle=\"padding:10px 5px 10px 0px\">Nett Amount</td><td class=\"name text-center\"><i \nclass=\"icon icon-currency-inr grey-900-fg\" style=\"font-size:16px\"></i></td><td class=\"name text-center\">\n{{vm.purchase.purchase_total_net | number: vm.c_d}}</td></tr></table></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoPurchase()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"purchaseForm.$invalid || purchaseForm.$pristine\" ng-click=\"vm.addNewPurchase()\" \ntranslate=\"NEWPURCHASE.SUBMIT\" translate-attr-aria-label=\"NEWPURCHASE.SUBMIT\">Submit</md-button></div></form></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/purchasei/new_purchasei/new_purchasei.html","<div id=\"new_purchasei\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"content md-background-bg\"><div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" \nms-scroll><div class=\"form-wrapper\" flex=\"100\"><form name=\"purchaseiForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2>Purchase Details</h2></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-16 border-bottom md-blue-500-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nSupplier Details</div></div><div class=\"p-16 ctmr-frm\"><div layout=\"column\" layout-gt-xs=\"row\"><label \nclass=\"font-size-16\">Supplier Name :</label><md-input-container flex class=\"m-0 p-0 pt-15 pl-10\"><input type=\"text\" \nname=\"supplier_name\" ng-model=\"vm.supplier.supplier_name\" required ng-keypress=\"vm.setCustID()\"><ul \nstyle=\"list-style:none; float:left\" ng-show=\"vm.cust_list==true\"><li \ndata-ng-repeat=\"cust in vm.purchaseiDB.supplierList | filter:vm.supplier.supplier_name\" \nng-click=\"vm.showcustlist(cust.supplier_id)\">{{cust.supplier_name}}</li></ul><div \nng-messages=\"purchaseiForm.supplier_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSupplier Name field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:-15px\"><label class=\"font-size-16\"><span>Supplier Mobile No</span> : {{vm.supplier.supplier_mobile}}\n</label></div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\"><span>Supplier Address</span>\n : {{vm.supplier.supplier_address}}</label></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom md-blue-500-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Bill Details</div></div><div class=\"p-16 scnd-form\">\n<div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\"><span>Bill No</span> : {{vm.purchasei_fullno}}\n</label></div><div layout=\"row\" layout-gt-xs=\"row\" flex class=\"flex\"><label layout=\"row\" class=\"font-size-16\">Date :\n</label><md-datepicker name=\"date\" md-placeholder=\"Enter date\" ng-model=\"vm.purchasei.purchasei_date\"></md-datepicker>\n</div><div layout=\"row\" layout-gt-xs=\"row\" flex class=\"flex\"><label class=\"font-size-16\">Warehouse :</label><md-select \nclass=\"simplified select-class md-default-theme\" ng-model=\"vm.purchasei.purchasei_warehouse_id\" \nname=\"purchasei_warehouse_id\" required><md-option ng-repeat=\"op in vm.warehouseList\" ng-value=\"op.warehouse_id\" \nng-selected=\"op.warehouse_id==vm.purchasei.purchasei_warehouse_id\">{{op.warehouse_name}}</md-option></md-select></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3 text-bold\">Item Details</div></div><div class=\"p-5\">\n<table class=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th class=\"text-center\" \nstyle=\"max-width:40px;min-width:40px;padding-left:20px\">S.No</th><th class=\"text-center\">Name</th><th \nclass=\"text-center\" style=\"max-width:150px;min-width:150px\">Unit</th><th class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\">Price</th><th class=\"text-center\">Qty</th><th class=\"text-center\">Total</th><th\n class=\"text-center\">Action</th></tr></thead><tbody ng-repeat=\"itm in vm.purchaseiItems\"><tr><td \nclass=\"name tbl text-center\" style=\"max-width:50px;min-width:50px\">{{$index+1}}</td><td class=\"name tbl text-center\">\n<input type=\"text\" layout=\"row\" name=\"prod_name\" ng-model=\"itm.prod_name\" ng-keypress=\"vm.showitmlist(itm.sno)\"><ul \nstyle=\"list-style:none; float:left\" layout=\"column\" ng-show=\"itm.prod_list==true\"><li layout=\"column\" \ndata-ng-repeat=\"prod in vm.productsList | filter:itm.prod_name\" ng-click=\"vm.setProdID(prod.itemlist_id)\">\n{{prod.itemlist_name}}</li></ul></td><td class=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">\n{{itm.prod_unit_name}}</td><td class=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\"><input type=\"text\" \nname=\"prod_price\" ng-model=\"itm.prod_price\" ng-change=\"vm.sumTotal()\"></td><td class=\"name tbl text-center\"><input \ntype=\"text\" name=\"prod_qty\" ng-model=\"itm.prod_qty\" ng-change=\"vm.sumTotal()\"></td><td class=\"name tbl text-right\" \nstyle=\"padding-right:15px\">{{itm.prod_total}}</td><td class=\"name tbl text-center\"><md-button \nclass=\"md-fab md-mini md-red-700-bg\" ng-click=\"vm.removeProduct(itm.prod_id)\" ng-if=\"(itm.prod_remove==true)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody><tr class=\"md-blue-500-bg\"><td \nclass=\"name text-center grey-50-fg\"></td><td class=\"name text-center grey-50-fg\"></td><td \nclass=\"name text-center grey-50-fg\"></td><td class=\"name text-center grey-50-fg\"></td><td \nclass=\"name text-center grey-50-fg\">{{vm.purchasei.purchasei_total_qty}}</td><td class=\"name text-center grey-50-fg\">\n</td><td class=\"name text-right grey-50-fg\">{{vm.purchasei.purchasei_total_gross | number: vm.c_d}}</td></tr></table>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div><table class=\"simple\" ms-responsive-table><tr><td \nclass=\"name text-right md-blue-50-bg\">Gross Amount</td><td class=\"name text-center\"><i \nclass=\"icon icon-currency-inr grey-900-fg\" style=\"font-size:16px\"></i></td><td class=\"name text-right\">\n{{vm.purchasei.purchasei_total_gross | number: vm.c_d}}</td></tr><tr><td class=\"name text-right md-blue-50-bg\">\nNett Amount</td><td class=\"name text-center\"><i class=\"icon icon-currency-inr grey-900-fg\" style=\"font-size:16px\"></i>\n</td><td class=\"name text-right\">{{vm.purchasei.purchasei_total_net | number: vm.c_d}}</td></tr></table></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoPurchasei()\">Back</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"purchaseiForm.$invalid || purchaseiForm.$pristine\" ng-click=\"vm.addNewPurchasei()\">Submit</md-button>\n</div></form></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/recipes/new_recipes/new_recipes.html","<div id=\"new_recipes\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div class=\"form-wrapper\" flex=\"100\">\n<form name=\"recipesForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\"><h2 \ntranslate=\"NEWRECIPES.RECE_DETAILS\">Recipes Details</h2></div><div class=\"widget-group fst-wid\" layout=\"row\" \nlayout-align=\"space-between\" flex=\"100\" layout-wrap><div layout=\"column\" layout-gt-xs=\"row\" flex><label \nclass=\"font-size-16\" translate=\"NEWRECIPES.ITEM_NAME\">Item Name:</label><md-input-container flex class=\"p-0 pl-10\">\n<md-autocomplete ng-disabled=\"vm.isDisabled2\" md-no-cache=\"vm.noCache2\" md-selected-item=\"vm.selectedItem2\" \nmd-search-text-change=\"vm.searchTextChange2(vm.searchText2)\" md-search-text=\"vm.searchText2\" \nmd-selected-item-change=\"vm.selectedItemChange2(item)\" md-items=\"item in vm.querySearch2(vm.searchText2)\" \nmd-item-text=\"item.itemlist_name\" md-min-length=\"1\" md-menu-class=\"autocomplete-custom-template\" \nmd-dropdown-position=\"bottom\" required><md-item-template><span class=\"item-title\"><span>{{item.itemlist_name}}</span>\n</span></md-item-template></md-autocomplete><div ng-messages=\"recipesForm.item_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"NEWRECIPES.ALERT_ITEM_NAME\">Item Name field is required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><label class=\"font-size-16\" \ntranslate=\"NEWRECIPES.OPTION_NAME\">Option Name:</label><md-input-container flex class=\"p-0 pl-10\"><input type=\"text\" \nname=\"option_name\" ng-model=\"vm.item.option_name\" required ng-keypress=\"vm.setOptID()\" autocomplete=\"off\"><ul \nclass=\"ato-cmplt\" ng-show=\"vm.opt_list==true\" ms-scroll><li \ndata-ng-repeat=\"opt in vm.recipesOpts | filter:vm.item.option_name\" ng-click=\"vm.showoptlist(opt.itmlist_option_id)\">\n{{opt.itmlist_option_name}}</li></ul><div ng-messages=\"recipesForm.option_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"NEWRECIPES.ALERT_OPTION_NAME\">Option Name field is required.</span></div></div>\n</md-input-container></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\" style=\"overflow:visible\"><div \nclass=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3 text-bold\" \ntranslate=\"NEWRECIPES.INGRE_DTLS\">Ingredients Details</div></div><div style=\"padding:5px 5px 0px 5px\"><table \nclass=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th class=\"text-center\" \nstyle=\"max-width:10px;min-width:10px;padding-left:25px\" translate=\"NEWRECIPES.TABLE_SNO\">S.No</th><th \nclass=\"text-center\" translate=\"NEWRECIPES.TABLE_NAME\">Name</th><th class=\"text-center\" \ntranslate=\"NEWRECIPES.TABLE_QTY\">Qty</th><th class=\"text-center\" translate=\"NEWRECIPES.TABLE_UNIT\">Unit</th><th \nclass=\"text-center\" translate=\"NEWRECIPES.TABLE_ACTION\">Action</th></tr></thead><tbody \nng-repeat=\"itm in vm.recipesItems\"><tr><td class=\"name tbl text-center\" style=\"max-width:40px;min-width:40px\">\n{{$index+1}}</td><td class=\"name tbl text-center\"><md-autocomplete ng-disabled=\"itm.isDisabled\" \nmd-no-cache=\"itm.noCache\" md-selected-item=\"itm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(itm.searchText)\" md-search-text=\"itm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item,$index)\" md-items=\"item in vm.querySearch(itm.searchText)\" \nmd-item-text=\"item.ingredients_name\" md-min-length=\"1\" placeholder=\"Select Ingredients\" \nmd-menu-class=\"autocomplete-custom-template\" md-dropdown-position=\"bottom\"><md-item-template><span class=\"item-title\">\n<span>{{item.ingredients_name}}</span></span></md-item-template></md-autocomplete></td><td \nclass=\"name tbl text-center\"><input type=\"text\" name=\"prod_qty\" ng-model=\"itm.prod_qty\"></td><td \nclass=\"name tbl text-center\"><md-autocomplete ng-disabled=\"itm.isDisabled4\" md-no-cache=\"itm.noCache4\" \nmd-selected-item=\"itm.selectedItem4\" md-search-text-change=\"vm.searchTextChange4(itm.searchText4)\" \nmd-search-text=\"itm.searchText4\" md-selected-item-change=\"vm.selectedItemChange4(itm.sno,item)\" \nmd-items=\"item in vm.querySearch4(itm.searchText4)\" md-item-text=\"item.unit_name\" md-min-length=\"1\" \nplaceholder=\"Select Unit\" md-menu-class=\"autocomplete-custom-template\" md-dropdown-position=\"bottom\"><md-item-template>\n<span class=\"item-title\"><span>{{item.unit_name}}</span></span></md-item-template></md-autocomplete></td><td \nclass=\"name tbl text-center\"><md-button class=\"md-fab md-mini md-red-700-bg\" ng-click=\"vm.removeProduct(itm.prod_id)\" \nng-if=\"(itm.prod_remove==true)\"><md-icon md-font-icon=\"icon-close\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" aria-hidden=\"true\"></md-icon>\n</md-button></td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoRecipes()\" translate=\"NEWRECIPES.BACK_BTN\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"recipesForm.$invalid || recipesForm.$pristine\" \nng-click=\"vm.addNewRecipes()\" translate=\"NEWRECIPES.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/reportmenu/demo/accordion.html","<div class=\"accordion\"><ms-nav><ms-nav-item ms-nav-toggle><a ms-nav-button md-ink-ripple><i \nclass=\"icon-account-multiple s16\"></i> <span class=\"ms-nav-label\">Work Report</span></a></ms-nav-item><ms-nav-item \nms-nav-toggle><a ms-nav-button md-ink-ripple><i class=\"icon-apps s16\"></i> <span class=\"ms-nav-label\">Sales Report\n</span></a></ms-nav-item><ms-nav-item ms-nav-toggle><a ms-nav-button md-ink-ripple><i class=\"icon-currency-inr s16\">\n</i> <span class=\"ms-nav-label\">Price</span></a></ms-nav-item></ms-nav></div>");
$templateCache.put("app/main/apps/reportmenu/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/apps/reportmenu/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/reportmenu/demo/dine.html","<div id=\"dine\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><table class=\"simple\" \nms-responsive-table><thead></thead><tbody><tr><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-400-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2C</span></md-list-item></td></tr><tr><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-400-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2C</span></md-list-item></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/apps/roles/new_roles/new_roles.html","<div id=\"new_roles\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\" flex><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"rolesForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2>Roles Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nRole Name</label><input type=\"text\" name=\"roles_name\" ng-model=\"vm.roles.roles_name\" required><div \nng-messages=\"rolesForm.roles_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Role Name field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Status</label><md-select name=\"roles_status\" \nng-model=\"vm.roles.roles_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\" \nng-selected=\"op==vm.roles.roles_status\">{{op}}</md-option></md-select></md-input-container></div><div \nclass=\"available-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><md-checkbox \nmd-no-ink ng-model=\"vm.mainchk2\" class=\"md-accent\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-checked=\"(vm.mainchk2==1)\" ng-click=\"vm.selectAll2()\"></md-checkbox></div></th><th class=\"secondary-text\" \nshow-gt-sm><div class=\"table-header\"><span class=\"column-title\">Departments</span></div></th></tr></thead><tbody><tr \nng-repeat=\"dept in vm.departments\"><td align=\"center\"><md-checkbox md-no-ink ng-model=\"dept.chk\" class=\"md-accent\" \nng-checked=\"(dept.chk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox></td><td class=\"text-left\" \nshow-gt-sm><b>{{dept.department_name}}</b></td></tr></tbody></table></div><div \nclass=\"available-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><md-checkbox \nmd-no-ink ng-model=\"vm.mainchk\" class=\"md-accent\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-checked=\"(vm.mainchk==1)\" ng-click=\"vm.selectAll()\"></md-checkbox></div></th><th class=\"secondary-text\" show-gt-sm>\n<div class=\"table-header\"><span class=\"column-title\">Module Name</span></div></th></tr></thead><tbody><tr \nclass=\"md-grey-100-bg\"><td colspan=\"2\" class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\">Dashboard Modules</span></div></td></tr><tr \nng-repeat=\"module in vm.modulesList | filter:{module_type:\'Dashboard\'}\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"module.chk\" class=\"md-accent\" ng-checked=\"(module.chk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nng-click=\"vm.selectModules(module)\"></md-checkbox></td><td class=\"text-left\" show-gt-sm><b>{{module.module_name}}</b>\n</td></tr><tr class=\"md-grey-100-bg\"><td colspan=\"2\" class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\">Top Menu</span></div></td></tr><tr \nng-repeat=\"module in vm.modulesList | filter:{module_type:\'Top Menu\'}\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"module.chk\" class=\"md-accent\" ng-checked=\"(module.chk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">\n</md-checkbox></td><td class=\"text-left\" show-gt-sm><b>{{module.module_name}}</b></td></tr><tr class=\"md-grey-100-bg\">\n<td colspan=\"2\" class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Side Menu</span>\n</div></td></tr><tr ng-repeat=\"module in vm.modulesList | filter:{module_type:\'Side Menu\'}\"><td align=\"center\">\n<md-checkbox md-no-ink ng-model=\"module.chk\" class=\"md-accent\" ng-checked=\"(module.chk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\"></md-checkbox></td><td class=\"text-left\" show-gt-sm><b>{{module.module_name}}</b></td></tr><tr \nclass=\"md-grey-100-bg\"><td colspan=\"2\" class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\">Manage Modules</span></div></td></tr><tr \nng-repeat=\"module in vm.modulesList | filter:{module_type:\'Manage\'}\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"module.chk\" class=\"md-accent\" ng-checked=\"(module.chk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">\n</md-checkbox></td><td class=\"text-left\" show-gt-sm><b>{{module.module_name}}</b></td></tr><tr class=\"md-grey-100-bg\">\n<td colspan=\"2\" class=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">\nWarehouse Modules</span></div></td></tr><tr ng-repeat=\"module in vm.modulesList | filter:{module_type:\'Warehouse\'}\"><td\n align=\"center\"><md-checkbox md-no-ink ng-model=\"module.chk\" class=\"md-accent\" ng-checked=\"(module.chk==1)\" \nng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"></md-checkbox></td><td class=\"text-left\" show-gt-sm><b>{{module.module_name}}\n</b></td></tr><tr class=\"md-grey-100-bg\"><td colspan=\"2\" class=\"secondary-text\" show-gt-sm><div class=\"table-header\">\n<span class=\"column-title\">Reports Modules</span></div></td></tr><tr \nng-repeat=\"module in vm.modulesList | filter:{module_type:\'Reports\'}\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"module.chk\" class=\"md-accent\" ng-checked=\"(module.chk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\">\n</md-checkbox></td><td class=\"text-left\" show-gt-sm><b>{{module.module_name}}</b></td></tr></tbody></table></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoRoles()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"rolesForm.$invalid || rolesForm.$pristine\" ng-click=\"vm.saveRoles()\">Submit\n</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/roles/sidenavs/customer-sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list><md-subheader class=\"sub_header\">Navigation</md-subheader>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoDepartmentPage()\"><span>Departments</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoPriceTagPage()\"><span>Price Tags</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCustomerPage()\"><span>Customers</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoWaiterPage()\"><span>Waiters</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoStaffPage()\"><span>Staffs</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoSeatsPage()\"><span>Tables/Seats</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCategoryPage()\"><span>Categorys</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoItemPage()\"><span>Items</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoPricingPage()\"><span>Pricings</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoTaxPage()\"><span>Tax</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoSettingPage()\"><span>Settings</span></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/scategory/new_scategory/new_scategory.html","<div id=\"new_scategory\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"scategoryForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_SCATEGORY.TABLE_CATDTLS\">Table Category Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_SCATEGORY.CATNAME\">Category Name</label><input \ntype=\"text\" name=\"scategory_name\" ng-model=\"vm.scategory.scategory_name\" required><div \nng-messages=\"scategoryForm.scategory_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_SCATEGORY.ALERT_CATNAME\">Category Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_SCATEGORY.ORDER_INDEX\">Order Index</label><input \ntype=\"text\" name=\"scategory_order\" ng-model=\"vm.scategory.scategory_order\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_SCATEGORY.SELECT_DEPARTMENT\">\nSelect Department</label><md-select name=\"scategory_dept_id\" ng-model=\"vm.scategory.scategory_dept_id\" \nng-selected=\"m.scategory.scategory_dept_id==dept.department_id\"><md-option ng-repeat=\"dept in vm.deptList\" \nng-value=\"dept.department_id\">{{dept.department_name}}</md-option></md-select></md-input-container><md-input-container \nflex><label translate=\"NEW_SCATEGORY.STATUS\">Status</label><md-select name=\"scategory_status\" \nng-model=\"vm.scategory.scategory_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoScategory()\" translate=\"NEW_SCATEGORY.BACK_BTN\">\nBack</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"scategoryForm.$invalid || scategoryForm.$pristine\" ng-click=\"vm.saveScategory()\" \ntranslate=\"NEW_SCATEGORY.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/staff/new_staff/new_staff.html","<div id=\"new_staff\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"admission-content\" \nlayout=\"column\"><div class=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form \nname=\"staffForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\"><h2 translate=\"NEWSTAFF.SUPPLIERDET\">\nStaff Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"NEWSTAFF.NAME\">Staff Name</label><input type=\"text\" name=\"staff_name\" ng-model=\"vm.staff.staff_name\" \nrequired><div ng-messages=\"staffForm.staff_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEWSTAFF.ERRORS.NAME_REQUIRED\">Staff Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"NEWSTAFF.Designation\">Designation</label><input type=\"text\" \nname=\"staff_designation\" ng-model=\"vm.staff.staff_designation\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"NEWSTAFF.Email\">Email ID</label><input \ntype=\"text\" name=\"staff_email\" ng-model=\"vm.staff.staff_email\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"NEWSTAFF.Mobile\">Mobile No</label><input type=\"text\" name=\"staff_mobile\" \nng-model=\"vm.staff.staff_mobile\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n class=\"md-block\" flex><label translate=\"NEWSTAFF.Username\">Username</label><input type=\"text\" name=\"staff_username\" \nng-model=\"vm.staff.staff_username\" required><div ng-messages=\"staffForm.staff_username.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"NEWSTAFF.ERRORS.USERNAME_REQUIRED\">Username field is required.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"NEWSTAFF.Password\">Password\n</label><input type=\"password\" name=\"staff_password\" ng-model=\"vm.staff.staff_password\"></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEWSTAFF.Address\">Address</label><input \ntype=\"text\" name=\"staff_address\" ng-model=\"vm.staff.staff_address\"></md-input-container><md-input-container flex><label\n translate=\"NEWSTAFF.DOJ\">DOJ</label><md-datepicker name=\"date\" md-placeholder=\"Enter date\" \nng-model=\"vm.staff.staff_doj\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"NEWSTAFF.STATUS\">Status</label><md-select name=\"staff_status\" \nng-model=\"vm.staff.staff_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container><md-input-container flex></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoStaff()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"staffForm.$invalid || staffForm.$pristine\" ng-click=\"vm.saveStaff()\" translate=\"NEWSTAFF.SUBMIT\" \ntranslate-attr-aria-label=\"NEWSTAFF.SUBMIT\">Submit</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/apps/supplier/new_supplier/new_supplier.html","<div id=\"new_supplier\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\" flex><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"supplierForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_SUPPLIER.SUPPLIER_DTLS\">Supplier Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_SUPPLIER.SUPPLIER_NAME\">Supplier Name</label><input \ntype=\"text\" name=\"supplier_name\" ng-model=\"vm.supplier.supplier_name\" required><div \nng-messages=\"supplierForm.supplier_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_SUPPLIER.ALERT_SUPPLIER_NAME\">Supplier Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_SUPPLIER.MOBILENO\">Mobile No</label><input type=\"text\" \nname=\"supplier_mobileno\" ng-model=\"vm.supplier.supplier_mobileno\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"NEW_SUPPLIER.ADDRESS\">Address</label>\n<input type=\"text\" name=\"supplier_address\" ng-model=\"vm.supplier.supplier_address\"></md-input-container>\n<md-input-container flex><label translate=\"NEW_SUPPLIER.STATUS\">Status</label><md-select name=\"supplier_status\" \nng-model=\"vm.supplier.supplier_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoSupplier()\" translate=\"NEW_SUPPLIER.BACK_BTN\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"supplierForm.$invalid || supplierForm.$pristine\" ng-click=\"vm.saveSupplier()\" \ntranslate=\"NEW_SUPPLIER.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/supplier/sidenavs/customer-sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list><md-subheader class=\"sub_header\">Navigation</md-subheader>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoDepartmentPage()\"><span>Departments</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoPriceTagPage()\"><span>Price Tags</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCustomerPage()\"><span>Customers</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoWaiterPage()\"><span>Waiters</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoStaffPage()\"><span>Staffs</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoSeatsPage()\"><span>Tables/Seats</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCategoryPage()\"><span>Categorys</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoItemPage()\"><span>Items</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoPricingPage()\"><span>Pricings</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoTaxPage()\"><span>Tax</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoSettingPage()\"><span>Settings</span></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/seats/new_seats/new_seats.html","<div id=\"new_seats\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"seatsForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_SEATS.TABLE_DETAILS\">Table Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_SEATS.TABLE_NAME\">Table Name</label><input \ntype=\"text\" name=\"table_name\" ng-model=\"vm.seats.table_name\" required><div ng-messages=\"seatsForm.table_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"NEW_SEATS.ALERT_TBLENAME\">Table Name field is required.</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label translate=\"NEW_SEATS.ORDER_INDEX\">\nOrder Index</label><input type=\"text\" name=\"table_order\" ng-model=\"vm.seats.table_order\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_SEATS.CATEGORY\">Category</label>\n<md-select name=\"table_scategory_id\" ng-model=\"vm.seats.table_scategory_id\"><md-option \nng-repeat=\"op in vm.seatsDB.scategoryList\" ng-value=\"op.scategory_id\" \nng-selected=\"op.scategory_id==vm.seats.table_scategory_id\">{{op.scategory_name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"NEW_SEATS.STATUS\">Status</label><md-select \nname=\"table_status\" ng-model=\"vm.seats.table_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoSeats()\" translate=\"NEW_SEATS.BACK_BTN\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"seatsForm.$invalid || seatsForm.$pristine\" ng-click=\"vm.saveSeats()\" translate=\"NEW_SEATS.SUBMIT_BTN\">\nSubmit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/tax/mapping/printers_mapping.html","<div id=\"category\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div\n layout=\"column\" layout-align=\"center start\"></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\">\n<span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\" style=\"width:25%\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\" style=\"width:25%\">\n<div class=\"table-header\"><span class=\"column-title\">Product</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.printerMapItems\"><td align=\"left\"><md-select name=\"order_tag_dept_id\" \nng-model=\"itm.print_map_department_id\"><md-option ng-value=\"0\" ng-selected=\"itm.print_map_department_id==0\">*\n</md-option><md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.print_map_department_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_category_id\" ng-model=\"itm.print_map_category_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.print_map_category_id==0\">*</md-option><md-option ng-repeat=\"op in vm.categorys\" \nng-value=\"op.category_id\" ng-selected=\"itm.print_map_category_id==op.category_id\">{{op.category_name}}</md-option>\n</md-select></td><td align=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.print_map_item_id\"><md-option \nng-value=\"0\" ng-selected=\"itm.print_map_item_id==0\">*</md-option><md-option ng-repeat=\"op in vm.items\" \nng-value=\"op.item_id\" ng-selected=\"itm.print_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td \nalign=\"center\"><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.print_map_id)\">\n<span>Delete</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Printers\" ng-click=\"vm.gotoPrinters()\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" ng-click=\"vm.savePrintersItems()\">Submit</md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/tax/new_tax/new_tax.html","<div id=\"new_tax\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper style=\"padding:0px\"><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><form name=\"taxForm\" class=\"md-inline-form fst-frm\" novalidate><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div class=\"form-title\"><h2>\nTax Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Tax Name</label><input \ntype=\"text\" name=\"tax_name\" ng-model=\"vm.tax.tax_name\" required><div ng-messages=\"taxForm.tax_name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tax Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Type</label><md-select name=\"tax_type\" ng-model=\"vm.tax.tax_type\"><md-option \nng-repeat=\"op in vm.typelist\" ng-value=\"op\">{{op}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Tax Rate</label><input type=\"text\" name=\"tax_rate\" \nng-model=\"vm.tax.tax_rate\" required><div ng-messages=\"taxForm.tax_rate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Tax Rate field is required.</span></div></div></md-input-container><md-input-container flex><label>Status</label>\n<md-select name=\"tax_status\" ng-model=\"vm.tax.tax_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">\n{{op}}</md-option></md-select></md-input-container></div></div></div><div class=\"main scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\">\n<span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\" style=\"width:25%\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\" style=\"width:25%\">\n<div class=\"table-header\"><span class=\"column-title\">Product</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.taxMapItems\"><td align=\"left\"><md-select name=\"order_tag_dept_id\" \nng-model=\"itm.tax_map_department_id\"><md-option ng-value=\"0\" ng-selected=\"itm.tax_map_department_id==0\">*</md-option>\n<md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.tax_map_department_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_category_id\" ng-model=\"itm.tax_map_category_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.tax_map_category_id==0\">*</md-option><md-option ng-repeat=\"op in vm.categorys\" \nng-value=\"op.category_id\" ng-selected=\"itm.tax_map_category_id==op.category_id\">{{op.category_name}}</md-option>\n</md-select></td><td align=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.tax_map_item_id\"><md-option \nng-value=\"0\" ng-selected=\"itm.tax_map_item_id==0\">*</md-option><md-option ng-repeat=\"op in vm.items\" \nng-value=\"op.item_id\" ng-selected=\"itm.tax_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td \nalign=\"center\"><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.tax_map_id)\"><span>\nDelete</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Tax\" ng-click=\"vm.gotoTax()\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"taxForm.$invalid || taxForm.$pristine\" \nng-click=\"vm.saveTax()\">Submit</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/template/new-template/new-template.html","<div id=\"template\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll \nlayout=\"row\" layout-align=\"space-between\"><div class=\"content md-background-bg\" layout=\"column\" flex=\"70\" \nstyle=\"box-shadow: 5px 0px 10px rgba(0,0,0,0.10)\"><div class=\"admission-content\" layout=\"column\"><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"settingsForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\"><h2>Template Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Template Name</label><input type=\"text\" name=\"template_name\" \nng-model=\"vm.template.template_name\" required><div ng-messages=\"settingsForm.template_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Template Name field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Template Design</label><textarea \nname=\"template_name\" ng-model=\"vm.template.template_design\" rows=\"5\" md-select-on-focus></textarea>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" \nclass=\"md-raised btm-btn\" aria-label=\"Submit\" ng-click=\"vm.gotoTemplate()\">back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"settingsForm.$invalid || settingsForm.$pristine\" \nng-click=\"vm.saveTemplate()\">Submit</md-button></div></form></div></div></div></div><div class=\"\" flex=\"30\" \nlayout=\"column\"><div class=\"right-sidnav\"><h3>Company Tags :</h3><h6>Company Logo: <span>[COMPANY_LOGO]</span></h6><h6>\nCompany Name: <span>[COMPANY_NAME]</span></h6><h6>Company Address: <span>[COMPANY_ADDRESS]</span></h6><h6>Company GST: \n<span>[COMPANY_GST]</span></h6><h6>Company City: <span>[COMPANY_CITY]</span></h6><h6>Company Country: <span>\n[COMPANY_COUNTRY]</span></h6><h6>Company Mobile No 1: <span>[COMPANY_MOBILE1]</span></h6><h6>Company Mobile No 2: \n<span>[COMPANY_MOBILE2]</span></h6><br><h3>Bill Tags :</h3><h6>Bill No: <span>[BILL_NO]</span></h6><h6>Bill Dept.: \n<span>[BILL_DEPT]</span></h6><h6>Bill Dept. Type: <span>[BILL_TYPE]</span></h6><h6>Bill Date: <span>[BILL_DATE	]</span>\n</h6><h6>Bill Time: <span>[BILL_TIME]</span></h6><h6>Bill Order ID: <span>[BILL_ORDERID]</span></h6><h6>\nBill Kot No List: <span>[BILL_KOTNO_LIST]</span></h6><h6>Total Qty: <span>[BILL_TOTAL_QTY]</span></h6><h6>Total Items: \n<span>[ITEMS_COUNT]</span></h6><h6>Sub Total: <span>[BILL_TOTAL]</span></h6><h6>Tax: <span>[BILL_TAX]</span></h6><h6>\nExtras: <span>[BILL_EXTRA]</span></h6><h6>Discount: <span>[BILL_DISCOUNT]</span></h6><h6>Nett Total: <span>\n[BILL_NETT_TOTAL]</span></h6><h6>User Name: <span>[USER_NAME]</span></h6><h6>Waiter Name: <span>[WAITER_NAME]</span>\n</h6><h6>Customer Name: <span>[CUSTOMER_NAME]</span></h6><h6>Customer No: <span>[CUSTOMER_NO]</span></h6><h6>\nCustomer Name & No: <span>[CUSTOMER_DETS]</span></h6><h6>Customer Address: <span>[CUSTOMER_ADDRESS]</span></h6><h6>\nTicket Notes: <span>[BILL_NOTES]</span></h6><h6>Total Tax: <span>[BILL_TAX_TOTAL]</span></h6><h6>Round Of: <span>\n[BILL_ROUND]</span></h6><h6>Final Total: <span>[BILL_TOTAL_AMOUNT]</span></h6><br><h3>Bill Item Tags :</h3><h6>\nBill Item Name: <span>[ITEM_NAME]</span></h6><h6>Bill Item Qty: <span>[ITEM_QTY]</span></h6><h6>Bill Item Rate: <span>\n[ITEM_RATE]</span></h6><h6>Bill Total Amount: <span>[ITEM_AMOUNT]</span></h6><br><h3>Kot Tags :</h3><h6>Kot No: <span>\n[KOT_NO]</span></h6><h6>Kot Dept.: <span>[KOT_DEPT]</span></h6><h6>Kot Date: <span>[KOT_DATE]</span></h6><h6>Kot Time: \n<span>[KOT_TIME]</span></h6><h6>Kot Date & Time: <span>[KOT_DATETIME]</span></h6><h6>Kot Bill No: <span>[KOT_BILL_NO]\n</span></h6><h6>Kot Dept. Type: <span>[KOT_TYPE]</span></h6><h6>Kot Reference No: <span>[KOT_REFERENCE_NO]</span></h6>\n<h6>Kot Table No: <span>[KOT_TABLE_NO]</span></h6><h6>Kot Waiter Name: <span>[KOT_WAITER_NAME]</span></h6><h6>\nKot Order ID: <span>[KOT_ORDERID]</span></h6><br><h3>Kot Item Tags :</h3><h6>Kot Item Name: <span>[KOT_ITEM_NAME]\n</span></h6><h6>Kot Item Qty: <span>[KOT_ITEM_QTY]</span></h6><h6>Kot Item Rate: <span>[KOT_ITEM_RATE]</span></h6><h6>\nKot Total Amount: <span>[KOT_ITEM_AMOUNT]</span></h6><br><h3>Extra Tags :</h3><h6>Extra Name: <span>[EXTRA_NAME]</span>\n</h6><h6>Extra Amount: <span>[EXTRA_AMOUNT]</span></h6><br><h3>Tax Tags :</h3><h6>Tax Name: <span>[TAX_NAME]</span>\n</h6><h6>Tax Type: <span>[TAX_TYPE]</span></h6><h6>Tax Rate: <span>[TAX_PER]</span></h6><h6>Tax Amount: <span>[TAX_AMT]\n</span></h6></div></div></div></div>");
$templateCache.put("app/main/apps/transfer/new_transfer/new_transfer.html","<div id=\"new_transfer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div class=\"form-wrapper\" \nflex=\"100\"><form name=\"transferForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\"><h2 \ntranslate=\"NEWTRANSFER.TRANFER_TLT\">Transfer Details</h2></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" style=\"background:#00a931\"><div \nclass=\"h3 grey-50-fg\" translate=\"NEWTRANSFER.WAREHOUSE_TLT\">Warehouse Details</div></div><div class=\"p-16 ctmr-frm\">\n<div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\" translate=\"NEWTRANSFER.FROM_BRANCH\">From Branch :\n</label><md-select class=\"simplified select-class md-default-theme\" ng-model=\"vm.transfer.transfer_from_branch_id\" \nname=\"transfer_from_branch_id\" required><md-option ng-repeat=\"op in vm.branchList\" ng-value=\"op.branch_id\" \nng-selected=\"op.branch_id==vm.transfer.transfer_from_branch_id\">{{op.branch_name}}</md-option></md-select><div \nng-messages=\"transferForm.transfer_from_branch_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEWTRANSFER.ALERT_FRMBRNCH\">From Branch field is required.</span></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><label class=\"font-size-16\" translate=\"NEWTRANSFER.FRM_WAREHOUE\">From Warehouse :</label><md-select \nclass=\"simplified select-class md-default-theme\" ng-model=\"vm.transfer.transfer_from_warehouse_id\" \nname=\"transfer_from_warehouse_id\" required><md-option \nng-repeat=\"op in vm.warehouseList | filter:{warehouse_branch_id:vm.transfer.transfer_from_branch_id}:true\" \nng-value=\"op.warehouse_id\" ng-selected=\"op.warehouse_id==vm.transfer.transfer_from_warehouse_id\">{{op.warehouse_name}}\n</md-option></md-select></div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\" \ntranslate=\"NEWTRANSFER.TO_BRANCH\">To Branch :</label><md-select class=\"simplified select-class md-default-theme\" \nng-model=\"vm.transfer.transfer_to_branch_id\" name=\"transfer_to_branch_id\" required><md-option \nng-repeat=\"op in vm.branchList\" ng-value=\"op.branch_id\" ng-selected=\"op.branch_id==vm.transfer.transfer_to_branch_id\">\n{{op.branch_name}}</md-option></md-select></div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\" \ntranslate=\"NEWTRANSFER.TO_WAREHOUSE\">To Warehouse :</label><md-select class=\"simplified select-class md-default-theme\" \nng-model=\"vm.transfer.transfer_to_warehouse_id\" name=\"transfer_to_warehouse_id\" required><md-option \nng-repeat=\"op in vm.warehouseList | filter:{warehouse_branch_id:vm.transfer.transfer_to_branch_id}:true\" \nng-value=\"op.warehouse_id\" ng-selected=\"op.warehouse_id==vm.transfer.transfer_to_warehouse_id\">{{op.warehouse_name}}\n</md-option></md-select></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"background:#00a931\"><div class=\"h3 grey-50-fg\" \ntranslate=\"NEWTRANSFER.BILL_TLT\">Bill Details</div></div><div class=\"p-16 scnd-form\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><label class=\"font-size-16\"><span translate=\"NEWTRANSFER.BILL_NO\">Bill No</span>\n {{vm.transfer_fullno}}</label></div><div layout=\"row\" layout-gt-xs=\"row\" flex class=\"flex\"><label \ntranslate=\"NEWTRANSFER.BILL_DATE\" layout=\"row\" class=\"font-size-16\" style=\"width:auto;padding-top:9px\">Date :</label>\n<md-datepicker name=\"date\" md-placeholder=\"Enter date\" ng-model=\"vm.transfer.transfer_date\" style=\"margin:0px\">\n</md-datepicker></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div translate=\"NEWTRANSFER.ITEM_TLT\" \nclass=\"h3 text-bold\">Item Details</div></div><div class=\"p-5\"><table class=\"simple\" ms-responsive-table><thead><tr \nclass=\"md-blue-500-bg\"><th translate=\"NEWTRANSFER.TBL_SNO\" class=\"text-center\" \nstyle=\"max-width:40px;min-width:40px;padding-left:20px\">S.No</th><th translate=\"NEWTRANSFER.TBL_NAME\" \nclass=\"text-center\">Name</th><th translate=\"NEWTRANSFER.TBL_HANDQTY\" class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\">Hand Qty</th><th translate=\"NEWTRANSFER.TBL_UNIT\" class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\">Unit</th><th translate=\"NEWTRANSFER.TBL_QTY\" class=\"text-center\">Qty</th><th \ntranslate=\"NEWTRANSFER.TBL_ACTION\" class=\"text-center\" translate=\"NEWPURCHASE.ITEMACTION\">Action</th></tr></thead>\n<tbody ng-repeat=\"itm in vm.transferItems\"><tr><td class=\"name tbl text-center\" style=\"max-width:50px;min-width:50px\">\n{{$index+1}}</td><td class=\"name tbl text-center\"><input type=\"text\" layout=\"row\" name=\"prod_name\" \nng-model=\"itm.prod_name\" ng-keypress=\"vm.showitmlist(itm.sno)\"><ul style=\"list-style:none; float:left\" layout=\"column\" \nng-show=\"itm.prod_list==true\"><li layout=\"column\" \ndata-ng-repeat=\"prod in vm.productsList | filter:{itm_warehouse:vm.transfer.transfer_from_warehouse_id}:true | filter:itm.prod_name\" \nng-click=\"vm.setProdID(prod,itm.sno)\">{{prod.itm_name}} ({{prod.itm_type}})</li></ul></td><td \nclass=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_hqty}}</td><td \nclass=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_unit_name}}</td><td \nclass=\"name tbl text-center\"><input type=\"text\" name=\"prod_qty\" ng-model=\"itm.prod_qty\" \nng-change=\"vm.checkQty(itm.prod_id)\"></td><td class=\"name tbl text-center\"><md-button \nclass=\"md-fab md-mini md-red-700-bg\" ng-click=\"vm.removeProduct(itm.prod_id)\" ng-if=\"(itm.prod_remove==true)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"ng-scope md-default-theme md-font material-icons icon-close\" role=\"img\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody><thead><tr class=\"\"><th class=\"name text-center grey-50-fg\">\n</th><th class=\"name text-center grey-50-fg\"></th><th class=\"name text-center grey-50-fg\"></th><th \nclass=\"name text-center grey-50-fg\"></th><th class=\"name text-center grey-50-fg\">{{vm.transfer.transfer_total_qty}}\n</th><th class=\"name text-center grey-50-fg\"></th></tr></thead></table></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button translate=\"NEWTRANSFER.TBL_BACKBTN\" class=\"md-raised btm-btn\" \naria-label=\"Go to Staffs\" ng-click=\"vm.gotoTransfer()\">Back</md-button><md-button translate=\"NEWTRANSFER.TBL_SAVEBTN\" \ntype=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"transferForm.$invalid || transferForm.$pristine\" ng-click=\"vm.addNewTransfer()\">Submit</md-button></div>\n</form></div></div></div></div></div>");
$templateCache.put("app/main/apps/tickets/items/items_list.html","<div id=\"category\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div\n layout=\"column\" layout-align=\"center start\"></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span \nclass=\"column-title\"><md-checkbox md-no-ink ng-model=\"vm.mainChk\" ng-checked=\"(vm.mainChk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\" class=\"md-accent\" ng-click=\"vm.selectAll()\"></md-checkbox></span></div></th><th \nclass=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Item Name</span></div></th><th \nclass=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Order Index</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"cat in vm.items\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"cat.selectedchk\" ng-checked=\"(cat.selectedchk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nclass=\"md-accent\"></md-checkbox></td><td align=\"left\" show-gt-sm><b>{{cat.item_name}}</b></td><td align=\"center\"><input\n type=\"text\" name=\"order\" ng-model=\"cat.order\"></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Categorys\" \nng-click=\"vm.gotoCategorys()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" ng-click=\"vm.saveCatItems()\">Submit</md-button></div>\n</div></div>");
$templateCache.put("app/main/apps/transferin/new_transferin/new_transferin.html","<div id=\"new_transfer\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div class=\"form-wrapper\" \nflex=\"100\"><form name=\"transferForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\"><h2>Transfer In Details\n</h2></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"background:#00a931\"><div class=\"h3 grey-50-fg\">Warehouse Details</div></div>\n<div class=\"p-16 ctmr-frm\"><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">From Branch :</label><b \nng-repeat=\"op in vm.branchList| filter:{branch_id:vm.transfer.transfer_from_branch_id}\">{{op.branch_name}}</b></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">From Warehouse :</label><b \nng-repeat=\"op in vm.warehouseList| filter:{warehouse_id:vm.transfer.transfer_from_warehouse_id}\">{{op.warehouse_name}}\n</b></div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">To Branch :</label><b \nng-repeat=\"op in vm.warehouseList| filter:{warehouse_id:vm.transfer.transfer_to_branch_id}\">{{op.warehouse_name}}</b>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">To Warehouse :</label><b \nng-repeat=\"op in vm.warehouseList| filter:{warehouse_id:vm.transfer.transfer_to_warehouse_id}\">{{op.warehouse_name}}\n</b></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background:#00a931\"><div class=\"h3 grey-50-fg\">Bill Details</div></div><div class=\"p-16 scnd-form\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\"><span>Bill No</span> : {{vm.transfer_fullno}}</label>\n</div><div layout=\"row\" layout-gt-xs=\"row\" flex class=\"flex\"><label layout=\"row\" class=\"font-size-16\" \nstyle=\"width:auto;padding-top:9px\">Date : {{vm.transfer.transfer_date}}</label></div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 text-bold\">Item Details</div></div><div class=\"p-5\"><table \nclass=\"simple\" ms-responsive-table><thead><tr class=\"md-blue-500-bg\"><th class=\"text-center\" \nstyle=\"max-width:40px;min-width:40px;padding-left:20px\">S.No</th><th class=\"text-center\">Name</th><th \nclass=\"text-center\" style=\"max-width:150px;min-width:150px\">Sent Qty</th><th class=\"text-center\" \nstyle=\"max-width:150px;min-width:150px\">Unit</th><th class=\"text-center\">Received Qty</th><th class=\"text-center\">\nMissing Qty</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.transferItems\" height=\"30\"><td \nclass=\"name tbl text-center\" style=\"max-width:50px;min-width:50px\">{{$index+1}}</td><td class=\"name tbl text-center\">\n{{itm.prod_name}}</td><td class=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_qty}}</td><td\n class=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_unit_name}}</td><td \nclass=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_receqty}}</td><td \nclass=\"name tbl text-center\"><input type=\"text\" name=\"prod_missqty\" ng-model=\"itm.prod_missqty\" \nng-change=\"vm.checkQty(itm.prod_id)\"></td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Goto TransferIn\" \nng-click=\"vm.gotoTransferin()\">Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" \naria-label=\"Submit\" ng-disabled=\"transferForm.$invalid || transferForm.$pristine\" ng-click=\"vm.addNewTransferin()\">\nReceived</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/transferin/new_transferin/new_transferin_old.html","<div id=\"new_transfer\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"admission-content\" \nlayout=\"column\"><div class=\"main scrollable\" ms-scroll><div class=\"form-wrapper\" flex=\"100\"><form name=\"transferForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\"><h2>Transfer In Details</h2></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-16 border-bottom md-blue-500-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">Warehouse Details</div></div><div class=\"p-16 ctmr-frm\"><div layout=\"column\" layout-gt-xs=\"row\"><label \nclass=\"font-size-16\">From Branch : <b \nng-repeat=\"op in vm.branchList| filter:{branch_id:vm.transfer.transfer_from_branch_id}\">{{op.branch_name}}</b></label>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">From Warehouse : <b \nng-repeat=\"op in vm.warehouseList| filter:{warehouse_id:vm.transfer.transfer_from_warehouse_id}\">{{op.warehouse_name}}\n</b></label></div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">To Branch : <b \nng-repeat=\"op in vm.warehouseList| filter:{warehouse_id:vm.transfer.transfer_to_branch_id}\">{{op.warehouse_name}}</b>\n</label></div><div layout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\">To Warehouse : <b \nng-repeat=\"op in vm.warehouseList| filter:{warehouse_id:vm.transfer.transfer_to_warehouse_id}\">{{op.warehouse_name}}\n</b></label></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-16 border-bottom md-blue-500-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Bill Details</div></div><div class=\"p-16 scnd-form\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><label class=\"font-size-16\"><span>Bill No</span> : {{vm.transfer_fullno}}</label>\n</div><div layout=\"row\" layout-gt-xs=\"row\" flex class=\"flex\"><label layout=\"row\" class=\"font-size-16\">\nDate : {{vm.transfer.transfer_date}}</label></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 text-bold\">Item Details</div></div><div class=\"p-5\"><table class=\"simple\" ms-responsive-table><thead><tr \nclass=\"md-blue-500-bg\"><th class=\"text-center\" style=\"max-width:40px;min-width:40px;padding-left:20px\">S.No</th><th \nclass=\"text-center\">Name</th><th class=\"text-center\" style=\"max-width:150px;min-width:150px\">Sent Qty</th><th \nclass=\"text-center\" style=\"max-width:150px;min-width:150px\">Unit</th><th class=\"text-center\">Received Qty</th><th \nclass=\"text-center\">Missing Qty</th></tr></thead><tbody ng-repeat=\"itm in vm.transferItems\"><tr><td \nclass=\"name tbl text-center\" style=\"max-width:50px;min-width:50px\">{{$index+1}}</td><td class=\"name tbl text-center\">\n{{itm.prod_name}}</td><td class=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_qty}}</td><td\n class=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_unit_name}}</td><td \nclass=\"name tbl text-center\" style=\"max-width:150px;min-width:150px\">{{itm.prod_receqty}}</td><td \nclass=\"name tbl text-center\"><input type=\"text\" name=\"prod_missqty\" ng-model=\"itm.prod_missqty\" \nng-change=\"vm.checkQty(itm.prod_id)\"></td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-blue-500-bg grey-50-fg\" \naria-label=\"Go to Staffs\" ng-click=\"vm.gotoTransferin()\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"transferForm.$invalid \" ng-click=\"vm.addNewTransferin()\">\nReceived</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/apps/units/new_units/new_units.html","<div id=\"new_units\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"unitsForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2>Unit Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nUnit Name</label><input type=\"text\" name=\"unit_name\" ng-model=\"vm.units.unit_name\" required><div \nng-messages=\"unitsForm.unit_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Unit Name field is required.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoUnits()\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" ng-disabled=\"unitsForm.$invalid || unitsForm.$pristine\" \nng-click=\"vm.saveUnits()\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/user/new_user/new_user.html","<div id=\"new_user\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\" flex><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"userForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2>User Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nName</label><input type=\"text\" name=\"usr_name\" ng-model=\"vm.user.usr_name\" required><div \nng-messages=\"userForm.usr_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Type</label><md-select name=\"usr_type\" \nng-model=\"vm.user.usr_type\" required><md-option ng-repeat=\"op in vm.type\" ng-value=\"op.roles_id\">{{op.roles_name}}\n</md-option></md-select><div ng-messages=\"userForm.usr_type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nType field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label>Username</label><input type=\"text\" name=\"usr_uname\" \nng-model=\"vm.user.usr_uname\" required><div ng-messages=\"userForm.usr_uname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Username field is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Password</label><input type=\"password\" name=\"usr_password\" \nng-model=\"vm.user.usr_password\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><label>Status</label><md-select name=\"usr_status\" ng-model=\"vm.user.usr_status\"><md-option \nng-repeat=\"op in vm.statuslist\" ng-value=\"op\" ng-selected=\"op==vm.user.usr_status\">{{op}}</md-option></md-select>\n</md-input-container><md-input-container flex></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoUser()\">\nBack</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"userForm.$invalid || userForm.$pristine\" ng-click=\"vm.saveUser()\">Submit</md-button></div></form></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/user/sidenavs/customer-sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list><md-subheader class=\"sub_header\">Navigation</md-subheader>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoDepartmentPage()\"><span>Departments</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoPriceTagPage()\"><span>Price Tags</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCustomerPage()\"><span>Customers</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoWaiterPage()\"><span>Waiters</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoStaffPage()\"><span>Staffs</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoSeatsPage()\"><span>Tables/Seats</span>\n</md-list-item><md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoCategoryPage()\"><span>Categorys</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoItemPage()\"><span>Items</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoPricingPage()\"><span>Pricings</span></md-list-item><md-list-item class=\"cntr-btn md-background\" \nlayout=\"row\" layout-align=\"center center\" md-ink-ripple ng-click=\"vm.gotoTaxPage()\"><span>Tax</span></md-list-item>\n<md-list-item class=\"cntr-btn md-background\" layout=\"row\" layout-align=\"center center\" md-ink-ripple \nng-click=\"vm.gotoSettingPage()\"><span>Settings</span></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/waiter/new_waiter/new_waiter.html","<div id=\"new_waiter\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"waiterForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"NEW_WAITER.WAITER_DETAILS\">Waiter Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEW_WAITER.WAITER_NAME\">Waiter Name</label><input \ntype=\"text\" name=\"waiter_name\" ng-model=\"vm.waiter.waiter_name\" required><div \nng-messages=\"waiterForm.waiter_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"NEW_WAITER.ALERT_WAITER_NAME\">Waiter Name field is required.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_WAITER.PIN\">Pin</label><input type=\"text\" \nname=\"waiter_pin\" ng-model=\"vm.waiter.waiter_pin\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"NEW_WAITER.MOBILENO\">Mobile No</label><input type=\"text\" \nname=\"waiter_mobileno\" ng-model=\"vm.waiter.waiter_mobileno\"></md-input-container><md-input-container class=\"md-block\" \nflex><label translate=\"NEW_WAITER.ADDRESS\">Address</label><input type=\"text\" name=\"waiter_address\" \nng-model=\"vm.waiter.waiter_address\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"NEW_WAITER.TYPE\">Type</label><md-select name=\"waiter_type\" \nng-model=\"vm.waiter.waiter_type\"><md-option ng-repeat=\"type in vm.typelist\" ng-value=\"type\">{{type}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"NEW_WAITER.STATUS\">Status</label><md-select\n name=\"waiter_status\" ng-model=\"vm.waiter.waiter_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">\n{{op}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" ng-click=\"vm.gotoWaiter()\" translate=\"NEW_WAITER.BACK_BTN\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"waiterForm.$invalid || waiterForm.$pristine\" ng-click=\"vm.saveWaiter()\" translate=\"NEW_WAITER.SUBMIT_BTN\">\nSubmit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/waiter/tables/tables_list.html","<div id=\"waiter-item\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\">\n<div layout=\"column\" layout-align=\"center start\"></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"waiter-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\"><span \nclass=\"column-title\"><md-checkbox md-no-ink ng-model=\"vm.mainChk\" ng-checked=\"(vm.mainChk==1)\" ng-true-value=\"\'1\'\" \nng-false-value=\"\'0\'\" class=\"md-accent\" ng-click=\"vm.selectAll()\"></md-checkbox></span></div></th><th \nclass=\"secondary-text\" show-gt-sm><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TABLE_WAITER.TABLE_NAME\">Table Name</span></div></th></tr></thead><tbody><tr \nng-repeat=\"cat in vm.tables | orderBy:[\'selectedchk\']\" height=\"50\"><td align=\"center\"><md-checkbox md-no-ink \nng-model=\"cat.selectedchk\" ng-checked=\"(cat.selectedchk==1)\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" \nclass=\"md-accent\"></md-checkbox></td><td align=\"left\" show-gt-sm><b>{{cat.scategory_name}} - {{cat.table_name}}</b>\n</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" \naria-label=\"Go to Waiters\" ng-click=\"vm.gotoWaiters()\" translate=\"TABLE_WAITER.BACK_BTN\">Back</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"waiterForm.$invalid || waiterForm.$pristine\" ng-click=\"vm.saveWaiterTables()\" \ntranslate=\"TABLE_WAITER.SUBMIT_BTN\">Submit</md-button></div></div></div>");
$templateCache.put("app/main/apps/warehouse/new_warehouse/new_warehouse.html","<div id=\"new_warehouse\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/warehousemenu/warehousemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"warehouseForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\"><h2 translate=\"WAREHOUSE.INPG_DTLSTLT\">Warehouse Details</h2></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"WAREHOUSE.INPG_WNAME\">Warehouse Name</label><input \ntype=\"text\" name=\"warehouse_name\" ng-model=\"vm.warehouse.warehouse_name\" required><div \nng-messages=\"warehouseForm.warehouse_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"WAREHOUSE.ALERT_WNAME\">Warehouse Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"WAREHOUSE.INPG_BRANCH\">Branch</label><md-select name=\"warehouse_branch_id\" \nng-model=\"vm.warehouse.warehouse_branch_id\"><md-option ng-repeat=\"op in vm.branchList\" ng-value=\"op.branch_id\">\n{{op.branch_name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"WAREHOUSE.INPG_STAUTS\">Status</label><md-select name=\"warehouse_status\" \nng-model=\"vm.warehouse.warehouse_status\"><md-option ng-repeat=\"op in vm.statuslist\" ng-value=\"op\">{{op}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex></md-input-container></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" aria-label=\"Go to Staffs\" \nng-click=\"vm.gotoWarehouse()\" translate=\"WAREHOUSE.INPG_BACKBTN\">Back</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"warehouseForm.$invalid || warehouseForm.$pristine\" ng-click=\"vm.saveWarehouse()\" \ntranslate=\"WAREHOUSE.INPG_SAVEBTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/work-report/menu/accordion.html","<div class=\"accordion\"><ms-nav><ms-nav-item ms-nav-toggle><a ms-nav-button md-ink-ripple><i \nclass=\"icon-account-multiple s16\"></i> <span class=\"ms-nav-label\">Master</span> <i \nclass=\"icon-chevron-right s16 arrow\"></i></a><ms-nav-toggle-items><ms-nav-item><a ms-nav-button \nui-sref=\"app.department\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Department</span></a>\n</ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.price-tag\" ui-sref-active=\"active\" md-ink-ripple><span \nclass=\"ms-nav-label\">Price Tags</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.customer\" \nui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Customers</span></a></ms-nav-item><ms-nav-item><a \nms-nav-button ui-sref=\"app.waiter\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Waiters</span></a>\n</ms-nav-item></ms-nav-toggle-items></ms-nav-item><ms-nav-item ms-nav-toggle><a ms-nav-button md-ink-ripple><i \nclass=\"icon-apps s16\"></i> <span class=\"ms-nav-label\">Dining</span> <i class=\"icon-chevron-right s16 arrow\"></i></a>\n<ms-nav-toggle-items><ms-nav-item><a ms-nav-button ui-sref=\"app.dashboard-v1\" ui-sref-active=\"active\" md-ink-ripple>\n<span class=\"ms-nav-label\">Tables Categories</span></a></ms-nav-item><ms-nav-item><a ms-nav-button \nui-sref=\"app.dashboard-v2\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Categories</span></a>\n</ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.dashboard-v2\" ui-sref-active=\"active\" md-ink-ripple><span \nclass=\"ms-nav-label\">Items</span></a></ms-nav-item></ms-nav-toggle-items></ms-nav-item><ms-nav-item ms-nav-toggle><a \nms-nav-button md-ink-ripple><i class=\"icon-currency-inr s16\"></i> <span class=\"ms-nav-label\">Price</span> <i \nclass=\"icon-chevron-right s16 arrow\"></i></a><ms-nav-toggle-items><ms-nav-item><a ms-nav-button \nui-sref=\"app.dashboard-v1\" ui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Pricing</span></a>\n</ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.dashboard-v2\" ui-sref-active=\"active\" md-ink-ripple><span \nclass=\"ms-nav-label\">Pricing Tag</span></a></ms-nav-item><ms-nav-item><a ms-nav-button ui-sref=\"app.dashboard-v2\" \nui-sref-active=\"active\" md-ink-ripple><span class=\"ms-nav-label\">Order Tag</span></a></ms-nav-item>\n</ms-nav-toggle-items></ms-nav-item></ms-nav></div>");
$templateCache.put("app/main/apps/work-report/menu/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/apps/work-report/menu/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/work-report/menu/dine.html","<div id=\"dine\" class=\"page-layout simple fullwidth\"><div class=\"center\" layout=\"row\" flex><table class=\"simple\" \nms-responsive-table><thead></thead><tbody><tr><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-400-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2C</span></md-list-item></td></tr><tr><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-50-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T1B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-grey-400-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2A</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2B</span></md-list-item></td><td style=\"text-align:center !important\" class=\"\"><md-list-item \nclass=\"crd md-background md-yellow-700-bg grey-900-fg\" md-ink-ripple ng-click=\"vm.openContactDialog($event, contact)\">\n<span>T2C</span></md-list-item></td></tr></tbody></table></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/printerjobs/new_printerjobs/new_printerjobs.html","<div id=\"new_printerjobs\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper style=\"padding:0px\"><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><form name=\"printerjobsForm\" class=\"md-inline-form fst-frm\" novalidate><div \nclass=\"main scrollable\" ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><div class=\"form-title\"><h2>\nPrinter Job Details</h2></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Job Name</label>\n<input type=\"text\" name=\"printerjobs_name\" ng-model=\"vm.printerjobs.printerjobs_name\" required><div \nng-messages=\"printerjobsForm.printerjobs_name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nJob Name field is required.</span></div></div></md-input-container><md-input-container flex><label>Type</label>\n<md-select name=\"printerjobs_type\" ng-model=\"vm.printerjobs.printerjobs_type\"><md-option ng-repeat=\"op in vm.typelist\" \nng-value=\"op\">{{op}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Printer</label><md-select name=\"printerjobs_printers_id\" \nng-model=\"vm.printerjobs.printerjobs_printers_id\"><md-option ng-repeat=\"op in vm.printersDB.printersList\" \nng-value=\"op.printers_id\" ng-selected=\"op.printers_id==vm.printerjobs.printerjobs_printers_id\">{{op.printers_name}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Printing Template</label><md-select \nname=\"printerjobs_template\" ng-model=\"vm.printerjobs.printerjobs_template\"><md-option \nng-repeat=\"op in vm.templateList\" ng-value=\"op.template_id\">{{op.template_name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-checkbox \nng-model=\"vm.printerjobs.printerjobs_local_printer\" ng-checked=\"vm.printerjobs.printerjobs_local_printer==1\" \nng-true-value=\"1\" ng-false-value=\"0\" style=\"display:flex;align-items:center\" flex>Use Local Printer First</md-checkbox>\n<div layout=\"row\" layout-align=\"space-between\" flex><md-input-container ng-if=\"vm.showLink==1\" style=\"width:100%\">\n<label>KDS Link</label><input type=\"text\" name=\"printerjobs_kdslink\" ng-model=\"vm.printerjobs.printerjobs_kdslink\">\n</md-input-container></div></div></div></div><div class=\"main scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\">\n<span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\" style=\"width:25%\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\" style=\"width:25%\">\n<div class=\"table-header\"><span class=\"column-title\">Product</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.printerMapItems\"><td align=\"left\"><md-select name=\"order_tag_dept_id\" \nng-model=\"itm.print_map_department_id\"><md-option ng-value=\"0\" ng-selected=\"itm.print_map_department_id==0\">*\n</md-option><md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.print_map_department_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_category_id\" ng-model=\"itm.print_map_category_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.print_map_category_id==0\">*</md-option><md-option ng-repeat=\"op in vm.categorys\" \nng-value=\"op.category_id\" ng-selected=\"itm.print_map_category_id==op.category_id\">{{op.category_name}}</md-option>\n</md-select></td><td align=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.print_map_item_id\"><md-option \nng-value=\"0\" ng-selected=\"itm.print_map_item_id==0\">*</md-option><md-option \nng-repeat=\"op in vm.items | filter:{catitm_category_id:itm.print_map_category_id}:true\" ng-value=\"op.item_id\" \nng-selected=\"itm.print_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td align=\"center\">\n<md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span></md-button>\n<md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.print_map_id)\"><span>Delete\n</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised btm-btn\" aria-label=\"Go to Printerjobs\" ng-click=\"vm.gotoPrinterjobs()\">Back</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"printerjobsForm.$invalid || printerjobsForm.$pristine\" ng-click=\"vm.savePrinterjobs()\">Submit</md-button>\n</div></div></form></div></div></div>");
$templateCache.put("app/main/apps/printerjobs/mapping/printers_mapping.html","<div id=\"category\" class=\"page-layout simple fullwidth\"><div class=\"row\" layout=\"row\" layout-align=\"space-between\"><div\n layout=\"column\" layout-align=\"center start\"></div></div><div class=\"list-content scrollable\" ms-scroll><div \nclass=\"category-table-wrapper md-background-bg md-whiteframe-1dp\"><table class=\"simple\" ms-responsive-table><thead \nclass=\"md-accent-bg\"><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\" style=\"width:25%\"><div class=\"table-header\">\n<span class=\"column-title\">Department</span></div></th><th class=\"secondary-text\" style=\"width:25%\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\" style=\"width:25%\">\n<div class=\"table-header\"><span class=\"column-title\">Product</span></div></th><th class=\"secondary-text\" \nstyle=\"width:25%\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"itm in vm.printerMapItems\"><td align=\"left\"><md-select name=\"order_tag_dept_id\" \nng-model=\"itm.print_map_department_id\"><md-option ng-value=\"0\" ng-selected=\"itm.print_map_department_id==0\">*\n</md-option><md-option ng-repeat=\"op in vm.depts\" ng-value=\"op.department_id\" \nng-selected=\"itm.print_map_department_id==op.department_id\">{{op.department_name}}</md-option></md-select></td><td \nalign=\"left\"><md-select name=\"order_tag_category_id\" ng-model=\"itm.print_map_category_id\"><md-option ng-value=\"0\" \nng-selected=\"itm.print_map_category_id==0\">*</md-option><md-option ng-repeat=\"op in vm.categorys\" \nng-value=\"op.category_id\" ng-selected=\"itm.print_map_category_id==op.category_id\">{{op.category_name}}</md-option>\n</md-select></td><td align=\"left\"><md-select name=\"order_tag_item_id\" ng-model=\"itm.print_map_item_id\"><md-option \nng-value=\"0\" ng-selected=\"itm.print_map_item_id==0\">*</md-option><md-option ng-repeat=\"op in vm.items\" \nng-value=\"op.item_id\" ng-selected=\"itm.print_map_item_id==op.item_id\">{{op.item_name}}</md-option></md-select></td><td \nalign=\"center\"><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.addRow()\"><span>Add</span>\n</md-button><md-button class=\"new-btn md-raised md-background indigo-fg\" ng-click=\"vm.deleteRow(itm.print_map_id)\">\n<span>Delete</span></md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-blue-500-bg grey-50-fg\" aria-label=\"Go to Printers\" ng-click=\"vm.gotoPrinters()\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" ng-click=\"vm.savePrintersItems()\">Submit</md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/ordertagoption/new_ordertagoption/new_ordertagoption.html","<div id=\"new_ordertagoption\" class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/managemenu/managemenu.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"admission-content\" layout=\"column\"><div class=\"main scrollable\" ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"ordertagoptionForm\" class=\"md-inline-form\" novalidate>\n<div class=\"form-title\"><h2 translate=\"NEWORDERTAG_OPTION.ORDERTAG_DTLS\">Order Tag Option Details</h2></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"NEWORDERTAG_OPTION.OPTION_NAME\">\nOption Name</label><input type=\"text\" name=\"ordertagoption_name\" ng-model=\"vm.ordertagoption.ordertagoption_name\" \nrequired><div ng-messages=\"ordertagoptionForm.ordertagoption_name.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"NEWORDERTAG_OPTION.ALERT_OPTION_NAME\">Option Name field is required.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"NEWORDERTAG_OPTION.OPTION_RATE\">\nOption Rate</label><input type=\"text\" name=\"ordertagoption_rate\" ng-model=\"vm.ordertagoption.ordertagoption_rate\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised btm-btn\" \naria-label=\"Go to Ordertagoptions\" ng-click=\"vm.gotoOrdertagoptions()\" translate=\"NEWORDERTAG_OPTION.BACK_BTN\">Back\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent btm-btn\" aria-label=\"Submit\" \nng-disabled=\"ordertagoptionForm.$invalid || ordertagoptionForm.$pristine\" ng-click=\"vm.saveOrdertagoptions()\" \ntranslate=\"NEWORDERTAG_OPTION.SUBMIT_BTN\">Submit</md-button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/dining/dialog/tender-dialog/tender-dialog.html","<md-dialog class=\"tender-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"top-bar\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Select Tender</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CLASSES.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"tender-btn-bx\" layout=\"row\" layout-wrap><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button><md-button \nclass=\"tender-btn md-raised md-background grey-50-fg\" ng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\">\n<span>Change Tender</span></md-button><md-button class=\"tender-btn md-raised md-background grey-50-fg\" \nng-click=\"vm.closeBillasOnline()\" style=\"background:#04738C\"><span>Change Tender</span></md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/login/dialogs/notification/notification-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"\" layout=\"column\" style=\"background:#00A931\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"list\" \nng-repeat=\"alert in vm.alertList\" ng-click=\"vm.gotoKot(alert)\"><div layout=\"row\" layout-align=\"space-between center\">\n<h4>#{{alert.customerkot_no}}</h4><span class=\"department\">{{alert.department_name}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><h5>{{alert.customer_name}} ({{alert.customer_mobileno}})</h5><span class=\"time\">\n{{alert.customerkot_date}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><h6>Table No: <span \nstyle=\"color:#34a353;font-weight:500\">{{alert.table_name}}</span></h6><span class=\"price\" \nng-if=\"alert.customerkot_type==\'Order\'\">{{alert.totalQty}} Qty : <span style=\"color:#34a353;font-weight:500\">\n₹ {{alert.totalTotal | number: vm.c_d}}</span></span> <span class=\"price\" ng-if=\"alert.customerkot_type==\'Billing\'\">\n<span style=\"color:#34a353;font-weight:500\">{{alert.customerkot_type}}</span></span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" \nclass=\"sve-btn\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/toolbar-inner/dialogs/printer-settings/printer-settings-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"\" layout=\"column\" style=\"background:#00A931\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-no-float md-block\"><label>Printer IP</label><input \nname=\"printerIP\" ng-model=\"vm.printerIP\" type=\"text\" ng-required md-autofocus></md-input-container><md-input-container \nclass=\"md-no-float md-block\" ng-if=\"vm.showLab==1\"><label class=\"alert\">Printer Auth Code Generated</label>\n</md-input-container><md-input-container class=\"md-no-float md-block\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.printerStatus==0\" style=\"color:red;margin:0px\"></md-icon>\n<md-icon md-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"vm.printerStatus==1\" style=\"color:#00A931;margin:0px\">\n</md-icon><md-button type=\"submit\" ng-click=\"vm.initWebPrinter()\" class=\"sve-btn\">Check Printer</md-button></div>\n</md-input-container><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-no-float md-block\">\n<label>Local Printer</label><input name=\"localPrinter\" ng-model=\"vm.localPrinter\" type=\"text\" md-autofocus>\n</md-input-container><md-button type=\"submit\" ng-click=\"vm.testPrinter()\" class=\"sve-btn\">Test Printing</md-button>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveInfo(\'contactForm\')\" class=\"sve-btn\">SAVE\n</md-button><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" class=\"sve-btn\">Close</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/toolbar-inner/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/toolbar-inner/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/toolbar-inner/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\" style=\"\"><div layout=\"row\" layout-align=\"start center\"><md-button\n id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><img md-menu-align-target class=\"ml-20 mr-10\" \nsrc=\"assets/img/icon.png\"> <span class=\"ml-1 mr-10\" style=\"font-size:22px; color:#00A931; font-weight:600\" \nng-bind=\"pageTitle+\'\'\"></span></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent mr-10 pr-10\" md-diameter=\"32\">\n</md-progress-circular><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"dept in vm.departmentList\" \nng-if=\"dept.show==1\"><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"language-button\" \nng-click=\"vm.setDepartment(dept)\" aria-label=\"{{dept.department_name}}\" ng-if=\"vm.deptID!=dept.department_id\" \nng-disabled=\"vm.show==0 || KOTItmCount>0\"><h3>{{dept.department_name}}</h3></md-button><div class=\"toolbar-separator\">\n</div><md-button id=\"quick-panel-toggle\" class=\"language-button tool-active\" ng-click=\"vm.setDepartment(dept)\" \naria-label=\"{{dept.department_name}}\" ng-if=\"vm.deptID==dept.department_id\" ng-disabled=\"vm.show==0 || KOTItmCount>0\">\n<h3>{{dept.department_name}}</h3></md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.role==\'Super Admin\'\"><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"language-button\" ui-sref=\"app.dashboard\" aria-label=\"Logout\"><h3 translate=\"TOOLBAR.NAVLINK_HOME\">Home</h3>\n</md-button><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"language-button tool-active\" ng-click=\"vm.logout()\" aria-label=\"Logout\"><h3 translate=\"TOOLBAR.NAVLINK_LOGOUT\">\nLogout</h3></md-button></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.billsBlock==0\"><div \nclass=\"toolbar-separator\" ng-if=\"vm.deptID!=\'bills\'\"></div><md-button id=\"quick-panel-toggle\" class=\"language-button\" \nng-click=\"vm.gotoBills()\" aria-label=\"Main Menu\" ng-if=\"vm.deptID!=\'bills\'\" ng-disabled=\"KOTItmCount>0\"><h3 \ntranslate=\"TOOLBAR.NAVLINK_BILL\">Bills</h3></md-button><div class=\"toolbar-separator\" ng-if=\"vm.deptID==\'bills\'\"></div>\n<md-button id=\"quick-panel-toggle\" class=\"language-button tool-active\" ng-click=\"vm.gotoBills()\" \naria-label=\"Main Menu\" ng-if=\"vm.deptID==\'bills\'\" ng-disabled=\"KOTItmCount>0\"><h3 translate=\"TOOLBAR.NAVLINK_BILL\">\nBills</h3></md-button></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.role!=\'Super Admin\'\"><div \nclass=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"language-button tool-active\" \nng-click=\"vm.gotoHome()\" aria-label=\"Main Menu\" ng-if=\"vm.main==1\" ng-disabled=\"KOTItmCount>0\"><h4><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon s24\" style=\"height:27px!important\" hide-xs></md-icon><b \nstyle=\"text-transform:capitalize\" translate=\"TOOLBAR.NAVLINK_MAINMENU\">Main Menu</b></h4></md-button><md-button \nid=\"quick-panel-toggle\" class=\"language-button\" ng-click=\"vm.gotoHome()\" aria-label=\"Main Menu\" ng-if=\"vm.main==0\" \nng-disabled=\"KOTItmCount>0\"><h4><md-icon md-font-icon=\"icon-apps\" class=\"icon s24\" style=\"height:27px!important\" \nhide-xs></md-icon><b style=\"text-transform:capitalize\" translate=\"TOOLBAR.NAVLINK_MAINMENU\">Main Menu</b></h4>\n</md-button><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nid=\"quick-panel-toggle\" class=\"language-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Main Menu\"><div \nclass=\"notifiction\"><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon><span style=\"background-color:#34a353\" \nng-bind=\"totalAlert\"></span></div></md-button><div class=\"toolbar-separator\"></div></div><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"{{vm.SelectStudentImg}}\"></div><span \nclass=\"username\" hide show-gt-sm><b>{{vm.CustomerName}}</b></span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>{{vm.CustomerName}}\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nng-if=\"vm.printStatus==1\" md-font-icon=\"icon-checkbox-blank-circle\" style=\"color:green\" class=\"icon\"></md-icon><md-icon\n ng-if=\"vm.printStatus==0\" md-font-icon=\"icon-checkbox-blank-circle\" style=\"color:red\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.getPrinterStatus()\" translate=\"TOOLBAR.NAVLINK_PRINTERSTATUS\">Printer Status</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-printer\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.openLocalPrinterDialog()\" translate=\"TOOLBAR.NAVLINK_LOCALSETTING\">\nLocal Settings</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.NAVLINK_LOGOUT\">\nLogout</md-button></md-menu-item></md-menu-content></md-menu><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"lang in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate \ntranslate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div>");
$templateCache.put("app/main/apps/toolbar-inner/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/toolbar-inner/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/toolbar-inner/dialogs/local-printer/local-printer-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"\" layout=\"column\" style=\"background:#00A931\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-no-float md-block\" \nng-if=\"vm.hostLab==0\"><label><b>Selected Printer IP : {{vm.localPrinterIP}}</b></label></md-input-container>\n<md-input-container class=\"md-no-float md-block\" ng-if=\"vm.hostLab==1\"><label>Select Printer IP</label><md-select \nname=\"localPrinterIP\" ng-model=\"vm.localPrinterIP\" ng-change=\"vm.setPrintIP()\"><md-option \nng-repeat=\"op in vm.hostList\" ng-value=\"op.host\" ng-selected=\"op.host==vm.localPrinterIP\">{{op.host}}</md-option>\n</md-select></md-input-container><br><md-input-container class=\"md-no-float md-block\"><md-checkbox \nng-model=\"vm.localNotificationEnable\" ng-true-value=\"1\" ng-false-value=\"0\" ng-checked=\"vm.localNotificationEnable==1\" \naria-label=\"Enable Order Notifications.\">Enable Order Notifications.</md-checkbox></md-input-container>\n<md-input-container class=\"md-no-float md-block\"><label>Enter Default Printer Name</label><input name=\"localPrinter\" \nng-model=\"vm.localPrinter\" type=\"text\" ng-required md-autofocus></md-input-container><md-input-container \nclass=\"md-no-float md-block\"><md-checkbox ng-model=\"vm.localPrinterReminder\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-checked=\"vm.localPrinterReminder==1\" aria-label=\"Don\'t Show Again.\">Don\'t Show Again.</md-checkbox>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveRole(\'contactForm\')\" \nclass=\"sve-btn\">SAVE</md-button><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" class=\"sve-btn\">SKIP</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);